
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4759"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4759"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7CoBd", function(module, exports) {
(function() {
    "use strict";
    var doc = document;
    var win = window;
    var docEle = doc.documentElement;
    var createElement = doc.createElement.bind(doc);
    var div = createElement("div");
    var table = createElement("table");
    var tbody = createElement("tbody");
    var tr = createElement("tr");
    var isArray = Array.isArray, ArrayPrototype = Array.prototype;
    var concat = ArrayPrototype.concat, filter = ArrayPrototype.filter, indexOf = ArrayPrototype.indexOf, map = ArrayPrototype.map, push = ArrayPrototype.push, slice = ArrayPrototype.slice, some = ArrayPrototype.some, splice = ArrayPrototype.splice;
    var idRe = /^#(?:[\w-]|\\.|[^\x00-\xa0])*$/;
    var classRe = /^\.(?:[\w-]|\\.|[^\x00-\xa0])*$/;
    var htmlRe = /<.+>/;
    var tagRe = /^\w+$/;
    // @require ./variables.ts
    function find(selector, context) {
        var isFragment = isDocumentFragment(context);
        return !selector || !isFragment && !isDocument(context) && !isElement(context) ? [] : !isFragment && classRe.test(selector) ? context.getElementsByClassName(selector.slice(1).replace(/\\/g, "")) : !isFragment && tagRe.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    }
    // @require ./find.ts
    // @require ./variables.ts
    var Cash = /** @class */ function() {
        function Cash(selector, context) {
            if (!selector) return;
            if (isCash(selector)) return selector;
            var eles = selector;
            if (isString(selector)) {
                var ctx = context || doc;
                eles = idRe.test(selector) && isDocument(ctx) ? ctx.getElementById(selector.slice(1).replace(/\\/g, "")) : htmlRe.test(selector) ? parseHTML(selector) : isCash(ctx) ? ctx.find(selector) : isString(ctx) ? cash(ctx).find(selector) : find(selector, ctx);
                if (!eles) return;
            } else if (isFunction(selector)) return this.ready(selector); //FIXME: `fn.ready` is not included in `core`, but it's actually a core functionality
            if (eles.nodeType || eles === win) eles = [
                eles
            ];
            this.length = eles.length;
            for(var i = 0, l = this.length; i < l; i++)this[i] = eles[i];
        }
        Cash.prototype.init = function(selector, context) {
            return new Cash(selector, context);
        };
        return Cash;
    }();
    var fn = Cash.prototype;
    var cash = fn.init;
    cash.fn = cash.prototype = fn; // Ensuring that `cash () instanceof cash`
    fn.length = 0;
    fn.splice = splice; // Ensuring a cash collection gets printed as array-like in Chrome's devtools
    if (typeof Symbol === "function") fn[Symbol["iterator"]] = ArrayPrototype[Symbol["iterator"]];
    function isCash(value) {
        return value instanceof Cash;
    }
    function isWindow(value) {
        return !!value && value === value.window;
    }
    function isDocument(value) {
        return !!value && value.nodeType === 9;
    }
    function isDocumentFragment(value) {
        return !!value && value.nodeType === 11;
    }
    function isElement(value) {
        return !!value && value.nodeType === 1;
    }
    function isText(value) {
        return !!value && value.nodeType === 3;
    }
    function isBoolean(value) {
        return typeof value === "boolean";
    }
    function isFunction(value) {
        return typeof value === "function";
    }
    function isString(value) {
        return typeof value === "string";
    }
    function isUndefined(value) {
        return value === undefined;
    }
    function isNull(value) {
        return value === null;
    }
    function isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
    function isPlainObject(value) {
        if (typeof value !== "object" || value === null) return false;
        var proto = Object.getPrototypeOf(value);
        return proto === null || proto === Object.prototype;
    }
    cash.isWindow = isWindow;
    cash.isFunction = isFunction;
    cash.isArray = isArray;
    cash.isNumeric = isNumeric;
    cash.isPlainObject = isPlainObject;
    function each(arr, callback, _reverse) {
        if (_reverse) {
            var i = arr.length;
            while(i--){
                if (callback.call(arr[i], i, arr[i]) === false) return arr;
            }
        } else if (isPlainObject(arr)) {
            var keys = Object.keys(arr);
            for(var i = 0, l = keys.length; i < l; i++){
                var key = keys[i];
                if (callback.call(arr[key], key, arr[key]) === false) return arr;
            }
        } else for(var i = 0, l = arr.length; i < l; i++){
            if (callback.call(arr[i], i, arr[i]) === false) return arr;
        }
        return arr;
    }
    cash.each = each;
    fn.each = function(callback) {
        return each(this, callback);
    };
    fn.empty = function() {
        return this.each(function(i, ele) {
            while(ele.firstChild)ele.removeChild(ele.firstChild);
        });
    };
    function extend() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        var deep = isBoolean(sources[0]) ? sources.shift() : false;
        var target = sources.shift();
        var length = sources.length;
        if (!target) return {};
        if (!length) return extend(deep, cash, target);
        for(var i = 0; i < length; i++){
            var source = sources[i];
            for(var key in source)if (deep && (isArray(source[key]) || isPlainObject(source[key]))) {
                if (!target[key] || target[key].constructor !== source[key].constructor) target[key] = new source[key].constructor();
                extend(deep, target[key], source[key]);
            } else target[key] = source[key];
        }
        return target;
    }
    cash.extend = extend;
    fn.extend = function(plugins) {
        return extend(fn, plugins);
    };
    // @require ./type_checking.ts
    var splitValuesRe = /\S+/g;
    function getSplitValues(str) {
        return isString(str) ? str.match(splitValuesRe) || [] : [];
    }
    fn.toggleClass = function(cls, force) {
        var classes = getSplitValues(cls);
        var isForce = !isUndefined(force);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            each(classes, function(i, c) {
                if (isForce) force ? ele.classList.add(c) : ele.classList.remove(c);
                else ele.classList.toggle(c);
            });
        });
    };
    fn.addClass = function(cls) {
        return this.toggleClass(cls, true);
    };
    fn.removeAttr = function(attr) {
        var attrs = getSplitValues(attr);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            each(attrs, function(i, a) {
                ele.removeAttribute(a);
            });
        });
    };
    function attr(attr, value) {
        if (!attr) return;
        if (isString(attr)) {
            if (arguments.length < 2) {
                if (!this[0] || !isElement(this[0])) return;
                var value_1 = this[0].getAttribute(attr);
                return isNull(value_1) ? undefined : value_1;
            }
            if (isUndefined(value)) return this;
            if (isNull(value)) return this.removeAttr(attr);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                ele.setAttribute(attr, value);
            });
        }
        for(var key in attr)this.attr(key, attr[key]);
        return this;
    }
    fn.attr = attr;
    fn.removeClass = function(cls) {
        if (arguments.length) return this.toggleClass(cls, false);
        return this.attr("class", "");
    };
    fn.hasClass = function(cls) {
        return !!cls && some.call(this, function(ele) {
            return isElement(ele) && ele.classList.contains(cls);
        });
    };
    fn.get = function(index) {
        if (isUndefined(index)) return slice.call(this);
        index = Number(index);
        return this[index < 0 ? index + this.length : index];
    };
    fn.eq = function(index) {
        return cash(this.get(index));
    };
    fn.first = function() {
        return this.eq(0);
    };
    fn.last = function() {
        return this.eq(-1);
    };
    function text(text) {
        if (isUndefined(text)) return this.get().map(function(ele) {
            return isElement(ele) || isText(ele) ? ele.textContent : "";
        }).join("");
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            ele.textContent = text;
        });
    }
    fn.text = text;
    // @require core/type_checking.ts
    // @require core/variables.ts
    function computeStyle(ele, prop, isVariable) {
        if (!isElement(ele)) return;
        var style = win.getComputedStyle(ele, null);
        return isVariable ? style.getPropertyValue(prop) || undefined : style[prop] || ele.style[prop];
    }
    // @require ./compute_style.ts
    function computeStyleInt(ele, prop) {
        return parseInt(computeStyle(ele, prop), 10) || 0;
    }
    // @require css/helpers/compute_style_int.ts
    function getExtraSpace(ele, xAxis) {
        return computeStyleInt(ele, "border".concat(xAxis ? "Left" : "Top", "Width")) + computeStyleInt(ele, "padding".concat(xAxis ? "Left" : "Top")) + computeStyleInt(ele, "padding".concat(xAxis ? "Right" : "Bottom")) + computeStyleInt(ele, "border".concat(xAxis ? "Right" : "Bottom", "Width"));
    }
    // @require css/helpers/compute_style.ts
    var defaultDisplay = {};
    function getDefaultDisplay(tagName) {
        if (defaultDisplay[tagName]) return defaultDisplay[tagName];
        var ele = createElement(tagName);
        doc.body.insertBefore(ele, null);
        var display = computeStyle(ele, "display");
        doc.body.removeChild(ele);
        return defaultDisplay[tagName] = display !== "none" ? display : "block";
    }
    // @require css/helpers/compute_style.ts
    function isHidden(ele) {
        return computeStyle(ele, "display") === "none";
    }
    // @require ./cash.ts
    function matches(ele, selector) {
        var matches = ele && (ele["matches"] || ele["webkitMatchesSelector"] || ele["msMatchesSelector"]);
        return !!matches && !!selector && matches.call(ele, selector);
    }
    // @require ./matches.ts
    // @require ./type_checking.ts
    function getCompareFunction(comparator) {
        return isString(comparator) ? function(i, ele) {
            return matches(ele, comparator);
        } : isFunction(comparator) ? comparator : isCash(comparator) ? function(i, ele) {
            return comparator.is(ele);
        } : !comparator ? function() {
            return false;
        } : function(i, ele) {
            return ele === comparator;
        };
    }
    fn.filter = function(comparator) {
        var compare = getCompareFunction(comparator);
        return cash(filter.call(this, function(ele, i) {
            return compare.call(ele, i, ele);
        }));
    };
    // @require collection/filter.ts
    function filtered(collection, comparator) {
        return !comparator ? collection : collection.filter(comparator);
    }
    fn.detach = function(comparator) {
        filtered(this, comparator).each(function(i, ele) {
            if (ele.parentNode) ele.parentNode.removeChild(ele);
        });
        return this;
    };
    var fragmentRe = /^\s*<(\w+)[^>]*>/;
    var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
    var containers = {
        "*": div,
        tr: tbody,
        td: tr,
        th: tr,
        thead: table,
        tbody: table,
        tfoot: table
    };
    //TODO: Create elements inside a document fragment, in order to prevent inline event handlers from firing
    //TODO: Ensure the created elements have the fragment as their parent instead of null, this also ensures we can deal with detatched nodes more reliably
    function parseHTML(html) {
        if (!isString(html)) return [];
        if (singleTagRe.test(html)) return [
            createElement(RegExp.$1)
        ];
        var fragment = fragmentRe.test(html) && RegExp.$1;
        var container = containers[fragment] || containers["*"];
        container.innerHTML = html;
        return cash(container.childNodes).detach().get();
    }
    cash.parseHTML = parseHTML;
    fn.has = function(selector) {
        var comparator = isString(selector) ? function(i, ele) {
            return find(selector, ele).length;
        } : function(i, ele) {
            return ele.contains(selector);
        };
        return this.filter(comparator);
    };
    fn.not = function(comparator) {
        var compare = getCompareFunction(comparator);
        return this.filter(function(i, ele) {
            return (!isString(comparator) || isElement(ele)) && !compare.call(ele, i, ele);
        });
    };
    function pluck(arr, prop, deep, until) {
        var plucked = [];
        var isCallback = isFunction(prop);
        var compare = until && getCompareFunction(until);
        for(var i = 0, l = arr.length; i < l; i++)if (isCallback) {
            var val_1 = prop(arr[i]);
            if (val_1.length) push.apply(plucked, val_1);
        } else {
            var val_2 = arr[i][prop];
            while(val_2 != null){
                if (until && compare(-1, val_2)) break;
                plucked.push(val_2);
                val_2 = deep ? val_2[prop] : null;
            }
        }
        return plucked;
    }
    // @require core/pluck.ts
    // @require core/variables.ts
    function getValue(ele) {
        if (ele.multiple && ele.options) return pluck(filter.call(ele.options, function(option) {
            return option.selected && !option.disabled && !option.parentNode.disabled;
        }), "value");
        return ele.value || "";
    }
    function val(value) {
        if (!arguments.length) return this[0] && getValue(this[0]);
        return this.each(function(i, ele) {
            var isSelect = ele.multiple && ele.options;
            if (isSelect || checkableRe.test(ele.type)) {
                var eleValue_1 = isArray(value) ? map.call(value, String) : isNull(value) ? [] : [
                    String(value)
                ];
                if (isSelect) each(ele.options, function(i, option) {
                    option.selected = eleValue_1.indexOf(option.value) >= 0;
                }, true);
                else ele.checked = eleValue_1.indexOf(ele.value) >= 0;
            } else ele.value = isUndefined(value) || isNull(value) ? "" : value;
        });
    }
    fn.val = val;
    fn.is = function(comparator) {
        var compare = getCompareFunction(comparator);
        return some.call(this, function(ele, i) {
            return compare.call(ele, i, ele);
        });
    };
    cash.guid = 1;
    function unique(arr) {
        return arr.length > 1 ? filter.call(arr, function(item, index, self) {
            return indexOf.call(self, item) === index;
        }) : arr;
    }
    cash.unique = unique;
    fn.add = function(selector, context) {
        return cash(unique(this.get().concat(cash(selector, context).get())));
    };
    fn.children = function(comparator) {
        return filtered(cash(unique(pluck(this, function(ele) {
            return ele.children;
        }))), comparator);
    };
    fn.parent = function(comparator) {
        return filtered(cash(unique(pluck(this, "parentNode"))), comparator);
    };
    fn.index = function(selector) {
        var child = selector ? cash(selector)[0] : this[0];
        var collection = selector ? this : cash(child).parent().children();
        return indexOf.call(collection, child);
    };
    fn.closest = function(comparator) {
        var filtered = this.filter(comparator);
        if (filtered.length) return filtered;
        var $parent = this.parent();
        if (!$parent.length) return filtered;
        return $parent.closest(comparator);
    };
    fn.siblings = function(comparator) {
        return filtered(cash(unique(pluck(this, function(ele) {
            return cash(ele).parent().children().not(ele);
        }))), comparator);
    };
    fn.find = function(selector) {
        return cash(unique(pluck(this, function(ele) {
            return find(selector, ele);
        })));
    };
    // @require core/variables.ts
    // @require collection/filter.ts
    // @require traversal/find.ts
    var HTMLCDATARe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    var scriptTypeRe = /^$|^module$|\/(java|ecma)script/i;
    var scriptAttributes = [
        "type",
        "src",
        "nonce",
        "noModule"
    ];
    function evalScripts(node, doc) {
        var collection = cash(node);
        collection.filter("script").add(collection.find("script")).each(function(i, ele) {
            if (scriptTypeRe.test(ele.type) && docEle.contains(ele)) {
                var script_1 = createElement("script");
                script_1.text = ele.textContent.replace(HTMLCDATARe, "");
                each(scriptAttributes, function(i, attr) {
                    if (ele[attr]) script_1[attr] = ele[attr];
                });
                doc.head.insertBefore(script_1, null);
                doc.head.removeChild(script_1);
            }
        });
    }
    // @require ./eval_scripts.ts
    function insertElement(anchor, target, left, inside, evaluate) {
        if (inside) anchor.insertBefore(target, left ? anchor.firstChild : null);
        else if (anchor.nodeName === "HTML") anchor.parentNode.replaceChild(target, anchor);
        else anchor.parentNode.insertBefore(target, left ? anchor : anchor.nextSibling);
        if (evaluate) evalScripts(target, anchor.ownerDocument);
    }
    // @require ./insert_element.ts
    function insertSelectors(selectors, anchors, inverse, left, inside, reverseLoop1, reverseLoop2, reverseLoop3) {
        each(selectors, function(si, selector) {
            each(cash(selector), function(ti, target) {
                each(cash(anchors), function(ai, anchor) {
                    var anchorFinal = inverse ? target : anchor;
                    var targetFinal = inverse ? anchor : target;
                    var indexFinal = inverse ? ti : ai;
                    insertElement(anchorFinal, !indexFinal ? targetFinal : targetFinal.cloneNode(true), left, inside, !indexFinal);
                }, reverseLoop3);
            }, reverseLoop2);
        }, reverseLoop1);
        return anchors;
    }
    fn.after = function() {
        return insertSelectors(arguments, this, false, false, false, true, true);
    };
    fn.append = function() {
        return insertSelectors(arguments, this, false, false, true);
    };
    function html(html) {
        if (!arguments.length) return this[0] && this[0].innerHTML;
        if (isUndefined(html)) return this;
        var hasScript = /<script[\s>]/.test(html);
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            if (hasScript) cash(ele).empty().append(html);
            else ele.innerHTML = html;
        });
    }
    fn.html = html;
    fn.appendTo = function(selector) {
        return insertSelectors(arguments, this, true, false, true);
    };
    fn.wrapInner = function(selector) {
        return this.each(function(i, ele) {
            var $ele = cash(ele);
            var contents = $ele.contents();
            contents.length ? contents.wrapAll(selector) : $ele.append(selector);
        });
    };
    fn.before = function() {
        return insertSelectors(arguments, this, false, true);
    };
    fn.wrapAll = function(selector) {
        var structure = cash(selector);
        var wrapper = structure[0];
        while(wrapper.children.length)wrapper = wrapper.firstElementChild;
        this.first().before(structure);
        return this.appendTo(wrapper);
    };
    fn.wrap = function(selector) {
        return this.each(function(i, ele) {
            var wrapper = cash(selector)[0];
            cash(ele).wrapAll(!i ? wrapper : wrapper.cloneNode(true));
        });
    };
    fn.insertAfter = function(selector) {
        return insertSelectors(arguments, this, true, false, false, false, false, true);
    };
    fn.insertBefore = function(selector) {
        return insertSelectors(arguments, this, true, true);
    };
    fn.prepend = function() {
        return insertSelectors(arguments, this, false, true, true, true, true);
    };
    fn.prependTo = function(selector) {
        return insertSelectors(arguments, this, true, true, true, false, false, true);
    };
    fn.contents = function() {
        return cash(unique(pluck(this, function(ele) {
            return ele.tagName === "IFRAME" ? [
                ele.contentDocument
            ] : ele.tagName === "TEMPLATE" ? ele.content.childNodes : ele.childNodes;
        })));
    };
    fn.next = function(comparator, _all, _until) {
        return filtered(cash(unique(pluck(this, "nextElementSibling", _all, _until))), comparator);
    };
    fn.nextAll = function(comparator) {
        return this.next(comparator, true);
    };
    fn.nextUntil = function(until, comparator) {
        return this.next(comparator, true, until);
    };
    fn.parents = function(comparator, _until) {
        return filtered(cash(unique(pluck(this, "parentElement", true, _until))), comparator);
    };
    fn.parentsUntil = function(until, comparator) {
        return this.parents(comparator, until);
    };
    fn.prev = function(comparator, _all, _until) {
        return filtered(cash(unique(pluck(this, "previousElementSibling", _all, _until))), comparator);
    };
    fn.prevAll = function(comparator) {
        return this.prev(comparator, true);
    };
    fn.prevUntil = function(until, comparator) {
        return this.prev(comparator, true, until);
    };
    fn.map = function(callback) {
        return cash(concat.apply([], map.call(this, function(ele, i) {
            return callback.call(ele, i, ele);
        })));
    };
    fn.clone = function() {
        return this.map(function(i, ele) {
            return ele.cloneNode(true);
        });
    };
    fn.offsetParent = function() {
        return this.map(function(i, ele) {
            var offsetParent = ele.offsetParent;
            while(offsetParent && computeStyle(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
            return offsetParent || docEle;
        });
    };
    fn.slice = function(start, end) {
        return cash(slice.call(this, start, end));
    };
    // @require ./cash.ts
    var dashAlphaRe = /-([a-z])/g;
    function camelCase(str) {
        return str.replace(dashAlphaRe, function(match, letter) {
            return letter.toUpperCase();
        });
    }
    fn.ready = function(callback) {
        var cb = function() {
            return setTimeout(callback, 0, cash);
        };
        if (doc.readyState !== "loading") cb();
        else doc.addEventListener("DOMContentLoaded", cb);
        return this;
    };
    fn.unwrap = function() {
        this.parent().each(function(i, ele) {
            if (ele.tagName === "BODY") return;
            var $ele = cash(ele);
            $ele.replaceWith($ele.children());
        });
        return this;
    };
    fn.offset = function() {
        var ele = this[0];
        if (!ele) return;
        var rect = ele.getBoundingClientRect();
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    };
    fn.position = function() {
        var ele = this[0];
        if (!ele) return;
        var isFixed = computeStyle(ele, "position") === "fixed";
        var offset = isFixed ? ele.getBoundingClientRect() : this.offset();
        if (!isFixed) {
            var doc_1 = ele.ownerDocument;
            var offsetParent = ele.offsetParent || doc_1.documentElement;
            while((offsetParent === doc_1.body || offsetParent === doc_1.documentElement) && computeStyle(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
            if (offsetParent !== ele && isElement(offsetParent)) {
                var parentOffset = cash(offsetParent).offset();
                offset.top -= parentOffset.top + computeStyleInt(offsetParent, "borderTopWidth");
                offset.left -= parentOffset.left + computeStyleInt(offsetParent, "borderLeftWidth");
            }
        }
        return {
            top: offset.top - computeStyleInt(ele, "marginTop"),
            left: offset.left - computeStyleInt(ele, "marginLeft")
        };
    };
    var propMap = {
        /* GENERAL */ class: "className",
        contenteditable: "contentEditable",
        /* LABEL */ for: "htmlFor",
        /* INPUT */ readonly: "readOnly",
        maxlength: "maxLength",
        tabindex: "tabIndex",
        /* TABLE */ colspan: "colSpan",
        rowspan: "rowSpan",
        /* IMAGE */ usemap: "useMap"
    };
    fn.prop = function(prop, value) {
        if (!prop) return;
        if (isString(prop)) {
            prop = propMap[prop] || prop;
            if (arguments.length < 2) return this[0] && this[0][prop];
            return this.each(function(i, ele) {
                ele[prop] = value;
            });
        }
        for(var key in prop)this.prop(key, prop[key]);
        return this;
    };
    fn.removeProp = function(prop) {
        return this.each(function(i, ele) {
            delete ele[propMap[prop] || prop];
        });
    };
    var cssVariableRe = /^--/;
    // @require ./variables.ts
    function isCSSVariable(prop) {
        return cssVariableRe.test(prop);
    }
    // @require core/camel_case.ts
    // @require core/cash.ts
    // @require core/each.ts
    // @require core/variables.ts
    // @require ./is_css_variable.ts
    var prefixedProps = {};
    var style = div.style;
    var vendorsPrefixes = [
        "webkit",
        "moz",
        "ms"
    ];
    function getPrefixedProp(prop, isVariable) {
        if (isVariable === void 0) isVariable = isCSSVariable(prop);
        if (isVariable) return prop;
        if (!prefixedProps[prop]) {
            var propCC = camelCase(prop);
            var propUC = "".concat(propCC[0].toUpperCase()).concat(propCC.slice(1));
            var props = "".concat(propCC, " ").concat(vendorsPrefixes.join("".concat(propUC, " "))).concat(propUC).split(" ");
            each(props, function(i, p) {
                if (p in style) {
                    prefixedProps[prop] = p;
                    return false;
                }
            });
        }
        return prefixedProps[prop];
    }
    // @require core/type_checking.ts
    // @require ./is_css_variable.ts
    var numericProps = {
        animationIterationCount: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gridArea: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnStart: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowStart: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        widows: true,
        zIndex: true
    };
    function getSuffixedValue(prop, value, isVariable) {
        if (isVariable === void 0) isVariable = isCSSVariable(prop);
        return !isVariable && !numericProps[prop] && isNumeric(value) ? "".concat(value, "px") : value;
    }
    function css(prop, value) {
        if (isString(prop)) {
            var isVariable_1 = isCSSVariable(prop);
            prop = getPrefixedProp(prop, isVariable_1);
            if (arguments.length < 2) return this[0] && computeStyle(this[0], prop, isVariable_1);
            if (!prop) return this;
            value = getSuffixedValue(prop, value, isVariable_1);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                if (isVariable_1) ele.style.setProperty(prop, value);
                else ele.style[prop] = value;
            });
        }
        for(var key in prop)this.css(key, prop[key]);
        return this;
    }
    fn.css = css;
    function attempt(fn, arg) {
        try {
            return fn(arg);
        } catch (_a) {
            return arg;
        }
    }
    // @require core/attempt.ts
    // @require core/camel_case.ts
    var JSONStringRe = /^\s+|\s+$/;
    function getData(ele, key) {
        var value = ele.dataset[key] || ele.dataset[camelCase(key)];
        if (JSONStringRe.test(value)) return value;
        return attempt(JSON.parse, value);
    }
    // @require core/attempt.ts
    // @require core/camel_case.ts
    function setData(ele, key, value) {
        value = attempt(JSON.stringify, value);
        ele.dataset[camelCase(key)] = value;
    }
    function data(name, value) {
        if (!name) {
            if (!this[0]) return;
            var datas = {};
            for(var key in this[0].dataset)datas[key] = getData(this[0], key);
            return datas;
        }
        if (isString(name)) {
            if (arguments.length < 2) return this[0] && getData(this[0], name);
            if (isUndefined(value)) return this;
            return this.each(function(i, ele) {
                setData(ele, name, value);
            });
        }
        for(var key in name)this.data(key, name[key]);
        return this;
    }
    fn.data = data;
    function getDocumentDimension(doc, dimension) {
        var docEle = doc.documentElement;
        return Math.max(doc.body["scroll".concat(dimension)], docEle["scroll".concat(dimension)], doc.body["offset".concat(dimension)], docEle["offset".concat(dimension)], docEle["client".concat(dimension)]);
    }
    each([
        true,
        false
    ], function(i, outer) {
        each([
            "Width",
            "Height"
        ], function(i, prop) {
            var name = "".concat(outer ? "outer" : "inner").concat(prop);
            fn[name] = function(includeMargins) {
                if (!this[0]) return;
                if (isWindow(this[0])) return outer ? this[0]["inner".concat(prop)] : this[0].document.documentElement["client".concat(prop)];
                if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
                return this[0]["".concat(outer ? "offset" : "client").concat(prop)] + (includeMargins && outer ? computeStyleInt(this[0], "margin".concat(i ? "Top" : "Left")) + computeStyleInt(this[0], "margin".concat(i ? "Bottom" : "Right")) : 0);
            };
        });
    });
    each([
        "Width",
        "Height"
    ], function(index, prop) {
        var propLC = prop.toLowerCase();
        fn[propLC] = function(value) {
            if (!this[0]) return isUndefined(value) ? undefined : this;
            if (!arguments.length) {
                if (isWindow(this[0])) return this[0].document.documentElement["client".concat(prop)];
                if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
                return this[0].getBoundingClientRect()[propLC] - getExtraSpace(this[0], !index);
            }
            var valueNumber = parseInt(value, 10);
            return this.each(function(i, ele) {
                if (!isElement(ele)) return;
                var boxSizing = computeStyle(ele, "boxSizing");
                ele.style[propLC] = getSuffixedValue(propLC, valueNumber + (boxSizing === "border-box" ? getExtraSpace(ele, !index) : 0));
            });
        };
    });
    var displayProperty = "___cd";
    fn.toggle = function(force) {
        return this.each(function(i, ele) {
            if (!isElement(ele)) return;
            var hidden = isHidden(ele);
            var show = isUndefined(force) ? hidden : force;
            if (show) {
                ele.style.display = ele[displayProperty] || "";
                if (isHidden(ele)) ele.style.display = getDefaultDisplay(ele.tagName);
            } else if (!hidden) {
                ele[displayProperty] = computeStyle(ele, "display");
                ele.style.display = "none";
            }
        });
    };
    fn.hide = function() {
        return this.toggle(false);
    };
    fn.show = function() {
        return this.toggle(true);
    };
    var eventsNamespace = "___ce";
    var eventsNamespacesSeparator = ".";
    var eventsFocus = {
        focus: "focusin",
        blur: "focusout"
    };
    var eventsHover = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    var eventsMouseRe = /^(mouse|pointer|contextmenu|drag|drop|click|dblclick)/i;
    // @require ./variables.ts
    function getEventNameBubbling(name) {
        return eventsHover[name] || eventsFocus[name] || name;
    }
    // @require ./variables.ts
    function parseEventName(eventName) {
        var parts = eventName.split(eventsNamespacesSeparator);
        return [
            parts[0],
            parts.slice(1).sort()
        ]; // [name, namespace[]]
    }
    fn.trigger = function(event, data) {
        if (isString(event)) {
            var _a = parseEventName(event), nameOriginal = _a[0], namespaces = _a[1];
            var name_1 = getEventNameBubbling(nameOriginal);
            if (!name_1) return this;
            var type = eventsMouseRe.test(name_1) ? "MouseEvents" : "HTMLEvents";
            event = doc.createEvent(type);
            event.initEvent(name_1, true, true);
            event.namespace = namespaces.join(eventsNamespacesSeparator);
            event.___ot = nameOriginal;
        }
        event.___td = data;
        var isEventFocus = event.___ot in eventsFocus;
        return this.each(function(i, ele) {
            if (isEventFocus && isFunction(ele[event.___ot])) {
                ele["___i".concat(event.type)] = true; // Ensuring the native event is ignored
                ele[event.___ot]();
                ele["___i".concat(event.type)] = false; // Ensuring the custom event is not ignored
            }
            ele.dispatchEvent(event);
        });
    };
    // @require ./variables.ts
    function getEventsCache(ele) {
        return ele[eventsNamespace] = ele[eventsNamespace] || {};
    }
    // @require core/guid.ts
    // @require events/helpers/get_events_cache.ts
    function addEvent(ele, name, namespaces, selector, callback) {
        var eventCache = getEventsCache(ele);
        eventCache[name] = eventCache[name] || [];
        eventCache[name].push([
            namespaces,
            selector,
            callback
        ]);
        ele.addEventListener(name, callback);
    }
    function hasNamespaces(ns1, ns2) {
        return !ns2 || !some.call(ns2, function(ns) {
            return ns1.indexOf(ns) < 0;
        });
    }
    // @require ./get_events_cache.ts
    // @require ./has_namespaces.ts
    // @require ./parse_event_name.ts
    function removeEvent(ele, name, namespaces, selector, callback) {
        var cache = getEventsCache(ele);
        if (!name) for(name in cache)removeEvent(ele, name, namespaces, selector, callback);
        else if (cache[name]) cache[name] = cache[name].filter(function(_a) {
            var ns = _a[0], sel = _a[1], cb = _a[2];
            if (callback && cb.guid !== callback.guid || !hasNamespaces(ns, namespaces) || selector && selector !== sel) return true;
            ele.removeEventListener(name, cb);
        });
    }
    fn.off = function(eventFullName, selector, callback) {
        var _this = this;
        if (isUndefined(eventFullName)) this.each(function(i, ele) {
            if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
            removeEvent(ele);
        });
        else if (!isString(eventFullName)) for(var key in eventFullName)this.off(key, eventFullName[key]);
        else {
            if (isFunction(selector)) {
                callback = selector;
                selector = "";
            }
            each(getSplitValues(eventFullName), function(i, eventFullName) {
                var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
                var name = getEventNameBubbling(nameOriginal);
                _this.each(function(i, ele) {
                    if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
                    removeEvent(ele, name, namespaces, selector, callback);
                });
            });
        }
        return this;
    };
    fn.remove = function(comparator) {
        filtered(this, comparator).detach().off();
        return this;
    };
    fn.replaceWith = function(selector) {
        return this.before(selector).remove();
    };
    fn.replaceAll = function(selector) {
        cash(selector).replaceWith(this);
        return this;
    };
    function on(eventFullName, selector, data, callback, _one) {
        var _this = this;
        if (!isString(eventFullName)) {
            for(var key in eventFullName)this.on(key, selector, data, eventFullName[key], _one);
            return this;
        }
        if (!isString(selector)) {
            if (isUndefined(selector) || isNull(selector)) selector = "";
            else if (isUndefined(data)) {
                data = selector;
                selector = "";
            } else {
                callback = data;
                data = selector;
                selector = "";
            }
        }
        if (!isFunction(callback)) {
            callback = data;
            data = undefined;
        }
        if (!callback) return this;
        each(getSplitValues(eventFullName), function(i, eventFullName) {
            var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
            var name = getEventNameBubbling(nameOriginal);
            var isEventHover = nameOriginal in eventsHover;
            var isEventFocus = nameOriginal in eventsFocus;
            if (!name) return;
            _this.each(function(i, ele) {
                if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
                var finalCallback = function(event) {
                    if (event.target["___i".concat(event.type)]) return event.stopImmediatePropagation(); // Ignoring native event in favor of the upcoming custom one
                    if (event.namespace && !hasNamespaces(namespaces, event.namespace.split(eventsNamespacesSeparator))) return;
                    if (!selector && (isEventFocus && (event.target !== ele || event.___ot === name) || isEventHover && event.relatedTarget && ele.contains(event.relatedTarget))) return;
                    var thisArg = ele;
                    if (selector) {
                        var target = event.target;
                        while(!matches(target, selector)){
                            if (target === ele) return;
                            target = target.parentNode;
                            if (!target) return;
                        }
                        thisArg = target;
                    }
                    Object.defineProperty(event, "currentTarget", {
                        configurable: true,
                        get: function() {
                            return thisArg;
                        }
                    });
                    Object.defineProperty(event, "delegateTarget", {
                        configurable: true,
                        get: function() {
                            return ele;
                        }
                    });
                    Object.defineProperty(event, "data", {
                        configurable: true,
                        get: function() {
                            return data;
                        }
                    });
                    var returnValue = callback.call(thisArg, event, event.___td);
                    if (_one) removeEvent(ele, name, namespaces, selector, finalCallback);
                    if (returnValue === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                finalCallback.guid = callback.guid = callback.guid || cash.guid++;
                addEvent(ele, name, namespaces, selector, finalCallback);
            });
        });
        return this;
    }
    fn.on = on;
    function one(eventFullName, selector, data, callback) {
        return this.on(eventFullName, selector, data, callback, true);
    }
    fn.one = one;
    var queryEncodeCRLFRe = /\r?\n/g;
    function queryEncode(prop, value) {
        return "&".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent(value.replace(queryEncodeCRLFRe, "\r\n")));
    }
    var skippableRe = /file|reset|submit|button|image/i;
    var checkableRe = /radio|checkbox/i;
    fn.serialize = function() {
        var query = "";
        this.each(function(i, ele) {
            each(ele.elements || [
                ele
            ], function(i, ele) {
                if (ele.disabled || !ele.name || ele.tagName === "FIELDSET" || skippableRe.test(ele.type) || checkableRe.test(ele.type) && !ele.checked) return;
                var value = getValue(ele);
                if (!isUndefined(value)) {
                    var values = isArray(value) ? value : [
                        value
                    ];
                    each(values, function(i, value) {
                        query += queryEncode(ele.name, value);
                    });
                }
            });
        });
        return query.slice(1);
    };
    module.exports = cash;
})();

});

parcelRegister("hyTiP", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eFNkz", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $aaeb2913ea9675ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $cxnJK = parcelRequire("cxnJK");
var $aaeb2913ea9675ec$var$_handlebarsRuntime2 = $aaeb2913ea9675ec$var$_interopRequireDefault($cxnJK);

var $dUGfH = parcelRequire("dUGfH");
var $aaeb2913ea9675ec$var$_handlebarsCompilerAst2 = $aaeb2913ea9675ec$var$_interopRequireDefault($dUGfH);

var $gcFST = parcelRequire("gcFST");

var $jKGBz = parcelRequire("jKGBz");

var $dSwB5 = parcelRequire("dSwB5");
var $aaeb2913ea9675ec$var$_handlebarsCompilerJavascriptCompiler2 = $aaeb2913ea9675ec$var$_interopRequireDefault($dSwB5);

var $e34mu = parcelRequire("e34mu");
var $aaeb2913ea9675ec$var$_handlebarsCompilerVisitor2 = $aaeb2913ea9675ec$var$_interopRequireDefault($e34mu);

var $1R8En = parcelRequire("1R8En");
var $aaeb2913ea9675ec$var$_handlebarsNoConflict2 = $aaeb2913ea9675ec$var$_interopRequireDefault($1R8En);
var $aaeb2913ea9675ec$var$_create = $aaeb2913ea9675ec$var$_handlebarsRuntime2["default"].create;
function $aaeb2913ea9675ec$var$create() {
    var hb = $aaeb2913ea9675ec$var$_create();
    hb.compile = function(input, options) {
        return $jKGBz.compile(input, options, hb);
    };
    hb.precompile = function(input, options) {
        return $jKGBz.precompile(input, options, hb);
    };
    hb.AST = $aaeb2913ea9675ec$var$_handlebarsCompilerAst2["default"];
    hb.Compiler = $jKGBz.Compiler;
    hb.JavaScriptCompiler = $aaeb2913ea9675ec$var$_handlebarsCompilerJavascriptCompiler2["default"];
    hb.Parser = $gcFST.parser;
    hb.parse = $gcFST.parse;
    hb.parseWithoutProcessing = $gcFST.parseWithoutProcessing;
    return hb;
}
var $aaeb2913ea9675ec$var$inst = $aaeb2913ea9675ec$var$create();
$aaeb2913ea9675ec$var$inst.create = $aaeb2913ea9675ec$var$create;
$aaeb2913ea9675ec$var$_handlebarsNoConflict2["default"]($aaeb2913ea9675ec$var$inst);
$aaeb2913ea9675ec$var$inst.Visitor = $aaeb2913ea9675ec$var$_handlebarsCompilerVisitor2["default"];
$aaeb2913ea9675ec$var$inst["default"] = $aaeb2913ea9675ec$var$inst;
module.exports["default"] = $aaeb2913ea9675ec$var$inst;
module.exports = module.exports["default"];

});
parcelRegister("cxnJK", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $920afabb26416c79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $920afabb26416c79$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $24qvS = parcelRequire("24qvS");
var $920afabb26416c79$var$base = $920afabb26416c79$var$_interopRequireWildcard($24qvS);

var $eJIc2 = parcelRequire("eJIc2");
var $920afabb26416c79$var$_handlebarsSafeString2 = $920afabb26416c79$var$_interopRequireDefault($eJIc2);

var $6fk66 = parcelRequire("6fk66");
var $920afabb26416c79$var$_handlebarsException2 = $920afabb26416c79$var$_interopRequireDefault($6fk66);

var $6kalm = parcelRequire("6kalm");
var $920afabb26416c79$var$Utils = $920afabb26416c79$var$_interopRequireWildcard($6kalm);

var $6TFcA = parcelRequire("6TFcA");
var $920afabb26416c79$var$runtime = $920afabb26416c79$var$_interopRequireWildcard($6TFcA);

var $1R8En = parcelRequire("1R8En");
var $920afabb26416c79$var$_handlebarsNoConflict2 = $920afabb26416c79$var$_interopRequireDefault($1R8En);
// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function $920afabb26416c79$var$create() {
    var hb = new $920afabb26416c79$var$base.HandlebarsEnvironment();
    $920afabb26416c79$var$Utils.extend(hb, $920afabb26416c79$var$base);
    hb.SafeString = $920afabb26416c79$var$_handlebarsSafeString2["default"];
    hb.Exception = $920afabb26416c79$var$_handlebarsException2["default"];
    hb.Utils = $920afabb26416c79$var$Utils;
    hb.escapeExpression = $920afabb26416c79$var$Utils.escapeExpression;
    hb.VM = $920afabb26416c79$var$runtime;
    hb.template = function(spec) {
        return $920afabb26416c79$var$runtime.template(spec, hb);
    };
    return hb;
}
var $920afabb26416c79$var$inst = $920afabb26416c79$var$create();
$920afabb26416c79$var$inst.create = $920afabb26416c79$var$create;
$920afabb26416c79$var$_handlebarsNoConflict2["default"]($920afabb26416c79$var$inst);
$920afabb26416c79$var$inst["default"] = $920afabb26416c79$var$inst;
module.exports["default"] = $920afabb26416c79$var$inst;
module.exports = module.exports["default"];

});
parcelRegister("24qvS", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $1820856e32d6c922$export$1e511d4a378977f5; }, function (v) { return $1820856e32d6c922$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "HandlebarsEnvironment", function () { return $1820856e32d6c922$export$5d1b9d3ad24c13f9; }, function (v) { return $1820856e32d6c922$export$5d1b9d3ad24c13f9 = v; });
$parcel$export(module.exports, "VERSION", function () { return $1820856e32d6c922$export$a4ad2735b021c132; }, function (v) { return $1820856e32d6c922$export$a4ad2735b021c132 = v; });
$parcel$export(module.exports, "COMPILER_REVISION", function () { return $1820856e32d6c922$export$682db5a6f2fa1046; }, function (v) { return $1820856e32d6c922$export$682db5a6f2fa1046 = v; });
$parcel$export(module.exports, "LAST_COMPATIBLE_COMPILER_REVISION", function () { return $1820856e32d6c922$export$b416520f9fd5c520; }, function (v) { return $1820856e32d6c922$export$b416520f9fd5c520 = v; });
$parcel$export(module.exports, "REVISION_CHANGES", function () { return $1820856e32d6c922$export$534648964353ca81; }, function (v) { return $1820856e32d6c922$export$534648964353ca81 = v; });
$parcel$export(module.exports, "log", function () { return $1820856e32d6c922$export$bef1f36f5486a6a3; }, function (v) { return $1820856e32d6c922$export$bef1f36f5486a6a3 = v; });
$parcel$export(module.exports, "createFrame", function () { return $1820856e32d6c922$export$52b3fe9f41f5650c; }, function (v) { return $1820856e32d6c922$export$52b3fe9f41f5650c = v; });
$parcel$export(module.exports, "logger", function () { return $1820856e32d6c922$export$af88d00dbe7f521; }, function (v) { return $1820856e32d6c922$export$af88d00dbe7f521 = v; });
var $1820856e32d6c922$export$1e511d4a378977f5;
var $1820856e32d6c922$export$5d1b9d3ad24c13f9;
var $1820856e32d6c922$export$a4ad2735b021c132;
var $1820856e32d6c922$export$682db5a6f2fa1046;
var $1820856e32d6c922$export$b416520f9fd5c520;
var $1820856e32d6c922$export$534648964353ca81;
var $1820856e32d6c922$export$bef1f36f5486a6a3;
var $1820856e32d6c922$export$52b3fe9f41f5650c;
var $1820856e32d6c922$export$af88d00dbe7f521;
"use strict";
$1820856e32d6c922$export$1e511d4a378977f5 = true;
$1820856e32d6c922$export$5d1b9d3ad24c13f9 = $1820856e32d6c922$var$HandlebarsEnvironment;
// istanbul ignore next
function $1820856e32d6c922$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6kalm = parcelRequire("6kalm");

var $6fk66 = parcelRequire("6fk66");
var $1820856e32d6c922$var$_exception2 = $1820856e32d6c922$var$_interopRequireDefault($6fk66);

var $3YjM4 = parcelRequire("3YjM4");

var $gQbm4 = parcelRequire("gQbm4");

var $jepZe = parcelRequire("jepZe");
var $1820856e32d6c922$var$_logger2 = $1820856e32d6c922$var$_interopRequireDefault($jepZe);

var $4zuHC = parcelRequire("4zuHC");
var $1820856e32d6c922$var$VERSION = "4.7.8";
$1820856e32d6c922$export$a4ad2735b021c132 = $1820856e32d6c922$var$VERSION;
var $1820856e32d6c922$var$COMPILER_REVISION = 8;
$1820856e32d6c922$export$682db5a6f2fa1046 = $1820856e32d6c922$var$COMPILER_REVISION;
var $1820856e32d6c922$var$LAST_COMPATIBLE_COMPILER_REVISION = 7;
$1820856e32d6c922$export$b416520f9fd5c520 = $1820856e32d6c922$var$LAST_COMPATIBLE_COMPILER_REVISION;
var $1820856e32d6c922$var$REVISION_CHANGES = {
    1: "<= 1.0.rc.2",
    2: "== 1.0.0-rc.3",
    3: "== 1.0.0-rc.4",
    4: "== 1.x.x",
    5: "== 2.0.0-alpha.x",
    6: ">= 2.0.0-beta.1",
    7: ">= 4.0.0 <4.3.0",
    8: ">= 4.3.0"
};
$1820856e32d6c922$export$534648964353ca81 = $1820856e32d6c922$var$REVISION_CHANGES;
var $1820856e32d6c922$var$objectType = "[object Object]";
function $1820856e32d6c922$var$HandlebarsEnvironment(helpers, partials, decorators) {
    this.helpers = helpers || {};
    this.partials = partials || {};
    this.decorators = decorators || {};
    $3YjM4.registerDefaultHelpers(this);
    $gQbm4.registerDefaultDecorators(this);
}
$1820856e32d6c922$var$HandlebarsEnvironment.prototype = {
    constructor: $1820856e32d6c922$var$HandlebarsEnvironment,
    logger: $1820856e32d6c922$var$_logger2["default"],
    log: $1820856e32d6c922$var$_logger2["default"].log,
    registerHelper: function registerHelper(name, fn) {
        if ($6kalm.toString.call(name) === $1820856e32d6c922$var$objectType) {
            if (fn) throw new $1820856e32d6c922$var$_exception2["default"]("Arg not supported with multiple helpers");
            $6kalm.extend(this.helpers, name);
        } else this.helpers[name] = fn;
    },
    unregisterHelper: function unregisterHelper(name) {
        delete this.helpers[name];
    },
    registerPartial: function registerPartial(name, partial) {
        if ($6kalm.toString.call(name) === $1820856e32d6c922$var$objectType) $6kalm.extend(this.partials, name);
        else {
            if (typeof partial === "undefined") throw new $1820856e32d6c922$var$_exception2["default"]('Attempting to register a partial called "' + name + '" as undefined');
            this.partials[name] = partial;
        }
    },
    unregisterPartial: function unregisterPartial(name) {
        delete this.partials[name];
    },
    registerDecorator: function registerDecorator(name, fn) {
        if ($6kalm.toString.call(name) === $1820856e32d6c922$var$objectType) {
            if (fn) throw new $1820856e32d6c922$var$_exception2["default"]("Arg not supported with multiple decorators");
            $6kalm.extend(this.decorators, name);
        } else this.decorators[name] = fn;
    },
    unregisterDecorator: function unregisterDecorator(name) {
        delete this.decorators[name];
    },
    /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */ resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        $4zuHC.resetLoggedProperties();
    }
};
var $1820856e32d6c922$var$log = $1820856e32d6c922$var$_logger2["default"].log;
$1820856e32d6c922$export$bef1f36f5486a6a3 = $1820856e32d6c922$var$log;
$1820856e32d6c922$export$52b3fe9f41f5650c = $6kalm.createFrame;
$1820856e32d6c922$export$af88d00dbe7f521 = $1820856e32d6c922$var$_logger2["default"];

});
parcelRegister("6kalm", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $49aca25ccee525c2$export$1e511d4a378977f5; }, function (v) { return $49aca25ccee525c2$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "extend", function () { return $49aca25ccee525c2$export$8b58be045bf06082; }, function (v) { return $49aca25ccee525c2$export$8b58be045bf06082 = v; });
$parcel$export(module.exports, "indexOf", function () { return $49aca25ccee525c2$export$305f7d4e9d4624f2; }, function (v) { return $49aca25ccee525c2$export$305f7d4e9d4624f2 = v; });
$parcel$export(module.exports, "escapeExpression", function () { return $49aca25ccee525c2$export$e6d4483b22f6b058; }, function (v) { return $49aca25ccee525c2$export$e6d4483b22f6b058 = v; });
$parcel$export(module.exports, "isEmpty", function () { return $49aca25ccee525c2$export$dd1bc94b04021eeb; }, function (v) { return $49aca25ccee525c2$export$dd1bc94b04021eeb = v; });
$parcel$export(module.exports, "createFrame", function () { return $49aca25ccee525c2$export$52b3fe9f41f5650c; }, function (v) { return $49aca25ccee525c2$export$52b3fe9f41f5650c = v; });
$parcel$export(module.exports, "blockParams", function () { return $49aca25ccee525c2$export$b0cad7e592dd4356; }, function (v) { return $49aca25ccee525c2$export$b0cad7e592dd4356 = v; });
$parcel$export(module.exports, "appendContextPath", function () { return $49aca25ccee525c2$export$e0253507f826725a; }, function (v) { return $49aca25ccee525c2$export$e0253507f826725a = v; });
$parcel$export(module.exports, "toString", function () { return $49aca25ccee525c2$export$f84e8e69fd4488a5; }, function (v) { return $49aca25ccee525c2$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isFunction", function () { return $49aca25ccee525c2$export$f6e2535fb5126e54; }, function (v) { return $49aca25ccee525c2$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isArray", function () { return $49aca25ccee525c2$export$43bee75e5e14138e; }, function (v) { return $49aca25ccee525c2$export$43bee75e5e14138e = v; });
var $49aca25ccee525c2$export$1e511d4a378977f5;
var $49aca25ccee525c2$export$8b58be045bf06082;
var $49aca25ccee525c2$export$305f7d4e9d4624f2;
var $49aca25ccee525c2$export$e6d4483b22f6b058;
var $49aca25ccee525c2$export$dd1bc94b04021eeb;
var $49aca25ccee525c2$export$52b3fe9f41f5650c;
var $49aca25ccee525c2$export$b0cad7e592dd4356;
var $49aca25ccee525c2$export$e0253507f826725a;
var $49aca25ccee525c2$export$f84e8e69fd4488a5;
var $49aca25ccee525c2$export$f6e2535fb5126e54;
var $49aca25ccee525c2$export$43bee75e5e14138e;
"use strict";
$49aca25ccee525c2$export$1e511d4a378977f5 = true;
$49aca25ccee525c2$export$8b58be045bf06082 = $49aca25ccee525c2$var$extend;
$49aca25ccee525c2$export$305f7d4e9d4624f2 = $49aca25ccee525c2$var$indexOf;
$49aca25ccee525c2$export$e6d4483b22f6b058 = $49aca25ccee525c2$var$escapeExpression;
$49aca25ccee525c2$export$dd1bc94b04021eeb = $49aca25ccee525c2$var$isEmpty;
$49aca25ccee525c2$export$52b3fe9f41f5650c = $49aca25ccee525c2$var$createFrame;
$49aca25ccee525c2$export$b0cad7e592dd4356 = $49aca25ccee525c2$var$blockParams;
$49aca25ccee525c2$export$e0253507f826725a = $49aca25ccee525c2$var$appendContextPath;
var $49aca25ccee525c2$var$escape = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;",
    "=": "&#x3D;"
};
var $49aca25ccee525c2$var$badChars = /[&<>"'`=]/g, $49aca25ccee525c2$var$possible = /[&<>"'`=]/;
function $49aca25ccee525c2$var$escapeChar(chr) {
    return $49aca25ccee525c2$var$escape[chr];
}
function $49aca25ccee525c2$var$extend(obj /* , ...source */ ) {
    for(var i = 1; i < arguments.length; i++){
        for(var key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
    }
    return obj;
}
var $49aca25ccee525c2$var$toString = Object.prototype.toString;
$49aca25ccee525c2$export$f84e8e69fd4488a5 = $49aca25ccee525c2$var$toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */ var $49aca25ccee525c2$var$isFunction = function isFunction(value) {
    return typeof value === "function";
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */ if ($49aca25ccee525c2$var$isFunction(/x/)) $49aca25ccee525c2$export$f6e2535fb5126e54 = $49aca25ccee525c2$var$isFunction = function(value) {
    return typeof value === "function" && $49aca25ccee525c2$var$toString.call(value) === "[object Function]";
};
$49aca25ccee525c2$export$f6e2535fb5126e54 = $49aca25ccee525c2$var$isFunction;
/* eslint-enable func-style */ /* istanbul ignore next */ var $49aca25ccee525c2$var$isArray = Array.isArray || function(value) {
    return value && typeof value === "object" ? $49aca25ccee525c2$var$toString.call(value) === "[object Array]" : false;
};
$49aca25ccee525c2$export$43bee75e5e14138e = $49aca25ccee525c2$var$isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.
function $49aca25ccee525c2$var$indexOf(array, value) {
    for(var i = 0, len = array.length; i < len; i++){
        if (array[i] === value) return i;
    }
    return -1;
}
function $49aca25ccee525c2$var$escapeExpression(string) {
    if (typeof string !== "string") {
        // don't escape SafeStrings, since they're already safe
        if (string && string.toHTML) return string.toHTML();
        else if (string == null) return "";
        else if (!string) return string + "";
        // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = "" + string;
    }
    if (!$49aca25ccee525c2$var$possible.test(string)) return string;
    return string.replace($49aca25ccee525c2$var$badChars, $49aca25ccee525c2$var$escapeChar);
}
function $49aca25ccee525c2$var$isEmpty(value) {
    if (!value && value !== 0) return true;
    else if ($49aca25ccee525c2$var$isArray(value) && value.length === 0) return true;
    else return false;
}
function $49aca25ccee525c2$var$createFrame(object) {
    var frame = $49aca25ccee525c2$var$extend({}, object);
    frame._parent = object;
    return frame;
}
function $49aca25ccee525c2$var$blockParams(params, ids) {
    params.path = ids;
    return params;
}
function $49aca25ccee525c2$var$appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + "." : "") + id;
}

});

parcelRegister("6fk66", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $48c3bbb53edc2ab8$var$errorProps = [
    "description",
    "fileName",
    "lineNumber",
    "endLineNumber",
    "message",
    "name",
    "number",
    "stack"
];
function $48c3bbb53edc2ab8$var$Exception(message, node) {
    var loc = node && node.loc, line = undefined, endLineNumber = undefined, column = undefined, endColumn = undefined;
    if (loc) {
        line = loc.start.line;
        endLineNumber = loc.end.line;
        column = loc.start.column;
        endColumn = loc.end.column;
        message += " - " + line + ":" + column;
    }
    var tmp = Error.prototype.constructor.call(this, message);
    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for(var idx = 0; idx < $48c3bbb53edc2ab8$var$errorProps.length; idx++)this[$48c3bbb53edc2ab8$var$errorProps[idx]] = tmp[$48c3bbb53edc2ab8$var$errorProps[idx]];
    /* istanbul ignore else */ if (Error.captureStackTrace) Error.captureStackTrace(this, $48c3bbb53edc2ab8$var$Exception);
    try {
        if (loc) {
            this.lineNumber = line;
            this.endLineNumber = endLineNumber;
            // Work around issue under safari where we can't directly set the column value
            /* istanbul ignore next */ if (Object.defineProperty) {
                Object.defineProperty(this, "column", {
                    value: column,
                    enumerable: true
                });
                Object.defineProperty(this, "endColumn", {
                    value: endColumn,
                    enumerable: true
                });
            } else {
                this.column = column;
                this.endColumn = endColumn;
            }
        }
    } catch (nop) {
    /* Ignore if the browser is very particular */ }
}
$48c3bbb53edc2ab8$var$Exception.prototype = new Error();
module.exports["default"] = $48c3bbb53edc2ab8$var$Exception;
module.exports = module.exports["default"];

});

parcelRegister("3YjM4", function(module, exports) {

$parcel$export(module.exports, "registerDefaultHelpers", function () { return $2e46507505cc992a$export$bdf7582f74746f6b; }, function (v) { return $2e46507505cc992a$export$bdf7582f74746f6b = v; });
$parcel$export(module.exports, "moveHelperToHooks", function () { return $2e46507505cc992a$export$a8e22c3e8a03ea7e; }, function (v) { return $2e46507505cc992a$export$a8e22c3e8a03ea7e = v; });
var $2e46507505cc992a$export$1e511d4a378977f5;
var $2e46507505cc992a$export$bdf7582f74746f6b;
var $2e46507505cc992a$export$a8e22c3e8a03ea7e;
"use strict";
$2e46507505cc992a$export$1e511d4a378977f5 = true;
$2e46507505cc992a$export$bdf7582f74746f6b = $2e46507505cc992a$var$registerDefaultHelpers;
$2e46507505cc992a$export$a8e22c3e8a03ea7e = $2e46507505cc992a$var$moveHelperToHooks;
// istanbul ignore next
function $2e46507505cc992a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $jPjs7 = parcelRequire("jPjs7");
var $2e46507505cc992a$var$_helpersBlockHelperMissing2 = $2e46507505cc992a$var$_interopRequireDefault($jPjs7);

var $9Cg2G = parcelRequire("9Cg2G");
var $2e46507505cc992a$var$_helpersEach2 = $2e46507505cc992a$var$_interopRequireDefault($9Cg2G);

var $5FTXo = parcelRequire("5FTXo");
var $2e46507505cc992a$var$_helpersHelperMissing2 = $2e46507505cc992a$var$_interopRequireDefault($5FTXo);

var $18KG5 = parcelRequire("18KG5");
var $2e46507505cc992a$var$_helpersIf2 = $2e46507505cc992a$var$_interopRequireDefault($18KG5);

var $78F4J = parcelRequire("78F4J");
var $2e46507505cc992a$var$_helpersLog2 = $2e46507505cc992a$var$_interopRequireDefault($78F4J);

var $6WJO8 = parcelRequire("6WJO8");
var $2e46507505cc992a$var$_helpersLookup2 = $2e46507505cc992a$var$_interopRequireDefault($6WJO8);

var $3TDwm = parcelRequire("3TDwm");
var $2e46507505cc992a$var$_helpersWith2 = $2e46507505cc992a$var$_interopRequireDefault($3TDwm);
function $2e46507505cc992a$var$registerDefaultHelpers(instance) {
    $2e46507505cc992a$var$_helpersBlockHelperMissing2["default"](instance);
    $2e46507505cc992a$var$_helpersEach2["default"](instance);
    $2e46507505cc992a$var$_helpersHelperMissing2["default"](instance);
    $2e46507505cc992a$var$_helpersIf2["default"](instance);
    $2e46507505cc992a$var$_helpersLog2["default"](instance);
    $2e46507505cc992a$var$_helpersLookup2["default"](instance);
    $2e46507505cc992a$var$_helpersWith2["default"](instance);
}
function $2e46507505cc992a$var$moveHelperToHooks(instance, helperName, keepHelper) {
    if (instance.helpers[helperName]) {
        instance.hooks[helperName] = instance.helpers[helperName];
        if (!keepHelper) delete instance.helpers[helperName];
    }
}

});
parcelRegister("jPjs7", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $6kalm = parcelRequire("6kalm");
module.exports["default"] = function(instance) {
    instance.registerHelper("blockHelperMissing", function(context, options) {
        var inverse = options.inverse, fn = options.fn;
        if (context === true) return fn(this);
        else if (context === false || context == null) return inverse(this);
        else if ($6kalm.isArray(context)) {
            if (context.length > 0) {
                if (options.ids) options.ids = [
                    options.name
                ];
                return instance.helpers.each(context, options);
            } else return inverse(this);
        } else {
            if (options.data && options.ids) {
                var data = $6kalm.createFrame(options.data);
                data.contextPath = $6kalm.appendContextPath(options.data.contextPath, options.name);
                options = {
                    data: data
                };
            }
            return fn(context, options);
        }
    });
};
module.exports = module.exports["default"];

});

parcelRegister("9Cg2G", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $70041b59f363ea12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6kalm = parcelRequire("6kalm");

var $6fk66 = parcelRequire("6fk66");
var $70041b59f363ea12$var$_exception2 = $70041b59f363ea12$var$_interopRequireDefault($6fk66);
module.exports["default"] = function(instance) {
    instance.registerHelper("each", function(context, options) {
        if (!options) throw new $70041b59f363ea12$var$_exception2["default"]("Must pass iterator to #each");
        var fn = options.fn, inverse = options.inverse, i = 0, ret = "", data = undefined, contextPath = undefined;
        if (options.data && options.ids) contextPath = $6kalm.appendContextPath(options.data.contextPath, options.ids[0]) + ".";
        if ($6kalm.isFunction(context)) context = context.call(this);
        if (options.data) data = $6kalm.createFrame(options.data);
        function execIteration(field, index, last) {
            if (data) {
                data.key = field;
                data.index = index;
                data.first = index === 0;
                data.last = !!last;
                if (contextPath) data.contextPath = contextPath + field;
            }
            ret = ret + fn(context[field], {
                data: data,
                blockParams: $6kalm.blockParams([
                    context[field],
                    field
                ], [
                    contextPath + field,
                    null
                ])
            });
        }
        if (context && typeof context === "object") {
            if ($6kalm.isArray(context)) {
                for(var j = context.length; i < j; i++)if (i in context) execIteration(i, i, i === context.length - 1);
            } else if (typeof Symbol === "function" && context[Symbol.iterator]) {
                var newContext = [];
                var iterator = context[Symbol.iterator]();
                for(var it = iterator.next(); !it.done; it = iterator.next())newContext.push(it.value);
                context = newContext;
                for(var j = context.length; i < j; i++)execIteration(i, i, i === context.length - 1);
            } else (function() {
                var priorKey = undefined;
                Object.keys(context).forEach(function(key) {
                    // We're running the iterations one step out of sync so we can detect
                    // the last iteration without have to scan the object twice and create
                    // an itermediate keys array.
                    if (priorKey !== undefined) execIteration(priorKey, i - 1);
                    priorKey = key;
                    i++;
                });
                if (priorKey !== undefined) execIteration(priorKey, i - 1, true);
            })();
        }
        if (i === 0) ret = inverse(this);
        return ret;
    });
};
module.exports = module.exports["default"];

});

parcelRegister("5FTXo", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $421c2ffc3070296e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6fk66 = parcelRequire("6fk66");
var $421c2ffc3070296e$var$_exception2 = $421c2ffc3070296e$var$_interopRequireDefault($6fk66);
module.exports["default"] = function(instance) {
    instance.registerHelper("helperMissing", function() /* [args, ]options */ {
        if (arguments.length === 1) // A missing field in a {{foo}} construct.
        return undefined;
        else // Someone is actually trying to call something, blow up.
        throw new $421c2ffc3070296e$var$_exception2["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    });
};
module.exports = module.exports["default"];

});

parcelRegister("18KG5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $0d4abf1026e6cf4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6kalm = parcelRequire("6kalm");

var $6fk66 = parcelRequire("6fk66");
var $0d4abf1026e6cf4a$var$_exception2 = $0d4abf1026e6cf4a$var$_interopRequireDefault($6fk66);
module.exports["default"] = function(instance) {
    instance.registerHelper("if", function(conditional, options) {
        if (arguments.length != 2) throw new $0d4abf1026e6cf4a$var$_exception2["default"]("#if requires exactly one argument");
        if ($6kalm.isFunction(conditional)) conditional = conditional.call(this);
        // Default behavior is to render the positive path if the value is truthy and not empty.
        // The `includeZero` option may be set to treat the condtional as purely not empty based on the
        // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
        if (!options.hash.includeZero && !conditional || $6kalm.isEmpty(conditional)) return options.inverse(this);
        else return options.fn(this);
    });
    instance.registerHelper("unless", function(conditional, options) {
        if (arguments.length != 2) throw new $0d4abf1026e6cf4a$var$_exception2["default"]("#unless requires exactly one argument");
        return instance.helpers["if"].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn,
            hash: options.hash
        });
    });
};
module.exports = module.exports["default"];

});

parcelRegister("78F4J", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("log", function() /* message, options */ {
        var args = [
            undefined
        ], options = arguments[arguments.length - 1];
        for(var i = 0; i < arguments.length - 1; i++)args.push(arguments[i]);
        var level = 1;
        if (options.hash.level != null) level = options.hash.level;
        else if (options.data && options.data.level != null) level = options.data.level;
        args[0] = level;
        instance.log.apply(instance, args);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("6WJO8", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = function(instance) {
    instance.registerHelper("lookup", function(obj, field, options) {
        if (!obj) // Note for 5.0: Change to "obj == null" in 5.0
        return obj;
        return options.lookupProperty(obj, field);
    });
};
module.exports = module.exports["default"];

});

parcelRegister("3TDwm", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $2d652a2e01594c37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6kalm = parcelRequire("6kalm");

var $6fk66 = parcelRequire("6fk66");
var $2d652a2e01594c37$var$_exception2 = $2d652a2e01594c37$var$_interopRequireDefault($6fk66);
module.exports["default"] = function(instance) {
    instance.registerHelper("with", function(context, options) {
        if (arguments.length != 2) throw new $2d652a2e01594c37$var$_exception2["default"]("#with requires exactly one argument");
        if ($6kalm.isFunction(context)) context = context.call(this);
        var fn = options.fn;
        if (!$6kalm.isEmpty(context)) {
            var data = options.data;
            if (options.data && options.ids) {
                data = $6kalm.createFrame(options.data);
                data.contextPath = $6kalm.appendContextPath(options.data.contextPath, options.ids[0]);
            }
            return fn(context, {
                data: data,
                blockParams: $6kalm.blockParams([
                    context
                ], [
                    data && data.contextPath
                ])
            });
        } else return options.inverse(this);
    });
};
module.exports = module.exports["default"];

});


parcelRegister("gQbm4", function(module, exports) {

$parcel$export(module.exports, "registerDefaultDecorators", function () { return $c42a4f8cdd1555bb$export$7eaca4a3d56dbe6d; }, function (v) { return $c42a4f8cdd1555bb$export$7eaca4a3d56dbe6d = v; });
var $c42a4f8cdd1555bb$export$1e511d4a378977f5;
var $c42a4f8cdd1555bb$export$7eaca4a3d56dbe6d;
"use strict";
$c42a4f8cdd1555bb$export$1e511d4a378977f5 = true;
$c42a4f8cdd1555bb$export$7eaca4a3d56dbe6d = $c42a4f8cdd1555bb$var$registerDefaultDecorators;
// istanbul ignore next
function $c42a4f8cdd1555bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $ihMmW = parcelRequire("ihMmW");
var $c42a4f8cdd1555bb$var$_decoratorsInline2 = $c42a4f8cdd1555bb$var$_interopRequireDefault($ihMmW);
function $c42a4f8cdd1555bb$var$registerDefaultDecorators(instance) {
    $c42a4f8cdd1555bb$var$_decoratorsInline2["default"](instance);
}

});
parcelRegister("ihMmW", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $6kalm = parcelRequire("6kalm");
module.exports["default"] = function(instance) {
    instance.registerDecorator("inline", function(fn, props, container, options) {
        var ret = fn;
        if (!props.partials) {
            props.partials = {};
            ret = function(context, options) {
                // Create a new partials stack frame prior to exec.
                var original = container.partials;
                container.partials = $6kalm.extend({}, original, props.partials);
                var ret = fn(context, options);
                container.partials = original;
                return ret;
            };
        }
        props.partials[options.args[0]] = options.fn;
        return ret;
    });
};
module.exports = module.exports["default"];

});


parcelRegister("jepZe", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $6kalm = parcelRequire("6kalm");
var $e0037b8570e86be6$var$logger = {
    methodMap: [
        "debug",
        "info",
        "warn",
        "error"
    ],
    level: "info",
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function lookupLevel(level) {
        if (typeof level === "string") {
            var levelMap = $6kalm.indexOf($e0037b8570e86be6$var$logger.methodMap, level.toLowerCase());
            if (levelMap >= 0) level = levelMap;
            else level = parseInt(level, 10);
        }
        return level;
    },
    // Can be overridden in the host environment
    log: function log(level) {
        level = $e0037b8570e86be6$var$logger.lookupLevel(level);
        if (typeof console !== "undefined" && $e0037b8570e86be6$var$logger.lookupLevel($e0037b8570e86be6$var$logger.level) <= level) {
            var method = $e0037b8570e86be6$var$logger.methodMap[level];
            // eslint-disable-next-line no-console
            if (!console[method]) method = "log";
            for(var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)message[_key - 1] = arguments[_key];
            console[method].apply(console, message); // eslint-disable-line no-console
        }
    }
};
module.exports["default"] = $e0037b8570e86be6$var$logger;
module.exports = module.exports["default"];

});

parcelRegister("4zuHC", function(module, exports) {

$parcel$export(module.exports, "createProtoAccessControl", function () { return $35423f3652b60fe4$export$9fc505f5102b04a5; }, function (v) { return $35423f3652b60fe4$export$9fc505f5102b04a5 = v; });
$parcel$export(module.exports, "resultIsAllowed", function () { return $35423f3652b60fe4$export$8b633651c7cf59b9; }, function (v) { return $35423f3652b60fe4$export$8b633651c7cf59b9 = v; });
$parcel$export(module.exports, "resetLoggedProperties", function () { return $35423f3652b60fe4$export$419dc2c4b2f2238b; }, function (v) { return $35423f3652b60fe4$export$419dc2c4b2f2238b = v; });
var $35423f3652b60fe4$export$1e511d4a378977f5;
var $35423f3652b60fe4$export$9fc505f5102b04a5;
var $35423f3652b60fe4$export$8b633651c7cf59b9;
var $35423f3652b60fe4$export$419dc2c4b2f2238b;
"use strict";
$35423f3652b60fe4$export$1e511d4a378977f5 = true;
$35423f3652b60fe4$export$9fc505f5102b04a5 = $35423f3652b60fe4$var$createProtoAccessControl;
$35423f3652b60fe4$export$8b633651c7cf59b9 = $35423f3652b60fe4$var$resultIsAllowed;
$35423f3652b60fe4$export$419dc2c4b2f2238b = $35423f3652b60fe4$var$resetLoggedProperties;
// istanbul ignore next
function $35423f3652b60fe4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $kdUJ5 = parcelRequire("kdUJ5");

var $jepZe = parcelRequire("jepZe");
var $35423f3652b60fe4$var$_logger2 = $35423f3652b60fe4$var$_interopRequireDefault($jepZe);
var $35423f3652b60fe4$var$loggedProperties = Object.create(null);
function $35423f3652b60fe4$var$createProtoAccessControl(runtimeOptions) {
    var defaultMethodWhiteList = Object.create(null);
    defaultMethodWhiteList["constructor"] = false;
    defaultMethodWhiteList["__defineGetter__"] = false;
    defaultMethodWhiteList["__defineSetter__"] = false;
    defaultMethodWhiteList["__lookupGetter__"] = false;
    var defaultPropertyWhiteList = Object.create(null);
    // eslint-disable-next-line no-proto
    defaultPropertyWhiteList["__proto__"] = false;
    return {
        properties: {
            whitelist: $kdUJ5.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
            defaultValue: runtimeOptions.allowProtoPropertiesByDefault
        },
        methods: {
            whitelist: $kdUJ5.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
            defaultValue: runtimeOptions.allowProtoMethodsByDefault
        }
    };
}
function $35423f3652b60fe4$var$resultIsAllowed(result, protoAccessControl, propertyName) {
    if (typeof result === "function") return $35423f3652b60fe4$var$checkWhiteList(protoAccessControl.methods, propertyName);
    else return $35423f3652b60fe4$var$checkWhiteList(protoAccessControl.properties, propertyName);
}
function $35423f3652b60fe4$var$checkWhiteList(protoAccessControlForType, propertyName) {
    if (protoAccessControlForType.whitelist[propertyName] !== undefined) return protoAccessControlForType.whitelist[propertyName] === true;
    if (protoAccessControlForType.defaultValue !== undefined) return protoAccessControlForType.defaultValue;
    $35423f3652b60fe4$var$logUnexpecedPropertyAccessOnce(propertyName);
    return false;
}
function $35423f3652b60fe4$var$logUnexpecedPropertyAccessOnce(propertyName) {
    if ($35423f3652b60fe4$var$loggedProperties[propertyName] !== true) {
        $35423f3652b60fe4$var$loggedProperties[propertyName] = true;
        $35423f3652b60fe4$var$_logger2["default"].log("error", 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + "You can add a runtime option to disable the check or this warning:\n" + "See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details");
    }
}
function $35423f3652b60fe4$var$resetLoggedProperties() {
    Object.keys($35423f3652b60fe4$var$loggedProperties).forEach(function(propertyName) {
        delete $35423f3652b60fe4$var$loggedProperties[propertyName];
    });
}

});
parcelRegister("kdUJ5", function(module, exports) {

$parcel$export(module.exports, "createNewLookupObject", function () { return $eb910631a76bec9e$export$ec2932ee0c0e8dcc; }, function (v) { return $eb910631a76bec9e$export$ec2932ee0c0e8dcc = v; });
var $eb910631a76bec9e$export$1e511d4a378977f5;
var $eb910631a76bec9e$export$ec2932ee0c0e8dcc;
"use strict";
$eb910631a76bec9e$export$1e511d4a378977f5 = true;
$eb910631a76bec9e$export$ec2932ee0c0e8dcc = $eb910631a76bec9e$var$createNewLookupObject;

var $6kalm = parcelRequire("6kalm");
/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */ function $eb910631a76bec9e$var$createNewLookupObject() {
    for(var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    return $6kalm.extend.apply(undefined, [
        Object.create(null)
    ].concat(sources));
}

});



parcelRegister("eJIc2", function(module, exports) {
// Build out our basic SafeString type
"use strict";
module.exports.__esModule = true;
function $aba78c851d1819bd$var$SafeString(string) {
    this.string = string;
}
$aba78c851d1819bd$var$SafeString.prototype.toString = $aba78c851d1819bd$var$SafeString.prototype.toHTML = function() {
    return "" + this.string;
};
module.exports["default"] = $aba78c851d1819bd$var$SafeString;
module.exports = module.exports["default"];

});

parcelRegister("6TFcA", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $5057d6f9dd92c462$export$1e511d4a378977f5; }, function (v) { return $5057d6f9dd92c462$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "checkRevision", function () { return $5057d6f9dd92c462$export$1a97de37fc44aecb; }, function (v) { return $5057d6f9dd92c462$export$1a97de37fc44aecb = v; });
$parcel$export(module.exports, "template", function () { return $5057d6f9dd92c462$export$ce69bd05624d0c48; }, function (v) { return $5057d6f9dd92c462$export$ce69bd05624d0c48 = v; });
$parcel$export(module.exports, "wrapProgram", function () { return $5057d6f9dd92c462$export$3976c39aa34be3b; }, function (v) { return $5057d6f9dd92c462$export$3976c39aa34be3b = v; });
$parcel$export(module.exports, "resolvePartial", function () { return $5057d6f9dd92c462$export$ee54384c867bf98e; }, function (v) { return $5057d6f9dd92c462$export$ee54384c867bf98e = v; });
$parcel$export(module.exports, "invokePartial", function () { return $5057d6f9dd92c462$export$6c4303200e44071a; }, function (v) { return $5057d6f9dd92c462$export$6c4303200e44071a = v; });
$parcel$export(module.exports, "noop", function () { return $5057d6f9dd92c462$export$8793edee2d425525; }, function (v) { return $5057d6f9dd92c462$export$8793edee2d425525 = v; });
var $5057d6f9dd92c462$export$1e511d4a378977f5;
var $5057d6f9dd92c462$export$1a97de37fc44aecb;
var $5057d6f9dd92c462$export$ce69bd05624d0c48;
var $5057d6f9dd92c462$export$3976c39aa34be3b;
var $5057d6f9dd92c462$export$ee54384c867bf98e;
var $5057d6f9dd92c462$export$6c4303200e44071a;
var $5057d6f9dd92c462$export$8793edee2d425525;
"use strict";
$5057d6f9dd92c462$export$1e511d4a378977f5 = true;
$5057d6f9dd92c462$export$1a97de37fc44aecb = $5057d6f9dd92c462$var$checkRevision;
$5057d6f9dd92c462$export$ce69bd05624d0c48 = $5057d6f9dd92c462$var$template;
$5057d6f9dd92c462$export$3976c39aa34be3b = $5057d6f9dd92c462$var$wrapProgram;
$5057d6f9dd92c462$export$ee54384c867bf98e = $5057d6f9dd92c462$var$resolvePartial;
$5057d6f9dd92c462$export$6c4303200e44071a = $5057d6f9dd92c462$var$invokePartial;
$5057d6f9dd92c462$export$8793edee2d425525 = $5057d6f9dd92c462$var$noop;
// istanbul ignore next
function $5057d6f9dd92c462$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// istanbul ignore next
function $5057d6f9dd92c462$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}

var $6kalm = parcelRequire("6kalm");
var $5057d6f9dd92c462$var$Utils = $5057d6f9dd92c462$var$_interopRequireWildcard($6kalm);

var $6fk66 = parcelRequire("6fk66");
var $5057d6f9dd92c462$var$_exception2 = $5057d6f9dd92c462$var$_interopRequireDefault($6fk66);

var $24qvS = parcelRequire("24qvS");

var $3YjM4 = parcelRequire("3YjM4");

var $8WFFn = parcelRequire("8WFFn");

var $4zuHC = parcelRequire("4zuHC");
function $5057d6f9dd92c462$var$checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = $24qvS.COMPILER_REVISION;
    if (compilerRevision >= $24qvS.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= $24qvS.COMPILER_REVISION) return;
    if (compilerRevision < $24qvS.LAST_COMPATIBLE_COMPILER_REVISION) {
        var runtimeVersions = $24qvS.REVISION_CHANGES[currentRevision], compilerVersions = $24qvS.REVISION_CHANGES[compilerRevision];
        throw new $5057d6f9dd92c462$var$_exception2["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ") or downgrade your runtime to an older version (" + compilerVersions + ").");
    } else // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new $5057d6f9dd92c462$var$_exception2["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ").");
}
function $5057d6f9dd92c462$var$template(templateSpec, env) {
    /* istanbul ignore next */ if (!env) throw new $5057d6f9dd92c462$var$_exception2["default"]("No environment passed to template");
    if (!templateSpec || !templateSpec.main) throw new $5057d6f9dd92c462$var$_exception2["default"]("Unknown template object: " + typeof templateSpec);
    templateSpec.main.decorator = templateSpec.main_d;
    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as pseudo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler);
    // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
    var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
    function invokePartialWrapper(partial, context, options) {
        if (options.hash) {
            context = $5057d6f9dd92c462$var$Utils.extend({}, context, options.hash);
            if (options.ids) options.ids[0] = true;
        }
        partial = env.VM.resolvePartial.call(this, partial, context, options);
        var extendedOptions = $5057d6f9dd92c462$var$Utils.extend({}, options, {
            hooks: this.hooks,
            protoAccessControl: this.protoAccessControl
        });
        var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
        if (result == null && env.compile) {
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, extendedOptions);
        }
        if (result != null) {
            if (options.indent) {
                var lines = result.split("\n");
                for(var i = 0, l = lines.length; i < l; i++){
                    if (!lines[i] && i + 1 === l) break;
                    lines[i] = options.indent + lines[i];
                }
                result = lines.join("\n");
            }
            return result;
        } else throw new $5057d6f9dd92c462$var$_exception2["default"]("The partial " + options.name + " could not be compiled when running in runtime-only mode");
    }
    // Just add water
    var container = {
        strict: function strict(obj, name, loc) {
            if (!obj || !(name in obj)) throw new $5057d6f9dd92c462$var$_exception2["default"]('"' + name + '" not defined in ' + obj, {
                loc: loc
            });
            return container.lookupProperty(obj, name);
        },
        lookupProperty: function lookupProperty(parent, propertyName) {
            var result = parent[propertyName];
            if (result == null) return result;
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return result;
            if ($4zuHC.resultIsAllowed(result, container.protoAccessControl, propertyName)) return result;
            return undefined;
        },
        lookup: function lookup(depths, name) {
            var len = depths.length;
            for(var i = 0; i < len; i++){
                var result = depths[i] && container.lookupProperty(depths[i], name);
                if (result != null) return depths[i][name];
            }
        },
        lambda: function lambda(current, context) {
            return typeof current === "function" ? current.call(context) : current;
        },
        escapeExpression: $5057d6f9dd92c462$var$Utils.escapeExpression,
        invokePartial: invokePartialWrapper,
        fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + "_d"];
            return ret;
        },
        programs: [],
        program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i], fn = this.fn(i);
            if (data || depths || blockParams || declaredBlockParams) programWrapper = $5057d6f9dd92c462$var$wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            else if (!programWrapper) programWrapper = this.programs[i] = $5057d6f9dd92c462$var$wrapProgram(this, i, fn);
            return programWrapper;
        },
        data: function data(value, depth) {
            while(value && depth--)value = value._parent;
            return value;
        },
        mergeIfNeeded: function mergeIfNeeded(param, common) {
            var obj = param || common;
            if (param && common && param !== common) obj = $5057d6f9dd92c462$var$Utils.extend({}, common, param);
            return obj;
        },
        // An empty object to use as replacement for null-contexts
        nullContext: Object.seal({}),
        noop: env.VM.noop,
        compilerInfo: templateSpec.compiler
    };
    function ret(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var data = options.data;
        ret._setup(options);
        if (!options.partial && templateSpec.useData) data = $5057d6f9dd92c462$var$initData(context, data);
        var depths = undefined, blockParams = templateSpec.useBlockParams ? [] : undefined;
        if (templateSpec.useDepths) {
            if (options.depths) depths = context != options.depths[0] ? [
                context
            ].concat(options.depths) : options.depths;
            else depths = [
                context
            ];
        }
        function main(context /*, options*/ ) {
            return "" + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
        }
        main = $5057d6f9dd92c462$var$executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
        return main(context, options);
    }
    ret.isTop = true;
    ret._setup = function(options) {
        if (!options.partial) {
            var mergedHelpers = $5057d6f9dd92c462$var$Utils.extend({}, env.helpers, options.helpers);
            $5057d6f9dd92c462$var$wrapHelpersToPassLookupProperty(mergedHelpers, container);
            container.helpers = mergedHelpers;
            if (templateSpec.usePartial) // Use mergeIfNeeded here to prevent compiling global partials multiple times
            container.partials = container.mergeIfNeeded(options.partials, env.partials);
            if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = $5057d6f9dd92c462$var$Utils.extend({}, env.decorators, options.decorators);
            container.hooks = {};
            container.protoAccessControl = $4zuHC.createProtoAccessControl(options);
            var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
            $3YjM4.moveHelperToHooks(container, "helperMissing", keepHelperInHelpers);
            $3YjM4.moveHelperToHooks(container, "blockHelperMissing", keepHelperInHelpers);
        } else {
            container.protoAccessControl = options.protoAccessControl; // internal option
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
            container.hooks = options.hooks;
        }
    };
    ret._child = function(i, data, blockParams, depths) {
        if (templateSpec.useBlockParams && !blockParams) throw new $5057d6f9dd92c462$var$_exception2["default"]("must pass block params");
        if (templateSpec.useDepths && !depths) throw new $5057d6f9dd92c462$var$_exception2["default"]("must pass parent depths");
        return $5057d6f9dd92c462$var$wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
    };
    return ret;
}
function $5057d6f9dd92c462$var$wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
    function prog(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var currentDepths = depths;
        if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [
            context
        ].concat(depths);
        return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [
            options.blockParams
        ].concat(blockParams), currentDepths);
    }
    prog = $5057d6f9dd92c462$var$executeDecorators(fn, prog, container, depths, data, blockParams);
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    prog.blockParams = declaredBlockParams || 0;
    return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */ function $5057d6f9dd92c462$var$resolvePartial(partial, context, options) {
    if (!partial) {
        if (options.name === "@partial-block") partial = options.data["partial-block"];
        else partial = options.partials[options.name];
    } else if (!partial.call && !options.name) {
        // This is a dynamic partial that returned a string
        options.name = partial;
        partial = options.partials[partial];
    }
    return partial;
}
function $5057d6f9dd92c462$var$invokePartial(partial, context, options) {
    // Use the current closure context to save the partial-block if this partial
    var currentPartialBlock = options.data && options.data["partial-block"];
    options.partial = true;
    if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
    var partialBlock = undefined;
    if (options.fn && options.fn !== $5057d6f9dd92c462$var$noop) (function() {
        options.data = $24qvS.createFrame(options.data);
        // Wrapper function to get access to currentPartialBlock from the closure
        var fn = options.fn;
        partialBlock = options.data["partial-block"] = function partialBlockWrapper(context) {
            var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            // Restore the partial-block from the closure for the execution of the block
            // i.e. the part inside the block of the partial call.
            options.data = $24qvS.createFrame(options.data);
            options.data["partial-block"] = currentPartialBlock;
            return fn(context, options);
        };
        if (fn.partials) options.partials = $5057d6f9dd92c462$var$Utils.extend({}, options.partials, fn.partials);
    })();
    if (partial === undefined && partialBlock) partial = partialBlock;
    if (partial === undefined) throw new $5057d6f9dd92c462$var$_exception2["default"]("The partial " + options.name + " could not be found");
    else if (partial instanceof Function) return partial(context, options);
}
function $5057d6f9dd92c462$var$noop() {
    return "";
}
function $5057d6f9dd92c462$var$initData(context, data) {
    if (!data || !("root" in data)) {
        data = data ? $24qvS.createFrame(data) : {};
        data.root = context;
    }
    return data;
}
function $5057d6f9dd92c462$var$executeDecorators(fn, prog, container, depths, data, blockParams) {
    if (fn.decorator) {
        var props = {};
        prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
        $5057d6f9dd92c462$var$Utils.extend(prog, props);
    }
    return prog;
}
function $5057d6f9dd92c462$var$wrapHelpersToPassLookupProperty(mergedHelpers, container) {
    Object.keys(mergedHelpers).forEach(function(helperName) {
        var helper = mergedHelpers[helperName];
        mergedHelpers[helperName] = $5057d6f9dd92c462$var$passLookupPropertyOption(helper, container);
    });
}
function $5057d6f9dd92c462$var$passLookupPropertyOption(helper, container) {
    var lookupProperty = container.lookupProperty;
    return $8WFFn.wrapHelper(helper, function(options) {
        return $5057d6f9dd92c462$var$Utils.extend({
            lookupProperty: lookupProperty
        }, options);
    });
}

});
parcelRegister("8WFFn", function(module, exports) {

$parcel$export(module.exports, "wrapHelper", function () { return $68340f9396a26096$export$34b84bc8884ca465; }, function (v) { return $68340f9396a26096$export$34b84bc8884ca465 = v; });
var $68340f9396a26096$export$1e511d4a378977f5;
var $68340f9396a26096$export$34b84bc8884ca465;
"use strict";
$68340f9396a26096$export$1e511d4a378977f5 = true;
$68340f9396a26096$export$34b84bc8884ca465 = $68340f9396a26096$var$wrapHelper;
function $68340f9396a26096$var$wrapHelper(helper, transformOptionsFn) {
    if (typeof helper !== "function") // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
    var wrapper = function wrapper() /* dynamic arguments */ {
        var options = arguments[arguments.length - 1];
        arguments[arguments.length - 1] = transformOptionsFn(options);
        return helper.apply(this, arguments);
    };
    return wrapper;
}

});


parcelRegister("1R8En", function(module, exports) {
/* global globalThis */ "use strict";
module.exports.__esModule = true;
module.exports["default"] = function(Handlebars) {
    /* istanbul ignore next */ // https://mathiasbynens.be/notes/globalthis
    (function() {
        if (typeof globalThis === "object") return;
        Object.prototype.__defineGetter__("__magic__", function() {
            return this;
        });
        __magic__.globalThis = __magic__; // eslint-disable-line no-undef
        delete Object.prototype.__magic__;
    })();
    var $Handlebars = globalThis.Handlebars;
    /* istanbul ignore next */ Handlebars.noConflict = function() {
        if (globalThis.Handlebars === Handlebars) globalThis.Handlebars = $Handlebars;
        return Handlebars;
    };
};
module.exports = module.exports["default"];

});


parcelRegister("dUGfH", function(module, exports) {
"use strict";
module.exports.__esModule = true;
var $a21147bbb8699768$var$AST = {
    // Public API used to evaluate derived attributes regarding AST nodes
    helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function helperExpression(node) {
            return node.type === "SubExpression" || (node.type === "MustacheStatement" || node.type === "BlockStatement") && !!(node.params && node.params.length || node.hash);
        },
        scopedId: function scopedId(path) {
            return /^\.|this\b/.test(path.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function simpleId(path) {
            return path.parts.length === 1 && !$a21147bbb8699768$var$AST.helpers.scopedId(path) && !path.depth;
        }
    }
};
// Must be exported as an object rather than the root of the module as the jison lexer
// must modify the object to operate properly.
module.exports["default"] = $a21147bbb8699768$var$AST;
module.exports = module.exports["default"];

});

parcelRegister("gcFST", function(module, exports) {

$parcel$export(module.exports, "parseWithoutProcessing", function () { return $bcbe41b01ba4119c$export$fc85b2c4462e0bc6; }, function (v) { return $bcbe41b01ba4119c$export$fc85b2c4462e0bc6 = v; });
$parcel$export(module.exports, "parse", function () { return $bcbe41b01ba4119c$export$98e6a39c04603d36; }, function (v) { return $bcbe41b01ba4119c$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "parser", function () { return $bcbe41b01ba4119c$export$8f49e4af10703ce3; }, function (v) { return $bcbe41b01ba4119c$export$8f49e4af10703ce3 = v; });
var $bcbe41b01ba4119c$export$1e511d4a378977f5;
var $bcbe41b01ba4119c$export$fc85b2c4462e0bc6;
var $bcbe41b01ba4119c$export$98e6a39c04603d36;
var $bcbe41b01ba4119c$export$8f49e4af10703ce3;
"use strict";
$bcbe41b01ba4119c$export$1e511d4a378977f5 = true;
$bcbe41b01ba4119c$export$fc85b2c4462e0bc6 = $bcbe41b01ba4119c$var$parseWithoutProcessing;
$bcbe41b01ba4119c$export$98e6a39c04603d36 = $bcbe41b01ba4119c$var$parse;
// istanbul ignore next
function $bcbe41b01ba4119c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj["default"] = obj;
        return newObj;
    }
}
// istanbul ignore next
function $bcbe41b01ba4119c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $fB5LL = parcelRequire("fB5LL");
var $bcbe41b01ba4119c$var$_parser2 = $bcbe41b01ba4119c$var$_interopRequireDefault($fB5LL);

var $cjOZa = parcelRequire("cjOZa");
var $bcbe41b01ba4119c$var$_whitespaceControl2 = $bcbe41b01ba4119c$var$_interopRequireDefault($cjOZa);

var $ghAQ4 = parcelRequire("ghAQ4");
var $bcbe41b01ba4119c$var$Helpers = $bcbe41b01ba4119c$var$_interopRequireWildcard($ghAQ4);

var $6kalm = parcelRequire("6kalm");
$bcbe41b01ba4119c$export$8f49e4af10703ce3 = $bcbe41b01ba4119c$var$_parser2["default"];
var $bcbe41b01ba4119c$var$yy = {};
$6kalm.extend($bcbe41b01ba4119c$var$yy, $bcbe41b01ba4119c$var$Helpers);
function $bcbe41b01ba4119c$var$parseWithoutProcessing(input, options) {
    // Just return if an already-compiled AST was passed in.
    if (input.type === "Program") return input;
    $bcbe41b01ba4119c$var$_parser2["default"].yy = $bcbe41b01ba4119c$var$yy;
    // Altering the shared object here, but this is ok as parser is a sync operation
    $bcbe41b01ba4119c$var$yy.locInfo = function(locInfo) {
        return new $bcbe41b01ba4119c$var$yy.SourceLocation(options && options.srcName, locInfo);
    };
    var ast = $bcbe41b01ba4119c$var$_parser2["default"].parse(input);
    return ast;
}
function $bcbe41b01ba4119c$var$parse(input, options) {
    var ast = $bcbe41b01ba4119c$var$parseWithoutProcessing(input, options);
    var strip = new $bcbe41b01ba4119c$var$_whitespaceControl2["default"](options);
    return strip.accept(ast);
}

});
parcelRegister("fB5LL", function(module, exports) {
// File ignored in coverage tests via setting in .istanbul.yml
/* Jison generated parser */ "use strict";
module.exports.__esModule = true;
var $b5aec96ab869c754$var$handlebars = function() {
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "root": 3,
            "program": 4,
            "EOF": 5,
            "program_repetition0": 6,
            "statement": 7,
            "mustache": 8,
            "block": 9,
            "rawBlock": 10,
            "partial": 11,
            "partialBlock": 12,
            "content": 13,
            "COMMENT": 14,
            "CONTENT": 15,
            "openRawBlock": 16,
            "rawBlock_repetition0": 17,
            "END_RAW_BLOCK": 18,
            "OPEN_RAW_BLOCK": 19,
            "helperName": 20,
            "openRawBlock_repetition0": 21,
            "openRawBlock_option0": 22,
            "CLOSE_RAW_BLOCK": 23,
            "openBlock": 24,
            "block_option0": 25,
            "closeBlock": 26,
            "openInverse": 27,
            "block_option1": 28,
            "OPEN_BLOCK": 29,
            "openBlock_repetition0": 30,
            "openBlock_option0": 31,
            "openBlock_option1": 32,
            "CLOSE": 33,
            "OPEN_INVERSE": 34,
            "openInverse_repetition0": 35,
            "openInverse_option0": 36,
            "openInverse_option1": 37,
            "openInverseChain": 38,
            "OPEN_INVERSE_CHAIN": 39,
            "openInverseChain_repetition0": 40,
            "openInverseChain_option0": 41,
            "openInverseChain_option1": 42,
            "inverseAndProgram": 43,
            "INVERSE": 44,
            "inverseChain": 45,
            "inverseChain_option0": 46,
            "OPEN_ENDBLOCK": 47,
            "OPEN": 48,
            "mustache_repetition0": 49,
            "mustache_option0": 50,
            "OPEN_UNESCAPED": 51,
            "mustache_repetition1": 52,
            "mustache_option1": 53,
            "CLOSE_UNESCAPED": 54,
            "OPEN_PARTIAL": 55,
            "partialName": 56,
            "partial_repetition0": 57,
            "partial_option0": 58,
            "openPartialBlock": 59,
            "OPEN_PARTIAL_BLOCK": 60,
            "openPartialBlock_repetition0": 61,
            "openPartialBlock_option0": 62,
            "param": 63,
            "sexpr": 64,
            "OPEN_SEXPR": 65,
            "sexpr_repetition0": 66,
            "sexpr_option0": 67,
            "CLOSE_SEXPR": 68,
            "hash": 69,
            "hash_repetition_plus0": 70,
            "hashSegment": 71,
            "ID": 72,
            "EQUALS": 73,
            "blockParams": 74,
            "OPEN_BLOCK_PARAMS": 75,
            "blockParams_repetition_plus0": 76,
            "CLOSE_BLOCK_PARAMS": 77,
            "path": 78,
            "dataName": 79,
            "STRING": 80,
            "NUMBER": 81,
            "BOOLEAN": 82,
            "UNDEFINED": 83,
            "NULL": 84,
            "DATA": 85,
            "pathSegments": 86,
            "SEP": 87,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            5: "EOF",
            14: "COMMENT",
            15: "CONTENT",
            18: "END_RAW_BLOCK",
            19: "OPEN_RAW_BLOCK",
            23: "CLOSE_RAW_BLOCK",
            29: "OPEN_BLOCK",
            33: "CLOSE",
            34: "OPEN_INVERSE",
            39: "OPEN_INVERSE_CHAIN",
            44: "INVERSE",
            47: "OPEN_ENDBLOCK",
            48: "OPEN",
            51: "OPEN_UNESCAPED",
            54: "CLOSE_UNESCAPED",
            55: "OPEN_PARTIAL",
            60: "OPEN_PARTIAL_BLOCK",
            65: "OPEN_SEXPR",
            68: "CLOSE_SEXPR",
            72: "ID",
            73: "EQUALS",
            75: "OPEN_BLOCK_PARAMS",
            77: "CLOSE_BLOCK_PARAMS",
            80: "STRING",
            81: "NUMBER",
            82: "BOOLEAN",
            83: "UNDEFINED",
            84: "NULL",
            85: "DATA",
            87: "SEP"
        },
        productions_: [
            0,
            [
                3,
                2
            ],
            [
                4,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                13,
                1
            ],
            [
                10,
                3
            ],
            [
                16,
                5
            ],
            [
                9,
                4
            ],
            [
                9,
                4
            ],
            [
                24,
                6
            ],
            [
                27,
                6
            ],
            [
                38,
                6
            ],
            [
                43,
                2
            ],
            [
                45,
                3
            ],
            [
                45,
                1
            ],
            [
                26,
                3
            ],
            [
                8,
                5
            ],
            [
                8,
                5
            ],
            [
                11,
                5
            ],
            [
                12,
                3
            ],
            [
                59,
                5
            ],
            [
                63,
                1
            ],
            [
                63,
                1
            ],
            [
                64,
                5
            ],
            [
                69,
                1
            ],
            [
                71,
                3
            ],
            [
                74,
                3
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                56,
                1
            ],
            [
                56,
                1
            ],
            [
                79,
                2
            ],
            [
                78,
                1
            ],
            [
                86,
                3
            ],
            [
                86,
                1
            ],
            [
                6,
                0
            ],
            [
                6,
                2
            ],
            [
                17,
                0
            ],
            [
                17,
                2
            ],
            [
                21,
                0
            ],
            [
                21,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                1
            ],
            [
                25,
                0
            ],
            [
                25,
                1
            ],
            [
                28,
                0
            ],
            [
                28,
                1
            ],
            [
                30,
                0
            ],
            [
                30,
                2
            ],
            [
                31,
                0
            ],
            [
                31,
                1
            ],
            [
                32,
                0
            ],
            [
                32,
                1
            ],
            [
                35,
                0
            ],
            [
                35,
                2
            ],
            [
                36,
                0
            ],
            [
                36,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                1
            ],
            [
                40,
                0
            ],
            [
                40,
                2
            ],
            [
                41,
                0
            ],
            [
                41,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                46,
                0
            ],
            [
                46,
                1
            ],
            [
                49,
                0
            ],
            [
                49,
                2
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                52,
                0
            ],
            [
                52,
                2
            ],
            [
                53,
                0
            ],
            [
                53,
                1
            ],
            [
                57,
                0
            ],
            [
                57,
                2
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                2
            ],
            [
                62,
                0
            ],
            [
                62,
                1
            ],
            [
                66,
                0
            ],
            [
                66,
                2
            ],
            [
                67,
                0
            ],
            [
                67,
                1
            ],
            [
                70,
                1
            ],
            [
                70,
                2
            ],
            [
                76,
                1
            ],
            [
                76,
                2
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
            var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    return $$[$0 - 1];
                case 2:
                    this.$ = yy.prepareProgram($$[$0]);
                    break;
                case 3:
                    this.$ = $$[$0];
                    break;
                case 4:
                    this.$ = $$[$0];
                    break;
                case 5:
                    this.$ = $$[$0];
                    break;
                case 6:
                    this.$ = $$[$0];
                    break;
                case 7:
                    this.$ = $$[$0];
                    break;
                case 8:
                    this.$ = $$[$0];
                    break;
                case 9:
                    this.$ = {
                        type: "CommentStatement",
                        value: yy.stripComment($$[$0]),
                        strip: yy.stripFlags($$[$0], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 10:
                    this.$ = {
                        type: "ContentStatement",
                        original: $$[$0],
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 11:
                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 12:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1]
                    };
                    break;
                case 13:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
                    break;
                case 14:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
                    break;
                case 15:
                    this.$ = {
                        open: $$[$0 - 5],
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 16:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 17:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 18:
                    this.$ = {
                        strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]),
                        program: $$[$0]
                    };
                    break;
                case 19:
                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$), program = yy.prepareProgram([
                        inverse
                    ], $$[$0 - 1].loc);
                    program.chained = true;
                    this.$ = {
                        strip: $$[$0 - 2].strip,
                        program: program,
                        chain: true
                    };
                    break;
                case 20:
                    this.$ = $$[$0];
                    break;
                case 21:
                    this.$ = {
                        path: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 2], $$[$0])
                    };
                    break;
                case 22:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 23:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 24:
                    this.$ = {
                        type: "PartialStatement",
                        name: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        indent: "",
                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 25:
                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 26:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 4], $$[$0])
                    };
                    break;
                case 27:
                    this.$ = $$[$0];
                    break;
                case 28:
                    this.$ = $$[$0];
                    break;
                case 29:
                    this.$ = {
                        type: "SubExpression",
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 30:
                    this.$ = {
                        type: "Hash",
                        pairs: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 31:
                    this.$ = {
                        type: "HashPair",
                        key: yy.id($$[$0 - 2]),
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 32:
                    this.$ = yy.id($$[$0 - 1]);
                    break;
                case 33:
                    this.$ = $$[$0];
                    break;
                case 34:
                    this.$ = $$[$0];
                    break;
                case 35:
                    this.$ = {
                        type: "StringLiteral",
                        value: $$[$0],
                        original: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 36:
                    this.$ = {
                        type: "NumberLiteral",
                        value: Number($$[$0]),
                        original: Number($$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 37:
                    this.$ = {
                        type: "BooleanLiteral",
                        value: $$[$0] === "true",
                        original: $$[$0] === "true",
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 38:
                    this.$ = {
                        type: "UndefinedLiteral",
                        original: undefined,
                        value: undefined,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 39:
                    this.$ = {
                        type: "NullLiteral",
                        original: null,
                        value: null,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 40:
                    this.$ = $$[$0];
                    break;
                case 41:
                    this.$ = $$[$0];
                    break;
                case 42:
                    this.$ = yy.preparePath(true, $$[$0], this._$);
                    break;
                case 43:
                    this.$ = yy.preparePath(false, $$[$0], this._$);
                    break;
                case 44:
                    $$[$0 - 2].push({
                        part: yy.id($$[$0]),
                        original: $$[$0],
                        separator: $$[$0 - 1]
                    });
                    this.$ = $$[$0 - 2];
                    break;
                case 45:
                    this.$ = [
                        {
                            part: yy.id($$[$0]),
                            original: $$[$0]
                        }
                    ];
                    break;
                case 46:
                    this.$ = [];
                    break;
                case 47:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 48:
                    this.$ = [];
                    break;
                case 49:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 50:
                    this.$ = [];
                    break;
                case 51:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 58:
                    this.$ = [];
                    break;
                case 59:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 64:
                    this.$ = [];
                    break;
                case 65:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 70:
                    this.$ = [];
                    break;
                case 71:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 78:
                    this.$ = [];
                    break;
                case 79:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 82:
                    this.$ = [];
                    break;
                case 83:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 86:
                    this.$ = [];
                    break;
                case 87:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 90:
                    this.$ = [];
                    break;
                case 91:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 94:
                    this.$ = [];
                    break;
                case 95:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 98:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 99:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 100:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 101:
                    $$[$0 - 1].push($$[$0]);
                    break;
            }
        },
        table: [
            {
                3: 1,
                4: 2,
                5: [
                    2,
                    46
                ],
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                1: [
                    3
                ]
            },
            {
                5: [
                    1,
                    4
                ]
            },
            {
                5: [
                    2,
                    2
                ],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [
                    1,
                    12
                ],
                15: [
                    1,
                    20
                ],
                16: 17,
                19: [
                    1,
                    23
                ],
                24: 15,
                27: 16,
                29: [
                    1,
                    21
                ],
                34: [
                    1,
                    22
                ],
                39: [
                    2,
                    2
                ],
                44: [
                    2,
                    2
                ],
                47: [
                    2,
                    2
                ],
                48: [
                    1,
                    13
                ],
                51: [
                    1,
                    14
                ],
                55: [
                    1,
                    18
                ],
                59: 19,
                60: [
                    1,
                    24
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                5: [
                    2,
                    47
                ],
                14: [
                    2,
                    47
                ],
                15: [
                    2,
                    47
                ],
                19: [
                    2,
                    47
                ],
                29: [
                    2,
                    47
                ],
                34: [
                    2,
                    47
                ],
                39: [
                    2,
                    47
                ],
                44: [
                    2,
                    47
                ],
                47: [
                    2,
                    47
                ],
                48: [
                    2,
                    47
                ],
                51: [
                    2,
                    47
                ],
                55: [
                    2,
                    47
                ],
                60: [
                    2,
                    47
                ]
            },
            {
                5: [
                    2,
                    3
                ],
                14: [
                    2,
                    3
                ],
                15: [
                    2,
                    3
                ],
                19: [
                    2,
                    3
                ],
                29: [
                    2,
                    3
                ],
                34: [
                    2,
                    3
                ],
                39: [
                    2,
                    3
                ],
                44: [
                    2,
                    3
                ],
                47: [
                    2,
                    3
                ],
                48: [
                    2,
                    3
                ],
                51: [
                    2,
                    3
                ],
                55: [
                    2,
                    3
                ],
                60: [
                    2,
                    3
                ]
            },
            {
                5: [
                    2,
                    4
                ],
                14: [
                    2,
                    4
                ],
                15: [
                    2,
                    4
                ],
                19: [
                    2,
                    4
                ],
                29: [
                    2,
                    4
                ],
                34: [
                    2,
                    4
                ],
                39: [
                    2,
                    4
                ],
                44: [
                    2,
                    4
                ],
                47: [
                    2,
                    4
                ],
                48: [
                    2,
                    4
                ],
                51: [
                    2,
                    4
                ],
                55: [
                    2,
                    4
                ],
                60: [
                    2,
                    4
                ]
            },
            {
                5: [
                    2,
                    5
                ],
                14: [
                    2,
                    5
                ],
                15: [
                    2,
                    5
                ],
                19: [
                    2,
                    5
                ],
                29: [
                    2,
                    5
                ],
                34: [
                    2,
                    5
                ],
                39: [
                    2,
                    5
                ],
                44: [
                    2,
                    5
                ],
                47: [
                    2,
                    5
                ],
                48: [
                    2,
                    5
                ],
                51: [
                    2,
                    5
                ],
                55: [
                    2,
                    5
                ],
                60: [
                    2,
                    5
                ]
            },
            {
                5: [
                    2,
                    6
                ],
                14: [
                    2,
                    6
                ],
                15: [
                    2,
                    6
                ],
                19: [
                    2,
                    6
                ],
                29: [
                    2,
                    6
                ],
                34: [
                    2,
                    6
                ],
                39: [
                    2,
                    6
                ],
                44: [
                    2,
                    6
                ],
                47: [
                    2,
                    6
                ],
                48: [
                    2,
                    6
                ],
                51: [
                    2,
                    6
                ],
                55: [
                    2,
                    6
                ],
                60: [
                    2,
                    6
                ]
            },
            {
                5: [
                    2,
                    7
                ],
                14: [
                    2,
                    7
                ],
                15: [
                    2,
                    7
                ],
                19: [
                    2,
                    7
                ],
                29: [
                    2,
                    7
                ],
                34: [
                    2,
                    7
                ],
                39: [
                    2,
                    7
                ],
                44: [
                    2,
                    7
                ],
                47: [
                    2,
                    7
                ],
                48: [
                    2,
                    7
                ],
                51: [
                    2,
                    7
                ],
                55: [
                    2,
                    7
                ],
                60: [
                    2,
                    7
                ]
            },
            {
                5: [
                    2,
                    8
                ],
                14: [
                    2,
                    8
                ],
                15: [
                    2,
                    8
                ],
                19: [
                    2,
                    8
                ],
                29: [
                    2,
                    8
                ],
                34: [
                    2,
                    8
                ],
                39: [
                    2,
                    8
                ],
                44: [
                    2,
                    8
                ],
                47: [
                    2,
                    8
                ],
                48: [
                    2,
                    8
                ],
                51: [
                    2,
                    8
                ],
                55: [
                    2,
                    8
                ],
                60: [
                    2,
                    8
                ]
            },
            {
                5: [
                    2,
                    9
                ],
                14: [
                    2,
                    9
                ],
                15: [
                    2,
                    9
                ],
                19: [
                    2,
                    9
                ],
                29: [
                    2,
                    9
                ],
                34: [
                    2,
                    9
                ],
                39: [
                    2,
                    9
                ],
                44: [
                    2,
                    9
                ],
                47: [
                    2,
                    9
                ],
                48: [
                    2,
                    9
                ],
                51: [
                    2,
                    9
                ],
                55: [
                    2,
                    9
                ],
                60: [
                    2,
                    9
                ]
            },
            {
                20: 25,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 36,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 37,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                4: 38,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                15: [
                    2,
                    48
                ],
                17: 39,
                18: [
                    2,
                    48
                ]
            },
            {
                20: 41,
                56: 40,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 44,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                5: [
                    2,
                    10
                ],
                14: [
                    2,
                    10
                ],
                15: [
                    2,
                    10
                ],
                18: [
                    2,
                    10
                ],
                19: [
                    2,
                    10
                ],
                29: [
                    2,
                    10
                ],
                34: [
                    2,
                    10
                ],
                39: [
                    2,
                    10
                ],
                44: [
                    2,
                    10
                ],
                47: [
                    2,
                    10
                ],
                48: [
                    2,
                    10
                ],
                51: [
                    2,
                    10
                ],
                55: [
                    2,
                    10
                ],
                60: [
                    2,
                    10
                ]
            },
            {
                20: 45,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 46,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 47,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 41,
                56: 48,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    2,
                    78
                ],
                49: 49,
                65: [
                    2,
                    78
                ],
                72: [
                    2,
                    78
                ],
                80: [
                    2,
                    78
                ],
                81: [
                    2,
                    78
                ],
                82: [
                    2,
                    78
                ],
                83: [
                    2,
                    78
                ],
                84: [
                    2,
                    78
                ],
                85: [
                    2,
                    78
                ]
            },
            {
                23: [
                    2,
                    33
                ],
                33: [
                    2,
                    33
                ],
                54: [
                    2,
                    33
                ],
                65: [
                    2,
                    33
                ],
                68: [
                    2,
                    33
                ],
                72: [
                    2,
                    33
                ],
                75: [
                    2,
                    33
                ],
                80: [
                    2,
                    33
                ],
                81: [
                    2,
                    33
                ],
                82: [
                    2,
                    33
                ],
                83: [
                    2,
                    33
                ],
                84: [
                    2,
                    33
                ],
                85: [
                    2,
                    33
                ]
            },
            {
                23: [
                    2,
                    34
                ],
                33: [
                    2,
                    34
                ],
                54: [
                    2,
                    34
                ],
                65: [
                    2,
                    34
                ],
                68: [
                    2,
                    34
                ],
                72: [
                    2,
                    34
                ],
                75: [
                    2,
                    34
                ],
                80: [
                    2,
                    34
                ],
                81: [
                    2,
                    34
                ],
                82: [
                    2,
                    34
                ],
                83: [
                    2,
                    34
                ],
                84: [
                    2,
                    34
                ],
                85: [
                    2,
                    34
                ]
            },
            {
                23: [
                    2,
                    35
                ],
                33: [
                    2,
                    35
                ],
                54: [
                    2,
                    35
                ],
                65: [
                    2,
                    35
                ],
                68: [
                    2,
                    35
                ],
                72: [
                    2,
                    35
                ],
                75: [
                    2,
                    35
                ],
                80: [
                    2,
                    35
                ],
                81: [
                    2,
                    35
                ],
                82: [
                    2,
                    35
                ],
                83: [
                    2,
                    35
                ],
                84: [
                    2,
                    35
                ],
                85: [
                    2,
                    35
                ]
            },
            {
                23: [
                    2,
                    36
                ],
                33: [
                    2,
                    36
                ],
                54: [
                    2,
                    36
                ],
                65: [
                    2,
                    36
                ],
                68: [
                    2,
                    36
                ],
                72: [
                    2,
                    36
                ],
                75: [
                    2,
                    36
                ],
                80: [
                    2,
                    36
                ],
                81: [
                    2,
                    36
                ],
                82: [
                    2,
                    36
                ],
                83: [
                    2,
                    36
                ],
                84: [
                    2,
                    36
                ],
                85: [
                    2,
                    36
                ]
            },
            {
                23: [
                    2,
                    37
                ],
                33: [
                    2,
                    37
                ],
                54: [
                    2,
                    37
                ],
                65: [
                    2,
                    37
                ],
                68: [
                    2,
                    37
                ],
                72: [
                    2,
                    37
                ],
                75: [
                    2,
                    37
                ],
                80: [
                    2,
                    37
                ],
                81: [
                    2,
                    37
                ],
                82: [
                    2,
                    37
                ],
                83: [
                    2,
                    37
                ],
                84: [
                    2,
                    37
                ],
                85: [
                    2,
                    37
                ]
            },
            {
                23: [
                    2,
                    38
                ],
                33: [
                    2,
                    38
                ],
                54: [
                    2,
                    38
                ],
                65: [
                    2,
                    38
                ],
                68: [
                    2,
                    38
                ],
                72: [
                    2,
                    38
                ],
                75: [
                    2,
                    38
                ],
                80: [
                    2,
                    38
                ],
                81: [
                    2,
                    38
                ],
                82: [
                    2,
                    38
                ],
                83: [
                    2,
                    38
                ],
                84: [
                    2,
                    38
                ],
                85: [
                    2,
                    38
                ]
            },
            {
                23: [
                    2,
                    39
                ],
                33: [
                    2,
                    39
                ],
                54: [
                    2,
                    39
                ],
                65: [
                    2,
                    39
                ],
                68: [
                    2,
                    39
                ],
                72: [
                    2,
                    39
                ],
                75: [
                    2,
                    39
                ],
                80: [
                    2,
                    39
                ],
                81: [
                    2,
                    39
                ],
                82: [
                    2,
                    39
                ],
                83: [
                    2,
                    39
                ],
                84: [
                    2,
                    39
                ],
                85: [
                    2,
                    39
                ]
            },
            {
                23: [
                    2,
                    43
                ],
                33: [
                    2,
                    43
                ],
                54: [
                    2,
                    43
                ],
                65: [
                    2,
                    43
                ],
                68: [
                    2,
                    43
                ],
                72: [
                    2,
                    43
                ],
                75: [
                    2,
                    43
                ],
                80: [
                    2,
                    43
                ],
                81: [
                    2,
                    43
                ],
                82: [
                    2,
                    43
                ],
                83: [
                    2,
                    43
                ],
                84: [
                    2,
                    43
                ],
                85: [
                    2,
                    43
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                72: [
                    1,
                    35
                ],
                86: 51
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                52: 52,
                54: [
                    2,
                    82
                ],
                65: [
                    2,
                    82
                ],
                72: [
                    2,
                    82
                ],
                80: [
                    2,
                    82
                ],
                81: [
                    2,
                    82
                ],
                82: [
                    2,
                    82
                ],
                83: [
                    2,
                    82
                ],
                84: [
                    2,
                    82
                ],
                85: [
                    2,
                    82
                ]
            },
            {
                25: 53,
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 54,
                47: [
                    2,
                    54
                ]
            },
            {
                28: 59,
                43: 60,
                44: [
                    1,
                    58
                ],
                47: [
                    2,
                    56
                ]
            },
            {
                13: 62,
                15: [
                    1,
                    20
                ],
                18: [
                    1,
                    61
                ]
            },
            {
                33: [
                    2,
                    86
                ],
                57: 63,
                65: [
                    2,
                    86
                ],
                72: [
                    2,
                    86
                ],
                80: [
                    2,
                    86
                ],
                81: [
                    2,
                    86
                ],
                82: [
                    2,
                    86
                ],
                83: [
                    2,
                    86
                ],
                84: [
                    2,
                    86
                ],
                85: [
                    2,
                    86
                ]
            },
            {
                33: [
                    2,
                    40
                ],
                65: [
                    2,
                    40
                ],
                72: [
                    2,
                    40
                ],
                80: [
                    2,
                    40
                ],
                81: [
                    2,
                    40
                ],
                82: [
                    2,
                    40
                ],
                83: [
                    2,
                    40
                ],
                84: [
                    2,
                    40
                ],
                85: [
                    2,
                    40
                ]
            },
            {
                33: [
                    2,
                    41
                ],
                65: [
                    2,
                    41
                ],
                72: [
                    2,
                    41
                ],
                80: [
                    2,
                    41
                ],
                81: [
                    2,
                    41
                ],
                82: [
                    2,
                    41
                ],
                83: [
                    2,
                    41
                ],
                84: [
                    2,
                    41
                ],
                85: [
                    2,
                    41
                ]
            },
            {
                20: 64,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 65,
                47: [
                    1,
                    66
                ]
            },
            {
                30: 67,
                33: [
                    2,
                    58
                ],
                65: [
                    2,
                    58
                ],
                72: [
                    2,
                    58
                ],
                75: [
                    2,
                    58
                ],
                80: [
                    2,
                    58
                ],
                81: [
                    2,
                    58
                ],
                82: [
                    2,
                    58
                ],
                83: [
                    2,
                    58
                ],
                84: [
                    2,
                    58
                ],
                85: [
                    2,
                    58
                ]
            },
            {
                33: [
                    2,
                    64
                ],
                35: 68,
                65: [
                    2,
                    64
                ],
                72: [
                    2,
                    64
                ],
                75: [
                    2,
                    64
                ],
                80: [
                    2,
                    64
                ],
                81: [
                    2,
                    64
                ],
                82: [
                    2,
                    64
                ],
                83: [
                    2,
                    64
                ],
                84: [
                    2,
                    64
                ],
                85: [
                    2,
                    64
                ]
            },
            {
                21: 69,
                23: [
                    2,
                    50
                ],
                65: [
                    2,
                    50
                ],
                72: [
                    2,
                    50
                ],
                80: [
                    2,
                    50
                ],
                81: [
                    2,
                    50
                ],
                82: [
                    2,
                    50
                ],
                83: [
                    2,
                    50
                ],
                84: [
                    2,
                    50
                ],
                85: [
                    2,
                    50
                ]
            },
            {
                33: [
                    2,
                    90
                ],
                61: 70,
                65: [
                    2,
                    90
                ],
                72: [
                    2,
                    90
                ],
                80: [
                    2,
                    90
                ],
                81: [
                    2,
                    90
                ],
                82: [
                    2,
                    90
                ],
                83: [
                    2,
                    90
                ],
                84: [
                    2,
                    90
                ],
                85: [
                    2,
                    90
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    80
                ],
                50: 71,
                63: 72,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 73,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                72: [
                    1,
                    79
                ]
            },
            {
                23: [
                    2,
                    42
                ],
                33: [
                    2,
                    42
                ],
                54: [
                    2,
                    42
                ],
                65: [
                    2,
                    42
                ],
                68: [
                    2,
                    42
                ],
                72: [
                    2,
                    42
                ],
                75: [
                    2,
                    42
                ],
                80: [
                    2,
                    42
                ],
                81: [
                    2,
                    42
                ],
                82: [
                    2,
                    42
                ],
                83: [
                    2,
                    42
                ],
                84: [
                    2,
                    42
                ],
                85: [
                    2,
                    42
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                20: 74,
                53: 80,
                54: [
                    2,
                    84
                ],
                63: 81,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 82,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 83,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    55
                ]
            },
            {
                4: 84,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                47: [
                    2,
                    20
                ]
            },
            {
                20: 85,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 86,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                26: 87,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    57
                ]
            },
            {
                5: [
                    2,
                    11
                ],
                14: [
                    2,
                    11
                ],
                15: [
                    2,
                    11
                ],
                19: [
                    2,
                    11
                ],
                29: [
                    2,
                    11
                ],
                34: [
                    2,
                    11
                ],
                39: [
                    2,
                    11
                ],
                44: [
                    2,
                    11
                ],
                47: [
                    2,
                    11
                ],
                48: [
                    2,
                    11
                ],
                51: [
                    2,
                    11
                ],
                55: [
                    2,
                    11
                ],
                60: [
                    2,
                    11
                ]
            },
            {
                15: [
                    2,
                    49
                ],
                18: [
                    2,
                    49
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    88
                ],
                58: 88,
                63: 89,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 90,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                65: [
                    2,
                    94
                ],
                66: 91,
                68: [
                    2,
                    94
                ],
                72: [
                    2,
                    94
                ],
                80: [
                    2,
                    94
                ],
                81: [
                    2,
                    94
                ],
                82: [
                    2,
                    94
                ],
                83: [
                    2,
                    94
                ],
                84: [
                    2,
                    94
                ],
                85: [
                    2,
                    94
                ]
            },
            {
                5: [
                    2,
                    25
                ],
                14: [
                    2,
                    25
                ],
                15: [
                    2,
                    25
                ],
                19: [
                    2,
                    25
                ],
                29: [
                    2,
                    25
                ],
                34: [
                    2,
                    25
                ],
                39: [
                    2,
                    25
                ],
                44: [
                    2,
                    25
                ],
                47: [
                    2,
                    25
                ],
                48: [
                    2,
                    25
                ],
                51: [
                    2,
                    25
                ],
                55: [
                    2,
                    25
                ],
                60: [
                    2,
                    25
                ]
            },
            {
                20: 92,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                31: 93,
                33: [
                    2,
                    60
                ],
                63: 94,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 95,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    60
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    66
                ],
                36: 96,
                63: 97,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 98,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    66
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                22: 99,
                23: [
                    2,
                    52
                ],
                63: 100,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 101,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    92
                ],
                62: 102,
                63: 103,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 104,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    105
                ]
            },
            {
                33: [
                    2,
                    79
                ],
                65: [
                    2,
                    79
                ],
                72: [
                    2,
                    79
                ],
                80: [
                    2,
                    79
                ],
                81: [
                    2,
                    79
                ],
                82: [
                    2,
                    79
                ],
                83: [
                    2,
                    79
                ],
                84: [
                    2,
                    79
                ],
                85: [
                    2,
                    79
                ]
            },
            {
                33: [
                    2,
                    81
                ]
            },
            {
                23: [
                    2,
                    27
                ],
                33: [
                    2,
                    27
                ],
                54: [
                    2,
                    27
                ],
                65: [
                    2,
                    27
                ],
                68: [
                    2,
                    27
                ],
                72: [
                    2,
                    27
                ],
                75: [
                    2,
                    27
                ],
                80: [
                    2,
                    27
                ],
                81: [
                    2,
                    27
                ],
                82: [
                    2,
                    27
                ],
                83: [
                    2,
                    27
                ],
                84: [
                    2,
                    27
                ],
                85: [
                    2,
                    27
                ]
            },
            {
                23: [
                    2,
                    28
                ],
                33: [
                    2,
                    28
                ],
                54: [
                    2,
                    28
                ],
                65: [
                    2,
                    28
                ],
                68: [
                    2,
                    28
                ],
                72: [
                    2,
                    28
                ],
                75: [
                    2,
                    28
                ],
                80: [
                    2,
                    28
                ],
                81: [
                    2,
                    28
                ],
                82: [
                    2,
                    28
                ],
                83: [
                    2,
                    28
                ],
                84: [
                    2,
                    28
                ],
                85: [
                    2,
                    28
                ]
            },
            {
                23: [
                    2,
                    30
                ],
                33: [
                    2,
                    30
                ],
                54: [
                    2,
                    30
                ],
                68: [
                    2,
                    30
                ],
                71: 106,
                72: [
                    1,
                    107
                ],
                75: [
                    2,
                    30
                ]
            },
            {
                23: [
                    2,
                    98
                ],
                33: [
                    2,
                    98
                ],
                54: [
                    2,
                    98
                ],
                68: [
                    2,
                    98
                ],
                72: [
                    2,
                    98
                ],
                75: [
                    2,
                    98
                ]
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                73: [
                    1,
                    108
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                23: [
                    2,
                    44
                ],
                33: [
                    2,
                    44
                ],
                54: [
                    2,
                    44
                ],
                65: [
                    2,
                    44
                ],
                68: [
                    2,
                    44
                ],
                72: [
                    2,
                    44
                ],
                75: [
                    2,
                    44
                ],
                80: [
                    2,
                    44
                ],
                81: [
                    2,
                    44
                ],
                82: [
                    2,
                    44
                ],
                83: [
                    2,
                    44
                ],
                84: [
                    2,
                    44
                ],
                85: [
                    2,
                    44
                ],
                87: [
                    2,
                    44
                ]
            },
            {
                54: [
                    1,
                    109
                ]
            },
            {
                54: [
                    2,
                    83
                ],
                65: [
                    2,
                    83
                ],
                72: [
                    2,
                    83
                ],
                80: [
                    2,
                    83
                ],
                81: [
                    2,
                    83
                ],
                82: [
                    2,
                    83
                ],
                83: [
                    2,
                    83
                ],
                84: [
                    2,
                    83
                ],
                85: [
                    2,
                    83
                ]
            },
            {
                54: [
                    2,
                    85
                ]
            },
            {
                5: [
                    2,
                    13
                ],
                14: [
                    2,
                    13
                ],
                15: [
                    2,
                    13
                ],
                19: [
                    2,
                    13
                ],
                29: [
                    2,
                    13
                ],
                34: [
                    2,
                    13
                ],
                39: [
                    2,
                    13
                ],
                44: [
                    2,
                    13
                ],
                47: [
                    2,
                    13
                ],
                48: [
                    2,
                    13
                ],
                51: [
                    2,
                    13
                ],
                55: [
                    2,
                    13
                ],
                60: [
                    2,
                    13
                ]
            },
            {
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 111,
                46: 110,
                47: [
                    2,
                    76
                ]
            },
            {
                33: [
                    2,
                    70
                ],
                40: 112,
                65: [
                    2,
                    70
                ],
                72: [
                    2,
                    70
                ],
                75: [
                    2,
                    70
                ],
                80: [
                    2,
                    70
                ],
                81: [
                    2,
                    70
                ],
                82: [
                    2,
                    70
                ],
                83: [
                    2,
                    70
                ],
                84: [
                    2,
                    70
                ],
                85: [
                    2,
                    70
                ]
            },
            {
                47: [
                    2,
                    18
                ]
            },
            {
                5: [
                    2,
                    14
                ],
                14: [
                    2,
                    14
                ],
                15: [
                    2,
                    14
                ],
                19: [
                    2,
                    14
                ],
                29: [
                    2,
                    14
                ],
                34: [
                    2,
                    14
                ],
                39: [
                    2,
                    14
                ],
                44: [
                    2,
                    14
                ],
                47: [
                    2,
                    14
                ],
                48: [
                    2,
                    14
                ],
                51: [
                    2,
                    14
                ],
                55: [
                    2,
                    14
                ],
                60: [
                    2,
                    14
                ]
            },
            {
                33: [
                    1,
                    113
                ]
            },
            {
                33: [
                    2,
                    87
                ],
                65: [
                    2,
                    87
                ],
                72: [
                    2,
                    87
                ],
                80: [
                    2,
                    87
                ],
                81: [
                    2,
                    87
                ],
                82: [
                    2,
                    87
                ],
                83: [
                    2,
                    87
                ],
                84: [
                    2,
                    87
                ],
                85: [
                    2,
                    87
                ]
            },
            {
                33: [
                    2,
                    89
                ]
            },
            {
                20: 74,
                63: 115,
                64: 75,
                65: [
                    1,
                    43
                ],
                67: 114,
                68: [
                    2,
                    96
                ],
                69: 116,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    117
                ]
            },
            {
                32: 118,
                33: [
                    2,
                    62
                ],
                74: 119,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    59
                ],
                65: [
                    2,
                    59
                ],
                72: [
                    2,
                    59
                ],
                75: [
                    2,
                    59
                ],
                80: [
                    2,
                    59
                ],
                81: [
                    2,
                    59
                ],
                82: [
                    2,
                    59
                ],
                83: [
                    2,
                    59
                ],
                84: [
                    2,
                    59
                ],
                85: [
                    2,
                    59
                ]
            },
            {
                33: [
                    2,
                    61
                ],
                75: [
                    2,
                    61
                ]
            },
            {
                33: [
                    2,
                    68
                ],
                37: 121,
                74: 122,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    65
                ],
                65: [
                    2,
                    65
                ],
                72: [
                    2,
                    65
                ],
                75: [
                    2,
                    65
                ],
                80: [
                    2,
                    65
                ],
                81: [
                    2,
                    65
                ],
                82: [
                    2,
                    65
                ],
                83: [
                    2,
                    65
                ],
                84: [
                    2,
                    65
                ],
                85: [
                    2,
                    65
                ]
            },
            {
                33: [
                    2,
                    67
                ],
                75: [
                    2,
                    67
                ]
            },
            {
                23: [
                    1,
                    123
                ]
            },
            {
                23: [
                    2,
                    51
                ],
                65: [
                    2,
                    51
                ],
                72: [
                    2,
                    51
                ],
                80: [
                    2,
                    51
                ],
                81: [
                    2,
                    51
                ],
                82: [
                    2,
                    51
                ],
                83: [
                    2,
                    51
                ],
                84: [
                    2,
                    51
                ],
                85: [
                    2,
                    51
                ]
            },
            {
                23: [
                    2,
                    53
                ]
            },
            {
                33: [
                    1,
                    124
                ]
            },
            {
                33: [
                    2,
                    91
                ],
                65: [
                    2,
                    91
                ],
                72: [
                    2,
                    91
                ],
                80: [
                    2,
                    91
                ],
                81: [
                    2,
                    91
                ],
                82: [
                    2,
                    91
                ],
                83: [
                    2,
                    91
                ],
                84: [
                    2,
                    91
                ],
                85: [
                    2,
                    91
                ]
            },
            {
                33: [
                    2,
                    93
                ]
            },
            {
                5: [
                    2,
                    22
                ],
                14: [
                    2,
                    22
                ],
                15: [
                    2,
                    22
                ],
                19: [
                    2,
                    22
                ],
                29: [
                    2,
                    22
                ],
                34: [
                    2,
                    22
                ],
                39: [
                    2,
                    22
                ],
                44: [
                    2,
                    22
                ],
                47: [
                    2,
                    22
                ],
                48: [
                    2,
                    22
                ],
                51: [
                    2,
                    22
                ],
                55: [
                    2,
                    22
                ],
                60: [
                    2,
                    22
                ]
            },
            {
                23: [
                    2,
                    99
                ],
                33: [
                    2,
                    99
                ],
                54: [
                    2,
                    99
                ],
                68: [
                    2,
                    99
                ],
                72: [
                    2,
                    99
                ],
                75: [
                    2,
                    99
                ]
            },
            {
                73: [
                    1,
                    108
                ]
            },
            {
                20: 74,
                63: 125,
                64: 75,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    23
                ],
                14: [
                    2,
                    23
                ],
                15: [
                    2,
                    23
                ],
                19: [
                    2,
                    23
                ],
                29: [
                    2,
                    23
                ],
                34: [
                    2,
                    23
                ],
                39: [
                    2,
                    23
                ],
                44: [
                    2,
                    23
                ],
                47: [
                    2,
                    23
                ],
                48: [
                    2,
                    23
                ],
                51: [
                    2,
                    23
                ],
                55: [
                    2,
                    23
                ],
                60: [
                    2,
                    23
                ]
            },
            {
                47: [
                    2,
                    19
                ]
            },
            {
                47: [
                    2,
                    77
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    72
                ],
                41: 126,
                63: 127,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 128,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    72
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    24
                ],
                14: [
                    2,
                    24
                ],
                15: [
                    2,
                    24
                ],
                19: [
                    2,
                    24
                ],
                29: [
                    2,
                    24
                ],
                34: [
                    2,
                    24
                ],
                39: [
                    2,
                    24
                ],
                44: [
                    2,
                    24
                ],
                47: [
                    2,
                    24
                ],
                48: [
                    2,
                    24
                ],
                51: [
                    2,
                    24
                ],
                55: [
                    2,
                    24
                ],
                60: [
                    2,
                    24
                ]
            },
            {
                68: [
                    1,
                    129
                ]
            },
            {
                65: [
                    2,
                    95
                ],
                68: [
                    2,
                    95
                ],
                72: [
                    2,
                    95
                ],
                80: [
                    2,
                    95
                ],
                81: [
                    2,
                    95
                ],
                82: [
                    2,
                    95
                ],
                83: [
                    2,
                    95
                ],
                84: [
                    2,
                    95
                ],
                85: [
                    2,
                    95
                ]
            },
            {
                68: [
                    2,
                    97
                ]
            },
            {
                5: [
                    2,
                    21
                ],
                14: [
                    2,
                    21
                ],
                15: [
                    2,
                    21
                ],
                19: [
                    2,
                    21
                ],
                29: [
                    2,
                    21
                ],
                34: [
                    2,
                    21
                ],
                39: [
                    2,
                    21
                ],
                44: [
                    2,
                    21
                ],
                47: [
                    2,
                    21
                ],
                48: [
                    2,
                    21
                ],
                51: [
                    2,
                    21
                ],
                55: [
                    2,
                    21
                ],
                60: [
                    2,
                    21
                ]
            },
            {
                33: [
                    1,
                    130
                ]
            },
            {
                33: [
                    2,
                    63
                ]
            },
            {
                72: [
                    1,
                    132
                ],
                76: 131
            },
            {
                33: [
                    1,
                    133
                ]
            },
            {
                33: [
                    2,
                    69
                ]
            },
            {
                15: [
                    2,
                    12
                ],
                18: [
                    2,
                    12
                ]
            },
            {
                14: [
                    2,
                    26
                ],
                15: [
                    2,
                    26
                ],
                19: [
                    2,
                    26
                ],
                29: [
                    2,
                    26
                ],
                34: [
                    2,
                    26
                ],
                47: [
                    2,
                    26
                ],
                48: [
                    2,
                    26
                ],
                51: [
                    2,
                    26
                ],
                55: [
                    2,
                    26
                ],
                60: [
                    2,
                    26
                ]
            },
            {
                23: [
                    2,
                    31
                ],
                33: [
                    2,
                    31
                ],
                54: [
                    2,
                    31
                ],
                68: [
                    2,
                    31
                ],
                72: [
                    2,
                    31
                ],
                75: [
                    2,
                    31
                ]
            },
            {
                33: [
                    2,
                    74
                ],
                42: 134,
                74: 135,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    71
                ],
                65: [
                    2,
                    71
                ],
                72: [
                    2,
                    71
                ],
                75: [
                    2,
                    71
                ],
                80: [
                    2,
                    71
                ],
                81: [
                    2,
                    71
                ],
                82: [
                    2,
                    71
                ],
                83: [
                    2,
                    71
                ],
                84: [
                    2,
                    71
                ],
                85: [
                    2,
                    71
                ]
            },
            {
                33: [
                    2,
                    73
                ],
                75: [
                    2,
                    73
                ]
            },
            {
                23: [
                    2,
                    29
                ],
                33: [
                    2,
                    29
                ],
                54: [
                    2,
                    29
                ],
                65: [
                    2,
                    29
                ],
                68: [
                    2,
                    29
                ],
                72: [
                    2,
                    29
                ],
                75: [
                    2,
                    29
                ],
                80: [
                    2,
                    29
                ],
                81: [
                    2,
                    29
                ],
                82: [
                    2,
                    29
                ],
                83: [
                    2,
                    29
                ],
                84: [
                    2,
                    29
                ],
                85: [
                    2,
                    29
                ]
            },
            {
                14: [
                    2,
                    15
                ],
                15: [
                    2,
                    15
                ],
                19: [
                    2,
                    15
                ],
                29: [
                    2,
                    15
                ],
                34: [
                    2,
                    15
                ],
                39: [
                    2,
                    15
                ],
                44: [
                    2,
                    15
                ],
                47: [
                    2,
                    15
                ],
                48: [
                    2,
                    15
                ],
                51: [
                    2,
                    15
                ],
                55: [
                    2,
                    15
                ],
                60: [
                    2,
                    15
                ]
            },
            {
                72: [
                    1,
                    137
                ],
                77: [
                    1,
                    136
                ]
            },
            {
                72: [
                    2,
                    100
                ],
                77: [
                    2,
                    100
                ]
            },
            {
                14: [
                    2,
                    16
                ],
                15: [
                    2,
                    16
                ],
                19: [
                    2,
                    16
                ],
                29: [
                    2,
                    16
                ],
                34: [
                    2,
                    16
                ],
                44: [
                    2,
                    16
                ],
                47: [
                    2,
                    16
                ],
                48: [
                    2,
                    16
                ],
                51: [
                    2,
                    16
                ],
                55: [
                    2,
                    16
                ],
                60: [
                    2,
                    16
                ]
            },
            {
                33: [
                    1,
                    138
                ]
            },
            {
                33: [
                    2,
                    75
                ]
            },
            {
                33: [
                    2,
                    32
                ]
            },
            {
                72: [
                    2,
                    101
                ],
                77: [
                    2,
                    101
                ]
            },
            {
                14: [
                    2,
                    17
                ],
                15: [
                    2,
                    17
                ],
                19: [
                    2,
                    17
                ],
                29: [
                    2,
                    17
                ],
                34: [
                    2,
                    17
                ],
                39: [
                    2,
                    17
                ],
                44: [
                    2,
                    17
                ],
                47: [
                    2,
                    17
                ],
                48: [
                    2,
                    17
                ],
                51: [
                    2,
                    17
                ],
                55: [
                    2,
                    17
                ],
                60: [
                    2,
                    17
                ]
            }
        ],
        defaultActions: {
            4: [
                2,
                1
            ],
            54: [
                2,
                55
            ],
            56: [
                2,
                20
            ],
            60: [
                2,
                57
            ],
            73: [
                2,
                81
            ],
            82: [
                2,
                85
            ],
            86: [
                2,
                18
            ],
            90: [
                2,
                89
            ],
            101: [
                2,
                53
            ],
            104: [
                2,
                93
            ],
            110: [
                2,
                19
            ],
            111: [
                2,
                77
            ],
            116: [
                2,
                97
            ],
            119: [
                2,
                63
            ],
            122: [
                2,
                69
            ],
            135: [
                2,
                75
            ],
            136: [
                2,
                32
            ]
        },
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], vstack = [
                null
            ], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            function lex() {
                var token;
                token = self.lexer.lex() || 1;
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token;
            }
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == "undefined") symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    if (!recovering) {
                        expected = [];
                        for(p in table[state])if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
                        if (this.lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                        this.parseError(errStr, {
                            text: this.lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: this.lexer.yylineno,
                            loc: yyloc,
                            expected: expected
                        });
                    }
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                        if (typeof r !== "undefined") return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* Jison generated lexer */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            setInput: function setInput(input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                return this;
            },
            more: function more() {
                this._more = true;
                return this;
            },
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index, col, lines;
                if (!this._more) {
                    this.yytext = "";
                    this.match = "";
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/(?:\r\n?|\n).*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                    };
                    this.yytext += match[0];
                    this.match += match[0];
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    if (this.options.ranges) this.yylloc.range = [
                        this.offset,
                        this.offset += this.yyleng
                    ];
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;
                    else return;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            lex: function lex() {
                var r = this.next();
                if (typeof r !== "undefined") return r;
                else return this.lex();
            },
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState: function popState() {
                return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
                return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
                this.begin(condition);
            }
        };
        lexer.options = {};
        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
            function strip(start, end) {
                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
            }
            var YYSTATE = YY_START;
            switch($avoiding_name_collisions){
                case 0:
                    if (yy_.yytext.slice(-2) === "\\\\") {
                        strip(0, 1);
                        this.begin("mu");
                    } else if (yy_.yytext.slice(-1) === "\\") {
                        strip(0, 1);
                        this.begin("emu");
                    } else this.begin("mu");
                    if (yy_.yytext) return 15;
                    break;
                case 1:
                    return 15;
                case 2:
                    this.popState();
                    return 15;
                case 3:
                    this.begin("raw");
                    return 15;
                case 4:
                    this.popState();
                    // Should be using `this.topState()` below, but it currently
                    // returns the second top instead of the first top. Opened an
                    // issue about it at https://github.com/zaach/jison/issues/291
                    if (this.conditionStack[this.conditionStack.length - 1] === "raw") return 15;
                    else {
                        strip(5, 9);
                        return "END_RAW_BLOCK";
                    }
                    break;
                case 5:
                    return 15;
                case 6:
                    this.popState();
                    return 14;
                case 7:
                    return 65;
                case 8:
                    return 68;
                case 9:
                    return 19;
                case 10:
                    this.popState();
                    this.begin("raw");
                    return 23;
                case 11:
                    return 55;
                case 12:
                    return 60;
                case 13:
                    return 29;
                case 14:
                    return 47;
                case 15:
                    this.popState();
                    return 44;
                case 16:
                    this.popState();
                    return 44;
                case 17:
                    return 34;
                case 18:
                    return 39;
                case 19:
                    return 51;
                case 20:
                    return 48;
                case 21:
                    this.unput(yy_.yytext);
                    this.popState();
                    this.begin("com");
                    break;
                case 22:
                    this.popState();
                    return 14;
                case 23:
                    return 48;
                case 24:
                    return 73;
                case 25:
                    return 72;
                case 26:
                    return 72;
                case 27:
                    return 87;
                case 28:
                    break;
                case 29:
                    this.popState();
                    return 54;
                case 30:
                    this.popState();
                    return 33;
                case 31:
                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');
                    return 80;
                case 32:
                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");
                    return 80;
                case 33:
                    return 85;
                case 34:
                    return 82;
                case 35:
                    return 82;
                case 36:
                    return 83;
                case 37:
                    return 84;
                case 38:
                    return 81;
                case 39:
                    return 75;
                case 40:
                    return 77;
                case 41:
                    return 72;
                case 42:
                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, "$1");
                    return 72;
                case 43:
                    return "INVALID";
                case 44:
                    return 5;
            }
        };
        lexer.rules = [
            /^(?:[^\x00]*?(?=(\{\{)))/,
            /^(?:[^\x00]+)/,
            /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
            /^(?:\{\{\{\{(?=[^/]))/,
            /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
            /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
            /^(?:[\s\S]*?--(~)?\}\})/,
            /^(?:\()/,
            /^(?:\))/,
            /^(?:\{\{\{\{)/,
            /^(?:\}\}\}\})/,
            /^(?:\{\{(~)?>)/,
            /^(?:\{\{(~)?#>)/,
            /^(?:\{\{(~)?#\*?)/,
            /^(?:\{\{(~)?\/)/,
            /^(?:\{\{(~)?\^\s*(~)?\}\})/,
            /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
            /^(?:\{\{(~)?\^)/,
            /^(?:\{\{(~)?\s*else\b)/,
            /^(?:\{\{(~)?\{)/,
            /^(?:\{\{(~)?&)/,
            /^(?:\{\{(~)?!--)/,
            /^(?:\{\{(~)?![\s\S]*?\}\})/,
            /^(?:\{\{(~)?\*?)/,
            /^(?:=)/,
            /^(?:\.\.)/,
            /^(?:\.(?=([=~}\s\/.)|])))/,
            /^(?:[\/.])/,
            /^(?:\s+)/,
            /^(?:\}(~)?\}\})/,
            /^(?:(~)?\}\})/,
            /^(?:"(\\["]|[^"])*")/,
            /^(?:'(\\[']|[^'])*')/,
            /^(?:@)/,
            /^(?:true(?=([~}\s)])))/,
            /^(?:false(?=([~}\s)])))/,
            /^(?:undefined(?=([~}\s)])))/,
            /^(?:null(?=([~}\s)])))/,
            /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
            /^(?:as\s+\|)/,
            /^(?:\|)/,
            /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
            /^(?:\[(\\\]|[^\]])*\])/,
            /^(?:.)/,
            /^(?:$)/
        ];
        lexer.conditions = {
            "mu": {
                "rules": [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44
                ],
                "inclusive": false
            },
            "emu": {
                "rules": [
                    2
                ],
                "inclusive": false
            },
            "com": {
                "rules": [
                    6
                ],
                "inclusive": false
            },
            "raw": {
                "rules": [
                    3,
                    4,
                    5
                ],
                "inclusive": false
            },
            "INITIAL": {
                "rules": [
                    0,
                    1,
                    44
                ],
                "inclusive": true
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
module.exports["default"] = $b5aec96ab869c754$var$handlebars;
module.exports = module.exports["default"];

});

parcelRegister("cjOZa", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $8f7ecf0fbfc05efe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $e34mu = parcelRequire("e34mu");
var $8f7ecf0fbfc05efe$var$_visitor2 = $8f7ecf0fbfc05efe$var$_interopRequireDefault($e34mu);
function $8f7ecf0fbfc05efe$var$WhitespaceControl() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    this.options = options;
}
$8f7ecf0fbfc05efe$var$WhitespaceControl.prototype = new $8f7ecf0fbfc05efe$var$_visitor2["default"]();
$8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.Program = function(program) {
    var doStandalone = !this.options.ignoreStandalone;
    var isRoot = !this.isRootSeen;
    this.isRootSeen = true;
    var body = program.body;
    for(var i = 0, l = body.length; i < l; i++){
        var current = body[i], strip = this.accept(current);
        if (!strip) continue;
        var _isPrevWhitespace = $8f7ecf0fbfc05efe$var$isPrevWhitespace(body, i, isRoot), _isNextWhitespace = $8f7ecf0fbfc05efe$var$isNextWhitespace(body, i, isRoot), openStandalone = strip.openStandalone && _isPrevWhitespace, closeStandalone = strip.closeStandalone && _isNextWhitespace, inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;
        if (strip.close) $8f7ecf0fbfc05efe$var$omitRight(body, i, true);
        if (strip.open) $8f7ecf0fbfc05efe$var$omitLeft(body, i, true);
        if (doStandalone && inlineStandalone) {
            $8f7ecf0fbfc05efe$var$omitRight(body, i);
            if ($8f7ecf0fbfc05efe$var$omitLeft(body, i)) // If we are on a standalone node, save the indent info for partials
            {
                if (current.type === "PartialStatement") // Pull out the whitespace from the final line
                current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
            }
        }
        if (doStandalone && openStandalone) {
            $8f7ecf0fbfc05efe$var$omitRight((current.program || current.inverse).body);
            // Strip out the previous content node if it's whitespace only
            $8f7ecf0fbfc05efe$var$omitLeft(body, i);
        }
        if (doStandalone && closeStandalone) {
            // Always strip the next node
            $8f7ecf0fbfc05efe$var$omitRight(body, i);
            $8f7ecf0fbfc05efe$var$omitLeft((current.inverse || current.program).body);
        }
    }
    return program;
};
$8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.BlockStatement = $8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.DecoratorBlock = $8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.PartialBlockStatement = function(block) {
    this.accept(block.program);
    this.accept(block.inverse);
    // Find the inverse program that is involed with whitespace stripping.
    var program = block.program || block.inverse, inverse = block.program && block.inverse, firstInverse = inverse, lastInverse = inverse;
    if (inverse && inverse.chained) {
        firstInverse = inverse.body[0].program;
        // Walk the inverse chain to find the last inverse that is actually in the chain.
        while(lastInverse.chained)lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
    }
    var strip = {
        open: block.openStrip.open,
        close: block.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: $8f7ecf0fbfc05efe$var$isNextWhitespace(program.body),
        closeStandalone: $8f7ecf0fbfc05efe$var$isPrevWhitespace((firstInverse || program).body)
    };
    if (block.openStrip.close) $8f7ecf0fbfc05efe$var$omitRight(program.body, null, true);
    if (inverse) {
        var inverseStrip = block.inverseStrip;
        if (inverseStrip.open) $8f7ecf0fbfc05efe$var$omitLeft(program.body, null, true);
        if (inverseStrip.close) $8f7ecf0fbfc05efe$var$omitRight(firstInverse.body, null, true);
        if (block.closeStrip.open) $8f7ecf0fbfc05efe$var$omitLeft(lastInverse.body, null, true);
        // Find standalone else statments
        if (!this.options.ignoreStandalone && $8f7ecf0fbfc05efe$var$isPrevWhitespace(program.body) && $8f7ecf0fbfc05efe$var$isNextWhitespace(firstInverse.body)) {
            $8f7ecf0fbfc05efe$var$omitLeft(program.body);
            $8f7ecf0fbfc05efe$var$omitRight(firstInverse.body);
        }
    } else if (block.closeStrip.open) $8f7ecf0fbfc05efe$var$omitLeft(program.body, null, true);
    return strip;
};
$8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.Decorator = $8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.MustacheStatement = function(mustache) {
    return mustache.strip;
};
$8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.PartialStatement = $8f7ecf0fbfc05efe$var$WhitespaceControl.prototype.CommentStatement = function(node) {
    /* istanbul ignore next */ var strip = node.strip || {};
    return {
        inlineStandalone: true,
        open: strip.open,
        close: strip.close
    };
};
function $8f7ecf0fbfc05efe$var$isPrevWhitespace(body, i, isRoot) {
    if (i === undefined) i = body.length;
    // Nodes that end with newlines are considered whitespace (but are special
    // cased for strip operations)
    var prev = body[i - 1], sibling = body[i - 2];
    if (!prev) return isRoot;
    if (prev.type === "ContentStatement") return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
}
function $8f7ecf0fbfc05efe$var$isNextWhitespace(body, i, isRoot) {
    if (i === undefined) i = -1;
    var next = body[i + 1], sibling = body[i + 2];
    if (!next) return isRoot;
    if (next.type === "ContentStatement") return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
}
// Marks the node to the right of the position as omitted.
// I.e. {{foo}}' ' will mark the ' ' node as omitted.
//
// If i is undefined, then the first child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $8f7ecf0fbfc05efe$var$omitRight(body, i, multiple) {
    var current = body[i == null ? 0 : i + 1];
    if (!current || current.type !== "ContentStatement" || !multiple && current.rightStripped) return;
    var original = current.value;
    current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, "");
    current.rightStripped = current.value !== original;
}
// Marks the node to the left of the position as omitted.
// I.e. ' '{{foo}} will mark the ' ' node as omitted.
//
// If i is undefined then the last child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $8f7ecf0fbfc05efe$var$omitLeft(body, i, multiple) {
    var current = body[i == null ? body.length - 1 : i - 1];
    if (!current || current.type !== "ContentStatement" || !multiple && current.leftStripped) return;
    // We omit the last node if it's whitespace only and not preceded by a non-content node.
    var original = current.value;
    current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, "");
    current.leftStripped = current.value !== original;
    return current.leftStripped;
}
module.exports["default"] = $8f7ecf0fbfc05efe$var$WhitespaceControl;
module.exports = module.exports["default"];

});
parcelRegister("e34mu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $a3a4baa0d184e8d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6fk66 = parcelRequire("6fk66");
var $a3a4baa0d184e8d1$var$_exception2 = $a3a4baa0d184e8d1$var$_interopRequireDefault($6fk66);
function $a3a4baa0d184e8d1$var$Visitor() {
    this.parents = [];
}
$a3a4baa0d184e8d1$var$Visitor.prototype = {
    constructor: $a3a4baa0d184e8d1$var$Visitor,
    mutating: false,
    // Visits a given value. If mutating, will replace the value if necessary.
    acceptKey: function acceptKey(node, name) {
        var value = this.accept(node[name]);
        if (this.mutating) {
            // Hacky sanity check: This may have a few false positives for type for the helper
            // methods but will generally do the right thing without a lot of overhead.
            if (value && !$a3a4baa0d184e8d1$var$Visitor.prototype[value.type]) throw new $a3a4baa0d184e8d1$var$_exception2["default"]('Unexpected node type "' + value.type + '" found when accepting ' + name + " on " + node.type);
            node[name] = value;
        }
    },
    // Performs an accept operation with added sanity check to ensure
    // required keys are not removed.
    acceptRequired: function acceptRequired(node, name) {
        this.acceptKey(node, name);
        if (!node[name]) throw new $a3a4baa0d184e8d1$var$_exception2["default"](node.type + " requires " + name);
    },
    // Traverses a given array. If mutating, empty respnses will be removed
    // for child elements.
    acceptArray: function acceptArray(array) {
        for(var i = 0, l = array.length; i < l; i++){
            this.acceptKey(array, i);
            if (!array[i]) {
                array.splice(i, 1);
                i--;
                l--;
            }
        }
    },
    accept: function accept(object) {
        if (!object) return;
        /* istanbul ignore next: Sanity code */ if (!this[object.type]) throw new $a3a4baa0d184e8d1$var$_exception2["default"]("Unknown type: " + object.type, object);
        if (this.current) this.parents.unshift(this.current);
        this.current = object;
        var ret = this[object.type](object);
        this.current = this.parents.shift();
        if (!this.mutating || ret) return ret;
        else if (ret !== false) return object;
    },
    Program: function Program(program) {
        this.acceptArray(program.body);
    },
    MustacheStatement: $a3a4baa0d184e8d1$var$visitSubExpression,
    Decorator: $a3a4baa0d184e8d1$var$visitSubExpression,
    BlockStatement: $a3a4baa0d184e8d1$var$visitBlock,
    DecoratorBlock: $a3a4baa0d184e8d1$var$visitBlock,
    PartialStatement: $a3a4baa0d184e8d1$var$visitPartial,
    PartialBlockStatement: function PartialBlockStatement(partial) {
        $a3a4baa0d184e8d1$var$visitPartial.call(this, partial);
        this.acceptKey(partial, "program");
    },
    ContentStatement: function ContentStatement() /* content */ {},
    CommentStatement: function CommentStatement() /* comment */ {},
    SubExpression: $a3a4baa0d184e8d1$var$visitSubExpression,
    PathExpression: function PathExpression() /* path */ {},
    StringLiteral: function StringLiteral() /* string */ {},
    NumberLiteral: function NumberLiteral() /* number */ {},
    BooleanLiteral: function BooleanLiteral() /* bool */ {},
    UndefinedLiteral: function UndefinedLiteral() /* literal */ {},
    NullLiteral: function NullLiteral() /* literal */ {},
    Hash: function Hash(hash) {
        this.acceptArray(hash.pairs);
    },
    HashPair: function HashPair(pair) {
        this.acceptRequired(pair, "value");
    }
};
function $a3a4baa0d184e8d1$var$visitSubExpression(mustache) {
    this.acceptRequired(mustache, "path");
    this.acceptArray(mustache.params);
    this.acceptKey(mustache, "hash");
}
function $a3a4baa0d184e8d1$var$visitBlock(block) {
    $a3a4baa0d184e8d1$var$visitSubExpression.call(this, block);
    this.acceptKey(block, "program");
    this.acceptKey(block, "inverse");
}
function $a3a4baa0d184e8d1$var$visitPartial(partial) {
    this.acceptRequired(partial, "name");
    this.acceptArray(partial.params);
    this.acceptKey(partial, "hash");
}
module.exports["default"] = $a3a4baa0d184e8d1$var$Visitor;
module.exports = module.exports["default"];

});


parcelRegister("ghAQ4", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $bdaacf52a30cf5f6$export$1e511d4a378977f5; }, function (v) { return $bdaacf52a30cf5f6$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "SourceLocation", function () { return $bdaacf52a30cf5f6$export$7387db7caf96fcdb; }, function (v) { return $bdaacf52a30cf5f6$export$7387db7caf96fcdb = v; });
$parcel$export(module.exports, "id", function () { return $bdaacf52a30cf5f6$export$d560c7e4a29451c2; }, function (v) { return $bdaacf52a30cf5f6$export$d560c7e4a29451c2 = v; });
$parcel$export(module.exports, "stripFlags", function () { return $bdaacf52a30cf5f6$export$a56883f706fd4153; }, function (v) { return $bdaacf52a30cf5f6$export$a56883f706fd4153 = v; });
$parcel$export(module.exports, "stripComment", function () { return $bdaacf52a30cf5f6$export$b0ad15fcf54729ff; }, function (v) { return $bdaacf52a30cf5f6$export$b0ad15fcf54729ff = v; });
$parcel$export(module.exports, "preparePath", function () { return $bdaacf52a30cf5f6$export$ea68d0dfa0ba072f; }, function (v) { return $bdaacf52a30cf5f6$export$ea68d0dfa0ba072f = v; });
$parcel$export(module.exports, "prepareMustache", function () { return $bdaacf52a30cf5f6$export$6b8089a1dfd22498; }, function (v) { return $bdaacf52a30cf5f6$export$6b8089a1dfd22498 = v; });
$parcel$export(module.exports, "prepareRawBlock", function () { return $bdaacf52a30cf5f6$export$c642052fcb02035b; }, function (v) { return $bdaacf52a30cf5f6$export$c642052fcb02035b = v; });
$parcel$export(module.exports, "prepareBlock", function () { return $bdaacf52a30cf5f6$export$9814855d713f4497; }, function (v) { return $bdaacf52a30cf5f6$export$9814855d713f4497 = v; });
$parcel$export(module.exports, "prepareProgram", function () { return $bdaacf52a30cf5f6$export$6e1c63ef90231a66; }, function (v) { return $bdaacf52a30cf5f6$export$6e1c63ef90231a66 = v; });
$parcel$export(module.exports, "preparePartialBlock", function () { return $bdaacf52a30cf5f6$export$8b47bc71272f067a; }, function (v) { return $bdaacf52a30cf5f6$export$8b47bc71272f067a = v; });
var $bdaacf52a30cf5f6$export$1e511d4a378977f5;
var $bdaacf52a30cf5f6$export$7387db7caf96fcdb;
var $bdaacf52a30cf5f6$export$d560c7e4a29451c2;
var $bdaacf52a30cf5f6$export$a56883f706fd4153;
var $bdaacf52a30cf5f6$export$b0ad15fcf54729ff;
var $bdaacf52a30cf5f6$export$ea68d0dfa0ba072f;
var $bdaacf52a30cf5f6$export$6b8089a1dfd22498;
var $bdaacf52a30cf5f6$export$c642052fcb02035b;
var $bdaacf52a30cf5f6$export$9814855d713f4497;
var $bdaacf52a30cf5f6$export$6e1c63ef90231a66;
var $bdaacf52a30cf5f6$export$8b47bc71272f067a;
"use strict";
$bdaacf52a30cf5f6$export$1e511d4a378977f5 = true;
$bdaacf52a30cf5f6$export$7387db7caf96fcdb = $bdaacf52a30cf5f6$var$SourceLocation;
$bdaacf52a30cf5f6$export$d560c7e4a29451c2 = $bdaacf52a30cf5f6$var$id;
$bdaacf52a30cf5f6$export$a56883f706fd4153 = $bdaacf52a30cf5f6$var$stripFlags;
$bdaacf52a30cf5f6$export$b0ad15fcf54729ff = $bdaacf52a30cf5f6$var$stripComment;
$bdaacf52a30cf5f6$export$ea68d0dfa0ba072f = $bdaacf52a30cf5f6$var$preparePath;
$bdaacf52a30cf5f6$export$6b8089a1dfd22498 = $bdaacf52a30cf5f6$var$prepareMustache;
$bdaacf52a30cf5f6$export$c642052fcb02035b = $bdaacf52a30cf5f6$var$prepareRawBlock;
$bdaacf52a30cf5f6$export$9814855d713f4497 = $bdaacf52a30cf5f6$var$prepareBlock;
$bdaacf52a30cf5f6$export$6e1c63ef90231a66 = $bdaacf52a30cf5f6$var$prepareProgram;
$bdaacf52a30cf5f6$export$8b47bc71272f067a = $bdaacf52a30cf5f6$var$preparePartialBlock;
// istanbul ignore next
function $bdaacf52a30cf5f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6fk66 = parcelRequire("6fk66");
var $bdaacf52a30cf5f6$var$_exception2 = $bdaacf52a30cf5f6$var$_interopRequireDefault($6fk66);
function $bdaacf52a30cf5f6$var$validateClose(open, close) {
    close = close.path ? close.path.original : close;
    if (open.path.original !== close) {
        var errorNode = {
            loc: open.path.loc
        };
        throw new $bdaacf52a30cf5f6$var$_exception2["default"](open.path.original + " doesn't match " + close, errorNode);
    }
}
function $bdaacf52a30cf5f6$var$SourceLocation(source, locInfo) {
    this.source = source;
    this.start = {
        line: locInfo.first_line,
        column: locInfo.first_column
    };
    this.end = {
        line: locInfo.last_line,
        column: locInfo.last_column
    };
}
function $bdaacf52a30cf5f6$var$id(token) {
    if (/^\[.*\]$/.test(token)) return token.substring(1, token.length - 1);
    else return token;
}
function $bdaacf52a30cf5f6$var$stripFlags(open, close) {
    return {
        open: open.charAt(2) === "~",
        close: close.charAt(close.length - 3) === "~"
    };
}
function $bdaacf52a30cf5f6$var$stripComment(comment) {
    return comment.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
}
function $bdaacf52a30cf5f6$var$preparePath(data, parts, loc) {
    loc = this.locInfo(loc);
    var original = data ? "@" : "", dig = [], depth = 0;
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].part, // If we have [] syntax then we do not treat path references as operators,
        // i.e. foo.[this] resolves to approximately context.foo['this']
        isLiteral = parts[i].original !== part;
        original += (parts[i].separator || "") + part;
        if (!isLiteral && (part === ".." || part === "." || part === "this")) {
            if (dig.length > 0) throw new $bdaacf52a30cf5f6$var$_exception2["default"]("Invalid path: " + original, {
                loc: loc
            });
            else if (part === "..") depth++;
        } else dig.push(part);
    }
    return {
        type: "PathExpression",
        data: data,
        depth: depth,
        parts: dig,
        original: original,
        loc: loc
    };
}
function $bdaacf52a30cf5f6$var$prepareMustache(path, params, hash, open, strip, locInfo) {
    // Must use charAt to support IE pre-10
    var escapeFlag = open.charAt(3) || open.charAt(2), escaped = escapeFlag !== "{" && escapeFlag !== "&";
    var decorator = /\*/.test(open);
    return {
        type: decorator ? "Decorator" : "MustacheStatement",
        path: path,
        params: params,
        hash: hash,
        escaped: escaped,
        strip: strip,
        loc: this.locInfo(locInfo)
    };
}
function $bdaacf52a30cf5f6$var$prepareRawBlock(openRawBlock, contents, close, locInfo) {
    $bdaacf52a30cf5f6$var$validateClose(openRawBlock, close);
    locInfo = this.locInfo(locInfo);
    var program = {
        type: "Program",
        body: contents,
        strip: {},
        loc: locInfo
    };
    return {
        type: "BlockStatement",
        path: openRawBlock.path,
        params: openRawBlock.params,
        hash: openRawBlock.hash,
        program: program,
        openStrip: {},
        inverseStrip: {},
        closeStrip: {},
        loc: locInfo
    };
}
function $bdaacf52a30cf5f6$var$prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
    if (close && close.path) $bdaacf52a30cf5f6$var$validateClose(openBlock, close);
    var decorator = /\*/.test(openBlock.open);
    program.blockParams = openBlock.blockParams;
    var inverse = undefined, inverseStrip = undefined;
    if (inverseAndProgram) {
        if (decorator) throw new $bdaacf52a30cf5f6$var$_exception2["default"]("Unexpected inverse block on decorator", inverseAndProgram);
        if (inverseAndProgram.chain) inverseAndProgram.program.body[0].closeStrip = close.strip;
        inverseStrip = inverseAndProgram.strip;
        inverse = inverseAndProgram.program;
    }
    if (inverted) {
        inverted = inverse;
        inverse = program;
        program = inverted;
    }
    return {
        type: decorator ? "DecoratorBlock" : "BlockStatement",
        path: openBlock.path,
        params: openBlock.params,
        hash: openBlock.hash,
        program: program,
        inverse: inverse,
        openStrip: openBlock.strip,
        inverseStrip: inverseStrip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}
function $bdaacf52a30cf5f6$var$prepareProgram(statements, loc) {
    if (!loc && statements.length) {
        var firstLoc = statements[0].loc, lastLoc = statements[statements.length - 1].loc;
        /* istanbul ignore else */ if (firstLoc && lastLoc) loc = {
            source: firstLoc.source,
            start: {
                line: firstLoc.start.line,
                column: firstLoc.start.column
            },
            end: {
                line: lastLoc.end.line,
                column: lastLoc.end.column
            }
        };
    }
    return {
        type: "Program",
        body: statements,
        strip: {},
        loc: loc
    };
}
function $bdaacf52a30cf5f6$var$preparePartialBlock(open, program, close, locInfo) {
    $bdaacf52a30cf5f6$var$validateClose(open, close);
    return {
        type: "PartialBlockStatement",
        name: open.path,
        params: open.params,
        hash: open.hash,
        program: program,
        openStrip: open.strip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}

});


parcelRegister("jKGBz", function(module, exports) {

$parcel$export(module.exports, "Compiler", function () { return $e6135caf15e7ab69$export$3a6335acfcf707c9; }, function (v) { return $e6135caf15e7ab69$export$3a6335acfcf707c9 = v; });
$parcel$export(module.exports, "precompile", function () { return $e6135caf15e7ab69$export$cfb9e0f1330f9bbd; }, function (v) { return $e6135caf15e7ab69$export$cfb9e0f1330f9bbd = v; });
$parcel$export(module.exports, "compile", function () { return $e6135caf15e7ab69$export$ef7acd7185315e22; }, function (v) { return $e6135caf15e7ab69$export$ef7acd7185315e22 = v; });
/* eslint-disable new-cap */ var $e6135caf15e7ab69$export$1e511d4a378977f5;
var $e6135caf15e7ab69$export$3a6335acfcf707c9;
var $e6135caf15e7ab69$export$cfb9e0f1330f9bbd;
var $e6135caf15e7ab69$export$ef7acd7185315e22;
"use strict";
$e6135caf15e7ab69$export$1e511d4a378977f5 = true;
$e6135caf15e7ab69$export$3a6335acfcf707c9 = $e6135caf15e7ab69$var$Compiler;
$e6135caf15e7ab69$export$cfb9e0f1330f9bbd = $e6135caf15e7ab69$var$precompile;
$e6135caf15e7ab69$export$ef7acd7185315e22 = $e6135caf15e7ab69$var$compile;
// istanbul ignore next
function $e6135caf15e7ab69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $6fk66 = parcelRequire("6fk66");
var $e6135caf15e7ab69$var$_exception2 = $e6135caf15e7ab69$var$_interopRequireDefault($6fk66);

var $6kalm = parcelRequire("6kalm");

var $dUGfH = parcelRequire("dUGfH");
var $e6135caf15e7ab69$var$_ast2 = $e6135caf15e7ab69$var$_interopRequireDefault($dUGfH);
var $e6135caf15e7ab69$var$slice = [].slice;
function $e6135caf15e7ab69$var$Compiler() {}
// the foundHelper register will disambiguate helper lookup from finding a
// function in a context. This is necessary for mustache compatibility, which
// requires that context functions in blocks are evaluated by blockHelperMissing,
// and then proceed as if the resulting value was provided to blockHelperMissing.
$e6135caf15e7ab69$var$Compiler.prototype = {
    compiler: $e6135caf15e7ab69$var$Compiler,
    equals: function equals(other) {
        var len = this.opcodes.length;
        if (other.opcodes.length !== len) return false;
        for(var i = 0; i < len; i++){
            var opcode = this.opcodes[i], otherOpcode = other.opcodes[i];
            if (opcode.opcode !== otherOpcode.opcode || !$e6135caf15e7ab69$var$argEquals(opcode.args, otherOpcode.args)) return false;
        }
        // We know that length is the same between the two arrays because they are directly tied
        // to the opcode behavior above.
        len = this.children.length;
        for(var i = 0; i < len; i++){
            if (!this.children[i].equals(other.children[i])) return false;
        }
        return true;
    },
    guid: 0,
    compile: function compile(program, options) {
        this.sourceNode = [];
        this.opcodes = [];
        this.children = [];
        this.options = options;
        this.stringParams = options.stringParams;
        this.trackIds = options.trackIds;
        options.blockParams = options.blockParams || [];
        options.knownHelpers = $6kalm.extend(Object.create(null), {
            helperMissing: true,
            blockHelperMissing: true,
            each: true,
            "if": true,
            unless: true,
            "with": true,
            log: true,
            lookup: true
        }, options.knownHelpers);
        return this.accept(program);
    },
    compileProgram: function compileProgram(program) {
        var childCompiler = new this.compiler(), // eslint-disable-line new-cap
        result = childCompiler.compile(program, this.options), guid = this.guid++;
        this.usePartial = this.usePartial || result.usePartial;
        this.children[guid] = result;
        this.useDepths = this.useDepths || result.useDepths;
        return guid;
    },
    accept: function accept(node) {
        /* istanbul ignore next: Sanity code */ if (!this[node.type]) throw new $e6135caf15e7ab69$var$_exception2["default"]("Unknown type: " + node.type, node);
        this.sourceNode.unshift(node);
        var ret = this[node.type](node);
        this.sourceNode.shift();
        return ret;
    },
    Program: function Program(program) {
        this.options.blockParams.unshift(program.blockParams);
        var body = program.body, bodyLength = body.length;
        for(var i = 0; i < bodyLength; i++)this.accept(body[i]);
        this.options.blockParams.shift();
        this.isSimple = bodyLength === 1;
        this.blockParams = program.blockParams ? program.blockParams.length : 0;
        return this;
    },
    BlockStatement: function BlockStatement(block) {
        $e6135caf15e7ab69$var$transformLiteralToPath(block);
        var program = block.program, inverse = block.inverse;
        program = program && this.compileProgram(program);
        inverse = inverse && this.compileProgram(inverse);
        var type = this.classifySexpr(block);
        if (type === "helper") this.helperSexpr(block, program, inverse);
        else if (type === "simple") {
            this.simpleSexpr(block);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode("pushProgram", program);
            this.opcode("pushProgram", inverse);
            this.opcode("emptyHash");
            this.opcode("blockValue", block.path.original);
        } else {
            this.ambiguousSexpr(block, program, inverse);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode("pushProgram", program);
            this.opcode("pushProgram", inverse);
            this.opcode("emptyHash");
            this.opcode("ambiguousBlockValue");
        }
        this.opcode("append");
    },
    DecoratorBlock: function DecoratorBlock(decorator) {
        var program = decorator.program && this.compileProgram(decorator.program);
        var params = this.setupFullMustacheParams(decorator, program, undefined), path = decorator.path;
        this.useDecorators = true;
        this.opcode("registerDecorator", params.length, path.original);
    },
    PartialStatement: function PartialStatement(partial) {
        this.usePartial = true;
        var program = partial.program;
        if (program) program = this.compileProgram(partial.program);
        var params = partial.params;
        if (params.length > 1) throw new $e6135caf15e7ab69$var$_exception2["default"]("Unsupported number of partial arguments: " + params.length, partial);
        else if (!params.length) {
            if (this.options.explicitPartialContext) this.opcode("pushLiteral", "undefined");
            else params.push({
                type: "PathExpression",
                parts: [],
                depth: 0
            });
        }
        var partialName = partial.name.original, isDynamic = partial.name.type === "SubExpression";
        if (isDynamic) this.accept(partial.name);
        this.setupFullMustacheParams(partial, program, undefined, true);
        var indent = partial.indent || "";
        if (this.options.preventIndent && indent) {
            this.opcode("appendContent", indent);
            indent = "";
        }
        this.opcode("invokePartial", isDynamic, partialName, indent);
        this.opcode("append");
    },
    PartialBlockStatement: function PartialBlockStatement(partialBlock) {
        this.PartialStatement(partialBlock);
    },
    MustacheStatement: function MustacheStatement(mustache) {
        this.SubExpression(mustache);
        if (mustache.escaped && !this.options.noEscape) this.opcode("appendEscaped");
        else this.opcode("append");
    },
    Decorator: function Decorator(decorator) {
        this.DecoratorBlock(decorator);
    },
    ContentStatement: function ContentStatement(content) {
        if (content.value) this.opcode("appendContent", content.value);
    },
    CommentStatement: function CommentStatement() {},
    SubExpression: function SubExpression(sexpr) {
        $e6135caf15e7ab69$var$transformLiteralToPath(sexpr);
        var type = this.classifySexpr(sexpr);
        if (type === "simple") this.simpleSexpr(sexpr);
        else if (type === "helper") this.helperSexpr(sexpr);
        else this.ambiguousSexpr(sexpr);
    },
    ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
        var path = sexpr.path, name = path.parts[0], isBlock = program != null || inverse != null;
        this.opcode("getContext", path.depth);
        this.opcode("pushProgram", program);
        this.opcode("pushProgram", inverse);
        path.strict = true;
        this.accept(path);
        this.opcode("invokeAmbiguous", name, isBlock);
    },
    simpleSexpr: function simpleSexpr(sexpr) {
        var path = sexpr.path;
        path.strict = true;
        this.accept(path);
        this.opcode("resolvePossibleLambda");
    },
    helperSexpr: function helperSexpr(sexpr, program, inverse) {
        var params = this.setupFullMustacheParams(sexpr, program, inverse), path = sexpr.path, name = path.parts[0];
        if (this.options.knownHelpers[name]) this.opcode("invokeKnownHelper", params.length, name);
        else if (this.options.knownHelpersOnly) throw new $e6135caf15e7ab69$var$_exception2["default"]("You specified knownHelpersOnly, but used the unknown helper " + name, sexpr);
        else {
            path.strict = true;
            path.falsy = true;
            this.accept(path);
            this.opcode("invokeHelper", params.length, path.original, $e6135caf15e7ab69$var$_ast2["default"].helpers.simpleId(path));
        }
    },
    PathExpression: function PathExpression(path) {
        this.addDepth(path.depth);
        this.opcode("getContext", path.depth);
        var name = path.parts[0], scoped = $e6135caf15e7ab69$var$_ast2["default"].helpers.scopedId(path), blockParamId = !path.depth && !scoped && this.blockParamIndex(name);
        if (blockParamId) this.opcode("lookupBlockParam", blockParamId, path.parts);
        else if (!name) // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
        this.opcode("pushContext");
        else if (path.data) {
            this.options.data = true;
            this.opcode("lookupData", path.depth, path.parts, path.strict);
        } else this.opcode("lookupOnContext", path.parts, path.falsy, path.strict, scoped);
    },
    StringLiteral: function StringLiteral(string) {
        this.opcode("pushString", string.value);
    },
    NumberLiteral: function NumberLiteral(number) {
        this.opcode("pushLiteral", number.value);
    },
    BooleanLiteral: function BooleanLiteral(bool) {
        this.opcode("pushLiteral", bool.value);
    },
    UndefinedLiteral: function UndefinedLiteral() {
        this.opcode("pushLiteral", "undefined");
    },
    NullLiteral: function NullLiteral() {
        this.opcode("pushLiteral", "null");
    },
    Hash: function Hash(hash) {
        var pairs = hash.pairs, i = 0, l = pairs.length;
        this.opcode("pushHash");
        for(; i < l; i++)this.pushParam(pairs[i].value);
        while(i--)this.opcode("assignToHash", pairs[i].key);
        this.opcode("popHash");
    },
    // HELPERS
    opcode: function opcode(name) {
        this.opcodes.push({
            opcode: name,
            args: $e6135caf15e7ab69$var$slice.call(arguments, 1),
            loc: this.sourceNode[0].loc
        });
    },
    addDepth: function addDepth(depth) {
        if (!depth) return;
        this.useDepths = true;
    },
    classifySexpr: function classifySexpr(sexpr) {
        var isSimple = $e6135caf15e7ab69$var$_ast2["default"].helpers.simpleId(sexpr.path);
        var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);
        // a mustache is an eligible helper if:
        // * its id is simple (a single part, not `this` or `..`)
        var isHelper = !isBlockParam && $e6135caf15e7ab69$var$_ast2["default"].helpers.helperExpression(sexpr);
        // if a mustache is an eligible helper but not a definite
        // helper, it is ambiguous, and will be resolved in a later
        // pass or at runtime.
        var isEligible = !isBlockParam && (isHelper || isSimple);
        // if ambiguous, we can possibly resolve the ambiguity now
        // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
        if (isEligible && !isHelper) {
            var _name = sexpr.path.parts[0], options = this.options;
            if (options.knownHelpers[_name]) isHelper = true;
            else if (options.knownHelpersOnly) isEligible = false;
        }
        if (isHelper) return "helper";
        else if (isEligible) return "ambiguous";
        else return "simple";
    },
    pushParams: function pushParams(params) {
        for(var i = 0, l = params.length; i < l; i++)this.pushParam(params[i]);
    },
    pushParam: function pushParam(val) {
        var value = val.value != null ? val.value : val.original || "";
        if (this.stringParams) {
            if (value.replace) value = value.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".");
            if (val.depth) this.addDepth(val.depth);
            this.opcode("getContext", val.depth || 0);
            this.opcode("pushStringParam", value, val.type);
            if (val.type === "SubExpression") // SubExpressions get evaluated and passed in
            // in string params mode.
            this.accept(val);
        } else {
            if (this.trackIds) {
                var blockParamIndex = undefined;
                if (val.parts && !$e6135caf15e7ab69$var$_ast2["default"].helpers.scopedId(val) && !val.depth) blockParamIndex = this.blockParamIndex(val.parts[0]);
                if (blockParamIndex) {
                    var blockParamChild = val.parts.slice(1).join(".");
                    this.opcode("pushId", "BlockParam", blockParamIndex, blockParamChild);
                } else {
                    value = val.original || value;
                    if (value.replace) value = value.replace(/^this(?:\.|$)/, "").replace(/^\.\//, "").replace(/^\.$/, "");
                    this.opcode("pushId", val.type, value);
                }
            }
            this.accept(val);
        }
    },
    setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
        var params = sexpr.params;
        this.pushParams(params);
        this.opcode("pushProgram", program);
        this.opcode("pushProgram", inverse);
        if (sexpr.hash) this.accept(sexpr.hash);
        else this.opcode("emptyHash", omitEmpty);
        return params;
    },
    blockParamIndex: function blockParamIndex(name) {
        for(var depth = 0, len = this.options.blockParams.length; depth < len; depth++){
            var blockParams = this.options.blockParams[depth], param = blockParams && $6kalm.indexOf(blockParams, name);
            if (blockParams && param >= 0) return [
                depth,
                param
            ];
        }
    }
};
function $e6135caf15e7ab69$var$precompile(input, options, env) {
    if (input == null || typeof input !== "string" && input.type !== "Program") throw new $e6135caf15e7ab69$var$_exception2["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
    options = options || {};
    if (!("data" in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options);
    return new env.JavaScriptCompiler().compile(environment, options);
}
function $e6135caf15e7ab69$var$compile(input, options, env) {
    if (options === undefined) options = {};
    if (input == null || typeof input !== "string" && input.type !== "Program") throw new $e6135caf15e7ab69$var$_exception2["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
    options = $6kalm.extend({}, options);
    if (!("data" in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var compiled = undefined;
    function compileInput() {
        var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options), templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
        return env.template(templateSpec);
    }
    // Template is only compiled on first use and cached after that point.
    function ret(context, execOptions) {
        if (!compiled) compiled = compileInput();
        return compiled.call(this, context, execOptions);
    }
    ret._setup = function(setupOptions) {
        if (!compiled) compiled = compileInput();
        return compiled._setup(setupOptions);
    };
    ret._child = function(i, data, blockParams, depths) {
        if (!compiled) compiled = compileInput();
        return compiled._child(i, data, blockParams, depths);
    };
    return ret;
}
function $e6135caf15e7ab69$var$argEquals(a, b) {
    if (a === b) return true;
    if ($6kalm.isArray(a) && $6kalm.isArray(b) && a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (!$e6135caf15e7ab69$var$argEquals(a[i], b[i])) return false;
        }
        return true;
    }
}
function $e6135caf15e7ab69$var$transformLiteralToPath(sexpr) {
    if (!sexpr.path.parts) {
        var literal = sexpr.path;
        // Casting to string here to make false and 0 literal values play nicely with the rest
        // of the system.
        sexpr.path = {
            type: "PathExpression",
            data: false,
            depth: 0,
            parts: [
                literal.original + ""
            ],
            original: literal.original + "",
            loc: literal.loc
        };
    }
}

});

parcelRegister("dSwB5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
// istanbul ignore next
function $a1a99aa046561534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

var $24qvS = parcelRequire("24qvS");

var $6fk66 = parcelRequire("6fk66");
var $a1a99aa046561534$var$_exception2 = $a1a99aa046561534$var$_interopRequireDefault($6fk66);

var $6kalm = parcelRequire("6kalm");

var $hlSIE = parcelRequire("hlSIE");
var $a1a99aa046561534$var$_codeGen2 = $a1a99aa046561534$var$_interopRequireDefault($hlSIE);
function $a1a99aa046561534$var$Literal(value) {
    this.value = value;
}
function $a1a99aa046561534$var$JavaScriptCompiler() {}
$a1a99aa046561534$var$JavaScriptCompiler.prototype = {
    // PUBLIC API: You can override these methods in a subclass to provide
    // alternative compiled forms for name lookup and buffering semantics
    nameLookup: function nameLookup(parent, name /*,  type */ ) {
        return this.internalNameLookup(parent, name);
    },
    depthedLookup: function depthedLookup(name) {
        return [
            this.aliasable("container.lookup"),
            "(depths, ",
            JSON.stringify(name),
            ")"
        ];
    },
    compilerInfo: function compilerInfo() {
        var revision = $24qvS.COMPILER_REVISION, versions = $24qvS.REVISION_CHANGES[revision];
        return [
            revision,
            versions
        ];
    },
    appendToBuffer: function appendToBuffer(source, location, explicit) {
        // Force a source as this simplifies the merge logic.
        if (!$6kalm.isArray(source)) source = [
            source
        ];
        source = this.source.wrap(source, location);
        if (this.environment.isSimple) return [
            "return ",
            source,
            ";"
        ];
        else if (explicit) // This is a case where the buffer operation occurs as a child of another
        // construct, generally braces. We have to explicitly output these buffer
        // operations to ensure that the emitted code goes in the correct location.
        return [
            "buffer += ",
            source,
            ";"
        ];
        else {
            source.appendToBuffer = true;
            return source;
        }
    },
    initializeBuffer: function initializeBuffer() {
        return this.quotedString("");
    },
    // END PUBLIC API
    internalNameLookup: function internalNameLookup(parent, name) {
        this.lookupPropertyFunctionIsUsed = true;
        return [
            "lookupProperty(",
            parent,
            ",",
            JSON.stringify(name),
            ")"
        ];
    },
    lookupPropertyFunctionIsUsed: false,
    compile: function compile(environment, options, context, asObject) {
        this.environment = environment;
        this.options = options;
        this.stringParams = this.options.stringParams;
        this.trackIds = this.options.trackIds;
        this.precompile = !asObject;
        this.name = this.environment.name;
        this.isChild = !!context;
        this.context = context || {
            decorators: [],
            programs: [],
            environments: []
        };
        this.preamble();
        this.stackSlot = 0;
        this.stackVars = [];
        this.aliases = {};
        this.registers = {
            list: []
        };
        this.hashes = [];
        this.compileStack = [];
        this.inlineStack = [];
        this.blockParams = [];
        this.compileChildren(environment, options);
        this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
        this.useBlockParams = this.useBlockParams || environment.useBlockParams;
        var opcodes = environment.opcodes, opcode = undefined, firstLoc = undefined, i = undefined, l = undefined;
        for(i = 0, l = opcodes.length; i < l; i++){
            opcode = opcodes[i];
            this.source.currentLocation = opcode.loc;
            firstLoc = firstLoc || opcode.loc;
            this[opcode.opcode].apply(this, opcode.args);
        }
        // Flush any trailing content that might be pending.
        this.source.currentLocation = firstLoc;
        this.pushSource("");
        /* istanbul ignore next */ if (this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new $a1a99aa046561534$var$_exception2["default"]("Compile completed with content left on stack");
        if (!this.decorators.isEmpty()) {
            this.useDecorators = true;
            this.decorators.prepend([
                "var decorators = container.decorators, ",
                this.lookupPropertyFunctionVarDeclaration(),
                ";\n"
            ]);
            this.decorators.push("return fn;");
            if (asObject) this.decorators = Function.apply(this, [
                "fn",
                "props",
                "container",
                "depth0",
                "data",
                "blockParams",
                "depths",
                this.decorators.merge()
            ]);
            else {
                this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n");
                this.decorators.push("}\n");
                this.decorators = this.decorators.merge();
            }
        } else this.decorators = undefined;
        var fn = this.createFunctionContext(asObject);
        if (!this.isChild) {
            var ret = {
                compiler: this.compilerInfo(),
                main: fn
            };
            if (this.decorators) {
                ret.main_d = this.decorators; // eslint-disable-line camelcase
                ret.useDecorators = true;
            }
            var _context = this.context;
            var programs = _context.programs;
            var decorators = _context.decorators;
            for(i = 0, l = programs.length; i < l; i++)if (programs[i]) {
                ret[i] = programs[i];
                if (decorators[i]) {
                    ret[i + "_d"] = decorators[i];
                    ret.useDecorators = true;
                }
            }
            if (this.environment.usePartial) ret.usePartial = true;
            if (this.options.data) ret.useData = true;
            if (this.useDepths) ret.useDepths = true;
            if (this.useBlockParams) ret.useBlockParams = true;
            if (this.options.compat) ret.compat = true;
            if (!asObject) {
                ret.compiler = JSON.stringify(ret.compiler);
                this.source.currentLocation = {
                    start: {
                        line: 1,
                        column: 0
                    }
                };
                ret = this.objectLiteral(ret);
                if (options.srcName) {
                    ret = ret.toStringWithSourceMap({
                        file: options.destName
                    });
                    ret.map = ret.map && ret.map.toString();
                } else ret = ret.toString();
            } else ret.compilerOptions = this.options;
            return ret;
        } else return fn;
    },
    preamble: function preamble() {
        // track the last context pushed into place to allow skipping the
        // getContext opcode when it would be a noop
        this.lastContext = 0;
        this.source = new $a1a99aa046561534$var$_codeGen2["default"](this.options.srcName);
        this.decorators = new $a1a99aa046561534$var$_codeGen2["default"](this.options.srcName);
    },
    createFunctionContext: function createFunctionContext(asObject) {
        // istanbul ignore next
        var _this = this;
        var varDeclarations = "";
        var locals = this.stackVars.concat(this.registers.list);
        if (locals.length > 0) varDeclarations += ", " + locals.join(", ");
        // Generate minimizer alias mappings
        //
        // When using true SourceNodes, this will update all references to the given alias
        // as the source nodes are reused in situ. For the non-source node compilation mode,
        // aliases will not be used, but this case is already being run on the client and
        // we aren't concern about minimizing the template size.
        var aliasCount = 0;
        Object.keys(this.aliases).forEach(function(alias) {
            var node = _this.aliases[alias];
            if (node.children && node.referenceCount > 1) {
                varDeclarations += ", alias" + ++aliasCount + "=" + alias;
                node.children[0] = "alias" + aliasCount;
            }
        });
        if (this.lookupPropertyFunctionIsUsed) varDeclarations += ", " + this.lookupPropertyFunctionVarDeclaration();
        var params = [
            "container",
            "depth0",
            "helpers",
            "partials",
            "data"
        ];
        if (this.useBlockParams || this.useDepths) params.push("blockParams");
        if (this.useDepths) params.push("depths");
        // Perform a second pass over the output to merge content when possible
        var source = this.mergeSource(varDeclarations);
        if (asObject) {
            params.push(source);
            return Function.apply(this, params);
        } else return this.source.wrap([
            "function(",
            params.join(","),
            ") {\n  ",
            source,
            "}"
        ]);
    },
    mergeSource: function mergeSource(varDeclarations) {
        var isSimple = this.environment.isSimple, appendOnly = !this.forceBuffer, appendFirst = undefined, sourceSeen = undefined, bufferStart = undefined, bufferEnd = undefined;
        this.source.each(function(line) {
            if (line.appendToBuffer) {
                if (bufferStart) line.prepend("  + ");
                else bufferStart = line;
                bufferEnd = line;
            } else {
                if (bufferStart) {
                    if (!sourceSeen) appendFirst = true;
                    else bufferStart.prepend("buffer += ");
                    bufferEnd.add(";");
                    bufferStart = bufferEnd = undefined;
                }
                sourceSeen = true;
                if (!isSimple) appendOnly = false;
            }
        });
        if (appendOnly) {
            if (bufferStart) {
                bufferStart.prepend("return ");
                bufferEnd.add(";");
            } else if (!sourceSeen) this.source.push('return "";');
        } else {
            varDeclarations += ", buffer = " + (appendFirst ? "" : this.initializeBuffer());
            if (bufferStart) {
                bufferStart.prepend("return buffer + ");
                bufferEnd.add(";");
            } else this.source.push("return buffer;");
        }
        if (varDeclarations) this.source.prepend("var " + varDeclarations.substring(2) + (appendFirst ? "" : ";\n"));
        return this.source.merge();
    },
    lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
        return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
    },
    // [blockValue]
    //
    // On stack, before: hash, inverse, program, value
    // On stack, after: return value of blockHelperMissing
    //
    // The purpose of this opcode is to take a block of the form
    // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
    // replace it on the stack with the result of properly
    // invoking blockHelperMissing.
    blockValue: function blockValue(name) {
        var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs(name, 0, params);
        var blockName = this.popStack();
        params.splice(1, 0, blockName);
        this.push(this.source.functionCall(blockHelperMissing, "call", params));
    },
    // [ambiguousBlockValue]
    //
    // On stack, before: hash, inverse, program, value
    // Compiler value, before: lastHelper=value of last found helper, if any
    // On stack, after, if no lastHelper: same as [blockValue]
    // On stack, after, if lastHelper: value
    ambiguousBlockValue: function ambiguousBlockValue() {
        // We're being a bit cheeky and reusing the options value from the prior exec
        var blockHelperMissing = this.aliasable("container.hooks.blockHelperMissing"), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs("", 0, params, true);
        this.flushInline();
        var current = this.topStack();
        params.splice(1, 0, current);
        this.pushSource([
            "if (!",
            this.lastHelper,
            ") { ",
            current,
            " = ",
            this.source.functionCall(blockHelperMissing, "call", params),
            "}"
        ]);
    },
    // [appendContent]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Appends the string value of `content` to the current buffer
    appendContent: function appendContent(content) {
        if (this.pendingContent) content = this.pendingContent + content;
        else this.pendingLocation = this.source.currentLocation;
        this.pendingContent = content;
    },
    // [append]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Coerces `value` to a String and appends it to the current buffer.
    //
    // If `value` is truthy, or 0, it is coerced into a string and appended
    // Otherwise, the empty string is appended
    append: function append() {
        if (this.isInline()) {
            this.replaceStack(function(current) {
                return [
                    " != null ? ",
                    current,
                    ' : ""'
                ];
            });
            this.pushSource(this.appendToBuffer(this.popStack()));
        } else {
            var local = this.popStack();
            this.pushSource([
                "if (",
                local,
                " != null) { ",
                this.appendToBuffer(local, undefined, true),
                " }"
            ]);
            if (this.environment.isSimple) this.pushSource([
                "else { ",
                this.appendToBuffer("''", undefined, true),
                " }"
            ]);
        }
    },
    // [appendEscaped]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Escape `value` and append it to the buffer
    appendEscaped: function appendEscaped() {
        this.pushSource(this.appendToBuffer([
            this.aliasable("container.escapeExpression"),
            "(",
            this.popStack(),
            ")"
        ]));
    },
    // [getContext]
    //
    // On stack, before: ...
    // On stack, after: ...
    // Compiler value, after: lastContext=depth
    //
    // Set the value of the `lastContext` compiler value to the depth
    getContext: function getContext(depth) {
        this.lastContext = depth;
    },
    // [pushContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext, ...
    //
    // Pushes the value of the current context onto the stack.
    pushContext: function pushContext() {
        this.pushStackLiteral(this.contextName(this.lastContext));
    },
    // [lookupOnContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext[name], ...
    //
    // Looks up the value of `name` on the current context and pushes
    // it onto the stack.
    lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
        var i = 0;
        if (!scoped && this.options.compat && !this.lastContext) // The depthed query is expected to handle the undefined logic for the root level that
        // is implemented below, so we evaluate that directly in compat mode
        this.push(this.depthedLookup(parts[i++]));
        else this.pushContext();
        this.resolvePath("context", parts, i, falsy, strict);
    },
    // [lookupBlockParam]
    //
    // On stack, before: ...
    // On stack, after: blockParam[name], ...
    //
    // Looks up the value of `parts` on the given block param and pushes
    // it onto the stack.
    lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
        this.useBlockParams = true;
        this.push([
            "blockParams[",
            blockParamId[0],
            "][",
            blockParamId[1],
            "]"
        ]);
        this.resolvePath("context", parts, 1);
    },
    // [lookupData]
    //
    // On stack, before: ...
    // On stack, after: data, ...
    //
    // Push the data lookup operator
    lookupData: function lookupData(depth, parts, strict) {
        if (!depth) this.pushStackLiteral("data");
        else this.pushStackLiteral("container.data(data, " + depth + ")");
        this.resolvePath("data", parts, 0, true, strict);
    },
    resolvePath: function resolvePath(type, parts, i, falsy, strict) {
        // istanbul ignore next
        var _this2 = this;
        if (this.options.strict || this.options.assumeObjects) {
            this.push($a1a99aa046561534$var$strictLookup(this.options.strict && strict, this, parts, i, type));
            return;
        }
        var len = parts.length;
        for(; i < len; i++)/* eslint-disable no-loop-func */ this.replaceStack(function(current) {
            var lookup = _this2.nameLookup(current, parts[i], type);
            // We want to ensure that zero and false are handled properly if the context (falsy flag)
            // needs to have the special handling for these values.
            if (!falsy) return [
                " != null ? ",
                lookup,
                " : ",
                current
            ];
            else // Otherwise we can use generic falsy handling
            return [
                " && ",
                lookup
            ];
        });
    },
    // [resolvePossibleLambda]
    //
    // On stack, before: value, ...
    // On stack, after: resolved value, ...
    //
    // If the `value` is a lambda, replace it on the stack by
    // the return value of the lambda
    resolvePossibleLambda: function resolvePossibleLambda() {
        this.push([
            this.aliasable("container.lambda"),
            "(",
            this.popStack(),
            ", ",
            this.contextName(0),
            ")"
        ]);
    },
    // [pushStringParam]
    //
    // On stack, before: ...
    // On stack, after: string, currentContext, ...
    //
    // This opcode is designed for use in string mode, which
    // provides the string value of a parameter along with its
    // depth rather than resolving it immediately.
    pushStringParam: function pushStringParam(string, type) {
        this.pushContext();
        this.pushString(type);
        // If it's a subexpression, the string result
        // will be pushed after this opcode.
        if (type !== "SubExpression") {
            if (typeof string === "string") this.pushString(string);
            else this.pushStackLiteral(string);
        }
    },
    emptyHash: function emptyHash(omitEmpty) {
        if (this.trackIds) this.push("{}"); // hashIds
        if (this.stringParams) {
            this.push("{}"); // hashContexts
            this.push("{}"); // hashTypes
        }
        this.pushStackLiteral(omitEmpty ? "undefined" : "{}");
    },
    pushHash: function pushHash() {
        if (this.hash) this.hashes.push(this.hash);
        this.hash = {
            values: {},
            types: [],
            contexts: [],
            ids: []
        };
    },
    popHash: function popHash() {
        var hash = this.hash;
        this.hash = this.hashes.pop();
        if (this.trackIds) this.push(this.objectLiteral(hash.ids));
        if (this.stringParams) {
            this.push(this.objectLiteral(hash.contexts));
            this.push(this.objectLiteral(hash.types));
        }
        this.push(this.objectLiteral(hash.values));
    },
    // [pushString]
    //
    // On stack, before: ...
    // On stack, after: quotedString(string), ...
    //
    // Push a quoted version of `string` onto the stack
    pushString: function pushString(string) {
        this.pushStackLiteral(this.quotedString(string));
    },
    // [pushLiteral]
    //
    // On stack, before: ...
    // On stack, after: value, ...
    //
    // Pushes a value onto the stack. This operation prevents
    // the compiler from creating a temporary variable to hold
    // it.
    pushLiteral: function pushLiteral(value) {
        this.pushStackLiteral(value);
    },
    // [pushProgram]
    //
    // On stack, before: ...
    // On stack, after: program(guid), ...
    //
    // Push a program expression onto the stack. This takes
    // a compile-time guid and converts it into a runtime-accessible
    // expression.
    pushProgram: function pushProgram(guid) {
        if (guid != null) this.pushStackLiteral(this.programExpression(guid));
        else this.pushStackLiteral(null);
    },
    // [registerDecorator]
    //
    // On stack, before: hash, program, params..., ...
    // On stack, after: ...
    //
    // Pops off the decorator's parameters, invokes the decorator,
    // and inserts the decorator into the decorators list.
    registerDecorator: function registerDecorator(paramSize, name) {
        var foundDecorator = this.nameLookup("decorators", name, "decorator"), options = this.setupHelperArgs(name, paramSize);
        this.decorators.push([
            "fn = ",
            this.decorators.functionCall(foundDecorator, "", [
                "fn",
                "props",
                "container",
                options
            ]),
            " || fn;"
        ]);
    },
    // [invokeHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // Pops off the helper's parameters, invokes the helper,
    // and pushes the helper's return value onto the stack.
    //
    // If the helper is not found, `helperMissing` is called.
    invokeHelper: function invokeHelper(paramSize, name, isSimple) {
        var nonHelper = this.popStack(), helper = this.setupHelper(paramSize, name);
        var possibleFunctionCalls = [];
        if (isSimple) // direct call to helper
        possibleFunctionCalls.push(helper.name);
        // call a function from the input object
        possibleFunctionCalls.push(nonHelper);
        if (!this.options.strict) possibleFunctionCalls.push(this.aliasable("container.hooks.helperMissing"));
        var functionLookupCode = [
            "(",
            this.itemsSeparatedBy(possibleFunctionCalls, "||"),
            ")"
        ];
        var functionCall = this.source.functionCall(functionLookupCode, "call", helper.callParams);
        this.push(functionCall);
    },
    itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
        var result = [];
        result.push(items[0]);
        for(var i = 1; i < items.length; i++)result.push(separator, items[i]);
        return result;
    },
    // [invokeKnownHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // This operation is used when the helper is known to exist,
    // so a `helperMissing` fallback is not required.
    invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
        var helper = this.setupHelper(paramSize, name);
        this.push(this.source.functionCall(helper.name, "call", helper.callParams));
    },
    // [invokeAmbiguous]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of disambiguation
    //
    // This operation is used when an expression like `{{foo}}`
    // is provided, but we don't know at compile-time whether it
    // is a helper or a path.
    //
    // This operation emits more code than the other options,
    // and can be avoided by passing the `knownHelpers` and
    // `knownHelpersOnly` flags at compile-time.
    invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
        this.useRegister("helper");
        var nonHelper = this.popStack();
        this.emptyHash();
        var helper = this.setupHelper(0, name, helperCall);
        var helperName = this.lastHelper = this.nameLookup("helpers", name, "helper");
        var lookup = [
            "(",
            "(helper = ",
            helperName,
            " || ",
            nonHelper,
            ")"
        ];
        if (!this.options.strict) {
            lookup[0] = "(helper = ";
            lookup.push(" != null ? helper : ", this.aliasable("container.hooks.helperMissing"));
        }
        this.push([
            "(",
            lookup,
            helper.paramsInit ? [
                "),(",
                helper.paramsInit
            ] : [],
            "),",
            "(typeof helper === ",
            this.aliasable('"function"'),
            " ? ",
            this.source.functionCall("helper", "call", helper.callParams),
            " : helper))"
        ]);
    },
    // [invokePartial]
    //
    // On stack, before: context, ...
    // On stack after: result of partial invocation
    //
    // This operation pops off a context, invokes a partial with that context,
    // and pushes the result of the invocation back.
    invokePartial: function invokePartial(isDynamic, name, indent) {
        var params = [], options = this.setupParams(name, 1, params);
        if (isDynamic) {
            name = this.popStack();
            delete options.name;
        }
        if (indent) options.indent = JSON.stringify(indent);
        options.helpers = "helpers";
        options.partials = "partials";
        options.decorators = "container.decorators";
        if (!isDynamic) params.unshift(this.nameLookup("partials", name, "partial"));
        else params.unshift(name);
        if (this.options.compat) options.depths = "depths";
        options = this.objectLiteral(options);
        params.push(options);
        this.push(this.source.functionCall("container.invokePartial", "", params));
    },
    // [assignToHash]
    //
    // On stack, before: value, ..., hash, ...
    // On stack, after: ..., hash, ...
    //
    // Pops a value off the stack and assigns it to the current hash
    assignToHash: function assignToHash(key) {
        var value = this.popStack(), context = undefined, type = undefined, id = undefined;
        if (this.trackIds) id = this.popStack();
        if (this.stringParams) {
            type = this.popStack();
            context = this.popStack();
        }
        var hash = this.hash;
        if (context) hash.contexts[key] = context;
        if (type) hash.types[key] = type;
        if (id) hash.ids[key] = id;
        hash.values[key] = value;
    },
    pushId: function pushId(type, name, child) {
        if (type === "BlockParam") this.pushStackLiteral("blockParams[" + name[0] + "].path[" + name[1] + "]" + (child ? " + " + JSON.stringify("." + child) : ""));
        else if (type === "PathExpression") this.pushString(name);
        else if (type === "SubExpression") this.pushStackLiteral("true");
        else this.pushStackLiteral("null");
    },
    // HELPERS
    compiler: $a1a99aa046561534$var$JavaScriptCompiler,
    compileChildren: function compileChildren(environment, options) {
        var children = environment.children, child = undefined, compiler = undefined;
        for(var i = 0, l = children.length; i < l; i++){
            child = children[i];
            compiler = new this.compiler(); // eslint-disable-line new-cap
            var existing = this.matchExistingProgram(child);
            if (existing == null) {
                this.context.programs.push(""); // Placeholder to prevent name conflicts for nested children
                var index = this.context.programs.length;
                child.index = index;
                child.name = "program" + index;
                this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
                this.context.decorators[index] = compiler.decorators;
                this.context.environments[index] = child;
                this.useDepths = this.useDepths || compiler.useDepths;
                this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
                child.useDepths = this.useDepths;
                child.useBlockParams = this.useBlockParams;
            } else {
                child.index = existing.index;
                child.name = "program" + existing.index;
                this.useDepths = this.useDepths || existing.useDepths;
                this.useBlockParams = this.useBlockParams || existing.useBlockParams;
            }
        }
    },
    matchExistingProgram: function matchExistingProgram(child) {
        for(var i = 0, len = this.context.environments.length; i < len; i++){
            var environment = this.context.environments[i];
            if (environment && environment.equals(child)) return environment;
        }
    },
    programExpression: function programExpression(guid) {
        var child = this.environment.children[guid], programParams = [
            child.index,
            "data",
            child.blockParams
        ];
        if (this.useBlockParams || this.useDepths) programParams.push("blockParams");
        if (this.useDepths) programParams.push("depths");
        return "container.program(" + programParams.join(", ") + ")";
    },
    useRegister: function useRegister(name) {
        if (!this.registers[name]) {
            this.registers[name] = true;
            this.registers.list.push(name);
        }
    },
    push: function push(expr) {
        if (!(expr instanceof $a1a99aa046561534$var$Literal)) expr = this.source.wrap(expr);
        this.inlineStack.push(expr);
        return expr;
    },
    pushStackLiteral: function pushStackLiteral(item) {
        this.push(new $a1a99aa046561534$var$Literal(item));
    },
    pushSource: function pushSource(source) {
        if (this.pendingContent) {
            this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
            this.pendingContent = undefined;
        }
        if (source) this.source.push(source);
    },
    replaceStack: function replaceStack(callback) {
        var prefix = [
            "("
        ], stack = undefined, createdStack = undefined, usedLiteral = undefined;
        /* istanbul ignore next */ if (!this.isInline()) throw new $a1a99aa046561534$var$_exception2["default"]("replaceStack on non-inline");
        // We want to merge the inline statement into the replacement statement via ','
        var top = this.popStack(true);
        if (top instanceof $a1a99aa046561534$var$Literal) {
            // Literals do not need to be inlined
            stack = [
                top.value
            ];
            prefix = [
                "(",
                stack
            ];
            usedLiteral = true;
        } else {
            // Get or create the current stack name for use by the inline
            createdStack = true;
            var _name = this.incrStack();
            prefix = [
                "((",
                this.push(_name),
                " = ",
                top,
                ")"
            ];
            stack = this.topStack();
        }
        var item = callback.call(this, stack);
        if (!usedLiteral) this.popStack();
        if (createdStack) this.stackSlot--;
        this.push(prefix.concat(item, ")"));
    },
    incrStack: function incrStack() {
        this.stackSlot++;
        if (this.stackSlot > this.stackVars.length) this.stackVars.push("stack" + this.stackSlot);
        return this.topStackName();
    },
    topStackName: function topStackName() {
        return "stack" + this.stackSlot;
    },
    flushInline: function flushInline() {
        var inlineStack = this.inlineStack;
        this.inlineStack = [];
        for(var i = 0, len = inlineStack.length; i < len; i++){
            var entry = inlineStack[i];
            /* istanbul ignore if */ if (entry instanceof $a1a99aa046561534$var$Literal) this.compileStack.push(entry);
            else {
                var stack = this.incrStack();
                this.pushSource([
                    stack,
                    " = ",
                    entry,
                    ";"
                ]);
                this.compileStack.push(stack);
            }
        }
    },
    isInline: function isInline() {
        return this.inlineStack.length;
    },
    popStack: function popStack(wrapped) {
        var inline = this.isInline(), item = (inline ? this.inlineStack : this.compileStack).pop();
        if (!wrapped && item instanceof $a1a99aa046561534$var$Literal) return item.value;
        else {
            if (!inline) {
                /* istanbul ignore next */ if (!this.stackSlot) throw new $a1a99aa046561534$var$_exception2["default"]("Invalid stack pop");
                this.stackSlot--;
            }
            return item;
        }
    },
    topStack: function topStack() {
        var stack = this.isInline() ? this.inlineStack : this.compileStack, item = stack[stack.length - 1];
        /* istanbul ignore if */ if (item instanceof $a1a99aa046561534$var$Literal) return item.value;
        else return item;
    },
    contextName: function contextName(context) {
        if (this.useDepths && context) return "depths[" + context + "]";
        else return "depth" + context;
    },
    quotedString: function quotedString(str) {
        return this.source.quotedString(str);
    },
    objectLiteral: function objectLiteral(obj) {
        return this.source.objectLiteral(obj);
    },
    aliasable: function aliasable(name) {
        var ret = this.aliases[name];
        if (ret) {
            ret.referenceCount++;
            return ret;
        }
        ret = this.aliases[name] = this.source.wrap(name);
        ret.aliasable = true;
        ret.referenceCount = 1;
        return ret;
    },
    setupHelper: function setupHelper(paramSize, name, blockHelper) {
        var params = [], paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
        var foundHelper = this.nameLookup("helpers", name, "helper"), callContext = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : (container.nullContext || {})");
        return {
            params: params,
            paramsInit: paramsInit,
            name: foundHelper,
            callParams: [
                callContext
            ].concat(params)
        };
    },
    setupParams: function setupParams(helper, paramSize, params) {
        var options = {}, contexts = [], types = [], ids = [], objectArgs = !params, param = undefined;
        if (objectArgs) params = [];
        options.name = this.quotedString(helper);
        options.hash = this.popStack();
        if (this.trackIds) options.hashIds = this.popStack();
        if (this.stringParams) {
            options.hashTypes = this.popStack();
            options.hashContexts = this.popStack();
        }
        var inverse = this.popStack(), program = this.popStack();
        // Avoid setting fn and inverse if neither are set. This allows
        // helpers to do a check for `if (options.fn)`
        if (program || inverse) {
            options.fn = program || "container.noop";
            options.inverse = inverse || "container.noop";
        }
        // The parameters go on to the stack in order (making sure that they are evaluated in order)
        // so we need to pop them off the stack in reverse order
        var i = paramSize;
        while(i--){
            param = this.popStack();
            params[i] = param;
            if (this.trackIds) ids[i] = this.popStack();
            if (this.stringParams) {
                types[i] = this.popStack();
                contexts[i] = this.popStack();
            }
        }
        if (objectArgs) options.args = this.source.generateArray(params);
        if (this.trackIds) options.ids = this.source.generateArray(ids);
        if (this.stringParams) {
            options.types = this.source.generateArray(types);
            options.contexts = this.source.generateArray(contexts);
        }
        if (this.options.data) options.data = "data";
        if (this.useBlockParams) options.blockParams = "blockParams";
        return options;
    },
    setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
        var options = this.setupParams(helper, paramSize, params);
        options.loc = JSON.stringify(this.source.currentLocation);
        options = this.objectLiteral(options);
        if (useRegister) {
            this.useRegister("options");
            params.push("options");
            return [
                "options=",
                options
            ];
        } else if (params) {
            params.push(options);
            return "";
        } else return options;
    }
};
(function() {
    var reservedWords = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" ");
    var compilerWords = $a1a99aa046561534$var$JavaScriptCompiler.RESERVED_WORDS = {};
    for(var i = 0, l = reservedWords.length; i < l; i++)compilerWords[reservedWords[i]] = true;
})();
/**
 * @deprecated May be removed in the next major version
 */ $a1a99aa046561534$var$JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
    return !$a1a99aa046561534$var$JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
};
function $a1a99aa046561534$var$strictLookup(requireTerminal, compiler, parts, i, type) {
    var stack = compiler.popStack(), len = parts.length;
    if (requireTerminal) len--;
    for(; i < len; i++)stack = compiler.nameLookup(stack, parts[i], type);
    if (requireTerminal) return [
        compiler.aliasable("container.strict"),
        "(",
        stack,
        ", ",
        compiler.quotedString(parts[i]),
        ", ",
        JSON.stringify(compiler.source.currentLocation),
        " )"
    ];
    else return stack;
}
module.exports["default"] = $a1a99aa046561534$var$JavaScriptCompiler;
module.exports = module.exports["default"];

});
parcelRegister("hlSIE", function(module, exports) {
/* global define, require */ "use strict";
module.exports.__esModule = true;

var $6kalm = parcelRequire("6kalm");
var $ca1ed7ef60b1e126$var$SourceNode = undefined;

try {
    /* istanbul ignore next */ if (typeof define !== "function" || !define.amd) {
        // We don't support this in AMD environments. For these environments, we assume that
        // they are running on the browser and thus have no need for the source-map library.
        var $ca1ed7ef60b1e126$var$SourceMap = (parcelRequire("d7xtF"));
        $ca1ed7ef60b1e126$var$SourceNode = $ca1ed7ef60b1e126$var$SourceMap.SourceNode;
    }
} catch (err) {}
/* NOP */ /* istanbul ignore if: tested but not covered in istanbul due to dist build  */ if (!$ca1ed7ef60b1e126$var$SourceNode) {
    $ca1ed7ef60b1e126$var$SourceNode = function(line, column, srcFile, chunks) {
        this.src = "";
        if (chunks) this.add(chunks);
    };
    /* istanbul ignore next */ $ca1ed7ef60b1e126$var$SourceNode.prototype = {
        add: function add(chunks) {
            if ($6kalm.isArray(chunks)) chunks = chunks.join("");
            this.src += chunks;
        },
        prepend: function prepend(chunks) {
            if ($6kalm.isArray(chunks)) chunks = chunks.join("");
            this.src = chunks + this.src;
        },
        toStringWithSourceMap: function toStringWithSourceMap() {
            return {
                code: this.toString()
            };
        },
        toString: function toString() {
            return this.src;
        }
    };
}
function $ca1ed7ef60b1e126$var$castChunk(chunk, codeGen, loc) {
    if ($6kalm.isArray(chunk)) {
        var ret = [];
        for(var i = 0, len = chunk.length; i < len; i++)ret.push(codeGen.wrap(chunk[i], loc));
        return ret;
    } else if (typeof chunk === "boolean" || typeof chunk === "number") // Handle primitives that the SourceNode will throw up on
    return chunk + "";
    return chunk;
}
function $ca1ed7ef60b1e126$var$CodeGen(srcFile) {
    this.srcFile = srcFile;
    this.source = [];
}
$ca1ed7ef60b1e126$var$CodeGen.prototype = {
    isEmpty: function isEmpty() {
        return !this.source.length;
    },
    prepend: function prepend(source, loc) {
        this.source.unshift(this.wrap(source, loc));
    },
    push: function push(source, loc) {
        this.source.push(this.wrap(source, loc));
    },
    merge: function merge() {
        var source = this.empty();
        this.each(function(line) {
            source.add([
                "  ",
                line,
                "\n"
            ]);
        });
        return source;
    },
    each: function each(iter) {
        for(var i = 0, len = this.source.length; i < len; i++)iter(this.source[i]);
    },
    empty: function empty() {
        var loc = this.currentLocation || {
            start: {}
        };
        return new $ca1ed7ef60b1e126$var$SourceNode(loc.start.line, loc.start.column, this.srcFile);
    },
    wrap: function wrap(chunk) {
        var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || {
            start: {}
        } : arguments[1];
        if (chunk instanceof $ca1ed7ef60b1e126$var$SourceNode) return chunk;
        chunk = $ca1ed7ef60b1e126$var$castChunk(chunk, this, loc);
        return new $ca1ed7ef60b1e126$var$SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
    },
    functionCall: function functionCall(fn, type, params) {
        params = this.generateList(params);
        return this.wrap([
            fn,
            type ? "." + type + "(" : "(",
            params,
            ")"
        ]);
    },
    quotedString: function quotedString(str) {
        return '"' + (str + "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\u2028/g, "\\u2028") // Per Ecma-262 7.3 + 7.8.4
        .replace(/\u2029/g, "\\u2029") + '"';
    },
    objectLiteral: function objectLiteral(obj) {
        // istanbul ignore next
        var _this = this;
        var pairs = [];
        Object.keys(obj).forEach(function(key) {
            var value = $ca1ed7ef60b1e126$var$castChunk(obj[key], _this);
            if (value !== "undefined") pairs.push([
                _this.quotedString(key),
                ":",
                value
            ]);
        });
        var ret = this.generateList(pairs);
        ret.prepend("{");
        ret.add("}");
        return ret;
    },
    generateList: function generateList(entries) {
        var ret = this.empty();
        for(var i = 0, len = entries.length; i < len; i++){
            if (i) ret.add(",");
            ret.add($ca1ed7ef60b1e126$var$castChunk(entries[i], this));
        }
        return ret;
    },
    generateArray: function generateArray(entries) {
        var ret = this.generateList(entries);
        ret.prepend("[");
        ret.add("]");
        return ret;
    }
};
module.exports["default"] = $ca1ed7ef60b1e126$var$CodeGen;
module.exports = module.exports["default"];

});
parcelRegister("d7xtF", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", function () { return $98d5e5c106de5577$export$4d99f7c30e854ff; }, function (v) { return $98d5e5c106de5577$export$4d99f7c30e854ff = v; });
$parcel$export(module.exports, "SourceMapConsumer", function () { return $98d5e5c106de5577$export$194e92554d04abdd; }, function (v) { return $98d5e5c106de5577$export$194e92554d04abdd = v; });
$parcel$export(module.exports, "SourceNode", function () { return $98d5e5c106de5577$export$7e987e8f375d24c2; }, function (v) { return $98d5e5c106de5577$export$7e987e8f375d24c2 = v; });
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $98d5e5c106de5577$export$4d99f7c30e854ff;
var $98d5e5c106de5577$export$194e92554d04abdd;
var $98d5e5c106de5577$export$7e987e8f375d24c2;

$98d5e5c106de5577$export$4d99f7c30e854ff = (parcelRequire("8R90Q")).SourceMapGenerator;

$98d5e5c106de5577$export$194e92554d04abdd = (parcelRequire("kw68d")).SourceMapConsumer;

$98d5e5c106de5577$export$7e987e8f375d24c2 = (parcelRequire("xYwuS")).SourceNode;

});
parcelRegister("8R90Q", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", function () { return $672a43a97b320d06$export$4d99f7c30e854ff; }, function (v) { return $672a43a97b320d06$export$4d99f7c30e854ff = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $672a43a97b320d06$export$4d99f7c30e854ff;

var $hFoZM = parcelRequire("hFoZM");

var $7vXOe = parcelRequire("7vXOe");

var $kSonN = parcelRequire("kSonN");
var $672a43a97b320d06$require$ArraySet = $kSonN.ArraySet;

var $9dDOy = parcelRequire("9dDOy");
var $672a43a97b320d06$require$MappingList = $9dDOy.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $672a43a97b320d06$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $7vXOe.getArg(aArgs, "file", null);
    this._sourceRoot = $7vXOe.getArg(aArgs, "sourceRoot", null);
    this._skipValidation = $7vXOe.getArg(aArgs, "skipValidation", false);
    this._sources = new $672a43a97b320d06$require$ArraySet();
    this._names = new $672a43a97b320d06$require$ArraySet();
    this._mappings = new $672a43a97b320d06$require$MappingList();
    this._sourcesContents = null;
}
$672a43a97b320d06$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $672a43a97b320d06$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $672a43a97b320d06$var$SourceMapGenerator({
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $7vXOe.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $7vXOe.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $7vXOe.getArg(aArgs, "generated");
    var original = $7vXOe.getArg(aArgs, "original", null);
    var source = $7vXOe.getArg(aArgs, "source", null);
    var name = $7vXOe.getArg(aArgs, "name", null);
    if (!this._skipValidation) this._validateMapping(generated, original, source, name);
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $7vXOe.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$7vXOe.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$7vXOe.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $7vXOe.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $672a43a97b320d06$require$ArraySet();
    var newNames = new $672a43a97b320d06$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $7vXOe.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $7vXOe.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $7vXOe.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $7vXOe.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
    if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else throw new Error("Invalid mapping: " + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
    }));
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = "";
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = "";
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ";";
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$7vXOe.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ",";
        }
        next += $hFoZM.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $hFoZM.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $hFoZM.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $hFoZM.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $hFoZM.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$672a43a97b320d06$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $7vXOe.relative(aSourceRoot, source);
        var key = $7vXOe.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $672a43a97b320d06$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$672a43a97b320d06$export$4d99f7c30e854ff = $672a43a97b320d06$var$SourceMapGenerator;

});
parcelRegister("hFoZM", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $cdc9a79968cdbb03$export$c564cdbbe6da493; }, function (v) { return $cdc9a79968cdbb03$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $cdc9a79968cdbb03$export$2f872c0f2117be69; }, function (v) { return $cdc9a79968cdbb03$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $cdc9a79968cdbb03$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $cdc9a79968cdbb03$export$2f872c0f2117be69;

var $EYtX2 = parcelRequire("EYtX2");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $cdc9a79968cdbb03$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $cdc9a79968cdbb03$var$VLQ_BASE = 1 << $cdc9a79968cdbb03$var$VLQ_BASE_SHIFT;
// binary: 011111
var $cdc9a79968cdbb03$var$VLQ_BASE_MASK = $cdc9a79968cdbb03$var$VLQ_BASE - 1;
// binary: 100000
var $cdc9a79968cdbb03$var$VLQ_CONTINUATION_BIT = $cdc9a79968cdbb03$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $cdc9a79968cdbb03$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $cdc9a79968cdbb03$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$cdc9a79968cdbb03$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $cdc9a79968cdbb03$var$toVLQSigned(aValue);
    do {
        digit = vlq & $cdc9a79968cdbb03$var$VLQ_BASE_MASK;
        vlq >>>= $cdc9a79968cdbb03$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $cdc9a79968cdbb03$var$VLQ_CONTINUATION_BIT;
        encoded += $EYtX2.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$cdc9a79968cdbb03$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $EYtX2.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $cdc9a79968cdbb03$var$VLQ_CONTINUATION_BIT);
        digit &= $cdc9a79968cdbb03$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $cdc9a79968cdbb03$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $cdc9a79968cdbb03$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("EYtX2", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $07b2a705ff93a024$export$c564cdbbe6da493; }, function (v) { return $07b2a705ff93a024$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $07b2a705ff93a024$export$2f872c0f2117be69; }, function (v) { return $07b2a705ff93a024$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $07b2a705ff93a024$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $07b2a705ff93a024$export$2f872c0f2117be69;
var $07b2a705ff93a024$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$07b2a705ff93a024$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $07b2a705ff93a024$var$intToCharMap.length) return $07b2a705ff93a024$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$07b2a705ff93a024$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("7vXOe", function(module, exports) {

$parcel$export(module.exports, "getArg", function () { return $5789d27eb1199df9$export$6e45e70adce70bb2; }, function (v) { return $5789d27eb1199df9$export$6e45e70adce70bb2 = v; });
$parcel$export(module.exports, "urlParse", function () { return $5789d27eb1199df9$export$d6e833647f7f5f17; }, function (v) { return $5789d27eb1199df9$export$d6e833647f7f5f17 = v; });
$parcel$export(module.exports, "isAbsolute", function () { return $5789d27eb1199df9$export$e434c7255acda994; }, function (v) { return $5789d27eb1199df9$export$e434c7255acda994 = v; });
$parcel$export(module.exports, "normalize", function () { return $5789d27eb1199df9$export$a3295358bff77e; }, function (v) { return $5789d27eb1199df9$export$a3295358bff77e = v; });
$parcel$export(module.exports, "join", function () { return $5789d27eb1199df9$export$f7e2c8231c57a8bd; }, function (v) { return $5789d27eb1199df9$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "relative", function () { return $5789d27eb1199df9$export$f0e7d1106eeabbe6; }, function (v) { return $5789d27eb1199df9$export$f0e7d1106eeabbe6 = v; });
$parcel$export(module.exports, "toSetString", function () { return $5789d27eb1199df9$export$be0fa1163fa7a4c; }, function (v) { return $5789d27eb1199df9$export$be0fa1163fa7a4c = v; });
$parcel$export(module.exports, "fromSetString", function () { return $5789d27eb1199df9$export$1fc47c3d4c3302a1; }, function (v) { return $5789d27eb1199df9$export$1fc47c3d4c3302a1 = v; });
$parcel$export(module.exports, "compareByOriginalPositions", function () { return $5789d27eb1199df9$export$273077902de92ff2; }, function (v) { return $5789d27eb1199df9$export$273077902de92ff2 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", function () { return $5789d27eb1199df9$export$b7acf533941302f6; }, function (v) { return $5789d27eb1199df9$export$b7acf533941302f6 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", function () { return $5789d27eb1199df9$export$f9c43907549d61f1; }, function (v) { return $5789d27eb1199df9$export$f9c43907549d61f1 = v; });
$parcel$export(module.exports, "parseSourceMapInput", function () { return $5789d27eb1199df9$export$b49e2de2ad542732; }, function (v) { return $5789d27eb1199df9$export$b49e2de2ad542732 = v; });
$parcel$export(module.exports, "computeSourceURL", function () { return $5789d27eb1199df9$export$659a1aa8f1cdc036; }, function (v) { return $5789d27eb1199df9$export$659a1aa8f1cdc036 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $5789d27eb1199df9$export$6e45e70adce70bb2;
var $5789d27eb1199df9$export$d6e833647f7f5f17;
var $5789d27eb1199df9$export$2ec9abc2d2cac192;
var $5789d27eb1199df9$export$a3295358bff77e;
var $5789d27eb1199df9$export$f7e2c8231c57a8bd;
var $5789d27eb1199df9$export$e434c7255acda994;
var $5789d27eb1199df9$export$f0e7d1106eeabbe6;
var $5789d27eb1199df9$export$be0fa1163fa7a4c;
var $5789d27eb1199df9$export$1fc47c3d4c3302a1;
var $5789d27eb1199df9$export$273077902de92ff2;
var $5789d27eb1199df9$export$b7acf533941302f6;
var $5789d27eb1199df9$export$f9c43907549d61f1;
var $5789d27eb1199df9$export$b49e2de2ad542732;
var $5789d27eb1199df9$export$659a1aa8f1cdc036;
function $5789d27eb1199df9$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$5789d27eb1199df9$export$6e45e70adce70bb2 = $5789d27eb1199df9$var$getArg;
var $5789d27eb1199df9$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $5789d27eb1199df9$var$dataUrlRegexp = /^data:.+\,.+$/;
function $5789d27eb1199df9$var$urlParse(aUrl) {
    var match = aUrl.match($5789d27eb1199df9$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$5789d27eb1199df9$export$d6e833647f7f5f17 = $5789d27eb1199df9$var$urlParse;
function $5789d27eb1199df9$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$5789d27eb1199df9$export$2ec9abc2d2cac192 = $5789d27eb1199df9$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $5789d27eb1199df9$var$normalize(aPath) {
    var path = aPath;
    var url = $5789d27eb1199df9$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $5789d27eb1199df9$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $5789d27eb1199df9$var$urlGenerate(url);
    }
    return path;
}
$5789d27eb1199df9$export$a3295358bff77e = $5789d27eb1199df9$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $5789d27eb1199df9$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $5789d27eb1199df9$var$urlParse(aPath);
    var aRootUrl = $5789d27eb1199df9$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $5789d27eb1199df9$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($5789d27eb1199df9$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $5789d27eb1199df9$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $5789d27eb1199df9$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $5789d27eb1199df9$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$5789d27eb1199df9$export$f7e2c8231c57a8bd = $5789d27eb1199df9$var$join;
$5789d27eb1199df9$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || $5789d27eb1199df9$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $5789d27eb1199df9$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$5789d27eb1199df9$export$f0e7d1106eeabbe6 = $5789d27eb1199df9$var$relative;
var $5789d27eb1199df9$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $5789d27eb1199df9$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $5789d27eb1199df9$var$toSetString(aStr) {
    if ($5789d27eb1199df9$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$5789d27eb1199df9$export$be0fa1163fa7a4c = $5789d27eb1199df9$var$supportsNullProto ? $5789d27eb1199df9$var$identity : $5789d27eb1199df9$var$toSetString;
function $5789d27eb1199df9$var$fromSetString(aStr) {
    if ($5789d27eb1199df9$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$5789d27eb1199df9$export$1fc47c3d4c3302a1 = $5789d27eb1199df9$var$supportsNullProto ? $5789d27eb1199df9$var$identity : $5789d27eb1199df9$var$fromSetString;
function $5789d27eb1199df9$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $5789d27eb1199df9$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $5789d27eb1199df9$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $5789d27eb1199df9$var$strcmp(mappingA.name, mappingB.name);
}
$5789d27eb1199df9$export$273077902de92ff2 = $5789d27eb1199df9$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $5789d27eb1199df9$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $5789d27eb1199df9$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $5789d27eb1199df9$var$strcmp(mappingA.name, mappingB.name);
}
$5789d27eb1199df9$export$b7acf533941302f6 = $5789d27eb1199df9$var$compareByGeneratedPositionsDeflated;
function $5789d27eb1199df9$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $5789d27eb1199df9$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $5789d27eb1199df9$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $5789d27eb1199df9$var$strcmp(mappingA.name, mappingB.name);
}
$5789d27eb1199df9$export$f9c43907549d61f1 = $5789d27eb1199df9$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $5789d27eb1199df9$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
}
$5789d27eb1199df9$export$b49e2de2ad542732 = $5789d27eb1199df9$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $5789d27eb1199df9$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || "";
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") sourceRoot += "/";
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $5789d27eb1199df9$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf("/");
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $5789d27eb1199df9$var$join($5789d27eb1199df9$var$urlGenerate(parsed), sourceURL);
    }
    return $5789d27eb1199df9$var$normalize(sourceURL);
}
$5789d27eb1199df9$export$659a1aa8f1cdc036 = $5789d27eb1199df9$var$computeSourceURL;

});

parcelRegister("kSonN", function(module, exports) {

$parcel$export(module.exports, "ArraySet", function () { return $f32bc3bc31b8b191$export$605bbf5ea7b60ba3; }, function (v) { return $f32bc3bc31b8b191$export$605bbf5ea7b60ba3 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $f32bc3bc31b8b191$export$605bbf5ea7b60ba3;

var $7vXOe = parcelRequire("7vXOe");
var $f32bc3bc31b8b191$var$has = Object.prototype.hasOwnProperty;
var $f32bc3bc31b8b191$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $f32bc3bc31b8b191$var$ArraySet() {
    this._array = [];
    this._set = $f32bc3bc31b8b191$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $f32bc3bc31b8b191$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $f32bc3bc31b8b191$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.size = function ArraySet_size() {
    return $f32bc3bc31b8b191$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $f32bc3bc31b8b191$var$hasNativeMap ? aStr : $7vXOe.toSetString(aStr);
    var isDuplicate = $f32bc3bc31b8b191$var$hasNativeMap ? this.has(aStr) : $f32bc3bc31b8b191$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($f32bc3bc31b8b191$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($f32bc3bc31b8b191$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $7vXOe.toSetString(aStr);
        return $f32bc3bc31b8b191$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($f32bc3bc31b8b191$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $7vXOe.toSetString(aStr);
        if ($f32bc3bc31b8b191$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $f32bc3bc31b8b191$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$f32bc3bc31b8b191$export$605bbf5ea7b60ba3 = $f32bc3bc31b8b191$var$ArraySet;

});

parcelRegister("9dDOy", function(module, exports) {

$parcel$export(module.exports, "MappingList", function () { return $6b643645e5a39496$export$e82e0908843dd951; }, function (v) { return $6b643645e5a39496$export$e82e0908843dd951 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $6b643645e5a39496$export$e82e0908843dd951;

var $7vXOe = parcelRequire("7vXOe");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $6b643645e5a39496$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $7vXOe.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $6b643645e5a39496$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $6b643645e5a39496$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $6b643645e5a39496$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($6b643645e5a39496$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $6b643645e5a39496$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($7vXOe.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$6b643645e5a39496$export$e82e0908843dd951 = $6b643645e5a39496$var$MappingList;

});


parcelRegister("kw68d", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", function () { return $eefb8d6af95c5a84$export$194e92554d04abdd; }, function (v) { return $eefb8d6af95c5a84$export$194e92554d04abdd = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $eefb8d6af95c5a84$export$194e92554d04abdd;
var $eefb8d6af95c5a84$export$bef6691594139a79;
var $eefb8d6af95c5a84$export$823525094e5b803c;

var $7vXOe = parcelRequire("7vXOe");

var $6rPeb = parcelRequire("6rPeb");

var $kSonN = parcelRequire("kSonN");
var $eefb8d6af95c5a84$require$ArraySet = $kSonN.ArraySet;

var $hFoZM = parcelRequire("hFoZM");

var $jUFsS = parcelRequire("jUFsS");
var $eefb8d6af95c5a84$require$quickSort = $jUFsS.quickSort;
function $eefb8d6af95c5a84$var$SourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $7vXOe.parseSourceMapInput(aSourceMap);
    return sourceMap.sections != null ? new $eefb8d6af95c5a84$var$IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new $eefb8d6af95c5a84$var$BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}
$eefb8d6af95c5a84$var$SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
    return $eefb8d6af95c5a84$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $eefb8d6af95c5a84$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$eefb8d6af95c5a84$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($eefb8d6af95c5a84$var$SourceMapConsumer.prototype, "_generatedMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$eefb8d6af95c5a84$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($eefb8d6af95c5a84$var$SourceMapConsumer.prototype, "_originalMappings", {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$eefb8d6af95c5a84$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $eefb8d6af95c5a84$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$eefb8d6af95c5a84$var$SourceMapConsumer.GENERATED_ORDER = 1;
$eefb8d6af95c5a84$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$eefb8d6af95c5a84$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$eefb8d6af95c5a84$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $eefb8d6af95c5a84$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $eefb8d6af95c5a84$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $eefb8d6af95c5a84$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $eefb8d6af95c5a84$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        source = $7vXOe.computeSourceURL(sourceRoot, source, this._sourceMapURL);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */ $eefb8d6af95c5a84$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $7vXOe.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $7vXOe.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $7vXOe.getArg(aArgs, "column", 0)
    };
    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) return [];
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $7vXOe.compareByOriginalPositions, $6rPeb.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $7vXOe.getArg(mapping, "generatedLine", null),
                    column: $7vXOe.getArg(mapping, "generatedColumn", null),
                    lastColumn: $7vXOe.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $7vXOe.getArg(mapping, "generatedLine", null),
                    column: $7vXOe.getArg(mapping, "generatedColumn", null),
                    lastColumn: $7vXOe.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$eefb8d6af95c5a84$export$194e92554d04abdd = $eefb8d6af95c5a84$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $eefb8d6af95c5a84$var$BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $7vXOe.parseSourceMapInput(aSourceMap);
    var version = $7vXOe.getArg(sourceMap, "version");
    var sources = $7vXOe.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $7vXOe.getArg(sourceMap, "names", []);
    var sourceRoot = $7vXOe.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $7vXOe.getArg(sourceMap, "sourcesContent", null);
    var mappings = $7vXOe.getArg(sourceMap, "mappings");
    var file = $7vXOe.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    if (sourceRoot) sourceRoot = $7vXOe.normalize(sourceRoot);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($7vXOe.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $7vXOe.isAbsolute(sourceRoot) && $7vXOe.isAbsolute(source) ? $7vXOe.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $eefb8d6af95c5a84$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $eefb8d6af95c5a84$require$ArraySet.fromArray(sources, true);
    this._absoluteSources = this._sources.toArray().map(function(s) {
        return $7vXOe.computeSourceURL(sourceRoot, s, aSourceMapURL);
    });
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this._sourceMapURL = aSourceMapURL;
    this.file = file;
}
$eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype = Object.create($eefb8d6af95c5a84$var$SourceMapConsumer.prototype);
$eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.consumer = $eefb8d6af95c5a84$var$SourceMapConsumer;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $7vXOe.relative(this.sourceRoot, relativeSource);
    if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
    // Maybe aSource is an absolute URL as returned by |sources|.  In
    // this case we can't simply undo the transform.
    var i;
    for(i = 0; i < this._absoluteSources.length; ++i){
        if (this._absoluteSources[i] == aSource) return i;
    }
    return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create($eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $eefb8d6af95c5a84$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $eefb8d6af95c5a84$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function(s) {
        return $7vXOe.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $eefb8d6af95c5a84$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $eefb8d6af95c5a84$require$quickSort(smc.__originalMappings, $7vXOe.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._absoluteSources.slice();
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $eefb8d6af95c5a84$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $eefb8d6af95c5a84$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $hFoZM.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $eefb8d6af95c5a84$require$quickSort(generatedMappings, $7vXOe.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $eefb8d6af95c5a84$require$quickSort(originalMappings, $7vXOe.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $6rPeb.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $7vXOe.getArg(aArgs, "line"),
        generatedColumn: $7vXOe.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $7vXOe.compareByGeneratedPositionsDeflated, $7vXOe.getArg(aArgs, "bias", $eefb8d6af95c5a84$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $7vXOe.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                source = $7vXOe.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
            }
            var name = $7vXOe.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $7vXOe.getArg(mapping, "originalLine", null),
                column: $7vXOe.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    var index = this._findSourceIndex(aSource);
    if (index >= 0) return this.sourcesContent[index];
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $7vXOe.relative(this.sourceRoot, relativeSource);
    var url;
    if (this.sourceRoot != null && (url = $7vXOe.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + relativeSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $eefb8d6af95c5a84$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $7vXOe.getArg(aArgs, "source");
    source = this._findSourceIndex(source);
    if (source < 0) return {
        line: null,
        column: null,
        lastColumn: null
    };
    var needle = {
        source: source,
        originalLine: $7vXOe.getArg(aArgs, "line"),
        originalColumn: $7vXOe.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $7vXOe.compareByOriginalPositions, $7vXOe.getArg(aArgs, "bias", $eefb8d6af95c5a84$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $7vXOe.getArg(mapping, "generatedLine", null),
            column: $7vXOe.getArg(mapping, "generatedColumn", null),
            lastColumn: $7vXOe.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$eefb8d6af95c5a84$export$bef6691594139a79 = $eefb8d6af95c5a84$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $eefb8d6af95c5a84$var$IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = $7vXOe.parseSourceMapInput(aSourceMap);
    var version = $7vXOe.getArg(sourceMap, "version");
    var sections = $7vXOe.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $eefb8d6af95c5a84$require$ArraySet();
    this._names = new $eefb8d6af95c5a84$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $7vXOe.getArg(s, "offset");
        var offsetLine = $7vXOe.getArg(offset, "line");
        var offsetColumn = $7vXOe.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $eefb8d6af95c5a84$var$SourceMapConsumer($7vXOe.getArg(s, "map"), aSourceMapURL)
        };
    });
}
$eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype = Object.create($eefb8d6af95c5a84$var$SourceMapConsumer.prototype);
$eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype.constructor = $eefb8d6af95c5a84$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $7vXOe.getArg(aArgs, "line"),
        generatedColumn: $7vXOe.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $6rPeb.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer._findSourceIndex($7vXOe.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $eefb8d6af95c5a84$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            source = $7vXOe.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = null;
            if (mapping.name) {
                name = section.consumer._names.at(mapping.name);
                this._names.add(name);
                name = this._names.indexOf(name);
            }
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $eefb8d6af95c5a84$require$quickSort(this.__generatedMappings, $7vXOe.compareByGeneratedPositionsDeflated);
    $eefb8d6af95c5a84$require$quickSort(this.__originalMappings, $7vXOe.compareByOriginalPositions);
};
$eefb8d6af95c5a84$export$823525094e5b803c = $eefb8d6af95c5a84$var$IndexedSourceMapConsumer;

});
parcelRegister("6rPeb", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", function () { return $4b1d007a15b8a6fa$export$4ecd616dce182dff; }, function (v) { return $4b1d007a15b8a6fa$export$4ecd616dce182dff = v; });
$parcel$export(module.exports, "LEAST_UPPER_BOUND", function () { return $4b1d007a15b8a6fa$export$b99fbecff261243; }, function (v) { return $4b1d007a15b8a6fa$export$b99fbecff261243 = v; });
$parcel$export(module.exports, "search", function () { return $4b1d007a15b8a6fa$export$d76128d007d19019; }, function (v) { return $4b1d007a15b8a6fa$export$d76128d007d19019 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $4b1d007a15b8a6fa$export$4ecd616dce182dff;
var $4b1d007a15b8a6fa$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $4b1d007a15b8a6fa$export$d76128d007d19019;
$4b1d007a15b8a6fa$export$4ecd616dce182dff = 1;
$4b1d007a15b8a6fa$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $4b1d007a15b8a6fa$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $4b1d007a15b8a6fa$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $4b1d007a15b8a6fa$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $4b1d007a15b8a6fa$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $4b1d007a15b8a6fa$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$4b1d007a15b8a6fa$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $4b1d007a15b8a6fa$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $4b1d007a15b8a6fa$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("jUFsS", function(module, exports) {

$parcel$export(module.exports, "quickSort", function () { return $e7f3694fbefb170e$export$866270269b9544a5; }, function (v) { return $e7f3694fbefb170e$export$866270269b9544a5 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $e7f3694fbefb170e$export$866270269b9544a5;
function $e7f3694fbefb170e$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $e7f3694fbefb170e$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $e7f3694fbefb170e$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $e7f3694fbefb170e$var$randomIntInRange(p, r);
        var i = p - 1;
        $e7f3694fbefb170e$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $e7f3694fbefb170e$var$swap(ary, i, j);
        }
        $e7f3694fbefb170e$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $e7f3694fbefb170e$var$doQuickSort(ary, comparator, p, q - 1);
        $e7f3694fbefb170e$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$e7f3694fbefb170e$export$866270269b9544a5 = function(ary, comparator) {
    $e7f3694fbefb170e$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});


parcelRegister("xYwuS", function(module, exports) {

$parcel$export(module.exports, "SourceNode", function () { return $066207d15f7e73fe$export$7e987e8f375d24c2; }, function (v) { return $066207d15f7e73fe$export$7e987e8f375d24c2 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $066207d15f7e73fe$export$7e987e8f375d24c2;

var $8R90Q = parcelRequire("8R90Q");
var $066207d15f7e73fe$require$SourceMapGenerator = $8R90Q.SourceMapGenerator;

var $7vXOe = parcelRequire("7vXOe");
// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var $066207d15f7e73fe$var$REGEX_NEWLINE = /(\r?\n)/;
// Newline character code for charCodeAt() comparisons
var $066207d15f7e73fe$var$NEWLINE_CODE = 10;
// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var $066207d15f7e73fe$var$isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */ function $066207d15f7e73fe$var$SourceNode(aLine, aColumn, aSource, aChunks, aName) {
    this.children = [];
    this.sourceContents = {};
    this.line = aLine == null ? null : aLine;
    this.column = aColumn == null ? null : aColumn;
    this.source = aSource == null ? null : aSource;
    this.name = aName == null ? null : aName;
    this[$066207d15f7e73fe$var$isSourceNode] = true;
    if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */ $066207d15f7e73fe$var$SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new $066207d15f7e73fe$var$SourceNode();
    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split($066207d15f7e73fe$var$REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
        var lineContents = getNextLine();
        // The last line of a file might not have a newline.
        var newLine = getNextLine() || "";
        return lineContents + newLine;
        function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
        }
    };
    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;
    aSourceMapConsumer.eachMapping(function(mapping) {
        if (lastMapping !== null) {
            // We add the code from "lastMapping" to "mapping":
            // First check if there is a new line in between.
            if (lastGeneratedLine < mapping.generatedLine) {
                // Associate first line with "lastMapping"
                addMappingWithCode(lastMapping, shiftNextLine());
                lastGeneratedLine++;
                lastGeneratedColumn = 0;
            // The remaining code is added without mapping
            } else {
                // There is no new line in between.
                // Associate the code between "lastGeneratedColumn" and
                // "mapping.generatedColumn" with "lastMapping"
                var nextLine = remainingLines[remainingLinesIndex] || "";
                var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
                remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
                lastGeneratedColumn = mapping.generatedColumn;
                addMappingWithCode(lastMapping, code);
                // No more remaining code, continue
                lastMapping = mapping;
                return;
            }
        }
        // We add the generated code until the first mapping
        // to the SourceNode without any mapping.
        // Each line is added as separate string.
        while(lastGeneratedLine < mapping.generatedLine){
            node.add(shiftNextLine());
            lastGeneratedLine++;
        }
        if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex] || "";
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
        }
        lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
        if (lastMapping) // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        // and add the remaining lines without any mapping
        node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }
    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aRelativePath != null) sourceFile = $7vXOe.join(aRelativePath, sourceFile);
            node.setSourceContent(sourceFile, content);
        }
    });
    return node;
    function addMappingWithCode(mapping, code) {
        if (mapping === null || mapping.source === undefined) node.add(code);
        else {
            var source = aRelativePath ? $7vXOe.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new $066207d15f7e73fe$var$SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
        }
    }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $066207d15f7e73fe$var$SourceNode.prototype.add = function SourceNode_add(aChunk) {
    if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
        this.add(chunk);
    }, this);
    else if (aChunk[$066207d15f7e73fe$var$isSourceNode] || typeof aChunk === "string") {
        if (aChunk) this.children.push(aChunk);
    } else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $066207d15f7e73fe$var$SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
    if (Array.isArray(aChunk)) for(var i = aChunk.length - 1; i >= 0; i--)this.prepend(aChunk[i]);
    else if (aChunk[$066207d15f7e73fe$var$isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
    else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */ $066207d15f7e73fe$var$SourceNode.prototype.walk = function SourceNode_walk(aFn) {
    var chunk;
    for(var i = 0, len = this.children.length; i < len; i++){
        chunk = this.children[i];
        if (chunk[$066207d15f7e73fe$var$isSourceNode]) chunk.walk(aFn);
        else if (chunk !== "") aFn(chunk, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
        });
    }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */ $066207d15f7e73fe$var$SourceNode.prototype.join = function SourceNode_join(aSep) {
    var newChildren;
    var i;
    var len = this.children.length;
    if (len > 0) {
        newChildren = [];
        for(i = 0; i < len - 1; i++){
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
        }
        newChildren.push(this.children[i]);
        this.children = newChildren;
    }
    return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */ $066207d15f7e73fe$var$SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
    var lastChild = this.children[this.children.length - 1];
    if (lastChild[$066207d15f7e73fe$var$isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
    else if (typeof lastChild === "string") this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
    else this.children.push("".replace(aPattern, aReplacement));
    return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */ $066207d15f7e73fe$var$SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[$7vXOe.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */ $066207d15f7e73fe$var$SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
    for(var i = 0, len = this.children.length; i < len; i++)if (this.children[i][$066207d15f7e73fe$var$isSourceNode]) this.children[i].walkSourceContents(aFn);
    var sources = Object.keys(this.sourceContents);
    for(var i = 0, len = sources.length; i < len; i++)aFn($7vXOe.fromSetString(sources[i]), this.sourceContents[sources[i]]);
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */ $066207d15f7e73fe$var$SourceNode.prototype.toString = function SourceNode_toString() {
    var str = "";
    this.walk(function(chunk) {
        str += chunk;
    });
    return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */ $066207d15f7e73fe$var$SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
    var generated = {
        code: "",
        line: 1,
        column: 0
    };
    var map = new $066207d15f7e73fe$require$SourceMapGenerator(aArgs);
    var sourceMappingActive = false;
    var lastOriginalSource = null;
    var lastOriginalLine = null;
    var lastOriginalColumn = null;
    var lastOriginalName = null;
    this.walk(function(chunk, original) {
        generated.code += chunk;
        if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
        } else if (sourceMappingActive) {
            map.addMapping({
                generated: {
                    line: generated.line,
                    column: generated.column
                }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
        }
        for(var idx = 0, length = chunk.length; idx < length; idx++)if (chunk.charCodeAt(idx) === $066207d15f7e73fe$var$NEWLINE_CODE) {
            generated.line++;
            generated.column = 0;
            // Mappings end at eol
            if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
            } else if (sourceMappingActive) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
        } else generated.column++;
    });
    this.walkSourceContents(function(sourceFile, sourceContent) {
        map.setSourceContent(sourceFile, sourceContent);
    });
    return {
        code: generated.code,
        map: map
    };
};
$066207d15f7e73fe$export$7e987e8f375d24c2 = $066207d15f7e73fe$var$SourceNode;

});





parcelRegister("cGHmm", function(module, exports) {

$parcel$export(module.exports, "Fancybox", function () { return $93cb0a9ece8ab271$export$cb45b08d97cdc4fd; });
const $93cb0a9ece8ab271$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $93cb0a9ece8ab271$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $93cb0a9ece8ab271$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($93cb0a9ece8ab271$var$e(t) ? t : $93cb0a9ece8ab271$var$i(t.parentElement, n));
}, $93cb0a9ece8ab271$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $93cb0a9ece8ab271$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $93cb0a9ece8ab271$var$o = (t, e, i)=>{
    t && $93cb0a9ece8ab271$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $93cb0a9ece8ab271$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $93cb0a9ece8ab271$var$r = {
    passive: !1
};
class $93cb0a9ece8ab271$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $93cb0a9ece8ab271$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $93cb0a9ece8ab271$var$r), this.element.addEventListener("touchmove", this.onMove, $93cb0a9ece8ab271$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $93cb0a9ece8ab271$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $93cb0a9ece8ab271$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $93cb0a9ece8ab271$var$a(t)) : [
            new $93cb0a9ece8ab271$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $93cb0a9ece8ab271$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $93cb0a9ece8ab271$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $93cb0a9ece8ab271$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $93cb0a9ece8ab271$var$r), this.element.removeEventListener("touchmove", this.onMove, $93cb0a9ece8ab271$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $93cb0a9ece8ab271$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $93cb0a9ece8ab271$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $93cb0a9ece8ab271$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $93cb0a9ece8ab271$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $93cb0a9ece8ab271$var$d(i) ? Object.assign(t[e], $93cb0a9ece8ab271$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $93cb0a9ece8ab271$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $93cb0a9ece8ab271$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $93cb0a9ece8ab271$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $93cb0a9ece8ab271$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $93cb0a9ece8ab271$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $93cb0a9ece8ab271$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($93cb0a9ece8ab271$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $93cb0a9ece8ab271$var$g extends $93cb0a9ece8ab271$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $93cb0a9ece8ab271$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($93cb0a9ece8ab271$var$m || ($93cb0a9ece8ab271$var$m = {}));
const $93cb0a9ece8ab271$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $93cb0a9ece8ab271$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $93cb0a9ece8ab271$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $93cb0a9ece8ab271$var$b
}, $93cb0a9ece8ab271$var$w = '<circle cx="25" cy="25" r="20"></circle>', $93cb0a9ece8ab271$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $93cb0a9ece8ab271$var$w + $93cb0a9ece8ab271$var$w + "</svg></div>", $93cb0a9ece8ab271$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $93cb0a9ece8ab271$var$S = (t, e)=>{
    t && $93cb0a9ece8ab271$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $93cb0a9ece8ab271$var$P = (t, e)=>{
    t && $93cb0a9ece8ab271$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $93cb0a9ece8ab271$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $93cb0a9ece8ab271$var$T = 1e5, $93cb0a9ece8ab271$var$M = 1e4, $93cb0a9ece8ab271$var$O = "mousemove", $93cb0a9ece8ab271$var$A = "drag", $93cb0a9ece8ab271$var$L = "content", $93cb0a9ece8ab271$var$z = "auto";
let $93cb0a9ece8ab271$var$R = null, $93cb0a9ece8ab271$var$k = null;
class $93cb0a9ece8ab271$export$b704d075ddd20210 extends $93cb0a9ece8ab271$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $93cb0a9ece8ab271$var$k && ($93cb0a9ece8ab271$var$k = window.matchMedia("(hover: none)").matches), $93cb0a9ece8ab271$var$k;
    }
    get isMobile() {
        return null === $93cb0a9ece8ab271$var$R && ($93cb0a9ece8ab271$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $93cb0a9ece8ab271$var$R;
    }
    get panMode() {
        return this.options.panMode !== $93cb0a9ece8ab271$var$O || this.isTouchDevice ? $93cb0a9ece8ab271$var$A : $93cb0a9ece8ab271$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $93cb0a9ece8ab271$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $93cb0a9ece8ab271$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $93cb0a9ece8ab271$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $93cb0a9ece8ab271$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $93cb0a9ece8ab271$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $93cb0a9ece8ab271$var$n($93cb0a9ece8ab271$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($93cb0a9ece8ab271$var$L);
        let i = this.option($93cb0a9ece8ab271$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $93cb0a9ece8ab271$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $93cb0a9ece8ab271$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $93cb0a9ece8ab271$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $93cb0a9ece8ab271$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $93cb0a9ece8ab271$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($93cb0a9ece8ab271$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($93cb0a9ece8ab271$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $93cb0a9ece8ab271$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $93cb0a9ece8ab271$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $93cb0a9ece8ab271$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $93cb0a9ece8ab271$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $93cb0a9ece8ab271$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $93cb0a9ece8ab271$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $93cb0a9ece8ab271$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $93cb0a9ece8ab271$var$t(this.targetScale) <= $93cb0a9ece8ab271$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $93cb0a9ece8ab271$var$h(s[0], s[1]), r = $93cb0a9ece8ab271$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $93cb0a9ece8ab271$var$c(s[0], s[1]), p = $93cb0a9ece8ab271$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $93cb0a9ece8ab271$var$t(this.targetScale) === $93cb0a9ece8ab271$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($93cb0a9ece8ab271$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $93cb0a9ece8ab271$var$t(this.targetScale) === $93cb0a9ece8ab271$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $93cb0a9ece8ab271$var$t(y) === $93cb0a9ece8ab271$var$t(w) && (g = 0), "x" === this.lockedAxis && $93cb0a9ece8ab271$var$t(y) === $93cb0a9ece8ab271$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $93cb0a9ece8ab271$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $93cb0a9ece8ab271$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $93cb0a9ece8ab271$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $93cb0a9ece8ab271$var$S(this.container, "is-scaling"), $93cb0a9ece8ab271$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $93cb0a9ece8ab271$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $93cb0a9ece8ab271$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $93cb0a9ece8ab271$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $93cb0a9ece8ab271$var$C);
        for (const n of $93cb0a9ece8ab271$var$v){
            const s = "e" == n || "f" === n ? $93cb0a9ece8ab271$var$M : $93cb0a9ece8ab271$var$T;
            o[n] = $93cb0a9ece8ab271$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $93cb0a9ece8ab271$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $93cb0a9ece8ab271$var$z, b = this.option("height", g) || $93cb0a9ece8ab271$var$z;
        const y = v === $93cb0a9ece8ab271$var$z, w = b === $93cb0a9ece8ab271$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($93cb0a9ece8ab271$var$t(this.targetScale) < $93cb0a9ece8ab271$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $93cb0a9ece8ab271$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $93cb0a9ece8ab271$var$t(o * n, $93cb0a9ece8ab271$var$M), p = $93cb0a9ece8ab271$var$t(a * n, $93cb0a9ece8ab271$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $93cb0a9ece8ab271$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $93cb0a9ece8ab271$var$A && !!this.option("touch"), p = d && u;
        if (u && ($93cb0a9ece8ab271$var$t(a) < $93cb0a9ece8ab271$var$t(r) && !this.panOnlyZoomed && (p = !0), ($93cb0a9ece8ab271$var$t(s.width, 1) > $93cb0a9ece8ab271$var$t(s.fitWidth, 1) || $93cb0a9ece8ab271$var$t(s.height, 1) > $93cb0a9ece8ab271$var$t(s.fitHeight, 1)) && (p = !0)), $93cb0a9ece8ab271$var$t(s.width * a, 1) < $93cb0a9ece8ab271$var$t(s.fitWidth, 1) && (p = !1), n === $93cb0a9ece8ab271$var$O && (p = !1), $93cb0a9ece8ab271$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $93cb0a9ece8ab271$var$t(l) > $93cb0a9ece8ab271$var$t(a), g = !f && !p && d && $93cb0a9ece8ab271$var$t(l) < $93cb0a9ece8ab271$var$t(a);
        $93cb0a9ece8ab271$var$o(i, this.cn("canZoomIn"), f), $93cb0a9ece8ab271$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $93cb0a9ece8ab271$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $93cb0a9ece8ab271$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $93cb0a9ece8ab271$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $93cb0a9ece8ab271$var$t(y[e], $93cb0a9ece8ab271$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $93cb0a9ece8ab271$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $93cb0a9ece8ab271$var$m.Init ? this.animate() : this.isResting || (this.state = $93cb0a9ece8ab271$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $93cb0a9ece8ab271$var$m.Init || this.state === $93cb0a9ece8ab271$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $93cb0a9ece8ab271$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $93cb0a9ece8ab271$var$S(this.container, "is-scaling"), $93cb0a9ece8ab271$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $93cb0a9ece8ab271$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $93cb0a9ece8ab271$var$P(this.container, "is-animating"), this.isScaling && $93cb0a9ece8ab271$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $93cb0a9ece8ab271$var$O || !e) return;
        if ($93cb0a9ece8ab271$var$t(this.targetScale) <= $93cb0a9ece8ab271$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $93cb0a9ece8ab271$var$m.Destroy || this.state === $93cb0a9ece8ab271$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $93cb0a9ece8ab271$var$t(l) < $93cb0a9ece8ab271$var$t(r) && $93cb0a9ece8ab271$var$t(o) <= $93cb0a9ece8ab271$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $93cb0a9ece8ab271$var$t(l) > $93cb0a9ece8ab271$var$t(a) && $93cb0a9ece8ab271$var$t(o) >= $93cb0a9ece8ab271$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $93cb0a9ece8ab271$var$t(l) !== $93cb0a9ece8ab271$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($93cb0a9ece8ab271$var$t(this.contentRect.width, 1) < $93cb0a9ece8ab271$var$t(this.contentRect.fitWidth, 1) || $93cb0a9ece8ab271$var$t(this.targetScale) < $93cb0a9ece8ab271$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $93cb0a9ece8ab271$var$t(this.targetScale) > $93cb0a9ece8ab271$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $93cb0a9ece8ab271$var$z, originX: i = $93cb0a9ece8ab271$var$z, originY: n = $93cb0a9ece8ab271$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $93cb0a9ece8ab271$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $93cb0a9ece8ab271$var$O && (s = this.pmme || s), s || i === $93cb0a9ece8ab271$var$z || n === $93cb0a9ece8ab271$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $93cb0a9ece8ab271$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $93cb0a9ece8ab271$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $93cb0a9ece8ab271$var$m.Init && this.state !== $93cb0a9ece8ab271$var$m.Destroy) {
            this.stop("current");
            for (const t of $93cb0a9ece8ab271$var$v)this.target[t] = $93cb0a9ece8ab271$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $93cb0a9ece8ab271$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $93cb0a9ece8ab271$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($93cb0a9ece8ab271$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$y
}), Object.defineProperty($93cb0a9ece8ab271$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $93cb0a9ece8ab271$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $93cb0a9ece8ab271$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $93cb0a9ece8ab271$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $93cb0a9ece8ab271$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($93cb0a9ece8ab271$var$B || ($93cb0a9ece8ab271$var$B = {}));
const $93cb0a9ece8ab271$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $93cb0a9ece8ab271$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $93cb0a9ece8ab271$var$_ extends $93cb0a9ece8ab271$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $93cb0a9ece8ab271$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $93cb0a9ece8ab271$var$W extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $93cb0a9ece8ab271$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $93cb0a9ece8ab271$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($93cb0a9ece8ab271$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $93cb0a9ece8ab271$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$93cb0a9ece8ab271$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $93cb0a9ece8ab271$var$P(t, this.cn("isPrev")), $93cb0a9ece8ab271$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $93cb0a9ece8ab271$var$P(i, this.cn("isNext")), $93cb0a9ece8ab271$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $93cb0a9ece8ab271$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $93cb0a9ece8ab271$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$$
});
const $93cb0a9ece8ab271$var$X = "disabled", $93cb0a9ece8ab271$var$q = "next", $93cb0a9ece8ab271$var$Y = "prev";
class $93cb0a9ece8ab271$var$V extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($93cb0a9ece8ab271$var$X), s.removeAttribute($93cb0a9ece8ab271$var$X), t.isInfinite || (i <= 0 && n.setAttribute($93cb0a9ece8ab271$var$X, ""), i >= e - 1 && s.setAttribute($93cb0a9ece8ab271$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $93cb0a9ece8ab271$var$P(n, this.cn("button") + " " + this.cn(t === $93cb0a9ece8ab271$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $93cb0a9ece8ab271$var$q ? $93cb0a9ece8ab271$var$Y : $93cb0a9ece8ab271$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $93cb0a9ece8ab271$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($93cb0a9ece8ab271$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($93cb0a9ece8ab271$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $93cb0a9ece8ab271$var$Z extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $93cb0a9ece8ab271$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $93cb0a9ece8ab271$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $93cb0a9ece8ab271$var$B.Ready || i.state !== $93cb0a9ece8ab271$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $93cb0a9ece8ab271$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $93cb0a9ece8ab271$var$U = {
    Navigation: $93cb0a9ece8ab271$var$V,
    Dots: $93cb0a9ece8ab271$var$W,
    Sync: $93cb0a9ece8ab271$var$Z
}, $93cb0a9ece8ab271$var$G = "animationend", $93cb0a9ece8ab271$var$K = "isSelected", $93cb0a9ece8ab271$var$J = "slide";
class $93cb0a9ece8ab271$export$144901db2ea8e967 extends $93cb0a9ece8ab271$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $93cb0a9ece8ab271$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$93cb0a9ece8ab271$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $93cb0a9ece8ab271$var$D(this.slideNext.bind(this), 150), this.slidePrev = $93cb0a9ece8ab271$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $93cb0a9ece8ab271$var$u({}, $93cb0a9ece8ab271$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $93cb0a9ece8ab271$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $93cb0a9ece8ab271$var$d(e) && (n += t, $93cb0a9ece8ab271$var$u(i, e));
        n === this.bp && this.state !== $93cb0a9ece8ab271$var$B.Init || (this.bp = n, this.state === $93cb0a9ece8ab271$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $93cb0a9ece8ab271$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $93cb0a9ece8ab271$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $93cb0a9ece8ab271$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $93cb0a9ece8ab271$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $93cb0a9ece8ab271$var$P(t, this.cn("container")), $93cb0a9ece8ab271$var$o(t, e.isLTR, !this.isRTL), $93cb0a9ece8ab271$var$o(t, e.isRTL, this.isRTL), $93cb0a9ece8ab271$var$o(t, e.isVertical, !this.isHorizontal), $93cb0a9ece8ab271$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $93cb0a9ece8ab271$var$P(i, e.viewport), i.append(...$93cb0a9ece8ab271$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $93cb0a9ece8ab271$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$93cb0a9ece8ab271$var$F(t, `.${this.cn($93cb0a9ece8ab271$var$J)}`)
        ].forEach((t)=>{
            if ($93cb0a9ece8ab271$var$E(t)) {
                const e = $93cb0a9ece8ab271$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($93cb0a9ece8ab271$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $93cb0a9ece8ab271$export$b704d075ddd20210(this.viewport, $93cb0a9ece8ab271$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($93cb0a9ece8ab271$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $93cb0a9ece8ab271$var$t(e.pos, 1e3), e.dim = $93cb0a9ece8ab271$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $93cb0a9ece8ab271$var$P(r, this.cn($93cb0a9ece8ab271$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $93cb0a9ece8ab271$var$t(o, 1e3),
            gap: $93cb0a9ece8ab271$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$93cb0a9ece8ab271$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($93cb0a9ece8ab271$var$t(i.pos) < $93cb0a9ece8ab271$var$t(a) && $93cb0a9ece8ab271$var$t(i.pos + i.dim + i.gap) < $93cb0a9ece8ab271$var$t(g) && $93cb0a9ece8ab271$var$t(g) > $93cb0a9ece8ab271$var$t(r - a) && (i.el.style[e] = `${$93cb0a9ece8ab271$var$t(p + f, 1e3)}px`), $93cb0a9ece8ab271$var$t(i.pos + i.gap) >= $93cb0a9ece8ab271$var$t(r - a) && $93cb0a9ece8ab271$var$t(i.pos) > $93cb0a9ece8ab271$var$t(g + a) && $93cb0a9ece8ab271$var$t(g) < $93cb0a9ece8ab271$var$t(a) && (i.el.style[e] = `-${$93cb0a9ece8ab271$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$93cb0a9ece8ab271$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $93cb0a9ece8ab271$var$P(n, this.cn($93cb0a9ece8ab271$var$J)), $93cb0a9ece8ab271$var$P(n, t.class), $93cb0a9ece8ab271$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($93cb0a9ece8ab271$var$K);
        if (i.classList.contains(n) && ($93cb0a9ece8ab271$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($93cb0a9ece8ab271$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $93cb0a9ece8ab271$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $93cb0a9ece8ab271$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($93cb0a9ece8ab271$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($93cb0a9ece8ab271$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($93cb0a9ece8ab271$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($93cb0a9ece8ab271$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($93cb0a9ece8ab271$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $93cb0a9ece8ab271$var$S(e, o), e.complete && ($93cb0a9ece8ab271$var$P(e, s), setTimeout(()=>{
                $93cb0a9ece8ab271$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $93cb0a9ece8ab271$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $93cb0a9ece8ab271$var$n($93cb0a9ece8ab271$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $93cb0a9ece8ab271$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $93cb0a9ece8ab271$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $93cb0a9ece8ab271$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $93cb0a9ece8ab271$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($93cb0a9ece8ab271$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($93cb0a9ece8ab271$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $93cb0a9ece8ab271$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $93cb0a9ece8ab271$var$t(n, 1e3), o = $93cb0a9ece8ab271$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $93cb0a9ece8ab271$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $93cb0a9ece8ab271$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $93cb0a9ece8ab271$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $93cb0a9ece8ab271$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $93cb0a9ece8ab271$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $93cb0a9ece8ab271$var$m.Init && n.state !== $93cb0a9ece8ab271$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $93cb0a9ece8ab271$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $93cb0a9ece8ab271$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($93cb0a9ece8ab271$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$export$b704d075ddd20210
}), Object.defineProperty($93cb0a9ece8ab271$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$j
}), Object.defineProperty($93cb0a9ece8ab271$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$U
});
const $93cb0a9ece8ab271$var$tt = function(t) {
    if (!$93cb0a9ece8ab271$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $93cb0a9ece8ab271$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $93cb0a9ece8ab271$var$it;
const $93cb0a9ece8ab271$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $93cb0a9ece8ab271$var$st = (t)=>{
    if (t && $93cb0a9ece8ab271$var$et) {
        void 0 === $93cb0a9ece8ab271$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $93cb0a9ece8ab271$var$it = !0, !1;
            }
        });
        try {
            if ($93cb0a9ece8ab271$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $93cb0a9ece8ab271$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $93cb0a9ece8ab271$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $93cb0a9ece8ab271$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $93cb0a9ece8ab271$var$rt, $93cb0a9ece8ab271$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($93cb0a9ece8ab271$var$rt || ($93cb0a9ece8ab271$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($93cb0a9ece8ab271$var$lt || ($93cb0a9ece8ab271$var$lt = {}));
let $93cb0a9ece8ab271$var$ct = "", $93cb0a9ece8ab271$var$ht = !1, $93cb0a9ece8ab271$var$dt = !1, $93cb0a9ece8ab271$var$ut = null;
const $93cb0a9ece8ab271$var$pt = ()=>{
    let t = "", e = "";
    const i = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $93cb0a9ece8ab271$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $93cb0a9ece8ab271$var$gt = ()=>{
    const { slug: t, index: e } = $93cb0a9ece8ab271$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $93cb0a9ece8ab271$var$mt = ()=>{
    if (!1 === $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $93cb0a9ece8ab271$var$ft(), { slug: n } = $93cb0a9ece8ab271$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($93cb0a9ece8ab271$var$ht = !0, t.close())), $93cb0a9ece8ab271$var$gt();
}, $93cb0a9ece8ab271$var$vt = ()=>{
    $93cb0a9ece8ab271$var$ut && clearTimeout($93cb0a9ece8ab271$var$ut), queueMicrotask(()=>{
        $93cb0a9ece8ab271$var$mt();
    });
}, $93cb0a9ece8ab271$var$bt = ()=>{
    window.addEventListener("hashchange", $93cb0a9ece8ab271$var$vt, !1), setTimeout(()=>{
        $93cb0a9ece8ab271$var$mt();
    }, 500);
};
$93cb0a9ece8ab271$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $93cb0a9ece8ab271$var$bt() : document.addEventListener("DOMContentLoaded", $93cb0a9ece8ab271$var$bt));
const $93cb0a9ece8ab271$var$yt = "is-zooming-in";
class $93cb0a9ece8ab271$var$wt extends $93cb0a9ece8ab271$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $93cb0a9ece8ab271$var$S(this.instance.container, $93cb0a9ece8ab271$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $93cb0a9ece8ab271$var$m.Init || a.state === $93cb0a9ece8ab271$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $93cb0a9ece8ab271$var$rt.CustomClosing, i.classList.remove($93cb0a9ece8ab271$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $93cb0a9ece8ab271$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $93cb0a9ece8ab271$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($93cb0a9ece8ab271$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $93cb0a9ece8ab271$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $93cb0a9ece8ab271$var$n(l)), !l || !$93cb0a9ece8ab271$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $93cb0a9ece8ab271$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $93cb0a9ece8ab271$export$b704d075ddd20210(r, $93cb0a9ece8ab271$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $93cb0a9ece8ab271$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($93cb0a9ece8ab271$var$S(s, $93cb0a9ece8ab271$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $93cb0a9ece8ab271$var$P(s, $93cb0a9ece8ab271$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $93cb0a9ece8ab271$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $93cb0a9ece8ab271$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $93cb0a9ece8ab271$var$xt = "html", $93cb0a9ece8ab271$var$Et = "image", $93cb0a9ece8ab271$var$St = "map", $93cb0a9ece8ab271$var$Pt = "youtube", $93cb0a9ece8ab271$var$Ct = "vimeo", $93cb0a9ece8ab271$var$Tt = "html5video", $93cb0a9ece8ab271$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $93cb0a9ece8ab271$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $93cb0a9ece8ab271$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $93cb0a9ece8ab271$var$Lt extends $93cb0a9ece8ab271$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $93cb0a9ece8ab271$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $93cb0a9ece8ab271$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $93cb0a9ece8ab271$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $93cb0a9ece8ab271$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $93cb0a9ece8ab271$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($93cb0a9ece8ab271$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $93cb0a9ece8ab271$var$Pt || e === $93cb0a9ece8ab271$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($93cb0a9ece8ab271$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $93cb0a9ece8ab271$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $93cb0a9ece8ab271$var$Pt && t.type !== $93cb0a9ece8ab271$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $93cb0a9ece8ab271$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $93cb0a9ece8ab271$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $93cb0a9ece8ab271$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $93cb0a9ece8ab271$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $93cb0a9ece8ab271$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $93cb0a9ece8ab271$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $93cb0a9ece8ab271$var$Mt(e, this.optionFor(t, $93cb0a9ece8ab271$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $93cb0a9ece8ab271$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $93cb0a9ece8ab271$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $93cb0a9ece8ab271$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $93cb0a9ece8ab271$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $93cb0a9ece8ab271$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $93cb0a9ece8ab271$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $93cb0a9ece8ab271$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $93cb0a9ece8ab271$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $93cb0a9ece8ab271$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $93cb0a9ece8ab271$var$St:
                case $93cb0a9ece8ab271$var$Pt:
                case $93cb0a9ece8ab271$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $93cb0a9ece8ab271$var$Pt,
            $93cb0a9ece8ab271$var$Ct,
            $93cb0a9ece8ab271$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$Ot
});
const $93cb0a9ece8ab271$var$zt = "play", $93cb0a9ece8ab271$var$Rt = "pause", $93cb0a9ece8ab271$var$kt = "ready";
class $93cb0a9ece8ab271$var$It extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $93cb0a9ece8ab271$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $93cb0a9ece8ab271$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $93cb0a9ece8ab271$var$zt, $93cb0a9ece8ab271$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $93cb0a9ece8ab271$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $93cb0a9ece8ab271$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $93cb0a9ece8ab271$var$S(i, "has-autoplay"), e !== $93cb0a9ece8ab271$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $93cb0a9ece8ab271$var$zt && (t.state = $93cb0a9ece8ab271$var$Rt, t.clear(), t.emit($93cb0a9ece8ab271$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $93cb0a9ece8ab271$var$zt) {
                if (t.state === $93cb0a9ece8ab271$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $93cb0a9ece8ab271$var$zt || this.state === $93cb0a9ece8ab271$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $93cb0a9ece8ab271$var$Dt extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $93cb0a9ece8ab271$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $93cb0a9ece8ab271$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $93cb0a9ece8ab271$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $93cb0a9ece8ab271$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $93cb0a9ece8ab271$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $93cb0a9ece8ab271$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($93cb0a9ece8ab271$var$jt || ($93cb0a9ece8ab271$var$jt = {}));
const $93cb0a9ece8ab271$var$Bt = "isResting", $93cb0a9ece8ab271$var$Ht = "thumbWidth", $93cb0a9ece8ab271$var$Nt = "thumbHeight", $93cb0a9ece8ab271$var$_t = "thumbClipWidth";
let $93cb0a9ece8ab271$var$$t = class extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$93cb0a9ece8ab271$var$_t] = parseFloat(i[$93cb0a9ece8ab271$var$_t] || "") || e[$93cb0a9ece8ab271$var$_t] || 0, e[$93cb0a9ece8ab271$var$Nt] = parseFloat(i.thumbHeight || "") || e[$93cb0a9ece8ab271$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $93cb0a9ece8ab271$var$S(e, this.cn($93cb0a9ece8ab271$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$93cb0a9ece8ab271$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $93cb0a9ece8ab271$var$o(e, this.cn($93cb0a9ece8ab271$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$93cb0a9ece8ab271$var$Ht] = t[$93cb0a9ece8ab271$var$_t] && t[$93cb0a9ece8ab271$var$Nt] ? Math.round(this[$93cb0a9ece8ab271$var$Nt] * (t[$93cb0a9ece8ab271$var$_t] / t[$93cb0a9ece8ab271$var$Nt])) : this[$93cb0a9ece8ab271$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$93cb0a9ece8ab271$var$Ht] = e("width") || 40, this[$93cb0a9ece8ab271$var$_t] = e("clip-width") || 40, this[$93cb0a9ece8ab271$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $93cb0a9ece8ab271$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $93cb0a9ece8ab271$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $93cb0a9ece8ab271$var$P(l, `is-${s}`), $93cb0a9ece8ab271$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $93cb0a9ece8ab271$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $93cb0a9ece8ab271$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $93cb0a9ece8ab271$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$93cb0a9ece8ab271$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$93cb0a9ece8ab271$var$Ht], a = i[$93cb0a9ece8ab271$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $93cb0a9ece8ab271$var$t(1 - Math.abs(s.getProgress(e))), o = $93cb0a9ece8ab271$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $93cb0a9ece8ab271$var$m.Init || n.state === $93cb0a9ece8ab271$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$93cb0a9ece8ab271$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $93cb0a9ece8ab271$var$jt.Init, $93cb0a9ece8ab271$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $93cb0a9ece8ab271$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($93cb0a9ece8ab271$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$Ft
});
const $93cb0a9ece8ab271$var$Wt = Object.assign(Object.assign({}, $93cb0a9ece8ab271$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $93cb0a9ece8ab271$var$Xt = "is-masked", $93cb0a9ece8ab271$var$qt = "aria-hidden";
class $93cb0a9ece8ab271$var$Yt extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $93cb0a9ece8ab271$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $93cb0a9ece8ab271$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $93cb0a9ece8ab271$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $93cb0a9ece8ab271$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $93cb0a9ece8ab271$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $93cb0a9ece8ab271$var$jt.Hidden ? (t.state = $93cb0a9ece8ab271$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($93cb0a9ece8ab271$var$qt), e.classList.remove($93cb0a9ece8ab271$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($93cb0a9ece8ab271$var$Xt), e.setAttribute($93cb0a9ece8ab271$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $93cb0a9ece8ab271$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$Wt
});
const $93cb0a9ece8ab271$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $93cb0a9ece8ab271$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($93cb0a9ece8ab271$var$Zt || ($93cb0a9ece8ab271$var$Zt = {}));
const $93cb0a9ece8ab271$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $93cb0a9ece8ab271$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $93cb0a9ece8ab271$var$Kt = "has-toolbar", $93cb0a9ece8ab271$var$Jt = "fancybox__toolbar";
class $93cb0a9ece8ab271$var$Qt extends $93cb0a9ece8ab271$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $93cb0a9ece8ab271$var$P(i, $93cb0a9ece8ab271$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $93cb0a9ece8ab271$var$P(r, "is-absolute"), this.state = $93cb0a9ece8ab271$var$Zt.Ready, this.onRefresh();
        } else this.state = $93cb0a9ece8ab271$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $93cb0a9ece8ab271$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $93cb0a9ece8ab271$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $93cb0a9ece8ab271$var$Jt);
        return i || (i = document.createElement("div"), $93cb0a9ece8ab271$var$P(i, $93cb0a9ece8ab271$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $93cb0a9ece8ab271$var$P(t, $93cb0a9ece8ab271$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$93cb0a9ece8ab271$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $93cb0a9ece8ab271$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $93cb0a9ece8ab271$var$Vt[t]) {
            const e = $93cb0a9ece8ab271$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $93cb0a9ece8ab271$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($93cb0a9ece8ab271$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $93cb0a9ece8ab271$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($93cb0a9ece8ab271$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $93cb0a9ece8ab271$var$Zt.Disabled;
        const e = this.instance.container;
        e && $93cb0a9ece8ab271$var$S(e, $93cb0a9ece8ab271$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($93cb0a9ece8ab271$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$Ut
});
const $93cb0a9ece8ab271$var$te = {
    Hash: class extends $93cb0a9ece8ab271$var$_ {
        onReady() {
            $93cb0a9ece8ab271$var$ht = !1;
        }
        onChange(t) {
            $93cb0a9ece8ab271$var$ut && clearTimeout($93cb0a9ece8ab271$var$ut);
            const { hash: e } = $93cb0a9ece8ab271$var$pt(), { hash: i } = $93cb0a9ece8ab271$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($93cb0a9ece8ab271$var$ct = i === e ? "" : i), e && e !== i && ($93cb0a9ece8ab271$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $93cb0a9ece8ab271$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$93cb0a9ece8ab271$var$dt && (t = "pushState", $93cb0a9ece8ab271$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($93cb0a9ece8ab271$var$ut && clearTimeout($93cb0a9ece8ab271$var$ut), !$93cb0a9ece8ab271$var$ht && $93cb0a9ece8ab271$var$dt) return $93cb0a9ece8ab271$var$dt = !1, $93cb0a9ece8ab271$var$ht = !1, void window.history.back();
            if (!$93cb0a9ece8ab271$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($93cb0a9ece8ab271$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $93cb0a9ece8ab271$var$ft();
        }
        static startFromUrl() {
            $93cb0a9ece8ab271$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $93cb0a9ece8ab271$var$vt, !1);
        }
    },
    Html: $93cb0a9ece8ab271$var$Lt,
    Images: $93cb0a9ece8ab271$var$wt,
    Slideshow: $93cb0a9ece8ab271$var$Dt,
    Thumbs: $93cb0a9ece8ab271$var$Yt,
    Toolbar: $93cb0a9ece8ab271$var$Qt
}, $93cb0a9ece8ab271$var$ee = "with-fancybox", $93cb0a9ece8ab271$var$ie = "hide-scrollbar", $93cb0a9ece8ab271$var$ne = "--fancybox-scrollbar-compensate", $93cb0a9ece8ab271$var$se = "--fancybox-body-margin", $93cb0a9ece8ab271$var$oe = "aria-hidden", $93cb0a9ece8ab271$var$ae = "is-using-tab", $93cb0a9ece8ab271$var$re = "is-animated", $93cb0a9ece8ab271$var$le = "is-compact", $93cb0a9ece8ab271$var$ce = "is-loading", $93cb0a9ece8ab271$var$he = "is-opening", $93cb0a9ece8ab271$var$de = "has-caption", $93cb0a9ece8ab271$var$ue = "disabled", $93cb0a9ece8ab271$var$pe = "tabindex", $93cb0a9ece8ab271$var$fe = "download", $93cb0a9ece8ab271$var$ge = "href", $93cb0a9ece8ab271$var$me = "src", $93cb0a9ece8ab271$var$ve = (t)=>"string" == typeof t, $93cb0a9ece8ab271$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $93cb0a9ece8ab271$var$ye, $93cb0a9ece8ab271$var$we = null, $93cb0a9ece8ab271$var$xe = null, $93cb0a9ece8ab271$var$Ee = 0, $93cb0a9ece8ab271$var$Se = 0, $93cb0a9ece8ab271$var$Pe = 0, $93cb0a9ece8ab271$var$Ce = 0;
const $93cb0a9ece8ab271$var$Te = new Map;
let $93cb0a9ece8ab271$var$Me = 0;
class $93cb0a9ece8ab271$export$cb45b08d97cdc4fd extends $93cb0a9ece8ab271$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $93cb0a9ece8ab271$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $93cb0a9ece8ab271$var$ye || ($93cb0a9ece8ab271$var$ye = $93cb0a9ece8ab271$var$ot()), this.id = e.id || ++$93cb0a9ece8ab271$var$Me, $93cb0a9ece8ab271$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $93cb0a9ece8ab271$var$rt.Destroy) return;
        this.state = $93cb0a9ece8ab271$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$93cb0a9ece8ab271$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($93cb0a9ece8ab271$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($93cb0a9ece8ab271$var$ne, `${n}px`), s && e.style.setProperty($93cb0a9ece8ab271$var$se, `${s}px`), e.classList.add($93cb0a9ece8ab271$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $93cb0a9ece8ab271$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($93cb0a9ece8ab271$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $93cb0a9ece8ab271$var$ye && !$93cb0a9ece8ab271$var$ye.isFullscreen() ? $93cb0a9ece8ab271$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $93cb0a9ece8ab271$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($93cb0a9ece8ab271$var$le, this.isCompact), $93cb0a9ece8ab271$var$P(s, this.option("mainClass") || ""), $93cb0a9ece8ab271$var$P(s, $93cb0a9ece8ab271$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $93cb0a9ece8ab271$var$P(document.documentElement, $93cb0a9ece8ab271$var$ee), $93cb0a9ece8ab271$var$we && $93cb0a9ece8ab271$var$xe || ($93cb0a9ece8ab271$var$we = document.createElement("span"), $93cb0a9ece8ab271$var$P($93cb0a9ece8ab271$var$we, "fancybox-focus-guard"), $93cb0a9ece8ab271$var$we.setAttribute($93cb0a9ece8ab271$var$pe, "0"), $93cb0a9ece8ab271$var$we.setAttribute($93cb0a9ece8ab271$var$oe, "true"), $93cb0a9ece8ab271$var$we.setAttribute("aria-label", "Focus guard"), $93cb0a9ece8ab271$var$xe = $93cb0a9ece8ab271$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($93cb0a9ece8ab271$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($93cb0a9ece8ab271$var$xe)), s.addEventListener("mousedown", (t)=>{
                $93cb0a9ece8ab271$var$Ee = t.pageX, $93cb0a9ece8ab271$var$Se = t.pageY, $93cb0a9ece8ab271$var$S(s, $93cb0a9ece8ab271$var$ae);
            }), this.option("closeExisting")) for (const t of $93cb0a9ece8ab271$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($93cb0a9ece8ab271$var$P(s, $93cb0a9ece8ab271$var$re), setTimeout(()=>{
                this.isClosing() || $93cb0a9ece8ab271$var$S(s, $93cb0a9ece8ab271$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $93cb0a9ece8ab271$export$144901db2ea8e967(n, $93cb0a9ece8ab271$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $93cb0a9ece8ab271$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $93cb0a9ece8ab271$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($93cb0a9ece8ab271$var$ue), i.removeAttribute($93cb0a9ece8ab271$var$pe)) : (i.setAttribute($93cb0a9ece8ab271$var$ue, ""), i.setAttribute($93cb0a9ece8ab271$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($93cb0a9ece8ab271$var$ue), i.removeAttribute($93cb0a9ece8ab271$var$pe)) : (i.setAttribute($93cb0a9ece8ab271$var$ue, ""), i.setAttribute($93cb0a9ece8ab271$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$93cb0a9ece8ab271$var$ve(i[$93cb0a9ece8ab271$var$me]) || (n = i[$93cb0a9ece8ab271$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($93cb0a9ece8ab271$var$ue), t.removeAttribute($93cb0a9ece8ab271$var$pe), t.setAttribute($93cb0a9ece8ab271$var$ge, n), t.setAttribute($93cb0a9ece8ab271$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($93cb0a9ece8ab271$var$ue, ""), t.setAttribute($93cb0a9ece8ab271$var$pe, "-1"), t.removeAttribute($93cb0a9ece8ab271$var$ge), t.removeAttribute($93cb0a9ece8ab271$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $93cb0a9ece8ab271$var$Ee) > 30 || Math.abs(t.pageY - $93cb0a9ece8ab271$var$Se) > 30) return;
        const o = document.activeElement;
        if ($93cb0a9ece8ab271$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($93cb0a9ece8ab271$var$nt) || o.blur();
            }
            if ($93cb0a9ece8ab271$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($93cb0a9ece8ab271$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($93cb0a9ece8ab271$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($93cb0a9ece8ab271$var$Pe, $93cb0a9ece8ab271$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $93cb0a9ece8ab271$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $93cb0a9ece8ab271$var$P(this.container, $93cb0a9ece8ab271$var$ae) : $93cb0a9ece8ab271$var$S(this.container, $93cb0a9ece8ab271$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($93cb0a9ece8ab271$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $93cb0a9ece8ab271$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $93cb0a9ece8ab271$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $93cb0a9ece8ab271$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $93cb0a9ece8ab271$var$S(s, $93cb0a9ece8ab271$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $93cb0a9ece8ab271$var$S(t.el, $93cb0a9ece8ab271$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $93cb0a9ece8ab271$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $93cb0a9ece8ab271$var$P(r, $93cb0a9ece8ab271$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $93cb0a9ece8ab271$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $93cb0a9ece8ab271$var$P(s, $93cb0a9ece8ab271$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $93cb0a9ece8ab271$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $93cb0a9ece8ab271$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($93cb0a9ece8ab271$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $93cb0a9ece8ab271$var$xe ? d = c[0] : this.lastFocus !== s && i !== $93cb0a9ece8ab271$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $93cb0a9ece8ab271$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $93cb0a9ece8ab271$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $93cb0a9ece8ab271$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($93cb0a9ece8ab271$var$E(e) ? o = e : (o = $93cb0a9ece8ab271$var$n(e + ""), $93cb0a9ece8ab271$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $93cb0a9ece8ab271$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $93cb0a9ece8ab271$var$E(o) ? ($93cb0a9ece8ab271$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $93cb0a9ece8ab271$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $93cb0a9ece8ab271$var$lt.Ready, this.emit("done", t), $93cb0a9ece8ab271$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($93cb0a9ece8ab271$var$S(this.container, $93cb0a9ece8ab271$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $93cb0a9ece8ab271$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $93cb0a9ece8ab271$var$P(e, $93cb0a9ece8ab271$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $93cb0a9ece8ab271$var$lt.Loading) {
                let i = $93cb0a9ece8ab271$var$n($93cb0a9ece8ab271$var$x);
                $93cb0a9ece8ab271$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($93cb0a9ece8ab271$var$S(e, $93cb0a9ece8ab271$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $93cb0a9ece8ab271$var$lt.Loading && (this.emit("loaded", t), t.state = $93cb0a9ece8ab271$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($93cb0a9ece8ab271$var$S(e, "has-error"), $93cb0a9ece8ab271$var$S(e, "has-unknown"), $93cb0a9ece8ab271$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $93cb0a9ece8ab271$var$ye && $93cb0a9ece8ab271$var$ye.isFullscreen() ? Promise.resolve($93cb0a9ece8ab271$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $93cb0a9ece8ab271$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $93cb0a9ece8ab271$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $93cb0a9ece8ab271$var$ye && ($93cb0a9ece8ab271$var$ye.isFullscreen() ? $93cb0a9ece8ab271$var$ye.exit() : $93cb0a9ece8ab271$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $93cb0a9ece8ab271$var$rt.Closing,
            $93cb0a9ece8ab271$var$rt.CustomClosing,
            $93cb0a9ece8ab271$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $93cb0a9ece8ab271$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($93cb0a9ece8ab271$var$tt(r) ? $93cb0a9ece8ab271$var$st(r) : r.focus()), s && ($93cb0a9ece8ab271$var$S(s, $93cb0a9ece8ab271$var$he), $93cb0a9ece8ab271$var$P(s, "is-closing"), s.setAttribute($93cb0a9ece8ab271$var$oe, "true"), this.option("animated") && $93cb0a9ece8ab271$var$P(s, $93cb0a9ece8ab271$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $93cb0a9ece8ab271$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $93cb0a9ece8ab271$var$Pe = window.scrollX, $93cb0a9ece8ab271$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $93cb0a9ece8ab271$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $93cb0a9ece8ab271$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $93cb0a9ece8ab271$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $93cb0a9ece8ab271$var$Te.delete(this.id);
        const i = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($93cb0a9ece8ab271$var$we && ($93cb0a9ece8ab271$var$we.remove(), $93cb0a9ece8ab271$var$we = null), $93cb0a9ece8ab271$var$xe && ($93cb0a9ece8ab271$var$xe.remove(), $93cb0a9ece8ab271$var$xe = null), $93cb0a9ece8ab271$var$S(document.documentElement, $93cb0a9ece8ab271$var$ee), (()=>{
            if (!$93cb0a9ece8ab271$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($93cb0a9ece8ab271$var$ie), e.style.setProperty($93cb0a9ece8ab271$var$se, ""), t.documentElement.style.setProperty($93cb0a9ece8ab271$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$93cb0a9ece8ab271$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $93cb0a9ece8ab271$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $93cb0a9ece8ab271$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$93cb0a9ece8ab271$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($93cb0a9ece8ab271$var$ve(t) ? (i = document.body, n = t) : (i = t, $93cb0a9ece8ab271$var$ve(e) && (n = e)), !i) return;
        const s = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.fromEvent);
        $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $93cb0a9ece8ab271$var$u({}, $93cb0a9ece8ab271$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($93cb0a9ece8ab271$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $93cb0a9ece8ab271$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $93cb0a9ece8ab271$var$u({}, a.get(s) || {}, o), !!o && $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $93cb0a9ece8ab271$var$u({}, $93cb0a9ece8ab271$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$93cb0a9ece8ab271$var$me] || n.getAttribute($93cb0a9ece8ab271$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($93cb0a9ece8ab271$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$93cb0a9ece8ab271$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$93cb0a9ece8ab271$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $93cb0a9ece8ab271$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $93cb0a9ece8ab271$var$Te.get(t);
        return Array.from($93cb0a9ece8ab271$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $93cb0a9ece8ab271$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $93cb0a9ece8ab271$var$Te.values())t.close(...e);
        else {
            const t = $93cb0a9ece8ab271$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($93cb0a9ece8ab271$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($93cb0a9ece8ab271$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$at
}), Object.defineProperty($93cb0a9ece8ab271$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $93cb0a9ece8ab271$var$te
}), Object.defineProperty($93cb0a9ece8ab271$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});

});

parcelRegister("lhdyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7d5b29e53d61229$export$2e2bcd8739ae039; });

var $hyTiP = parcelRequire("hyTiP");

var $johf1 = parcelRequire("johf1");

var $9UqMq = parcelRequire("9UqMq");
const $f7d5b29e53d61229$var$data = {
    "home1-45547": {
        caption: "\u660E \u900F\u96D5\u87E0\u9F99\u82B1\u5349\u7280\u89D2\u676F",
        thumbnail: $johf1["home1-45547-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-45547-1.jpg"],
                points: []
            }
        ]
    },
    "home1-45546": {
        caption: "\u6E05 \u6731\u5F5D\u5C0A\u8096\u50CF\u7AEF\u781A",
        thumbnail: $johf1["home1-45546-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-45546-1.jpg"],
                points: []
            }
        ]
    },
    "home1-45543": {
        caption: "\u897F\u5468\u4E2D\u671F \u51E4\u9F99\u7EB9\u7389\u9970",
        thumbnail: $johf1["home1-45543-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-45543-1.jpg"],
                points: []
            }
        ]
    },
    "home1-54646": {
        caption: "\u590F \u7389\u748B",
        thumbnail: $johf1["home1-54646-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-54646-1.jpg"],
                points: []
            }
        ]
    },
    "home1-54633": {
        caption: "\u65B0\u77F3\u5668\u65F6\u4EE3 \u7389\u74A7",
        thumbnail: $johf1["home1-54633-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-54633-1.jpg"],
                points: []
            }
        ]
    },
    "home1-54630": {
        caption: "\u5546 \u7389\u621A",
        thumbnail: $johf1["home1-54630-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-54630-1.jpg"],
                points: []
            }
        ]
    },
    "home1-54647": {
        caption: "\u65B0\u77F3\u5668\u65F6\u4EE3 \u7389\u5200",
        thumbnail: $johf1["home1-54647-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-54647-1.jpg"],
                points: []
            }
        ]
    },
    "home1-54655": {
        caption: "\u65B0\u77F3\u5668\u65F6\u4EE3 \u7389\u742E",
        thumbnail: $johf1["home1-54655-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-54655-1.jpg"],
                points: []
            }
        ]
    },
    "home1-64644": {
        caption: "\u65B0\u77F3\u5668\u65F6\u4EE3 \u7389\u73AF",
        thumbnail: $johf1["home1-64644-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-64644-1.jpg"],
                points: []
            }
        ]
    },
    "home1-8108": {
        caption: "\u897F\u5468\u665A\u671F \u8D9E\u66F9\u9F0E",
        thumbnail: $johf1["home1-8108-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-8108-1.jpg"],
                points: []
            }
        ]
    },
    "home1-2563": {
        caption: "\u897F\u5468\u4E2D\u671F \u8D9E\u66F9\u9F0E",
        thumbnail: $johf1["home1-2563-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-2563-1.jpg"],
                points: []
            }
        ]
    },
    "home1-23561": {
        caption: "\u6625\u79CB\u665A\u671F \u8005\uB1FE\u949F",
        thumbnail: $johf1["home1-23561-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-23561-1.jpg"],
                points: []
            }
        ]
    },
    "home1-26397": {
        caption: "\u897F\u5468\u4E2D\u671F \u5E08\uB010\u7236\u9F0E",
        thumbnail: $johf1["home1-26397-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-26397-1.jpg"],
                points: []
            }
        ]
    },
    "home1-39416": {
        caption: "\u5B8B\u4EBA \u591C\u5408\u82B1\u56FE\u7EA8\u6247\u9875",
        thumbnail: $johf1["home1-39416-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-39416-1.jpg"],
                points: []
            }
        ]
    },
    "home1-45511": {
        caption: "\u6E05 \u738B\u9274\u5173\u5C71\u79CB\u9701\u56FE\u8F74",
        thumbnail: $johf1["home1-45511-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-45511-1.jpg"],
                points: []
            }
        ]
    },
    "home1-64745": {
        caption: "\u6E05 \u91D1\u519C \u96B6\u4E66\u516D\u8A00\u8054\u8F74",
        thumbnail: $johf1["home1-64745-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-64745-1.jpg"],
                points: []
            }
        ]
    },
    "home1-64777": {
        caption: "\u6E05 \u4EFB\u85B0 \u6119\u658B\u96C6\u53E4\u56FE",
        thumbnail: $johf1["home1-64777-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-64777-1.jpg"],
                zoomLevel: 5,
                points: []
            }
        ]
    },
    "home1-64771": {
        caption: "\u6E05 \u91D1\u4FCA\u660E \u7FA4\u82B3\u5408\u74A7\u56FE\u518C",
        thumbnail: $johf1["home1-64771-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-64771-1.jpg"],
                points: []
            }
        ]
    },
    "home1-51064": {
        caption: "\u660E \u91D1\u6E5C\uFF08\u6B3E\uFF09\u53CC\u94A9\u7AF9\u56FE\u8F74",
        thumbnail: $johf1["home1-51064-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-51064-1.jpg"],
                points: []
            }
        ]
    },
    "home1-64517": {
        caption: "\u8FD1\u4EE3 \u5434\u5927\u6F82 \u201C\u6119\u658B\u6240\u5F97\u91D1\u77F3\u201D\u77F3\u7AE0",
        thumbnail: $johf1["home1-64517-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home1-64517-1.jpg"],
                points: []
            }
        ]
    },
    "home2-2447": {
        caption: "\u660E \u8463\u5176\u660C \u70DF\u6C5F\u53E0\u5E5B\u56FE\u5377",
        thumbnail: $johf1["home2-2447-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-2447-1.jpg"],
                zoomLevel: 5,
                points: []
            }
        ]
    },
    "home2-2574": {
        caption: "\u660E \u5510\u5BC5 \u6625\u5C71\u4F34\u4FA3\u56FE\u8F74",
        thumbnail: $johf1["home2-2574-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-2574-1.jpg"],
                points: []
            }
        ]
    },
    "home2-8882": {
        caption: "\u660E \u9648\u6DF3 \u5C71\u8336\u6C34\u4ED9\u56FE\u8F74",
        thumbnail: $johf1["home2-8882-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-8882-1.jpg"],
                points: []
            }
        ]
    },
    "home2-19951": {
        caption: "\u660E \u8463\u5176\u660C \u6816\u971E\u5BFA\u8BD7\u610F\u56FE\u8F74",
        thumbnail: $johf1["home2-19951-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-19951-1.jpg"],
                points: []
            }
        ]
    },
    "home2-65505": {
        caption: "\u660E \u8463\u5176\u660C \u5C71\u6C34 \u9648\u7EE7\u5112\u884C\u4E66\u5408\u5377",
        thumbnail: $johf1["home2-65505-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-65505-1.jpg"],
                zoomLevel: 5,
                points: []
            }
        ]
    },
    "home2-45532": {
        caption: "\u660E \u738B\u5EFA\u7AE0 \u5C71\u6C34\u6247\u9875",
        thumbnail: $johf1["home2-45532-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-45532-1.jpg"],
                points: []
            }
        ]
    },
    "home2-59917": {
        caption: "\u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C",
        thumbnail: $johf1["home2-59917-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-59917-1.jpg"],
                points: []
            },
            {
                url: $johf1["home2-59917-2.jpg"],
                points: []
            },
            {
                url: $johf1["home2-59917-3.jpg"],
                points: []
            },
            {
                url: $johf1["home2-59917-4.jpg"],
                points: []
            }
        ]
    },
    "home2-59926": {
        caption: "\u968B \u5E38\u4E11\u5974\u5893\u5FD7\u94ED\u518C",
        thumbnail: $johf1["home2-59926-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-59926-1.jpg"],
                points: []
            }
        ]
    },
    "home2-51383": {
        caption: "\u8FD1\u4EE3 \u848B\u8282\u201C\u6C88\u6811\u955B\u5370\u201D\u77F3\u7AE0",
        thumbnail: $johf1["home2-51383-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home2-51383-1.jpg"],
                points: []
            }
        ]
    },
    "home3-24306": {
        caption: "\u897F\u5468\u665A\u671F \u5E08\uAF50\u7C0B",
        thumbnail: $johf1["home3-24306-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-24306-1.jpg"],
                points: []
            }
        ]
    },
    "home3-34693": {
        caption: "\u6625\u79CB\u665A\u671F \u90D8\uBFEC\u949F",
        thumbnail: $johf1["home3-34693-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-34693-1.jpg"],
                points: []
            }
        ]
    },
    "home3-41536": {
        caption: "\u6625\u79CB\u665A\u671F \u6C87\u513F\u949F",
        thumbnail: $johf1["home3-41536-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-41536-1.jpg"],
                points: []
            }
        ]
    },
    "home3-15234": {
        caption: "\u897F\u5468\u665A\u671F \u4EF2\u4E49\u7236\uBBC9",
        thumbnail: $johf1["home3-15234-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-15234-1.jpg"],
                points: []
            }
        ]
    },
    "home3-2809": {
        caption: "\u897F\u5468\u665A\u671F \u5E08\uB2C4\u7C0B",
        thumbnail: $johf1["home3-2809-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-2809-1.jpg"],
                points: []
            }
        ]
    },
    "home3-8105": {
        caption: "\u897F\u5468\u665A\u671F \u4E95\u4EBA\uB44D\u949F",
        thumbnail: $johf1["home3-8105-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-8105-1.jpg"],
                points: []
            }
        ]
    },
    "home3-8106": {
        caption: "\u897F\u5468\u4E2D\u671F \u5C0F\u514B\u9F0E",
        thumbnail: $johf1["home3-8106-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-8106-1.jpg"],
                points: []
            }
        ]
    },
    "home3-8107": {
        caption: "\u897F\u5468\u4E2D\u671F \u514B\u949F",
        thumbnail: $johf1["home3-8107-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-8107-1.jpg"],
                points: []
            }
        ]
    },
    "home3-21806": {
        caption: "\u897F\u5468\u4E2D\u671F \u5E08\u864E\u7C0B",
        thumbnail: $johf1["home3-21806-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-21806-1.jpg"],
                points: []
            }
        ]
    },
    "home3-15235": {
        caption: "\u897F\u5468\u665A\u671F \u53F2\u9882\u9F0E",
        thumbnail: $johf1["home3-15235-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-15235-1.jpg"],
                points: []
            }
        ]
    },
    "home3-35361": {
        caption: "\u897F\u5468\u4E2D\u671F \u5E08\u907D\u65B9\u5F5D",
        thumbnail: $johf1["home3-35361-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-35361-1.jpg"],
                points: []
            }
        ]
    },
    "home3-3183": {
        caption: "\u897F\u5468\u4E2D\u671F \u5927\u514B\u9F0E",
        thumbnail: $johf1["home3-3183-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-3183-1.jpg"],
                points: []
            }
        ]
    },
    "home3-44047": {
        caption: "\u5357\u5B8B\u520A \u7AF9\u53CB\u96C6",
        thumbnail: $johf1["home3-44047-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-44047-1.jpg"],
                points: []
            }
        ]
    },
    "home3-44048": {
        caption: "\u5B8B\u520A \u4E56\u5D16\u96C6",
        thumbnail: $johf1["home3-44048-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-44048-1.jpg"],
                points: []
            }
        ]
    },
    "home3-59934": {
        caption: "\u660E\u62D3 \u5510\u5D14\u6566\u793C\u7891\u518C",
        thumbnail: $johf1["home3-59934-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-59934-1.jpg"],
                points: []
            }
        ]
    },
    "home3-45534": {
        references: "home4-45534"
    },
    "home3-35389": {
        caption: "\u6E05 \u8D75\u4E4B\u8C26 \u201C\u7FF0\u6797\u4F9B\u5949\u201D\u77F3\u7AE0",
        thumbnail: $johf1["home3-35389-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["home3-35389-1.jpg"],
                points: []
            }
        ]
    },
    "home4-45511": {
        caption: "\u6E05 \u738B\u9274\u5173\u5C71\u79CB\u9701\u56FE\u8F74",
        thumbnail: $johf1["home4-45511-0.jpg"],
        description: "<p>\u5EB7\u7199\u5341\u56DB\u5E74\uFF081675\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u738B\u9274\uFF081598-1677\uFF09\uFF0C\u5B57\u5706\u7167\uFF0C\u53F7\u6E58\u78A7\uFF0C\u6C5F\u82CF\u592A\u4ED3\u4EBA\u3002\u6E05\u521D\u201C\u56DB\u738B\u201D\u4E4B\u4E00\u3002\u6B64\u56FE\u4E3A\u5176\u4E03\u5341\u516B\u5C81\u6240\u4F5C\u3002</p><p>\u6B64\u4F5C\u539F\u4E3A\u5434\u5927\u6F82\u7684\u6536\u85CF\uFF0C\u6709\u5176\u9898\u7B7E\u53CA\u9898\u8DCB\u3002\u51E1\u7956\u7236\u65E7\u85CF\uFF0C\u5434\u6E56\u5E06\u7686\u5B9D\u7231\u6709\u52A0\uFF0C\u6563\u4F5A\u5728\u5916\u7684\u4F46\u51E1\u6709\u80FD\u529B\u5219\u6089\u6570\u8D2D\u56DE\uFF0C\u6B64\u753B\u5373\u662F\u4E00\u4F8B\u3002\u5982\u5434\u6E56\u5E06\u5728\u88F1\u8FB9\u7684\u9898\u8DCB\u4E2D\u6240\u8A00\uFF1A\u201C\u543E\u5BB6\u65E7\u6709\u7269\u4E5F\u3002\u58EC\u7533\uFF081932\uFF09\u56DB\u6708\u81EA\u6545\u90FD\u8D2D\u5F52\uFF0C\u6C38\u85CF\u4EC0\u88AD\u3002\u201D\u4F53\u73B0\u51FA\u5BF9\u7956\u8F88\u7684\u5C0A\u656C\uFF0C\u4EA6\u662F\u5BF9\u5BB6\u85CF\u65E7\u7269\u7684\u73CD\u60DC\u3002</p>",
        slides: [
            {
                url: $johf1["home4-45511-1.jpg"],
                points: [
                    {
                        x: 73,
                        y: 910,
                        content: "<p>\u5434\u5927\u6F82\u9898\u8DCB\uFF1A\u201C\u6E58\u78A7\u8001\u4EBA\u65E9\u5E74\u591A\u6CFC\u58A8\u6DCB\u6F13\u4E4B\u7B14\uFF0C\u5176\u7CBE\u7EC6\u4E4B\u4F5C\u7686\u5728\u516D\u4E03\u5341\u5C81\u4EE5\u540E\u3002\u6B64\u5E5B\u4EFF\u8303\u539F\u534E\u300A\u5173\u5C71\u79CB\u9701\u56FE\u300B\uFF0C\u4E0E\u4E88\u6240\u4E34\u300A\u865E\u5C71\u5341\u666F\u300B\u7B14\u610F\u53EF\u76F8\u5F15\u8BC1\u4E5F\u3002\u6B64\u5E45\u4E88\u5F97\u4E4B\u5341\u4F59\u5E74\uFF0C\u5EC9\u592B\u5C61\u5C61\u501F\u4E34\uFF0C\u5176\u7528\u610F\u4E4B\u7F1C\u5BC6\uFF0C\u867D\u6781\u5C0F\u5904\u65E0\u4E00\u61C8\u7B14\uFF0C\u5373\u6B64\u53EF\u89C1\u5A04\u4E1C\u5BB6\u6CD5\u4E5F\u3002\u4E19\u7533\uFF081896\uFF09\u590F\u516D\u6708\uFF0C\u4E45\u75C5\u65B0\u7625\uFF0C\u5C55\u73A9\u518D\u56DB\uFF0C\u4FE1\u7B14\u9898\u6B64\u3002\u767D\u4E91\u5C71\u6A35\u5434\u5927\u6F82\u65F6\u5E74\u516D\u5341\u6709\u4E8C\u3002\u201D</p>"
                    },
                    {
                        x: 1738,
                        y: 2082,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u738B\u6E58\u78A7\u300A\u5173\u5C71\u79CB\u9701\u56FE\u300B\u6709\u5148\u5C1A\u4E66\u516C\u9898\u5B57\uFF0C\u543E\u5BB6\u65E7\u6709\u7269\u4E5F\u3002\u58EC\u7533\u56DB\u6708\u81EA\u6545\u90FD\u8D2D\u5F52\uFF0C\u6C38\u85CF\u4EC0\u88AD\u3002\u5434\u6E56\u5E06\u8C28\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "home4-64745": {
        caption: "\u6E05 \u91D1\u519C \u96B6\u4E66\u516D\u8A00\u8054\u8F74",
        thumbnail: $johf1["home4-64745-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u91D1\u519C\uFF081687-1763\uFF09\uFF0C\u5B57\u5BFF\u95E8\uFF0C\u53F7\u51AC\u5FC3\u7B49\uFF0C\u4EC1\u548C\uFF08\u4ECA\u6D59\u6C5F\u676D\u5DDE\uFF09\u4EBA\u3002\u626C\u5DDE\u753B\u6D3E\u753B\u5BB6\u4E4B\u4E00\u3002\u8054\u8BED\u51FA\u81EA\u300A\u5317\u9F50\u4E66.\u9E3F\u52CB\u300B\u3002\u91D1\u519C\u540E\u671F\u7684\u516B\u5206\u4E66\uFF0C\u7834\u5706\u4E3A\u65B9\uFF0C\u58A8\u6D53\u5982\u6F06\uFF0C\u540E\u4EBA\u79F0\u4E4B\u4E3A\u201C\u6F06\u4E66\u201D\u3002</p><p>\u4ECE\u5434\u6E56\u5E06\u7684\u88F1\u8FB9\u9898\u8DCB\u53EF\u77E5\uFF0C\u6B64\u8054\u4E3A\u5176\u7956\u5434\u5927\u6F82\u85CF\u54C1\u3002\u8DCB\u6587\u5B57\u91CC\u884C\u95F4\uFF0C\u6D41\u9732\u51FA\u5BF9\u7956\u4F20\u85CF\u54C1\u7684\u73CD\u60DC\u4E4B\u60C5\u3002</p>",
        slides: [
            {
                url: $johf1["home4-64745-1.jpg"],
                points: [
                    {
                        x: 1808,
                        y: 503,
                        content: "<p>\u5434\u5927\u6F82\u9898\u7B7E\uFF1A\u201C\u51AC\u5FC3\u5148\u751F\u5BF9\u3002\u4E0A\u3002\u201D</p>"
                    },
                    {
                        x: 966,
                        y: 492,
                        content: "<p>\u5434\u5927\u6F82\u9898\u7B7E\uFF1A\u201C\u51AC\u5FC3\u5148\u751F\u5BF9\u3002\u4E0B\u3002\u201D</p>"
                    },
                    {
                        x: 82,
                        y: 2707,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u8054\u72B9\u662F\u7956\u9057\u65E7\u85CF\u54C1\u3002\u4E0A\u4E0B\u4E8C\u7B7E\u7686\u6119\u658B\u516C\u4EB2\u7B14\u4E66\u3002\u6E56\u5E06\u73CD\u85CF\u656C\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "home4-64777": {
        caption: "\u6E05 \u4EFB\u85B0\u3001\u9646\u6062 \u6119\u658B\u96C6\u53E4\u56FE",
        thumbnail: $johf1["home4-64777-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u4EFB\u85B0\uFF081834-1893\uFF09\uFF0C\u5B57\u961C\u957F\uFF0C\u6D59\u6C5F\u8427\u5C71\u4EBA\u3002</p><p>\u9646\u6062\uFF081851-1920\uFF09\uFF0C\u5B57\u5EC9\u592B\uFF0C\u539F\u7C4D\u6C5F\u82CF\u5434\u6C5F\uFF0C\u5C45\u82CF\u5DDE\u3002</p><p>\u6B64\u5377\u662F\u91D1\u77F3\u6536\u85CF\u5927\u5BB6\u3001\u5434\u6E56\u5E06\u7684\u7956\u7236\u5434\u5927\u6F82\uFF081835-1902\uFF0C\u665A\u53F7\u6119\u658B\uFF09\u5C06\u81EA\u5DF1\u6536\u85CF\u7684\u9752\u94DC\u5668\u5168\u5F62\u58A8\u62D3\u800C\u6210\u7684\u56FE\u5377\uFF0C\u5171\u5206\u4E0A\u4E0B\u5377\u3002\u4E0A\u4E0B\u5377\u5206\u522B\u6709\u6D77\u6D3E\u540D\u5BB6\u4EFB\u85B0\u4E0E\u5434\u5E55\u5E9C\u753B\u5BB6\u9646\u6062\u6240\u4F5C\u300A\u6119\u658B\u96C6\u53E4\u56FE\u300B\uFF0C\u56FE\u7ED8\u5434\u5927\u6F82\u89C2\u8D4F\u5176\u85CF\u54C1\u7684\u573A\u666F\u3002\u540C\u65F6\uFF0C\u56FE\u4E2D\u5BF9\u5F62\u5236\u5404\u5F02\u7684\u9752\u94DC\u5668\u4F5C\u4E86\u7EC6\u81F4\u903C\u771F\u7684\u63CF\u7ED8\uFF0C\u5E76\u4E3A\u5176\u4E00\u4E00\u6CE8\u660E\u540D\u79F0\u3002\u4ECE\u6B64\u5377\u53EF\u89C1\u5434\u5927\u6F82\u6536\u85CF\u4E4B\u5BCC\uFF0C\u4EA6\u53EF\u89C1\u5434\u6E56\u5E06\u4E4B\u5BB6\u5B66\u6E0A\u6E90\u3002</p>",
        slides: [
            {
                url: $johf1["home4-64777-1.jpg"],
                zoomLevel: 5,
                points: []
            },
            {
                url: $johf1["home4-64777-2.jpg"],
                points: []
            }
        ]
    },
    "home4-64771": {
        caption: "\u6E05 \u91D1\u4FCA\u660E \u7FA4\u82B3\u5408\u74A7\u56FE\u518C",
        thumbnail: $johf1["home4-64771-0.jpg"],
        description: "<p>\u987A\u6CBB\u5341\u4E03\u5E74\uFF081660\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8/\u8BBE\u8272</p><p>\u91D1\u4FCA\u660E\uFF081602-1675\uFF09\uFF0C\u5B57\u5B5D\u7AE0\uFF0C\u53F7\u803F\u5EB5\uFF0C\u6C5F\u82CF\u82CF\u5DDE\u4EBA\u3002\u6B64\u518C\u4E3A\u4F5C\u8005\u58A8\u620F\u81EA\u8D4F\u4E4B\u4F5C\uFF0C\u4F5C\u4E8E\u987A\u6CBB\u5341\u4E03\u5E74\u65F6\u5E74\u4E94\u5341\u4E5D\u5C81\u4E4B\u9645\uFF0C\u753B\u540E\u53C8\u8BF7\u597D\u53CB\u4E00\u4E00\u8865\u7F00\u5404\u79CD\u82B1\u5349\u677E\u7AF9\u4EE5\u6210\u3002</p><p>\u6B64\u518C\u539F\u4E3A\u5434\u6E56\u5E06\u7956\u7236\u5434\u5927\u6F82\u3001\u7236\u4EB2\u5434\u672C\u5584\u9274\u9898\u9012\u85CF\u65E7\u7269\uFF0C\u518C\u540E\u5C1A\u6709\u5434\u6E56\u5E06\u7236\u4EB2\u8BB7\u58EB\u5434\u672C\u5584\u5C0F\u6977\u8003\u8BA2\u518C\u4E2D\u8BF8\u4EBA\u751F\u5E73\uFF0C\u53EF\u89C1\u660E\u672B\u6E05\u521D\u91D1\u4FCA\u660E\u7684\u4EA4\u6E38\u5708\u3002</p>",
        slides: [
            {
                url: $johf1["home4-64771-1.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-2.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-3.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-4.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-5.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-6.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-7.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-8.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-9.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-10.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-11.jpg"],
                points: []
            },
            {
                url: $johf1["home4-64771-12.jpg"],
                points: [
                    {
                        x: 797,
                        y: 200,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u543E\u5BB6\u65E7\u5C45\u53CC\u6797\u5DF7\u6625\u8349\u95F2\u623F\uFF0C\u5B5D\u7AE0\u5148\u751F\u6545\u91CC\u4E5F\u3002\u5148\u7956\u6536\u5F97\u5148\u751F\u753B\u6885\u518C\u51E1\u4E09\uFF0C\u4EE5\u6B64\u4E3A\u51A0\u3002\u53C8\u5148\u751F\u624B\u4E66\u8BD7\u7A3F\u4E00\u5377\uFF0C\u7686\u4E19\u620C\uFF081646\uFF09\u3001\u4E01\u4EA5\uFF081647\uFF09\u65F6\u4F5C\u8BED\uFF0C\u591A\u51C4\u611F\uFF0C\u76D6\u8EAB\u4E16\u4E0E\u6240\u5357\u4EFF\u4F5B\u8033\u3002\u6B64\u518C\u66FE\u88C5\u4E8E\u5149\u7EEA\u620A\u7533\uFF081908\uFF09\uFF0C\u5148\u7236\u5F55\u4F5C\u5BB6\u5C0F\u4F20\u4E8E\u540E\uFF0C\u8D8A\u4ECA\u53C8\u5EFF\u4F59\u5E74\u77E3\u3002\u91CD\u4ED8\u6F62\u6C60\u9898\u4E4B\uFF0C\u65F6\u8F9B\u672A\uFF081931\uFF09\u5341\u6708\uFF0C\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-64771-13.jpg"],
                points: [
                    {
                        x: 1878,
                        y: 112,
                        content: "<p>\u5434\u8BB7\u58EB\u9898\u8DCB\u8003\u8BC1\u9875</p>"
                    }
                ]
            }
        ]
    },
    "home4-51064": {
        caption: "\u660E \u91D1\u6E5C\uFF08\u6B3E\uFF09\u53CC\u94A9\u7AF9\u56FE\u8F74",
        thumbnail: $johf1["home4-51064-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u91D1\u6E5C\uFF08\u5341\u4E94\u4E16\u7EAA\uFF09\uFF0C\u5B57\u672C\u6E05\uFF0C\u53F7\u592A\u7626\u751F\uFF0C\u6D59\u6C5F\u5B81\u6CE2\u4EBA\u3002\u6B63\u7EDF\u4E2D\u4E3E\u4EBA\uFF0C\u5584\u753B\u7AF9\u77F3\uFF0C\u7BC6\u96B6\u884C\u8349\uFF0C\u7686\u6709\u664B\u4EBA\u98CE\u5EA6\u3002\u672C\u56FE\u592A\u6E56\u77F3\u58A8\u67D3\uFF0C\u52FE\u52D2\u7684\u7AF9\u679D\u3001\u7AF9\u53F6\u58A8\u8272\u6DE1\u96C5\u5DE5\u4E3D\uFF0C\u6D53\u6DE1\u76F8\u5B9C\u3002</p><p>\u636E\u753B\u8F74\u5916\u7B7E\u53EF\u77E5\uFF0C\u6B64\u4E3A\u5434\u6E56\u5E06\u7956\u7236\u5434\u5927\u6F82\u85CF\u54C1\uFF0C\u5F53\u5E74\u89C6\u82E5\u62F1\u74A7\u3002\u6545\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u592B\u5987\u4EA6\u6781\u4E3A\u73CD\u89C6\uFF0C\u753B\u9762\u8FED\u6709\u9274\u8D4F\u5370\u8BB0\u3002\u6B64\u8F74\u7591\u975E\u91D1\u6C0F\u771F\u8FF9\uFF0C\u5F85\u7814\u7A76\u3002</p>",
        slides: [
            {
                url: $johf1["home4-51064-1.jpg"],
                points: [
                    {
                        x: 1544,
                        y: 1099,
                        content: "<p>\u5434\u5927\u6F82\u9898\u7B7E\uFF1A\u201C\u673D\u6728\u5C45\u58EB\u7AF9\u77F3\uFF0C\u795E\u54C1\u3002\u6119\u658B\u5B9D\u85CF\u201D</p>"
                    }
                ]
            }
        ]
    },
    "home4-45532": {
        caption: "\u660E \u738B\u5EFA\u7AE0 \u5C71\u6C34\u6247\u9875",
        thumbnail: $johf1["home4-45532-0.jpg"],
        description: "<p>\u5D07\u796F\u5341\u4E03\u5E74\uFF081644\uFF09</p><p>\u91D1\u7B3A \u6C34\u58A8</p><p>\u738B\u5EFA\u7AE0\uFF08\u5341\u4E03\u4E16\u7EAA\uFF09\uFF0C\u5B57\u4EF2\u521D\u3002</p><p>\u6B64\u6247\u7CFB\u5434\u6E56\u5E06\u5916\u7956\u6C88\u6811\u955B\u65E7\u85CF\u3002\u7ECF\u5434\u6E56\u5E06\u8003\u8BC1\u6307\u51FA\uFF1A\u738B\u5EFA\u7AE0\u771F\u8FF9\u4E0D\u591A\uFF0C\u753B\u4EA6\u65E0\u751A\u51FA\u8272\uFF0C\u56E0\u66FE\u4E1C\u6E21\u65E5\u672C\uFF0C\u4F5C\u54C1\u6D41\u4F20\u81F3\u65E5\u672C\u800C\u88AB\u5F7C\u4EBA\u5949\u4E3A\u81F3\u5B9D\u3002\u73B0\u5B58\u738B\u5EFA\u7AE0\u6B3E\u56FE\u6247\u9762\u8C8C\u98CE\u683C\u4E0D\u4E00\uFF0C\u4E0D\u77E5\u8005\u4EE5\u4E3A\u5EFA\u7AE0\u98CE\u683C\u591A\u53D8\uFF0C\u5B9E\u5219\u201C\u67D0\u5B5D\u5EC9\u201D\u4E3A\u725F\u5229\u641C\u96C6\u660E\u4EBA\u753B\u6247\u6570\u5341\u7B91\uFF0C\u53BB\u5176\u6B3E\u800C\u586B\u5199\u5EFA\u7AE0\u4E4B\u540D\u7684\u4F2A\u4F5C\u3002\u800C\u8FD9\u4EF6\u738B\u5EFA\u7AE0\u6B3E\u56FE\u6247\u624D\u662F\u738B\u6C0F\u4F5C\u54C1\u7684\u771F\u6B63\u9762\u8C8C\u3002</p>",
        slides: [
            {
                url: $johf1["home4-45532-1.jpg"],
                points: [
                    {
                        x: 4506,
                        y: 156,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u738B\u4EF2\u521D\u66FE\u4E1C\u6E21\u65E5\u672C\uFF0C\u9057\u6D41\u771F\u8FF9\u4E00\u4E8C\uFF0C\u6545\u65E5\u672C\u77E5\u5176\u4EBA\u800C\u91CD\u5176\u753B\u3002\u6E05\u5B63\u6709\u67D0\u5B5D\u5EC9\u8005\u6089\u5176\u72B6\uFF0C\u9042\u641C\u96C6\u660E\u4EBA\u753B\u4E4B\u7A77\u6B3E\u8005\u6570\u5341\u7B91(zh\xe1)\uFF0C\u6089\u51FA\u5176\u6B3E\u800C\u586B\u5199\u5EFA\u7AE0\u4E4B\u540D\u3002\u5176\u8BA1\u5927\u916C\uFF0C\u8BC6\u8005\u4E43\u5927\u60D1\u5EFA\u7AE0\u4E4B\u65E0\u6240\u4E0D\u5DE5\u800C\u771F\u9762\u83AB\u6D4B\u4E5F\u3002\u82E5\u67D0\u5B5D\u5EC9\u8005\uFF0C\u53EF\u8C13\u72E1\u77E3\u3002\u6B64\u7B91(zh\xe1)\u4E43\u5148\u5916\u79DF\u65E7\u85CF\uFF0C\u4E0E\u67D0\u5B5D\u5EC9\u4E4B\u5EFA\u7AE0\u4E0D\u540C\uFF0C\u5E90\u5C71\u771F\u9762\uFF0C\u613F\u8BC6\u8005\u5171\u8BA4\u3002\u4E0D\u77E5\u701B\u6D77\u5BA2\u58EB\u89C1\u4E4B\u5982\u4F55\uFF1F\u5E78\u6D77\u5185\u85CF\u5BB6\u52FF\u5FFD\u3002\u5434\u6E56\u5E06\u8BC6\u3002</p>"
                    }
                ]
            }
        ]
    },
    "home4-59917": {
        caption: "\u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C",
        thumbnail: $johf1["home4-59917-0.jpg"],
        description: "<p>\u8427\u6577\uFF08\uFF1F\uFF0D497\uFF09\uFF0C\u5B57\u4EF2\u8FBE\uFF0C\u5357\u671D\u9F50\u5170\u9675\uFF08\u4ECA\u6C5F\u82CF\u9547\u6C5F\uFF09\u4EBA\uFF0C\u6881\u6B66\u5E1D\u5144\u3002</p><p>\u672C\u518C\u53CC\u5FD7\u62D3\u672C\uFF0C\u5411\u6765\u88AB\u89C6\u4E3A\u8F83\u4E4B\u53F2\u4F20\u8BB0\u8F7D\u66F4\u4E3A\u8BE6\u5C3D\u7684\u8427\u6577\u4E0E\u656C\u592A\u5983\u4F20\u4E16\u5893\u5FD7\u5B64\u672C\u3002</p><p>\u56E0\u6B64\u518C\u4E3A\u5434\u6E56\u5E06\u5916\u7956\u3001\u665A\u6E05\u6CAA\u4E0A\u91D1\u77F3\u7891\u7248\u9274\u85CF\u5BB6\u6C88\u6811\u955B\u65E7\u85CF\uFF0C\u6545\u5434\u6E56\u5E06\u7AED\u529B\u641C\u8BBF\uFF0C\u5F97\u4E4B\u4E8E\u4E8C\u5341\u4E16\u7EAA\u4E09\u5341\u5E74\u4EE3\u521D\u671F\uFF0C\u5949\u4E3A\u81F3\u5B9D\uFF0C\u9898\u4E3A\u201C\u58A8\u7687\u201D\u3002\u5E76\u56E0\u53CC\u5FD7\u64B0\u8005\u5F90\u52C9\u8868\u5B57\u4FEE\u4EC1\u800C\u547D\u658B\u5BA4\u540D\u201C\u53CC\u4FEE\u9601\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["home4-59917-1.jpg"],
                points: []
            },
            {
                url: $johf1["home4-59917-2.jpg"],
                points: [
                    {
                        x: 1785,
                        y: 91,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u9996\uFF1A\u201C\u58A8\u7687\uFF0C\u5434\u6C0F\u6587\u7269\u81F3\u5B9D\u4E4B\u4E00\uFF0C\u5B8B\u62D3\u5B64\u672C\u6881\u6C38\u9633\u662D\u738B\u3001\u656C\u592A\u5983\u53CC\u5FD7\uFF0C\u53CC\u4FEE\u9601\u9547\u5B9D\u8BB0\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-59917-3.jpg"],
                points: [
                    {
                        x: 1250,
                        y: 269,
                        content: "<p>\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u76F8\u5173\u9898\u8DCB\uFF1A\u201C\u6881\u4EC6\u5C04\u5F90\u52C9\uFF0C\u5B57\u4FEE\u4EC1\uFF0C\u5DE5\u6587\u7AE0\uFF0C\u5F53\u65F6\u4E30\u529F\u4F1F\u7EE9\u4E4B\u6587\u7686\u51FA\u5176\u5236\u3002\u6B64\u6C38\u9633\u738B\u656C\u592A\u5983\u53CC\u5FD7\uFF0C\u54B8\u4E3A\u4FEE\u4EC1\u5949\u6555\u6240\u64B0\uFF0C\u56E0\u540D\u543E\u5BA4\u66F0\uFF1A\u53CC\u4FEE\u9601\u3002\u7678\u9149\uFF081933\uFF09\u4E8C\u6708\uFF0C\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u8BB0\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-59917-4.jpg"],
                points: [
                    {
                        x: 634,
                        y: 269,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u4E3A\u5B8B\u62D3\u5B64\u672C\u7B2C\u4E00\u540D\u6D41\u3002\u300A\u65E7\u9986\u575B\u7891\u300B\u5DF2\u4EA1\uFF0C\u300A\u8427\u61BA\u300B\u4EC5\u4F59\u77F3\u9ABC\uFF0C\u5411\u4E3A\u6F58\u6C0F\u538B\u7BB1\uFF0C\u540D\u7C4D\u6D77\u5185\uFF0C\u4ECA\u5C5E\u9759\u6DD1\u55E3\u5B88\uFF0C\u5F53\u6C38\u4FDD\u4E4B\u3002\u5434\u6E56\u5E06\u8C28\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "home4-59926": {
        caption: "\u968B \u5E38\u4E11\u5974\u5893\u5FD7\u94ED\u518C",
        thumbnail: $johf1["home4-59926-0.jpg"],
        description: "<p>\u7EB8\u672C \u58A8\u62D3</p><p>\u300A\u968B\u5E38\u4E11\u5974\u5893\u5FD7\u94ED\u300B\u5168\u79F0\u300A\u968B\u90FD\u7763\u8365\u6CFD\u53BF\u4EE4\u6545\u5E38\u5E9C\u541B\u5893\u5FD7\u300B\uFF0C\u662F\u5E38\u6C0F\u4E0E\u59BB\u5B97\u6C0F\u5408\u846C\u5FD7\u3002\u65E0\u64B0\u4E66\u4EBA\u540D\uFF0C\u539F\u5B58\u9655\u897F\u5174\u5E73\u53BF\u5D07\u5B81\u5BFA\u58C1\u95F4\uFF0C\u540E\u5BFA\u5E9F\u77F3\u4F5A\uFF0C\u62D3\u672C\u9042\u4E3A\u4E16\u4EBA\u6240\u91CD\uFF0C\u88AB\u5949\u4E3A\u5510\u6977\u5148\u58F0\u3002</p><p>\u672C\u518C\u62D3\u672C\u66FE\u4E3A\u6E05\u626C\u5DDE\u753B\u6D3E\u753B\u5BB6\u91D1\u519C\u65E7\u85CF\uFF0C\u540E\u7531\u5434\u6E56\u5E06\u5916\u7956\u6C88\u97F5\u521D\u3001\u7956\u7236\u5434\u5927\u6F82\u9012\u85CF\uFF0C\u4E3A\u5434\u6C0F\u81EA\u53F7\u201C\u4E11\u7C03\u201D\u51FA\u5904\u3002</p>",
        slides: [
            {
                url: $johf1["home4-59926-1.jpg"],
                points: []
            },
            {
                url: $johf1["home4-59926-2.jpg"],
                points: [
                    {
                        x: 230,
                        y: 1485,
                        content: "<p>\u4E11\u7C03</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-59926-3.jpg"],
                points: [
                    {
                        x: 144,
                        y: 1134,
                        content: "<p>\u65E2\u4E11\u4E14\u7F8E</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-59926-4.jpg"],
                points: [
                    {
                        x: 1682,
                        y: 267,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5148\u5916\u7956\u6C88\u97F5\u521D\u5148\u751F\u624B\u672D\u4E00\u901A\uFF0C\u56E0\u63D0\u53CA\u300A\u5E38\u4E11\u5974\u300B\u3001\u300A\u8463\u7F8E\u4EBA\u300B\u4E24\u5FD7\uFF0C\u524D\u5C81\u6C88\u6E58\u4E4B\u8868\u5144\u6536\u5F97\u8D3B\u4F59\uFF0C\u5373\u7C98\u4E8E\u300A\u5E38\u5FD7\u300B\u4E4B\u524D\u3002\u6E56\u5E06\u8C28\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "home4-45534": {
        caption: "\u5357\u5B8B \u666F\u5B9A\u4E8C\u5E74\u520A\u6885\u82B1\u559C\u795E\u8C31",
        thumbnail: $johf1["home4-45534-0.jpg"],
        description: "<p>\u666F\u5B9A\u4E8C\u5E74\uFF081261\uFF09</p><p>\u7EB8\u672C \u96D5\u7248\u5370\u5237</p><p>\u53E4\u79F0\u753B\u50CF\u4E3A\u201C\u559C\u795E\u201D\uFF0C\u6545\u672C\u8C31\u540D\u79F0\u201C\u6885\u82B1\u559C\u795E\u8C31\u201D\uFF0C\u5373\u6885\u82B1\u753B\u8C31\u3002\u672C\u8C31\u521D\u523B\u4E8E\u5357\u5B8B\u5609\u7199\u4E8C\u5E74\uFF081238\uFF09\uFF0C\u539F\u523B\u672C\u672A\u89C1\u4F20\u4E16\u3002\u6B64\u4E3A\u5357\u5B8B\u666F\u5B9A\u4E8C\u5E74\uFF081261\uFF09\u91D1\u534E\u53CC\u6842\u5802\u91CD\u520A\u672C\uFF0C\u5B8B\u4F2F\u4EC1\u7F16\u7ED8\uFF0C\u662F\u4E2D\u56FD\u6700\u65E9\u7684\u6728\u523B\u56FE\u7C4D\uFF0C\u4EA6\u662F\u7B2C\u4E00\u90E8\u4E13\u95E8\u63CF\u7ED8\u6885\u82B1\u7684\u753B\u8C31\u3002\u6B64\u8C31\u6309\u6885\u82B1\u65B0\u9648\u4EE3\u8C22\u89C4\u5F8B\uFF0C\u753B\u5C31\u4E0D\u540C\u5F62\u6001\u6298\u679D\u6885\u82B1\u767E\u5E45\uFF0C\u59FF\u6001\u5404\u5F02\uFF0C\u72B6\u7269\u4F20\u795E\uFF0C\u6BCF\u56FE\u9898\u540D\u5E76\u914D\u4E94\u8A00\u7EDD\u53E5\uFF0C\u56FE\u6587\u5E76\u8302\uFF0C\u4E14\u96D5\u523B\u606D\u559C\uFF0C\u6781\u5BCC\u827A\u672F\u9274\u8D4F\u4EF7\u503C\u3002</p><p>\u6B64\u8C31\u4E3A\u5434\u6E56\u5E06\u5CB3\u5BB6\u6F58\u7956\u836B\u7956\u4F20\u5584\u672C\u53E4\u7C4D\uFF0C\u5434\u6E56\u5E06\u5BF9\u6B64\u6781\u4E3A\u73CD\u89C6\uFF0C\u4E13\u95E8\u7BC6\u523B\u9274\u85CF\u5370\u201C\u5434\u6E56\u5E06\u6F58\u9759\u6DD1\u592B\u5987\u6240\u85CF\u6D77\u5185\u5B64\u672C\u5B8B\u520A\u6885\u82B1\u559C\u795E\u8C31\u4E4B\u5370\u7AE0\u201D\u3002\u5176\u658B\u540D\u201C\u6885\u666F\u4E66\u5C4B\u201D\u7684\u201C\u6885\u201D\u5B57\u5BD3\u610F\uFF0C\u5373\u56E0\u6B64\u8C31\u5F97\u540D\u3002</p>",
        slides: [
            {
                url: $johf1["home4-45534-1.jpg"],
                points: [
                    {
                        x: 244,
                        y: 1799,
                        content: "<p>\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u9898\u8DCB\uFF1A\u6885\u82B1\u559C\u795E\u8C31\u4E8C\u5377</p><p>\u5434\u6C0F\u6885\u5F71\u4E66\u5C4B\u73CD\u85CF\u9547\u5B9D\u5B8B\u523B\u5B8B\u5370\u672C</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-2.jpg"],
                points: []
            },
            {
                url: $johf1["home4-45534-3.jpg"],
                points: []
            },
            {
                url: $johf1["home4-45534-4.jpg"],
                points: [
                    {
                        x: 1707,
                        y: 1302,
                        content: "<p>\u5434\u6E56\u5E06\u6F58\u9759\u6DD1\u592B\u5987\u6240\u85CF\u6D77\u5185\u5B64\u672C\u5B8B\u520A\u6885\u82B1\u559C\u795E\u8C31\u4E4B\u5370\u7AE0</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-5.jpg"],
                points: [
                    {
                        x: 1548,
                        y: 248,
                        content: "<p>\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u9898\u5199\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u518C\u9875</p><p>\u6B64\u753B\u4E3A\u6F58\u9759\u6DD1\u7ED8\u7EFF\u843C\u6885\u82B1\u56FE\uFF0C\u540E\u7ECF\u5434\u6E56\u5E06\u8865\u5199\u7EA2\u6885\u3002\u56FE\u4E0A\u53E6\u6709\u5434\u6E56\u5E06\u5B66\u751F\u5468\u70BC\u971E\u9898\u8BD7\u3002\u540E\u7686\u88C5\u5165\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u518C\u4E2D\u3002</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-6.jpg"],
                points: [
                    {
                        x: 1782,
                        y: 238,
                        content: "<p>\u6F58\u9759\u6DD1\u96C6\u6587\u5FB5\u660E\u8BD7\u53E5\u9875</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-7.jpg"],
                points: [
                    {
                        x: 1751,
                        y: 200,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8BCD</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-8.jpg"],
                points: [
                    {
                        x: 1736,
                        y: 182,
                        content: "<p>\u6F58\u9759\u6DD1\u9898\u8BCD</p>"
                    }
                ]
            },
            {
                url: $johf1["home4-45534-9.jpg"],
                points: [
                    {
                        x: 1721,
                        y: 182,
                        content: "<p>\u5468\u70BC\u971E\u9898\u5199\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u518C\u9875</p><p>\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u4E2D\u539F\u6709\u5973\u753B\u5BB6\u5F20\u6C38\u82B3\u6885\u82B1\u4E00\u5E27\uFF0C\u56E0\u6B8B\u635F\uFF0C\u7531\u5468\u70BC\u971E\u8865\u753B\u6B64\u9875\u7F00\u5165\u3002\u53E6\u6709\u5434\u6E56\u5E06\u9898\u8BD7\u4E00\u9996\u3002</p>"
                    }
                ]
            }
        ]
    },
    "home4-51079": {
        caption: "\u5510 \u4F5A\u540D \u6977\u4E66\u5927\u65B9\u5E7F\u4F5B\u534E\u4E25\u7ECF\u5377\u7B2C\u5345\u4E8C",
        thumbnail: $johf1["home4-51079-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u672C\u5377\u4E3A\u5434\u5BB6\u65E7\u85CF\u3002\u5185\u5BB9\u53C2\u89C1\u300A\u5927\u6B63\u85CF\u300B\u7B2C\u5341\u5377\u3002\u539F\u4E3A\u957F\u5377\uFF0C\u540E\u6539\u4E3A\u56DB\u884C\u4E00\u6298\uFF0C\u590D\u53C8\u5272\u88C2\u91CD\u88F1\u4E3A\u957F\u5377\u3002</p>",
        slides: [
            {
                url: $johf1["home4-51079-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 461,
                        y: 387,
                        content: "<p>\u5434\u6E56\u5E06\u8DCB\u91CA\u6587\uFF1A\u201C\u5510\u4EBA\u5199\u7ECF\u5377\u5B50\uFF0C\u81EA\u5149\u7EEA\u95F4\u7518\u8083\u6566\u714C\u77F3\u5BA4\u574D\u53D1\u4E4B\u540E\uFF0C\u4F20\u4E16\u9042\u591A\uFF0C\u8033\u6FE1\u76EE\u67D3\uFF0C\u4F59\u6240\u89C1\u4EA6\u4E0D\u6B62\u6570\u767E\u5377\u77E3\u3002\u6B64\u5377\u543E\u5BB6\u65E7\u85CF\uFF0C\u975E\u6566\u714C\u53D1\u73B0\u672C\uFF0C\u5176\u5148\u4E0D\u77E5\u6240\u81EA\u51FA\uFF0C\u4E66\u6CD5\u4E0E\u7ECF\u6587\u8F83\u6566\u714C\u672C\u65E0\u5927\u51FA\u5165\uFF0C\u60DF\u7EB8\u8272\u5219\u4F20\u4E16\u8F83\u53E4\u8033\u3002\u201D </p>"
                    }
                ]
            }
        ]
    },
    "sight-w00001": {
        caption: "\u5434\u6E56\u5E06 \u70DB\u5978\u5F55\u624B\u7A3F\u518C",
        thumbnail: $johf1["sight-w00001-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u8FD9\u662F\u5434\u6E56\u5E061935\u5E74\u5E94\u4F26\u6566\u56FD\u9645\u827A\u672F\u5C55\u89C8\u4F1A\u4E4B\u7EA6\uFF0C\u68C0\u9605\u6545\u5BAB\u535A\u7269\u9662\u6240\u85CF\u4E66\u753B\u4E4B\u9274\u5B9A\u7EAA\u5F55\u3002\u624B\u7A3F\u5185\u5BB9\u5373\u4E3A\u5434\u6C0F\u9274\u5B9A\u8FC7\u7A0B\u4E2D\u6240\u8BB0\u5F55\u7684\u4F2A\u4F5C\u3002\u5176\u4E2D\u8F83\u4E3A\u8457\u540D\u7684\u9274\u5B9A\u610F\u89C1\u6709\uFF1A\u6307\u4E7E\u9686\u6570\u5341\u9898\u8DCB\u7684\u9EC4\u516C\u671B\u300A\u5BCC\u6625\u5C71\u5C45\u56FE\u300B\u5377\u4E3A\u4F2A\u672C\uFF1B\u8303\u5BBD\u300A\u6EAA\u5C71\u884C\u65C5\u56FE\u300B\u8F74\u4E8C\u5E45\u5927\u5C0F\u76F8\u4EFF\uFF0C\u6709\u8463\u5176\u660C\u9898\u8005\u4E3A\u771F\uFF08\u53F0\u5317\u6545\u5BAB\u85CF\uFF09\uFF0C\u6709\u738B\u65F6\u654F\u9898\u8005\u7591\u4E3A\u738B\u7FDA\u6479\u672C\uFF08\u53F0\u5317\u6545\u5BAB\u85CF\uFF09\u7B49\u7B49\u3002</p>",
        slides: [
            {
                url: $johf1["sight-w00001-1.jpg"],
                points: []
            }
        ]
    },
    "sight-6651": {
        caption: "\u5317\u5B8B \u90ED\u7199 \u5E7D\u8C37\u56FE\u8F74",
        thumbnail: $johf1["sight-6651-0.jpg"],
        description: "<p>\u7EE2\u672C \u6C34\u58A8</p><p>\u90ED\u7199\uFF08\u5341\u4E00\u4E16\u7EAA\uFF09\uFF0C\u5B57\u6DF3\u592B\uFF0C\u6CB3\u5357\u6E29\u53BF\u4EBA\u3002\u6B64\u753B\u4E3A\u5317\u5B8B\u79D8\u5E9C\u65E7\u85CF\uFF0C\u8457\u5F55\u4E8E\u300A\u5BA3\u548C\u753B\u8C31\u300B\u3002</p><p>\u300A\u4E11\u7C03\u65E5\u8BB0\u300B1933\u5E74\u6B63\u6708\u8BB0\uFF1A\u201C\u5927\u5343\u643A\u793A\u90ED\u6CB3\u9633\u300A\u5E7D\u8C37\u56FE\u300B\u7EE2\u672C\u771F\u8FF9\uFF0C\u7B14\u58A8\u751F\u52A8\uFF0C\u767E\u8BFB\u4E0D\u538C\uFF0C\u8F7D\u5165\u5B89\u4EEA\u5468\u300A\u58A8\u7F18\u6C47\u89C2\u300B\u4E2D\uFF0C\u4ECA\u5728\u5E90\u5C71\u8521\u91D1\u53F0\u5BB6\u3002\u201D\u4E8C\u6708\u4E8C\u65E5\uFF0C\u53F6\u606D\u7EF0\u8FC7\u8BBF\uFF0C\u5434\u6E56\u5E06\u51FA\u793A\u800C\u4E0E\u4E4B\u540C\u89C2\u3002\u4E8C\u6708\u5341\u4E94\u65E5\uFF0C\u5434\u6E56\u5E06\u5728\u65E5\u8BB0\u4E2D\u5199\u9053\uFF1A\u201C\u4E34\u90ED\u7199\u300A\u5E7D\u8C37\u56FE\u300B\u4E00\u89D2\u3002\u201D\u4ECA\u5434\u6E56\u5E06\u300A\u4E34\u90ED\u7199\u5E7D\u8C37\u56FE\u300B\u4ECD\u5B58\u4E16\u3002</p>",
        slides: [
            {
                url: $johf1["sight-6651-1.jpg"],
                points: []
            }
        ]
    },
    "sight-8857": {
        caption: "\u4E94\u4EE3 \u8463\u6E90 \u590F\u5C71\u56FE\u5377",
        thumbnail: $johf1["sight-8857-0.jpg"],
        description: "<p>\u8463\u6E90\uFF0C\u4E94\u4EE3\u5357\u5510\u753B\u5BB6\uFF0C\u5357\u6D3E\u5C71\u6C34\u753B\u5F00\u5C71\u9F3B\u7956\u3002</p><p>\u6B64\u5377\u66FE\u7ECF\u5434\u6E56\u5E06\u5916\u7956\u6C88\u97F5\u521D\u548C\u5E9E\u83B1\u81E3\u9012\u85CF\uFF0C\u4E0E\u73B0\u85CF\u6545\u5BAB\u535A\u7269\u9662\u7684\u8463\u6E90\u300A\u6F47\u6E58\u56FE\u300B\u5377\u3001\u7F8E\u56FD\u5927\u90FD\u4F1A\u535A\u7269\u9986\u7684\u300A\u6EAA\u5CB8\u56FE\u300B\u8F74\uFF08\u65F6\u7686\u4E3A\u5F20\u5927\u5343\u6536\u85CF\uFF09\uFF0C\u7686\u66FE\u7ECF\u5434\u6E56\u5E06\u8FC7\u76EE\u3002\u5728\u5434\u6C0F\u81EA\u7ED8\u300A\u6F47\u6E58\u96E8\u8FC7\u56FE\u300B\u8F74\u7B49\u81EA\u9898\u4E2D\u5C61\u6709\u63D0\u53CA\uFF0C\u201C\u76D6\u4E00\u65F6\u7B14\u4E5F\uFF0C\u7B14\u52BF\u96C4\u5947\u7F1C\u5BC6\uFF0C\u6D35\u827A\u6797\u5267\u8FF9\u3002\u201D</p><p>\u5434\u6E56\u5E06\u5341\u5206\u5173\u6CE8\u6C5F\u5357\u4E00\u5E26\u5C24\u5176\u662F\u6CAA\u4E0A\u5927\u85CF\u5BB6\u6240\u85CF\uFF0C\u6BD4\u5982\u5E9E\u83B1\u81E3\u5BB6\u85CF\u7684\u9EC4\u516C\u671B\u300A\u5FEB\u96EA\u65F6\u6674\u56FE\u300B\u5377\uFF08\u73B0\u85CF\u6545\u5BAB\uFF09\u7B49\uFF0C\u5434\u6C0F\u65E5\u8BB0\u867D\u672A\u4E00\u4E00\u8BE6\u5217\uFF0C\u4E14\u5E9E\u6C0F\u6240\u85CF\u5927\u90FD\u4EA6\u65E0\u5434\u6C0F\u672C\u4EBA\u9898\u9274\uFF0C\u4F46\u636E\u5176\u8BB0\u8F7D\u4ECD\u53EF\u6089\u77E5\uFF0C\u201C\u4F59\u4E8E\u5E9E\u6C0F\u753B\u6240\u89C1\u5341\u4E4B\u4E03\u516B\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["sight-8857-1.jpg"],
                zoomLevel: 5,
                points: []
            }
        ]
    },
    "sight-31403": {
        caption: "\u5143 \u738B\u8499 \u9752\u535E\u9690\u5C45\u56FE\u8F74",
        thumbnail: $johf1["sight-31403-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u738B\u8499\uFF081308-1385\uFF09\uFF0C\u5B57\u53D4\u660E\uFF0C\u53F7\u9EC4\u9E64\u5C71\u6A35\u3002\u5434\u5174\uFF08\u4ECA\u6D59\u6C5F\u6E56\u5DDE\uFF09\u4EBA\u3002\u201C\u5143\u56DB\u5BB6\u201D\u4E4B\u4E00\u3002\u56FE\u7ED8\u5176\u5BB6\u4E61\u5434\u5174\u535E\u5C71\u80DC\u666F\u3002\u6B64\u56FE\u4E3A\u5176\u4F20\u4E16\u4EE3\u8868\u4F5C\uFF0C\u81F3\u6B63\u4E8C\u5341\u516D\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E5D\u5C81\u3002</p><p>\u5434\u6E56\u5E06\u4E8E1935\u5E74\u6570\u6B21\u89C2\u6469\u6B64\u753B\uFF0C1937\u5E74\u65F6\u66FE\u8BB0\u8F7D\u72C4\u5E73\u5B50\u5C06\u6B64\u5B9D\u7269\u85CF\u4E8E\u6D77\u4E0A\u201C\u91D1\u57CE\u201D\uFF08\u4FDD\u9669\u67DC\uFF09\u4E2D\u7684\u201C\u5EFF\u516D\u53F7\u67DC\u201D\uFF0C\u67DC\u4E2D\u53E6\u6709\u72C4\u6C0F\u85CF\u94B1\u9009\u300A\u6D6E\u7389\u5C71\u5C45\u56FE\u300B\u5377\u7B49\u540D\u4EF6\uFF0C\u800C\u5434\u6E56\u5E06\u6240\u85CF\u7684\u672C\u5C55\u4E2D\u5434\u9547\u300A\u6E14\u7236\u56FE\u300B\u5377\u5219\u5BC4\u5B58\u4E8E\u201C\u5EFF\u4E03\u53F7\u201D\u67DC\u30021944\u5E74\uFF0C\u5434\u6C0F\u4E8E\u738B\u8499\u6B64\u753B\u4E0A\u9898\u5199\u89C2\u6B3E\u3002</p>",
        slides: [
            {
                url: $johf1["sight-31403-1.jpg"],
                points: [
                    {
                        x: 103,
                        y: 7931,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u7532\u7533\u56DB\u6708\u5434\u6E56\u5E06\u8C28\u89C2</p>"
                    }
                ]
            }
        ]
    },
    "sight-35731": {
        caption: "\u660E \u9648\u696B \u864E\u4E18\u5341\u4E8C\u666F\u56FE\u518C",
        thumbnail: $johf1["sight-35731-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["sight-35731-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-35731-2.jpg"],
                points: []
            },
            {
                url: $johf1["sight-35731-14.jpg"],
                points: [
                    {
                        x: 1698,
                        y: 264,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u8003\u8BA2\u4F5C\u8005\u751F\u5E73\uFF1A\u201C\u9648\u696B\uFF0C\u5B57\u83B1\u5C71\uFF0C\u53F7\u6D4E\u4E4B\uFF0C\u5434\u90E1\u4EBA\u3002\u660E\u4E07\u5386\u95F4\u4EE5\u753B\u540D\u4E8E\u65F6\u3002\u4E0E\u738B\u4EF2\u5C71\uFF08\u95EE\uFF09\u53CB\u5584\uFF0C\u4EF2\u5C71\u753B\u95F4\u51FA\u6D4E\u4E4B\u6349\u5200\uFF08\u89C1\u6545\u5BAB\u5468\u520A\u4EF2\u5C71\u5C71\u6C34\u4E00\u5E45\u5373\u9648\u7B14\u4E5F\uFF09\u3002\u6B64\u518C\u4E4B\u524D\u539F\u6709\u4EF2\u5C71\u4E66\u5F15\u9996\u56DB\u5B57\u53CA\u6587\u4F2F\u4EC1\u753B\u864E\u961C\u5168\u666F\u4E00\u5E45\uFF0C\u738B\u6587\u8083\u3001\u738B\u5F07\u5DDE\u7B49\u6570\u8DCB\uFF08\u94B1\u4F59\u521D\u89C1\u65F6\u672A\u7686\u4F5A\uFF09\uFF0C\u65CB\u88AB\u5EB8\u5DE5\u5272\u88C2\uFF0C\u5145\u5E02\u8D3E\u9152\u8D44\u77E3\uFF0C\u4E0D\u80DC\u60CB\u60DC\u3002\u540E\u6B64\u518C\u4E3A\u5F20\u5927\u5343\u5144\u6240\u89C1\uFF0C\u4EE5\u543E\u5434\u666F\u7269\u8D2D\u4E4B\u76F8\u8D60\u4E91\uFF0C\u7532\u620C\u51AC\u65E5\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["sight-35731-15.jpg"],
                points: [
                    {
                        x: 1818,
                        y: 340,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u8003\u8BC1\uFF1A\u201C\u9648\u696B\u4E4B\u540D\u4E0D\u89C1\u753B\u53F2\uFF0C\u5BA1\u5176\u6811\u77F3\u6781\u4F3C\u6234\u6587\u8FDB\u3001\u5434\u5C0F\u50CA\u3002\u5076\u53C2\u5357\u5B97\u5904\uFF0C\u5927\u7C7B\u8C22\u6A52\u4ED9\uFF0C\u4EBA\u7269\u4E43\u5468\u4E1C\u90A8\u4E4B\u4F59\u7EEA\uFF0C\u82B1\u5349\u5219\u9648\u767D\u9633\u4E4B\u65E9\u5E74\u3002\u5404\u6D3E\u54B8\u5177\u95E8\u6237\u3002\u89C2\u4EF2\u5C71\u8BF8\u753B\uFF0C\u77E5\u51FA\u9648\u6C0F\u624B\u4E0D\u5C11\uFF0C\u76D6\u5176\u540D\u4E3A\u4EF2\u5C71\u6240\u63A9\uFF0C\u6545\u4E16\u4F20\u4E0D\u5F70\u77E3\u3002\u5B8B\u4EBA\u51B7\u753B\u81F3\u660E\u5B63\u800C\u6709\u4EBA\u96C6\u5F55\uFF0C\u81F3\u6E05\u672B\u800C\u7ADF\u82E5\u81F3\u5B9D\u3002\u5B89\u77E5\u660E\u4EBA\u51B7\u753B\u4E0D\u4ECA\u65E5\u800C\u5165\u655D\u7B08\uFF0C\u540E\u65E5\u800C\u767B\u9526\u56CA\u8005\u4E4E\uFF01\u543E\u4E8E\u9648\u6C0F\u300A\u864E\u961C\u5341\u4E8C\u666F\u518C\u300B\u4E0D\u80DC\u6168\u53F9\u4E14\u73CD\u62A4\u7109\u3002\u60DC\u5A04\u4E1C\u4E8C\u738B\u8DCB\u4E4B\u88AB\u622A\u4E0E\u5E02\u4FA9\u800C\u4E0D\u5F97\u9884\u4E4B\u3002\u65F6\u4E59\u4EA5\uFF081935\uFF09\u6B63\u6708\u4E8C\u5341\u4E09\u65E5\u62E5\u7089\u591C\u5750\u9063\u95F7\u9898\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-8815": {
        caption: "\u5357\u5B8B \u8D75\u6784 \u4E34\u865E\u4E16\u5357\u771F\u8349\u5343\u5B57\u6587\u5377",
        thumbnail: $johf1["sight-8815-0.jpg"],
        description: "<p>\u6B64\u5377\u7528\u7B14\u4E0E\u8FBD\u5B81\u7701\u535A\u7269\u9986\u85CF\u8D75\u6784\u300A\u6D1B\u795E\u8D4B\u300B\u5377\u76F8\u5408\uFF0C\u5F53\u4E3A\u8D75\u6784\u540D\u8FF9\u3002\u5377\u540E\u6709\u9AD8\u5B97\u9898\u8DCB\u62BC\u5370\uFF0C\u5219\u79F0\u6B64\u5377\u4E3A\u5510\u865E\u4E16\u5357\u771F\u8FF9\u3002\u540E\u5143\u660E\u95F4\u4FDE\u53CB\u4EC1\u3001\u94B1\u5BB0\u53CA\u660E\u4EE3\u6536\u85CF\u5BB6\u9879\u5143\u6C74\u7B49\u9898\u8DCB\uFF0C\u4EA6\u7686\u8BA4\u4E3A\u662F\u865E\u4E66\u3002\u5434\u6E56\u5E06\u6536\u8D2D\u65F6\u4EA6\u5B9A\u4E3A\u865E\u4E66\u771F\u8FF9\uFF0C\u5E76\u5BF9\u6B64\u5377\u6D41\u4F20\u505A\u4E86\u8BE6\u5C3D\u7684\u8003\u8BC1\uFF0C\u5176\u53CB\u4EBA\u53F6\u606D\u7EF0\u3001\u5434\u6885\u7B49\u7686\u8D5E\u6210\u5176\u8BF4\u30021937\u5E74\uFF0C\u5434\u6E56\u5E06\u6839\u636E\u660E\u4EBA\u97E9\u9022\u79A7\u8BB0\u8F7D\uFF0C\u77E5\u9AD8\u5B97\u665A\u5E74\u559C\u6B22\u6479\u5199\u664B\u5510\u540D\u5BB6\u771F\u8FF9\u5E76\u6258\u540D\u9881\u8D50\u5927\u81E3\u4E3A\u4E50\u7684\u4E8B\u8FF9\uFF0C\u518D\u4E09\u8003\u8FA8\u540E\u5C06\u6B64\u5377\u4F5C\u8005\u6539\u5B9A\u4E3A\u5B8B\u9AD8\u5B97\uFF0C\u5C55\u793A\u4E86\u5176\u5B9E\u4E8B\u6C42\u662F\u7684\u5B66\u672F\u7CBE\u795E\u3002</p>",
        slides: [
            {
                url: $johf1["sight-8815-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 12736,
                        y: 472,
                        content: "<p>\u5B8B\u9AD8\u5B97\u9898\u8DCB\uFF1A \u201C\u8D50\u601D\u6E29\u201D\u3002</p>"
                    },
                    {
                        x: 10914,
                        y: 684,
                        content: "<p>\u201C\u865E\u4F2F\u65BD\u4E66\u7FF0\u4E4B\u7EDD\uFF0C\u6B86\u4E0E\u664B\u5B8B\u4E89\u8861\uFF0C\u771F\u8349\u5343\u6587\uFF0C\u5999\u51A0\u5F53\u4EE3\uFF0C\u53EF\u8C13\u4E1C\u5357\u4E4B\u7F8E\u4E5F\u3002\u6587\u7687\u65F6\u4F5C\u6B64\u4E66\uFF0C\u6545\u7B14\u6240\u9619\u8005\u2018\u6C11\u2019\u3001\u2018\u6E0A\u2019\u4E8C\u5B57\u800C\u5DF2\u201D\u3002</p>"
                    },
                    {
                        x: 10756,
                        y: 166,
                        content: "<p>\u5370\u7AE0\uFF1A\u767D\u6587\u201C\u771F\u9601\u201D\u846B\u82A6\u5370</p>"
                    },
                    {
                        x: 10592,
                        y: 176,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u771F\u9601\u4E8C\u5B57\u846B\u82A6\u5370\u4E43\u5B8B\u9AD8\u5B97\u7389\u73BA\u5370\u4E5F\u201D\u3002</p>"
                    },
                    {
                        x: 9038,
                        y: 690,
                        content: "<p>\u4FDE\u53CB\u4EC1\u9898\u8DCB\uFF1A\u201C\u771F\u8349\u5343\u6587\u81EA\u968B\u50E7\u667A\u6C38\u6240\u4E66\uFF0C\u5999\u7EDD\u4ECA\u53E4\uFF0C\u865E\u4F2F\u65BD\u4E34\u672C\u4E16\u4EA6\u7F55\u53CA\u3002\u4F59\u89C2\u6B64\u5E16\uFF0C\u975E\u4F2F\u65BD\u6240\u4E66\uFF0C\u5219\u4F59\u4EA6\u83AB\u80FD\u53CA\u4E5F\u3002\u830D\u975E\u771F\u672C\uFF0C\u5219\u601D\u9675\u5B89\u5F97\u6279\u8D50\u5927\u81E3\uFF0C\u800C\u7528\u5185\u5E9C\u56FE\u5370\u4EE5\u73CD\u91CD\u4E4B\u54C9\uFF1F\u4FDE\u53CB\u4EC1\u9898\u3002\u201D</p>"
                    },
                    {
                        x: 4674,
                        y: 303,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u5377\u5B8B\u9AD8\u5B97\u9898\u4E3A\u865E\u4F2F\u65BD\u771F\u8FF9\uFF0C\u5377\u672B\u2018\u8D50\u601D\u6E29\u2019\u4E09\u5B57\u4EA6\u601D\u9675\u5FA1\u7B14\uFF0C\u5E76\u94A4\u2018\u5FA1\u4E66\u2019\u5370\u3002\u4E07\u5386\u4E03\u5E74\u4E3A\u6A87\u674E\u9879\u6C0F\u5929\u7C41\u9601\u6240\u85CF\uFF0C\u540E\u5F52\u5B89\u5FBD\u5434\u6C0F\uFF0C\u590D\u4EE5\u5343\u91D1\u5F52\u543E\u5434\u97E9\u6C0F\uFF0C\u5F55\u5165\u300A\u5357\u9633\u6CD5\u4E66\u8868\u300B\u6B63\u4E66\u7C7B\u7B2C\u4E94\u3002\u8D8A\u4E94\u5E74\u800C\u5F52\u534E\u4EAD\u674E\u5468\u751F\u6C38\u660C\uFF0C\u81F3\u6E05\u54B8\u4E30\u95F4\u4E43\u85CF\u4E8E\u5408\u80A5\u5468\u6C0F\uFF0C\u53C8\u5165\u9879\u57CE\u8881\u6587\u8BDA\u516C\u5BB6\uFF0C\u4F59\u76D6\u5F97\u4E4B\u4E8E\u8881\u6C0F\u8005\u4E5F\u3002\u636E\u300A\u5357\u9633\u6CD5\u4E66\u8868\u300B\u8F7D\u6709\u5B8B\u9AD8\u5B97\u7B49\u8DCB\uFF0C\u5C1A\u6709\u5143\u4FDE\u3001\u94B1\u4E8C\u8DCB\u3002\u6309\u4FDE\u53CB\u4EC1\uFF0C\u5B57\u6587\u8F85\uFF0C\u4EC1\u548C\u4EBA\uFF0C\u5DE5\u8BD7\u4E66\u6587\u5B57\uFF0C\u6D2A\u6B66\u521D\u5F00\u79D1\uFF0C\u4E61\u3001\u4F1A\u8BD5\u4FF1\u5217\u7B2C\u4E00\u4EBA\uFF0C\u6388\u957F\u5C71\u53BF\u4E1E\u3001\u5C71\u897F\u4F65\u4E8B\u3002\u5F90\u8679\u4EAD\u300A\u672C\u4E8B\u8BD7\u300B\u8BB0\u738B\u8499\u5BAB\u8BCD\uFF0C\u4EC1\u548C\u4FDE\u53CB\u4EC1\u89C1\u4E4B\uFF0C\u53F9\u8D4F\u66F0\u2018\u6B64\u5510\u4EBA\u5F97\u610F\u53E5\u4E5F\u2019\uFF0C\u9042\u4EE5\u5176\u59B9\u59BB\u4E4B\u3002\u94B1\u5BB0\u5B57\u4F2F\u5747\uFF0C\u53C8\u5B57\u5B50\u4E88\uFF0C\u4F1A\u7A3D\u4EBA\uFF0C\u767B\u81F3\u6B63\u95F4\u7532\u79D1\uFF0C\u8D1F\u5112\u540D\uFF0C\u6D2A\u6B66\u521D\u5F81\u4FEE\u793C\u4E50\uFF0C\u6388\u56FD\u5B50\u52A9\u6559\uFF0C\u8FDB\u535A\u58EB\uFF0C\u540E\u547D\u8BA2\u6B63\u300A\u5C1A\u4E66\u8521\u6C0F\u4F20\u300B\uFF0C\u4E66\u6210\u8D50\u5F52\uFF0C\u6709\u300A\u4E34\u5B89\u96C6\u300B\u3002\u6B64\u5377\u81EA\u5B8B\u5143\u4EE5\u6765\u85CF\u5E8B\u53EF\u8003\uFF0C\u4ECA\u4E3A\u543E\u5BB6\u6885\u666F\u4E66\u5C4B\u6CD5\u4E66\u51A0\u5195\uFF0C\u5343\u5E74\u58A8\u5B9D\uFF0C\u957F\u7559\u5929\u58E4\uFF0C\u5E94\u968F\u6240\u81F3\u6709\u5409\u7965\u4E91\u5475\u62A4\u4E4B\u4E91\uFF0C\u5434\u6E56\u5E06</p>"
                    },
                    {
                        x: 2645,
                        y: 876,
                        content: "<p>\u53F6\u606D\u7EF0\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u6C38\u5174\u771F\u8FF9\u5E73\u751F\u60DF\u89C1\u6B64\u4E0E\u300A\u6C5D\u5357\u516C\u4E3B\u5FD7\u6587\u300B\uFF0C\u5FD7\u6587\u602F\u61E6\uFF0C\u8C13\u4E3A\u7C73\u6479\u3002\u5C1A\u672A\u6562\u907D\u4FE1\u3002\u66E9\u666F\u6734\u5B59\u6B32\u4EE5\u89C1\u8BA9\uFF0C\u672A\u6562\u627F\u4E5F\u3002\u6B64\u5377\u6C14\u97F5\u6C89\u539A\uFF0C\u4F3C\u975E\u5B8B\u4EBA\u6240\u80FD\u529E\uFF0C\u660E\u773C\u4EBA\u5F53\u80FD\u8FA8\u4E4B\u3002\u81F3\u4E8E\u7EE2\u7D20\u5370\u7AE0\u4E4B\u8BC6\u522B\uFF0C\u6291\u5176\u6B21\u4E5F\u3002\u5176\u5C11\u89C1\u516C\u79C1\u8457\u5F55\uFF0C\u5219\u660E\u73E0\u5076\u9057\u73CA\u7F51\uFF0C\u672A\u53EF\u4EE5\u6B64\u9042\u5224\u771F\u8D5D\u3002\u6E56\u5E06\u5F97\u6B64\u5F02\u5B9D\uFF0C\u76CA\u4E3A\u9AD8\u658B\u589E\u8272\u77E3\u3002\u53F6\u606D\u7EF0\u83B7\u89C2\u56E0\u5FD7\u3002</p>"
                    },
                    {
                        x: 2146,
                        y: 162,
                        content: "<p>\u5434\u6885\u9898\u8DCB\uFF1A\u201C\u5C71\u8C37\u9898\u300A\u5E99\u5802\u7891\u300B\u4E91\uFF1A\u2018\u5B54\u5E99\u865E\u4E66\u8D1E\u89C2\u523B\uFF0C\u5343\u4E24\u9EC4\u91D1\u54EA\u8D2D\u5F97\uFF1F\u2019\u6B64\u5219\u6C38\u5174\u771F\u8FF9\u3001\u7ECD\u5174\u9898\u8BC6\uFF0C\u771F\u65E0\u4EF7\u7470\u5B9D\u77E3\u3002\u6E56\u5E06\u5F97\u6B64\u6CAA\u5E02\uFF0C\u51FA\u4EE5\u89C1\u793A\uFF0C\u81EA\u8BE9\u773C\u798F\u53EF\u4EE5\u50B2\u5C71\u8C37\u4E91\u3002\u5E9A\u5348\u4E03\u6708\uFF0C\u971C\u5393\u5434\u6885\u656C\u89C2\u3002\u201D</p>"
                    },
                    {
                        x: 39098,
                        y: 153,
                        content: "<p>\u5434\u6E56\u5E06\u518D\u8DCB\u91CA\u6587\uFF1A\u201C\u636E\u97E9\u9022\u79A7\u300A\u9EC4\u5EAD\u7ECF\u300B\u8DCB\u4E91\uFF1A\u5B8B\u601D\u9675\u665A\u5C81\u5C45\u5FB7\u5BFF\u5BAB\uFF0C\u6BCF\u6479\u5199\u4E8C\u738B\u53CA\u664B\u5510\u660E\u8D24\u771F\u8FF9\uFF0C\u6258\u540D\u81EA\u8DCB\u4EE5\u8D50\u5927\u81E3\u4E3A\u4E50\u3002\u543E\u5BB6\u6240\u85CF\u5982\u300A\u9EC4\u5EAD\u7ECF\u300B\u3001\u865E\u4E16\u5357\u300A\u5343\u6587\u300B\u7686\u662F\u7109\uFF0C\u4E91\u4E91\u3002\u4ECA\u5BA1\u6B64\u5377\u6709\u601D\u9675\u81EA\u8DCB\u53CA\u2018\u8D50\u601D\u6E29\u2019\u62BC\uFF0C\u53EF\u77E5\u51FA\u601D\u9675\u4E3A\u65E0\u7591\u3002\u4E01\u4E11\uFF081937\uFF09\u56DB\u6708\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-13756": {
        caption: "\u660E \u4EC7\u82F1 \u53F3\u519B\u4E66\u6247\u56FE\u8F74",
        thumbnail: $johf1["sight-13756-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u9B4F\u5EAD\u8363\u6350\u8D60</p><p>\u6B64\u300A\u53F3\u519B\u4E66\u6247\u56FE\u300B\u8F74\u65E0\u4F5C\u8005\u6B3E\u5370\uFF0C\u5434\u6E56\u5E06\u4E3A\u53CB\u4EBA\u6797\u5C14\u537F\u9274\u5B9A\u6B64\u56FE\uFF0C\u5C06\u5176\u4E0E\u6545\u5BAB\u535A\u7269\u9662\u85CF\u4EC7\u82F1\u300A\u6850\u9634\u6E05\u8BDD\u56FE\u300B\u548C\u300A\u8549\u9634\u7ED3\u590F\u56FE\u300B\u4E8C\u5927\u5E45\u76F8\u6BD4\u5BF9\uFF0C\u53D1\u73B0\u5176\u5171\u540C\u7279\u70B9\u4E3A\uFF1A\u56DB\u89D2\u9879\u6C0F\u6240\u94A4\u516B\u5370\u76F8\u540C\uFF0C\u7B14\u6CD5\u4FF1\u5B97\u9A6C\uFF08\u8FDC\uFF09\u3001\u590F\uFF08\u572D\uFF09\uFF0C\u800C\u6BCF\u56FE\u4FF1\u4F5C\u4E8C\u4EBA\u4E00\u7AE5\u5B50\uFF0C\u683C\u5C40\u76F8\u7C7B\u3002\u8FDB\u800C\u63A8\u77E5\u6B64\u65E0\u6B3E\u300A\u53F3\u519B\u4E66\u6247\u56FE\u300B\u8F74\u5E94\u662F\u4EC7\u82F1\u4E3A\u9879\u5143\u6C74\u6240\u4F5C\u56DB\u5927\u5E45\u4E4B\u4E00\uFF0C\u81F3\u4ECA\u72B9\u4E3A\u5B9A\u8BBA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-13756-1.jpg"],
                points: [
                    {
                        x: 1768,
                        y: 200,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u660E\u4EC7\u5B9E\u7236\u4E3A\u9879\u5B50\u4EAC\u753B\u300A\u53F3\u519B\u4E66\u6247\u56FE\u300B\u771F\u8FF9\uFF0C\u65E0\u4E0A\u795E\u54C1\u3002\u5B9E\u7236\u4E3A\u5B50\u4EAC\u753B\u300A\u6D88\u590F\u56FE\u300B\u90FD\u56DB\u5927\u5E45\u3002\u4E8C\u5E45\u85CF\u6545\u5BAB\u535A\u7269\u9662\uFF0C\u4E00\u66F0\u300A\u8549\u836B\u7ED3\u590F\u56FE\u300B\uFF08\u8F7D\u300A\u77F3\u6E20\u5B9D\u7B08\u300B\uFF09\uFF0C\u4E00\u66F0\u300A\u6850\u9634\u6E05\u8BDD\u56FE\u300B\uFF08\u8F7D\u300A\u5B9D\u7B08\u4E09\u7F16\u300B\uFF09\u3002\u4F59\u7686\u5BD3\u76EE\uFF0C\u5BBD\u9AD8\u4E0E\u6B64\u5C3A\u5BF8\u6089\u540C\u3002\u300A\u8549\u836B\u7ED3\u590F\u56FE\u300B\u6B3E\u66F0\u2018\u4EC7\u82F1\u620F\u5199\u2019\u3002\u300A\u6850\u9634\u6E05\u8BDD\u56FE\u300B\u4EA6\u65E0\u6B3E\u8BC6\uFF08\u6709\u2018\u5341\u6D32\u4EC7\u82F1\u2019\u6570\u5B57\uFF0C\u7CFB\u540E\u6DFB\uFF09\uFF0C\u4E0E\u6B64\u4EA6\u540C\u3002\u56DB\u89D2\u9879\u6C0F\u6240\u94A4\u516B\u5370\u4EA6\u540C\u3002\u7B14\u6CD5\u4FF1\u5B97\u9A6C\u3001\u590F\uFF0C\u800C\u6BCF\u56FE\u4FF1\u4F5C\u4E8C\u4EBA\u4E00\u7AE5\u5B50\uFF0C\u683C\u5C40\u76F8\u7C7B\uFF0C\u53EF\u77E5\u4E3A\u4E00\u65F6\u4F5C\u65E0\u7591\u3002\u5176\u53E6\u4E00\u56FE\uFF0C\u636E\u4F20\u5728\u5434\u4E0E\u5E9E\u6C0F\uFF0C\u60DC\u672A\u89C1\u4E5F\u3002\u662F\u5E45\u5411\u85CF\u5185\u6C5F\u5F20\u6C0F\uFF0C\u4ECA\u5F52\u56DB\u660E\u5C14\u537F\u6797\u5148\u751F\u5148\u751F\u79D8\u7C4D\u3002\u4E19\u5B50\uFF081936\uFF09\u590F\u516D\u6708\u51FA\u793A\u5C5E\u9898\uFF0C\u4E61\u540E\u5B66\u5434\u6E56\u5E06\u9274\u5B9A\u5E76\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-19336": {
        caption: "\u660E \u94B1\u8C37 \u6EAA\u5C71\u6DF1\u79C0\u56FE\u5377",
        thumbnail: $johf1["sight-19336-0.jpg"],
        description: "<p>\u94B1\u8C37\u662F\u5434\u95E8\u753B\u6D3E\u7684\u91CD\u8981\u753B\u5BB6\uFF0C\u5434\u6E56\u5E06\u5BF9\u5176\u8BC4\u4EF7\u9887\u9AD8\uFF0C\u8BA4\u4E3A\u4ED6\u662F\u6587\u5F81\u660E\u6700\u51FA\u8272\u7684\u5F1F\u5B50\u3002\u5728\u6B64\u56FE\u7684\u9898\u8DCB\u4E2D\uFF0C\u5434\u6E56\u5E06\u901A\u8FC7\u7B14\u6CD5\u7684\u5206\u6790\uFF0C\u6307\u51FA\u94B1\u8C37\u5B97\u6CD5\u6C88\u5468\u3001\u6587\u5F81\u660E\u4E4B\u5916\uFF0C\u8FD8\u4E0A\u8FFD\u5143\u4EBA\u753B\u6CD5\uFF0C\u683C\u5C40\u9614\u8FBE\uFF0C\u8FE5\u5F02\u4E8E\u540C\u4FAA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-19336-1.jpg"],
                points: [
                    {
                        x: 2045,
                        y: 80,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u94B1\u78EC\u5BA4\u6821\u5F55\u5584\u672C\u79D8\u7C4D\uFF0C\u53C8\u85CF\u4E66\u4E07\u5377\uFF0C\u590D\u5DE5\u753B\u5C71\u6C34\uFF0C\u4E3A\u6587\u95E8\u5F1F\u5B50\u4E4B\u51A0\u3002\u6B64\u5377\u4E3A\u738B\u5143\u7F8E\u4F5C\u300A\u6EAA\u5C71\u6DF1\u79C0\u56FE\u300B\uFF0C\u81EA\u8C13\u5E73\u751F\u80FD\u4E8B\u5C3D\u6B64\u77E3\u3002\u51B5\u6709\u5143\u7F8E\u9898\u8BB0\uFF0C\u76CA\u81FB\u6545\u5B9D\u3002\u4F59\u5F97\u85CF\u4E4B\uFF0C\u4E3A\u4E61\u5148\u8D24\u624B\u6CFD\u589E\u5149\u4E0D\u5C11\uFF0C\u5982\u6B64\u8896\u73CD\u957F\u5377\uFF0C\u5F25\u76CA\u5B9D\u8D35\u3002\u7532\u620C\uFF081934\uFF09\u4E8C\u6708\uFF0C\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    },
                    {
                        x: 844,
                        y: 463,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u53D4\u5B9D\u7B14\u6CD5\u867D\u4E0D\u79BB\u4E4E\u77F3\u7530\u3001\u8861\u5C71\uFF0C\u6C89\u7740\u6D51\u96C4\u9887\u6709\u738B\u5B5F\u7AEF\u6C14\u5473\uFF0C\u53EF\u77E5\u5176\u5F97\u529B\u4E8E\u5143\u8D24\u5904\u4EA6\u751A\u6DF1\u3002\u540C\u65F6\u82E5\u9646\u53D4\u5E73\u3001\u9648\u9053\u590D\u3001\u5C45\u58EB\u8D1E\u3001\u6587\u627F\u5FB7\u8F88\u54B8\u4EE5\u5CED\u52B2\u80DC\u4EBA\uFF0C\u72EC\u53D4\u5B9D\u4EE5\u5706\u7B14\u76F4\u4E0B\uFF0C\u7EE7\u8F68\u6C88\u6587\uFF0C\u4E0A\u8FFD\u4EF2\u572D\uFF0C\u89C4\u6A21\u4EA6\u6700\u5927\uFF0C\u51B5\u6B64\u5377\u81EA\u8BE9\uFF0C\u8DB3\u89C1\u6D41\u9732\u5F97\u610F\u4E5F\uFF0C\u4E0D\u72EC\u738B\u5143\u7F8E\u5F97\u4E4B\u800C\u503E\u5012\u82E5\u6B64\u3002\u6885\u666F\u4E66\u5C4B\u53C8\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-19800": {
        caption: "\u660E \u8463\u5176\u660C \u753B\u7985\u5BA4\u5C0F\u666F\u56FE\u518C",
        thumbnail: $johf1["sight-19800-0.jpg"],
        description: "<p>\u5434\u6E56\u5E06\u4E00\u751F\u63A8\u5D07\u8463\u5176\u660C\u7684\u753B\u98CE\u53CA\u753B\u5B66\u601D\u60F3\uFF0C\u53CD\u590D\u5927\u91CF\u5730\u89C2\u4E34\uFF0C\u5BF9\u8463\u753B\u7684\u7406\u89E3\u4E0E\u8BA4\u8BC6\u6781\u4E3A\u7CBE\u786E\u3002\u6B64\u8DCB\u6307\u51FA\u8BE5\u518C\u4E3A\u8463\u5176\u660C\u539F\u88C5\uFF0C\u4EA6\u7CFB\u76EE\u524D\u4F20\u4E16\u8463\u6C0F\u4F5C\u54C1\u4E2D\u4EC5\u89C1\u3002</p>",
        slides: [
            {
                url: $johf1["sight-19800-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-19800-2.jpg"],
                points: []
            },
            {
                url: $johf1["sight-19800-4.jpg"],
                points: [
                    {
                        x: 1752,
                        y: 218,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u601D\u7FC1\u4EB2\u7B14\u9898\u7B7E\u66F0\u2018\u753B\u7985\u5BA4\u5C0F\u666F\u2019\u56DB\u5E45\uFF0C\u76D6\u968F\u7B14\u81EA\u8D4F\u4E4B\u4F5C\u4E5F\u3002\u62BC\u89D2\u4FF1\u6709\u2018\u8463\u6C0F\u5BB6\u85CF\u2019\u5C0F\u5370\uFF0C\u72B9\u662F\u660E\u4EE3\u521D\u88C5\uFF0C\u66F4\u53EF\u5B9D\u7231\u3002\u8463\u753B\u4E2D\u65E0\u4E0A\u7CBE\u54C1\u4E5F\u3002\u5DF1\u5DF3\uFF081929\uFF09\u4E09\u6708\u6536\u5165\u4F59\u5B9D\u8463\u5BA4\u4E2D\u3002\u4E11\u7C03\u9898\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-20015": {
        caption: "\u6E05 \u738B\u7FDA \u4EFF\u5173\u4EDD\u6EAA\u5C71\u6674\u972D\u56FE\u5377",
        thumbnail: $johf1["sight-20015-0.jpg"],
        description: "<p>\u56DB\u738B\u5434\u607D\u662F\u6E05\u4EE3\u753B\u575B\u7684\u4E3B\u6D41\u753B\u6D3E\uFF0C\u5176\u4F5C\u54C1\u5434\u6E56\u5E06\u9274\u85CF\u7279\u591A\uFF0C\u5BF9\u4ED6\u4EEC\u7684\u7ED8\u753B\u98CE\u683C\u4E5F\u683C\u5916\u719F\u6089\uFF0C\u591A\u6B21\u5728\u9898\u8DCB\u4E2D\u8BC4\u8BBA\u8003\u636E\u3002\u6B64\u5377\u540E\u5373\u6709\u5434\u6C0F\u5BF9\u738B\u7FDA\u4F5C\u54C1\u98CE\u683C\u53CA\u6C34\u5E73\u7684\u7CBE\u5F69\u8BC4\u8BBA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-20015-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 1429,
                        y: 84,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4F59\u4E8C\u5341\u5E74\u6765\u6240\u89C1\u77F3\u8C37\u753B\u5377\u7EA6\u56DB\u5341\u4F59\u672C\uFF0C\u800C\u7CBE\u7EC6\u4E4B\u4F5C\u6709\u5341\u4E03\u516B\u672C\uFF0C\u60DF\u4EE5\u6B64\u5377\u300A\u4EFF\u5173\u4EDD\u6EAA\u5C71\u6674\u972D\u56FE\u300B\u4E3A\u7B2C\u4E00\u3002\u6309\u77F3\u8C37\u5728\u56DB\u5341\u5C81\u5DE6\u53F3\uFF0C\u7ECF\u70DF\u5BA2\u6307\u793A\u4E34\u6479\u5B8B\u5143\u540D\u8FF9\u540E\u827A\u4E43\u5927\u6210\uFF0C\u6545\u77F3\u8C37\u753B\u4EE5\u56DB\u5341\u81F3\u4E94\u5341\u5C81\u4E3A\u6700\u7CBE\uFF0C\u800C\u6479\u53E4\u4E3A\u5C24\u5DE5\uFF0C\u4E14\u77F3\u8C37\u957F\u4E8E\u5B8B\u753B\u800C\u4E0D\u5C1A\u6479\u5143\uFF0C\u76D6\u77F3\u8C37\u4E4B\u529F\u529B\u80DC\u4E8E\u795E\u97F5\uFF0C\u8BBE\u8272\u80DC\u4E8E\u6C34\u58A8\u3002\u6B64\u5377\u4E3A\u56DB\u5341\u4E03\u5C81\u6479\u5173\u4EDD\u7B14\u6CD5\uFF0C\u4E0D\u72EC\u4E3A\u77F3\u8C37\u751F\u5E73\u7B2C\u4E00\u5408\u4F5C\uFF0C\u800C\u660E\u6E05\u4EE5\u6765\u65E0\u7B2C\u4E8C\u4EBA\u80FD\u4E3A\u4E4B\u3002\u5C31\u4F59\u6240\u89C1\u77F3\u8C37\u4EFF\u5B8B\u4EBA\u7B14\uFF0C\u4EE5\u5173\u4EDD\u3001\u8303\u5BBD\u4E3A\u6700\u64C5\u957F\uFF0C\u4EA6\u6700\u5C20\u89C1\uFF0C\u4EC5\u4E8E\u518C\u4E2D\u5076\u7136\u5BD3\u76EE\u4E00\u3001\u4E8C\uFF0C\u82E5\u957F\u5377\u3001\u5DE8\u8F74\u56FA\u672A\u4E4B\u83B7\u89C1\u4E5F\u3002\u6B64\u672C\u5728\u4E8C\u5341\u5E74\u524D\u66FE\u89C1\u4E4B\uFF0C\u5FC3\u76EE\u4E0D\u5FD8\u8005\u7E8D\u5C81\uFF0C\u4ECA\u590D\u83B7\u4E4B\uFF0C\u6D35\u664F\u5143\u732E\u8BCD\u66F0\u2018\u4F3C\u66FE\u76F8\u8BC6\u71D5\u5F52\u6765\u2019\u662F\u4E5F\u3002\u620A\u5BC5\u4E2D\u79CB\uFF0C\u8D28\u4E4B\u5B59\u90A6\u745E\u5144\u4EE5\u4E3A\u7136\u5426\uFF1F\u5434\u6E56\u5E06\u8BC6\u4E8E\u6885\u666F\u4E66\u5C4B\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-20016": {
        caption: "\u6E05 \u738B\u7FDA \u4EFF\u5DE8\u7136\u590F\u5C71\u70DF\u96E8\u56FE\u5377",
        thumbnail: $johf1["sight-20016-0.jpg"],
        description: "<p>\u5EB7\u7199\u5341\u4E94\u5E74\uFF081676\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6B64\u56FE\u5377\u4E0E\u300A\u4EFF\u5173\u4EDD\u6EAA\u5C71\u6674\u972D\u56FE\u300B\u5377\u85CF\u4E8E\u4E00\u5323\uFF0C\u4E3A\u5434\u6C0F\u201C\u4EFF\u4E94\u4EE3\u5173\u4EDD\u3001\u5DE8\u7136\u6674\u96E8\u53CC\u5377\u4E4B\u4E00\u201D\uFF0C\u4F5C\u4E8E1676\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u56DB\u5341\u4E94\u5C81\u3002</p><p>\u672C\u5377\u4E2D\u5434\u6E56\u5E06\u5BF9\u738B\u7FDA\u7684\u753B\u98CE\u5206\u4E3A\u4E94\u4E2A\u65F6\u671F\uFF0C\u201C\u6545\u77F3\u8C37\uFF08\u738B\u7FDA\uFF09\u753B\u5F53\u4EE5\u56DB\u5341\u81F3\u4E94\u5341\u4E3A\u6781\u8BE3\u3002\u4E94\u5341\u81F3\u516D\u5341\u81EA\u5177\u9762\u76EE\u3002\u516D\u5341\u81F3\u4E03\u5341\u6E10\u843D\u4FD7\u5957\uFF0C\u6BCF\u5931\u97F5\u81F4\u3002\u4E03\u5341\u81F3\u516B\u5341\u6709\u8870\u9893\u6C14\u3002\u516B\u5341\u4EE5\u5916\u53C8\u590D\u53D8\u5316\u5165\u795E\uFF0C\u7528\u7B14\u5982\u4E07\u5C81\u67AF\u85E4\uFF0C\u82CD\u8FA3\u517C\u5177\uFF0C\u6709\u7A7A\u524D\u7EDD\u540E\u4E4B\u5999\u3002\u540E\u4EBA\u4E4B\u8BCB\u8AC6\u77F3\u8C37\u8005\uFF0C\u76D6\u591A\u89C1\u5176\u516D\u5341\u4EE5\u540E\u516B\u5341\u4EE5\u524D\u4F5C\u4E5F\u3002\u201D\u53EF\u4EE5\u770B\u5230\uFF0C\u57FA\u4E8E\u68B3\u7406\u98CE\u683C\u6F14\u53D8\u4F5C\u4E3A\u6BD4\u8F83\u5224\u65AD\u7684\u4F9D\u636E\uFF0C\u662F\u5434\u6C0F\u9274\u7814\u53E4\u4E66\u753B\u8FC7\u7A0B\u4E2D\u8FD0\u7528\u8F83\u591A\u7684\u91CD\u8981\u624B\u6BB5\u3002</p>",
        slides: [
            {
                url: $johf1["sight-20016-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 1572,
                        y: 89,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u77F3\u53E4\u5B50\u5E74\u56DB\u5341\u5DE6\u53F3\uFF0C\u5728\u5A04\u4E1C\u738B\u5949\u5E38\u5BB6\u4E34\u6479\u5B8B\u5143\u540D\u8FF9\uFF0C\u827A\u4E43\u5927\u6210\u3002\u95F4\u4E3A\u592A\u5E38\u4EE3\u7B14\uFF0C\u4EB2\u53D7\u6307\u70B9\uFF0C\u76CA\u81FB\u795E\u5316\uFF0C\u6545\u77F3\u8C37\u753B\u5F53\u4EE5\u56DB\u5341\u81F3\u4E94\u5341\u4E3A\u6781\u8BE3\uFF0C\u4E94\u5341\u81F3\u516D\u5341\u81EA\u5177\u9762\u76EE\uFF0C\u516D\u5341\u81F3\u4E03\u5341\u6E10\u843D\u4FD7\u5957\u3001\u6BCF\u5931\u97F5\u81F4\uFF0C\u4E03\u5341\u81F3\u516B\u5341\u6709\u8870\u9893\u6C14\uFF0C\u516B\u5341\u4EE5\u5916\u53C8\u590D\u53D8\u5316\u3002\u5165\u795E\u7528\u7B14\uFF0C\u5982\u4E07\u5C81\u67AF\u85E4\uFF0C\u82CD\u8FA3\u517C\u5177\uFF0C\u6709\u7A7A\u524D\u7EDD\u540E\u4E4B\u5999\u3002\u540E\u4EBA\u4E4B\u8BCB\u8AC6\u77F3\u8C37\u8005\uFF0C\u76D6\u591A\u89C1\u5176\u516D\u5341\u4EE5\u540E\u516B\u5341\u4EE5\u524D\u4F5C\u4E5F\u3002\u6B64\u5377\u5EB7\u7199\u4E19\u8FB0\u6B63\u56DB\u5341\u4E94\u5C81\uFF0C\u4E34\u53E4\u800C\u80FD\u8131\u53E4\u4E4B\u4F5C\uFF0C\u6545\u683C\u5EA6\u795E\u97F5\u65E0\u4E0D\u5999\u5230\u6BEB\u98A0\uFF0C\u6240\u4EFF\u5DE8\u7136\u5927\u7565\u4E0E\u6D77\u91CE\u56FE\u76F8\u4F3C\uFF0C\u4E43\u6563\u4EBA\u5FC3\u795E\u4EA4\u4F1A\u800C\u81F4\uFF0C\u4E0E\u5BFB\u5E38\u610F\u4E3A\u8005\u4E0D\u53EF\u540C\u8BED\u4E5F\u3002\u620A\u5BC5\uFF081938\uFF09\u4E2D\u79CB\u4E0E\u5B59\u90A6\u745E\u5144\u5F1F\u540C\u83B7\u5BD3\u76EE\uFF0C\u4E92\u8D4F\u4E0D\u7F6E\uFF0C\u5434\u6E56\u5E06\u5E76\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-31307": {
        caption: "\u6E05 \u738B\u7FDA \u65E9\u5E74\u5C71\u6C34\u56FE\u8F74",
        thumbnail: $johf1["sight-31307-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u738B\u7FDA\u4E09\u5341\u5C81\u524D\u7684\u4F5C\u54C1\u4F20\u4E16\u4E0D\u591A\uFF0C\u6B64\u56FE\u4E0E\u5176\u7678\u5DF3\uFF081653\uFF09\u4E8C\u5341\u4E8C\u5C81\u7684\u300A\u4EFF\u5DE8\u7136\u5C71\u6C34\u56FE\u300B\u8F74\uFF08\u4E0A\u6D77\u535A\u7269\u9986\u85CF\uFF09\u76F8\u8F83\uFF0C\u5C71\u6C34\u7ED3\u6784\u66F4\u8D8B\u89C4\u8303\uFF0C\u65E0\u7591\u7CFB\u5DF2\u53D7\u8001\u4E8C\u738B\u4EB2\u7099\u4E4B\u540E\u7684\u4F5C\u54C1\u3002\u7EA6\u4E3A\u4E8C\u5341\u4E03\u516B\u5C81\u4F5C\u54C1\uFF0C\u4E0E\u5176\u4E09\u5341\u4E00\u5C81\uFF081662\uFF09\u6240\u4F5C\u300A\u6EAA\u5C71\u96E8\u610F\u56FE\u300B\u8F74\uFF08\u7F8E\u56FD\u5927\u90FD\u4F1A\u535A\u7269\u9986\u85CF\uFF09\u76F8\u5148\u540E\u3002</p><p>\u4ECE\u8DCB\u6587\u53EF\u77E5\uFF0C\u5434\u6E56\u5E06\u6839\u636E\u201C\u8C61\u6587\u201D\u5370\u53CA\u738B\u7FDA\u4E66\u6CD5\u98CE\u683C\u7B49\u5224\u65AD\uFF0C\u6B64\u56FE\u5F53\u4E3A\u738B\u7FDA\u4E09\u5341\u5C81\u4EE5\u524D\u6240\u4F5C\u3002\u53EF\u89C1\u5434\u6C0F\u7684\u9274\u5B9A\u662F\u57FA\u4E8E\u5BF9\u77F3\u8C37\u4E00\u751F\u753B\u98CE\u7684\u7CBE\u8F9F\u5165\u91CC\u7684\u89C1\u89E3\uFF0C\u81F3\u4ECA\u4F9D\u7136\u4E3A\u7814\u9274\u8005\u6240\u7EE7\u627F\u3002</p>",
        slides: [
            {
                url: $johf1["sight-31307-1.jpg"],
                points: [
                    {
                        x: 3264,
                        y: 456,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u738B\u77F3\u8C37\u65E9\u5E74\u5B66\u767D\u77F3\u7FC1\u5C71\u6C34\u771F\u8FF9\u3002\u77F3\u8C37\u5B50\u521D\u540D\u8C61\u6587\uFF0C\u540E\u6613\u540D\u7FDA\u3002\u66FE\u5728\u6545\u5BAB\u535A\u7269\u9662\u83B7\u89C2\u5176\u5F31\u51A0\u65F6\u753B\u5C0F\u518C\u7F72\u540D\u2018\u8C61\u6587\u2019\uFF0C\u5176\u65F6\u5C1A\u672A\u4EE5\u7FDA\u540D\u4E5F\u3002\u4E66\u6CD5\u521D\u5B66\u7C73\u8944\u9633\uFF0C\u6B64\u5E27\u6B3E\u5F0F\u72B9\u4E0D\u8131\u7C73\u6CD5\u800C\u5DF2\uFF0C\u6613\u540D\u7FDA\uFF0C\u5370\u4E2D\u4ECD\u5B58\u2018\u8C61\u6587\u2019\uFF0C\u53EF\u8BC1\u4E3A\u521D\u6613\u540D\u65F6\u4E4B\u4F5C\u3002\u9A8C\u5176\u7B14\u6CD5\u6B3E\u4E66\uFF0C\u5F53\u5728\u4E09\u5341\u4EE5\u524D\u65E0\u7591\u3002\u5B63\u8FC1\u8001\u5F1F\u643A\u89C2\u5171\u7814\uFF0C\u56E0\u4E3A\u8BE0\u91CA\uFF0C\u4FFE\u4E3A\u8003\u8BC1\u77F3\u8C37\u753B\u8005\u4E4B\u52A9\u3002\u5434\u6E56\u5E06\uFF0C\u7532\u7533\uFF081944\uFF09\u516B\u6708\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-26743": {
        caption: "\u660E \u4EC7\u82F1 \u4EFF\u53E4\u4EBA\u7269\u56FE\u518C",
        thumbnail: $johf1["sight-26743-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u4EC7\u82F1\uFF08\uFF1F-\u7EA61552\uFF09\uFF0C\u5B57\u5B9E\u7236\uFF0C\u53F7\u5341\u6D32\uFF0C\u6C5F\u82CF\u592A\u4ED3\u4EBA\uFF0C\u5BD3\u5C45\u82CF\u5DDE\u3002</p><p>\u6B64\u56FE\u518C\u539F\u85CF\u4E8E\u674E\u62D4\u53EF\u5BB6\uFF0C\u539F\u6709\u4E8C\u5341\u5F00\uFF0C\u5176\u4E2D\u4E94\u5F00\u4E8E1932\u5E74\u6BC1\u4E8E\u6218\u706B\uFF0C\u4ECA\u5B58\u5341\u4E94\u5F00\u3002\u5434\u6E56\u5E06\u6307\u51FA\u6B64\u518C\u7684\u539F\u7A3F\u5C1A\u6709\u5B58\u8005\uFF0C\u4FDD\u5B58\u5728\u6545\u5BAB\u85CF\u300A\u5B8B\u5143\u4EBA\u96C6\u300B\u518C\u4E2D\u3002\u540C\u65F6\uFF0C\u6545\u5BAB\u85CF\u4EC7\u82F1\u4E3A\u9879\u5143\u6C74\u300A\u4E34\u5B8B\u5143\u753B\u518C\u300B\u516D\u5F00\uFF0C\u4EA6\u65E0\u7F72\u6B3E\u94A4\u5370\uFF0C\u6240\u7528\u7EE2\u4E0E\u6B64\u56FE\u518C\u76F8\u4F3C\u3002\u901A\u8FC7\u5BF9\u56FE\u518C\u7EE2\u8272\u3001\u7528\u7B14\u4E60\u6027\u7B49\u7EFC\u5408\u6BD4\u5BF9\uFF0C\u5434\u6E56\u5E06\u6700\u7EC8\u5F97\u51FA\u6B64\u56FE\u518C\u5F53\u662F\u4EC7\u82F1\u4E3A\u9879\u5143\u6C74\u6240\u4E34\u771F\u8FF9\u7684\u53EF\u4FE1\u7ED3\u8BBA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-26743-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-2.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-3.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-4.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-5.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-6.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-7.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-8.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-9.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-10.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-11.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-12.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-13.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-14.jpg"],
                points: []
            },
            {
                url: $johf1["sight-26743-15.jpg"],
                points: []
            }
        ]
    },
    "sight-31612": {
        caption: "\u660E \u674E\u6D41\u82B3 \u5C71\u6C34\u56FE\u518C",
        thumbnail: $johf1["sight-31612-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u674E\u6D41\u82B3\uFF081575-1629\uFF09\uFF0C\u5B57\u957F\u8605\uFF0C\u53F7\u6A80\u56ED\u3002\u5B89\u5FBD\u6B59\u53BF\u4EBA\uFF0C\u4FA8\u5C45\u5609\u5B9A\uFF08\u4ECA\u5C5E\u4E0A\u6D77\u5E02\uFF09</p><p>\u672C\u56FE\u518C\u662F\u5434\u6E56\u5E06\u63A5\u53D7\u5B59\u90A6\u745E\u9988\u8D60\u7684\u738B\u6B66\u300A\u82B1\u5349\u518C\u300B\u4E4B\u540E\uFF0C\u4F5C\u4E3A\u56DE\u62A5\u800C\u9898\u8D60\u7684\u3002\u5B59\u90A6\u745E\uFF081903-1972\uFF09\u662F\u6D77\u4E0A\u5B9E\u4E1A\u5BB6\u3001\u53E4\u4E66\u753B\u85CF\u5BB6\u5B59\u715C\u5CF0\uFF081901-1967\uFF09\u7684\u80DE\u5F1F\uFF0C\u6C5F\u82CF\u6C5F\u9634\u4EBA\u3002\u5B59\u90A6\u745E\u9177\u7231\u6536\u85CF\uFF0C\u4E0E\u5434\u6E56\u5E06\u6709\u901A\u5BB6\u4E4B\u8C0A\uFF0C\u5176\u85CF\u54C1\u591A\u7531\u5434\u6C0F\u9274\u5B9A\u3001\u9898\u8DCB\u3002\u9898\u8BC6\u4E2D\uFF0C\u5434\u6E56\u5E06\u7279\u522B\u63D0\u53CA\u6B64\u518C\u4EE5\u6781\u5C11\u89C1\u7684\u5B8B\u7EB8\u672C\u753B\u6210\uFF0C\u53EF\u89C1\u5176\u9274\u8D4F\u4E4B\u7CBE\u7EC6\u3002</p>",
        slides: [
            {
                url: $johf1["sight-31612-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-2.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-3.jpg"],
                points: [
                    {
                        x: 840,
                        y: 95,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u738B\u6E14\u6D0B\u6240\u85CF\u674E\u6A80\u56ED\u753B\u518C\uFF0C\u516B\u6862\uFF0C\u5B8B\u7EB8\u672C\uFF0C\u6C88\u7ECE\u5802\u3001\u6C6A\u949D\u7FC1\u7B49\u9898\u8F9E\uFF0C\u7686\u4E00\u65F6\u540D\u8D24\uFF0C\u835F\u8403\u4E00\u96C6\u3002\u539F\u6709\u5C48\u7FC1\u5C71\u4E00\u9898\uFF0C\u4E01\u4E11\uFF081937\uFF09\u4E71\u79BB\u4E2D\u9057\u53BB\u3002\u662F\u518C\u5411\u85CF\u5F20\u5927\u5343\u5904\uFF0C\u8FD1\u5C81\u59CB\u5F52\u655D\u7B08\uFF0C\u5C48\u9898\u5DF2\u4E0D\u5B58\u77E3\u3002\u9877\u90A6\u745E\u5144\u4EE5\u738B\u5FD8\u5EB5\u5728\u5C39\u5C71\u5784\u6B21\u6240\u753B\u518C\u59CB\u8D3B\uFF0C\u76D6\u9661\u5C7A\u4E4B\u601D\uFF0C\u767D\u4E91\u5728\u671B\uFF0C\u4F59\u4E0E\u5FD8\u5EB5\u540C\u611F\u3002\u56E0\u68C0\u6B64\u518C\u5949\u8D4F\uFF0C\u672A\u8DB3\u62A5\u5609\u60E0\u4E8E\u4E07\u4E00\u4E5F\u3002\u5E9A\u8FB0\uFF081940\uFF09\u5C81\u66AE\uFF0C\u5029\u5EB5\u5434\u6E56\u5E06\u6F2B\u8BC6\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["sight-31612-4.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-5.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-6.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-7.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-8.jpg"],
                points: []
            },
            {
                url: $johf1["sight-31612-9.jpg"],
                points: []
            }
        ]
    },
    "sight-31924": {
        caption: "\u5143 \u4F5A\u540D \u767E\u5C3A\u68A7\u6850\u56FE\u5377",
        thumbnail: $johf1["sight-31924-0.jpg"],
        description: "<p>\u56FE\u5377\u9996\u9898\u7F72\u201C\u5434\u5174\u8D75\u5B5F\u982B\u201D\u548C \u201C\u8D75\u6C0F\u5B50\u6602 \u201D\u6731\u6587\u65B9\u5370\u7686\u7CFB\u540E\u6DFB\u3002\u56FE\u7ED8\u6587\u4EBA\u56ED\u5C45\u95F2\u9002\u4E4B\u666F\u3002\u5EAD\u9662\u68A7\u6850\u679D\u53F6\u8302\u76DB\uFF0C\u53E4\u8DA3\u76CE\u7136\u3002\u636E\u8C22\u7A1A\u67F3\u8003\u5BDF\uFF0C\u6B64\u56FE\u662F\u6BD4\u8D75\u5B5F\u982B\u300A\u79CB\u90CA\u996E\u9A6C\u56FE\u300B\u66F4\u4E3A\u65E9\u671F\u7684\u4F5C\u54C1\u3002\u5085\u71B9\u5E74\u64B0\u5199\u300A\u5143\u4EBA\u7ED8\u3008\u767E\u5C3A\u68A7\u6850\u8F69\u56FE\u3009\u7814\u7A76\u300B\uFF0C\u6307\u51FA\u6B64\u56FE\u6240\u7ED8\u662F\u5F20\u58EB\u4FE1\u56ED\u5C45\u7684\u60C5\u666F\u3002</p><p>\u66FE\u7ECF\u660E\u4EBA\u5434\u5EF7\uFF08\u7528\u537F\uFF09\u3001\u6E05\u4EBA\u6881\u6E05\u6807\u548C\u8FD1\u4EBA\u5468\u6000\u6C11\u6536\u85CF\u3002\u5434\u6E56\u5E06\u4E8E1952\u5E74\u5E94\u6536\u85CF\u5BB6\u5468\u6C0F\u4E4B\u9080\u4E3A\u5176\u9898\u8DCB\u3002</p>",
        slides: [
            {
                url: $johf1["sight-31924-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 1143,
                        y: 120,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u677E\u96EA\u82B1\u771F\u4F3C\u7F13\u5E26\u8F7B\u88D8\uFF0C\u7389\u7C2A\u743C\u73EE\uFF0C\u98CE\u534E\u5BCC\u4E3D\u3002\u6545\u56FD\u738B\u5B59\u81EA\u5177\u6F47\u6D12\u4E30\u5EA6\uFF0C\u5B8B\u738B\u664B\u537F\u65E0\u6B64\u5A40\u5A1C\uFF0C\u660E\u4EC7\u5341\u6D32\u900A\u5176\u8574\u85C9\uFF0C\u6D35\u753B\u53F2\u4E2D\u5168\u624D\u4E5F\u3002\u5179\u767E\u5C3A\u68A7\u6850\u56FE\u5377\u6B63\u4E2D\u5C81\u7ECF\u8425\u4E4B\u4F5C\uFF0C\u56FE\u4E2D\u4E3B\u4EBA\u4E0D\u77E5\u8C01\u4F55\uFF0C\u5143\u8D24\u4E03\u9898\u4FF1\u672A\u53CA\uFF0C\u5176\u59D3\u6C0F\u5F85\u8003\u3002\u72EC\u738B\u53D4\u660E\u6B3E\u8BC6\u7528\u8C28\u9898\uFF0C\u5219\u8DB3\u8BC1\u677E\u96EA\u753B\u4E3A\u771F\u8FF9\u65E0\u7591\u3002\u4E49\u4E00\u5B57\u4E4B\u73CD\u4F59\u53EF\u4E0D\u8D58\u3002\u6000\u6C0F\u9053\u5144\u89C1\u793A\uFF0C\u8D28\u4E4B\u4EE5\u4E3A\u4F55\u5982\u3002\u58EC\u8FB0\u5927\u96EA\u5434\u6E56\u5E06\u89C2\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-34474": {
        caption: "\u660E \u9648\u6D2A\u7EF6 \u82B1\u9E1F\u8349\u866B\u56FE\u5377",
        thumbnail: $johf1["sight-34474-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u9648\u6D2A\u7EF6\uFF081598-1652\uFF09\uFF0C\u5B57\u7AE0\u4FAF\uFF0C\u53F7\u8001\u83B2\u3002\u6D59\u6C5F\u8BF8\u66A8\u4EBA\u3002</p><p>\u5434\u6E56\u5E06\u9898\u4E8E\u672C\u5E45\u672B\u5C3E\u7684\u7B2C\u4E00\u6BB5\u8DCB\u8BED\uFF0C\u7CFB\u4E3A\u539F\u6536\u85CF\u8005\u9EC4\u4EF2\u660E\u6240\u4F5C\u7684\u9274\u5B9A\u3002\u9EC4\u6C0F\u5F53\u65F6\u662F\u5546\u52A1\u5370\u4E66\u9986\u8944\u7406\uFF0C\u81EA\u5F00\u5370\u5237\u5382\uFF0C\u4E0E\u5434\u6E56\u5E06\u7B49\u6D77\u4E0A\u53E4\u4E66\u753B\u6536\u85CF\u5BB6\u4EA4\u5F80\u751A\u5BC6\u3002\u5434\u6E56\u5E06\u5728\u7B2C\u4E8C\u6B21\u9898\u8DCB\u4E2D\u63D0\u5230\uFF0C\u9002\u9022\u5F20\u5927\u5343\u81EA\u56DB\u5DDD\u6765\u6CAA\uFF0C\u4ED6\u4EEC\u4E00\u540C\u6B23\u8D4F\u540D\u753B\u7684\u60C5\u666F\u3002</p>",
        slides: [
            {
                url: $johf1["sight-34474-1.jpg"],
                zoomLevel: 5,
                points: [
                    {
                        x: 543,
                        y: 107,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u9648\u6094\u8FDF\u771F\u8FF9\u3002\u540E\u5B66\u5434\u6E56\u5E06\u9274\u5B9A\u3002\u201D\u201C\u524D\u65E5\u4EF2\u660E\u4E08\u643A\u793A\u8001\u83B2\u6B64\u5377\uFF0C\u9002\u5927\u5343\u81EA\u8700\u4E2D\u6765\uFF0C\u76F8\u4E0E\u5171\u8D4F\uFF0C\u53F9\u89C2\u6B62\u77E3\uFF0C\u5029\u5EB5\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-34476": {
        caption: "\u660E \u795D\u5141\u660E \u8349\u4E66\u674E\u767D\u4E94\u8A00\u53E4\u8BD7\u5377",
        thumbnail: $johf1["sight-34476-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u795D\u5141\u660E\uFF081460-1526\uFF09\uFF0C\u5B57\u5E0C\u54F2\uFF0C\u53F7\u679D\u5C71\uFF0C\u957F\u6D32\uFF08\u4ECA\u6C5F\u82CF\u82CF\u5DDE\uFF09\u4EBA\u3002</p><p>\u5377\u540E\u6709\u5434\u6E56\u5E06\u9898\u8DCB \u201C\u7532\u5348\uFF081954\uFF09\u6D88\u5BD2\uFF0C\u4E0E\u738B\u6587\u606A\u300A\u624B\u4E66\u8BD7\u300B\u5377\u540C\u83B7\u89C2\u6570\u9752\u8349\u5802\uFF0C\u5434\u5029\u3002\u201D\u5E76\u94A4\u6709\u201C\u6E56\u5E06\u9274\u8D4F\u201D\u5370\u7AE0\u3002\u201C\u6570\u9752\u8349\u5802\u201D\u662F\u94B1\u955C\u5858\u7684\u658B\u540D\uFF0C\u53EF\u77E5\u6B64\u5377\u5F53\u662F\u5434\u6E56\u5E06\u4E3A\u94B1\u955C\u5858\u8FDB\u884C\u54C1\u9274\u7684\u85CF\u54C1\u3002\u65F6\u5DF2\u6210\u4E3A\u6D77\u4E0A\u753B\u575B\u76DF\u4E3B\u7684\u5434\u6E56\u5E06\u5BF9\u4E8E\u6BD4\u4ED6\u5C0F\u5341\u591A\u5C81\u7684\u94B1\u955C\u5858\u9887\u6709\u63D0\u643A\u4E4B\u6069\u3002\u901A\u8FC7\u4E0E\u5434\u6E56\u5E06\u7684\u4EA4\u5F80\uFF0C\u94B1\u6C0F\u63D0\u9AD8\u4E86\u9274\u5B9A\u773C\u5149\uFF0C\u4E8C\u4EBA\u88AB\u8A89\u4E3A\u6D77\u4E0A\u201C\u9274\u5B9A\u53CC\u74A7\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["sight-34476-1.jpg"],
                points: [
                    {
                        x: 78,
                        y: 234,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A \u201C\u7532\u5348\uFF081954\uFF09\u6D88\u5BD2\uFF0C\u4E0E\u738B\u6587\u606A\u300A\u624B\u4E66\u8BD7\u300B\u5377\u540C\u83B7\u89C2\u6570\u9752\u8349\u5802\uFF0C\u5434\u5029\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-35365": {
        caption: "\u660E \u8463\u5176\u660C \u884C\u4E66\u82CF\u8F7C\u91CD\u4E5D\u8BCD\u8F74",
        thumbnail: $johf1["sight-35365-0.jpg"],
        description: "<p>\u5929\u542F\u5143\u5E74\uFF081621\uFF09</p><p>\u7EB8\u672C</p><p>\u8463\u5176\u660C\uFF081555-1636\uFF09\uFF0C\u5B57\u7384\u5BB0\uFF0C\u53F7\u9999\u5149\u5C45\u58EB\uFF0C\u534E\u4EAD\uFF08\u4ECA\u4E0A\u6D77\u677E\u6C5F\uFF09\u4EBA\u3002</p><p>\u6B64\u5377\u4E3A\u8463\u5176\u660C\u8F9B\u9149\u5E74\uFF081621\uFF09\u6240\u4E66\u82CF\u4E1C\u5761\u300A\u897F\u6C5F\u6708\u300B\u8BCD\u4E00\u9996\uFF1A\u201C\u70B9\u70B9\u697C\u524D\u7EC6\u96E8\uFF0C\u91CD\u91CD\u6C5F\u5916\u5E73\u6E56\u3002\u5F53\u5E74\u620F\u9A6C\u4F1A\u4E1C\u5F90\uFF0C\u4ECA\u65E5\u51C4\u51C9\u5357\u6D66\u3002\u83AB\u6068\u9EC4\u82B1\u672A\u5410\uFF0C\u4E14\u6559\u7EA2\u7C89\u76F8\u6276\u3002\u9152\u9611\u4E0D\u5FC5\u770B\u8331\u8438\uFF0C\u4FEF\u4EF0\u4EBA\u95F4\u4ECA\u53E4\u201D\u3002\u5434\u6E56\u5E06\u9898\u201C\u4E07\u5386\u8F9B\u9149\uFF0C\u516C\u4E94\u5341\u4E03\u5C81\u201D\u6709\u8BEF\uFF0C\u5E94\u4E3A\u5929\u542F\u8F9B\u9149\u8463\u5176\u660C\u5E74\u516D\u5341\u4E03\u5C81\u65F6\u4F5C\u3002\u5434\u6C0F\u9274\u5B9A\u6307\u51FA\u6B64\u8F74\u5F62\u5236\u4E0E\u672C\u5C55\u4E2D\u300A\u753B\u7985\u5BA4\u5C0F\u666F\u56FE\u300B\u518C\u7686\u5C5E\u660E\u4EE3\u4E07\u5386\u539F\u88C5\uFF0C\u6545\u5341\u5206\u73CD\u89C6\u3002</p>",
        slides: [
            {
                url: $johf1["sight-35365-1.jpg"],
                points: [
                    {
                        x: 1340,
                        y: 300,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u660E\u8463\u6587\u654F\u4E3A\u96F7\u5BB8\u752B\u4E66\u4E1C\u5761\u8BCD\u771F\u8FF9\u3002\u4E07\u5386\u8F9B\u9149\uFF0C\u516C\u4E94\u5341\u4E03\u5C81\u3002\u6B64\u5E27\u72B9\u662F\u4E07\u5386\u5F53\u65E5\u539F\u88C5\uFF0C\u66F4\u53EF\u5B9D\u8D35\u3002\u4F59\u84C4\u8463\u6C0F\u4E66\u753B\u5341\u6570\u4E8B\uFF0C\u5C1A\u5B58\u539F\u88C5\u8005\uFF0C\u7947\u620A\u5348\uFF081918\uFF09\u753B\u300A\u753B\u7985\u5BA4\u5C0F\u518C\u300B\u4E0E\u6B64\u8F74\u8033\u3002\u6F62\u6C60\u5982\u51FA\u4E00\u624B\uFF0C\u4E09\u767E\u5E74\u540E\u5434\u6E56\u5E06\u73CD\u7231\u903E\u6052\u3002\u4E19\u620C\uFF081946\uFF09\u957F\u590F\uFF0C\u6885\u666F\u4E66\u5C4B\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-39393": {
        caption: "\u5357\u5B8B \u4F5A\u540D \u6A31\u6843\u9EC4\u9E42\u56FE\u9875",
        thumbnail: $johf1["sight-39393-0.jpg"],
        description: "<p>\u672C\u56FE\u4F5C\u8005\u4E0D\u8BE6\uFF0C\u9898\u8005\u7CFB\u5357\u5B8B\u5B81\u5B97\u6768\u7687\u540E\uFF0C\u5434\u6E56\u5E06\u5728\u753B\u4E0A\u6709\u957F\u7BC7\u9898\u8DCB\u8003\u8BC1\u5176\u4EBA\u540D\u53F7\u4E4B\u5B9E\u3002</p>",
        slides: [
            {
                url: $johf1["sight-39393-1.jpg"],
                points: [
                    {
                        x: 1545,
                        y: 45,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5B8B\u5B81\u5B97\u540E\u6768\u59D3\u753B\u300A\u6A31\u6843\u9EC4\u9E42\u56FE\u300B\u771F\u8FF9\u3002\u662F\u5E27\u4E43\u6768\u7687\u540E\u753B\u8D60\u5176\u5144\u6C38\u9633\u90E1\u738B\u6768\u6B21\u5C71\u8005\u3002\u5370\u7AE0\u6587\u66F0\uFF1A\u2018\u7678\u9149\u5E74\u6625\u6768\u59D3\u4E4B\u7AE0\u2019\u516B\u5B57\u3002\u6309\uFF0C\u7678\u9149\u4E3A\u5357\u5B8B\u5B81\u5B97\u5609\u5B9A\u516D\u5E74\uFF081213\uFF09\u3002\u201D\u201C\u6309\uFF0C\u6768\u59D3\u4E4B\u4E66\u9898\uFF0C\u6709\u300A\u6545\u5BAB\u6240\u85CF\u4E66\u753B\u96C6\u300B\u7B2C\u5341\u4E00\u671F\u7B2C\u4E00\u54C1\u9A6C\u9E90\u753B\u300A\u5C42\u53E0\u51B0\u7EE1\u56FE\u300B\u9898\u7709\u56DB\u5B57\u53CA\u8BD7\u4E91\uFF1A\u2018\u6D51\u5982\u51B7\u8776\u5BBF\u82B1\u623F\uFF0C\u62B1\u62E5\u6A80\u5FC3\u5FC6\u65E7\u9999\u3002\u5F00\u5230\u5BD2\u68A2\u5C24\u53EF\u7231\uFF0C\u6B64\u822C\u5FC5\u662F\u6C49\u5BAB\u5986\u3002\u2019\u753B\u540E\u6CE8\u6768\u59D3\uFF0C\u8BEF\u4F5C\u6768\u5A03\uFF0C\u76D6\u5A03\u4E3A\u59D3\u4E4B\u59B9\uFF0C\u4E16\u79F0\u2018\u6768\u59B9\u5B50\u2019\u5176\u4EBA\u7109\u3002\u53C8\uFF0C\u6545\u5BAB\u85CF\u9A6C\u9E90\u753B\u300A\u6625\u82B1\u518C\u300B\u5341\u5E27\uFF0C\u5176\u6BCF\u5E27\u9898\u7709\u4EA6\u59D3\uFF0C\u4E66\u94A4\u5370\u66F0\u2018\u5764\u5B81\u777F\u7B14\u2019\u3002\u4EE5\u4E0A\u4E8C\u9898\uFF0C\u7686\u5609\u5B9A\u4E19\u5B50\u5E74\uFF081216\uFF09\u4E66\uFF0C\u8DDD\u6B64\u518C\u540E\u4E09\u5E74\uFF0C\u5434\u6E56\u5E06\u9274\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-39480": {
        caption: "\u660E \u5510\u5BC5 \u6B3E\u9E64\u56FE\u5377",
        thumbnail: $johf1["sight-39480-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u5434\u6E56\u5E06\u5BF9\u6B64\u56FE\u8FDB\u884C\u4E86\u5305\u62EC\u4E0A\u6B3E\u3001\u540D\u53F7\u3001\u5E74\u4EFD\u3001\u7B14\u6CD5\u7B49\u7EFC\u5408\u9274\u5B9A\uFF0C\u5E76\u4EE5\u5510\u5BC5\u300A\u5357\u5DDE\u501F\u5BBF\u56FE\u300B\u548C\u672C\u5C55\u6C88\u5468\u300A\u82D4\u77F3\u56FE\u300B\u8F74\u4F5C\u4E3A\u6BD4\u5BF9\u7684\u53C2\u7167\u7269\uFF0C\u6700\u7EC8\u5F97\u51FA\u201C\u6B64\u5377\u4E3A\u5C45\u58EB\u4E09\u5341\u4E03\u516B\u5C81\u4F5C\u53EF\u8BC1\u4E5F\u201D\u7684\u53EF\u4FE1\u7ED3\u8BBA\u3002\u53EF\u89C1\uFF0C\u5728\u5B9E\u9645\u9274\u7814\u8FC7\u7A0B\u4E2D\uFF0C\u5434\u6E56\u5E06\u6CE8\u91CD\u76F8\u5173\u6750\u6599\u7684\u7EFC\u5408\u6BD4\u5BF9\uFF0C\u8FDB\u800C\u4E3A\u5176\u7ED3\u8BBA\u63D0\u4F9B\u786E\u4FE1\u4F9D\u636E\uFF0C\u5E76\u4E0D\u4EC5\u4EC5\u4F9D\u9760\u4E3B\u89C2\u611F\u53D7\u4E0E\u7ECF\u9A8C\u3002</p>",
        slides: [
            {
                url: $johf1["sight-39480-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 1777,
                        y: 151,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B3E\u9E64\u4E3A\u738B\u9149\u5BA4\u540F\u90E8\u4E4B\u7236\uFF0C\u66FE\u89C1\u795D\u679D\u5C71\u4E66\u300A\u6B3E\u9E64\u5148\u751F\u5893\u5FD7\u300B\u58A8\u8FF9\u518C\u4E8E\u95FD\u53CB\u5904\uFF0C\u6B3E\u9E64\u5352\u5E74\u4E00\u65F6\u8BB0\u5FC6\u4E0D\u6E05\u77E3\u3002\u6309\u77F3\u7530\u7FC1\u5352\u4E8E\u5F18\u6CBB\u5DF1\u5DF3\uFF081509\uFF09\uFF0C\u5E74\u516B\u5341\u4E09\uFF0C\u662F\u5C81\u516D\u5982\u5C45\u58EB\u56DB\u5341\u5C81\u3002\u6B64\u5377\u753B\u6CD5\u4E0E\u516D\u5982\u4E4B\u300A\u5357\u5DDE\u501F\u5BBF\u56FE\u300B\u76F8\u540C\uFF0C\u5176\u4E3A\u4E00\u65F6\u4F5C\u65E0\u7591\u4E49\u3002\u53C8\u77F3\u7530\u7FC1\u8BD7\u9898\uFF0C\u4E0E\u543E\u5BB6\u300A\u82D4\u77F3\u56FE\u300B\u8BD7\u9898\u4EA6\u4F3C\u4E00\u65F6\u624B\u7B14\u3002\u300A\u82D4\u77F3\u56FE\u300B\u4F5C\u4E8E\u4E19\u5BC5\uFF081506\uFF09\uFF0C\u77F3\u7FC1\u5E74\u516B\u5341\uFF0C\u5219\u6B64\u5377\u4E3A\u5C45\u58EB\u4E09\u5341\u4E03\u516B\u5C81\u4F5C\u53EF\u8BC1\u4E5F\u3002\u516D\u5982\u753B\u7EE2\u7D20\u591A\u51FA\u696E\u672C\u4EC0\u767E\u500D\uFF0C\u5176\u6A2A\u5377\u66F4\u5C20\u89C1\u3002\u5B9C\u543E\u4E61\u8C22\u6C0F\u3001\u6EA7\u9633\u72C4\u6C0F\u7686\u4EE5\u73AF\u5B9D\u89C6\u4E4B\uFF0C\u4ECA\u5F52\u543E\u53CB\u90A6\u745E\u5B59\u5148\u751F\uFF0C\u7269\u805A\u6240\u597D\uFF0C\u5E94\u5E86\u662F\u5377\u5F97\u6240\u77E3\u3002\u7532\u7533\uFF081944\uFF09\u4E8C\u6708\u6625\u5206\u8282\uFF0C\u5434\u6E56\u5E06\u91CD\u89C2\u9898\u8BB0\u3002\u201D</p>"
                    },
                    {
                        x: 748,
                        y: 185,
                        content: "<p>\u201C\u53BB\u5E74\u4F59\u83B7\u8D2D\u516D\u5982\u300A\u5750\u7231\u67AB\u6797\u300B\u7EE2\u672C\u5C0F\u5E45\uFF0C\u4EA6\u7528\u5C0F\u65A7\u5288\u76B4\uFF0C\u4EE5\u7B14\u5C16\u6B63\u950B\u800C\u4E0D\u65BD\u4FA7\u7B14\uFF0C\u867D\u4E91\u5E08\u6CD5\u674E\u5E0C\u53E4\uFF0C\u5341\u516D\u5982\u81EA\u7ACB\u6CD5\u95E8\uFF0C\u4E0E\u6B64\u5377\u53CA\u300A\u5357\u5DDE\u56FE\u300B\u7686\u4E00\u65F6\u4F5C\u4E5F\u3002\u516D\u5982\u5EFF\u4E5D\u5C81\u4E2D\u5357\u4EAC\u89E3\u5143\uFF0C\u81EA\u540E\u5341\u5E74\u4E3A\u4E66\u753B\u6700\u7CBE\u8FDB\u65F6\u671F\u3002\u81F3\u5BB8\u6FE0\u653E\u5F52\u540E\u4FBF\u5165\u9893\u5510\uFF0C\u65E0\u6B64\u7CBE\u805A\u795E\u4F1A\u77E3\u3002\u90A6\u745E\u5F97\u516D\u5982\u753B\u300A\u6B3E\u9E64\u56FE\u300B\uFF0C\u5982\u7C73\u8944\u9633\u5F97\u53F3\u519B\u300A\u738B\u7565\u5E16\u300B\uFF0C\u5FEB\u4E0D\u53EF\u94ED\uFF0C\u643A\u793A\u5171\u8D4F\uFF0C\u53C8\u8BC6\u5377\u672B\u3002\u5029\u5EB5\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-41705": {
        caption: "\u660E \u8463\u5176\u660C \u79CB\u5174\u516B\u666F\u56FE\u518C",
        thumbnail: $johf1["sight-41705-0.jpg"],
        description: "<p>\u4E07\u5386\u56DB\u5341\u516B\u5E74\uFF081620\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u5218\u9756\u57FA\u6350\u8D60</p><p>\u6B64\u518C\u4F5C\u4E8E\u5E9A\u7533\u5E74\uFF081620\uFF09\uFF0C\u4F5C\u8005\u65F6\u5E74\u516D\u5341\u516D\u5C81\u3002</p><p>\u6B64\u518C\u66FE\u88AB\u5E9E\u5143\u6D4E\u6536\u85CF\u3002\u5E9E\u5143\u6D4E\uFF081864-1949\uFF09\uFF0C\u5B57\u83B1\u81E3\uFF0C\u53F7\u865A\u658B\uFF0C\u6D59\u6C5F\u5357\u6D54\u4EBA\u3002\u4E3A\u6D77\u4E0A\u9996\u5C48\u4E00\u6307\u7684\u85CF\u5BB6\uFF0C\u5176\u85CF\u54C1\u4E30\u5BCC\u7A0B\u5EA6\u51E0\u4E4E\u65E0\u4EBA\u80FD\u51FA\u5176\u53F3\u3002\u6B64\u518C\u5434\u6E56\u5E06\u5BD3\u76EE\u6570\u6B21\uFF0C\u7ED9\u4E88\u5F88\u9AD8\u8BC4\u4EF7\uFF0C\u5982\u5728\u5434\u6C0F\u9898\u8463\u5176\u660C\u300A\u753B\u7985\u5BA4\u5C0F\u666F\u56FE\u300B\u518C\u6307\u51FA\uFF0C\u201C\u4E03\u6708\u521D\u516D\u65E5\u83B7\u89C1\u300A\u79CB\u5174\u516B\u666F\u300B\u518C\u4E8E\u5E9E\u6C0F\uFF08\u5E9E\u83B1\u81E3\uFF09\uFF0C\u4E3A\u5927\u518C\u4E2D\u81F3\u7CBE\u8005\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["sight-41705-1.jpg"],
                points: []
            }
        ]
    },
    "sight-45513": {
        caption: "\u660E \u5510\u5BC5 \u9A91\u9A74\u601D\u5F52\u56FE\u8F74",
        thumbnail: $johf1["sight-45513-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u5510\u5BC5\uFF081470-1523\uFF09\uFF0C\u5B57\u4F2F\u864E\u3001\u5B50\u754F\uFF0C\u53F7\u516D\u5982\u5C45\u58EB\u7B49\u3002</p><p>\u5434\u6C0F\u5D07\u5C1A\u5357\u5B97\uFF0C\u63A8\u5D07\u5143\u4EE3\u6587\u4EBA\u753B\u98CE\u3002\u4F46\u5434\u95E8\u753B\u6D3E\u4E2D\u5510\u5BC5\u7684\u753B\u98CE\u4EA6\u7ED9\u4ED6\u5F88\u5927\u7684\u5F71\u54CD\uFF0C\u5434\u6C0F\u8BC4\u8BBA\u5510\u5BC5\u753B\u4E3A\u201C\u4EE5\u5357\u5B97\u7CBE\u97F5\u8868\u5317\u5B97\u9AA8\u5E72\u201D\uFF0C\u800C\u5176\u81EA\u5DF1\u7684\u67D0\u4E9B\u4F5C\u54C1\u4E2D\u4E5F\u6709\u4EE5\u5317\u5B97\u6280\u6CD5\u5C55\u73B0\u5357\u5B97\u6C14\u97F5\u7684\u7279\u8272\uFF0C\u53EF\u8C13\u5F02\u66F2\u540C\u5DE5\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45513-1.jpg"],
                points: [
                    {
                        x: 87,
                        y: 1527,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u516D\u5982\u5C45\u58EB\u753B\uFF0C\u6614\u4EBA\u8BBA\u66F0\uFF1A\u8FDC\u653B\u674E\u5510\uFF0C\u8DB3\u4EFB\u504F\u5E08\uFF0C\u800C\u4E0D\u77E5\u5176\u758F\u5B95\u5904\u5F97\u529B\u4E8E\u590F\u79B9\u7389\u751A\u6DF1\uFF0C\u53C8\u80FD\u4EE5\u5357\u5B97\u7CBE\u97F5\u8868\u5317\u5B97\u9AA8\u5E72\uFF0C\u662F\u6240\u8C13\u8FD0\u767E\u70BC\u94A2\u82E5\u7ED5\u6307\u67D4\uFF0C\u53D1\u5343\u53E4\u753B\u82D1\u5947\u683C\uFF0C\u4E0D\u72EC\u4E0E\u6C88\u6587\u89D2\u80DC\u4E00\u65F6\u4E5F\u3002\u6B64\u81EA\u5199\u8BD7\u610F\u56FE\uFF0C\u524D\u5C81\u4EE5\u5B8B\u6920\u6CB3\u4E0A\u672C\u300A\u9053\u5FB7\u7ECF\u300B\u6613\u4E8E\u5BC6\u97F5\u6402\u3002\u636E\u738B\u6829\u7F18\u4E08\u8003\u4E3A\u5F52\u81EA\u8C6B\u7AE0\u65F6\u4F5C\uFF0C\u4FE1\u6709\u5F81\u4E5F\u3002\u4F59\u6240\u89C1\u516D\u5982\u753B\u7CBE\u534E\u6240\u8403\uFF0C\u5E94\u63A8\u662F\u56FE\u4E3A\u7532\u89C2\u77E3\u3002\u4E19\u5B50\uFF081936\uFF09\u95F0\u4E09\u6708\u91CD\u88C5\uFF0C\u4E61\u540E\u5B66\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45529": {
        caption: "\u5143 \u5434\u9547 \u6E14\u7236\u56FE\u5377",
        thumbnail: $johf1["sight-45529-0.jpg"],
        description: "<p>\u81F3\u6B63\u4E94\u5E74\uFF081345\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u5434\u9547\uFF081280-1354\uFF09\uFF0C\u5B57\u4EF2\u572D\uFF0C\u53F7\u6885\u82B1\u9053\u4EBA\uFF0C\u6D59\u6C5F\u5609\u5174\u4EBA\uFF0C\u201C\u5143\u56DB\u5BB6\u201D\u4E4B\u4E00\u3002</p><p>\u5434\u6E56\u5E06\u83B7\u85CF\u6B64\u56FE\uFF0C\u5982\u83B7\u81F3\u5B9D\uFF0C\u5C61\u4F5C\u8D4F\u9274\u3001\u8003\u8BA2\uFF0C\u5B9A\u4E3A\u201C\u5434\u6C0F\u56DB\u5B9D\u201D\u4E4B\u4E00\u3002\u5F53\u65F6\u6D77\u4E0A\u5927\u85CF\u5BB6\u5E9E\u83B1\u81E3\u4E5F\u83B7\u8D2D\u4E00\u4EF6\u5434\u9547\u300A\u6E14\u7236\u56FE\u300B\u5377\uFF0C\u4E24\u5377\u6781\u4E3A\u76F8\u4F3C\u3002\u5434\u6E56\u5E06\u66FE\u6570\u6B21\u5F97\u4EE5\u89C2\u6469\u5E9E\u672C\uFF0C\u7ECF\u8FC7\u8BA4\u771F\u9274\u8003\u6BD4\u5BF9\uFF0C\u8BA4\u4E3A\u5E9E\u672C\u7CFB\u4F2A\uFF0C\u5E76\u64B0\u4E13\u6587\u8FA8\u6790\uFF0C\u5176\u65AD\u4F2A\u4F9D\u636E\u5256\u6790\u751A\u8BE6\u3002\u6BD4\u5982\u300A\u4E11\u7C03\u65E5\u8BB0\u300B1933\u5E74\u4E8C\u6708\u5199\u9053\uFF1A\u201C\u6821\u4EF2\u572D\u300A\u6E14\u7236\u56FE\u300B\u5E9E\u6C0F\u85CF\u300A\u5F0F\u53E4\u5802\u300B\u8457\u5F55\u672C\u3002\u6B3E\u5B57\u6885\u82B1\u9053\u4EBA\u2018\u6885\u2019\u2018\u9053\u2019\u4E8C\u5B57\u4E66\u4E0D\u6210\u5B57\u3002\u2018\u5341\u4F59\u5E74\u77E3\u2019\u4E4B\u2018\u4F59\u2019\u5B57\u4E66\u8BEF\u4F5C\u2018\u4F59\u2019\u3002\u2018\u6D41\u5149\u6613\u5F97\u2019\u4E4B\u2018\u6613\u2019\u4E66\u4F3C\u2018\u66F7\u2019\u5B57\u3002\u2018\u98CE\u63FD\u957F\u6C5F\u2019\u4E4B\u2018\u63FD\u2019\u5B57\u624B\u65C1\u8BEF\u4E0D\u6210\u5B57\u3002\u2018\u5F04\u6653\u971E\u2019\u4E4B\u2018\u971E\u2019\u4E0B\u534A\u4F3C\u2018\u971C\u2019\u975E\u2018\u971C\u2019\u3001\u4F3C\u2018\u971E\u2019\u975E\u2018\u971E\u2019\u3002\u2018\u9152\u7F3E\u4FA7\u2019\u4E4B\u2018\u4FA7\u2019\u5B57\u4F3C\u2018\u5012\u2019\u5B57\u800C\u7F3A\u7B14\u3002\u2018\u53EA\u5411\u6E56\u4E2D\u2019\u4E4B\u2018\u5411\u2019\u5B57\u4E0D\u6210\u5B57\u3002\u201D</p><p>\u5434\u6C0F\u7684\u9274\u5B9A\u610F\u89C1\u65F6\u83B7\u5F20\u5927\u5343\u7B49\u4EBA\u8BA4\u53EF\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45529-1.jpg"],
                zoomLevel: 10,
                points: []
            }
        ]
    },
    "sight-45531": {
        caption: "\u5317\u5B8B \u7C73\u82BE \u884C\u4E66\u591A\u666F\u697C\u8BD7\u518C",
        thumbnail: $johf1["sight-45531-0.jpg"],
        description: "<p>\u300A\u591A\u666F\u697C\u8BD7\u518C\u300B\u4E3A\u6885\u666F\u4E66\u5C4B\u91CD\u5B9D\uFF0C\u5434\u6E56\u5E06\u5BF9\u4E4B\u73CD\u7231\u903E\u5E38\uFF0C\u94BB\u7814\u6781\u6DF1\uFF0C\u5148\u540E\u591A\u6B21\u9898\u8DCB\uFF0C\u5BF9\u6B64\u518C\u521B\u4F5C\u5E74\u4EE3\u3001\u6D41\u4F20\u7ECF\u8FC7\u3001\u827A\u672F\u6210\u5C31\u7686\u6709\u8BE6\u5C3D\u7684\u8003\u8BC1\u8BBA\u8FF0\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45531-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-45531-2.jpg"],
                points: [
                    {
                        x: 1629,
                        y: 235,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u591A\u666F\u697C\u4E3A\u5929\u4E0B\u6709\u6570\u540D\u80DC\uFF0C\u7C73\u8944\u9633\u6B64\u4E66\u4E3A\u5929\u4E0B\u6709\u6570\u540D\u8FF9\u3002\u5728\u5317\u5B8B\u65F6\uFF0C\u8521\u5143\u5EA6\u5E2D\u4E0A\u4F55\u4F2F\u901A\u4EE5\u2018\u4E09\u7EDD\u2019\u8A89\u4E4B\uFF0C\u9605\u4ECA\u516B\u767E\u4F59\u8F7D\uFF0C\u5B8C\u7F8E\u5982\u6545\uFF0C\u5F97\u800C\u85CF\u4E4B\uFF0C\u5C82\u975E\u795E\u7075\u9ED8\u62A4\uFF0C\u5E94\u6709\u5409\u7965\u4E91\u8986\u6211\u5904\u4E5F\u3002\u4E59\u9149\uFF081945\uFF09\u4E03\u6708\u521D\u65EC\u5434\u6E56\u5E06\u8BC6\u4E8E\u6885\u5F71\u4E66\u5C4B\u201D\u3002</p><p>\u201C\u6B64\u518C\u81EA\u5B8B\u4EE5\u6765\uFF0C\u6240\u85CF\u5386\u5386\u7686\u53EF\u8003\u89C1\u3002\u5317\u5B8B\u65F6\uFF0C\u5DF2\u9080\u8D4F\u4E8E\u8521\u6C0F\u3002\u5357\u5B8B\u65F6\uFF0C\u5F52\u79E6\u6867\u3001\u79E6\u71BA\u3001\u79E6\u57D9\u8005\uFF0C\u51E1\u4E09\u4E16\u3002\u660E\u521D\uFF0C\u4E3A\u9ED4\u5B81\u738B\u5B50\u6C90\u7D20\u8F69\u6602\u6240\u5F97\uFF0C\u4F20\u81F3\u5176\u5B59\u5EF7\u7AE0\u7498\u3002\u518C\u4E2D\u2018\u9ED4\u5B81\u738B\u5B50\u5B59\u6C38\u4FDD\u4E4B\u2019\u5370\u3001\u2018\u5F81\u5357\u5C06\u519B\u56FE\u4E66\u2019\u5370\u3001\u2018\u516C\u4F59\u6E05\u73A9\u2019\u5370\uFF0C\u2018\u6C90\u7498\u5EF7\u7AE0\u2019\u5370\u7B49\uFF0C\u7686\u6C90\u6C0F\u85CF\u5370\u4E5F\u3002\u660E\u5B63\u800C\u5F52\u66F9\u5026\u5703\u4F8D\u90CE\uFF0C\u6E05\u521D\u800C\u5F52\u6881\u8549\u6797\u76F8\u56FD\uFF0C\u800C\u671D\u9C9C\u5B89\u5C90\u7C4D\u5165\u6E05\u5185\u5E9C\uFF0C\u5F97\u9080\u9AD8\u5B97\u777F\u8D4F\uFF0C\u5206\u8D50\u6210\u4EB2\u738B\u8BD2\u664B\u658B\u800C\u52D2\u77F3\u5165\u5E16\u3002\u6E05\u5B63\u4E3A\u5E38\u719F\u90B5\u606F\u658B\u592A\u53F2\u6240\u5F97\uFF0C\u8FC4\u4ECA\u6570\u5341\u5E74\uFF0C\u6D77\u5B87\u65B9\u9756\uFF0C\u76F8\u5E86\u548C\u5E73\u544A\u6210\uFF0C\u9042\u4E3A\u6211\u6709\uFF0C\u758F\u8BB0\u5FD7\u5FEB\uFF0C\u5029\u5EB5\u53C8\u8BC6\u3002\u201D</p><p>\u201C\u636E\u4F55\u592A\u5085\u9898\u4E8E\u5D07\u5B81\u5143\u5E74\u58EC\u5348\uFF0C\u6309\u8944\u9633\u751F\u4E8E\u7687\u7950\u4E09\u5E74\u8F9B\u536F\uFF0C\u6B81\u4E8E\u5927\u89C2\u5143\u5E74\u4E01\u4EA5\uFF0C\u5E74\u4E94\u5341\u4E03\uFF0C\u5219\u58EC\u5348\u5E74\u5F53\u4E94\u5341\u4E8C\uFF0C\u7C73\u6C0F\u72B9\u5065\u5728\u4E5F\u3002\u53EF\u77E5\u5F53\u65E5\u58F0\u8A89\u4E4B\u9686\uFF0C\u51B5\u8DDD\u4ECA\u516B\u767E\u56DB\u5341\u56DB\u5E74\u4E4B\u540E\uFF0C\u5B9D\u8D35\u5F53\u5982\u4F55\u8036\u3002\u6C11\u56FD\u5345\u56DB\u5E74\u4E59\u9149\u6E56\u5E06\u5F97\u6B64\uFF0C\u65F6\u5E74\u4E94\u5341\u4E8C\u559C\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45532": {
        caption: "\u660E \u84DD\u745B \u6C5F\u4EAD\u8BD7\u601D\u56FE\u6247",
        thumbnail: $johf1["sight-45532-0.jpg"],
        description: "<p>\u987A\u6CBB\u5341\u56DB\u5E74\uFF081657\uFF09</p><p>\u91D1\u7B3A \u8BBE\u8272</p><p>\u84DD\u745B\uFF081585-1664\u540E\uFF09\uFF0C\u5B57\u7530\u53D4\uFF0C\u94B1\u5858\uFF08\u4ECA\u6D59\u6C5F\u676D\u5DDE\uFF09\u4EBA\u3002\u672C\u56FE\u4F5C\u4E8E\u987A\u6CBB\u5341\u56DB\u5E74\uFF081657\uFF09\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E03\u5341\u4E09\u5C81\u3002</p><p>\u5434\u6E56\u5E06\u65F6\u4EE3\uFF0C\u53F2\u6599\u7F3A\u4E4F\uFF0C\u84DD\u745B\u751F\u5352\u5E74\u4EFD\u4FF1\u4E0D\u8BE6\u3002\u800C\u5434\u6E56\u5E06\u636E\u6B64\u6247\u6240\u7F72\u5E74\u4EFD\u5C81\u6570\uFF0C\u63A8\u77E5\u84DD\u745B\u751F\u4E8E\u4E07\u5386\u5341\u4E09\u5E74\uFF081585\uFF09\uFF0C\u5F25\u8865\u4E86\u753B\u53F2\u4E4B\u7F3A\u3002</p><p>\u4ECE\u76F8\u5173\u4F5C\u54C1\u4E4B\u6BD4\u8F83\uFF0C\u753B\u5BB6\u751F\u5352\u3001\u540D\u53F7\u3001\u658B\u540D\u3001\u4E0A\u6B3E\u4EBA\u53CA\u76F8\u5173\u80CC\u666F\u4EBA\u7269\u4EA4\u6E38\u7B49\u65B9\u9762\u4E4B\u8003\u8BC1\uFF0C\u4E43\u81F3\u7528\u5370\u3001\u88C5\u6F62\u4E0E\u5F62\u5236\u7B49\u7EC6\u8282\u89C2\u5BDF\uFF0C\u65E0\u4E0D\u8868\u660E\u5BF9\u5434\u6E56\u5E06\u800C\u8A00\uFF0C\u4E66\u753B\u9274\u5B9A\u662F\u4E00\u95E8\u76EE\u9274\u4E0E\u8003\u8BC1\u76F8\u7ED3\u5408\u7684\u5B66\u95EE\u3002\u8BDA\u5982\u672C\u6247\u4E2D\u5434\u6C0F\u9898\u8BED\u4E2D\u6240\u8A00\uFF0C\u201C\u4E66\u753B\u4E4B\u8DB3\u8BC1\u5982\u6B64\uFF0C\u4E0D\u72EC\u4EE5\u73A9\u8D4F\u4E3A\u96C5\u4E8B\u4E91\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45532-1.jpg"],
                points: [
                    {
                        x: 1864,
                        y: 50,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u7530\u53D4\u751F\u5E74\u753B\u7C4D\u4FF1\u4E0D\u8BE6\uFF0C\u4ECA\u5F97\u6B64\u7B91\uFF0C\u4F5C\u4E8E\u987A\u6CBB\u5341\u56DB\u5E74\u4E01\u9149\uFF0C\u5E74\u4E03\u5341\u4E09\uFF0C\u63A8\u5176\u751F\u5728\u4E07\u5386\u5341\u4E09\u5E74\u4E59\u9149\u4E5F\u3002\u4E66\u753B\u4E4B\u8DB3\u8BC1\u5982\u6B64\uFF0C\u4E0D\u72EC\u4EE5\u73A9\u8D4F\u4E3A\u96C5\u4E8B\u4E91\u3002\u662F\u7B91\u7528\u7B14\u5982\u5927\u75F4\u829D\u5170\u5BA4\u56FE\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45532a": {
        caption: "\u660E \u5510\u5BC5 \u643A\u7434\u8BBF\u53CB\u56FE\u6247",
        thumbnail: $johf1["sight-45532a-0.jpg"],
        description: "<p>\u91D1\u7B3A \u8BBE\u8272</p><p>\u5434\u6E56\u5E06\u7684\u9274\u5B9A\u6CE8\u91CD\u4F5C\u54C1\u7684\u7B14\u6CD5\u3001\u5370\u8BB0\u548C\u6B3E\u8BC6\u7684\u5BA1\u5B9A\u3002\u4ECE\u8DCB\u6587\u53EF\u77E5\uFF0C\u5434\u6E56\u5E06\u636E\u201C\u7B14\u6CD5\u6B3E\u8BC6\u201D\uFF0C\u521D\u6B65\u5224\u65AD\u6B64\u56FE\u662F\u5510\u5BC5\u201C\u5F53\u5728\u4E94\u5341\u5C81\u4EE5\u524D\u7CBE\u529B\u6700\u5F25\u6F2B\u65F6\u6240\u4F5C\u201D\uFF0C\u518D\u636E\u5510\u6C0F\u81EA\u94A4\u201C\u5B66\u5703\u5802\u201D</p><p>\u4E00\u5370\u4F5C\u4E3A\u65AD\u4EE3\u5E74\u4EFD\u4E4B\u65C1\u8BC1\uFF0C\u79F0\u201C\u6B64\u5370\u4EA6\u56DB\u5341\u4EE5\u540E\u6240\u7528\u201D\u3002\u53EF\u89C1\uFF0C\u5370\u9274\u5728\u4E66\u753B\u9274\u5B9A\u4E0E\u7814\u7A76\u4E2D\u6240\u8D77\u5230\u7684\u8F85\u52A9\u4F5C\u7528\uFF0C\u5434\u6C0F\u7686\u4E88\u4EE5\u76F8\u5F53\u91CD\u89C6\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45532a-1.jpg"],
                points: [
                    {
                        x: 1832,
                        y: 81,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u5510\u516D\u5982\u643A\u7434\u8BBF\u53CB\u56FE\u4FBF\u7B91\u65E0\u4E0A\u7CBE\u54C1\u3002\u4F59\u597D\u516D\u5982\u753B\uFF0C\u6240\u96C6\u4FBF\u7B91\u4E2D\u4EBA\u7269\u5C71\u6C34\u6700\u7CBE\u8005\u53EA\u4E8C\u4E09\u54C1\uFF0C\u6B64\u8D77\u4E00\u4E5F\u3002\u4EE5\u753B\u54C1\u8BBA\uFF0C\u6D51\u6210\u3001\u8001\u7EC3\u3001\u82CD\u79C0\u517C\u5177\uFF0C\u5BA1\u5176\u7B14\u6CD5\u4E0E\u6B3E\u8BC6\uFF0C\u5F53\u5728\u4E94\u5341\u5C81\u4EE5\u524D\u7CBE\u529B\u6700\u5F25\u6EE1\u65F6\u6240\u4F5C\u3002\u5B66\u5703\u5802\u4E00\u5370\u4EA6\u56DB\u5341\u4EE5\u540E\u6240\u7528\uFF0C\u66FE\u83B7\u5170\u4EAD\u4FEE\u8909\u56FE\u5C0F\u5377\uFF0C\u7528\u7B14\u7528\u58A8\uFF0C\u4EBA\u7269\u52FE\u52D2\uFF0C\u6811\u77F3\u76B4\u6CD5\u4E43\u4E00\u65F6\u4F5C\u4E5F\u3002\u4E59\u4E11\u590F\u65E5\u6240\u5F97\u3002\u6E56\u5E06\u8BB0\u73CD\u3002\u540C\u65F6\u6240\u6536\u6587\u8861\u5C71\u6625\u6709\u56FE\u4FBF\u9762\u4EA6\u81F3\u7CBE\u54C1\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45534": {
        caption: "\u5357\u5B8B \u666F\u5B9A\u4E8C\u5E74\u520A\u6885\u82B1\u559C\u795E\u8C31",
        thumbnail: $johf1["sight-45534-0.jpg"],
        description: "<p>\u6B64\u8C31\u4E3A\u5434\u6E56\u5E06\u592B\u4EBA\u6F58\u9759\u6DD1\u966A\u5AC1\u5B8B\u523B\u5B64\u672C\uFF0C\u6781\u4E3A\u73CD\u7F55\u3002\u4ECE\u9898\u8DCB\u53EF\u77E5\uFF0C\u5434\u6E56\u5E06\u5BF9\u5176\u6E90\u6D41\u52A0\u4EE5\u8003\u8BC1\uFF0C\u8BA4\u5B9A\u6B64\u518C\u4E3A\u5B8B\u4EE3\u7684\u7956\u523B\u672C\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45534-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-45534-2.jpg"],
                points: [
                    {
                        x: 78,
                        y: 342,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u77E5\u4E0D\u8DB3\u658B\u4E1B\u4E66\u6240\u523B\u6B64\u8C31\u6613\u9898\u7709\u4E8E\u4E66\u65C1\uFF0C\u5377\u5C3E\u6479\u523B\u7ECD\u5174\u65CC\u4E2D\u88D2\u8282\u4E4B\u5BB6\u5370\uFF0C\u53EF\u8BC1\u6B64\u518C\u4E3A\u9C8D\u6C0F\u7956\u672C\uFF0C\u66F4\u8BC1\u4E66\u7ECF\u7FFB\u954C\u4E0D\u590D\u65E7\u89C2\u4E4B\u5931\u3002\u4E19\u5BC5\u4E2D\u79CB\u5434\u6E56\u5E06\u8BC6\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45537": {
        caption: "\u660E \u5F90\u6E2D \u8349\u4E66\u6625\u96E8\u5E16\u4E03\u53E4\u4E8C\u7AE0\u5377",
        thumbnail: $johf1["sight-45537-0.jpg"],
        description: "<p>\u5434\u6E56\u5E06\u6536\u85CF\u7684\u5174\u8DA3\u591A\u96C6\u4E2D\u4E8E\u6B63\u7EDF\u548C\u4E3B\u6D41\u7684\u4E66\u753B\u5BB6\u4F5C\u54C1\uFF0C\u4F46\u5BF9\u4E8E\u5F90\u6E2D\u7684\u4F5C\u54C1\u5219\u5927\u4E3A\u6B23\u8D4F\uFF0C\u8BA4\u4E3A\u5176\u867D\u7136\u72C2\u653E\uFF0C\u5374\u59CB\u7EC8\u4E0D\u8131\u79BB\u4E8C\u738B\u4E66\u6CD5\u7684\u6CD5\u5EA6\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45537-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 2283,
                        y: 67,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5929\u6C60\u4E4B\u4E66\uFF0C\u81EA\u7C73\u6CD5\u4E0A\u6EAF\uFF0C\u51E0\u6B32\u593A\u65ED\u3001\u7D20\u4E4B\u5E2D\uFF0C\u6240\u8C13\u5929\u9A6C\u884C\u7A7A\uFF0C\u4E0D\u53EF\u7F81\u52D2\u77E3\u3002\u5B66\u4E4B\u8005\u5F80\u5F80\u72C2\u8BDE\u8FC7\u751A\uFF0C\u9042\u5165\u90AA\u9B54\uFF0C\u5982\u677F\u6865\u4E00\u6D41\u3002\u5929\u6C60\u5219\u4EFB\u72C2\u4EFB\u653E\uFF0C\u603B\u4E0D\u8131\u4E8C\u738B\u85E9\u7B3C\u5373\u5176\u597D\u5904\uFF0C\u6545\u80FD\u6A2A\u7EDD\u5343\u53E4\u800C\u4E0D\u78E8\u8005\u4E5F\u3002\u6B64\u5377\u5341\u5E74\u524D\u4E3A\u5F90\u4F1F\u58EB\u59CA\u4E08\u6240\u8D60\uFF0C\u524D\u540E\u51E1\u4E03\u53E4\u4E8C\u7AE0\uFF0C\u6B3E\u4E66\u2018\u9686\u5E86\u6625\u4E4B\u671B\u2019\uFF0C\u5F53\u662F\u9686\u5E86\u6539\u5143\u4E4B\u521D\uFF0C\u53EF\u8BC1\u5176\u9189\u540E\u4FE1\u7B14\u8131\u7EAA\u5E74\u6708\u8033\u3002\u6234\u6587\u8282\u3001\u5434\u7B0F\u5EB5\u3001\u8BB8\u4FE1\u81E3\u4E09\u8DCB\u5C24\u89C1\u5B8C\u6574\uFF0C\u53EF\u5B9D\u3002\u66E9\u5C81\u501A\u300A\u8D3A\u65B0\u90CE\u300B\u8BCD\u9898\u4E4B\uFF0C\u7678\u9149\uFF081933\uFF09\u6625\u4E09\u6708\u8865\u4E66\u3002\u201D</p>"
                    },
                    {
                        x: 1505,
                        y: 85,
                        content: "<p>\u201C\u9189\u6001\u8BD7\u4E2D\u7701\u3002\u60F3\u5F53\u521D\u3001\u4FE1\u624B\u6325\u6BEB\uFF0C\u58A8\u534E\u98DE\u53BB\u3002\u5C3D\u5C14\u867A\u86C7\u60CA\u5EA7\u7B14\uFF0C\u5BF9\u6B64\u4E5F\u987B\u76EE\u77AA\u3002\u8BE7\u72C2\u6BD4\u98A0\u5F20\u5C24\u6A2A\u3002\u6BD5\u7ADF\u4E66\u751F\u591A\u80C6\u6C14\uFF0C\u4ED7\u9526\u5FC3\u8FA3\u624B\u8C6A\u60C5\u901E\u3002\u5929\u6597\u5927\uFF0C\u6211\u5149\u9876\u3002\u9752\u85E4\u8BD7\u6709\u79C3\u5934\u5149\u9876\u4E4B\u53E5\u3002\u7834\u5934\u8840\u8FF8\u83ED\u82B1\u51B7\u3002\u4E14\u83AB\u95EE\u3001\u547D\u8BEF\u6587\u7AE0\uFF0C\u6587\u7AE0\u8BEF\u547D\u3002\u624D\u5B50\u4ECE\u6765\u591A\u65E0\u8914\uFF0C\u6789\u8BF4\u98CE\u6D41\u5B7D\u8BC1\u3002\u5F80\u5F80\u501F\u3001\u7F8E\u4EBA\u540A\u5F71\u3002\u68A6\u91CC\u5DF4\u5C71\u542C\u591C\u96E8\uFF0C\u5FC6\u9A6C\u5D6C\u3001\u75DB\u54ED\u534E\u6E05\u5E78\u3002\u8C01\u5473\u5F97\uFF0C\u6B64\u4E2D\u5883\u3002\u5434\u6E56\u5E06\u73CD\u85CF\u5E76\u9898\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-45539": {
        caption: "\u5143 \u5F20\u4E2D \u8299\u84C9\u9E33\u9E2F\u56FE\u8F74",
        thumbnail: $johf1["sight-45539-0.jpg"],
        description: "<p>\u6B64\u56FE\u4E3A1935\u5E74\u5434\u6E56\u5E06\u6240\u5F97\u6E05\u5BAB\u65E7\u85CF\uFF0C\u6781\u4E3A\u73CD\u8D35\uFF0C\u5434\u6C0F\u901A\u8FC7\u5BF9\u5176\u4E0A\u5370\u7AE0\u7684\u8003\u636E\uFF0C\u68B3\u7406\u4E86\u8FD9\u5E45\u753B\u7684\u6D41\u4F20\u7ECF\u5386\uFF0C\u6307\u51FA\u6B64\u753B\u66FE\u7ECF\u660E\u4EE3\u6C88\u5468\u4F2F\u7236\u4E0E\u6587\u5F81\u660E\u5916\u66FE\u5B59\u6536\u85CF\u3002</p>",
        slides: [
            {
                url: $johf1["sight-45539-1.jpg"],
                points: [
                    {
                        x: 1042,
                        y: 86,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u56FE\u53F3\u4E0B\u89D2\u6709\u2018\u8D1E\u5409\u5370\u2019\uFF0C\u4E43\u77F3\u7530\u7FC1\u4E4B\u7236\u6C88\u8D1E\u5409\u4E5F\u3002\u2018\u8D1E\u5409\u5370\u2019\u4E4B\u4E0A\u2018\u859B\u76CA\u4E4B\u5370\u2019\uFF0C\u610F\u5373\u6587\u8861\u5C71\u4E4B\u5916\u66FE\u5B59\u859B\u660E\u76CA\u865E\u537F\u4E5F\u3002\u865E\u537F\u5DE5\u5C0F\u6977\uFF0C\u5B97\u6587\u6C0F\u6CD5\uFF0C\u4E07\u5386\u3001\u5D07\u796F\u95F4\u543E\u5434\u4E66\u5BB6\u3002\u6B64\u56FE\u4E0A\u81EA\u5BA3\u5FB7\u3001\u666F\u6CF0\uFF0C\u4E0B\u81F3\u660E\u672B\uFF0C\u767E\u6570\u5341\u5E74\u95F4\uFF0C\u4FF1\u85CF\u543E\u5434\uFF0C\u8D8A\u4ECA\u53C8\u4E09\u767E\u5E74\u800C\u590D\u5F52\u4F59\u6709\uFF0C\u53EF\u8C13\u795E\u7075\u6240\u4F51\u77E3\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-46358": {
        caption: "\u6E05 \u5434\u5386 \u5BFF\u8BB8\u9752\u5C7F\u5C71\u6C34\u56FE\u8F74",
        thumbnail: $johf1["sight-46358-0.jpg"],
        description: "<p>\u5EB7\u7199\u5341\u4E00\u5E74\uFF081672\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u5434\u5386 (1632-1718)\uFF0C\u5B57\u6E14\u5C71\uFF0C\u53F7\u58A8\u4E95\u9053\u4EBA\uFF0C\u6C5F\u82CF\u5E38\u719F\u4EBA\u3002\u6B64\u56FE\u7CFB\u56DB\u5341\u4E00\u5C81\u7684\u5434\u5386\u4E3A\u8D3A\u53CB\u4EBA\u8BB8\u4E4B\u6E10\u516D\u5341\u5C81\u5BFF\u8FB0\u800C\u4F5C\u3002</p><p>\u5434\u6E56\u5E06\u5173\u6CE8\u6C5F\u5357\u4E00\u5E26\u5C24\u5176\u6CAA\u4E0A\u5404\u5927\u85CF\u5BB6\u7684\u6536\u85CF\uFF0C\u5BF9\u5E9E\u83B1\u81E3\u3001\u94B1\u955C\u5858\u3001\u51AF\u8D85\u7136\u7B49\u53CB\u4EBA\u7684\u8BF8\u591A\u85CF\u54C1\u4E0D\u4EC5\u5982\u6570\u5BB6\u73CD\uFF0C\u4E14\u591A\u6709\u9898\u9274\u3002\u6B64\u56FE\u66FE\u4E3A\u6E05\u4EE3\u987E\u6587\u5F6C\u65E7\u85CF\uFF0C\u300A\u8FC7\u4E91\u697C\u4E66\u753B\u8BB0\u300B\u5377\u516D\u8457\u5F55\uFF0C\u540E\u4E3A\u94B1\u955C\u5858\u6240\u5F97\u30021949\u5E74\u6625\u65E5\uFF0C\u5434\u6C0F\u5728\u89C2\u6B64\u753B\u540E\uFF0C\u5C06\u81EA\u5DF1\u7684\u9274\u5B9A\u7ED3\u8BBA\uFF0C\u4EE5\u9898\u7B7E\u5F62\u5F0F\u4E66\u4E8E\u753B\u4E0A\uFF0C\u4E0D\u4EC5\u5B9A\u4E3A\u201C\u771F\u8FF9\u201D\uFF0C\u4E14\u79F0\u4E4B\u4E3A\u201C\u9752\u7EFF\u5C71\u6C34\u795E\u54C1\u201D</p>",
        slides: [
            {
                url: $johf1["sight-46358-1.jpg"],
                points: []
            }
        ]
    },
    "sight-50327": {
        caption: "\u5357\u5B8B \u4F5A\u540D \u665A\u666F\u56FE\u8F74",
        thumbnail: $johf1["sight-50327-0.jpg"],
        description: "<p>\u7EE2\u672C \u6C34\u58A8</p><p>\u56FE\u7ED8\u91CD\u5CA9\u53E0\u5D82\uFF0C\u610F\u5883\u9AD8\u65F7\uFF0C\u5E03\u5C40\u6E05\u4E3D\u7D27\u51D1\uFF0C\u7528\u7B14\u7B80\u7EC3\u660E\u786E\uFF0C\u4FE8\u7136\u81EA\u5317\u5B8B\u8303\u5BBD\u4E00\u8DEF\u51FA\uFF0C\u66F4\u663E\u51FA\u901A\u900F\u53D8\u5E7B\u7684\u5357\u5B8B\u5C71\u6C34\u6C14\u6D3E\u3002</p><p>1950\u5E74\uFF0C\u5434\u6E56\u5E06\u4E3A\u6536\u85CF\u5BB6\u94B1\u955C\u5858\u9898\u8DCB\uFF0C\u8FFD\u6EAF\u4E86\u6B64\u56FE\u4E8E\u660E\u6E05\u4EE5\u6765\u7684\u6D41\u4F20\u7ECF\u5386\uFF1A\u66FE\u7ECF\u660E\u4E25\u5D69\uFF0C\u6E05\u6881\u6E05\u6807\u3001\u8C22\u6DDE\u6D32\u3001\u6BD5\u6CF7\u3001\u5218\u6055\u3001\u845B\u91D1\u70FA\u6536\u85CF\u3002\u8457\u5F55\u4E8E\u300A\u4F69\u6587\u658B\u4E66\u753B\u8C31\u300B\u5377\u4E5D\u5341\u516B\u3001\u300A\u73CA\u745A\u7F51\u300B\u5377\u56DB\u5341\u4E03\u3001\u300A\u7231\u65E5\u541F\u5E90\u4E66\u753B\u5F55\u300B\u5377\u4E00\u3002</p>",
        slides: [
            {
                url: $johf1["sight-50327-1.jpg"],
                points: [
                    {
                        x: 171,
                        y: 1866,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u660E\u4E25\u5206\u5B9C\u7C4D\u6CA1\u65F6\uFF0C\u6587\u4F11\u627F\u9002\u4E3A\u5357\u660C\u6559\u8C15\uFF0C\u4EFB\u5176\u5F79\u6709\u70B9\u6536\u4E25\u6C0F\u6240\u85CF\u4E66\u753B\u76EE\u5F55\uFF0C\u8303\u5BBD\u300A\u665A\u666F\u56FE\u300B\u662F\u5176\u4E00\u7109\u3002\u300A\u4F69\u6587\u658B\u300B\u53CA\u6C6A\u6C0F\u300A\u73CA\u745A\u7F51\u300B\u6240\u5F55\u5373\u636E\u6587\u6C0F\u76EE\u5F55\u3002\u5F55\u5165\u662F\u56FE\u540E\uFF0C\u5165\u6881\u8549\u6797\u3001\u8C22\u6797\u90A8\u3001\u6BD5\u7AF9\u5C7F\u3001\u5218\u84C9\u5CF0\u8BF8\u5BB6\u6536\u85CF\u3002\u4ECA\u636E\u6BD5\u7AF9\u5C7F\u665A\u5E74\u624B\u5B9A\u672C\u81EA\u4E66\u4E8E\u805A\u5934\u6247\u4E0A\u3002\u5E7F\u582A\u658B\u85CF\u753B\u76EE\u51E1\u4E94\u4EE3\u5B8B\u5143\u660E\u540D\u753B\u4E03\u5341\u4E5D\u4E8B\uFF0C\u7ECF\u56DB\u5341\u5E74\u82E6\u5FC3\u6240\u79EF\uFF0C\u4E0D\u557B\u795E\u4EA4\u5E08\u53CB\u3002\u5143\u7AE0\u6240\u8C13\u58F0\u8272\u4E4B\u7F8E\u4E0D\u80FD\u593A\u4E5F\u3002\u662F\u56FE\u8FD1\u4E3A\u543E\u53CB\u94B1\u955C\u5858\u541B\u6240\u5F97\uFF0C\u89C1\u770E\u5C5E\u758F\u8BC1\u4E4B\u3002\u5E9A\u5BC5\u79CB\u5434\u6E56\u5E06\u89C2\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-51068": {
        caption: "\u660E \u6C88\u5468 \u82D4\u77F3\u56FE\u8F74",
        thumbnail: $johf1["sight-51068-0.jpg"],
        description: "<p>\u6B63\u5FB7\u5143\u5E74\uFF081506\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6B64\u56FE\u4F5C\u4E8E\u6B63\u5FB7\u5143\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u516B\u5341\u5C81\u3002</p><p>\u517C\u5177\u4F20\u7EDF\u6587\u4EBA\u4E0E\u73B0\u4EE3\u5B66\u8005\u53CC\u91CD\u7279\u8D28\u7684\u5434\u6E56\u5E06\uFF0C\u4E0E\u7A0D\u665A\u7684\u5F20\u73E9\u7B49\u9274\u5B9A\u5BB6\u4E00\u6837\uFF0C\u4E1A\u5DF2\u5C55\u793A\u51FA\u517C\u878D\u4F20\u7EDF\u753B\u5B66\u4E0E\u73B0\u4EE3\u79D1\u5B66\u7814\u7A76\u65B9\u6CD5\u7684\u8D8B\u52BF\uFF0C\u5728\u4E66\u753B\u9274\u5B9A\u65B9\u9762\uFF0C\u7686\u91CD\u89C6\u76F8\u5173\u4F5C\u54C1\u7684\u6BD4\u5BF9\u548C\u8003\u8BC1\u3002</p><p>1944\u5E74\u5434\u6E56\u5E06\u83B7\u85CF\u6B64\u56FE\u4E4B\u9645\uFF0C\u6839\u636E\u5BB6\u85CF\u53E6\u4E00\u4EF6\u6C88\u5468\u6B63\u5FB7\u4E8C\u5E74\uFF081507\uFF09\u300A\u7261\u4E39\u82B1\u300B\u8F74\uFF08\u5357\u4EAC\u535A\u7269\u9662\uFF09\u63A8\u65AD\uFF0C\u56FE\u4E2D\u4E0A\u6B3E\u201C\u590D\u7AEF\u201D\u5373\u4E3A\u6F84\u6C5F\u7F2A\u590D\u7AEF\u3002\u66F4\u4E3A\u91CD\u8981\u7684\u662F\uFF0C\u5434\u6E56\u5E06\u5C06\u300A\u82D4\u77F3\u56FE\u300B\u8F74\u4E2D\u6C88\u5468\u516B\u5341\u5C81\u4E66\u98CE\u4F5C\u4E3A\u53C2\u7167\u7269\uFF0C\u8FDB\u800C\u5BF9\u6C88\u5468\u9898\u5510\u5BC5\u7684\u65E0\u5E74\u4EFD\u4F5C\u54C1\u300A\u6B3E\u9E64\u56FE\u300B\u5377\u8FDB\u884C\u4E86\u771F\u4F2A\u9274\u5B9A\u4E0E\u5E74\u4EFD\u8003\u8BC1\u3002</p>",
        slides: [
            {
                url: $johf1["sight-51068-1.jpg"],
                points: [
                    {
                        x: 123,
                        y: 807,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4E94\u767E\u5E74\u6765\u7FF0\u58A8\u9057\uFF0C\u91CD\u724B\u4F59\u4EF0\u8D39\u6E05\u8F9E\u3002\u5174\u62AB\u8001\u5230\u6885\u82B1\u7B14\uFF0C\u8B66\u6458\u95E8\u5F53\u8F66\u9A6C\u8BD7\u3002\u548F\u53D1\u753B\u5148\u771F\u610F\u5F97\uFF0C\u7956\u7F18\u5B59\u88AD\u65E7\u4EA4\u77E5\u3002\u77F3\u7FC1\u516B\u5341\u795E\u72B9\u58EE\uFF0C\u2018\u82D4\u77F3\u2019\u540D\u56FE\u6790\u8D4F\u5B9C\u3002\u7532\u7533\uFF081944\uFF09\u79CB\u65E5\u559C\u83B7\u6B64\u56FE\uFF0C\u77F3\u7FC1\u8001\u7B14\u7EB7\u62AB\uFF0C\u7CBE\u5F69\u5955\u5955\uFF0C\u6D35\u5C5E\u795E\u54C1\uFF0C\u4E3A\u4F9D\u539F\u9898\u97F5\u4E66\u8D09\u3002\u5434\u6E56\u5E06\u73CD\u85CF\u3002\u201D</p>"
                    },
                    {
                        x: 1845,
                        y: 1593,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u201C\u8FD1\u83B7\u77F3\u7530\u7FC1\u4E3A\u6F84\u6C5F\u7F2A\u590D\u7AEF\u753B\u300A\u7261\u4E39\u82B1\u300B\u8F74\uFF0C\u4F5C\u4E8E\u6B63\u5FB7\u4E8C\u5E74\uFF081507\uFF09\uFF0C\u6709\u300A\u60DC\u4F59\u6625\u300B\u3001\u300A\u4E34\u6C5F\u4ED9\u300B\u4E8C\u8BCD\uFF0C\u5F53\u65F6\u5531\u548C\u8005\u5C1A\u6709\u859B\u5C27\u537F\uFF0C\u6B64\u56FE\u4E3A\u590D\u7AEF\u5373\u5176\u4EBA\u7109\u3002\u620A\u5B50\uFF081948\uFF09\u4E5D\u6708\u6E56\u5E06\u53C8\u8BB0\u3002\u201D\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-51117": {
        caption: "\u6E05 \u8303\u5EF7\u9547 \u5C71\u6C34\u56FE\u518C",
        thumbnail: $johf1["sight-51117-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u665A\u6E05\u4EE5\u964D\uFF0C\u987E\u6587\u5F6C\u3001\u4F55\u7ECD\u57FA\u3001\u891A\u5FB7\u5F5D\u7B49\u5747\u89C6\u6B64\u4F5C\u4E3A\u607D\u5BFF\u5E73\u3001\u738B\u7FDA\u3001\u8303\u5EF7\u9547\u4E09\u4EBA\u5C71\u6C34\u5408\u518C\u3002\u300A\u4E2D\u56FD\u53E4\u4EE3\u4E66\u753B\u56FE\u76EE\u300B\u5C06\u5176\u5B9A\u4E3A\u8303\u6C0F\u4F5C\u54C1\u3002</p><p>\u4E8C\u5341\u4E16\u7EAA\u4E09\u5341\u5E74\u4EE3\uFF0C\u5434\u6E56\u5E06\u5728\u65E5\u8BB0\u4E2D\u6307\u51FA\uFF1A\u201C\u8303\u5EF7\u9547\uFF0C\u5B57\u8DBE\u5B89\uFF0C\u753B\u6CD5\u82B1\u5349\uFF0C\u4E0E\u5357\u7530\u80FD\u4E71\u771F\u3002\u5404\u4E66\u4FF1\u4E0D\u8F7D\uFF0C\u4EE5\u5E74\u4EE3\u7B14\u6CD5\u8BBA\uFF0C\u5F53\u662F\u5357\u7530\u5F1F\u5B50\u3002\u201D\u5434\u6E56\u5E06\u773C\u5149\u5982\u70AC\uFF0C\u8457\u540D\u7684\u201C\u4EE3\u7B14\u8BF4\u201D\u4EA6\u51FA\u81EA\u5176\u53E3\u3002\u4F8B\u5982\uFF0C\u6587\u5F6D\u3001\u6587\u5609\u3001\u6587\u4F2F\u4EC1\u7B49\u4E3A\u6587\u5F81\u660E\u4EE3\u7B14\uFF0C\u8D75\u5DE6\u3001\u6C88\u58EB\u5145\u3001\u5434\u6613\u7B49\u4E3A\u8463\u5176\u660C\u4EE3\u7B14\uFF0C\u859B\u5BA3\u4E3A\u738B\u9274\u4EE3\u7B14\uFF0C\u738B\u7FDA\u3001\u738B\u539F\u7941\u7B49\u4E3A\u738B\u65F6\u654F\u4EE3\u7B14\u3002</p>",
        slides: [
            {
                url: $johf1["sight-51117-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-2.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-3.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-4.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-5.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-6.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-7.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-8.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-9.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-10.jpg"],
                points: []
            },
            {
                url: $johf1["sight-51117-11.jpg"],
                points: []
            }
        ]
    },
    "sight-59917": {
        caption: "\u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C",
        thumbnail: $johf1["sight-59917-0.jpg"],
        description: "<p>\u6B64\u518C\u4E3A\u5434\u6C0F\u6885\u666F\u4E66\u5C4B\u81F3\u5B9D\uFF0C\u53F7\u79F0\u201C\u58A8\u7687\u201D\u3002\u5434\u6E56\u5E06\u5BF9\u5176\u94BB\u7814\u7CBE\u6DF1\uFF0C\u9010\u884C\u6821\u7406\uFF0C\u53C8\u5BF9\u518C\u4E2D\u5370\u9274\u3001\u88C5\u88F1\u7B49\u8BE6\u52A0\u5BA1\u8BA2\uFF0C\u66FE\u591A\u6B21\u9898\u8DCB\uFF0C\u636E\u5176\u6709\u5173\u5386\u4EE3\u53CC\u5FD7\u539F\u77F3\u3001\u539F\u62D3\u8BB0\u8F7D\u76F8\u5173\u8003\u8BC1\u5206\u6790\uFF0C\u8BE5\u672C\u5B9A\u4E3A\u5B8B\u62D3\u5B64\u672C\u8A00\u4E4B\u6709\u7406\u3002</p>",
        slides: [
            {
                url: $johf1["sight-59917-1.jpg"],
                points: []
            },
            {
                url: $johf1["sight-59917-2.jpg"],
                points: [
                    {
                        x: 1090,
                        y: 288,
                        content: "<p>\u6E56\u5E06\u518C\u524D\u753B\u8DCB\uFF1A\u201C\u7ECD\u5174\u65F6\uFF0C\u300A\u6C38\u9633\u738B\u5FD7\u300B\u5728\u6E05\u98CE\u4E61\u6C11\u5C45\u4E95\u7554\uFF0C\u300A\u656C\u592A\u5983\u5FD7\u300B\u5728\u6E05\u98CE\u4E61\u8DEF\u65C1\u3002\u89C1\u5B8B\u5F20\u517B\u6B63\u300A\u516D\u671D\u4E8B\u8FF9\u7C7B\u7F16\u300B\u3002\u5B8B\u738B\u8986\u658B\u300A\u8986\u658B\u7891\u5F55\u300B\u6536\u5176\u76EE\uFF0C\u672A\u8BE6\u5904\u6240\u3002\u5143\u9676\u4E5D\u6210\u300A\u53E4\u523B\u4E1B\u6284\u300B\u4EC5\u5F55\u300A\u656C\u592A\u5983\u5FD7\u300B\u800C\u4E0D\u7740\u300A\u6C38\u9633\u738B\u5FD7\u300B\uFF0C\u53EF\u77E5\u5143\u65F6\u738B\u5FD7\u5DF2\u4EA1\uFF0C\u9676\u6C0F\u5DF2\u65E0\u4ECE\u89C1\u77E3\uFF0C\u77E7\u8D8A\u4ECA\u53C8\u516D\u767E\u8F7D\uFF0C\u66F4\u53EF\u8D35\u4F55\u5982\u3002\u6881\u4EE3\u6587\u7269\uFF0C\u7947\u6B66\u5E1D\u4E66\u300A\u5F02\u8DA3\u5E16\u300B\uFF0C\u523B\u5165\u300A\u620F\u9E3F\u5802\u300B\u3001\u300A\u4E09\u5E0C\u5802\u300B\u4E8C\u5E16\u4E2D\uFF0C\u4ECA\u4EA6\u4E0D\u77E5\u4EA1\u5B58\u3002\u53C8\uFF0C\u8303\u6C0F\u5929\u4E00\u9601\u6240\u85CF\u4E4B\u5B8B\u62D3\u300A\u65E7\u9986\u575B\u7891\u300B\uFF0C\u4EC5\u987E\u6E58\u821F\u5F97\u5F20\u53D4\u672A\u6240\u5BC4\u53CC\u94A9\u672C\uFF0C\u6469\u52D2\u4E00\u77F3\uFF0C\u8F7D\u7891\u540D\u53CA\u7ED3\u8854\u4E00\u884C\uFF0C\u4E3A\u9676\u5F18\u666F\u624B\u4E66\uFF0C\u539F\u62D3\u4EA6\u4E45\u6E6E\u77E3\u3002\u9759\u6DD1\u53BB\u4E16\u5DF2\u5341\u5E74\uFF0C\u4E94\u8F7D\u4EE5\u6765\uFF0C\u7686\u62B1\u771F\u7EE7\u4E3B\u638C\u7406\uFF0C\u5E76\u8BC6\u4E8E\u8FE2\u8FE2\u9601\u3002\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["sight-59917-3.jpg"],
                points: [
                    {
                        x: 951,
                        y: 1260,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5357\u671D\u6709\u5FD7\u5893\u4E4B\u7981\uFF0C\u6B64\u5949\u6555\u6240\u64B0\uFF0C\u4E43\u7279\u4F8B\u4E5F\u3002\u738B\u5FD7\u6E0A\u7A46\uFF0C\u5983\u5FD7\u5CED\u52B2\uFF0C\u51B5\u4E3A\u5B8B\u62D3\u5B64\u672C\uFF0C\u6D35\u58A8\u7687\u4E5F\u3002\u53CC\u4FEE\u9601\u4E2D\uFF0C\u53EF\u65E0\u6127\u8272\u3002\u7678\u9149\uFF081933\uFF09\u6625\uFF0C\u5434\u6E56\u5E06\u9898\uFF0C\u6F58\u9759\u6DD1\u4E66\u3002\u201D</p><p>\u201C\u539F\u77F3\u300A\u6C38\u9633\u738B\u5FD7\u300B\uFF0C\u51E1\u4E09\u5341\u884C\uFF0C\u884C\u4E09\u5341\u516D\u5B57\uFF1B\u300A\u656C\u592A\u5983\u5FD7\u300B\uFF0C\u51E1\u4E8C\u5341\u516D\u884C\uFF0C\u884C\u4E09\u5341\u4E00\u5B57\u3002\u738B\u5FD7\u7B2C\u4E09\u884C\u2018\u7687\u2019\u5B57\u4F4E\u4E00\u683C\uFF0C\u4E09\u5341\u4E94\u5B57\uFF1B\u77F3\u9AD8\u516D\u5341\u516C\u5206\uFF0C\u9614\u4E94\u5341\u516B\u516C\u5206\u3002\u5983\u5FD7\u9AD8\u9614\u5747\u4E94\u5341\u516C\u5206\u3002\u4ECA\u5C06\u9010\u884C\u77F3\u6587\u6821\u7406\uFF0C\u6240\u6709\u65B9\u5C65\u7C5B\u3001\u9646\u589E\u7965\u672A\u8FA8\u3001\u8BEF\u5904\uFF0C\u4E00\u4E00\u8BA2\u6B63\uFF1B\u540E\u9644\u6444\u5F71\u6574\u672C\uFF0C\u6E56\u5E06\u53C8\u5FD7\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["sight-59917-4.jpg"],
                points: [
                    {
                        x: 3130,
                        y: 251,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5DE6\u4E0B\u89D2\u7F3A\u6709\u738B\u7740\u5C0F\u5370\uFF0C\u6309\u5B8B\u521D\u6709\u738B\u7740\u4E8C\uFF0C\u7686\u4EE5\u4E66\u540D\uFF0C\u867D\u6216\u7531\u540C\u59D3\u540D\u8005\uFF0C\u5747\u65E0\u6B64\u8003\uFF0C\u4EA6\u65E0\u6B64\u5DE7\u5408\u4E5F\u3002\u6E56\u5E06\u8BC6\u201D\u3002</p>"
                    }
                ]
            },
            {
                url: $johf1["sight-59917-5.jpg"],
                points: [
                    {
                        x: 3868,
                        y: 1542,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u4E0D\u72EC\u5B8B\u62D3\uFF0C\u72B9\u662F\u660E\u4EE3\u5E93\u88C5\u3002\u5C24\u53EF\u5B9D\u8D35\uFF0C\u6E56\u5E06\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-64330": {
        caption: "\u6E05 \u65B9\u85B0 \u4EFF\u5927\u75F4\u5C71\u6C34\u56FE\u8F74",
        thumbnail: $johf1["sight-64330-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6768\u74DE\u7EF5\u6350\u8D60</p><p>\u65B9\u85B0\uFF081736-1799\uFF09\uFF0C\u5B57\u5170\u58EB\uFF0C\u53F7\u5170\u5982\uFF0C\u77F3\u95E8\uFF08\u4ECA\u6D59\u6C5F\u5D07\u5FB7\uFF09\u4EBA\u3002\u64C5\u753B\u5C71\u6C34\u3001\u82B1\u9E1F\u3001\u4EBA\u7269\u3002</p><p>\u636E\u300A\u4E11\u7C03\u65E5\u8BB0\u300B\u8F7D\uFF0C\u6B64\u8F74\u4E3A\u5434\u6E56\u5E06\u4E8E1933\u5E74\u8D74\u6CAA\u4E0A\u201C\u6E56\u793E\u4E66\u753B\u5C55\u89C8\u4F1A\u201D\u5F53\u573A\u8D2D\u4E70\u3002\u4ECE\u5434\u6E56\u5E06\u8DCB\u6587\u53EF\u77E5\uFF0C\u5434\u6C0F\u8BA4\u4E3A\u6B64\u56FE\u4E3A\u5176\u4EC5\u89C1\u7684\u65B9\u85B0\u5C71\u6C34\u753B\u771F\u8FF9\uFF0C\u79F0\u201C\u89C2\u6B64\u53EF\u8BC1\u7EA4\u5F31\u4E00\u79CD\uFF0C\u7686\u975E\u65B9\u6C0F\u771F\u8FF9\u201D\u3002\u5728\u957F\u671F\u63A2\u6C42\u4E2D\uFF0C\u5434\u6E56\u5E06\u4E0D\u65AD\u5C06\u7ECF\u9A8C\u4E0E\u5FC3\u5F97\u52A0\u4EE5\u603B\u7ED3\uFF0C\u5E76\u5C06\u8FD9\u4E9B\u6210\u679C\u8FD0\u7528\u4E8E\u5B9E\u9645\u9274\u5B9A\u4E2D\u3002</p>",
        slides: [
            {
                url: $johf1["sight-64330-1.jpg"],
                points: [
                    {
                        x: 1728,
                        y: 128,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u595A\u94C1\u751F\u9898\u65B9\u5170\u577B\u300A\u4EFF\u5927\u75F4\u5BC6\u6797\u9661\u58D1\u56FE\u300B\u3002\u4E7E\u5609\u4E4B\u9645\uFF0C\u77F3\u95E8\u65B9\u5170\u577B\u85B0\u4E0E\u94B1\u5510\u595A\u94C1\u751F\u5188\u658B\u540D\u753B\u575B\uFF0C\u66F0\uFF1A\u65B9\u3001\u595A\u76D6\u7EE7\u2018\u56DB\u738B\u5434\u607D\u2019\u4E4B\u540E\u9886\u8896\u827A\u82D1\u3002\u595A\u753B\u6BCF\u6613\u83B7\u89C2\uFF0C\u65B9\u753B\u5219\u5341\u4E0D\u4E00\u4E8C\u3002\u6B64\u56FE\u65B9\u6C0F\u771F\u8FF9\uFF0C\u53C8\u5F97\u595A\u6C0F\u9898\u8BED\uFF0C\u4E8C\u96BE\u5E76\u5408\uFF0C\u592B\u5C82\u5076\u7136\u54C9\u3002\u7678\u9149\uFF081933\uFF09\u56DB\u6708\u5F97\u4E8E\u6CAA\u4E0A\uFF0C\u5434\u6E56\u5E06\u9898\u8BB0\u4E8E\u6885\u666F\u4E66\u5C4B\u3002\u201D</p>"
                    },
                    {
                        x: 136,
                        y: 2164,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u65B9\u6A17\u5EB5\u4E66\u591A\u82B1\u5349\uFF0C\u5C71\u6C34\u4EC5\u89C1\u6B64\u5E45\uFF0C\u7528\u7B14\u6C89\u90C1\uFF0C\u6709\u4EF2\u572D\u3001\u9999\u5149\u795E\u5473\uFF0C\u8FDC\u51FA\u5F20\u7BC1\u90A8\u3001\u94B1\u6587\u654F\u4E4B\u4E0A\u3002\u89C2\u6B64\u53EF\u8BC1\u7EA4\u5F31\u4E00\u79CD\uFF0C\u7686\u975E\u65B9\u6C0F\u771F\u8FF9\u3002\u595A\u8499\u6CC9\u9898\u66F0\u8FD1\u5927\u75F4\u300A\u9661\u58D1\u5BC6\u6797\u56FE\u300B\uFF0C\u72B9\u672A\u80FD\u5C3D\u5176\u957F\u4E5F\u3002\u56DB\u6708\u4E94\u65E5\u5434\u6E56\u5E06\u9898\u65B9\u3001\u595A\u53CC\u5E45\u4E4B\u4E00\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-64339": {
        caption: "\u660E \u8463\u5176\u660C \u5317\u5C71\u8377\u9504\u56FE\u8F74",
        thumbnail: $johf1["sight-64339-0.jpg"],
        description: "<p>\u7EEB\u672C \u6C34\u58A8</p><p>\u8463\u5176\u660C\u7684\u4F5C\u54C1\u662F\u5434\u6E56\u5E06\u91CD\u8981\u7684\u6536\u85CF\u5BF9\u8C61\uFF0C\u5728\u9274\u5B9A\u4E0A\uFF0C\u5434\u6E56\u5E06\u4EA6\u5BF9\u5176\u4F5C\u72EC\u6709\u5FC3\u5F97\uFF0C\u3002\u6B64\u56FE\u5434\u6C0F\u4ECE\u8463\u5176\u660C\u7684\u4E66\u8FF9\u4E0E\u753B\u98CE\u5224\u65AD\uFF0C\u5B9A\u4E3A\u8463\u6C0F\u4E03\u5341\u5C81\u5DE6\u53F3\u4F5C\u54C1\uFF0C\u5F53\u5C5E\u7684\u8BBA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-64339-1.jpg"],
                points: [
                    {
                        x: 1830,
                        y: 1701,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u601D\u7FC1\u795E\u6765\u4E4B\u7B14\uFF0C\u76F4\u903C\u75F4\u8FC2\u3002\u6B64\u56FE\u5929\u673A\u6D41\u7545\u3001\u521A\u5065\u5A40\u5A1C\uFF0C\u6050\u8D77\u502A\u9EC4\uFF0C\u4EA6\u5F53\u9000\u907F\uFF0C\u975E\u5BFB\u5E38\u968F\u7B14\u53EF\u53CA\u3002\u5BA1\u5176\u7B14\u52BF\uFF0C\u5728\u4E03\u5341\u5C81\u4EE5\u524D\u6240\u4F5C\u4E3A\u65E0\u7591\u4E49\u3002\u5E9A\u5BC5\uFF081950\uFF09\u590F\u5434\u6E56\u5E06\u9274\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-64770": {
        caption: "\u660E \u6587\u5F81\u660E \u79CB\u58F0\u8D4B\u56FE\u5377",
        thumbnail: $johf1["sight-64770-0.jpg"],
        description: "<p>\u5609\u9756\u4E8C\u5341\u516D\u5E74\uFF081547\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6B64\u56FE\u4F5C\u4E8E1547\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E03\u5341\u516B\u5C81\u3002\u56FE\u540E\u4E3A\u660E\u4EE3\u738B\u5B88\u8349\u4E66\u79CB\u58F0\u8D4B\uFF0C\u636E\u9898\u8DCB\u53EF\u77E5\uFF0C\u6B64\u753B\u6216\u4E3A\u6587\u5F81\u660E\u4E8E\u5609\u9756\u4E8C\u5341\u516D\u5E74\u590F\u5F80\u8BBF\u738B\u5B88\u3001\u738B\u5BA0\u5144\u5F1F\u65F6\u4E3A\u738B\u5B88\u7684\u81EA\u4E66\u5377\u8865\u56FE\u3002</p><p>\u5434\u6E56\u5E06\u9274\u5B9A\u91CD\u89C6\u7B14\u6CD5\u548C\u76F8\u5173\u80CC\u666F\u8D44\u6599\u7684\u8003\u8BC1\u3002\u901A\u8FC7\u5BF9\u6B64\u5377\u5F15\u9996\u56DB\u5B57\u7B14\u6CD5\u7684\u6BD4\u5BF9\uFF0C\u5434\u6E56\u5E06\u63A8\u7FFB\u4E86\u738B\u517B\u5EA6\u7684\u7ED3\u8BBA\uFF0C\u8BA4\u4E3A\u6B64\u56DB\u5B57\u5E76\u975E\u6587\u5F81\u660E\u6240\u4E66\uFF0C\u800C\u662F\u51FA\u81EA\u738B\u5B88\u3002\u6B64\u5916\uFF0C\u5434\u6C0F\u8FD8\u5BF9\u738B\u5B88\u3001\u738B\u5BA0\u5144\u5F1F\u8BFB\u4E66\u7684\u77F3\u6E56\u7CBE\u820D\u548C\u201C\u97E1\u97E1\u658B\u201D\u5370\u7AE0\u8FDB\u884C\u8003\u5BDF\uFF0C\u63A8\u65AD\u6587\u6C0F\u6B3E\u8BC6\u201C\u5BD3\u6E56\u4E0A\u201D\uFF0C\u76D6\u5373\u5BA2\u5BD3\u738B\u6C0F\u5144\u5F1F\u7684\u77F3\u6E56\u7CBE\u820D\uFF0C\u8FDB\u800C\u5BF9\u6B64\u56FE\u7684\u4F5C\u753B\u5730\u70B9\u8FDB\u884C\u4E86\u5408\u7406\u63A8\u8BBA\u3002</p>",
        slides: [
            {
                url: $johf1["sight-64770-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 15766,
                        y: 97,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u53F3\u5F15\u9996\u56DB\u5927\u5B57\u4EA6\u738B\u6DB5\u5CF0\u624B\u4E66\u4E5F\uFF0C\u4F9D\u7B14\u52BF\u7D22\u4E4B\u4E0E\u540E\u8D4B\u4E00\u81F4\u3002\u8F9B\u536F\u79CB\u65E5\u5434\u6E56\u5E06\u9274\u5B9A\u3002\u201D</p>"
                    },
                    {
                        x: 10465,
                        y: 81,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u662F\u56FE\u6587\u6C0F\u7528\u7B14\u5B8C\u5168\u53D6\u6CD5\u738B\u9EC4\u9E64\u53CA\u677E\u79C0\u4E4B\u80FD\u4E8B\uFF0C\u6B3E\u8BC6\u2018\u5BD3\u6E56\u4E0A\u2019\uFF0C\u76D6\u5373\u738B\u6DB5\u5CF0\u3001\u5C65\u5409\u5144\u5F1F\u77F3\u6E56\u7CBE\u820D\u4E5F\u3002\u201D</p>"
                    },
                    {
                        x: 959,
                        y: 112,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u77F3\u6E56\u7CBE\u820D\u4E3A\u738B\u6DB5\u5CF0\u5B88\u3001\u5C65\u5409\u5BA0\u5144\u5F1F\u8BFB\u4E66\u5904\u3002\u5BB6\u6709\u97E1\u97E1\u9F50\uFF0C\u4F59\u66FE\u6536\u5C65\u5409\u4E66\u5C0F\u6977\u300A\u4E09\u8D4B\u300B\u518C\uFF0C\u4EA6\u94A4\u6B64\u5370\u53EF\u8BC1\u3002\u738B\u6C0F\u6606\u5F1F\u4FF1\u53D7\u5B66\u4E8E\u8521\u4E5D\u9035\u7FBD\uFF0C\u4E66\u6CD5\u7686\u4E60\u6C38\u5174\uFF0C\u800C\u6DB5\u5CF0\u517C\u6D89\u82CF\u3001\u7C73\uFF0C\u5C65\u5409\u5C0F\u6977\u5219\u7CBE\u4E8E\u5927\u4EE4\u300A\u5341\u4E09\u884C\u300B\u3002\u6B64\u300A\u79CB\u58F0\u8D4B\u300B\u76D6\u6DB5\u5CF0\u5F97\u610F\u4E66\uFF0C\u6216\u662F\u590F\u8861\u7FC1\u9002\u81F3\u7CBE\u820D\uFF0C\u6DB5\u5CF0\u53C8\u51FA\u89C2\u8D4F\u4E4B\uFF0C\u4E3A\u4E4B\u8865\u56FE\uFF0C\u4E43\u8FD1\u60C5\u7406\u4E4B\u4E8B\u3002\u738B\u8499\u6CC9\u4EE5\u4E3A\u5F15\u9996\u56DB\u5B57\u4E3A\u6587\u4E66\u5219\u8BEF\u4E5F\u3002\u524D\u5C81\u83B7\u4E8E\u6CAA\u4E0A\uFF0C\u8F9B\u536F\uFF081951\uFF09\u79CB\u91CD\u88C5\uFF0C\u5434\u6E56\u5E06\u8BC6\u3002\u5F15\u9996\u4E3A\u738B\u6DB5\u5CF0\u4E66\uFF0C\u53C8\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "sight-64772": {
        caption: "\u660E \u6234\u8FDB \u79CB\u6797\u7B56\u6756\u56FE\u9875",
        thumbnail: $johf1["sight-64772-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6234\u8FDB\uFF081388-1462\uFF09\uFF0C\u5B57\u6587\u8FDB\uFF0C\u53F7\u9759\u5EB5\u3001\u7389\u6CC9\u5C71\u4EBA\u3002\u94B1\u5858\uFF08\u4ECA\u6D59\u6C5F\u676D\u5DDE\uFF09\u4EBA\u3002\u6B64\u56FE\u65E0\u4F5C\u8005\u6B3E\u5370\u3002\u7ECF\u5434\u6E56\u5E06\u8003\u8BC1\uFF0C\u4F5C\u8005\u5E94\u4E3A\u6234\u8FDB\u3002</p><p>\u6B64\u56FE\u4E3A\u5434\u6E56\u5E06\u96C6\u914D\u660E\u521D\u753B\u5BB6\u5C71\u6C34\u518C\u9875\u4E4B\u4E00\u3002\u5434\u6E56\u5E06\u5BF9\u5176\u6240\u9274\u85CF\u7684\u4E66\u753B\u5927\u591A\u4F1A\u8FDB\u884C\u4E00\u756A\u8003\u8BA2\uFF0C\u6216\u8FFD\u6EAF\u98CE\u683C\u6E0A\u6E90\uFF0C\u6216\u722C\u68B3\u6D41\u4F20\u8F68\u8FF9\uFF0C\u5F80\u5F80\u8A00\u7B80\u610F\u8D45\uFF0C\u5207\u4E2D\u80AF\u7DAE\uFF0C\u8FD9\u6B63\u662F\u5176\u4E0E\u4E00\u822C\u85CF\u5BB6\u7684\u4E0D\u540C\u4E4B\u5904\uFF0C\u4EA6\u662F\u540E\u4EBA\u5206\u5916\u91CD\u89C6\u5176\u85CF\u54C1\u7684\u539F\u56E0\u3002</p>",
        slides: [
            {
                url: $johf1["sight-64772-1.jpg"],
                points: [
                    {
                        x: 1792,
                        y: 103,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u6234\u6587\u8FDB\u300A\u79CB\u6797\u7B56\u6756\u56FE\u300B\u3002\u94B1\u5858\u6234\u8FDB\u5B97\u6CD5\u9A6C\u590F\uFF0C\u4E3A\u5317\u5B8B\u540E\u52B2\u3002\u81EA\u5143\u4EE5\u6765\u7686\u5B97\u5B50\u4E45\u3001\u53D4\u660E\uFF0C\u51E1\u9A6C\u3001\u590F\u65A7\u5288\u51E0\u4E3A\u51C8\u626B\uFF0C\u660E\u521D\u4EE5\u6765\u7947\u6234\u6C0F\u4E00\u4EBA\u72EC\u6811\u575B\u576B\uFF0C\u4EFF\u4F5B\u5317\u5B8B\u4E2D\u9C81\u6BBF\u4E5F\u3002\u662F\u56FE\u51FA\u81EA\u590F\u79B9\u7389\u800C\u5F97\u5F62\u795E\u4FF1\u4F3C\u8005\uFF0C\u6D35\u540D\u7B14\u7109\u3002\u543E\u53CB\u95FD\u4FAF\u674E\u62D4\u53EF\u5148\u751F\u8FD1\u83B7\u300A\u5B8B\u5143\u96C6\u73CD\u518C\u300B\uFF0C\u4E2D\u6709\u4E00\u5E27\u6597\u65B9\uFF0C\u7EE2\u672C\uFF0C\u6B3E\u4E66\u2018\u590F\u572D\u2019\u4E8C\u5C0F\u5B57\uFF0C\u6811\u77F3\u4F4D\u7F6E\u4E0E\u6B64\u6089\u5408\uFF0C\u5176\u6B64\u4E4B\u6EE5\u89DE\u4E0E\uFF1F\u6E56\u5E06\u53C8\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-3310": {
        caption: "\u5317\u5B8B \u8D75\u4F76 \u6977\u4E66\u5343\u5B57\u6587\u5377",
        thumbnail: $johf1["life1-3310-0.jpg"],
        description: "<p>\u5D07\u5B81\u4E09\u5E74\uFF081104\uFF09</p><p>\u7EB8\u672C</p><p>\u8D75\u4F76\uFF081082-1135\uFF09\uFF0C\u5373\u5B8B\u5FBD\u5B97\uFF0C\u64C5\u4E66\u6CD5\uFF0C\u81EA\u521B \u201C\u7626\u91D1\u4F53\u201D\u3002\u6B64\u5377\u4E0E\u5176\u4F20\u4E16\u53E6\u4E00\u540D\u8FF9 \u2014\u2014\u300A\u5B8B\u4EBA\u6CD5\u4E66\u300B\u7B2C\u4E00\u518C\u300A\u6B32\u501F\u98CE\u971C\u4E8C\u8BD7\u5E16\u300B\u7528\u7B14\u76F8\u540C\uFF0C\u4E3A\u4F20\u4E16\u540D\u8FF9\u3002\u6B64\u4E66\u7ED3\u4F53\u5300\u79F0\uFF0C\u7528\u7B14\u8F7B\u6309\u91CD\u6536\uFF0C\u987F\u8F6C\u5229\u843D\uFF0C\u5177\u6709\u98D8\u9038\u6E05\u6DA6\u4E4B\u611F\u3002\u7531\u5377\u5C3E\u5E74\u6B3E\u53EF\u77E5\uFF0C\u672C\u5377\u4E3A\u8D75\u4F76\u4E8C\u5341\u4E09\u5C81\u65F6\u4F5C\u54C1\u3002</p><p>\u6B64\u5377\u540E\u81EA\u6E05\u5BAB\u6D41\u6563\uFF0C\u4E3A\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u592B\u59871924\u5E74\u6B63\u5F0F\u79FB\u5C45\u4E0A\u6D77\u540E\u6240\u8D2D\u6CD5\u4E66\u540D\u8FF9\u4E4B\u4E00\u3002</p>",
        slides: [
            {
                url: $johf1["life1-3310-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 224,
                        y: 40,
                        content: "<p>\u8D75\u4F76\u9898\u6B3E\u91CA\u6587\uFF1A\u201C\u5D07\u5B81\u7532\u7533\u5C81\uFF081104\uFF09\uFF0C\u5BA3\u548C\u6BBF\u4E66\uFF0C\u8D50\u7AE5\u8D2F\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-6662": {
        caption: "\u5143 \u8D75\u96CD \u9752\u5F71\u7EA2\u5FC3\u56FE\u8F74",
        thumbnail: $johf1["life1-6662-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u8D75\u96CD\uFF081289-1360\u540E\uFF09\uFF0C\u5B57\u4EF2\u7A46\uFF0C\u5434\u5174\uFF08\u4ECA\u6D59\u6C5F\u6E56\u5DDE\uFF09\u4EBA,\u8D75\u5B5F\u982B\u5B50\u3002\u4E66\u753B\u7EE7\u627F\u5BB6\u5B66\uFF0C\u5C24\u7CBE\u4EBA\u7269\u978D\u9A6C\u3002\u56FE\u4E2D\u4EE5\u58A8\u9752\u6487\u51FA\u7AF9\u53F6\u548C\u8559\u5170\u53F6\u7247\uFF0C\u4EE5\u6C41\u7EFF\u70B9\u5170\u82B1\u74E3\uFF0C\u7EDB\u7EA2\u8F7B\u67D3\u854A\u5FC3\uFF0C\u8FD1\u6CA1\u9AA8\u53E4\u6CD5\uFF0C\u4E3A\u5143\u4EBA\u5170\u7AF9\u753B\u4E2D\u6240\u7F55\u89C1\u3002\u56FE\u4E2D\u7AF9\u5E72\u6D51\u5706\u539A\u91CD\u5982\u5199\u7BC6\u7C40\uFF0C\u7AF9\u53F6\u9052\u52B2\u51DD\u70BC\u6070\u4F3C\u516B\u5206\uFF0C\u6F47\u6D12\u98D8\u9038\u7684\u5170\u53F6\u5C31\u50CF\u884C\u8349\u4E66\u3002\u518D\u4F34\u4E4B\u4EE5\u6E56\u77F3\uFF0C\u663E\u51FA\u5BCC\u6709\u6587\u4EBA\u753B\u8DA3\u5473\u7684\u4E66\u6CD5\u610F\u97F5\u3002</p><p>\u6B64\u56FE\u7ECF\u660E\u6587\u5F81\u660E\u3001\u9879\u5143\u6C74\u85CF\u3002\u5728\u6210\u4E3A\u6885\u666F\u4E66\u5C4B\u85CF\u54C1\u524D\uFF0C\u4E00\u5EA6\u4E3A\u5434\u6E56\u5E06\u53CB\u4EBA\u9EC4\u4EF2\u660E\u6240\u6536\u85CF\u3002</p>",
        slides: [
            {
                url: $johf1["life1-6662-1.jpg"],
                points: []
            }
        ]
    },
    "life1-8815": {
        caption: "\u5357\u5B8B \u8D75\u6784 \u4E34\u865E\u4E16\u5357\u771F\u8349\u5343\u5B57\u6587\u5377",
        thumbnail: $johf1["life1-8815-0.jpg"],
        description: "<p>\u7EE2\u672C</p><p>\u8D75\u6784\uFF081107-1187\uFF09\uFF0C\u5B57\u5FB7\u57FA\uFF0C\u5B8B\u9AD8\u5B97\u3002\u5DE5\u6B63\u3001\u884C\u3001\u8349\u4E66\uFF0C\u5C11\u5373\u559C\u63FD\u7B14\u4F5C\u5B57\u3002\u7B14\u6CD5\u7AEF\u96C5\u6DF3\u539A\u3001\u6DB5\u6CF3\u96BD\u79C0\uFF0C \u76D6\u4EE5\u5F97\u529B\u4E8E\u667A\u6C38\u4E3A\u591A\uFF0C\u53C8\u5C1D\u6DF1\u7A76\u672C\u671D\u9EC4\u5EAD\u575A\u4E66\uFF0C\u4EA6\u9887\u80FD\u5F97\u5176\u795E\u9AD3\u3002</p><p>\u6B64\u5377\u662F\u5434\u6E56\u5E06\u4E8E1930\u5E74\u5728\u4E0A\u6D77\u8D2D\u5F97\u3002</p>",
        slides: [
            {
                url: $johf1["life1-8815-1.jpg"],
                zoomLevel: 10,
                points: []
            }
        ]
    },
    "life1-19800": {
        caption: "\u660E \u8463\u5176\u660C \u753B\u7985\u5BA4\u5C0F\u666F\u56FE\u518C",
        thumbnail: $johf1["life1-19800-0.jpg"],
        description: "<p>\u4E07\u5386\u56DB\u5341\u516D\u5E74\uFF081618\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6709\u8463\u5176\u660C\u81EA\u7B7E\uFF1A\u201C\u753B\u7985\u5BA4\u5C0F\u666F\u56DB\u5E45\uFF0C\u620A\u5348\uFF081618\uFF09\u4E09\u6708\u3002\u201D\u53EF\u77E5\u4F5C\u8005\u65F6\u5E74\u516D\u5341\u56DB\u5C81\u3002</p><p>\u8463\u5176\u660C\u5728\u7ED8\u753B\u7406\u8BBA\u4E0A\u7684\u6700\u5927\u8D21\u732E\uFF0C\u83AB\u8FC7\u4E8E\u753B\u5206\u5357\u5317\uFF0C\u4EE5\u7985\u55BB\u753B\u3002\u5434\u6E56\u5E06\u94A4\u201C\u5B9D\u8463\u5BA4\u201D\u5370\u4E8E\u518C\u4E0A\uFF0C\u5B9E\u5C5E\u53CC\u7F8E\u3002\u6B64\u5370\u4E3A\u5176\u5916\u7956\u7236\u6C88\u6811\u955B\u8BF7\u94B1\u53D4\u76D6\u6240\u6CBB\uFF0C\u4E0D\u5E78\u6563\u4F5A\u4ED6\u5904\uFF0C\u540E\u7EC8\u5F97\u5B8C\u74A7\u3002\u4ECA\u4E0E\u8463\u6C0F\u753B\u4F5C\u76F8\u6620\u6210\u8F89\u3002\u5434\u6E56\u5E06\u5916\u7956\u6C88\u6C0F\u4E0E\u5176\u672C\u4EBA\u7686\u4EE5\u201C\u5B9D\u8463\u201D\u540D\u5BA4\uFF0C\u6B64\u4E3A\u51FA\u5904\u4E4B\u4E00\u3002</p>",
        slides: [
            {
                url: $johf1["life1-19800-1.jpg"],
                points: []
            },
            {
                url: $johf1["life1-19800-2.jpg"],
                points: [
                    {
                        x: 1709,
                        y: 518,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u5148\u5916\u7956\u97F5\u521D\u6C88\u516C\u6536\u5317\u82D1\u300A\u590F\u5C71\u56FE\u300B\u5927\u5377\u3001\u300A\u8C3F\u5C71\u884C\u65C5\u300B\u534A\u5E45\u56FE\uFF0C\u989C\u5C45\u6240\u66F0\u2018\u5B9D\u8463\u2019\uFF0C\u5029\u4EC1\u548C\u94B1\u53D4\u76D6\u6CBB\u5C0F\u5370\u7109\u3002\u6B64\u54B8\u4E30\u95F4\u4E8B\uFF0C\u7CA4\u4ECA\u4E03\u5341\u5E74\u3002\u5317\u82D1\u4E8C\u753B\u4FF1\u4E0D\u4E3A\u6C88\u6C0F\u6709\uFF0C\u5C0F\u5370\u7531\u6E58\u4E4B\u8868\u5144\u8D3B\u4F59\uFF0C\u65F6\u620A\u5348\u5341\u6708\u9002\u5F97\u601D\u7FC1\u300A\u620F\u9E3F\u5802\u6479\u53E4\u6CD5\u5E16\u300B\u5341\u5377\u771F\u8FF9\uFF0C\u56E0\u6CBF\u2018\u5B9D\u8463\u2019\u4E4B\u540D\u540D\u4F59\u5C0F\u5BA4\u3002\u524D\u5E74\u53C8\u83B7\u6B64\u518C\uFF0C\u4E43\u601D\u7FC1\u81EA\u6021\u7269\uFF0C\u867D\u4EC5\u56DB\u53F6\uFF0C\u800C\u7CBE\u5999\u7EDD\u4F26\uFF0C\u80DC\u4EBA\u9E45\u6EAA\u5341\u4E08\u7EE2\u4E5F\uFF0C\u56E0\u8BC6\u2018\u5B9D\u8463\u2019\u4E4B\u7531\u3002\u8F9B\u672A\uFF081931\uFF09\u4E09\u6708\u5341\u65E5\u53C8\u9898\u3002\u201D</p><p>\u201C\u9189\u821E\u4E14\u6447\u9E3E\u51E4\u5F71\uFF0C\u6D69\u6B4C\u83AB\u9063\u9C7C\u9F99\u6CE3\u3002\u6B64\u8F9B\u7A3C\u8F69\u5F97\u610F\u53E5\uFF0C\u4EFF\u4F5B\u601D\u7FC1\u7EB5\u7B14\u60C5\u6982\u3002\u540E\u5B66\u5434\u6E56\u5E06\u6F2B\u4E66\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-19800-3.jpg"],
                points: []
            }
        ]
    },
    "life1-20015": {
        caption: "\u6E05 \u738B\u7FDA \u4EFF\u5173\u4EDD\u6EAA\u5C71\u6674\u972D\u56FE\u5377",
        thumbnail: $johf1["life1-20015-0.jpg"],
        description: "<p>\u5EB7\u7199\u5341\u4E03\u5E74\uFF081678\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u738B\u7FDA\uFF081632-1717\uFF09\u5B57\u77F3\u8C37\uFF0C\u6C5F\u82CF\u5E38\u719F\u4EBA\u3002\u6E05\u521D\u201C\u56DB\u738B\u201D\u4E4B\u4E00\u3002\u672C\u56FE\u662F\u4F5C\u8005\u56DB\u5341\u4E03\u5C81\u65F6\u6240\u4F5C\uFF0C\u4E3A\u6570\u6708\u4E4B\u540E\u8D74\u4EAC\u4E3B\u6301\u300A\u5EB7\u7199\u5357\u5DE1\u56FE\u300B\u524D\u7684\u91CD\u8981\u4F5C\u54C1\u3002</p><p>1937\u5E74\u6297\u6218\u7206\u53D1\uFF0C\u4E71\u4E16\u4E4B\u9645\uFF0C\u5357\u5317\u963B\u9694\uFF0C\u5C24\u5176\u6C5F\u6D59\u8FED\u906D\u5175\u4E71\uFF0C\u5434\u6C0F\u5BB6\u65CF\u7ECF\u6D4E\u6765\u6E90\u53D7\u5230\u4E25\u91CD\u51B2\u51FB\uFF0C\u201C\u5E73\u751F\u5FC3\u7231\u4E4B\u54C1\u51FA\u95E8\uFF0C\u51E0\u5982\u674E\u540E\u4E3B\u6325\u6CEA\u522B\u5B98\u4EBA\uFF0C\u610F\u6B8A\u4E0D\u820D\uFF0C\u60C5\u5B9E\u96BE\u582A\u201D\u3002\u6B64\u756A\u60C5\u5F62\u81F31938\u5E74\u590F\u5B63\u59CB\u6709\u597D\u8F6C\uFF0C\u6B64\u5377\u4EE5\u53CA\u672C\u5C55\u4E2D\u94B1\u9009\u300A\u8E74\u97A0\u56FE\u300B\u5377\u3001\u5143\u4EBA\u300A\u5C71\u6C34\u4E09\u6BB5\u56FE\u300B\u5377\u7B49\u5DE8\u8FF9\u7686\u4E3A\u4E4B\u540E\u6240\u8D2D\u3002</p>",
        slides: [
            {
                url: $johf1["life1-20015-1.jpg"],
                zoomLevel: 10,
                points: []
            }
        ]
    },
    "life1-31912": {
        caption: "\u5143 \u94B1\u9009 \u8E74\u97A0\u56FE\u5377",
        thumbnail: $johf1["life1-31912-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u94B1\u9009\uFF08\u7EA61235-1299\u540E\uFF09\u5B57\u821C\u4E3E\uFF0C\u53F7\u7389\u6F6D\uFF0C\u5434\u5174\uFF08\u4ECA\u6D59\u6C5F\u6E56\u5DDE\uFF09\u4EBA\u3002\u5B8B\u672B\u5143\u521D\u8457\u540D\u753B\u5BB6\u3002\u672C\u56FE\u662F\u5426\u51FA\u81EA\u94B1\u9009\u624B\u7B14\uFF0C\u5C1A\u5F85\u7814\u7A76\u3002</p><p>\u5434\u6E56\u5E06\u4EE5\u4E00\u201C\u5F7C\u6B64\u7686\u81F3\u5B9D\u201D\u7684\u201C\u5468\u56DB\u8DB3\u5B9D\u6566\u201D\u6362\u5F97\u6B64\u300A\u8E74\u97A0\u56FE\u300B\u4E0E\u5143\u4EBA\u300A\u5C71\u6C34\u4E09\u6BB5\u56FE\u300B\u5377\u3002\u636E\u8DCB\u53EF\u77E5\uFF0C\u5434\u6C0F\u8BA4\u4E3A\u94B1\u9009\u662F\u5B8B\u5143\u4E4B\u95F4\u7ED8\u753B\u98CE\u6C14\u8F6C\u53D8\u7684\u5173\u952E\u4EBA\u7269\uFF0C\u662F\u542F\u53D1\u4E86\u6587\u4EBA\u753B\u98CE\u7684\u5B97\u5320\u3002\u6536\u85CF\u5BB6\u7684\u85CF\u54C1\u6700\u80FD\u53CD\u6620\u4ED6\u7684\u827A\u672F\u89C2\u70B9\u4E0E\u54C1\u5473\uFF0C\u6E56\u5E06\u4E0D\u9057\u4F59\u529B\u5730\u8D2D\u85CF\u94B1\u9009\u4E0E\u5143\u4EBA\u4F5C\u54C1\uFF0C\u662F\u5176\u827A\u672F\u4F20\u627F\u6587\u4EBA\u753B\u98CE\u7684\u6709\u529B\u4F50\u8BC1\u3002</p>",
        slides: [
            {
                url: $johf1["life1-31912-1.jpg"],
                zoomLevel: 5,
                points: [
                    {
                        x: 6288,
                        y: 78,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u94B1\u821C\u4E3E\u8E74\u97A0\u56FE\u771F\u8FF9\u3002\u9705\u5DDD\u7FC1\u753B\u5143\u521D\u51A0\u5195\uFF0C\u677E\u96EA\u4EE5\u5E08\u793C\u4E8B\u4E4B\u3002\u5176\u6240\u4F5C\u4EBA\u7269\u76F4\u7EE7\u9053\u5B50\u3001\u9F99\u7720\u3002\u6B64\u56FE\u65E7\u85CF\u738B\u5F07\u5DDE\u8BB8\u3002\u6E56\u5E06\u79D8\u7C4D\u3002\u201D</p>"
                    },
                    {
                        x: 3534,
                        y: 84,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u7389\u6F6D\u5F53\u5B8B\u5143\u4E4B\u4EA4\u4EE5\u4E66\u753B\u76F8\u5C1A\uFF0C\u5C06\u5B8B\u8D24\u523B\u753B\u8F6C\u5553\u5143\u4EBA\u6F47\u6D12\u6CD5\u95E8\uFF0C\u6545\u5982\u623F\u5C71\u3001\u677E\u96EA\u3001\u5B50\u4E45\u3001\u8D1E\u7D20\u8BF8\u5BB6\u54B8\u63A8\u4E4B\u5B97\u5E08\u3002\u5176\u771F\u8FF9\u4E4B\u6D41\u4F20\u8FC4\u4ECA\u8005\u76D6\u4EA6\u4EC5\u77E3\u3002\u4F59\u6240\u89C1\u300A\u5C71\u5C45\u56FE\u300B\u4E09\u5377\u53CA\u6545\u5185\u300A\u79CB\u74DC\u300B\u800C\u5DF2\uFF0C\u82E5\u300A\u68A8\u82B1\u300B\u3001\u300A\u7D2B\u8304\u679C\u300B\u4EA6\u719F\u95F2\uFF0C\u60DF\u4EBA\u7269\u66F4\u7F55\u3002\u6B64\u300A\u8E74\u97A0\u56FE\u300B\u5C24\u4E3A\u540D\u8FF9\uFF0C\u89C2\u5176\u9898\u53E5\u53EF\u4EE5\u60F3\u8C61\u4E5F\u3002\u524D\u6708\u4F59\u6B63\u75C5\u5367\u69BB\uFF0C\u53CB\u4EBA\u6301\u81F3\uFF0C\u4E0E\u5B50\u4E45\u300A\u5BCC\u6625\u5269\u5C71\u300B\u540C\u6765\uFF0C\u9605\u4E4B\u89C9\u8EAB\u5FC3\u4FF1\u5FEB\uFF0C\u75C5\u5F31\u534A\u5931\u3002\u9759\u6DD1\u5C55\u4E4B\u800C\u7B11\u66F0\uFF1A\u2018\u5927\u9EC4\u4E00\u94B1\u53EF\u4EE5\u970D\u7136\u3002\u2019\u4E3A\u68C0\u5546\u5F5D\u76F8\u6613\uFF0C\u7F6E\u4E4B\u6795\u7554\u8005\u65EC\u65E5\u4E43\u4ED8\u88C5\u3002\u65F6\u620A\u5BC5\uFF081938\uFF09\u5341\u4E8C\u6708\u75C5\u8D77\u8BC6\u4E4B\uFF0C\u5750\u89C2\u8005\u5185\u5B50\u6F58\u9759\u6DD1\u540C\u7F72\uFF0C\u65F6\u5728\u6885\u666F\u4E66\u5C4B\u6674\u7A97\u3002\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    },
                    {
                        x: 1026,
                        y: 108,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u805A\u8BC6\u4EBA\u95F2\u6DF7\u7B49\u4F26\uFF0C\u5C82\u6B8A\u51E1\u7FFC\u4E0E\u5E38\u9E9F\u3002\u4E00\u671D\u9F99\u51E4\u98DE\u5929\u53BB\uFF0C\u603B\u662F\u6500\u9F99\u9644\u51E4\u4EBA\u3002\u9752\u5DFE\u9EC4\u888D\u8005\uFF0C\u5B8B\u592A\u7956\u4E5F\uFF1B\u5BF9\u8E74\u97A0\u8005\uFF0C\u8D75\u666E\u4E5F\uFF1B\u9752\u5DFE\u8863\u7D2B\u8005\uFF0C\u592A\u5B97\u4E5F\uFF1B\u5C45\u592A\u5B97\u4E4B\u4E0B\u4E43\u77F3\u5B88\u4FE1\u4E5F\uFF1B\u5DFE\u5782\u4E8E\u524D\u8005\u515A\u664B\u4E5F\uFF1B\u5E74\u5C11\u9752\u8863\u8005\uFF0C\u695A\u662D\u8F85\u4E5F\u3002\u5609\u9756\u5DF1\u9149\uFF081549\uFF09\u4E03\u6708\u5341\u56DB\u65E5\uFF0C\u5F81\u660E\u8BC6\u3002\u6309\u5609\u9756\u5EFF\u516B\u5E74\u5DF1\u9149\u4E3A\u516C\u5386\u4E00\u5343\u4E94\u767E\u56DB\u5341\u4E5D\u5E74\uFF0C\u8D8A\u4ECA\u4E09\u767E\u4E5D\u5341\u516D\u5E74\u77E3\u3002\u4F59\u66FE\u89C1\u6587\u6C0F\u6479\u94B1\u6C0F\u672C\u9898\u6B64\u8BD7\u8BB0\uFF0C\u56E0\u5F55\u5165\u3002\u7532\u7533\uFF081944\uFF09\u51AC\u65E5\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-45513": {
        caption: "\u660E \u5510\u5BC5 \u9A91\u9A74\u601D\u5F52\u56FE\u8F74",
        thumbnail: $johf1["life1-45513-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u5510\u5BC5\uFF081470-1523\uFF09\uFF0C\u5B57\u4F2F\u864E\u3001\u5B50\u754F\uFF0C\u53F7\u516D\u5982\u5C45\u58EB\u7B49\u3002</p><p>\u6B64\u5510\u5BC5\u7CBE\u54C1\uFF0C\u5434\u6E56\u5E06\u4EE5\u5BB6\u85CF\u6BDB\u949E\u300A\u76D8\u6D32\u4E50\u7AE0\u96C6\u300B\u518C\uFF0C\u4EE5\u53CA\u5B8B\u6920\u6CB3\u4E0A\u672C\u300A\u9053\u5FB7\u7ECF\u300B\u4E0E\u848B\u7956\u8BD2\u6362\u5F97\u3002\u5434\u6C0F\u5D07\u5C1A\u5357\u5B97\uFF0C\u63A8\u5D07\u5143\u4EE3\u6587\u4EBA\u753B\u98CE\uFF0C\u4F46\u5434\u95E8\u753B\u6D3E\u4E2D\u5510\u5BC5\u7684\u753B\u98CE\u4EA6\u7ED9\u4ED6\u5F88\u5927\u7684\u5F71\u54CD\u3002</p>",
        slides: [
            {
                url: $johf1["life1-45513-1.jpg"],
                points: []
            }
        ]
    },
    "life1-45517": {
        caption: "\u660E \u6C88\u5468 \u897F\u5C71\u7EAA\u6E38\u56FE\u5377",
        thumbnail: $johf1["life1-45517-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6C88\u5468\uFF081427-1509\uFF09\uFF0C\u5B57\u542F\u5357\uFF0C\u53F7\u77F3\u7530\uFF0C\u957F\u6D32\uFF08\u4ECA\u6C5F\u82CF\u82CF\u5DDE\uFF09\u4EBA\u3002</p><p>\u6B64\u56FE\u7CFB\u6C88\u5468\u51FA\u5B8B\u85CF\u7ECF\u7EB8\uFF0C\u8F85\u4EE5\u4F73\u58A8\u800C\u6210\uFF0C\u6545\u5174\u9163\u7B14\u7545\uFF0C\u70B9\u67D3\u6DCB\u6F13\uFF0C\u5434\u6E56\u5E06\u8DCB\u4E2D\u79F0\u201C\u65E9\u5C81\u4E4B\u4F5C\u4EE5\u6545\u5BAB\u6240\u85CF\u300A\u5E90\u5C71\u9AD8\u300B\u8F74\uFF08\u73B0\u85CF\u53F0\u5317\u6545\u5BAB\u535A\u7269\u9662\uFF09\u4E3A\u7B2C\u4E00\u201D\uFF0C\u201C\u665A\u5C81\u6240\u4F5C\u5E94\u4EE5\u6B64\u5377\u4E3A\u7B2C\u4E00\u201D\uFF0C\u5E76\u9898\u4E3A\u201C\u6885\u666F\u4E66\u5C4B\u6C88\u753B\u7B2C\u4E00\u201D\u3002</p><p>\u56FE\u7ED8\u5434\u4E2D\u80DC\u666F\uFF0C\u4E14\u53C8\u662F\u660E\u56DB\u5BB6\u4E4B\u9996\u6240\u4F5C\uFF0C\u4F5C\u4E3A\u540C\u4E61\u540E\u8F88\u7684\u5434\u6E56\u5E06\u81EA\u7136\u683C\u5916\u73CD\u91CD\u3002\u4E3A\u5F97\u6B64\u4F5C\uFF0C\u6E56\u5E06\u4E0D\u60DC\u4EE5\u5BB6\u85CF\u90D1\u601D\u8096\u300A\u5170\u82B1\u56FE\u300B\u51FA\u552E\uFF0C\u5F97\u8D44\u540E\u8F97\u8F6C\u83B7\u85CF\u3002</p>",
        slides: [
            {
                url: $johf1["life1-45517-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 5525,
                        y: 109,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u77F3\u7530\u7FC1\u300A\u897F\u5C71\u7EAA\u6E38\u56FE\u300B\u5377\u7EB7\u62AB\u7545\u53D1\uFF0C\u70B9\u67D3\u6DCB\u6F13\uFF0C\u64B7\u8463\u5DE8\u4E4B\u7CBE\u534E\uFF0C\u51B6\u5143\u56DB\u5927\u5BB6\u4E8E\u4E00\u7089\uFF0C\u76D6\u665A\u5E74\u5174\u5230\u65F6\u4F5C\u4E5F\u3002\u6240\u7528\u5B8B\u91D1\u7C9F\u5C71\u85CF\u7ECF\u7EB8\u51E1\u516D\u5377\u6709\u534A\uFF0C\u6BCF\u5377\u7EB8\u4E8C\u8282\uFF0C\u53C8\u53E6\u6BCF\u7EB8\u5408\u5DE5\u90E8\u5C3A\u4E00\u5C3A\u4E03\u5BF8\uFF0C\u53E6\u7EB8\u957F\u516D\u5BF8\u8BB8\uFF0C\u72B9\u5B8B\u65F6\u5370\u7ECF\u65E7\u63A5\u4E5F\u3002\u6700\u540E\u4E00\u8282\u7947\u7528\u4E00\u5E45\uFF0C\u8BA1\u957F\u4E8C\u4E08\u4E94\u5C3A\u4E03\u5BF8\uFF0C\u4E0B\u89D2\u94A4\u2018\u767D\u77F3\u7FC1\u2019\u6C34\u5370\uFF0C\u6B3E\u8BB0\u53E6\u4E66\u4E00\u7EB8\u3002\u738B\u6587\u606A\u4E03\u53E4\u4E00\u9996\u9898\u5176\u540E\u3002\u543E\u5BB6\u65E7\u85CF\u77F3\u7FC1\u753B\u5377\u51E1\u516B\uFF0C\u4EE5\u300A\u5F20\u516C\u6D1E\u56FE\u300B\u3001\u300A\u5434\u4E2D\u5947\u5883\u56FE\u300B\u4E3A\u6700\u7740\uFF0C\u5C1A\u6709\u300A\u5434\u4E2D\u5C71\u6C34\u300B\u957F\u5377\u65E9\u5F52\u4ED6\u59D3\uFF0C\u4F59\u672A\u53CA\u5BD3\u76EE\uFF0C\u4E0D\u77E5\u4E0E\u6B64\u5377\u76F8\u7E87\u5426\uFF1F\u6B64\u5377\u4F59\u4E8E\u5DF1\u536F\uFF081939\uFF09\u59CB\u5F97\u4E4B\uFF0C\u795E\u91C7\u7115\u7136\uFF0C\u8F83\u300A\u5F20\u516C\u6D1E\u300B\u3001\u300A\u5434\u4E2D\u5947\u5883\u300B\u6700\u80DC\uFF0C\u4E14\u5728\u6240\u89C1\u77F3\u7FC1\u8BF8\u5377\u4E4B\u4E0A\uFF0C\u582A\u79F0\u6B64\u8001\u665A\u5C81\u753B\u4E2D\u7B2C\u4E00\u54C1\u4E5F\u3002\u660E\u5B63\u85CF\u5F20\u89C1\u9633\u5BB6\uFF0C\u8FD1\u5E74\u904D\u5904\u4E27\u4E71\uFF0C\u7531\u6CF0\u548C\u8427\u6C0F\u6D41\u51FA\uFF0C\u4E43\u4E3A\u4F59\u83B7\uFF0C\u5B9A\u4E3A\u6885\u666F\u4E66\u5C4B\u660E\u753B\u4E4B\u51A0\u3002\u56DB\u6708\u5341\u4E94\u65E5\uFF0C\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-45526": {
        caption: "\u660E \u6C88\u5468\u7B49 \u56DB\u5BB6\u96C6\u9526\u56FE\u5377",
        thumbnail: $johf1["life1-45526-0.jpg"],
        description: "",
        slides: [
            {
                url: $johf1["life1-45526-1.jpg"],
                points: [
                    {
                        x: 1898,
                        y: 255,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6210\u5316\u4E09\u5E74\u4E01\u4EA5\u6240\u4F5C\uFF0C\u662F\u5E74\u56DB\u5341\u4E00\u5C81\uFF0C\u8D8A\u4E09\u8F7D\u5E9A\u5BC5\u800C\u6587\u5510\u59CB\u8BDE\u751F\uFF0C\u660E\u4EE3\u753B\u575B\u725B\u8033\u820D\u516C\u5176\u8C01\u3002\u4F59\u83B7\u4E8E\u7532\u620C\u4E4B\u6625\u9002\u56DB\u5341\u4E00\u5C81\uFF0C\u6E56\u5E06\u5FD7\u559C\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-45526-2.jpg"],
                points: [
                    {
                        x: 1901,
                        y: 234,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4F5C\u4E8E\u6B63\u5FB7\u4E59\u5DF3\u4E3A\u738B\u606A\u516D\u5341\u5BFF\u8005\u3002\u6D41\u5165\u4E3A\u6587\u606A\u53CA\u95E8\u5F97\u610F\u58EB\uFF0C\u65F6\u5E74\u56DB\u5341\u5C81\uFF0C\u7B14\u81F4\u79C0\u7F8E\uFF0C\u6B63\u624D\u534E\u7115\u5F69\u65F6\u4E5F\u3002\u6E56\u5E06\u6240\u5F97\u5510\u5BC5\u753B\u7532\u89C2\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-45526-3.jpg"],
                points: [
                    {
                        x: 1890,
                        y: 259,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4EC7\u6C0F\u7EB8\u672C\u753B\u6B8A\u5C11\u89C1\uFF0C\u6B64\u56FE\u7528\u7B14\u4E4B\u7CBE\u4E0E\u6C5F\u5357\u6625\u5377\u53EF\u4E89\u80DC\u3002\u56FE\u4E2D\u666F\u7269\u4F3C\u662F\u5B64\u5C71\u6545\u4E8B\uFF0C\u4EBA\u7269\u795E\u60C5\u7CBE\u5230\u975E\u4ED6\u4EBA\u53EF\u53CA\uFF0C\u4EA6\u4EC7\u753B\u4E2D\u96BD\u54C1\u4E5F\u3002\u6E56\u5E06\u73CD\u85CF\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-45526-4.jpg"],
                points: [
                    {
                        x: 1899,
                        y: 233,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u56FE\u672A\u7740\u5E74\u6708\uFF0C\u73A9\u5176\u7528\u7B14\u6B3E\u4E66\uFF0C\u76D6\u4E94\u516D\u5341\u5C81\u65F6\u6240\u4F5C\u3002\u4E34\u5DDD\u674E\u6C0F\u65E7\u85CF\uFF0C\u56DB\u5377\u4E2D\u4F59\u5F97\u4E4B\u6700\u665A\uFF0C\u56DB\u7F8E\u65B9\u5177\uFF0C\u6DF1\u81EA\u5E86\u5E78\u7FF0\u58A8\u7F18\u5206\u4E0D\u6D45\uFF0C\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-45526-5.jpg"],
                points: [
                    {
                        x: 1843,
                        y: 413,
                        content: "<p>\u5377\u4E3A\u201C\u660E\u56DB\u5BB6\u201D\u6C88\u5468\u3001\u5510\u5BC5\u3001\u6587\u5F81\u660E\u3001\u4EC7\u82F1\u4EE5\u53CA\u540C\u65F6\u671F\u76F8\u5173\u4E66\u753B\u5BB6\u4F5C\u54C1\u96C6\u9526\u5377\uFF0C\u636E\u5434\u8DCB\u81EA\u8FF0\uFF0C\u4ED6\u4E3A\u4E86\u96C6\u9F50\u56DB\u5BB6\u624B\u5377\u5148\u540E\u5BFB\u8BBF\u5386\u65F6\u56DB\u5341\u56DB\u5E74\uFF0C\u4F53\u73B0\u51FA\u4ED6\u4F5C\u4E3A\u6536\u85CF\u5BB6\u5728\u53E4\u4EE3\u4E66\u753B\u6536\u85CF\u65B9\u9762\u7684\u957F\u671F\u7528\u529F\u3001\u7CBE\u795E\u6295\u5165\u548C\u60C5\u8DA3\u6240\u5728\u3002\u56DB\u753B\u4E2D\u6C88\u5468\u4EFF\u5B8B\u674E\u5510\u300A\u6E14\u9690\u56FE\u300B\u7CFB\u4F5C\u8005\u56DB\u5341\u4E00\u5C81\u6240\u4F5C\u3002\u5510\u5BC5\u300A\u6587\u4F1A\u56FE\u300B\u7CFB\u56DB\u5341\u5C81\u65F6\u4E3A\u5E08\u957F\u3001\u4E66\u6CD5\u5BB6\u738B\u93CA\u516D\u5341\u5BFF\u8FB0\u7CBE\u5FC3\u6240\u7ED8\u3002\u5434\u6E56\u5E06\u9274\u85CF\u65F6\u591A\u6709\u62FC\u62C6\u914D\u51D1\u4E4B\u4E3E\uFF0C\u672C\u5377\u4E2D\u738B\u93CA\u300A\u81EA\u4F5C\u516D\u5341\u5BFF\u8BDE\u8BCD\u300B\u5373\u4ECE\u5B83\u5377\u4E2D\u79FB\u51FA\u540E\u62FC\u5165\uFF0C\u8FD9\u79CD\u5E26\u6709\u4E13\u4E1A\u6027\u8D28\u7684\u96C5\u73A9\u65B9\u5F0F\u662F\u6885\u666F\u4E66\u5C4B\u9274\u85CF\u6D3B\u52A8\u4E2D\u7684\u4E00\u5927\u7279\u8272\u3002</p>"
                    }
                ]
            },
            {
                url: $johf1["life1-45526-6.jpg"],
                points: [
                    {
                        x: 1769,
                        y: 192,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u660E\u5B63\u4EE5\u6765\uFF0C\u672A\u95FB\u6709\u5C06\u56DB\u5927\u5BB6\u753B\u76F8\u4EFF\u5C3A\u5E45\u96C6\u6210\u4E00\u5377\u8005\u3002\u4F59\u81EA\u7532\u620C\uFF081934\uFF09\u83B7\u6C88\u77F3\u7530\u300A\u6E14\u9690\u56FE\u300B\uFF0C\u8FC4\u4E01\u9149\uFF081957\uFF09\u83B7\u6587\u8861\u5C71\u300A\u6709\u7AF9\u56FE\u300B\uFF0C\u5148\u540E\u51E1\u5EFF\u56DB\u5E74\u3002\u5176\u95F4\u5148\u6536\u4EC7\u5341\u6D32\u300A\u8BBF\u6885\u300B\u4E00\u5E27\uFF0C\u540E\u9047\u5510\u516D\u5982\u300A\u6587\u4F1A\u56FE\u300B\uFF0C\u53C8\u6709\u4E8C\u5341\u5E74\u4E4B\u7ECF\u8FC7\u3002\u6700\u540E\u6587\u753B\u4EE5\u77F3\u7530\u300A\u5CE6\u5BB9\u5DDD\u8272\u56FE\u300B\u53CA\u9648\u767D\u9633\u300A\u6D1B\u9633\u6625\u8272\u56FE\u300B\u4E8C\u5377\u6613\u5F97\uFF0C\u4EA6\u4F59\u6C89\u6D78\u4E8E\u753B\u4E2D\u4E94\u5341\u5E74\u4E4B\u72C2\u4E3E\u4E4E\uFF01\u620A\u620C\uFF081958\uFF09\u4E03\u6708\u521D\u79CB\u88C5\u6210\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-45530": {
        caption: "\u5143 \u502A\u74D2\u7B49 \u884C\u4E66\u9898\u8DCB\u6C34\u7AF9\u5C45\u5377",
        thumbnail: $johf1["life1-45530-0.jpg"],
        description: "<p>\u81F3\u6B63\u4E8C\u5341\u4E8C\u5E74\uFF081362\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u672C\u4E66\u5377\u4E3A\u5434\u6E56\u5E06\u6536\u85CF\u4E2D\u5341\u5206\u91CD\u8981\u7684\u4F5C\u54C1\u3002\u5176\u524D\u534A\u56FE\u7ED8\u90E8\u5206\u7CFB\u5F20\u5927\u5343\u4EFF\u9020\uFF0C\u800C\u9898\u8DCB\u90E8\u5206\u81EA\u76DB\u9E9F\u4EE5\u540E\u516B\u5BB6\uFF0C\u5982\u66F9\u8BDC\u3001\u9646\u5E7F\u3001\u502A\u74D2\u3001\u9676\u5B97\u6587\u7B49\u7686\u4E3A\u5143\u4EBA\u6240\u9898\u771F\u8FF9\u3002\u636E\u502A\u4E91\u6797\u8DCB\u8BED\uFF0C\u6240\u9898\u539F\u56FE\u5E94\u4E3A\u4FDE\u502C\u7684\u79C1\u56ED\u6C34\u7AF9\u5C45\u800C\u4F5C\u3002\u4F46\u6709\u8DA3\u7684\u662F\uFF0C\u8FD9\u516B\u4F4D\u5143\u4EBA\u9898\u8DCB\u771F\u8FF9\uFF0C\u5728\u4E7E\u9686\u516B\u5E74\uFF081743\uFF09\u65F6\u8FD8\u66FE\u88AB\u7CFB\u4E8E\u8FC7\u4E91\u697C\u65E7\u85CF\u5143\u5434\u9547\u300A\u4E0E\u67EF\u4E5D\u601D\u3001\u8D75\u5929\u88D5\u3001\u8D75\u539F\u3001\u987E\u5B89\u3001\u5F20\u7EC5\u4E03\u541B\u5B50\u56FE\u300B\uFF08\u73B0\u85CF\u82CF\u5DDE\u535A\u7269\u9986\uFF09\u5377\u540E\uFF0C\u4EA6\u4E3A\u4F2A\u914D\u3002\u5386\u53F2\u4E0A\u8FD9\u79CD\u771F\u4F2A\u4EA4\u96C6\u7684\u624B\u6BB5\uFF0C\u4E3A\u53E4\u4E66\u753B\u9274\u5B9A\u63D0\u4F9B\u4E86\u4E00\u4E2A\u6781\u5177\u542F\u53D1\u6027\u7684\u5B9E\u4F8B\u3002</p>",
        slides: [
            {
                url: $johf1["life1-45530-1.jpg"],
                zoomLevel: 10,
                points: []
            }
        ]
    },
    "life1-45539": {
        caption: "\u5143 \u5F20\u4E2D \u8299\u84C9\u9E33\u9E2F\u56FE\u8F74",
        thumbnail: $johf1["life1-45539-0.jpg"],
        description: "<p>\u81F3\u6B63\u5341\u4E09\u5E74\uFF081353\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u5F20\u4E2D\uFF08\u5341\u56DB\u4E16\u7EAA\uFF09\uFF0C\u5B57\u5B50\u653F\uFF0C\u677E\u6C5F\uFF08\u4ECA\u5C5E\u4E0A\u6D77\u5E02\uFF09\u4EBA\u3002\u64C5\u6C34\u58A8\u82B1\u9E1F\uFF0C\u4F20\u4E16\u4F5C\u54C1\u7F55\u89C1\uFF0C\u591A\u4E3A\u5185\u5E9C\u6536\u85CF\u3002\u636E\u300A\u4E11\u7C03\u65E5\u8BB0\u300B\u8F7D\uFF0C1935\u5E74\u6625\uFF0C\u753B\u5546\u66F9\u53CB\u537F\u643A\u6B64\u753B\u81F3\u6885\u666F\u4E66\u5C4B\uFF0C\u5434\u6E56\u5E06\u7231\u4E0D\u91CA\u624B\uFF0C\u9042\u4EE5\u621A\u7EE7\u5149\u300A\u738B\u77BB\u7F8E\u4E94\u5341\u5BFF\u8BD7\u300B\u548C\u5F20\u590D\u300A\u51E4\u7B19\u660E\u6708\u56FE\u300B\u4E66\u753B\u8BD7\u5377\u4E24\u4EF6\u660E\u4EE3\u4E66\u753B\uFF0C\u5E76\u52A0800\u5143\u73B0\u91D1\u6362\u5F97\uFF0C\u603B\u8BA1\u201C\u7EA6\u516D\u5343\u91D1\u201D\u3002</p>",
        slides: [
            {
                url: $johf1["life1-45539-1.jpg"],
                points: [
                    {
                        x: 2069,
                        y: 53,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5143\u5F20\u5B50\u653F\u300A\u8299\u84C9\u9E02\u9D92\u300B\u4E0A\u4E0A\u795E\u54C1\u3002\u5B50\u653F\u5DE5\u82B1\u9E1F\uFF0C\u4E0E\u738B\u82E5\u6C34\u9F50\u540D\uFF0C\u4E3A\u5143\u4EE3\u4E24\u5927\u5DE8\u64D8\u3002\u636E\u753B\u77F3\u79F0\uFF0C\u5176\u5C71\u6C34\u5B97\u9EC4\u5B50\u4E45\uFF0C\u4EA6\u80FD\u58A8\u620F\u3002\u5176\u6240\u4F5C\u5C71\u6C34\u771F\u8FF9\u4F59\u56FA\u4E3A\u4E4B\u89C1\u4E5F\uFF0C\u5176\u5199\u751F\u82B1\u9E1F\u60DF\u6E05\u5BAB\u65E7\u85CF\u4E4B\u300A\u6843\u82B1\u6625\u9E1F\u300B\u4E0E\u300A\u67AF\u8377\u9E02\u9D92\u300B\u4E8C\u56FE\u53CA\u6B64\u771F\u8FF9\uFF0C\u7947\u4E09\u54C1\u800C\u5DF2\u3002\u4F59\u6240\u89C2\u8005\u591A\u4E0D\u53EF\u4FE1\u3002\u6B64\u5E27\u6709\u5FA1\u89C8\u4E94\u5B9D\uFF0C\u77E5\u4EA6\u300A\u77F3\u6E20\u5B9D\u7B08\u300B\u4E2D\u7269\u3002\u5179\u5C31\u771F\u8FF9\u4E09\u54C1\u4EE5\u63C5\u7D22\u5B50\u653F\u753B\u6CD5\uFF0C\u5219\u7B80\u53E4\u6E0A\u7A46\u662F\u5176\u672C\u8272\u3002\u81F3\u300A\u6843\u82B1\u6625\u9E1F\u56FE\u300B\uFF0C\u56E0\u9898\u8005\u4F17\u591A\u800C\u540D\u4EA6\u6700\u91CD\uFF0C\u7136\u6479\u672C\u4EA6\u81F3\u4F19\uFF0C\u4F59\u6240\u5BD3\u51E1\u4E94\u672C\uFF0C\u7ADF\u65E0\u4E00\u771F\u8FF9\u3002\u6B64\u5E27\u7B14\u6CD5\uFF0C\u7AE0\u6CD5\u4E0E\u300A\u67AF\u8377\u9E02\u9D92\u300B\u7EDD\u76F8\u4F3C\uFF0C\u53EF\u5B9A\u4E3A\u4E00\u65F6\u4E4B\u4F5C\uFF0C\u5B9E\u65A0\u300A\u6843\u82B1\u6625\u9E1F\u300B\u4E3A\u80DC\u3002\u4E59\u4EA5\uFF081935\uFF09\u4E4B\u6625\u83B7\u4E8E\u6D77\u4E0A\uFF0C\u4EE5\u621A\u5C11\u5B9D\u4E0E\u738B\u5143\u7F8E\u6606\u5F1F\u300A\u51E4\u7B19\u660E\u6708\u56FE\u300B\u4E66\u753B\u8BD5\u5377\uFF0C\u590D\u76CA\u4EE5\u5DE8\u91D1\u5F97\u4E4B\uFF0C\u4EE5\u4E3A\u6885\u666F\u4E66\u5C4B\u5143\u753B\u7532\u89C2\u4E5F\u3002\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-50258": {
        caption: "\u6E05 \u738B\u65F6\u654F \u4EFF\u53E4\u5C71\u6C34\u56FE\u518C",
        thumbnail: $johf1["life1-50258-0.jpg"],
        description: "<p>\u5EB7\u7199\u516D\u5E74\uFF081667\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8/\u8BBE\u8272</p><p>\u738B\u65F6\u654F\uFF081592-1680\uFF09\uFF0C\u5B57\u900A\u4E4B\uFF0C\u53F7\u70DF\u5BA2\uFF0C\u6C5F\u82CF\u592A\u4ED3\u4EBA\u3002\u6E05\u521D\u201C\u56DB\u738B\u201D\u4E4B\u4E00\u3002\u6B64\u56FE\u4F5C\u4E8E\u5EB7\u7199\u516D\u5E74\uFF081667\uFF09\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E03\u5341\u516D\u5C81\u3002</p><p>\u636E\u5434\u6E56\u5E06\u300A\u5434\u6C0F\u4E66\u753B\u8BB0\u300B\u4E2D\u6240\u8F7D\uFF0C\u6B64\u518C\u539F\u4E3A\u848B\u7956\u8BD2\u6240\u85CF\uFF0C\u7532\u620C\uFF081934\uFF09\u6625\uFF0C\u5434\u6E56\u5E06\u201C\u4E8E\u5BC6\u97F5\u697C\u8FC7\u8BFB\u6570\u6B21\uFF0C\u5B9E\u582A\u8273\u7FA1\uFF0C\u4E43\u4EE5\u5BB6\u85CF\u7B2C\u4E00\u5B8B\u94A7\u7A91\u6D17\u4E0E\u5B9A\u7A91\u7897\u3001\u6C5D\u7A91\u3001\u5B98\u7A91\u4E09\u789F\uFF0C\u51E1\u4E94\u5B8B\u74F7\u6613\u5F97\u4E4B\uFF0C\u4EE5\u4E3A\u6885\u666F\u4E66\u5C4B\u85CF\u56DB\u738B\u3001\u5434\u3001\u607D\u753B\u4E8B\u4E4B\u51A0\u5195\u4E91\u3002\u4E71\u4E16\u95F2\u60C5\uFF0C\u804A\u8DB3\u81EA\u6170\u8033\u201D\u3002\u8DB3\u8BC1\u6B64\u518C\u4E4B\u81F3\u7CBE\u3002</p>",
        slides: [
            {
                url: $johf1["life1-50258-1.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-2.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-3.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-4.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-5.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-6.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-7.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-8.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-9.jpg"],
                points: []
            },
            {
                url: $johf1["life1-50258-10.jpg"],
                points: []
            }
        ]
    },
    "life1-19944": {
        caption: "\u660E \u5434\u4F1F \u94C1\u7B1B\u56FE\u5377",
        thumbnail: $johf1["life1-19944-0.jpg"],
        description: "<p>\u6210\u5316\u4E8C\u5341\u5E74\uFF081484\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u5434\u4F1F\uFF081459-1508\uFF09\uFF0C\u5B57\u58EB\u82F1\uFF0C\u53F7\u5C0F\u4ED9\uFF0C\u6C5F\u590F\uFF08\u4ECA\u6E56\u5317\u6B66\u660C\uFF09\u4EBA\u3002\u6B64\u56FE\u4F5C\u4E8E1484\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E8C\u5341\u516D\u5C81\u3002</p><p>\u6B64\u56FE\u539F\u4E3A\u6881\u6E05\u6807\u65E7\u85CF\uFF0C\u65CB\u5165\u4E7E\u9686\u5FA1\u5E9C\uFF0C\u540E\u4ECE\u5BAB\u4E2D\u6D41\u51FA\u88AB\u989C\u4E16\u6E05\u8D2D\u5165\uFF0C1931\u5E74\u5434\u6E56\u5E06\u4EE5\u4E00\u5343\u516B\u767E\u91D1\u8D2D\u85CF\uFF0C\u9898\u4E3A\u201C\u5929\u4E0B\u5C0F\u4ED9\u753B\u7B2C\u4E00\u201D\u3002</p><p>\u6E05\u671D\u672B\u4EE3\u7687\u5E1D\u6EA5\u4EEA\u968F\u610F\u5C06\u5BAB\u4E2D\u85CF\u54C1\u8D4F\u8D50\u81E3\u5DE5\uFF0C\u53C8\u5927\u8086\u7A83\u53D6\u5BAB\u4E2D\u4E66\u753B\u3002\u5176\u4E2D\u90E8\u5206\u88AB\u53D8\u5356\uFF0C\u4E3A\u5F53\u65F6\u4EAC\u6D25\u6CAA\u7B49\u5730\u753B\u5546\u3001\u85CF\u5BB6\u8D2D\u5F97\uFF0C\u5434\u6E56\u5E06\u53CA\u5176\u53CB\u4EBA\u4EA6\u6709\u65A9\u83B7\u3002</p>",
        slides: [
            {
                url: $johf1["life1-19944-1.jpg"],
                points: [
                    {
                        x: 19813,
                        y: 101,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5929\u4E0B\u7B2C\u4E00\u5434\u5C0F\u4ED9\u753B\u3002\u660E\u5F20\u4F2F\u8D77\uFF0C\u6E05\u6881\u8549\u6797\u3001\u5468\u96EA\u5BA2\u3001\u59DC\u4E8C\u9149\u3001\u9AD8\u5B97\u5185\u5E9C\u3001\u989C\u97F5\u4F2F\u9012\u85CF\u3002\u5434\u6E56\u5E06\u9898\u3002\u201D</p>"
                    },
                    {
                        x: 13855,
                        y: 130,
                        content: "<p>\u795D\u5141\u660E\u9898\u8DCB\uFF1A\u201C\u4F1A\u7A3D\u8001\u58D1\u751F\u9ED1\u91D1\uFF0C\u795E\u5618\u9B3C\u5438\u5177\u4E94\u97F3\u3002\u5C71\u7075\u4E0D\u5B81\u6301\u9001\u5E1D\uFF0C\u6559\u5177\u53E3\u8033\u4EBA\u95F4\u541F\u3002\u8C6A\u6765\u54EE\u543C\u8277\u8C03\u7B11\uFF0C\u5D11\u5C71\u7389\u788E\u51E4\u7687\u53EB\u3002\u6B8B\u7C27\u4E00\u7247\u5728\u6545\u5BAB\uFF0C\u62FE\u53D6\u78E8\u6210\u742F\u516D\u7A8D\u3002\u96CC\u9F99\u54CD\u6B47\u5C0F\u5973\u6301\uFF0C\u94C1\u7CBE\u5750\u8C03\u53CC\u82B1\u679D\u3002\u5927\u679D\u62C8\u679D\u5BF9\u90CE\u63D2\uFF0C\u5C0F\u679D\u63A9\u6247\u8BF2\u5996\u75F4\u3002\u5448\u5996\u732E\u8C03\u4ECA\u5C0F\u4ED9\uFF0C\u5F20\u537F\u53CB\u4E4B\u6B8A\u7231\u601C\uFF0C\u8001\u6B4C\u7FFB\u8F6C\u8BC6\u9762\u9762\uFF0C\u4F11\u9053\u7792\u5B83\u56DB\u5341\u5E74\u3002\u957F\u6D32\u795D\u5141\u660E\u8D4B\u3002\u201D</p>"
                    },
                    {
                        x: 753,
                        y: 212,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5C0F\u4ED9\u751F\u5929\u987A\u5DF1\u536F\uFF081459\uFF09\uFF0C\u300A\u94C1\u7B1B\u56FE\u300B\u4F5C\u6210\u5316\u7532\u8FB0\uFF081484\uFF09\uFF0C\u5E74\u624D\u4E8C\u5341\u6709\u516D\uFF0C\u6B63\u5C11\u5E74\u5B5F\u664B\u4F5C\u65F6\u4E5F\u3002\u53EC\u6388\u9526\u8863\u9547\u629A\uFF0C\u5F85\u8BCF\u4EC1\u667A\u6BBF\uFF0C\u65F6\u5E74\u672A\u6EE1\u4E09\u5341\u3002\u5B5D\u5B97\u5F18\u6CBB\u5E74\u5143\uFF081488\uFF09\uFF0C\u7947\u4E09\u5341\u5C81\uFF0C\u6388\u9526\u8863\u536B\u767E\u6237\uFF0C\u8D50\u4E66\u72B6\u5143\u5370\u3002\u81EA\u6765\u753B\u5BB6\u5E74\u5C11\u77E5\u9047\u4E4B\u9686\u65E0\u6709\u8FC7\u4E4B\u3002\u60DC\u5929\u9773\u5176\u5BFF\uFF0C\u5352\u53EA\u5E74\u4E94\u5341\u8033\u3002\u795D\u5E0C\u54F2\u5C11\u5C0F\u4ED9\u4E00\u5C81\uFF0C\u6B64\u8BD7\u4E66\u6B86\u4EA6\u4E8C\u5341\u8BB8\u800C\u5DF2\uFF0C\u7136\u5982\u4E07\u5C81\u67AF\u85E4\u3001\u5043\u8E47\u866C\u9F99\u4E4B\u5999\uFF0C\u5B9C\u4E4E\u4E3A\u6709\u660E\u4E00\u4EE3\u4E66\u5BB6\u51A0\u5195\u4E5F\u3002\u4E8C\u4EBA\u8001\u7686\u72C2\u653E\uFF0C\u6B64\u4FF1\u5E84\u4E25\uFF0C\u53EF\u8C13\u5408\u74A7\u3002\u7678\u9149\uFF081933\uFF09\u4E2D\u79CB\u91CD\u88C5\uFF0C\u706F\u4E0B\u8BC6\u6B64\uFF0C\u5434\u6E56\u5E06\u6885\u666F\u4E66\u5C4B\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life1-45531": {
        caption: "\u5317\u5B8B \u7C73\u82BE \u884C\u4E66\u591A\u666F\u697C\u8BD7\u518C",
        thumbnail: $johf1["life1-45531-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u7C73\u82BE\uFF081051-1107\uFF09\uFF0C\u6E56\u5317\u8944\u9633\u4EBA\u3002\u662F\u518C\u4E3A\u7C73\u82BE\u5C45\u9547\u6C5F\u65F6\uFF0C\u767B\u4E34\u5317\u56FA\u5C71\u7518\u9732\u5BFA\u591A\u666F\u697C\uFF0C\u89E6\u666F\u751F\u60C5\u6240\u4F5C\u3002\u5B57\u5927\u5982\u62F3\uFF0C\u7B14\u52BF\u5F00\u5F20\uFF0C\u5411\u88AB\u89C6\u4F5C\u7C73\u6C0F\u4F20\u4E16\u5927\u5B57\u4F73\u6784\u3002</p><p>\u6297\u6218\u80DC\u5229\u524D\u5915\uFF0C\u5434\u6E56\u5E06\u5C06\u6B64\u91CD\u5B9D\u6536\u5165\u56CA\u4E2D\uFF0C\u73CD\u89C6\u903E\u5E38\uFF0C\u5176\u4E66\u658B\u51A0\u540D\u201C\u6885\u666F\u4E66\u5C4B\u201D\u6B21\u5B57\u201C\u666F\u201D\u5373\u5BD3\u610F\u4E8E\u6B64\uFF0C\u53C8\u4E8E\u591A\u5904\u9898\u8DCB\u63D0\u53CA\u5B9D\u7231\u4E4B\u91CD\uFF0C\u8DB3\u89C1\u8FD9\u4EF6\u4F5C\u54C1\u5BF9\u4E8E\u5434\u6C0F\u4E0D\u540C\u51E1\u54CD\u7684\u610F\u4E49\u3002</p>",
        slides: [
            {
                url: $johf1["life1-45531-1.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-2.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-3.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-4.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-5.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-6.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-7.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-8.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-9.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-10.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-11.jpg"],
                points: []
            },
            {
                url: $johf1["life1-45531-12.jpg"],
                points: [
                    {
                        x: 1876,
                        y: 632,
                        content: "<p>\u5434\u6E56\u5E06\u518C\u9996\u9898\u8DCB\uFF1A\u201C\u5B8B\u7C73\u5357\u5BAB\u4E66\u591A\u666F\u697C\u8BD7\u771F\u8FF9\u4E0E\u6881\u6C38\u9633\u662D\u738B\u656C\u592A\u5983\u53CC\u5FD7\u5B8B\u62D3\u5B64\u672C\uFF0C\u53C8\u5B8B\u523B\u6885\u82B1\u559C\u795E\u8C31\u3001\u5143\u5434\u4EF2\u572D\u6E14\u7236\u56FE\u5377\u771F\u8FF9\u4E3A\u5434\u6C0F\u6240\u85CF\u6587\u7269\u56DB\u5B9D\uFF0C\u5434\u6E56\u5E06\u73CD\u79D8\u5E76\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-31536": {
        caption: "\u5357\u5B8B \u6797\u693F \u6885\u7AF9\u5BD2\u79BD\u56FE\u9875",
        thumbnail: $johf1["life2-31536-0.jpg"],
        description: "<p>\u6797\u693F\uFF08\u5341\u4E8C\u4E16\u7EAA\uFF09\uFF0C\u94B1\u5858\uFF08\u4ECA\u6D59\u6C5F\u676D\u5DDE\uFF09\u4EBA\uFF0C\u6DF3\u7199\u95F4\uFF081174-1189\uFF09\u4E2D\u753B\u9662\u5F85\u8BCF\u3002\u5DE5\u82B1\u9E1F\u3001\u8349\u866B\u3001\u679C\u54C1\uFF0C\u4EE5\u8D75\u660C\u4E3A\u5E08\uFF1B\u8BBE\u8272\u6E05\u6DE1\uFF0C\u7CBE\u5DE5\u903C\u771F\u3002\u672C\u56FE\u753B\u7EA2\u6885\u7FE0\u7AF9\uFF0C\u6B8B\u96EA\u672A\u6D88\uFF1B\u5BD2\u79BD\u68B3\u7FBD\uFF0C\u795E\u6001\u751F\u52A8\uFF0C\u4E3A\u6797\u6C0F\u82B1\u9E1F\u753B\u6770\u4F5C\u3002</p><p>\u6B64\u4E3A\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u592B\u5987\u79FB\u5C45\u6CAA\u4E0A\u540E\u5165\u85CF\uFF0C\u4E0E\u5176\u8D2D\u85CF\u7684\u5357\u5B8B\u4F5A\u540D\u300A\u9E4C\u9E51\u56FE\u300B\u9875\u5927\u62B5\u540C\u65F6\uFF0C\u636E\u6B64\u4E0D\u96BE\u53D1\u73B0\u5176\u8FD9\u4E00\u65F6\u671F\u6536\u85CF\u8DA3\u5473\u4E4B\u6240\u5728\u3002</p>",
        slides: [
            {
                url: $johf1["life2-31536-1.jpg"],
                points: []
            }
        ]
    },
    "life2-31601": {
        caption: "\u5357\u5B8B \u4F5A\u540D \u9E4C\u9E51\u56FE\u9875",
        thumbnail: $johf1["life2-31601-0.jpg"],
        description: "<p>\u672C\u56FE\u4F5C\u8005\u4E0D\u8BE6\uFF0C\u6240\u4F5C\u9E4C\u9E51\u795E\u6001\u751F\u52A8\u6D3B\u6CFC\uFF0C\u5761\u540E\u79CB\u79BE\u4E00\u830E\uFF0C\u4EA6\u6447\u66F3\u751F\u59FF\uFF0C\u582A\u79F0\u5357\u5B8B\u5199\u751F\u4F73\u4F5C\u3002</p><p>\u6B64\u4E3A\u4E8C\u5341\u4E16\u7EAA\u4E09\u5341\u5E74\u4EE3\u4E2D\u671F\u4E4B\u524D\uFF0C\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u592B\u5987\u79FB\u5C45\u4E0A\u6D77\u4E4B\u540E\u8D2D\u85CF\u3002\u4ECE\u753B\u9762\u5185\u5BB9\u4EE5\u53CA\u540C\u65F6\u524D\u540E\u8D2D\u85CF\u7684\u5357\u5B8B\u4F5A\u540D\u300A\u6A31\u6843\u9EC4\u9E42\u56FE\u300B\u9875\u3001\u5357\u5B8B\u6797\u693F\u300A\u6885\u7AF9\u5BD2\u79BD\u56FE\u7EA8\u6247\u300B\u9875\u4E2D\uFF0C\u7565\u53EF\u7AA5\u89C1\u5434\u6C0F\u592B\u5987\u5F53\u65F6\u8FFD\u6C42\u548C\u5411\u5F80\u4E00\u79CD\u606C\u6DE1\u3001\u5B89\u5B81\u3001\u7965\u548C\u7684\u751F\u6D3B\u60C5\u8DA3\u3002</p>",
        slides: [
            {
                url: $johf1["life2-31601-1.jpg"],
                points: []
            }
        ]
    },
    "life2-39393": {
        caption: "\u5357\u5B8B \u4F5A\u540D \u6A31\u6843\u9EC4\u9E42\u56FE\u9875",
        thumbnail: $johf1["life2-39393-0.jpg"],
        description: "<p>\u7EE2\u672C \u8BBE\u8272</p><p>\u672C\u56FE\u4F5C\u8005\u4E0D\u8BE6\uFF0C\u9898\u8005\u7CFB\u5357\u5B8B\u5B81\u5B97\u6768\u7687\u540E\u3002\u6768\u7687\u540E\uFF081162-1233\uFF09\uFF0C\u4F1A\u7A3D\uFF08\u4ECA\u6D59\u6C5F\u7ECD\u5174\uFF09\u4EBA\u3002\u672C\u56FE\u753B\u9762\u610F\u5883\uFF0C\u4E8E\u5434\u6E56\u5E06\u300A\u9EC4\u9E42\u7ED5\u78A7\u6811\u300B\u8BCD\u9898\u548F\u4E00\u4E00\u5448\u73B0\u3002\u4ECE\u5434\u6C0F\u9898\u8DCB\u53EF\u77E5\uFF0C\u8BE5\u56FE\u4F3C\u5176\u5F97\u81EA\u4E0A\u6D77\u89E3\u653E\u524D\u5915\u3002\u56E0\u5434\u6E56\u5E06\u6781\u73CD\u89C6\u6B64\u56FE\u9875\uFF0C\u6545\u4EE5\u5BB6\u85CF\u53E4\u7C4D\u5584\u672C\u6613\u5F97\uFF0C\u5E76\u4E8E\u4E8C\u5341\u4E16\u7EAA\u4E94\u5341\u5E74\u4EE3\u521D\u9080\u7EA6\u6D77\u4E0A\u5973\u753B\u5BB6\u5468\u70BC\u971E\uFF0C\u4EE5\u5171\u8D4F\u96C5\u96C6\u7684\u5F62\u5F0F\u6B22\u5EA6\u65B0\u6625\u3002</p>",
        slides: [
            {
                url: $johf1["life2-39393-1.jpg"],
                points: [
                    {
                        x: 2061,
                        y: 1943,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u9EC4\u9E42\u7ED5\u78A7\u6811\uFF0C\u7528\u5468\u6E05\u771F\u97F5\u3002\u6625\u8272\u8FCE\u4EBA\uFF0C\u5A9A\u73E0\u5E18\uFF0C\u7389\u82D1\u5531\u968F\u671D\u66AE\uFF0C\u5C0F\u5370\u62C8\u7EA2\u6620\u4FEE\u7709\uFF0C\u9EDB\u78A7\u67D3\u9999\uFF0C\u7EA8\u7D20\u5E76\u80A9\uFF0C\u7B11\u8BED\u6307\u6A31\u9897\uFF0C\u5BAB\u7802\u67D4\u7EEA\uFF0C\u5EFB\u501A\u69DB\uFF0C\u542C\u556D\u9EC4\u9E42\uFF0C\u53C8\u559C\u548C\u9E23\u58F0\u7166\u3002\u6B64\u65E5\u6768\u5BB6\uFF0C\u79C0\u5410\u5C3D\u6B22\u5A31\uFF0C\u6D63\u82B1\u65E0\u8651\uFF0C\u4E14\u95F2\u620F\u8BD5\uFF0C\u5764\u5B81\u777F\u7B14\uFF0C\u6E05\u959F\u82B3\u571F\uFF0C\u8C29\u4F7F\u51E4\u57CE\uFF0C\u9E9D\u972D\u4FBF\u6D12\u5F97\uFF0C\u97F6\u5149\u4F4F\uFF0C\u51ED\u5C06\u4E3D\u666F\uFF0C\u88C1\u5941\u7FE0\u534E\u51DD\u6811\u3002\u5DF1\u4E11\uFF081949\uFF09\u6625\u65E5\uFF0C\u5175\u6208\u4ED3\u7687\u4E2D\uFF0C\u83B7\u89C1\u6B64\u56FE\uFF0C\u5178\u4E66\u76F8\u6613\uFF0C\u4EE5\u9063\u79EF\u6000\uFF0C\u4EA6\u79BB\u4E71\u95F4\uFF0C\u4E00\u5FEB\u4E8B\u7109\u3002\u5434\u6E56\u5E06\u9898\u4E8E\u8FE2\u8FE2\u9601\u3002\u201D</p>"
                    },
                    {
                        x: 258,
                        y: 1893,
                        content: "<p>\u5468\u70BC\u971E\u9898\u8DCB\uFF1A\u201C\u7678\u5DF3\uFF081953\uFF09\u65B0\u6625\u540C\u89C2\uFF0C\u62B1\u771F\u3001\u70BC\u971E\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-45516": {
        caption: "\u6E05 \u738B\u539F\u7941 \u4EFF\u6885\u9053\u4EBA\u5C71\u6C34\u56FE\u8F74",
        thumbnail: $johf1["life2-45516-0.jpg"],
        description: "<p>\u5EB7\u7199\u56DB\u5341\u4E8C\u5E74\uFF081703\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u738B\u539F\u7941\uFF081642-1715\uFF09\uFF0C\u5B57\u8302\u4EAC\uFF0C\u53F7\u9E93\u53F0\u3002\u6C5F\u82CF\u592A\u4ED3\u4EBA\u3002\u6E05\u521D\u201C\u56DB\u738B\u201D\u4E4B\u4E00\u3002\u6B64\u56FE\u662F\u4F5C\u8005\u516D\u5341\u4E8C\u5C81\u65F6\u6240\u4F5C\u3002</p><p>\u672C\u56FE\u4E3A\u6E05\u5EF7\u8D4F\u8D50\u5927\u81E3\u82F1\u548C\u5E76\u6D41\u843D\u6C11\u95F4\u7684\u53E4\u4E66\u753B\u4E4B\u4E00\u3002\u56F4\u7ED5\u4E00\u65B9\u201C\u626C\u513F\u201D\u5C0F\u5370\u7684\u5F52\u5C5E\uFF0C\u5434\u6E56\u5E06\u9976\u6709\u5174\u5473\u5730\u5C55\u5F00\u8D4F\u9274\u3002\u56E0\u5434\u6C0F\u6709\u4E00\u513F\u540D\u201C\u626C\u513F\u201D\uFF0C\u5176\u8BDE\u751F\u4E4B\u5E74\u7684\u7532\u5B50\u6070\u4E0E\u521B\u4F5C\u6B64\u753B\u7684\u5E72\u652F\u5E74\u4EFD\u7678\u672B\uFF081703\uFF09\u540C\uFF0C\u53EA\u662F\u665A\u4E86\u4E8C\u767E\u56DB\u5341\u5E74\u3002\u85CF\u5BB6\u559C\u7231\u5F3A\u8C03\u4F5C\u54C1\u4E0E\u81EA\u5DF1\u6216\u5BB6\u4EBA\u4E4B\u95F4\u7684\u56E0\u7F18\uFF0C\u4E5F\u6B63\u56E0\u4E3A\u4E00\u4E9B\u5DE7\u5408\u800C\u6536\u85CF\u4E00\u4EF6\u4F5C\u54C1\uFF0C\u8FD9\u4E5F\u4F53\u73B0\u51FA\u9274\u85CF\u6D3B\u52A8\u4E2D\u9887\u6709\u610F\u601D\u7684\u4E00\u9762\u3002</p>",
        slides: [
            {
                url: $johf1["life2-45516-1.jpg"],
                points: [
                    {
                        x: 1839,
                        y: 690,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u53F8\u519C\u68A6\u7B14\u6885\u6C99\u5F25\uFF0C\u7678\u672A\u521D\u6625\u753B\u8BDE\u65F6\u3002\u6211\u5C5E\u524D\u8EAB\u8001\u6E14\u7236\uFF0C\u5947\u7F18\u5C0F\u5370\u8BC6\u626C\u513F\u3002\u738B\u9E93\u53F0\u53F8\u519C\u4F5C\u753B\u4E8E\u5EB7\u7199\u56DB\u5341\u4E8C\u5E74\u7678\u672A\uFF081703\uFF09\u4E4B\u6625\uFF0C\u4EFF\u6885\u9053\u4EBA\u7B14\u3002\u6B63\u8D8A\u4E8C\u767E\u56DB\u5341\u5E74\uFF0C\u5C81\u6B21\u7678\u672A\u6B63\u6708\u5341\u56DB\u65E5\uFF0C\u6211\u626C\u513F\u751F\u903E\u6708\uFF0C\u5F97\u6B64\u753B\uFF0C\u800C\u53F3\u4E0B\u89D2\u6709\u2018\u626C\u513F\u5B9D\u73A9\u2019\u5C0F\u5370\uFF0C\u6D35\u5947\u7F18\u7109\uFF1F\u753B\u4E0A\u6709\u4E7E\u9686\u5FA1\u89C8\u73BA\u5370\u56DB\u65B9\uFF0C\u4E3A\u5B9D\u7B08\u91CD\u7F16\u4E4B\u54C1\u3002\u4E0B\u6709\u2018\u8D50\u672C\u2019\u53CA\u2018\u81E3\u548C\u606D\u85CF\u2019\u4E8C\u5370\uFF0C\u76D6\u6E05\u9AD8\u5B97\u5FA1\u8D50\u82F1\u7166\u658B\u76F8\u56FD\u8005\u3002\u626C\u513F\u4E00\u5370\u5176\u8272\u4E0E\u82F1\u6C0F\u5370\u7565\u540C\uFF0C\u662F\u5426\u4EA6\u82F1\u6C0F\u6240\u94A4\uFF1F\u6216\u82F1\u6C0F\u8BDE\u751F\u626C\u513F\u8005\uFF0C\u800C\u9AD8\u5B97\u5FA1\u8D50\u6B64\u753B\u56E0\u94A4\u5C0F\u5370\u4E3A\u8BC6\uFF1F\u672A\u53EF\u8003\u4E5F\u3002\u4E0D\u7136\uFF0C\u4EA6\u4ECE\u65E0\u4EE5\u67D0\u513F\u4E3A\u540D\u8D38\u94A4\u4E8E\u5FA1\u8D50\u540D\u753B\u4E4B\u4E0A\u4E4B\u7406\u3002\u53C8\u5341\u4F59\u5E74\u524D\uFF0C\u4F59\u66FE\u6536\u6885\u9053\u4EBA\u300A\u6E14\u7236\u56FE\u300B\u5377\uFF0C\u4EA6\u6E05\u5BAB\u5FA1\u89C8\u4E4B\u5B9D\uFF0C\u662F\u7686\u543E\u6C38\u4E3A\u73CD\u85CF\u9547\u5BB6\u54C1\u4E5F\u3002\u4E01\u4EA5\uFF081947\uFF09\u6625\u6B63\u91CD\u88C5\uFF0C\u5434\u6E56\u5E06\u8BC6\u4E8E\u6885\u666F\u4E66\u5C4B\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-45520": {
        caption: "\u6E05 \u738B\u9274 \u4EFF\u5B8B\u5143\u5341\u516D\u5BB6\u5C71\u6C34\u56FE\u518C",
        thumbnail: $johf1["life2-45520-0.jpg"],
        description: "<p>\u5EB7\u7199\u56DB\u5E74\uFF081665\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8/\u8BBE\u8272</p><p>\u6B64\u56FE\u518C\u4F5C\u4E8E\u6E05\u5EB7\u7199\u56DB\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u516D\u5341\u516B\u5C81\u3002</p><p>\u6B64\u518C\u5434\u6E56\u5E06\u6BCF\u5F00\u7686\u9898\u8BC6\u751A\u8BE6\uFF0C\u79F0\u6B64\u518C\u4E3A\u5176\u5BD3\u76EE\u738B\u9274\u753B\u518C\u771F\u8FF9\u7B2C\u4E8C\u5341\u4E94\u672C\u3002 \u5185\u6709\u5434\u6C0F\u9898\u8DCB\u6307\u6885\u82B1\u56FE\u8BF7\u6F58\u9759\u6DD1\u8D4F\u9274\u4E00\u6BB5\uFF0C\u5434\u6E56\u5E06\u592B\u4EBA\u6F58\u9759\u6DD1\u559C\u7231\u6885\u82B1\u9898\u6750\u7684\u4E66\u753B\uFF0C\u5C61\u6709\u6536\u85CF\u4E34\u6479\uFF0C\u5BF9\u5386\u4EE3\u6885\u753B\u751A\u4E3A\u719F\u6089\uFF0C\u6545\u5434\u5C31\u6B64\u56FE\u7591\u95EE\u4E0E\u4E4B\u63A2\u8BA8\u3002\u540E\u9875\u53C8\u9644\u4E00\u7EB8\u8BB0\u5F55\u5173\u4E8E\u6B64\u753B\u9898\u8BD7\u4F5C\u8005\u7684\u8003\u8BC1\uFF0C\u4E91\u636E\u5434\u4F84\u6F58\u8627\u76E6\u9274\u5B9A\uFF0C\u6B64\u8BD7\u4F5C\u8005\u5E94\u4E3A\u6E05\u4EE3\u5CAD\u5357\u6D3E\u4E66\u753B\u5BB6\u5C48\u5927\u5747\u3002</p>",
        slides: [
            {
                url: $johf1["life2-45520-1.jpg"],
                points: [
                    {
                        x: 316,
                        y: 1112,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u518C\u521D\u4E3A\u4E00\u6536\u65E7\u8D27\u62C5\u8005\u5F97\u4E8E\u8D25\u7C0F\u4E2D\uFF0C\u96F6\u4E71\u4E0D\u6574\uFF0C\u4EE5\u4E00\u5143\u516D\u6BDB\u5F97\u4E4B\u3002\u76D6\u81EA\u4E01\u4E11\u53D8\u4E71\u540E\u52AB\u4F59\u7269\u4E5F\uFF0C\u540E\u8F6C\u5C55\u81F3\u6B64\uFF0C\u4E0D\u77E5\u51E0\u7ECF\u9AA8\u8463\u4EBA\u624B\u77E3\u3002\u201D</p><p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u540E\u6709\u4F34\u6885\u8BD7\u9898\u4E00\u9875\uFF0C\u4EA6\u5EB7\u7199\u65F6\u539F\u88C5\u4E5F\u3002\u8BD7\u4E2D\u4E0E\u7384\u7167\u4F3C\u65E0\u5173\u7CFB\uFF0C\u4E14\u4E0D\u8BE6\u4E3A\u4F55\u8BB8\u4EBA\u3002\u5BA1\u5176\u7B14\u81F4\u6B86\u7C7B\u5973\u53F2\uFF0C\u5E94\u8D28\u9759\u6DD1\u4EE5\u4E3A\u4F55\u5982\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life2-45520-2.jpg"],
                points: [
                    {
                        x: 931,
                        y: 128,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u53F3\u4F34\u6885\u8BD7\u4E8C\u9996\u539F\u88C5\u4E8E\u7384\u7167\u518C\u540E\uFF0C\u867D\u672A\u8BE6\u59D3\u6C0F\uFF0C\u5BA1\u5176\u7B14\u52BF\u4E0E\u7384\u7167\u4E3A\u540C\u65F6\u4EBA\u3002\u521D\u7591\u51FA\u5973\u53F2\u624B\u7B14\uFF0C\u4F46\u8BD7\u53E5\u96C4\u5065\uFF0C\u6216\u975E\u5973\u53F2\u53E3\u6C14\u3002\u4ECA\u65E5\u5185\u4F84\u6F58\u5B50\u8627\u76E6\u9274\u8D4F\u66F0\uFF0C\u7B14\u6CD5\u4E66\u4F53\u9887\u4F3C\u5CAD\u5357\u5C48\u5927\u5747\u3002\u76D6\u8627\u76E6\u6536\u85CF\u5386\u4EE3\u5C3A\u724D\u5C06\u4E07\u901A\uFF0C\u641C\u7F57\u540D\u8D24\u7B14\u8FF9\u81F3\u5BCC\uFF0C\u770B\u6210\u4E1C\u5357\u9996\u5C48\uFF0C\u5176\u9274\u522B\u7D20\u7CBE\u786E\uFF0C\u5F53\u975E\u65E0\u56E0\u4E5F\u3002\u60DF\u636E\u8627\u76E6\u4E91\u5C48\u6C0F\u5434\u522B\u53F7\uFF0C\u4F34\u6885\u4E8C\u5B57\uFF0C\u6545\u4E0D\u6562\u65AD\u8A00\u3002\u4E59\u536F\u6625\u6E56\u5E06\u53C8\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-45527": {
        caption: "\u5143 \u4F5A\u540D \u5C71\u6C34\u4E09\u6BB5\u56FE\u5377",
        thumbnail: $johf1["life2-45527-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6B64\u56FE\u4F5C\u8005\u5F85\u8003\u3002\u5377\u4E2D\u7684\u300A\u79CB\u6797\u8FDC\u5CAB\u56FE\u300B\u3001\u300A\u6C5F\u5CB8\u4E54\u67EF\u56FE\u300B\u548C\u300A\u6C5F\u6DF1\u8349\u9601\u56FE\u300B\uFF0C\u7CFB\u5434\u6E56\u5E06\u5F97\u4E8E\u4E8C\u5341\u4E16\u7EAA\u4E09\u5341\u5E74\u4EE3\u540E\u671F\uFF1B\u5377\u4E2D\u6240\u9644\u7BA1\u9053\u5347\u300A\u53CC\u94A9\u7AF9\u300B\uFF0C\u5219\u6765\u81EA\u53CB\u4EBA\u94B1\u955C\u5858\u4E4B\u9988\u9057\uFF081953\u5E74\uFF09\u3002\u5434\u6E56\u5E06\u592B\u5987\u96C5\u597D\u4E66\u753B\uFF0C\u4E00\u5411\u8FFD\u6155\u8D75\u5B5F\u982B\u3001\u7BA1\u9053\u5347\u97F5\u4E8B\uFF0C\u6545\u5434\u6E56\u5E06\u4E8E\u5165\u85CF\u5C71\u6C34\u4E09\u6BB5\u5377\u540E\u5341\u4E94\u5E74\u83B7\u5F97\u7BA1\u6C0F\u753B\u7AF9\uFF0C\u8FFD\u5FC6\u539F\u914D\u4E0D\u80DC\u550F\u5618\uFF0C\u9898\u8BCD\u4EE5\u8BB0\uFF0C\u4E0E\u4E4B\u5171\u540C\u89C2\u753B\u7684\u4E0A\u6D77\u5973\u753B\u5BB6\u5468\u70BC\u971E\u4EA6\u4EE5\u539F\u8C03\u539F\u97F5\u5531\u548C\u4E8E\u540E\u3002</p>",
        slides: [
            {
                url: $johf1["life2-45527-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 2726,
                        y: 103,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u85CF\u677E\u96EA\u7FC1\u6B64\u5377\u5341\u4E94\u5E74\u4E43\u83B7\u9B4F\u56FD\u592B\u4EBA\u753B\u7AF9\u4E3A\u4FEA\uFF0C\u4E0D\u7981\u6005\u7136\uFF0C\u81EA\u8DB3\u7CFB\u4EE5\u8BCD\u3002\u300A\u9E67\u9E2A\u5929\u300B\uFF1A\u6625\u96E8\u697C\u5934\u7ED3\u7EEE\u601D\uFF0C\u6709\u60C5\u7737\u5C5E\u603B\u76F8\u671F\uFF0C\u9E25\u6CE2\u5B9A\u8BBA\u5343\u91D1\u8BFA\uFF0C\u6885\u5C4B\u9664\u5F00\u7247\u7389\u9057\u3002\u9F50\u56DB\u7F8E\uFF0C\u5408\u53CC\u6816\uFF0C\u7389\u53F0\u4F73\u5A5A\u5029\u91CD\u9898\uFF0C\u753B\u5802\u677E\u96EA\u73E0\u5E18\u5377\uFF0C\u7D2B\u71D5\u5F52\u6765\u5012\u597D\u5B09\u3002\u201D</p>"
                    },
                    {
                        x: 2328,
                        y: 117,
                        content: "<p>\u5468\u70BC\u971E\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u8277\u8BF4\u6CA4\u6CE2\u5012\u597D\u5B09\u3002\u751F\u82B1\u91C7\u7B14\u6709\u8FDE\u679D\u3002\u53CC\u94A9\u7EC6\u52D2\u6625\u70DF\u7D2B\uFF0C\u6DE1\u67D3\u6D53\u76B4\u87BA\u9EDB\u5B9C\u3002\u771F\u7F8E\u5177\uFF0C\u4E8C\u96BE\u9F50\u3002\u8FE2\u8FE2\u9601\u4E0A\u5FFD\u76F8\u671F\u3002\u660E\u73E0\u5B9D\u5251\u96BE\u8FD8\u5408\uFF0C\u7EC8\u53E4\u56E0\u7F18\u5C5E\u963F\u8C01\u3002\u7678\u5DF3\u6625\u5206\u524D\u4E8C\u65E5\uFF0C\u968F\u58F0\u9E67\u9E2A\u5929\u3002\u7F57\u5DDD\u70BC\u971E\u9898\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-47219": {
        caption: "\u6E05 \u607D\u5BFF\u5E73 \u82B1\u5349\u56FE\u518C",
        thumbnail: $johf1["life2-47219-0.jpg"],
        description: "<p>\u5EB7\u7199\u4E8C\u5341\u56DB\u5E74\uFF081685\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6B64\u518C\u4E3A\u607D\u5BFF\u5E73\u6CA1\u9AA8\u82B1\u5349\u7CBE\u54C1\uFF0C\u8BBE\u8272\u6E05\u96C5\uFF0C\u59FF\u6001\u5A34\u7F8E\uFF0C\u5F00\u4E00\u4EE3\u82B1\u9E1F\u753B\u4E4B\u98CE\u6C14\u3002\u7ECF\u5434\u6E56\u5E06\u8003\u8BC1\uFF0C\u6B64\u56FE\u518C\u4F5C\u4E8E\u5EB7\u7199\u4E8C\u5341\u56DB\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E09\u5C81\u3002</p><p>\u6F58\u9759\u6DD1\u96C5\u7231\u82B1\u9E1F\uFF0C\u5434\u6C0F\u91CD\u91D1\u4E3A\u5176\u8D2D\u5F97\u6B64\u518C\u3002\u5434\u6E56\u5E06\u4E8E\u6B64\u518C\u4E00\u89C1\u503E\u5FC3\uFF0C\u7136\u7D22\u503C\u9887\u6602\uFF0C\u8E0C\u8E87\u4E00\u663C\u591C\uFF0C\u5C06\u65E7\u85CF\u660E\u6E05\u300A\u6587\u6C0F\u4E66\u753B\u4FBF\u9762\u300B\u518C\u8D28\u53BB\uFF0C\u518D\u52A0\u5DE8\u91D1\uFF0C\u65B9\u5982\u613F\u8D2D\u85CF\u3002</p>",
        slides: [
            {
                url: $johf1["life2-47219-1.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-2.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-3.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-4.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-5.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-6.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-7.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-8.jpg"],
                points: []
            },
            {
                url: $johf1["life2-47219-9.jpg"],
                points: [
                    {
                        x: 1776,
                        y: 159,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4F59\u6700\u7231\u5357\u7530\u7FC1\u82B1\u5349\uFF0C\u76D6\u5176\u5929\u8D44\u4E30\u795E\u582A\u79F0\u7A7A\u524D\u7EDD\u540E\uFF0C\u867D\u8D77\u5F90\u3001\u9EC4\u4EA6\u672A\u5FC5\u80FD\u8FC7\uFF0C\u5176\u540E\u5982\u5357\u6C99\u3001\u65B0\u7F57\u4EA6\u8DF3\u4E0D\u51FA\u5176\u7BF1\u7B3C\u3002\u5341\u4F59\u5E74\u6765\u6240\u89C1\u6781\u4F5C\u5377\u518C\u4E09\u56DB\u4E8B\uFF0C\u7686\u85CF\u5F06\uFF0C\u85CF\u5BB6\u975E\u529B\u80FD\u81F4\u3002\u66E9\u5C81\u9759\u6DD1\u4E13\u4E60\u82B1\u5349\uFF0C\u540E\u9887\u6B32\u6536\u8D2E\u4E00\u4E8C\u6770\u54C1\u4EE5\u4E3A\u6469\u6332\uFF0C\u5F17\u80FD\u5F97\u3002\u4ECA\u79CB\u89C1\u6B64\u518C\u4ECE\u6545\u90FD\u6765\uFF0C\u5C55\u89C9\u795E\u5F80\uFF0C\u987E\u7D22\u503C\u6602\uFF0C\u8E0C\u8E87\u4E00\u4E66\u591C\uFF0C\u4E43\u5C06\u65E7\u85CF\u660E\u6E05\u6587\u6C0F\u4E66\u753B\u4FBF\u9762\u4E00\u518C\u8D28\u53BB\uFF0C\u590D\u76CA\u5DE8\u91D1\u8F87\u5F52\uFF0C\u4EE5\u6210\u65AF\u613F\u3002\u4F59\u5E73\u751F\u6240\u89C1\u607D\u518C\u90FD\u5341\u8BB8\u672C\uFF0C\u82B1\u5349\u516D\u4E03\uFF0C\u82E5\u6B64\u518C\u4E4B\u7CBE\u5F69\u7115\u53D1\uFF0C\u7947\u4E00\u4E8C\u6570\u77E3\u3002\u51A0\u518C\u4E4B\u767D\u7261\u4E39\u4E00\u5E27\uFF0C\u5C24\u89C1\u6E05\u534E\u6717\u6DA6\uFF0C\u51DD\u8102\u8000\u6708\uFF0C\u5149\u5C04\u5341\u6B65\u4E5F\u3002\u662F\u8C13\u795E\u54C1\uFF0C\u8C01\u66F0\u4E0D\u5B9C\uFF1F\u620A\u5BC5\uFF081938\uFF09\u51AC\u65E5\uFF0C\u5434\u6E56\u5E06\u8BC6\uFF0C\u6F58\u9759\u6DD1\u5B9D\u85CF\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life2-51061": {
        caption: "\u6E05 \u607D\u5BFF\u5E73 \u79CB\u82B1\u732B\u8776\u56FE\u8F74",
        thumbnail: $johf1["life2-51061-0.jpg"],
        description: "<p>\u5EB7\u7199\u4E8C\u5341\u4E09\u5E74\uFF081684\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u607D\u5BFF\u5E73\uFF081633-1690\uFF09\uFF0C\u521D\u540D\u683C\uFF0C\u5B57\u5BFF\u5E73\uFF0C\u53F7\u5357\u7530\u3002\u6B64\u56FE\u4F5C\u4E8E\u5EB7\u7199\u4E8C\u5341\u4E09\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E8C\u5C81\u3002</p><p>\u662F\u56FE\u4EE5\u58A8\u9AA8\u6DE1\u5F69\u4F5C\u82B1\u5349\u732B\u8776\uFF0C\u4E3A\u5434\u6C0F\u592B\u5987\u5341\u5206\u8D4F\u7231\u4E4B\u7269\u3002\u6885\u666F\u4E66\u5C4B\u6240\u85CF\u4E00\u4E9B\u7279\u6B8A\u9898\u6750\u7684\u53E4\u4EE3\u7ED8\u753B\uFF0C\u5F80\u5F80\u4E3A\u5434\u6F58\u592B\u5987\u6240\u5171\u55DC\u8005\uFF0C\u6BD4\u5982\u6885\u82B1\u53CA\u732B\u3002\u524D\u8005\u53CD\u6620\u4E86\u5434\u6F58\u592B\u5987\u4EE5\u201C\u6885\u82B1\u77E5\u5DF1\u201D\u81EA\u89C6\u7684\u60C5\u6000\uFF0C\u5BF9\u4E8E\u53E4\u4ECA\u540D\u5BB6\u753B\u732B\u4E4B\u504F\u7231\uFF0C\u5219\u4E3B\u8981\u6E90\u4E8E\u201C\u592B\u4EBA\u7231\u732B\u5165\u9AA8\uFF0C\u81EA\u5C0F\u5373\u5982\u6B64\u201D\u3001\u201C\u4F59\u592B\u5987\u6709\u732B\u7656\u201D\uFF0C\u4EE5\u53CA\u5434\u5BB6\u9075\u5FAA\u65E7\u5386\u91D1\u5371\u5371\u65E5\u753B\u732B\u8F9F\u706B\u7684\u4E60\u4FD7\u3002</p>",
        slides: [
            {
                url: $johf1["life2-51061-1.jpg"],
                points: []
            }
        ]
    },
    "life2-59917": {
        caption: "\u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C",
        thumbnail: $johf1["life2-59917-0.jpg"],
        description: "<p>\u6B64\u518C\u4E3A\u5434\u6E56\u5E06\u81F3\u7231\u4E4B\u85CF\u54C1\uFF0C\u5E38\u52A0\u89C2\u6469\u8D4F\u73A9\u3001\u8003\u8BA2\u9898\u548F\uFF0C\u51E0\u5341\u5E74\u95F4\u65F6\u6709\u5355\u72EC\u6216\u4E0E\u5143\u914D\u6F58\u6C0F\u3001\u7EE7\u914D\u987E\u6C0F\u5171\u8D4F\u5E76\u8BC6\u6587\u5B57\u3001\u5370\u9274\u89C1\u8BF8\u518C\u7AEF\u9875\u95F4\u3002\u592B\u5987\u5531\u968F\uFF0C\u6C89\u6F5C\u91D1\u77F3\u5B66\u7684\u7CBE\u6DF1\u6267\u7740\uFF0C\u51E0\u4E0E\u5357\u5B8B\u674E\u6E05\u7167\u4E0E\u4E08\u592B\u8D75\u660E\u8BDA\u5171\u540C\u706F\u4E0B\u8003\u6821\u7891\u7248\u6587\u5B57\u4E4B\u7CBE\u795E\u6295\u5165\u76F8\u4EFF\u4F5B\u3002</p>",
        slides: [
            {
                url: $johf1["life2-59917-1.jpg"],
                points: []
            },
            {
                url: $johf1["life2-59917-2.jpg"],
                points: [
                    {
                        x: 4224,
                        y: 1239,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6881\u6C38\u9633\u738B\u656C\u592A\u5983\u5893\u5FD7\uFF0C\u5434\u6C0F\u53CC\u4FEE\u9601\u73CD\u85CF\u81F3\u5B9D\u3002\u5434\u6E56\u5E06\u6F58\u9759\u6DD1\u540C\u8BB0\u3002\u201D</p>"
                    },
                    {
                        x: 921,
                        y: 1269,
                        content: "<p>\u6F58\u9759\u6DD1\u4E66\u8DCB\uFF1A\u201C\u5357\u671D\u6709\u5FD7\u5893\u4E4B\u7981\uFF0C\u6B64\u5949\u6555\u6240\u64B0\uFF0C\u4E43\u7279\u4F8B\u4E5F\u3002\u738B\u5FD7\u6E0A\u7A46\uFF0C\u5983\u5FD7\u5CED\u52B2\uFF0C\u51B5\u4E3A\u5B8B\u62D3\u5B64\u672C\uFF0C\u6D35\u58A8\u7687\u4E5F\u3002\u53CC\u4FEE\u9601\u4E2D\uFF0C\u53EF\u65E0\u6127\u8272\u3002\u7678\u9149\uFF081933\uFF09\u6625\uFF0C\u5434\u6E56\u5E06\u9898\uFF0C\u6F58\u9759\u6DD1\u4E66\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life2-59917-3.jpg"],
                points: [
                    {
                        x: 1273,
                        y: 269,
                        content: "<p>\u201C\u6881\u4EC6\u5C04\u5F90\u52C9\uFF0C\u5B57\u4FEE\u4EC1\uFF0C\u5DE5\u6587\u7AE0\uFF0C\u5F53\u65F6\u4E30\u529F\u4F1F\u7EE9\u4E4B\u6587\u7686\u51FA\u5176\u5236\u3002\u6B64\u6C38\u9633\u738B\u656C\u592A\u5983\u53CC\u5FD7\uFF0C\u54B8\u4E3A\u4FEE\u4EC1\u5949\u6555\u6240\u64B0\uFF0C\u56E0\u540D\u543E\u5BA4\u66F0\uFF1A\u53CC\u4FEE\u9601\u3002\u7678\u9149\uFF081933\uFF09\u4E8C\u6708\uFF0C\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u8BB0\u3002\u201D</p>"
                    },
                    {
                        x: 822,
                        y: 33,
                        content: "<p>\u201C\u5357\u671D\u91D1\u7C89\u6D51\u5982\u68A6\uFF0C\u58F9\u57CE\u66F4\u601C\u51C4\u665A\u3002\u6545\u96C1\u5206\u895F\uFF0C\u65B0\u9F99\u8865\u886E\uFF0C\u76DB\u4E8B\u5B8F\u6587\u4FEE\u7FE6\u3002\u5929\u60C5\u672A\u63A9\u3002\u5F85\u5AE0\u7EAC\u5D07\u92AE\uFF0C\u7389\u9C7C\u91CD\u7C1F\u3002\u6811\u6EE1\u957F\u5E72\uFF0C\u4E71\u9E26\u4F55\u8BA1\u66AE\u4E91\u5377\u3002\u6E05\u98CE\u4E61\u5E95\u4E95\u7554\uFF0C\u7FE0\u73C9\u614C\u5367\u4E45\uFF0C\u80A0\u65AD\u65E0\u9650\u3002\u738B\u5F55\u9F50\u6536\uFF0C\u9676\u949E\u4E00\u5FD7\uFF0C\u8E2A\u8FF9\u6C89\u6E6E\u83AB\u8F6C\u3002\u51DD\u601D\u4EE3\u8FDC\u3002\u8D4F\u6881\u82D1\u5B64\u82B3\uFF0C\u5B8B\u573A\u53CC\u8350\u3002\u5F02\u8DA3\u5BAB\u88C5\uFF0C\u9690\u5C45\u7709\u9EDB\u655B\u3002\u6E05\u771F\u300A\u9F50\u5929\u4E50\u300B\u97F5\u3002\u6E05\u771F\u6B64\u8BCD\uFF0C\u9996\u53E5\u6709\u2018\u7EFF\u829C\u51CB\u5C3D\u58F9\u57CE\u8DEF\u2019\u4E00\u8BED\uFF0C\u81EA\u540E\u5B8B\u5143\u4EE5\u6765\u5373\u7528\u2018\u58F9\u57CE\u8DEF\u2019\u4E3A\u724C\u540D\u3002\u4F59\u6545\u62C8\u6B64\u8C03\u9898\u4E4B\uFF0C\u5BF9\u5929\u76D1\u539F\u523B\uFF0C\u4E0D\u65E0\u6168\u611F\u4E91\u3002\u201D</p>"
                    },
                    {
                        x: 258,
                        y: 47,
                        content: "<p>\u201C\u516D\u671D\u91D1\u7C89\u90FD\u6210\u68A6\uFF0C\u5343\u53E4\u6C5F\u5C71\u4F9D\u65E7\u65F6\u3002\u5DF1\u4E11\uFF081949\uFF09\u6625\u6B63\u6708\u65E2\u671B\uFF0C\u5C55\u8BFB\u300A\u6881\u8427\u6577\u656C\u5983\u53CC\u5FD7\u300B\uFF0C\u62DF\u7528\u5F20\u50E7\u7E47\u6CD5\u5199\u56FE\u518C\u7AEF\u3002\u5434\u6E56\u5E06\u5E76\u8BC6\uFF0C\u987E\u62B1\u771F\u7406\u8272\u4E8E\u8FE2\u8FE2\u9601\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life3-19334": {
        caption: "\u660E \u9646\u6CBB \u5143\u591C\u71D5\u96C6\u56FE\u5377",
        thumbnail: $johf1["life3-19334-0.jpg"],
        description: "<p>\u5609\u9756\u4E8C\u5341\u516D\u5E74\uFF081547\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u9646\u6CBB\uFF081496-1576\uFF09\uFF0C\u5B57\u53D4\u5E73\uFF0C\u53F7\u5305\u5C71\uFF0C\u6C5F\u82CF\u82CF\u5DDE\u4EBA\u3002\u672C\u5377\u4E3A\u9646\u6CBB\u5E94\u9646\u5E08\u9053\u4E4B\u8BF7\u6240\u4F5C\uFF0C\u56FE\u7ED8\u5F53\u5E74\u9646\u6C0F\u5E08\u751F\u5143\u5BB5\u65F6\u8282\uFF0C\u5728\u6587\u5F81\u660E\u5BB6\u56ED\u8BD7\u9152\u5531\u548C\u7684\u96C5\u96C6\u60C5\u5F62\u3002\u6B64\u56FE\u4F5C\u4E8E\u5609\u9756\u4E8C\u5341\u516D\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E8C\u5C81\u3002</p><p>\u6B64\u56FE\u7CFB\u5434\u6E56\u5E06\u4E8E1929\u5E74\u5165\u85CF\u3002\u4E24\u5E74\u540E\uFF0C\u5434\u6E56\u5E06\u4E8E\u6F58\u9759\u6DD1\u751F\u65E5\u4E4B\u65F6\u53D6\u51FA\u9898\u548F\uFF0C\u53C8\u9080\u51AF\u8D85\u7136\u7B49\u9898\u8BC6\u3002\u5341\u5E74\u540E\uFF0C\u5434\u6E56\u5E06\u5C06\u8F6C\u8BA9\u5185\u5F1F\u7684\u6B64\u56FE\u5377\u501F\u5F52\u63D0\u770B\uFF0C\u5143\u914D\u6F58\u6C0F\u5DF2\u56E0\u75C5\u53BB\u4E16\uFF0C\u6545\u518D\u4F5C\u8BCD\u8FFD\u60BC\uFF0C\u4E0D\u80DC\u7269\u662F\u4EBA\u975E\u3001\u7269\u6211\u7275\u60C5\u4E4B\u6168\u3002</p>",
        slides: [
            {
                url: $johf1["life3-19334-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 6401,
                        y: 276,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u626B\u7709\u97F5\u8BED\u5C5E\u4ED9\u5BB6\uFF0C\u62C2\u69DB\u6625\u98CE\u6708\u9732\u534E\u3002\u540E\u65E5\u4E0A\u5143\u4ECA\u65E5\u5BFF\uFF0C\u753B\u5802\u5E76\u7ED3\u70DB\u7AEF\u82B1\u3002\u56E2\u571E\u660E\u6708\u51C0\u65E0\u57C3\uFF0C\u6EE1\u82D1\u6885\u82B1\u53D6\u6B21\u5F00\u3002\u706F\u706B\u6625\u5BB5\u5982\u753B\u88F9\uFF0C\u5E74\u5E74\u4ECA\u591C\u9189\u5343\u56DE\u3002\u8F9B\u672A\uFF081931\uFF09\u6B63\u6708\u5341\u4E09\u65E5\u9022\u5185\u5B50\u9759\u6DD1\u6F58\u592B\u4EBA\u56DB\u5341\u521D\u5EA6\uFF0C\u56E0\u6B21\u5377\u4E2D\u660E\u8D24\u97F5\u9898\u8BB0\u3002\u662F\u65E5\u592B\u4EBA\u4E4B\u4F84\u535A\u5C71\u541B\u9152\u91CF\u81F3\u8C6A\uFF0C\u5927\u9189\u800C\u5F52\uFF0C\u6545\u672B\u53E5\u53CA\u4E4B\uFF0C\u4EA6\u4E00\u65F6\u9038\u5174\u4E5F\u3002\u5143\u5BB5\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    },
                    {
                        x: 1292,
                        y: 204,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5973\u51A0\u5B50\u3002\u8F9B\u5DF3\uFF081941\uFF09\u4E0A\u5143\u706F\u8282\uFF0C\u9022\u6F58\u592B\u4EBA\u4E94\u5341\u8BDE\u65E5\uFF0C\u800C\u592B\u4EBA\u5DF2\u4F5C\u53E4\u4EBA\u3002\u56DE\u9996\u5341\u5E74\uFF0C\u604D\u5982\u68A6\u5F71\uFF0C\u91CD\u5411\u535A\u5C71\u5185\u4F84\uFF0C\u501F\u5F52\u65AF\u5377\u4E00\u8BFB\uFF0C\u7528\u848B\u7AF9\u5C71\u97F5\uFF0C\u9898\u8BCD\u4E8E\u540E\uFF0C\u613F\u535A\u5C71\u957F\u62A4\u4E5F\u3002\u4E0A\u5143\u65F6\u4E5F\u3002\u5341\u5E74\u5149\u666F\u5982\u753B\u3002\u56E2\u5706\u5E38\u7167\uFF0C\u51E0\u756A\u6B22\u7B11\uFF0C\u7269\u6211\u7275\u60C5\uFF0C\u6D41\u5149\u79FB\u5C04\u3002\u5FC3\u5934\u5343\u7EEA\u6302\u3002\u8BF4\u751A\u7206\u58F0\u71C3\u7AF9\uFF0C\u7981\u57CE\u901A\u591C\u3002\u53F9\u5929\u8FB9\u3001\u5982\u6C34\u955C\u6708\uFF0C\u56DE\u5F71\u6210\u53CC\u72B9\u800D\u3002\u8BD7\u706F\u7075\u8C1C\u731C\u8C01\u6253\u3002\u5FF5\u6CB3\u9633\u6625\u6EE1\uFF0C\u5377\u5411\u5305\u5C71\u501F\uFF0C\u7389\u53F0\u9999\u70A7\u3002\u5F85\u97F5\u8BED\u68C0\u70B9\uFF0C\u8C29\u718F\u9057\u5E15\uFF0C\u7EA2\u7F57\u7EB9\u4E14\u7811\u3002\u7EC6\u628A\u65E7\u6B22\u65B0\u6068\uFF0C\u5FCD\u4E66\u91CD\u8BDD\u3002\u613F\u5409\u4E91\u957F\u62A4\uFF0C\u78A7\u7EB1\u7B3C\u5904\uFF0C\u5B9D\u5C71\u697C\u4E0B\u3002\u5B9D\u5C71\u697C\uFF0C\u535A\u5C71\u3001\u666F\u90D1\u8D24\u6606\u4EF2\u85CF\u4E66\u5904\u4E5F\u3002\u5E74\u65F6\u591A\u75C5\uFF0C\u624B\u4EA6\u98A4\u77E3\uFF0C\u4E0D\u81EA\u85CF\u62D9\uFF0C\u6F2B\u4E66\u4E8E\u6B64\uFF0C\u76D6\u4EA6\u60C5\u4E4B\u6240\u4E0D\u80FD\u5DF2\u4E5F\u3002\u5E0C\u535A\u5C71\u8D24\u4F84\u52FF\u7CB2\u3002\u5029\u5EB5\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life3-35731": {
        caption: "\u660E \u9648\u696B \u864E\u4E18\u5341\u4E8C\u666F\u56FE\u518C",
        thumbnail: $johf1["life3-35731-0.jpg"],
        description: "<p>\u7EB8\u672C \u8BBE\u8272</p><p>\u9648\u696B\u5B57\u83B1\u5C71\uFF0C\u53F7\u6D4E\u4E4B\uFF0C\u5434\u90E1\u4EBA\u3002\u660E\u4E07\u5386\u95F4\u4EE5\u753B\u540D\u4E8E\u65F6\u3002</p><p>\u672C\u56FE\u518C\u4E3A\u5F20\u5927\u5343\u6240\u8D60\uFF0C\u6240\u753B\u7686\u5434\u6E56\u5E06\u5BB6\u4E61\u82CF\u5DDE\u5730\u533A\u80DC\u666F\u3002\u4ECE\u6885\u666F\u8001\u4EBA\u6240\u5F3A\u8C03\u7684\u201C\u73CD\u85CF\u4E61\u90A6\u6587\u7269\u201D\u8BDD\u8BED\uFF0C\u4EA6\u53EF\u89C1\u5176\u6536\u85CF\u65E8\u8DA3\u4E4B\u4E00\u6591\u3002</p>",
        slides: [
            {
                url: $johf1["life3-35731-1.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-2.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-3.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-4.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-5.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-6.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-7.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-8.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-9.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-10.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-11.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-12.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-13.jpg"],
                points: []
            },
            {
                url: $johf1["life3-35731-14.jpg"],
                points: [
                    {
                        x: 1718,
                        y: 310,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u9648\u696B\uFF0C\u5B57\u83B1\u5C71\uFF0C\u53F7\u6D4E\u4E4B\uFF0C\u5434\u90E1\u4EBA\u3002\u660E\u4E07\u5386\u95F4\u4EE5\u753B\u540D\u4E8E\u65F6\u3002\u4E0E\u738B\u4EF2\u5C71\uFF08\u95EE\uFF09\u53CB\u5584\uFF0C\u4EF2\u5C71\u753B\u95F4\u51FA\u6D4E\u4E4B\u6349\u5200\uFF08\u89C1\u6545\u5BAB\u5468\u520A\u4EF2\u5C71\u5C71\u6C34\u4E00\u5E45\u5373\u9648\u7B14\u4E5F\uFF09\u3002\u6B64\u518C\u4E4B\u524D\u539F\u6709\u4EF2\u5C71\u4E66\u5F15\u9996\u56DB\u5B57\u53CA\u6587\u4F2F\u4EC1\u753B\u864E\u961C\u5168\u666F\u4E00\u5E45\uFF0C\u738B\u6587\u8083\u3001\u738B\u5F07\u5DDE\u7B49\u6570\u8DCB\uFF08\u94B1\u4F59\u521D\u89C1\u65F6\u672A\u7686\u4F5A\uFF09\uFF0C\u65CB\u88AB\u5EB8\u5DE5\u5272\u88C2\uFF0C\u5145\u5E02\u8D3E\u9152\u8D44\u77E3\uFF0C\u4E0D\u80DC\u60CB\u60DC\u3002\u540E\u6B64\u518C\u4E3A\u5F20\u5927\u5343\u5144\u6240\u89C1\uFF0C\u4EE5\u543E\u5434\u666F\u7269\u8D2D\u4E4B\u76F8\u8D60\u4E91\uFF0C\u7532\u620C\u51AC\u65E5\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life3-45524": {
        caption: "\u5143 \u738B\u3F58\u7B49 \u8BF8\u5BB6\u9898\u502A\u74D2\u8015\u4E91\u8F69\u548F\u5377",
        thumbnail: $johf1["life3-45524-0.jpg"],
        description: "<p>\u7687\u5E86\u4E8C\u5E74\uFF081313\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6B64\u5377\u5206\u4E3A\u4E24\u90E8\u5206\uFF0C\u524D\u4E00\u90E8\u5206\u4E3A\u738B\u3F58\u3001\u5362\u718A\u3001\u5F20\u9002\u3001\u9AD8\u542F\u3001\u50E7\u884D\u3001\u5F90\u8FBE\u5DE6\u3001\u9EC4\u672C\u4E4B\u95F4\u7684\u5531\u548C\u3002\u540E\u4E00\u90E8\u5206\u662F\u660E\u4EBA\u9EC4\u59EC\u6C34\u3001\u5468\u5929\u7403\u3001\u738B\u7A49\u767B\u5BF9\u502A\u74D2\u4E3A\u738B.\u6240\u753B\u300A\u8015\u4E91\u8F69\u56FE\u300B\u7684\u9898\u8DCB\uFF0C\u9898\u548F\u524D\u8D24\u7686\u662F\u5434\u4EBA\uFF0C\u5434\u6E56\u5E06\u5E38\u8A00\u201C\u543E\u5434\u201D\uFF0C\u53EF\u89C1\u5176\u5BF9\u6545\u4E61\u7684\u6587\u5316\u4F20\u7EDF\u5341\u5206\u81EA\u8C6A\uFF0C\u5BF9\u4E8E\u5434\u5730\u4E66\u753B\u5BB6\u4F5C\u54C1\u7684\u641C\u7F57\u4EA6\u4E0D\u9057\u4F59\u529B\u3002\u6B64\u5377\u4E3A\u5434\u6C0F\u592B\u5987\u4EE5\u5343\u91D1\u7D2B\u8C82\u88D8\u6362\u5F97\uFF0C\u53C8\u4E8E\u8DCB\u4E2D\u75DB\u60DC\u502A\u74D2\u539F\u753B\u4E4B\u4F5A\u5931\uFF0C\u8868\u793A\u5C06\u5176\u4E0E\u9EC4\u516C\u671B\u3001\u5434\u9547\u3001\u738B\u8499\u7684\u540D\u5377\u540C\u85CF\uFF0C\u5E0C\u671B\u6709\u4E00\u5929\u80FD\u591F\u5F97\u5143\u56DB\u5BB6\u957F\u5377\u5B8C\u74A7\u7684\u5FC3\u613F\u3002</p>",
        slides: [
            {
                url: $johf1["life3-45524-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 11487,
                        y: 128,
                        content: "<p>\u738B\u3F58\u9898\u548F \uFF1A\u201C\u7542\u8870\u60EB\u4E4B\u8E2A\u672A\u5815\u6C9F\u58D1\uFF0C\u62B1\u75BE\u5C45\u51E4\u51F0\u5C71\u5148\u58E0\u4E4B\u4FA7\uFF0C\u4E0E\u6D77\u4E91\u76F8\u53BB\u54AB\u5C3A\u3002\u611A\u5EB5\u5E08\u5144\u81EA\u5F84\u5C71\u9000\u5E2D\u5BB6\u6797\uFF0C\u7B03\u5FF5\u5148\u6E05\u732E\u5951\u4E49\uFF0C\u65E5\u5915\u5F80\u8FD8\uFF0C\u60C5\u8FC7\u9AA8\u8089\u3002\u7542\u4EE5\u8270\u96BE\u5076\u9002\u6D77\u6D25\uFF0C\u5C81\u9611\u51B0\u96EA\uFF0C\u65F6\u6CAD\u89C1\u601D\u5F62\u4E8E\u6B4C\u548F\uFF0C\u6562\u5F53\u4F55\u5982\uFF1F\u8C28\u4F9D\u9AD8\u97F5\u4EE5\u8C22\u7109\u3002\u8001\u5F1F\u738B\u7542\u7AEF\u8083\u5949\u5448\u3002\u5076\u4E3A\u653E\u6D6A\u6E38\uFF0C\u98D8\u6CCA\u65E0\u5B9A\u5904\u3002\u9065\u5FC6\u6D77\u4E91\u6DF1\uFF0C\u5929\u534E\u9076\u743C\u6811\u3002\u6241\u821F\u5BBF\u6D77\u9645\uFF0C\u5C81\u9611\u72B9\u672A\u5F52\u3002\u5C71\u8272\u6885\u534E\u88F9\uFF0C\u76F8\u601D\u9010\u68A6\u98DE\u3002\u8270\u96BE\u963B\u6CB3\u51B0\uFF0C\u5929\u5BD2\u538C\u4E3A\u5BA2\u3002\u51C9\u6708\u6EE1\u7A7A\u821F\uFF0C\u5348\u591C\u95FB\u7075\u9E4A\u3002\u65F6\u7678\u4E11\uFF081313\uFF09\u6B63\u6708\u4E09\u65E5\u4E66\u4E8E\u8015\u4E91\u5C71\u5C45\u3002\u201D</p>"
                    },
                    {
                        x: 8359,
                        y: 282,
                        content: "<p>\u9AD8\u5553\u548C\u8BD7 \uFF1A\u201C\u5343\u5CF0\u4E00\u5BFA\u8FDC\uFF0C\u96EA\u6EE1\u8DCF\u8DBA\u5904\u3002\u65E0\u5BA2\u4F34\u5B64\u7985\uFF0C\u60AC\u706F\u7167\u7957\u6811\u3002\u949F\u52A8\u4E91\u58D1\u669D\uFF0C\u9E64\u5F52\u4EBA\u4E0D\u5F52\u3002\u4F55\u5F53\u8E51\u91D1\u7B56\uFF0C\u540C\u5411\u6D77\u5929\u98DE\u3002\u6708\u660E\u591C\u733F\u8D77\uFF0C\u9065\u5FC6\u5B64\u821F\u5BA2\u3002\u65E7\u6811\u6709\u5B89\u5DE2\uFF0C\u83AB\u4F5C\u5357\u98DE\u9E4A\u3002\u9AD8\u5553\u6B21\u97F5\u201D\u3002</p>"
                    },
                    {
                        x: 4002,
                        y: 128,
                        content: "<p>\u5468\u5929\u7403\u548C\u8BD7\uFF1A\u201C\u4E91\u6797\u5B50\u6E05\u9038\u9AD8\u53E4\uFF0C\u827A\u80FD\u4EA6\u7136\u3002\u4ECA\u5434\u4E2D\u4EBA\u58EB\u79F0\u597D\u4E8B\u535A\u96C5\u8005\uFF0C\u8D2D\u5F97\u7247\u7EB8\u4FBF\u81EA\u8C13\u540D\u4E0B\u4E0D\u865A\uFF0C\u7136\u4E0D\u6613\u5F97\u4E5F\u3002\u5176\u5E73\u751F\u4F5C\u6A2A\u5377\u95FB\u6B62\u6709\u4E09\uFF0C\u300A\u8015\u4E91\u300B\u5C45\u4E00\uFF0C\u6B64\u5C24\u8270\u81F4\u8005\uFF0C\u8FD1\u5F52\u8C08\u592A\u5E38\u601D\u91CD\uFF0C\u5F97\u501F\u9605\u7ECF\u65EC\uFF0C\u660E\u7A97\u5C55\u62C2\uFF0C\u80FD\u4EE4\u4EBA\u610F\u6D88\uFF0C\u4F59\u4EA6\u4ECE\u6B64\u4E0D\u6EB7\u4E8E\u4FD7\u77E3\u3002\u516D\u6B62\u5C45\u58EB\u5468\u5929\u7403\u9898\u3002\u201D\u94A4\uFF1A\u201C\u516D\u6B62\u5C45\u58EB\u201D\u3001\u201C\u5468\u6C0F\u516C\u6687\u201D\u767D\u6587\u65B9\u5370\u3002</p>"
                    },
                    {
                        x: 3401,
                        y: 127,
                        content: "<p>\u738B\u7A49\u767B\u548C\u8BD7\uFF1A\u201C\u5B3E\u516C\u4E66\u6CD5\u7EDD\u8FDC\u65F6\u8F88\uFF0C\u665A\u5C81\u5165\u8463\u5DE8\u4E4B\u5BA4\u3002\u89C2\u6B64\u5377\u6797\u5CAB\u6FEF\u6FEF\uFF0C\u8427\u7136\u6709\u9AD8\u4E16\u4E4B\u81F4\u3002\u8015\u4E91\u5B50\u8005\uFF0C\u4F59\u4E0D\u77E5\u4E3A\u4F55\u4EBA\uFF0C\u4FBF\u601D\u8377\u8863\u841D\u5E26\u5055\u9690\u5176\u95F4\u4E5F\u3002\u58EC\u7533\uFF081572\uFF09\u95F0\u6708\uFF0C\u4E0E\u601D\u91CD\u592A\u5E38\u540C\u6CDB\u5A04\u6C5F\uFF0C\u821F\u4E2D\u9605\u6B64\u56FE\u656C\u9898\u3002\u592A\u539F\u738B\u7A49\u767B\u3002\u201D</p>"
                    },
                    {
                        x: 1758,
                        y: 125,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u4F59\u65E2\u5F97\u9EC4\u5B50\u4E45\u5BCC\u6625\u5C71\u5C45\u56FE\u70EC\u4F59\u5377\uFF0C\u672A\u53CA\u7ECF\u5E74\uFF0C\u53C8\u5F97\u6B64\u8015\u4E91\u8F69\u56FE\u548F\u5377\u3002\u7686\u660E\u6881\u6EAA\u8C08\u601D\u91CD\u592A\u5E38\u6545\u7269\uFF0C\u60DC\u4E91\u6797\u4E4B\u753B\u4ECA\u4E0D\u590D\u5B58\uFF0C\u53EA\u5B58\u5143\u660E\u8D24\u8BD7\u8DCB\u5341\u5BB6\u800C\u5DF2\u3002\u6309\u6E05\u9AD8\u5B97\u4E09\u9898\u72B9\u4E91\u5C61\u548C\u4E91\u6797\u97F5\u9898\u4E8E\u753B\u5E45\uFF0C\u53EF\u77E5\u6B64\u753B\u4F5A\u4E8E\u4E7E\u9686\u4E4B\u540E\uFF0C\u6D35\u827A\u6797\u4E2D\u5927\u61BE\u4E8B\u4E5F\u3002\u6614\u4EBA\u4E91\u5927\u5B9D\u5FCC\u5B8C\uFF0C\u4EA6\u662F\u8FBE\u4EBA\u8BED\u4E5F\u3002\u9898\u4E2D\u5143\u8D24\u5982\u738B\u3F58\u5DF2\u5F97\u6E05\u9AD8\u5B97\u63ED\u6CE8\uFF0C\u82E5\u5362\u718A\u3001\u9AD8\u542F\u3001\u5F90\u8FBE\u3001\u5DE6\u50E7\u884D\u7686\u6709\u540D\u4F20\uFF0C\u5F20\u9002\u4EA6\u5434\u4EBA\u3002\u5FC6\u6545\u5185\u5E9C\u6240\u85CF\u5143\u8D24\u628A\u5BB6\u753B\u5377\u7686\u5F20\u9002\u65E7\u7269\uFF0C\u53EA\u9EC4\u672C\u5C1A\u672A\u8BE6\u4FDF\u8003\uFF0C\u660E\u4E09\u5BB6\u7686\u543E\u5434\u5609\u9686\u540D\u8D24\uFF0C\u6BCB\u5EB8\u4F59\u8D58\u3002\u662F\u5377\u65E7\u85CF\u543E\u82CF\u5F6D\u6C0F\uFF0C\u5341\u4F59\u5E74\u524D\u4F59\u66FE\u89C1\u4E4B\uFF0C\u672A\u80FD\u529B\u81F4\u3002\u4E01\u4E11\u4E71\u79BB\u4E2D\u590D\u89C1\u4E8E\u6D77\u4E0A\uFF0C\u5982\u9022\u6545\u65E7\uFF0C\u9042\u6536\u5165\u4E3A\u6885\u666F\u4E66\u5C4B\u957F\u7269\uFF0C\u4E0E\u5B50\u4E45\u5BCC\u6625\u6B8B\u5377\u3001\u4EF2\u572D\u6E14\u7236\u56FE\u5377\u3001\u53D4\u660E\u677E\u7A97\u8BFB\u6613\u56FE\u5377\u540C\u8D2E\u4EE5\u4FDF\u9AD8\u58EB\u539F\u8FF9\u7EB8\u5F52\u6765\u4E91\u3002\u4E59\u536F\u5434\u6E56\u5E06\u6F58\u9759\u6DD1\u540C\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life3-45535": {
        caption: "\u660E\u4EBA\u8BD7\u724D\u518C",
        thumbnail: $johf1["life3-45535-0.jpg"],
        description: "<p>\u5434\u6E56\u5E06\u559C\u7231\u4EE5\u4E00\u4E2A\u4E3B\u9898\u5C06\u85CF\u54C1\u96C6\u518C\u6216\u96C6\u5377\uFF0C\u5C24\u5176\u559C\u7231\u6C47\u96C6\u82CF\u5DDE\u4E61\u8D24\u7684\u4F5C\u54C1\uFF0C\u79FB\u5165\u79FB\u51FA\u62FC\u914D\u7684\u73B0\u8C61\u4E5F\u65F6\u6709\u53D1\u751F\u3002\u6BD4\u5982\u672C\u96C6\u518C\u4E2D\u7533\u65F6\u884C\u300A\u6E38\u5929\u5E73\u5C71\u8BD7\u300B\u9875\uFF0C\u539F\u4E0E\u738B\u93CA\u300A\u81EA\u4F5C\u516D\u5341\u5BFF\u8BDE\u8BCD\u300B\u5408\u88C5\u4E00\u5377\uFF0C\u540E\u4E3A\u5434\u6E56\u5E06\u62C6\u5206\uFF0C\u5C06\u738B\u93CA\u300A\u81EA\u4F5C\u516D\u5341\u5BFF\u8BDE\u8BCD\u300B\u79FB\u914D\u300A\u660E\u56DB\u5BB6\u96C6\u9526\u5377\u300B\uFF0C\u4E0E\u5510\u5BC5\u4E3A\u738B\u93CA\u6240\u7ED8\u300A\u6587\u4F1A\u56FE\u300B\u547C\u5E94\uFF0C\uFF0C\u800C\u7533\u6C0F\u6B64\u8BD7\u9875\u5219\u4E0E\u518C\u4E2D\u5176\u5B83\u5434\u95E8\u6587\u4EBA\u5982\u6587\u5F81\u660E\u3001\u5510\u5BC5\u3001\u795D\u5141\u660E\u7B49\u8BD7\u724D\u5408\u518C\u3002</p>",
        slides: [
            {
                url: $johf1["life3-45535-1.jpg"],
                zoomLevel: 2,
                points: []
            },
            {
                url: $johf1["life3-45535-2.jpg"],
                zoomLevel: 2,
                points: []
            },
            {
                url: $johf1["life3-45535-3.jpg"],
                zoomLevel: 2,
                points: []
            },
            {
                url: $johf1["life3-45535-4.jpg"],
                zoomLevel: 2,
                points: []
            },
            {
                url: $johf1["life3-45535-5.jpg"],
                zoomLevel: 2,
                points: [
                    {
                        x: 971,
                        y: 143,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u53F3\u543E\u5434\u660E\u8D24\u8BD7\u5E16\u7CBE\u54C1\u4E00\u518C\uFF0C\u4F59\u96C6\u4E4B\u5341\u5E74\u77E3\u3002\u51E1\u8BD7\u7528\u5176\u9898\u6807\u76EE\uFF0C\u624B\u724D\u5219\u68C0\u6587\u4E2D\u9996\u53E5\u6216\u4E3B\u4E8B\u540D\u4E4B\u66F0\u5E16\uFF0C\u76D6\u4EFF\u9601\u5E16\u540D\u4E8C\u738B\u4E66\u4F8B\u4E5F\u3002\u543E\u5434\u5728\u660E\u5609\u9686\u65F6\uFF0C\u6587\u7269\u4E4B\u76DB\u7532\u6D77\u5185\uFF0C\u678B\u56FD\u6587\u8C6A\u9F50\u80A9\u8F88\u51FA\u3002\u4E94\u767E\u5E74\u524D\u98CE\u6D41\u76DB\u4E1A\uFF0C\u81F3\u4ECA\u51ED\u4ED7\u7EB8\u58A8\u4E4B\u4F20\uFF0C\u96C6\u6210\u4E00\u5E19\uFF0C\u4EA6\u8DB3\u4EE5\u56DE\u77BB\u8D24\u578B\u800C\u5DF2\u3002\u5C81\u5728\u7532\u620C\uFF081934\uFF09\u5341\u4E8C\u6708\u4E09\u5341\u65E5\u9664\u5915\u591C\u8DCB\uFF0C\u9091\u4EBA\u5434\u6E56\u5E06\u3002\u201D</p><p>\u201C\u6B64\u518C\u867D\u5BE5\u5BE5\u4E8C\u5341\u4F59\u901A\uFF0C\u7136\u7686\u543E\u4E61\u5148\u8D24\u624B\u6CFD\uFF0C\u4E3A\u53EF\u73CD\u3002\u800C\u81EA\u6765\u85CF\u8005\u4E0D\u4E00\uFF0C\u82E5\u9879\u5B50\u4EAC\u3001\u6731\u5367\u5EB5\u3001\u7F2A\u6587\u5B50\u3001\u5B89\u4EEA\u5468\u3001\u4E54\u6DA6\u658B\u3001\u9646\u4E39\u53D4\u3001\u987E\u4E61\u821F\u3001\u72C4\u66FC\u519C\u7B49\u7686\u8457\u540D\u6536\u5F55\u5BB6\u6570\uFF0C\u5177\u6709\u94A4\u5370\u53EF\u7A3D\u3002\u53CA\u543E\u800C\u805A\u4E8E\u4E00\u5E19\uFF0C\u662F\u4EA6\u7FF0\u58A8\u7F18\u4E5F\u3002\u6821\u7ADF\u91CD\u8BB0\uFF0C\u65F6\u5DF2\u4E09\u9F13\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life3-64771": {
        caption: "\u6E05 \u91D1\u4FCA\u660E \u7FA4\u82B3\u5408\u74A7\u56FE\u518C",
        thumbnail: $johf1["life3-64771-0.jpg"],
        description: "<p>\u987A\u6CBB\u5341\u4E03\u5E74\uFF081660\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8/\u8BBE\u8272</p><p>\u91D1\u4FCA\u660E\uFF081602-1675\uFF09\uFF0C\u5B57\u5B5D\u7AE0\uFF0C\u53F7\u803F\u5EB5\uFF0C\u6C5F\u82CF\u82CF\u5DDE\u4EBA\u3002\u6B64\u518C\u4E3A\u4F5C\u8005\u58A8\u620F\u81EA\u8D4F\u4E4B\u4F5C\uFF0C\u4F5C\u4E8E\u987A\u6CBB\u5341\u4E03\u5E74\u65F6\u5E74\u4E94\u5341\u4E5D\u5C81\u4E4B\u9645\uFF0C\u753B\u540E\u53C8\u8BF7\u597D\u53CB\u4E00\u4E00\u8865\u7F00\u5404\u79CD\u82B1\u5349\u677E\u7AF9\u4EE5\u6210\u3002</p><p>\u6709\u5173\u5BB6\u4E16\u3001\u4E61\u8C0A\u3001\u4E0E\u5434\u95E8\u98CE\u571F\u4EBA\u60C5\u4EE5\u53CA\u5434\u6C0F\u5BB6\u65CF\u76F8\u5173\u7684\u53E4\u4EE3\u4E66\u753B\uFF0C\u662F\u6885\u666F\u4E66\u5C4B\u6240\u85CF\u4E4B\u53E6\u4E00\u7279\u8272\u3002\u91D1\u4FCA\u660E\u7FA4\u82B3\u5408\u74A7\u56FE\u518C\u65E2\u4E3A\u7956\u4F20\uFF0C\u753B\u5BB6\u91D1\u6C0F\u6240\u5C45\u201C\u6625\u8349\u95F2\u623F\u201D\u539F\u5740\u53C8\u662F\u5434\u5BB6\u82CF\u5DDE\u7956\u4E0A\u65E7\u5C45\uFF0C\u52A0\u4E4B\u6885\u82B1\u9898\u6750\u7CFB\u5434\u6F58\u6700\u7231\uFF0C\u53EF\u8C13\u662F\u6C47\u805A\u4E86\u6D53\u539A\u5BB6\u65CF\u4EB2\u60C5\u7684\u85CF\u54C1\uFF0C\u6545\u6DF1\u5F97\u5434\u6E56\u5E06\u559C\u7231\uFF0C\u6BCF\u5E74\u5143\u65E6\u5FC5\u68C0\u51FA\u4E0E\u5BB6\u4EBA\u5171\u540C\u6367\u8BFB\u3002</p>",
        slides: [
            {
                url: $johf1["life3-64771-1.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-2.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-3.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-4.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-5.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-6.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-7.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-8.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-9.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-10.jpg"],
                points: []
            },
            {
                url: $johf1["life3-64771-11.jpg"],
                points: [
                    {
                        x: 2223,
                        y: 1179,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB;\u201C\u543E\u5BB6\u65E7\u5C45\u53CC\u6797\u5DF7\u6625\u8349\u95F2\u623F\uFF0C\u5B5D\u7AE0\u5148\u751F\u6545\u91CC\u4E5F\u3002\u5148\u7956\u6536\u5F97\u5148\u751F\u753B\u6885\u518C\u51E1\u4E09\uFF0C\u4EE5\u6B64\u4E3A\u51A0\u3002\u53C8\u5148\u751F\u624B\u4E66\u8BD7\u7A3F\u4E00\u5377\uFF0C\u7686\u4E19\u620C\uFF081646\uFF09\u3001\u4E01\u4EA5\uFF081647\uFF09\u65F6\u4F5C\u8BED\uFF0C\u591A\u51C4\u611F\uFF0C\u76D6\u8EAB\u4E16\u4E0E\u6240\u5357\u4EFF\u4F5B\u8033\u3002\u6B64\u518C\u66FE\u88C5\u4E8E\u5149\u7EEA\u620A\u7533\uFF081908\uFF09\uFF0C\u5148\u7236\u5F55\u4F5C\u5BB6\u5C0F\u4F20\u4E8E\u540E\uFF0C\u8D8A\u4ECA\u53C8\u5EFF\u4F59\u5E74\u77E3\u3002\u91CD\u4ED8\u6F62\u6C60\u9898\u4E4B\uFF0C\u65F6\u8F9B\u672A\uFF081931\uFF09\u5341\u6708\uFF0C\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life3-64771-12.jpg"],
                points: [
                    {
                        x: 1689,
                        y: 768,
                        content: "<p>\u6F58\u9759\u6DD1\u9898\u8DCB\uFF1A\u201C\u5E74\u5E74\u5143\u65E6\uFF0C\u6E56\u5E06\u5FC5\u4EE5\u6B64\u518C\u5728\u6885\u666F\u4E66\u5C4B\u5171\u8BFB\u3002\u53F3\u5434\u971C\u5393\u5E08\u9898\u4E8E\u58EC\u7533\uFF081932\uFF09\uFF0C\u65F6\u9022\u502D\u5BC7\u6D77\u4E0A\u3002\u8DDD\u4ECA\u4E03\u5E74\uFF0C\u800C\u7B2C\u4E8C\u6B21\u4E71\u4E8B\u53C8\u9022\u77E3\uFF0C\u53EF\u53F9\u53EF\u53F9\u3002\u620A\u5BC5\uFF081938\uFF09\u5143\u65E5\u9759\u6DD1\u8BB0\u3002\u201D</p>"
                    },
                    {
                        x: 684,
                        y: 249,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB;\u201C \u4F2B\u82B1\u9634\uFF0C\u7CFB\u79BB\u6101\u51E0\u8BB8\uFF0C\u4ED9\u683C\u89E3\u6BEB\u7C2A\u3002\u6D95\u6CEA\u5BB6\u5E38\uFF0C\u5BAB\u5546\u56FD\u7834\uFF0C\u82F1\u6C14\u90FD\u4ED8\u6D88\u6C89\u3002\u5FC6\u6625\u8349\uFF0C\u95F2\u541F\u81EA\u8DB3\uFF0C\u7FA1\u6708\u6EE1\uFF0C\u679D\u4E0A\u5E76\u6816\u79BD\u3002\u5BC6\u62A4\u60C5\u540C\uFF0C\u6697\u6D6E\u9999\u5408\uFF0C\u4F55\u65E5\u91CD\u4E34\u3002 \u72B9\u8BB0\u53BB\u5E74\u5143\u591C\uFF0C\u6709\u534E\u706F\u7167\u6068\uFF0C\u7389\u7B1B\u5439\u5FC3\u3002\u758F\u5F71\u9EC4\u660F\uFF0C\u7EB9\u7A97\u60E8\u7EFF\uFF0C\u6E29\u68A6\u8F7B\u4ECE\u3002\u96BE\u627F\u6068\uFF0C\u7A7A\u8D1F\u6797\u6CC9\u65E7\u7EA6\uFF0C\u5269\u87BA\u9EDB\uFF0C\u6B8B\u7C89\u91CD\u5343\u91D1\u3002\u5374\u6028\u4FEE\u7709\u672A\u8212\uFF0C\u58A8\u6D45\u6101\u6DF1\u3002\u201D \u201C\u5DF1\u536F\uFF081939\uFF09\u5143\u65E5\uFF0C\u4F59\u9002\u75C5\u8D77\uFF0C\u9759\u6DD1\u66F4\u5F62\u6B23\u5FEB\uFF0C\u5E76\u4EE5\u66E9\u5C81\u5408\u4E34\u672C\u91CD\u52A0\u70B9\u67D3\u3002\u8D8A\u4ECA\u5C81\u5468\uFF0C\u800C\u592B\u4EBA\u5DF2\u4E3A\u53E4\u4EBA\uFF0C\u6B8B\u70DB\u9752\u706F\uFF0C\u4E0D\u80DC\u51C4\u7136\u6CEA\u4E0B\uFF0C\u5143\u65E5\u4E4B\u591C\uFF0C\u590D\u68C0\u8BFB\u662F\u518C\uFF0C\u4EE5\u6D88\u5B64\u6000\uFF0C\u7136\u9002\u8DB3\u4EE5\u589E\u4F59\u4E4B\u60B2\u4E5F\u3002\u5341\u4E09\u65E5\u6B63\u592B\u4EBA\u8BDE\u8FB0\uFF0C\u56E0\u4F9D\u767D\u77F3\u300A\u4E00\u843C\u7EA2\u300B\u97F5\u9898\u8BB0\uFF0C\u5E9A\u8FB0\uFF081940\uFF09\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life4-45537": {
        caption: "\u660E \u5F90\u6E2D \u8349\u4E66\u6625\u96E8\u5E16\u4E03\u53E4\u4E8C\u7AE0\u5377",
        thumbnail: $johf1["life4-45537-0.jpg"],
        description: "<p>\u7EB8\u672C</p><p>\u5F90\u6E2D\uFF081521-1593\uFF09\uFF0C\u5B57\u6587\u6E05\u3001\u6587\u957F\uFF0C\u53F7\u5929\u6C60\u3001\u9752\u85E4\u7B49\uFF0C\u5C71\u9634\uFF08\u4ECA\u6D59\u6C5F\u7ECD\u5174\uFF09\u4EBA\u3002\u6B64\u4E66\u4F5C\u4E8E\u9686\u5E86\u5143\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u56DB\u5341\u4E03\u5C81\u3002</p><p>\u4E8C\u5341\u4E16\u7EAA\u4E0A\u534A\u53F6\uFF0C\u85CF\u53CB\u95F4\u4E92\u901A\u6709\u65E0\u6027\u8D28\u7684\u9988\u8D60\u9887\u4E3A\u6D41\u884C\uFF0C\u4F53\u73B0\u4E86\u5F53\u65F6\u7684\u6587\u4EBA\u96C5\u73A9\u98CE\u5C1A\uFF0C\u6885\u666F\u4E66\u5C4B\u4EA6\u4E0D\u4F8B\u5916\u3002\u6B64\u5377\u4E3A\u5F90\u6E2D\u8349\u4E66\uFF0C\u5377\u524D\u6E05\u4EBA\u300A\u5F90\u6E2D\u8096\u50CF\u300B\u7CFB\u5434\u6C0F\u5F1F\u5B50\u738B\u5B63\u8FC1\u6240\u8D60\uFF0C\u5434\u6E56\u5E06\u5C06\u4E24\u8005\u88C5\u4E3A\u4E00\u5377\u3002\u5F90\u6E2D\u64C5\u8349\u4E66\uFF0C\u72C2\u653E\u4E0D\u7F81\u800C\u4E0D\u903E\u6CD5\u5EA6\uFF0C\u5434\u6E56\u5E06\u6B23\u8D4F\u6B64\u79CD\u7279\u8272\uFF0C\u4E8E\u6B64\u5377\u975E\u5E38\u73CD\u91CD\uFF0C\u591A\u6B21\u9898\u8DCB\uFF0C\u5BF9\u5176\u98CE\u683C\u3001\u6E90\u6D41\u3001\u6D41\u4F20\u8003\u8BC1\u8BE6\u5C3D\u3002</p>",
        slides: [
            {
                url: $johf1["life4-45537-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 31211,
                        y: 290,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5B63\u8FC1\u7814\u5F1F\u8FD1\u4E8E\u6545\u5BB6\u7EB8\u7C0F\u4E2D\u8D2D\u5F97\u5176\u5148\u5FB7\u738B\u6587\u606A\u516C\u4E0E\u5F90\u5C71\u4EBA\u4E8C\u8C61\u3002\u6807\u9898\u3001\u753B\u50CF\u7686\u5EB7\u7199\u95F4\u4EBA\u624B\u7B14\uFF0C\u987E\u53E4\u96C5\u53EF\u73A9\u3002\u300A\u6587\u606A\u8C61\u300B\uFF0C\u5B63\u8FC1\u88C5\u4E4B\u5BB6\u4E66\u5377\u3002\u300A\u5C71\u4EBA\u8C61\u300B\u4EE5\u8D3B\u6211\uFF0C\u5EFC\u88C5\u4E8E\u6B64\u3002\u7678\u9149\uFF081933\uFF09\u6625\u65E5\u5434\u6E56\u5E06\u8BB0\u3002\u201D</p>"
                    },
                    {
                        x: 29867,
                        y: 103,
                        content: "<p>\u201C\u660E\u5F90\u6587\u957F\u6625\u96E8\u5E16\u771F\u8FF9\u3002\u4EFF\u5B8B\u4EBA\u4E8E\u4E8C\u738B\u547D\u540D\u4E4B\u610F\uFF0C\u53D6\u5E16\u9996\u4E24\u5B57\u4E3A\u540D\uFF0C\u6B64\u5377\u7B2C\u4E8C\u5B57\u7B14\u8BEF\uFF0C\u5373\u53D6\u5176\u8BEF\u5B57\u4E3A\u540D\uFF0C\u5C24\u4E3A\u5207\u5408\u3002\u4F7F\u5343\u767E\u5E74\u540E\u5F53\u6613\u8BC6\u522B\u4E5F\u3002\u6E56\u5E06\u53C8\u5FD7\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life4-45540": {
        caption: "\u660E \u6587\u4FF6 \u58A8\u6885\u56FE\u8F74",
        thumbnail: $johf1["life4-45540-0.jpg"],
        description: "<p>\u5929\u542F\u4E03\u5E74\uFF081627\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u6587\u4FF6\uFF081595-1634\uFF09\uFF0C\u5B57\u7AEF\u5BB9\uFF0C\u6587\u5F81\u660E\u7384\u5B59\u4ECE\u7B80\u4E4B\u5973\uFF0C\u5AC1\u4E0E\u4ECE\u7236\u53D7\u4E1A\u7684\u8D75\u7075\u5747\u3002\u5929\u6027\u660E\u6167\uFF0C\u5584\u7ED8\u82B1\u9E1F\u8349\u866B\u3002\u6B64\u56FE\u6885\u82B1\u51FA\u4EE5\u58A8\u7B14\uFF0C\u8F7B\u63CF\u7B80\u52FE\uFF0C\u9C9C\u598D\u751F\u52A8\uFF0C\u914D\u4E4B\u4EE5\u82CD\u9052\u6811\u5E72\uFF0C\u5C3D\u5F97\u6027\u60C5\u3002\u4F5C\u4E8E\u5929\u542F\u4E03\u5E74\uFF0C\u65F6\u5E74\u4E09\u5341\u4E09\u5C81\u3002</p><p>\u4ECE\u8DCB\u6587\u4E2D\u53EF\u77E5\uFF0C\u6885\u666F\u4E66\u5C4B\u6536\u85CF\u7684\u5386\u4EE3\u5973\u6027\u521B\u4F5C\uFF0C\u4E0E\u5973\u4E3B\u4EBA\u6F58\u9759\u6DD1\u7684\u7814\u4E60\u606F\u606F\u76F8\u5173\u3002\u800C\u4E3B\u4EBA\u5434\u6E56\u5E06\u7684\u81EA\u6211\u671F\u8BB8\uFF0C\u592B\u5987\u4E8C\u4EBA\u8BD7\u6587\u4E66\u753B\u517C\u4FEE\u7684\u9020\u8BE3\uFF0C\u582A\u4E0E\u5143\u4EE3\u8D75\u5B5F\u982B\u3001\u7BA1\u9053\u5347\u548C\u660E\u4EE3\u8D75\u7075\u5747\u3001\u6587\u4FF6\u4F09\u4FEA\u5AB2\u7F8E\u3002</p>",
        slides: [
            {
                url: $johf1["life4-45540-1.jpg"],
                points: [
                    {
                        x: 254,
                        y: 1145,
                        content: "<p>\u6F58\u9759\u6DD1\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u4EAD\u4EAD\u6E05\u7EDD\uFF0C\u9999\u8FDC\u970F\u5E18\u9699\u3002\u72EC\u501A\u9611\u5E72\u60C5\u8109\u8109\uFF0C\u76F8\u5BF9\u65E0\u8A00\u8C01\u8BC6\u3002\u6041\u65F6\u5C0F\u8C2A\u4EBA\u95F4\uFF0C\u5DF2\u7ECF\u4E09\u767E\u4F59\u5E74\u3002\u672C\u662F\u7476\u53F0\u4ED9\u79CD\uFF0C\u5C18\u7F18\u5055\u9690\u5BD2\u5C71\u3002\u4E01\u4E11\u4E0A\u5143\u620F\u8C03\u300A\u6E05\u5E73\u4E50\u300B\uFF0C\u524D\u8DDD\u8D75\u592B\u4EBA\u753B\u65F6\u5DF2\u4E09\u767E\u5341\u53C8\u4E00\u5E74\u77E3\uFF0C\u4E61\u540E\u5B66\u6F58\u9759\u6DD1\u3002\u201D</p>"
                    },
                    {
                        x: 1720,
                        y: 27,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u660E\u8D75\u592B\u4EBA\u6587\u7AEF\u5BB9\u753B\u758F\u5F71\u6A2A\u659C\u56FE\u771F\u8FF9\u3002\u8D75\u592B\u4EBA\u753B\u9AD8\u534E\u743C\u7EDD\uFF0C\u50CA\u9AA8\u5A09\u5A77\uFF0C\u7BA1\u4EF2\u59EC\u540E\u4E00\u4EBA\u800C\u5DF2\u3002\u5F53\u660E\u672B\u5B63\u4E0E\u7075\u5747\u9AD8\u58EB\u5055\u9690\u5BD2\u5C71\uFF0C\u4EE5\u4E66\u753B\u5A31\u665A\uFF0C\u6240\u5199\u866B\u8776\u53EF\u79F0\u7A7A\u524D\u3002\u6B64\u56FE\u6697\u9999\u6D6E\u52A8\uFF0C\u758F\u5F71\u6A2A\u659C\uFF0C\u5C24\u89C1\u9AD8\u9038\uFF0C\u867D\u91D1\u5B5D\u7AE0\u3001\u90B5\u50E7\u5F25\u672A\u80FD\u8FC7\u4E5F\u3002\u5B9C\u5357\u697C\u3001\u6C5F\u9999\u4FF1\u5F53\u4E0B\u62DC\u77E3\u3002\u9759\u6DD1\u8FD1\u5C81\u4E60\u753B\u540E\uFF0C\u6240\u8D2E\u5973\u53F2\u6770\u6784\u6B8A\u591A\uFF0C\u6B64\u5176\u51A0\u4E4E\u3002\u4E01\u4E11\uFF081937\uFF09\u4E0A\u5143\u8282\u65E5\uFF0C\u5434\u6E56\u5E06\u6885\u666F\u4E66\u5C4B\u9898\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life4-47327": {
        caption: "\u6E05 \u674E\u56E0 \u8299\u84C9\u9E33\u9E2F\u56FE\u8F74",
        thumbnail: $johf1["life4-47327-0.jpg"],
        description: "<p>\u5EB7\u7199\u4E5D\u5E74\uFF081670\u5E74\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u674E\u56E0\uFF081616-1685\uFF09\uFF0C\u845B\u5F81\u5947\u4E4B\u59BE\uFF0C\u592B\u5987\u7686\u5584\u7ED8\u4E8B\u3002\u6B64\u56FE\u4F5C\u4E8E\u5EB7\u7199\u4E5D\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E94\u5C81\u3002</p><p>\u6F58\u9759\u6DD1\u81EA\u5E7C\u6D78\u6DEB\u5728\u6536\u85CF\u4E16\u5BB6\u6C1B\u56F4\u4E2D\uFF0C\u53CA\u957F\uFF0C\u5AC1\u4E8E\u5434\u6E56\u5E06\u3002\u592B\u5987\u4E8C\u4EBA\u7686\u75F4\u8FF7\u4E66\u753B\u4E00\u9053\uFF0C\u5E8B\u96C6\u3001\u6479\u53E4\u3001\u521B\u4F5C\u4E0D\u8F8D\u3002\u6F58\u9759\u6DD1\u5C24\u559C\u6536\u85CF\u5386\u53F2\u4E0A\u95FA\u9601\u753B\u5BB6\u4E4B\u4F5C\uFF0C\u65F6\u65F6\u4E34\u5199\u3002\u5BF9\u4E8E\u5386\u53F2\u4E0A\u592B\u59BB\u5171\u540C\u6536\u85CF\u3001\u521B\u4F5C\u7684\u4E66\u753B\uFF0C\u4F5C\u4E3A\u4E66\u753B\u5BB6\u548C\u6536\u85CF\u5BB6\u4F09\u4FEA\u7684\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u592B\u5987\u5219\u5C24\u559C\u6536\u84C4\u3002</p>",
        slides: [
            {
                url: $johf1["life4-47327-1.jpg"],
                points: []
            }
        ]
    },
    "life4-50143": {
        caption: "\u660E \u9A6C\u5B88\u771F \u859B\u7D20\u7D20 \u5170\u82B1\u56FE\u5377",
        thumbnail: $johf1["life4-50143-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u9A6C\u6E58\u5170\uFF081548-1604\uFF09\uFF0C\u4E00\u540D\u5B88\u771F\uFF0C\u53F7\u6708\u5A07\uFF0C\u91D1\u9675\u540D\u5993\u3002\u859B\u7D20\u7D20\uFF0C\u5B57\u7D20\u537F\uFF0C\u5C0F\u5B57\u6DA6\u5A18\uFF0C\u660E\u4E07\u5386\u5E74\u95F4\u79E6\u6DEE\u540D\u5993\u3002\u6B64\u56FE\u9A6C\u6C0F\u4F5C\u4E8E\u4E07\u5386\u4E09\u5341\u4E8C\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E03\u5C81\u3002</p><p>\u6F58\u9759\u6DD1\u597D\u753B\u7CBE\u9274\uFF0C\u201C\u6240\u8D2E\u5973\u53F2\u6770\u6784\u6B8A\u591A\u201D\uFF0C\u4E3A\u6885\u666F\u4E66\u5C4B\u9274\u85CF\u4E00\u5927\u7279\u8272\u3002\u6B64\u753B\u5377\u7ECF\u5434\u6885\u3001\u6C6A\u4E1C\u7B49\u8BCD\u5B66\u540D\u5BBF\u548C\u53F6\u606D\u7EF0\u3001\u51AF\u8D85\u7136\u7B49\u540D\u5BB6\u6325\u6BEB\u5531\u548C\uFF0C\u6108\u52A0\u53EF\u89C2\u3002\u4ECE\u8DCB\u6587\u53EF\u77E5\uFF0C\u5434\u6E56\u5E06\u51B3\u5B9A\u5C06\u6B64\u5377\u8F6C\u8D60\u94B1\u955C\u5858\uFF0C\u4E0E\u4E4B\u6240\u85CF\u7684\u76F8\u5173\u4FE1\u672D\u5408\u74A7\uFF0C\u582A\u79F0\u6D77\u4E0A\u6536\u85CF\u754C\u7684\u7F8E\u8C08\u3002</p>",
        slides: [
            {
                url: $johf1["life4-50143-1.jpg"],
                zoomLevel: 30,
                points: [
                    {
                        x: 30352,
                        y: 109,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u9A6C\u56DB\u3001\u859B\u4E94\u753B\uFF0C\u4F59\u6240\u89C1\u51E0\u53CA\u767E\u4E8B\uFF0C\u800C\u771F\u8FF9\u767E\u4E0D\u5F97\u4E00\u4E8C\u3002\u9A6C\u867D\u4F73\u54C1\u4EA6\u4E0D\u5C11\uFF0C\u534A\u4E3A\u540E\u6765\u597D\u4E8B\u8005\u6B4C\u5439\u6240\u6210\uFF0C\u51B3\u975E\u771F\u8FF9\u3002\u6B64\u5377\u6B3E\u8BC6\u3001\u7B14\u6CD5\u65E0\u4E0D\u795E\u5177\u9AA8\u900F\uFF0C\u4F59\u8D39\u5341\u4F59\u5E74\u641C\u7F57\u800C\u5F97\uFF0C\u771F\u6562\u4E91\u9A6C\u3001\u859B\u771F\u8FF9\u3002\u5E78\u8BFB\u8005\u52FF\u4EE5\u5BFB\u5E38\u9999\u7B7E\u54C1\u5FFD\u4E4B\uFF0C\u662F\u6B86\u4F59\u8D4F\u753B\u77E5\u5DF1\u3002\u5434\u6E56\u5E06\u8BC6\u4E8E\u5377\u9996\u3002\u201D</p>"
                    },
                    {
                        x: 12745,
                        y: 143,
                        content: "<p>\u5434\u6E56\u5E06\u8DCB\u8BCD\uFF1A\u201C\u770B\u5E7D\u9999\u51DD\u7C89\uFF0C\u82B3\u610F\u52A8\u5941\uFF0C\u753B\u7709\u4F59\u97F5\u6D41\u7167\u3002\u6D45\u62B9\u7329\u5507\uFF0C\u6162\u62C8\u51E4\u722A\u3002\u68C0\u70B9\u79BB\u75D5\u591A\u5C11\u3002\u6068\u53F6\u6101\u6839\uFF0C\u9732\u7EAB\u98CE\u7579\uFF0C\u751F\u6765\u5A07\u5C0F\u3002\u4F3C\u5E76\u9B1F\u3001\u73E0\u74A7\u73B2\u73D1\uFF0C\u4EFF\u4F5B\u671D\u4E91\u7434\u64CD\u3002\u5357\u90E8\u6B4C\u58F0\u6084\u6084\uFF0C\uFF08\u6B64\u65E5\u6B63\u91D1\u9675\u9996\u90FD\u98CE\u4E07\u5E9F\u5A3C\u65F6\u4E5F\u3002\uFF09\u4EFB\u79E6\u6DEE\u6708\uFF08\u2018\u53BB\u2019\u58F0\uFF09\u51B7\uFF0C\u83AB\u6101\u98CE\u6653\u3002\u8BA4\u6625\u8272\u4E09\u5206\uFF0C\u5360\u5C3D\u65AD\u80A0\u82B1\u8349\u3002\u7A7A\u7559\u5029\u5F71\uFF0C\u58A8\u90CE\u503E\u5012\u3002\u600E\u8BC6\u56E0\u557C\u7F18\u7B11\u3002\u5408\u6570\u90A3\u3001\u767D\u7EC3\u88D9\u598D\uFF0C\u8BD5\u9A6C\u5F39\u4E38\u4EBA\u4FCF\u3002\u8F9B\u672A\uFF081931\uFF09\u5E74\u957F\u590F\u6536\u6B64\u9A6C\u3001\u859B\u5170\u82B1\u5C0F\u5377\uFF0C\u6E05\u96BD\u5A49\u4E3D\uFF0C\u771F\u4EBA\u95F4\u7EDD\u54C1\u4E5F\u3002\u56E0\u7EA6\u9050\u5EB5\u62C8\u97F5\u9898\u4E4B\u3002\u501A\u8D3A\u4E1C\u5C71\u300A\u671B\u6E58\u4EBA\u300B\u5F8B\u8C29\u4E66\u4E8E\u540E\uFF0C\u5434\u6E56\u5E06\u3002\u201D</p>"
                    },
                    {
                        x: 4271,
                        y: 122,
                        content: "<p>\u5434\u6E56\u5E06\u8DCB\u8BCD\uFF1A\u201C\u4E01\u4E11\uFF081937\uFF09\u6B63\u6708\u5341\u4E09\u65E5\uFF0C\u5929\u96E8\uFF0C\u95F7\u5750\u5C0F\u697C\u3002\u9752\u706F\u76F8\u5BF9\uFF0C\u8BFB\u6C5F\u7075\u9E63\u4E08\u624B\u4E66\u65E5\u8BB0\u7A3F\u672C\u3002\u5149\u7EEA\u5EFF\u4E00\u5E74\uFF081895\uFF09\u5E74\u516B\u6708\u521D\u516D\u6240\u586B\u300A\u91D1\u7F15\u66F2\u300B\uFF0C\u5FC6\u859B\u4E94\u4E8B\uFF0C\u53C8\u9898\u9A6C\u56DB\u5A18\u753B\u6247\u4E24\u7EDD\u53E5\uFF0C\u56E0\u5E76\u5F55\u5165\u6B64\u5377\uFF0C\u4EA6\u53EF\u8C13\u5DE7\u5408\u4E5F\u3002\u300A\u9AD8\u9633\u53F0\u300B\u8BEF\u300A\u91D1\u7F15\u66F2\u300B\u3002\u5357\u90E8\u70DF\u82B1\uFF0C\u516D\u671D\u91D1\u7C89\uFF0C\u4F55\u56E0\u91CD\u611F\u6DF1\u5BB5\u3002\u5341\u91CC\u79E6\u6DEE\uFF0C\u5929\u6559\u751F\u6B64\u7A88\u5A06\u3002\u5B9D\u5F13\u7EC6\u9A6C\u9EC4\u91D1\u5F39\uFF0C\u4EFB\u75F4\u513F\u3001\u770B\u5C3D\u67D4\u8170\u3002\u53C8\u671D\u671D\u3001\u4E5D\u7579\u4E34\u98CE\uFF0C\u7740\u610F\u8F7B\u63CF\u3002\u5F53\u5E74\u98CE\u6708\u4ECA\u4F55\u5904\uFF1F\u8CF8\u753B\u4E2D\u7231\u5BA0\uFF0C\u5377\u88F9\u85CF\u5A07\u3002\u4E00\u6837\u6E58\u5170\uFF0C\u6559\u4EBA\u4E24\u6837\u9B42\u6D88\u3002\u677F\u6865\u603B\u662F\u4F24\u5FC3\u53F2\uFF0C\u5230\u5982\u4ECA\u3001\u68A6\u4E5F\u65E0\u804A\u3002\u66F4\u98D8\u6447\u3001\u71D5\u5B50\u6625\u706F\uFF0C\u66AE\u96E8\u6F47\u6F47\u3002\u5143\u513F\u5DF2\u8001\u6DA6\u5A18\u5F52\uFF0C\u80DC\u56FD\u98CE\u6D41\u4E8B\u5DF2\u975E\u3002\u5374\u8BB0\u751F\u7EE1\u53CC\u5F71\u5728\uFF0C\u4E00\u82B1\u4E00\u53F6\u5C1A\u4F9D\u7A00\u3002\u7EDD\u4EE3\u540D\u59DD\u540A\u5F71\u5355\uFF0C\u7D20\u5FC3\u867D\u5C0F\u8010\u6625\u5BD2\u3002\u4FAC\u5BB6\u62D3\u5F97\u79E6\u6DEE\u672C\uFF0C\u83AB\u5F53\u70DF\u82B1\u8D26\u7C3F\u770B\u3002\u4E11\u7C03\u6F2B\u5F55\u3002\u201D</p>"
                    },
                    {
                        x: 1094,
                        y: 287,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u955C\u5858\u5144\u524D\u5E74\u5F97\u9A6C\u6E58\u5170\u81F4\u738B\u767E\u6996\u516B\u672D\u771F\u8FF9\u5377\uFF0C\u7F20\u7EF5\u60B1\u607B\uFF0C\u4E00\u5F80\u60C5\u6DF1\uFF0C\u6D35\u4E0D\u6127\u7FE0\u88F9\u6731\u5BB6\u7EA2\u5986\u5B63\u5E03\u4E5F\u3002\u738B\u9A6C\u4F73\u8BDD\u4F20\u9001\u5955\u4E16\uFF0C\u89A9\u516B\u672D\u800C\u76CA\u4FE1\u3002\u6050\u9A6C\u5A07\u4EB2\u7B14\u60C5\u4E66\u7947\u6B64\u5B64\u672C\uFF0C\u6E05\u79E6\u6DEE\u8277\u8FF9\u7109\u3002\u4F59\u56CA\u6536\u6B64\u9A6C\u859B\u753B\u5170\u5408\u5377\uFF0C\u6709\u6731\u7AF9\u579E\u3001\u6768\u5DF1\u519B\u3001\u94B1\u7BA8\u77F3\u4E09\u5BB6\u9898\u5B57\uFF0C\u5E76\u7D22\u8BF8\u53CB\u597D\u6B4C\u8BCD\u548F\u4E4B\uFF0C\u5B58\u4E8E\u7B08\u4E2D\uFF0C\u5C06\u4E8C\u5341\u5E74\u77E3\u3002\u56E0\u8BFB\u516B\u672D\uFF0C\u4E0D\u7981\u8D77\u5EF6\u6D25\u5251\u5408\u4E4B\u601D\uFF0C\u5373\u4EE5\u6301\u8D60\u955C\u5858\u3002\u4E24\u5377\u5408\u532E\uFF0C\u6216\u53EF\u7559\u540E\u4E16\u55DF\u8C08\u52A9\u4E91\u3002\u5DF1\u4E11\uFF081949\uFF09\u79CB\u4E5D\u6708\u516B\u65E5\uFF0C\u6E56\u5E06\u706F\u4E0B\u8BC6\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "life4-51072": {
        caption: "\u660E \u738B\u7A49\u767B \u884C\u4E66\u5357\u8FD8\u8BD7\u518C",
        thumbnail: $johf1["life4-51072-0.jpg"],
        description: "<p>\u9686\u5E86\u4E8C\u5E74\uFF081568\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u738B\u7A49\u767B\uFF081535-1612\uFF09\uFF0C\u5B57\u767E\u6996\uFF0C\u53F7\u534A\u5048\u957F\u8005\uFF0C\u6C5F\u82CF\u82CF\u5DDE\u4EBA\u3002\u6B64\u4F5C\u4E66\u4E8E1568\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E09\u5341\u56DB\u5C81\u3002</p><p>\u56E0\u738B\u7A49\u767B\u4E0E\u9A6C\u5B88\u771F\uFF081548-1604\uFF09\u7684\u7231\u60C5\u6545\u4E8B\uFF0C\u5434\u6E56\u5E06\u5C06\u540C\u65F6\u5F97\u4E8E\u4E0D\u540C\u85CF\u5BB6\u7684\u4E24\u4EBA\u4E66\u753B\u5408\u88C5\u4E00\u518C\u3002\u5728\u9A6C\u6C0F\u753B\u9875\u4E0A\uFF0C\u5434\u6E56\u5E06\u9898\u9053\uFF1A\u201C\u738B\u6C0F\u8BD7\u518C\u4E3A\u7CA4\u4E1C\u4F0D\u4FEA\u8343\u65E7\u85CF\uFF0C\u6B64\u753B\u4E3A\u5434\u8377\u5C4B\u7269\uFF0C\u4F59\u540C\u65F6\u6240\u5F97\uFF0C\u7686\u7CA4\u7269\uFF0C\u6545\u5408\u88C5\u4E4B\u3002\u201D\u53C8\u8A00\u201C\u6B64\u753B\u539F\u5939\u5728\u518C\u5185\uFF0C\u7591\u5F53\u65F6\u4F0D\u6C0F\u6240\u6536\u672A\u53CA\u88C5\u5165\u8005\u3002\u201D\u5C06\u76F8\u5173\u4E66\u753B\u6BD4\u5982\u201C\u753B\u4E2D\u4E5D\u53CB\u201D\u3001\u201C\u91D1\u9675\u516B\u5BB6\u201D\u6C47\u96C6\u4E00\u518C\u7684\u504F\u7231\uFF0C\u4E8E\u5434\u6E56\u5E06\u5C24\u4E3A\u7A81\u51FA\u3002</p>",
        slides: [
            {
                url: $johf1["life4-51072-1.jpg"],
                points: [
                    {
                        x: 8960,
                        y: 4560,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u6B64\u753B\u539F\u5939\u5728\u518C\u5185\uFF0C\u7591\u5F53\u65F6\u4F0D\u6C0F\u6240\u6536\u672A\u53CA\u88C5\u5165\u8005\u3002\u6E56\u5E06\u5FD7\u3002\u201D\u201C\u4E07\u5386\u4E19\u5B50\u7CA4\u4ECA\u4E09\u767E\u516D\u5341\u5E74\uFF0C\u91CD\u88C5\u4E8E\u738B\u767E\u6996\u8BD7\u518C\u4E0A\uFF0C\u4E19\u5B50\u6625\u65E5\u5434\u6E56\u5E06\u8BB0\u3002\u201D\u201C\u738B\u6C0F\u8BD7\u518C\u4E3A\u7CA4\u4E1C\u4F0D\u4FA3\u8343\u65E7\u85CF\uFF0C\u6B64\u753B\u4E3A\u5434\u8377\u5C4B\u7269\uFF0C\u4F59\u540C\u65F6\u6240\u5F97\uFF0C\u7686\u7CA4\u7269\uFF0C\u6545\u5408\u88C5\u4E4B\u3002\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life4-51072-2.jpg"],
                points: [
                    {
                        x: 297,
                        y: 2030,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u5DF1\u5DF3\u516D\u6708\u5F97\u6B64\u518C\u4E8E\u674E\u6C0F\uFF0C\u540C\u65F6\u5E76\u5F97\u9A6C\u6E58\u5170\u6C34\u4ED9\u5C0F\u5E27\uFF0C\u9644\u8BB0\u4E8E\u6B64\uFF0C\u6E56\u5E06\u3002\u201D\u94A4\uFF1A\u201C\u5D07\u6613\u5C45\u58EB\u201D</p>"
                    }
                ]
            },
            {
                url: $johf1["life4-51072-3.jpg"],
                points: [
                    {
                        x: 4230,
                        y: 462,
                        content: "<p>\u5434\u6E56\u5E06\u518C\u540E\u9898\u8DCB\u91CA\u6587\uFF1A\u5434\u6E56\u5E06\uFF08\u4E09\u9898\uFF09\uFF1A\u201C\u5DF1\u5DF3\u590F\u5F97\u738B\u767E\u6996\u624B\u4E66\u8BD7\u7A3F\u4E00\u5341\u6709\u4E5D\u53F6\uFF0C\u51E1\u4E03\u5341\u9996\uFF0C\u4E3A\u8463\u9647\u897F\u4E66\u8005\u3002\u9647\u897F\u7231\u4E4B\uFF0C\u6BCF\u884C\u4E0E\u4FF1\u3002\u540E\u4E3A\u5434\u5E7C\u7384\u6240\u8D4F\uFF0C\u9042\u4EE5\u6301\u53BB\u3002\u5D07\u796F\u95F4\u4E3A\u5B63\u65B9\u8005\u6240\u5F97\uFF0C\u5029\u5A04\u82CF\u5EB5\u7EED\u5176\u540E\uFF0C\u5386\u65F6\u6587\u4EBA\u62A4\u7231\u582A\u4E91\u5907\u81F3\u3002\u7FC1\u9601\u5B66\u4E8C\u9898\u7686\u4E3A\u5357\u6D77\u53F6\u4E91\u8C37\u4E66\uFF0C\u65CB\u5F52\u4F0D\u4FEA\u8343\u3002\u9F0E\u9769\u540E\u4E3A\u674E\u5E73\u4E66\u4E08\u5F97\u4E8E\u88F4\u4F2F\u8C26\u5BB6\u8005\uFF0C\u4F59\u590D\u6536\u81EA\u674E\u6C0F\u3002\u6B64\u518C\u4E4B\u4F20\u53EF\u4E91\u7EBF\u7D22\u81EA\u4E45\u77E3\uFF0C\u60DC\u6CAA\u5BD3\u65E0\u767E\u8C37\u8BD7\u96C6\u4E00\u6821\u4E3A\u61BE\uFF0C\u5434\u6E56\u5E06\u8BB0\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "pen1-13834": {
        caption: "\u660E \u6587\u5F81\u660E \u7389\u5170\u82B1\u56FE\u8F74",
        thumbnail: $johf1["pen1-13834-0.jpg"],
        description: "<p>\u5609\u9756\u4E09\u5341\u5E74\uFF081551\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6587\u5F81\u660E\uFF081470-1559\uFF09\uFF0C\u5B57\u5F81\u4EF2\uFF0C\u53F7\u8861\u5C71\u5C45\u58EB\uFF0C\u957F\u6D32\uFF08\u4ECA\u6C5F\u82CF\u82CF\u5DDE\uFF09\u4EBA\u3002\u6B64\u56FE\u4E3A\u4F5C\u8005\u516B\u5341\u4E8C\u5C81\u4F5C\uFF0C\u53D7\u753B\u4EBA\u4E3A\u65E0\u9521\u85CF\u5BB6\u534E\u4E91\u3002</p><p>\u636E\u5434\u6E56\u5E06\u300A\u4E11\u7C03\u65E5\u8BB0\u300B1938\u5E745\u67087\u65E5\u8BB0\u8F7D\uFF0C\u300A\u7389\u5170\u56FE\u300B\u4E3A\u6587\u5F81\u660E\u540D\u4F5C\uFF0C\u574A\u95F4\u4F2A\u672C\u4F17\u591A\uFF0C\u800C\u6B64\u672C\u5B9E\u4E3A\u771F\u8FF9\u3002\u4F46\u201C\u7EB8\u7834\u4E0D\u582A\uFF0C\u5343\u75AE\u767E\u5B54\uFF0C\u4FEE\u8865\u7DA6\u96BE\uFF0C\u4ED6\u4EBA\u7686\u4E0D\u6562\u8D2D\u201D\uFF0C\u5434\u5C06\u6B64\u753B\u7559\u4E0B \uFF0C\u4EB2\u81EA\u52A8\u624B\u8865\u5B8C \uFF0C\u867D\u201C\u63A5\u7B14\u9887\u8D39\u529B\uFF0C\u7136\u4E3A\u4FDD\u5B58\u540D\u8FF9\u8D77\u89C1\uFF0C\u4E0D\u80FD\u907F\u8270\u4E5F\u3002\u201D</p>",
        slides: [
            {
                url: $johf1["pen1-13834-1.jpg"],
                points: []
            }
        ]
    },
    "pen1-64755": {
        caption: "\u660E \u6C88\u5468 \u4E54\u6728\u6148\u4E4C\u56FE\u8F74",
        thumbnail: $johf1["pen1-64755-0.jpg"],
        description: "<p>\u7EB8\u672C \u6C34\u58A8</p><p>\u300A\u6148\u4E4C\u56FE\u300B\u662F\u6C88\u5468\u665A\u5E74\u7684\u5E38\u4F5C\u9898\u6750\uFF0C\u4E00\u65B9\u9762\u753B\u6148\u4E4C\u6709\u5D07\u5C1A\u5B5D\u9053\u7684\u542B\u4E49\uFF0C\u53E6\u4E00\u65B9\u9762\u4E5F\u662F\u6C88\u5468\u5411\u660E\u521D\u753B\u5BB6\u6797\u826F\u5B66\u4E60\u7684\u7ED3\u679C\u3002</p><p>\u672C\u56FE\u88F1\u8FB9\u5434\u6E56\u5E06\u8DCB\u4E2D\u6240\u63D0\u5230\u7684\u53E6\u4E00\u4EF6\u5BB6\u85CF\u6C88\u5468\u300A\u4E54\u6728\u53CC\u4E4C\u56FE\u300B\u8F74\u66FE\u7ECF\u5176\u201C\u5168\u8865\u201D\uFF08\u89C1\u300A\u5434\u6E56\u5E06\u65E5\u8BB0\u300B1935\u5E741\u6708\uFF09\uFF0C\u73B0\u540C\u4E3A\u4E0A\u535A\u85CF\u54C1\u3002\u7EC6\u5BDF\u4E4B\u4E0B\uFF0C\u300A\u4E54\u6728\u6148\u4E4C\u56FE\u300B\u8F74\u4EA6\u66FE\u7ECF\u9AD8\u624B\u5168\u8865\uFF0C\u4FEE\u8865\u75D5\u8FF9\u5386\u5386\u5728\u76EE\uFF0C\u624B\u6CD5\u5341\u5206\u9AD8\u8D85\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-64755-1.jpg"],
                points: []
            }
        ]
    },
    "pen1-31758": {
        caption: "\u5143 \u8D75\u5B5F\u982B \u7AE0\u8349\u6025\u5C31\u7AE0\u518C",
        thumbnail: $johf1["pen1-31758-0.jpg"],
        description: "<p>\u81F3\u5927\u4E8C\u5E74\uFF081309\uFF09</p><p>\u7EB8\u672C \u91D1\u7B3A</p><p>\u8D75\u5B5F\u982B\uFF081254-1322\uFF09\uFF0C\u5B57\u5B50\u6602\uFF0C\u53F7\u677E\u96EA\u9053\u4EBA\u7B49\u3002\u5434\u5174\uFF08\u4ECA\u6D59\u6C5F\u6E56\u5DDE\uFF09\u4EBA\u3002\u6B64\u4E3A\u4F20\u4E16\u8D75\u5B5F\u982B\u300A\u7AE0\u8349\u6025\u5C31\u7AE0\u300B\u4E09\u672C\u4E4B\u4E00\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u516D\u5C811929\u5E745\u6708\uFF0C\u6B64\u518C\u5F52\u5434\u6E56\u5E06\u6536\u85CF\uFF0C\u5434\u6C0F\u8865\u4E66\u7B2C\u4E03\u5F00\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-31758-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-2.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-3.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-4.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-5.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-6.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-7.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-8.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-9.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-10.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-11.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-12.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-13.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-31758-14.jpg"],
                points: [
                    {
                        x: 1392,
                        y: 93,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\u91CA\u6587\uFF1A\u201C\u8C22\u6C60\u6625\u6162\u3002\u5B8B\u674E\u7AEF\u53D4\u97F5\u3002\u6325\u6BEB\u9A70\u9635\uFF0C\u6A2A\u626B\u7EE7\u3001\u5F81\u897F\u540E\u3002\u72C2\u7D20\u80AF\u5FC3\u964D\uFF0C\u98A0\u65ED\uFF08\u2018\u4E0A\u2019\u58F0\uFF09\u5E94\u7709\u76B1\u3002\u5DE6\u63D5\u5434\u751F\u5E26\uFF0C\u8C6A\u897B\u516C\u5B59\u8896\u3002\u7B11\u6768\u98CE\uFF0C\u5938\u5BDD\u753B\u3002\u7EFF\u7A97\u76F8\u5BF9\uFF0C\u5982\u9189\u5C71\u9634\u9152\u3002\u6CA4\u6CE2\u753B\u7701\uFF0C\u770B\u5C0F\u5370\u3001\u94F6\u94A9\u7626\u3002\u5317\u5B8B\u9E9D\u70DF\u6D53\uFF0C\u8839\u7EB8\u5357\u5510\u65E7\u3002\u8BD5\u95EE\u66FE\u85CF\u5904\uFF0C\u5929\u7C41\u9752\u7BB1\u5B88\u3002\u91D1\u9519\u4F53\uFF0C\u582A\u5E76\u5076\u3002\u77EB\u9E70\u543B\u5389\uFF0C\u4F11\u8BDD\u8BDA\u60AC\u67F3\u3002\u5DF1\u5DF3\uFF081929\uFF09\u590F\u83B7\u6B64\u677E\u96EA\u300A\u6025\u5C31\u7AE0\u300B\u5C0F\u518C\uFF0C\u620F\u62C8\u4E00\u8BCD\uFF0C\u8D8A\u4ECA\u5DF2\u5EFF\u5E74\u77E3\u3002\u5E9A\u5BC5\u6625\u5F55\u4E4B\u8865\u7A7A\uFF0C\u662F\u518C\u6BCF\u53F6\u95F4\u6709\u6731\u4E66\u6570\u76EE\u7947\u4E00\u3001\u4E09\u3001\u4E94\u7B49\u5355\u6570\u5B57\uFF0C\u5FC3\u9887\u5947\u8651\u3002\u540E\u4E8E\u6545\u5BAB\u5357\u8FC1\u4E66\u753B\uFF0C\u4F59\u53C2\u9605\u9274\u5BA1\u4E4B\u5F79\uFF0C\u5F97\u89C1\u4FDE\u7D2B\u829D\u5C0F\u6977\u300A\u6025\u5C31\u7AE0\u91CA\u6587\u518C\u300B\uFF0C\u5BBD\u5E7F\u5C3A\u5EA6\u53CA\u6240\u7528\u5B8B\u85CF\u7ECF\u7EB8\u4E0E\u6B64\u6089\u540C\uFF0C\u800C\u6BCF\u53F6\u95F4\u4EA6\u6709\u6731\u4E66\u6570\u76EE\uFF0C\u4E3A\u4E8C\u3001\u56DB\u3001\u516D\u7B49\u53CC\u6570\u5B57\uFF0C\u5E76\u7EB8\u89D2\u9A91\u7F1D\u7B49\u5904\u7686\u6709\u9879\u5B50\u4EAC\u5370\u8BB0\u3002\u4E43\u609F\u539F\u88C5\u4E00\u518C\uFF0C\u524D\u534A\u4E3A\u8D75\u4E66\u7AE0\u8349\uFF0C\u540E\u534A\u4E3A\u4FDE\u4E66\u91CA\u6587\uFF0C\u7531\u9879\u5B50\u4EAC\u5206\u88C5\u4E8C\u518C\uFF0C\u4E0D\u77E5\u4F55\u65F6\u79BB\u6563\uFF0C\u4FDE\u518C\u5165\u5185\u5E9C\uFF0C\u8D75\u518C\u8F6C\u8F6C\u4E3A\u4F59\u6709\u77E3\u3002\u60DF\u8D75\u518C\u7B2C\u4E03\u5E27\u7F3A\u53BB\uFF0C\u4F59\u4E43\u636E\u300A\u4E09\u5E0C\u5802\u300B\u523B\u672C\u6479\u5199\u4E00\u5E27\u8865\u5165\uFF0C\u4EE5\u8DB3\u5B8C\u6587\u4E91\u3002\u5434\u6E56\u5E06\u8BC6\u4E8E\u8FE2\u8FE2\u9601\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "pen1-45524": {
        caption: "\u5143 \u738B\u3F58\u7B49 \u8BF8\u5BB6\u9898\u502A\u74D2\u8015\u4E91\u8F69\u548F\u5377",
        thumbnail: $johf1["pen1-45524-0.jpg"],
        description: "<p>\u6B64\u5377\u539F\u4E3A\u502A\u4E91\u6797\u4E3A\u738B\u3F58\u6240\u753B\u300A\u8015\u8018\u8F69\u56FE\u300B\uFF0C\u540E\u6709\u660E\u4EE3\u5434\u5730\u8BF8\u8D24\u9898\u548F\uFF0C\u6E05\u4E7E\u9686\u4EE5\u540E\u502A\u753B\u4F5A\u5931\u3002\u5434\u6E56\u5E06\u5F97\u5230\u540E\u9762\u7684\u9898\u548F\u540E\u5341\u5206\u60CB\u60DC\uFF0C\u9042\u636E\u5176\u610F\u4EE5\u502A\u6C0F\u7B14\u6CD5\u8865\u753B\u4E00\u56FE\u5408\u88C5\u4E8E\u524D\uFF0C\u7B14\u58A8\u51B7\u96BD\u8427\u6563\uFF0C\u751A\u5F97\u4E91\u6797\u4E09\u5473\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-45524-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 12615,
                        y: 569,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u502A\u9AD8\u58EB\u300A\u8015\u4E91\u8F69\u56FE\u300B\u4E3A\u7167\u78E8\u738B\u3F58\u4F5C\uFF0C\u4ECA\u5377\u7947\u5B58\u738B\u3F58\u3001\u5362\u718A\u3001\u5F20\u9002\u3001\u9AD8\u5553\u3001\u50E7\u884D\uFF08\u59DA\u5E7F\u5B5D\uFF09\u3001\u5F90\u8FBE\u5DE6\u3001\u9EC4\u672C\u4E03\u5BB6\u8BD7\u8DCB\u53CA\u5468\u5929\u7403\u3001\u9EC4\u59EC\u6C34\u3001\u738B\u7A49\u767B\u4E09\u9898\u3002\u636E\u6E05\u9AD8\u5B97\u4E09\u8DCB\u4E91\uFF1A\u61D2\u74C9\u6B64\u56FE\u7B14\u610F\u8427\u6563\uFF0C\u8DB3\u4F20\u9AD8\u81F4\u3002\u53EF\u77E5\u771F\u8FF9\u5728\u4E7E\u9686\u95F4\u5C1A\u672A\u4F5A\u4E5F\u3002\u56E0\u63E3\u610F\u8865\u6B64\u4EE5\u5180\u5251\u5408\u65F6\u3002\u5DF1\u536F\uFF081939\uFF09\u4E94\u6708\u5434\u6E56\u5E06\u4F5C\u4E8E\u53CC\u4FEE\u9601\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "pen1-19800": {
        caption: "\u660E \u8463\u5176\u660C \u753B\u7985\u5BA4\u5C0F\u666F\u56FE\u518C",
        thumbnail: $johf1["pen1-19800-0.jpg"],
        description: "<p>\u5BF9\u81EA\u5DF1\u559C\u6B22\u7684\u85CF\u54C1\uFF0C\u5434\u6E56\u5E06\u5F80\u5F80\u53CD\u590D\u9898\u8DCB\uFF0C\u9664\u4E86\u4E00\u4E9B\u9274\u5B9A\u6216\u8003\u8BC1\u7684\u6587\u5B57\u5916\uFF0C\u4EA6\u591A\u6709\u8BD7\u8BCD\u6216\u4E66\u753B\u4E4B\u4F5C\u3002\u5982\u6B64\u518C\u7684\u677F\u9762\u80CC\u7EE2\u4E0A\u5373\u4EE5\u8463\u6C0F\u98CE\u683C\u620F\u4F5C\u5C0F\u666F\u4E00\u5E27\uFF0C\u7B14\u58A8\u6C14\u97F5\u4E0E\u539F\u4F5C\u6781\u4E3A\u76F8\u8FD1\uFF0C\u5434\u81EA\u79F0\u6B64\u7B49\u884C\u4E3A\u201C\u6050\u81EA\u53E4\u672A\u6709\u201D\uFF0C\u5F97\u610F\u4E4B\u60C5\u8DC3\u7136\u7EB8\u4E0A\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-19800-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-19800-2.jpg"],
                points: []
            }
        ]
    },
    "pen1-45531": {
        caption: "\u5434\u6E56\u5E06\u8865\u300A\u5317\u5B8B \u7C73\u82BE \u884C\u4E66\u591A\u666F\u697C\u8BD7\u518C\u300B\u518C\u524D\u9875",
        thumbnail: $johf1["pen1-45531-0.jpg"],
        description: "<p>\u8FD9\u662F\u5434\u6E56\u5E06\u6839\u636E\u300A\u591A\u666F\u697C\u300B\u8BD7\u610F\u4E3A\u7C73\u82BE\u8FD9\u4EF6\u540D\u4F5C\u914D\u753B\u7684\u753B\u9875\uFF0C\u4EE5\u7075\u6D3B\u7684\u7B14\u58A8\u56FE\u5199\u5317\u56FA\u5C71\u4E0A\u591A\u666F\u697C\u4E34\u6C5F\u72EC\u5CD9\u7684\u9AD8\u65F7\u5BE5\u5ED3\u4E4B\u666F\uFF0C\u70B9\u67D3\u6F47\u6D12\uFF0C\u9887\u6709\u7C73\u6C0F\u98CE\u97F5\uFF0C\u4EA6\u8DB3\u89C1\u5434\u5BF9\u8FD9\u4EF6\u4F5C\u54C1\u7684\u73CD\u89C6\u4E4B\u5FC3\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-45531-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-45531-2.jpg"],
                points: [
                    {
                        x: 608,
                        y: 82,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u53D6\u5357\u5BAB\u610F\u5883\uFF0C\u5199\u5317\u56FA\u6C5F\u5C71\u4E8E\u5927\u7C73\u300A\u591A\u666F\u697C\u8BD7\u300B\u771F\u8FF9\u518C\u9996\uFF0C\u4EA6\u516B\u767E\u5E74\u6765\u6587\u5B57\u7F18\u4E5F\u3002\u5434\u6E56\u5E06\u8BC6\uFF0C\u4E59\u5DF3\uFF081965\uFF09\u91CD\u9633\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "pen1-45534": {
        caption: "\u5434\u6E56\u5E06\u300A\u6885\u666F\u4E66\u5C4B\u56FE\u300B",
        thumbnail: $johf1["pen1-45534-0.jpg"],
        description: "<p>\u8FD9\u662F\u5434\u6E56\u5E06\u4E3A\u81EA\u5DF1\u7684\u4E66\u658B\u6885\u666F\u4E66\u5C4B\u6240\u7ED8\u753B\u9875\uFF0C\u5E03\u5C40\u4EFF\u5357\u5B8B\u9662\u672C\u4E4B\u5236\uFF0C\u8BBE\u8272\u598D\u96C5\uFF0C\u6E32\u67D3\u6E05\u6DA6\uFF0C\u6C14\u606F\u606C\u9759\u6021\u7136\u3002\u753B\u6210\u540E\u4E0E\u5176\u81EA\u5236\u300A\u5341\u516D\u5B57\u4EE4\u300B\u5171\u540C\u7531\u88C5\u88F1\u540D\u5BB6\u5218\u5B9A\u4E4B\u8865\u88C5\u5165\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u4E2D\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-45534-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-45534-2.jpg"],
                points: []
            }
        ]
    },
    "pen1-59917": {
        caption: "\u5434\u6E56\u5E06\u8865\u300A \u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C\u300B\u518C\u9996\u9875",
        thumbnail: $johf1["pen1-59917-0.jpg"],
        description: "<p>\u5BF9\u4E8E\u81EA\u5DF1\u5FC3\u7231\u7684\u85CF\u54C1\uFF0C\u5434\u6E56\u5E06\u5F80\u5F80\u6B23\u7136\u547D\u7B14\u4EE5\u8BD7\u8BCD\u3001\u7ED8\u753B\u7684\u5F62\u5F0F\u54C1\u8BC4\u8D5E\u53F9\uFF0C\u6292\u53D1\u559C\u7231\u4E4B\u60C5\uFF0C\u4E14\u6BCF\u4EE5\u4E0E\u85CF\u54C1\u76F8\u5173\u7684\u7B14\u6CD5\u3001\u98CE\u683C\u51FA\u4E4B\uFF0C\u5982\u300A\u591A\u666F\u697C\u56FE\u300B\u4EE5\u7C73\u6C0F\u98CE\u683C\u70B9\u67D3\uFF0C\u300A\u6885\u666F\u4E66\u5C4B\u300B\u51FA\u4EE5\u5B8B\u9662\u4F53\u683C\u5C40\uFF0C\u300A\u753B\u7985\u5BA4\u5C0F\u666F\u8865\u56FE\u300B\u4EFF\u8463\u5176\u660C\u7B14\u58A8\u7B49\u3002\u300A \u5B8B\u62D3 \u6881\u8427\u6577\u656C\u5983\u5893\u5FD7\u94ED\u5408\u518C\u300B\u4EA6\u4E3A\u5434\u6C0F\u5BB6\u4F20\u4E4B\u73CD\uFF0C\u5C24\u6240\u504F\u7231\uFF0C\u56E0\u5176\u539F\u77F3\u4E3A\u516D\u671D\u9057\u7269\uFF0C\u6545\u5434\u6E56\u5E06\u4E8E\u518C\u524D\u4F5C\u9752\u7EFF\u5C71\u6C34\u4E00\u9875\uFF0C\u4EE5\u201C\u5F20\u50E7\u9E5E\u6CD5\u201D\u56FE\u5199\uFF0C\u7B14\u6CD5\u7CBE\u7EC6\uFF0C\u8BBE\u8272\u5927\u80C6\uFF0C\u800C\u80FD\u8273\u4E0D\u4F24\u96C5\uFF0C\u9887\u5F97\u9AD8\u53E4\u6C14\u97F5\u3002</p>",
        slides: [
            {
                url: $johf1["pen1-59917-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen1-59917-2.jpg"],
                points: []
            }
        ]
    },
    "pen2-45518": {
        caption: "\u7F57\u8058\u3001\u65B9\u5A49\u4EEA \u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1 \u6885\u82B1\u5408\u4F5C\u56FE\u5377",
        thumbnail: $johf1["pen2-45518-0.jpg"],
        description: "<p>\u4E7E\u9686\u4E8C\u5341\u516B\u5E74\uFF081763\uFF09 \u6C11\u56FD\u4E8C\u5341\u4E94\u5E74\uFF081936\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u7F57\u8058\uFF081733-1799\uFF09\uFF0C\u5B57\u906F\u592B\uFF0C\u53F7\u82B1\u4E4B\u5BFA\u50E7\u3002\u5B89\u5FBD\u6B59\u53BF\u4EBA\uFF0C\u8FC1\u5C45\u626C\u5DDE\u3002\u201C\u626C\u5DDE\u516B\u602A\u201D\u4E4B\u4E00\u3002\u65B9\u5A49\u4EEA\uFF081732\u20141784\u540E\uFF09\u4E00\u4F5C\u7579\u4EEA\uFF0C\u5B57\u4EEA\u5B50\uFF0C\u53F7\u767D\u83B2\u5C45\u58EB\u7B49\uFF0C\u5B89\u5FBD\u6B59\u53BF\u4EBA\u3002\u7F57\u8058\u59BB\u5B50\u3002</p><p>\u5434\u6E56\u5E06\u592B\u5987\u5FD7\u8DA3\u76F8\u6295\uFF0C\u4E8E\u8BD7\u8BCD\u4E66\u753B\u4E4B\u9053\u7528\u5FC3\u751A\u6DF1\uFF0C\u4E0D\u4F46\u5171\u540C\u9274\u85CF\uFF0C\u66F4\u5E38\u5408\u4F5C\u9898\u5199\u67D3\u7FF0\u30021936\u5E74\uFF0C\u5434\u6E56\u5E06\u5F97\u7F57\u8058\u3001\u65B9\u5A49\u4EEA\u592B\u5987\u5408\u4F5C\u300A\u6885\u82B1\u56FE\u300B\u5377\uFF0C\u5373\u7F57\u8058\u4EE5\u738B\u5195\u7E41\u6885\u4E4B\u6CD5\u6240\u7ED8\uFF0C\u5176\u59BB\u65B9\u5A49\u4EEA\u4EE5\u753B\u9762\u4E0D\u751A\u5206\u660E\uFF0C\u53D6\u7275\u725B\u82B1\u6D78\u6C41\u6E0D\u67D3\u82B1\u74E3\uFF0C\u4F7F\u4E4B\u4E00\u76EE\u4E86\u7136\u3002\u5434\u6C0F\u592B\u59BB\u8FFD\u6155\u524D\u4EBA\u97F5\u4E8B\uFF0C\u4EA6\u5408\u4F5C\u4E00\u5377\u88C5\u88F1\u5176\u540E\uFF0C\u6F58\u9759\u6DD1\u70B9\u7F00\u6885\u82B1\uFF0C\u5434\u6E56\u5E06\u8865\u5199\u679D\u5E72\u6708\u5F71\uFF0C\u8D8A\u767E\u5E74\u800C\u518D\u8D4B\u753B\u7709\u6DFB\u9999\u3001\u5531\u968F\u4E8E\u98DE\u4E4B\u96C5\u8C03\uFF0C\u6D35\u4E3A\u4F73\u8BDD\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-45518-1.jpg"],
                zoomLevel: 10,
                points: [
                    {
                        x: 13381,
                        y: 218,
                        content: "<p>\u7F57\u8058\u9898\u8DCB\uFF1A\u201C\u2026\u2026\u522B\u6709\u98CE\u5149\u4E0D\u53D7\u6625\uFF0C\u753B\u6BD5\u81EA\u770B\u8FD8\u81EA\u60DC\u3002\u95EE\u5230\u5E95\u8D60\u4F55\u4EBA\u82B1\u3002\u7678\u672A\uFF081763\uFF09\u590F\u516D\u6708\u4EFF\u738B\u5143\u7AE0\u7E41\u679D\u6885\u82B1\uFF0C\u8D75\u5B50\u56FA\u4E91\uFF1A\u6D53\u58A8\u70B9\u6912\uFF0C\u5927\u662F\u96BE\u4E8B\u3002\u4E88\u753B\u6B64\u5377\uFF0C\u4E09\u65E5\u59CB\u6210\u3002\u5185\u5B50\u767D\u83B2\uFF0C\u5C55\u89C2\u518D\u56DB\uFF0C\u5ACC\u5176\u4E0D\u751A\u5206\u660E\uFF0C\u6668\u8D77\u4E43\u6458\u7275\u725B\u82B1\uFF0C\u6D78\u6C41\u6E0D\u5176\u82B1\u74E3\uFF0C\u4EE4\u89C2\u8005\u4E00\u76EE\u4E86\u7136\u3002\u4E88\u4E0D\u53EF\u4E0D\u8BB0\u5176\u82E6\u5FC3\u4E5F\u3002\u7532\u7533\uFF081764\uFF09\u56DB\u6708\u821F\u8FC7\u53E4\u4E30\u25A1\u9898\uFF0C\u6731\u8349\u8BD7\u6797\u4E2D\u4EBA\u7F57\u8058\u3002</p>"
                    },
                    {
                        x: 13770,
                        y: 52,
                        content: "<p>\u201C\u6B64\u5377\u6240\u7528\u4E4B\u7EB8\uFF0C\u4E43\u4E24\u5CF0\u753B\u4E4B\u7279\u5F81\u3002\u5F80\u5F80\u91D1\u51AC\u5FC3\u753B\u4EA6\u7528\u6B64\u7EB8\uFF0C\u7136\u591A\u51FA\u4E8E\u4E24\u5CF0\u4EE3\u4F5C\u3002\u51AC\u5FC3\u4EB2\u7B14\u753B\u9C9C\u7528\u6B64\u7EB8\uFF0C\u800C\u4ED6\u4EBA\u7EDD\u65E0\u7528\u4E4B\u8005\u3002\u767D\u83B2\u5973\u53F2\u6216\u7528\u4E4B\uFF0C\u6545\u6B64\u7EB8\u7279\u547D\u4E4B\u66F0\u2018\u4E24\u5CF0\u7EB8\u2019\u53EF\u4E5F\u3002\u767D\u83B2\u753B\u9887\u67D4\u7F8E\uFF0C\u5176\u82CD\u52B2\u4E00\u79CD\uFF0C\u90FD\u51FA\u4E24\u5CF0\u4E4B\u7B14\uFF0C\u5F80\u5F80\u4EA6\u7528\u6B64\u7EB8\u3002\u738B\u5143\u7AE0\u597D\u753B\u7E41\u679D\u76F4\u69A6\uFF0C\u6B64\u5377\u6DF1\u5177\u795E\u4F3C\uFF0C\u767D\u83B2\u67D3\u8272\u5C24\u97F5\u81F4\u3002\u201D</p>"
                    },
                    {
                        x: 8210,
                        y: 98,
                        content: "<p>\u201C\u758F\u666F\u9EC4\u69A6\u3002\u8FD1\u89C1\u5B8B\u753B\u300A\u6708\u5F71\u6885\u82B1\u300B\u7EA8\u6247\uFF0C\u5C55\u5176\u610F\u4F5C\u6B64\u56FE\uFF0C\u4F59\u5199\u679D\u5E72\u6708\u5F71\u3002\u65F6\u4E19\u5B50\u4E2D\u79CB\uFF0C\u5434\u6E56\u5E06\u8BC6\u3002\u201D</p>"
                    },
                    {
                        x: 7835,
                        y: 77,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u9759\u6DD1\u7F00\u7EFF\u843C\u82B1\u767E\u6735\u4E8E\u6885\u666F\u4E66\u5C4B\u3002\u201D\u94A4\uFF1A\u201C\u5434\u6F58\u9759\u6DD1\u201D\u767D\u6587\u65B9\u5370\uFF0C\u201C\u6885\u666F\u4E66\u5C4B\u201D\u6731\u6587\u65B9\u5370\u3002</p>"
                    }
                ]
            }
        ]
    },
    "pen2-47811": {
        caption: "\u90D1\u6155\u5EB7\u3001\u5434\u6E56\u5E06\u3001\u9646\u4FE8\u5C11 \u5218\u5B9A\u4E4B\u50CF\u5377",
        thumbnail: $johf1["pen2-47811-0.jpg"],
        description: "<p>\u4E59\u672A\uFF081955\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u5218\u5B9A\u4E4B\u662F\u6C11\u56FD\u65F6\u671F\u4E66\u753B\u88C5\u6C60\u5927\u5BB6\uFF0C\u4ED6\u5F00\u8BBE\u7684\u201C\u5218\u5B9A\u4E4B\u88C5\u6C60\u201D\uFF0C\u95FB\u540D\u6D77\u4E0A\u30021949\u5E74\u540E\uFF0C\u5218\u6C0F\u53C2\u52A0\u4E0A\u6D77\u5E02\u88C5\u88F1\u4E1A\u540C\u4E1A\u516C\u4F1A\uFF0C1960\u5E74\u8FDB\u5165\u4E0A\u6D77\u535A\u7269\u9986\u4EFB\u6587\u7269\u4FEE\u590D\u987E\u95EE\uFF0C\u540E\u81F3\u5317\u4EAC\u3002\u4E0A\u535A\u4E0E\u6545\u5BAB\u8BF8\u591A\u4F20\u4E16\u540D\u8FF9\u5982\u5F20\u62E9\u7AEF\u300A\u6E05\u660E\u4E0A\u6CB3\u56FE\u300B\u5377\u3001\u5B59\u4F4D\u300A\u9AD8\u9038\u56FE\u300B\u5377\u7B49\u7686\u51FA\u5176\u624B\u3002</p><p>\u5218\u5B9A\u4E4B\u7684\u88C5\u88F1\u5DE5\u827A\u72EC\u7279\u3001\u6280\u672F\u9AD8\u8D85\u3001\u7528\u6599\u8BB2\u7A76\uFF0C\u5434\u6E56\u5E06\u7684\u8BB8\u591A\u91CD\u8981\u85CF\u54C1\u5982\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u518C\u3001\u502A\u74D2\u300A\u6C40\u6811\u9065\u5C91\u56FE\u300B\u8F74\u7B49\u7686\u7531\u5176\u4EB2\u81EA\u64CD\u5200\uFF0C\u5218\u6C0F\u4E5F\u56E0\u6B64\u4E0E\u4E66\u753B\u5BB6\u7ED3\u4E0B\u6DF1\u539A\u7684\u53CB\u8C0A\u3002\u6B64\u5377\u7531\u5F53\u65F6\u8457\u540D\u8096\u50CF\u753B\u5BB6\u90D1\u6155\u5EB7\u6240\u4F5C\uFF0C\u7531\u9646\u4FE8\u5C11\u3001\u5468\u70BC\u971E\u3001\u4FDE\u5B50\u624D\u3001\u4F55\u9042\u7B49\u8BF8\u5BB6\u8865\u9611\u5E72\u6811\u77F3\u7FCE\u6BDB\uFF0C\u5434\u6E56\u5E06\u9898\u5199\u5377\u9996\uFF0C\u53EF\u8C13\u96C6\u4E00\u65F6\u4E4B\u80DC\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-47811-1.jpg"],
                zoomLevel: 2,
                points: []
            },
            {
                url: $johf1["pen2-47811-2.jpg"],
                zoomLevel: 5,
                points: [
                    {
                        x: 4800,
                        y: 84,
                        content: "<p>\u5434\u6E56\u5E06\u9898\u8DCB\uFF1A\u201C\u8001\u53CB\u52FE\u66F2\u5218\u5148\u751F\u5B9A\u4E4B\uFF0C\u5177\u7CBE\u88C5\u4E66\u753B\u4E4B\u672F\uFF0C\u4E94\u5341\u4F59\u5E74\u4E2D\u7ECF\u5176\u5999\u624B\u6F62\u6CBB\u800C\u5F97\u8FD8\u65E7\u89C2\u8005\uFF0C\u4E0D\u77E5\u51E0\u5343\u767E\u4E8B\u3002\u6614\u9879\u58A8\u6797\u5C0A\u5F53\u65F6\u6F62\u6C60\u540D\u5BB6\u66F0\u4E66\u753B\u795E\u533B\uFF0C\u6B86\u975E\u865A\u8A89\u3002\u5B9A\u4E4B\u5148\u751F\u51FA\u90D1\u541B\u6155\u5EB7\u9020\u516D\u5341\u4E03\u5C81\u50CF\uFF0C\u7D22\u4F59\u8865\u56FE\u5F15\u4E66\u5377\u7AEF\u3002\u4E59\u672A\uFF081955\uFF09\u6E05\u660E\uFF0C\u5434\u6E56\u5E06\u3002\u201D</p>"
                    }
                ]
            }
        ]
    },
    "pen2-61174": {
        caption: "\u5434\u6E56\u5E06 \u677E\u98CE\u9E23\u6CC9\u56FE\u8F74",
        thumbnail: $johf1["pen2-61174-0.jpg"],
        description: "<p>\u7678\u5DF3\uFF081953\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8</p><p>\u672C\u56FE\u7EAF\u7528\u6C34\u58A8\uFF0C\u4EE5\u4E0D\u540C\u7684\u58A8\u8272\u8425\u9020\u51FA\u5E7D\u6DF1\u7684\u610F\u5883\u3002\u8FDC\u666F\u5D07\u5C71\u5CFB\u5CAD\uFF0C\u4EE5\u6DE1\u58A8\u6655\u67D3\uFF0C\u8FD1\u666F\u7528\u6D53\u58A8\u52FE\u52D2\u4E24\u682A\u53C2\u5929\u53E4\u677E\uFF0C\u8F85\u4EE5\u5C42\u5C42\u76B4\u67D3\u7684\u5C71\u77F3\uFF0C\u6C34\u58A8\u6DCB\u6F13\uFF0C\u5B9B\u82E5\u5929\u6210\u3002\u4E00\u65C1\u5C71\u6CC9\u98DE\u6D41\u76F4\u4E0B\uFF0C\u4E00\u9759\u4E00\u52A8\u5F62\u6210\u5F3A\u70C8\u5BF9\u6BD4\uFF0C\u72EC\u5177\u5320\u5FC3\u3002\u5434\u6E56\u5E06\u5728\u4F20\u7EDF\u548C\u521B\u65B0\u4E4B\u95F4\uFF0C\u8D70\u51FA\u81EA\u5DF1\u7684\u827A\u672F\u9053\u8DEF\uFF0C\u5F62\u6210\u6E05\u5B81\u96C5\u4E3D\u3001\u7CBE\u81F4\u6DF1\u79C0\u7684\u7ED8\u753B\u98CE\u683C\u3002\u6B64\u56FE\u4F5C\u4E8E\u7678\u5DF3\uFF081953\uFF09\uFF0C\u5434\u6E56\u5E06\u65F6\u5E74\u516D\u5341\u5C81\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-61174-1.jpg"],
                points: []
            }
        ]
    },
    "pen2-67596": {
        caption: "\u5434\u6E56\u5E06 \u5C42\u5CA9\u79EF\u7FE0\u56FE\u8F74",
        thumbnail: $johf1["pen2-67596-0.jpg"],
        description: "<p>\u6C11\u56FD\u4E09\u5341\u4E09\u5E74\uFF081944\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6B64\u56FE\u662F\u5434\u6E56\u5E06\u9752\u7EFF\u5C71\u6C34\u7684\u4EE3\u8868\u4F5C\u3002\u56FE\u4E2D\u63CF\u7ED8\u6DF1\u5C71\u5CA9\u6811\u7684\u666F\u81F4\u3002\u8FD1\u666F\u7684\u4E1B\u6811\u7EAF\u7528\u6C34\u58A8\uFF0C\u4EE5\u4E0D\u540C\u7684\u58A8\u8272\u8425\u9020\u51FA\u5E7D\u6DF1\u7684\u6C1B\u56F4\u3002\u800C\u5C71\u77F3\u5219\u5148\u4EE5\u58A8\u8272\u4E3A\u5E95\uFF0C\u76B4\u67D3\u51FA\u7ED3\u6784\uFF0C\u518D\u7528\u6781\u6DE1\u7684\u8272\u5F69\u5C42\u5C42\u70D8\u67D3\uFF0C\u6700\u540E\u5F62\u6210\u8272\u58A8\u4E92\u4E0D\u76F8\u788D\u4E14\u76F8\u4E92\u751F\u53D1\u7684\u6548\u679C\u3002\u56E0\u4E3A\u8FD9\u79CD\u65B0\u9896\u7684\u8BBE\u8272\u6280\u5DE7\uFF0C\u4F7F\u5434\u6E56\u5E06\u7684\u9752\u7EFF\u5C71\u6C34\u65E2\u6709\u4F20\u7EDF\u9752\u7EFF\u5C71\u6C34\u9C9C\u660E\u7684\u8272\u5F69\uFF0C\u53C8\u4FDD\u6709\u6C34\u58A8\u5C71\u6C34\u4E30\u5BCC\u7684\u7B14\u58A8\u53D8\u5316\uFF0C\u5F62\u6210\u598D\u4E3D\u800C\u6587\u96C5\u3001\u6DF1\u539A\u800C\u6E05\u79C0\u7684\u72EC\u7279\u753B\u98CE\u3002\u6B64\u56FE\u4F5C\u4E8E1944\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u4E00\u5C81\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-67596-1.jpg"],
                points: []
            }
        ]
    },
    "pen2-72444": {
        caption: "\u5434\u6E56\u5E06 \u6885\u666F\u4E66\u5C4B\u56FE\u8F74",
        thumbnail: $johf1["pen2-72444-0.jpg"],
        description: "<p>\u6C11\u56FD\u5341\u516B\u5E74\uFF081929\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6B64\u56FE\u4E3A\u5434\u6E56\u5E06\u4E09\u5341\u516D\u5C81\u6240\u7ED8\uFF0C\u51FA\u4EE5\u5510\u5BC5\u7B14\u6CD5\u3002\u56FE\u4E2D\u5C71\u6DA7\u5E7D\u8C37\uFF0C\u767D\u6885\u4E07\u70B9\uFF0C\u8305\u5C4B\u63A9\u6620\u5176\u95F4\u3002\u5BA4\u5185\u6709\u4E00\u96C5\u58EB\u4E0E\u5973\u53F2\u51ED\u6848\u5BF9\u5750\uFF0C\u5F53\u4E3A\u5434\u6C0F\u592B\u59BB\u81EA\u51B5\u3002</p><p>\u88F1\u8FB9\u4E3A\u5434\u6E56\u5E06\u3001\u6F58\u9759\u6DD1\u4F09\u4FEA\u96C6\u9009\u5357\u5B8B\u8BCD\u4EBA\u5434\u6587\u82F1\u300A\u68A6\u7A97\u8BCD\u300B\u53E5\uFF0C\u636E\u300A\u745E\u9E64\u4ED9\u300B\u548C\u300A\u70DB\u5F71\u6447\u7EA2\u300B\u8BCD\u724C\u6240\u586B\u65B0\u8BCD\uFF0C\u4E0E\u56FE\u753B\u60C5\u666F\u76F8\u5F97\u76CA\u5F70\u3002\u4E8C\u8BCD\u53E6\u89C1\u4E8E\u5218\u5B9A\u4E4B\u4E3A\u5434\u6E56\u5E06\u91CD\u88C5\u7684\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u518C\u5185\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-72444-1.jpg"],
                points: []
            }
        ]
    },
    "pen2-72519": {
        caption: "\u5434\u6E56\u5E06 \u4EFF\u71D5\u6587\u8D35\u6EAA\u5C71\u697C\u89C2\u56FE\u8F74",
        thumbnail: $johf1["pen2-72519-0.jpg"],
        description: "<p>\u6C11\u56FD\u4E8C\u5341\u56DB\u5E74\uFF081935\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u6B64\u56FE\u4E3A\u5434\u6E56\u5E06\u4EFF\u5317\u5B8B\u753B\u5BB6\u71D5\u6587\u8D35\uFF08967-1044\uFF09\u753B\u4F5C\u3002\u56FE\u7ED8\u8FDC\u5C71\u5DCD\u5CE8\uFF0C\u5C42\u5CE6\u53E0\u5D82\uFF0C\u4E91\u6C14\u84B8\u817E\u3002\u8FD1\u666F\u53E4\u677E\u9052\u52B2\uFF0C\u6EAA\u6C34\u6F7A\u6F7A\u3002\u5434\u6E56\u5E06\u56DB\u5341\u4E00\u5C81\u6210\u4E3A\u6545\u5BAB\u535A\u7269\u9662\u5BA1\u67E5\u59D4\u5458\uFF0C\u6240\u89C1\u5B8B\u5143\u540D\u8FF9\u751A\u591A\u3002\u8FC7\u773C\u4E4B\u4F59\uFF0C\u5176\u4E8E\u6479\u5199\u53C8\u80FD\u5F62\u795E\u4FF1\u4F3C\uFF0C\u7B14\u76CA\u7CBE\u70BC\uFF0C\u795E\u660E\u7115\u7136\uFF0C\u753B\u4E43\u76CA\u8FDB\u3002\u5434\u6E56\u5E06\u5728\u827A\u672F\u521B\u4F5C\u4E0A\u5584\u4E8E\u878D\u4F1A\u8D2F\u901A\uFF0C\u5176\u6DF1\u690D\u5728\u5FC3\u5E95\u7684\u6839\u57FA\u8FD8\u662F\u5B8B</p>",
        slides: [
            {
                url: $johf1["pen2-72519-1.jpg"],
                points: []
            }
        ]
    },
    "pen2-73413": {
        caption: "\u5434\u6E56\u5E06 \u6E56\u5C71\u79CB\u8272\u56FE\u8F74",
        thumbnail: $johf1["pen2-73413-0.jpg"],
        description: "<p>\u6C11\u56FD\u4E8C\u5341\u4E00\u5E74\uFF081932\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u5434\u6E56\u5E06\u5C71\u6C34\u4ECE\u8463\u5176\u660C\u3001\u201C\u56DB\u738B\u201D\u51FA\uFF0C\u65E9\u671F\u4F5C\u54C1\u53D7\u5230\u7684\u5F71\u54CD\u5C24\u6DF1\u3002\u6B64\u56FE\u4F5C\u4E8E 1932\u5E74\uFF0C\u5434\u6E56\u5E06\u65F6\u5E74\u4E09\u5341\u4E5D\u5C81\uFF0C\u6B63\u662F\u5176\u5C71\u6C34\u753B\u6CD5\u53D1\u751F\u53D8\u5316\uFF0C\u9010\u6E10\u5F62\u6210\u81EA\u8EAB\u98CE\u683C\u7684\u65F6\u671F\u3002\u6B64\u56FE\u867D\u4E91\u5B66\u8463\u5176\u660C</p><p>\u4E0E\u738B\u9274\uFF0C\u5176\u6784\u56FE\u5E03\u666F\u3001\u5C71\u77F3\u5F62\u8C8C\u4E5F\u786E\u662F\u534E\u4EAD\u3001\u201C\u56DB\u738B\u201D\u5BB6\u6CD5\uFF0C\u4F46\u5176\u7B14\u58A8\u5374\u5DF2\u53D8\u8463\u3001\u738B\u4E4B\u6E05\u900F\u800C\u4E3A\u8174\u79C0\uFF0C\u5316\u751F\u62D9\u4E3A\u7EF5\u539A\uFF0C\u5434\u6C0F\u9762\u8C8C\u5DF2\u7136\u547C\u4E4B\u6B32\u51FA\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-73413-1.jpg"],
                points: []
            }
        ]
    },
    "pen2-75947": {
        caption: "\u5434\u6E56\u5E06 \u6885\u82B1\u56FE\u6247\u9875",
        thumbnail: $johf1["pen2-75947-0.jpg"],
        description: "<p>\u6C11\u56FD\u4E8C\u5341\u5E74\uFF081931\uFF09</p><p>\u7EB8\u672C \u6C34\u58A8/\u8BBE\u8272</p><p>\u5434\u6E56\u5E06\u658B\u53F7\u201C\u6885\u666F\u4E66\u5C4B\u201D\uFF0C\u5176\u4E0E\u6885\u82B1\u6709\u5173\u7684\u6700\u8457\u540D\u85CF\u54C1\u662F\u5B8B\u523B\u300A\u6885\u82B1\u559C\u795E\u8C31\u300B\u3002\u9664\u6B64\u4E4B\u5916\uFF0C\u5434\u6E56\u5E06\u4EA6\u7559\u610F\u6536\u85CF\u53E4\u4ECA\u753B\u5BB6\u7684\u6885\u82B1\u4F5C\u54C1\uFF0C\u81EA\u5DF1\u4E5F\u559C\u4F5C\u6885\u82B1\u3002\u6B64\u56DB\u5F00\u6885\u82B1\u6247\u9762\u662F\u5434\u6E56\u5E06\u4E3A\u53CB\u670B\u6240\u4F5C\uFF0C\u4E24\u5F00\u6C34\u58A8\uFF0C\u7B14\u58A8\u6E05\u96C5\u4E2D\u89C1\u6C89\u8174\uFF1B\u4E24\u5F00\u8BBE\u8272\uFF0C\u8272\u6CFD\u660E\u51C0\u4E2D\u89C1\u5A07\u7F8E\u3002\u6BCF\u5F00\u5206\u522B\u914D\u9898\u59DC\u5914\u3001\u5468\u90A6\u5F66\u3001\u53F2\u8FBE\u7956\u3001\u5434\u6587\u82F1\u6885\u82B1\u8BCD\u4E00\u53E5\uFF0C\u867D\u4E3A\u5C0F\u54C1\uFF0C\u4EA6\u53EF\u89C1\u5176\u5320\u5FC3\u4E0E\u6587\u5FC3\u3002\u6B64\u56FE\u4F5C\u4E8E1931\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E09\u5341\u516B\u5C81\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-75947-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen2-75947-2.jpg"],
                points: []
            },
            {
                url: $johf1["pen2-75947-3.jpg"],
                points: []
            },
            {
                url: $johf1["pen2-75947-4.jpg"],
                points: []
            }
        ]
    },
    "pen2-78124": {
        caption: "\u5434\u6E56\u5E06 \u5199\u5C0F\u65B9\u58F6\u77F3\u50CF\u8F74",
        thumbnail: $johf1["pen2-78124-0.jpg"],
        description: "<p>\u8F9B\u536F\uFF081951\uFF09</p><p>\u7EB8\u672C \u8BBE\u8272</p><p>\u738B\u4E00\u5E73\u6350\u8D60</p><p>\u56FE\u7ED8\u5C0F\u65B9\u58F6\u77F3\uFF0C\u8272\u5F69\u96C5\u4E3D\uFF0C\u6829\u6829\u5982\u751F\u3002\u6B64\u56FE\u4F5C\u4E8E1951\u5E74\uFF0C\u4F5C\u8005\u65F6\u5E74\u4E94\u5341\u516B\u5C81\u3002\u6B64\u56FE\u7ECF\u738B\u4E00\u5E73\uFF081914-2007\uFF0C\u66FE\u4EFB\u4E2D\u5171\u4E0A\u6D77\u5E02\u59D4\u4E66\u8BB0\uFF09\u9274\u85CF\u3002</p>",
        slides: [
            {
                url: $johf1["pen2-78124-1.jpg"],
                points: []
            },
            {
                url: $johf1["pen2-78124-2.jpg"],
                points: [
                    {
                        x: 1737,
                        y: 165,
                        content: "<p>\u738B\u4E00\u5E73\u6350\u8D60</p><p>\u9AD8\u51E4\u7FF0\uFF081683-1748\uFF09\uFF0C\u5B57\u897F\u56ED\uFF0C\u53F7\u5357\u6751\uFF0C\u665A\u53F7\u5357\u961C\uFF0C\u5C71\u4E1C\u80F6\u53BF\u4EBA\u3002</p><p>\u6B64\u77F3\u5C5E\u77F3\u82F1\u7802\u5CA9\u7C7B\uFF0C\u4F5C\u5C71\u5F62\uFF0C\u4E0A\u523B\u201C\u5C0F\u65B9\u58F6\u201D\u548C\u8349\u4E66\u201C\u4E19\u5BC5\u79CB\u65E5\u5357\u961C\u5DE6\u624B\u5236\u201D\u3002\u5E95\u5EA7\u4E0A\u6709\u201C\u5B8B\u5751\u5C0F\u65B9\u58F6\u201D\u540D\uFF0C\u5E76\u9898\u523B\u201C\u5357\u961C\u65E7\u85CF\u5C0F\u65B9\u58F6\uFF0C\u77F3\u6D53\u7FE0\u6B32\u6EF4\uFF0C\u5B8B\u5751\u4E2D\u5947\u54C1\u4E5F\uFF0C\u955C\u5858\u5144\u83B7\u4E4B\uFF0C\u4E3A\u6570\u9752\u8349\u5802\u76CA\u53CB\u3002\u8F9B\u536F\u51AC\uFF0C\u5434\u6E56\u5E06\u9898\u201D\u3002\u53EF\u77E5\u6B64\u77F3\u539F\u4E3A\u9AD8\u51E4\u7FF0\u6536\u85CF\uFF0C\u540E\u4E3A\u6536\u85CF\u5BB6\u94B1\u955C\u5858\u6240\u83B7\u3002</p>"
                    }
                ]
            }
        ]
    },
    extra: {
        home1: {
            toHomeBtn: (/*@__PURE__*/$parcel$interopDefault($9UqMq)),
            caption: "\u5434\u5927\u6F82\uFF081835\uFF5E1902\uFF09",
            description: "<p>\u521D\u540D\u5927\u6DF3\uFF0C\u5B57\u6B62\u656C\uFF0C\u53C8\u5B57\u6E05\u537F\uFF0C\u53F7\u6052\u8F69\uFF0C\u665A\u5E74\u53C8\u53F7\u6119\u658B\uFF0C\u6C5F\u82CF\u7701\u5434\u53BF\uFF08\u4ECA\u6C5F\u82CF\u82CF\u5DDE\uFF09\u4EBA\u3002\u6E05\u4EE3\u5B66\u8005\u3001\u91D1\u77F3\u5B66\u5BB6\u3001\u4E66\u753B\u5BB6\uFF0C\u66FE\u4EFB\u5E7F\u4E1C\u3001\u6E56\u5357\u5DE1\u629A\uFF0C\u8457\u6709\u300A\u8BF4\u6587\u53E4\u7C40\u8865\u300B\u3001\u300A\u53E4\u7389\u56FE\u8003\u300B\u3001\u300A\u6743\u8861\u5EA6\u91CF\u8003\u300B\u3001\u300A\u6119\u658B\u96C6\u53E4\u5F55\u300B\u3001\u300A\u6052\u8F69\u6240\u89C1\u6240\u85CF\u5409\u91D1\u5F55\u300B\u3001\u300A\u6119\u658B\u6587\u96C6\u300B\u7B49\u3002</p>"
        },
        home2: {
            toHomeBtn: (/*@__PURE__*/$parcel$interopDefault($9UqMq)),
            caption: "\u6C88\u6811\u955B",
            description: "<p>\u53F7\u97F5\u521D\u3002\u5DDD\u6C99\u57CE\u9547\u4EBA\u3002\u6E05\u54B8\u4E30\u4E5D\u5E74\uFF081859\u5E74\uFF09\u4E2D\u4E3E\u3002\u535A\u5B66\u591A\u624D\uFF0C\u5B98\u81F3\u5185\u9601\u4E2D\u4E66\u3002\u55DC\u91D1\u77F3\u3001\u7891\u5E16\u3001\u4E66\u753B\uFF0C\u5584\u9274\u5B9A\u3001\u6536\u85CF\u751A\u5BCC\uFF0C\u4EA6\u4F5C\u4E66\u753B\u3002\u7891\u7248\u6587\u5B57\u8003\u8BA2\u7CBE\u8F9F\uFF0C\u6240\u85CF\u79D8\u7C4D\u73CD\u672C\u6781\u4E30\uFF0C\u6709\u201C\u5BCC\u7532\u4E1C\u5357\u201D\u4E4B\u8A89\u3002</p>"
        },
        home3: {
            toHomeBtn: (/*@__PURE__*/$parcel$interopDefault($9UqMq)),
            caption: "\u6F58\u7956\u836B\uFF081830\uFF5E1890\u5E74\uFF09",
            description: "<p>\u5B57\u4F2F\u5BC5\uFF0C\u6E05\u4EE3\u82CF\u5DDE\u5E9C\u5434\u53BF\u4EBA\u3002\u54B8\u4E30\u4E8C\u5E74\uFF081852\uFF09\u58EC\u5B50\u79D1\u63A2\u82B1\uFF0C\u6388\u7FF0\u6797\u9662\u7F16\u4FEE\uFF0C\u5386\u4EFB\u5211\u90E8\u3001\u5DE5\u90E8\u5C1A\u4E66\uFF0C\u5B98\u81F3\u519B\u673A\u5927\u81E3\u3002</p><p>\u6F58\u7956\u836B\u81EA\u5E7C\u6D89\u730E\u767E\u5BB6\uFF0C\u7CBE\u901A\u7ECF\u53F2\uFF0C\u5DE5\u4E66\u6CD5\uFF0C\u597D\u6536\u85CF\uFF0C\u5C24\u55DC\u4E66\u753B\u3001\u7248\u672C\u548C\u91D1\u77F3\u3002\u4ED6\u8FD8\u662F\u4F4D\u91D1\u77F3\u3001\u7248\u672C\u5B66\u5BB6\uFF0C\u66FE\u8F91\u6709\u300A\u6500\u53E4\u697C\u91D1\u77F3\u6B3E\u8BC6\u300B\u4E8C\u5377\uFF0C\u5E76\u8457\u6210\u300A\u6EC2\u559C\u658B\u8BFB\u4E66\u8BB0\u300B\u4E8C\u5377\uFF0C\u300A\u6EC2\u559C\u658B\u5B8B\u5143\u672C\u4E66\u76EE\u300B\u4E00\u5377\uFF0C\u66FE\u520A\u6709\u300A\u6EC2\u559C\u658B\u4E1B\u4E66\u300B\u3001\u300A\u529F\u987A\u5802\u4E1B\u4E66\u300B\u3002</p>"
        },
        home4: {
            toHomeBtn: (/*@__PURE__*/$parcel$interopDefault($9UqMq)),
            caption: "\u5434\u6E56\u5E06\uFF081894-1968\uFF09",
            description: "<p>\u521D\u540D\u7FFC\u71D5\uFF0C\u5B57\u9079\u9A8F\uFF0C\u540E\u66F4\u540D\u4E07\uFF0C\u5B57\u4E1C\u5E84\uFF0C\u522B\u7F72\u4E11\u7C03\uFF0C\u53C8\u6539\u540D\u5029\uFF0C\u5B57\u5029\u5EB5\uFF0C\u4E66\u753B\u7F72\u540D\u6E56\u5E06\uFF0C\u658B\u540D\u201C\u6885\u666F\u4E66\u5C4B\u201D\uFF0C\u82CF\u5DDE\u4EBA\u3002\u6F58\u9759\u6DD1\uFF081892-1939\uFF09\uFF0C\u540D\u6811\u6625\uFF0C\u5434\u6E56\u5E06\u592B\u4EBA\u3002</p>"
        },
        sight: {
            toHomeBtn: (/*@__PURE__*/$parcel$interopDefault($9UqMq)),
            caption: "\u773C\u5149\u4E0E\u8BC6\u89C1",
            description: ""
        }
    }
};
(0, (/*@__PURE__*/$parcel$interopDefault($hyTiP))).forIn($f7d5b29e53d61229$var$data, function(v, k) {
    if (v.references) $f7d5b29e53d61229$var$data[k] = $f7d5b29e53d61229$var$data[v.references];
});
var $f7d5b29e53d61229$export$2e2bcd8739ae039 = $f7d5b29e53d61229$var$data;

});
parcelRegister("johf1", function(module, exports) {

var $1rR3P = parcelRequire("1rR3P");

var $6ABRQ = parcelRequire("6ABRQ");

var $gCfaO = parcelRequire("gCfaO");

var $73N3n = parcelRequire("73N3n");

var $9LPhg = parcelRequire("9LPhg");

var $hQBsA = parcelRequire("hQBsA");

var $ircuq = parcelRequire("ircuq");

var $4eaBy = parcelRequire("4eaBy");

var $1NwPa = parcelRequire("1NwPa");

var $2sxIS = parcelRequire("2sxIS");

var $eR2Ju = parcelRequire("eR2Ju");

var $lFc41 = parcelRequire("lFc41");

var $likMZ = parcelRequire("likMZ");

var $89Tof = parcelRequire("89Tof");

var $1k9ew = parcelRequire("1k9ew");

var $byfTx = parcelRequire("byfTx");

var $aF0SG = parcelRequire("aF0SG");

var $cuzmR = parcelRequire("cuzmR");

var $2ZHsa = parcelRequire("2ZHsa");

var $2chDU = parcelRequire("2chDU");

var $gMNtC = parcelRequire("gMNtC");

var $c3D4e = parcelRequire("c3D4e");

var $gqE1h = parcelRequire("gqE1h");

var $fND9t = parcelRequire("fND9t");

var $f8zBY = parcelRequire("f8zBY");

var $cKIkz = parcelRequire("cKIkz");

var $80H1K = parcelRequire("80H1K");

var $dukS5 = parcelRequire("dukS5");

var $7aB5n = parcelRequire("7aB5n");

var $a87gl = parcelRequire("a87gl");

var $2nR7f = parcelRequire("2nR7f");

var $2yjIs = parcelRequire("2yjIs");

var $2AUSr = parcelRequire("2AUSr");

var $kLqsR = parcelRequire("kLqsR");

var $j0RPi = parcelRequire("j0RPi");

var $7mnfo = parcelRequire("7mnfo");

var $aXvx1 = parcelRequire("aXvx1");

var $8gqEP = parcelRequire("8gqEP");

var $gBIBW = parcelRequire("gBIBW");

var $5hCLD = parcelRequire("5hCLD");

var $7YEfJ = parcelRequire("7YEfJ");

var $c7UdW = parcelRequire("c7UdW");

var $7LlPF = parcelRequire("7LlPF");

var $cBWXi = parcelRequire("cBWXi");

var $gdSXe = parcelRequire("gdSXe");

var $gcOXs = parcelRequire("gcOXs");

var $jS4UN = parcelRequire("jS4UN");

var $dFWKF = parcelRequire("dFWKF");

var $beODY = parcelRequire("beODY");

var $efr8z = parcelRequire("efr8z");

var $2Vp5Q = parcelRequire("2Vp5Q");

var $b5Qs1 = parcelRequire("b5Qs1");

var $3BhDV = parcelRequire("3BhDV");

var $4SlWS = parcelRequire("4SlWS");

var $6gxSo = parcelRequire("6gxSo");

var $3jBSP = parcelRequire("3jBSP");

var $kT5mF = parcelRequire("kT5mF");

var $4SQmg = parcelRequire("4SQmg");

var $6QufH = parcelRequire("6QufH");

var $kShnH = parcelRequire("kShnH");

var $2QUnt = parcelRequire("2QUnt");

var $czmLI = parcelRequire("czmLI");

var $1wdCh = parcelRequire("1wdCh");

var $5I8gY = parcelRequire("5I8gY");

var $cCHwt = parcelRequire("cCHwt");

var $aMbfU = parcelRequire("aMbfU");

var $kGGJH = parcelRequire("kGGJH");

var $8cDzg = parcelRequire("8cDzg");

var $37mGl = parcelRequire("37mGl");

var $kxi1h = parcelRequire("kxi1h");

var $ic5Rf = parcelRequire("ic5Rf");

var $aoW3W = parcelRequire("aoW3W");

var $8mTmB = parcelRequire("8mTmB");

var $cOsjb = parcelRequire("cOsjb");

var $9JQ7l = parcelRequire("9JQ7l");

var $2xYXJ = parcelRequire("2xYXJ");

var $AFoeg = parcelRequire("AFoeg");

var $2TLi5 = parcelRequire("2TLi5");

var $dmUnZ = parcelRequire("dmUnZ");

var $9OnCZ = parcelRequire("9OnCZ");

var $6FmY5 = parcelRequire("6FmY5");

var $cUwqu = parcelRequire("cUwqu");

var $eqwfS = parcelRequire("eqwfS");

var $444tx = parcelRequire("444tx");

var $6Kcd7 = parcelRequire("6Kcd7");

var $dAaUr = parcelRequire("dAaUr");

var $4jnSc = parcelRequire("4jnSc");

var $88DuS = parcelRequire("88DuS");

var $v748g = parcelRequire("v748g");

var $gsbMZ = parcelRequire("gsbMZ");

var $eggqP = parcelRequire("eggqP");

var $8IuIZ = parcelRequire("8IuIZ");

var $fbeXo = parcelRequire("fbeXo");

var $bYvmr = parcelRequire("bYvmr");

var $8adLw = parcelRequire("8adLw");

var $aaCKw = parcelRequire("aaCKw");

var $dJJuY = parcelRequire("dJJuY");

var $iqWr1 = parcelRequire("iqWr1");

var $1IxW9 = parcelRequire("1IxW9");

var $7o9Ul = parcelRequire("7o9Ul");

var $eiA8E = parcelRequire("eiA8E");

var $2l18z = parcelRequire("2l18z");

var $h5rKg = parcelRequire("h5rKg");

var $kwGUa = parcelRequire("kwGUa");

var $dx0o6 = parcelRequire("dx0o6");

var $bBAmS = parcelRequire("bBAmS");

var $6wwuW = parcelRequire("6wwuW");

var $hhK4S = parcelRequire("hhK4S");

var $bXdjk = parcelRequire("bXdjk");

var $gjmde = parcelRequire("gjmde");

var $3rULa = parcelRequire("3rULa");

var $5RexM = parcelRequire("5RexM");

var $cCXR1 = parcelRequire("cCXR1");

var $03duD = parcelRequire("03duD");

var $hQo7R = parcelRequire("hQo7R");

var $2MrDj = parcelRequire("2MrDj");

var $7yIdZ = parcelRequire("7yIdZ");

var $eybJG = parcelRequire("eybJG");

var $9Osm1 = parcelRequire("9Osm1");

var $d8La6 = parcelRequire("d8La6");

var $5jQci = parcelRequire("5jQci");

var $3qAzE = parcelRequire("3qAzE");

var $4XKp9 = parcelRequire("4XKp9");

var $2nHYP = parcelRequire("2nHYP");

var $17LkS = parcelRequire("17LkS");

var $aX5yG = parcelRequire("aX5yG");

var $7bROg = parcelRequire("7bROg");

var $6RDaF = parcelRequire("6RDaF");

var $2yofo = parcelRequire("2yofo");

var $jDU34 = parcelRequire("jDU34");

var $bIFRt = parcelRequire("bIFRt");

var $lK5Gw = parcelRequire("lK5Gw");

var $aO3Yz = parcelRequire("aO3Yz");

var $e1N59 = parcelRequire("e1N59");

var $ksmPC = parcelRequire("ksmPC");

var $kWhyr = parcelRequire("kWhyr");

var $bZFIC = parcelRequire("bZFIC");

var $iLX5O = parcelRequire("iLX5O");

var $8NOxn = parcelRequire("8NOxn");

var $j00rP = parcelRequire("j00rP");

var $eqhmb = parcelRequire("eqhmb");

var $jCx7v = parcelRequire("jCx7v");

var $7wjtj = parcelRequire("7wjtj");

var $q5kfj = parcelRequire("q5kfj");

var $jWyGo = parcelRequire("jWyGo");

var $8GWKF = parcelRequire("8GWKF");

var $2sBW4 = parcelRequire("2sBW4");

var $5zk60 = parcelRequire("5zk60");

var $ccZ1E = parcelRequire("ccZ1E");

var $5xicv = parcelRequire("5xicv");

var $auNNO = parcelRequire("auNNO");

var $7ueUy = parcelRequire("7ueUy");

var $5h1D2 = parcelRequire("5h1D2");

var $87Yj2 = parcelRequire("87Yj2");

var $4jlDv = parcelRequire("4jlDv");

var $3XDEk = parcelRequire("3XDEk");

var $hImkx = parcelRequire("hImkx");

var $88dVv = parcelRequire("88dVv");

var $1Bl2Y = parcelRequire("1Bl2Y");

var $kJBNc = parcelRequire("kJBNc");

var $2b9GB = parcelRequire("2b9GB");

var $eRxyQ = parcelRequire("eRxyQ");

var $7SmsT = parcelRequire("7SmsT");

var $5lChU = parcelRequire("5lChU");

var $enA0R = parcelRequire("enA0R");

var $ir7qT = parcelRequire("ir7qT");

var $lT9Nx = parcelRequire("lT9Nx");

var $ckfad = parcelRequire("ckfad");

var $7GNiz = parcelRequire("7GNiz");

var $9yv2b = parcelRequire("9yv2b");

var $33iAn = parcelRequire("33iAn");

var $27CZ3 = parcelRequire("27CZ3");

var $joykB = parcelRequire("joykB");

var $fhZyo = parcelRequire("fhZyo");

var $4Qxms = parcelRequire("4Qxms");

var $9O2Lb = parcelRequire("9O2Lb");

var $aU2nt = parcelRequire("aU2nt");

var $3wcRx = parcelRequire("3wcRx");

var $gQKGT = parcelRequire("gQKGT");

var $VR1uH = parcelRequire("VR1uH");

var $SovBX = parcelRequire("SovBX");

var $a9A9x = parcelRequire("a9A9x");

var $3cblz = parcelRequire("3cblz");

var $eNSZ8 = parcelRequire("eNSZ8");

var $3ECoS = parcelRequire("3ECoS");

var $9NFpn = parcelRequire("9NFpn");

var $6jSNg = parcelRequire("6jSNg");

var $iA9g4 = parcelRequire("iA9g4");

var $eXij7 = parcelRequire("eXij7");

var $ifcYi = parcelRequire("ifcYi");

var $9GH9a = parcelRequire("9GH9a");

var $hGuaV = parcelRequire("hGuaV");

var $b8oNu = parcelRequire("b8oNu");

var $8py4l = parcelRequire("8py4l");

var $gETuy = parcelRequire("gETuy");

var $g2r2B = parcelRequire("g2r2B");

var $d6POJ = parcelRequire("d6POJ");

var $bponE = parcelRequire("bponE");

var $9QAmz = parcelRequire("9QAmz");

var $dsOvN = parcelRequire("dsOvN");

var $em1lw = parcelRequire("em1lw");

var $k5dAv = parcelRequire("k5dAv");

var $jCkFq = parcelRequire("jCkFq");

var $e0s6D = parcelRequire("e0s6D");

var $dihlM = parcelRequire("dihlM");

var $erSjq = parcelRequire("erSjq");

var $bnCrZ = parcelRequire("bnCrZ");

var $ekdhu = parcelRequire("ekdhu");

var $lNpsh = parcelRequire("lNpsh");

var $dysyG = parcelRequire("dysyG");

var $6DVXn = parcelRequire("6DVXn");

var $dhrQq = parcelRequire("dhrQq");

var $jC5zD = parcelRequire("jC5zD");

var $cpGa3 = parcelRequire("cpGa3");

var $j7w1Z = parcelRequire("j7w1Z");

var $8xdRz = parcelRequire("8xdRz");

var $13z5Y = parcelRequire("13z5Y");

var $kuBwa = parcelRequire("kuBwa");

var $h0r6M = parcelRequire("h0r6M");

var $cXWmz = parcelRequire("cXWmz");

var $6btdl = parcelRequire("6btdl");

var $6o0Cl = parcelRequire("6o0Cl");

var $bgcVU = parcelRequire("bgcVU");

var $7yeWR = parcelRequire("7yeWR");

var $gaXcR = parcelRequire("gaXcR");

var $5Jb4S = parcelRequire("5Jb4S");

var $aUKDh = parcelRequire("aUKDh");

var $2kiEa = parcelRequire("2kiEa");

var $l2O0u = parcelRequire("l2O0u");

var $78lGe = parcelRequire("78lGe");

var $gwak9 = parcelRequire("gwak9");

var $5lNbv = parcelRequire("5lNbv");

var $2hRfo = parcelRequire("2hRfo");

var $8j8i1 = parcelRequire("8j8i1");

var $bPLkT = parcelRequire("bPLkT");

var $b4h5S = parcelRequire("b4h5S");

var $cxyf0 = parcelRequire("cxyf0");

var $5fPJF = parcelRequire("5fPJF");

var $yl9Bf = parcelRequire("yl9Bf");

var $dzcY9 = parcelRequire("dzcY9");

var $5wVJR = parcelRequire("5wVJR");

var $ifsQ0 = parcelRequire("ifsQ0");

var $6ocXz = parcelRequire("6ocXz");

var $6Wozp = parcelRequire("6Wozp");

var $8JbJi = parcelRequire("8JbJi");

var $6047g = parcelRequire("6047g");

var $7BYLj = parcelRequire("7BYLj");

var $eYFd8 = parcelRequire("eYFd8");

var $jar7r = parcelRequire("jar7r");

var $iHESA = parcelRequire("iHESA");

var $f4IEa = parcelRequire("f4IEa");

var $9DXCb = parcelRequire("9DXCb");

var $iqARd = parcelRequire("iqARd");

var $c3yW3 = parcelRequire("c3yW3");

var $3GBRP = parcelRequire("3GBRP");

var $2N1go = parcelRequire("2N1go");

var $j1IhL = parcelRequire("j1IhL");

var $45su8 = parcelRequire("45su8");

var $337rU = parcelRequire("337rU");

var $9Tj7A = parcelRequire("9Tj7A");

var $jut4w = parcelRequire("jut4w");

var $6AjDG = parcelRequire("6AjDG");

var $82LYH = parcelRequire("82LYH");

var $lg52c = parcelRequire("lg52c");

var $kiy7M = parcelRequire("kiy7M");

var $Jlq5R = parcelRequire("Jlq5R");

var $2htVZ = parcelRequire("2htVZ");

var $3GcR5 = parcelRequire("3GcR5");

var $eiAam = parcelRequire("eiAam");

var $dZE8e = parcelRequire("dZE8e");

var $7yg54 = parcelRequire("7yg54");

var $jCMHf = parcelRequire("jCMHf");

var $bcgtY = parcelRequire("bcgtY");

var $5SSjN = parcelRequire("5SSjN");

var $gln6L = parcelRequire("gln6L");

var $eW2ed = parcelRequire("eW2ed");

var $cSGmy = parcelRequire("cSGmy");

var $t086i = parcelRequire("t086i");

var $axGks = parcelRequire("axGks");

var $iClop = parcelRequire("iClop");

var $flWUF = parcelRequire("flWUF");

var $dyPKw = parcelRequire("dyPKw");

var $9D0N5 = parcelRequire("9D0N5");

var $lGzaH = parcelRequire("lGzaH");

var $2ni6A = parcelRequire("2ni6A");

var $xf4t3 = parcelRequire("xf4t3");

var $k1aO7 = parcelRequire("k1aO7");

var $3xuUi = parcelRequire("3xuUi");

var $eaj5f = parcelRequire("eaj5f");

var $4hx9m = parcelRequire("4hx9m");

var $8nIzB = parcelRequire("8nIzB");

var $5oXmG = parcelRequire("5oXmG");

var $hNSCE = parcelRequire("hNSCE");

var $b1nyJ = parcelRequire("b1nyJ");

var $eknCS = parcelRequire("eknCS");

var $edbnv = parcelRequire("edbnv");

var $7WvKB = parcelRequire("7WvKB");

var $egZ7s = parcelRequire("egZ7s");

var $NxMmD = parcelRequire("NxMmD");

var $hepu1 = parcelRequire("hepu1");

var $5oIry = parcelRequire("5oIry");

var $9Vw7y = parcelRequire("9Vw7y");

var $296tr = parcelRequire("296tr");

var $3XfKF = parcelRequire("3XfKF");

var $l4BYf = parcelRequire("l4BYf");

var $4D3KT = parcelRequire("4D3KT");

var $d7BYn = parcelRequire("d7BYn");

var $e1arP = parcelRequire("e1arP");

var $eV3IU = parcelRequire("eV3IU");

var $5HZnK = parcelRequire("5HZnK");

var $9Rj0w = parcelRequire("9Rj0w");

var $6tO56 = parcelRequire("6tO56");

var $8YLEs = parcelRequire("8YLEs");

var $bdHb7 = parcelRequire("bdHb7");

var $6nApc = parcelRequire("6nApc");

var $eAhbH = parcelRequire("eAhbH");

var $jJKXJ = parcelRequire("jJKXJ");

var $bxnOn = parcelRequire("bxnOn");

var $01fzV = parcelRequire("01fzV");

var $1RFDO = parcelRequire("1RFDO");

var $jYZK2 = parcelRequire("jYZK2");

var $6CJda = parcelRequire("6CJda");

var $cmNYu = parcelRequire("cmNYu");

var $bNGde = parcelRequire("bNGde");

var $im0FW = parcelRequire("im0FW");

var $5gKHz = parcelRequire("5gKHz");

var $eOYwi = parcelRequire("eOYwi");

var $8DHIL = parcelRequire("8DHIL");

var $9lIZD = parcelRequire("9lIZD");

var $bRGTg = parcelRequire("bRGTg");

var $4WV4L = parcelRequire("4WV4L");

var $9HTrt = parcelRequire("9HTrt");

var $kZeNj = parcelRequire("kZeNj");

var $lc4oM = parcelRequire("lc4oM");

var $dGU5x = parcelRequire("dGU5x");

var $4EUv7 = parcelRequire("4EUv7");

var $brTVG = parcelRequire("brTVG");

var $cBhNh = parcelRequire("cBhNh");

var $hdwVD = parcelRequire("hdwVD");

var $96Zr9 = parcelRequire("96Zr9");

var $iREtf = parcelRequire("iREtf");

var $dPQfT = parcelRequire("dPQfT");

var $9jiQw = parcelRequire("9jiQw");

var $lB9r4 = parcelRequire("lB9r4");

var $fr0U3 = parcelRequire("fr0U3");

var $kFi32 = parcelRequire("kFi32");

var $cHPWf = parcelRequire("cHPWf");

var $5ulUW = parcelRequire("5ulUW");

var $3DkIO = parcelRequire("3DkIO");

var $4NAgg = parcelRequire("4NAgg");

var $e9YWh = parcelRequire("e9YWh");

var $kEt6c = parcelRequire("kEt6c");

var $cH8up = parcelRequire("cH8up");

var $7iB1D = parcelRequire("7iB1D");

var $azYiL = parcelRequire("azYiL");

var $7YBvz = parcelRequire("7YBvz");

var $FUAeI = parcelRequire("FUAeI");

var $9RPPs = parcelRequire("9RPPs");

var $3FvtI = parcelRequire("3FvtI");

var $8FZ2X = parcelRequire("8FZ2X");

var $bl5P5 = parcelRequire("bl5P5");

var $bIpnO = parcelRequire("bIpnO");

var $4Pvry = parcelRequire("4Pvry");

var $ltq5h = parcelRequire("ltq5h");

var $jNVKZ = parcelRequire("jNVKZ");

var $lcmQO = parcelRequire("lcmQO");

var $8GNW2 = parcelRequire("8GNW2");

var $cl9wG = parcelRequire("cl9wG");

var $2fLCP = parcelRequire("2fLCP");

var $6xxbs = parcelRequire("6xxbs");

var $3Mkse = parcelRequire("3Mkse");

var $ghIKJ = parcelRequire("ghIKJ");

var $2EG7e = parcelRequire("2EG7e");

var $6vvWa = parcelRequire("6vvWa");

var $994kh = parcelRequire("994kh");

var $bCUjp = parcelRequire("bCUjp");

var $evC5K = parcelRequire("evC5K");

var $jAaC7 = parcelRequire("jAaC7");

var $FVXN2 = parcelRequire("FVXN2");

var $jYEYb = parcelRequire("jYEYb");

var $1uBow = parcelRequire("1uBow");

var $218js = parcelRequire("218js");

var $iwCX5 = parcelRequire("iwCX5");

var $k0Tqe = parcelRequire("k0Tqe");

var $cDJaL = parcelRequire("cDJaL");

var $gLNIR = parcelRequire("gLNIR");

var $1vfKK = parcelRequire("1vfKK");

var $jrbh7 = parcelRequire("jrbh7");

var $5I6WU = parcelRequire("5I6WU");

var $37OkM = parcelRequire("37OkM");

var $6xhEu = parcelRequire("6xhEu");

var $3RXN4 = parcelRequire("3RXN4");

var $RYb4Z = parcelRequire("RYb4Z");

var $gajLv = parcelRequire("gajLv");

var $hyE1H = parcelRequire("hyE1H");

var $lCbh2 = parcelRequire("lCbh2");

var $kTJ8M = parcelRequire("kTJ8M");

var $dXP0z = parcelRequire("dXP0z");

var $1BGYc = parcelRequire("1BGYc");

var $6gVmk = parcelRequire("6gVmk");

var $gI8Zc = parcelRequire("gI8Zc");

var $kNjLj = parcelRequire("kNjLj");

var $aBi1v = parcelRequire("aBi1v");

var $e9Z9n = parcelRequire("e9Z9n");

var $8qq6G = parcelRequire("8qq6G");

var $f7mp6 = parcelRequire("f7mp6");

var $gRSlt = parcelRequire("gRSlt");

var $1UqO3 = parcelRequire("1UqO3");

var $jgaoD = parcelRequire("jgaoD");

var $dad5E = parcelRequire("dad5E");

var $hqZPd = parcelRequire("hqZPd");

var $hmNgh = parcelRequire("hmNgh");

var $gEmg6 = parcelRequire("gEmg6");

var $lu1EP = parcelRequire("lu1EP");

var $iZrQ6 = parcelRequire("iZrQ6");

var $kgzuB = parcelRequire("kgzuB");

var $j9V9g = parcelRequire("j9V9g");

var $40oue = parcelRequire("40oue");

var $iu2BQ = parcelRequire("iu2BQ");

var $eBuOv = parcelRequire("eBuOv");

var $k5HbI = parcelRequire("k5HbI");

var $4P8K3 = parcelRequire("4P8K3");

var $99Paz = parcelRequire("99Paz");

var $j0VCL = parcelRequire("j0VCL");

var $9Y6Pz = parcelRequire("9Y6Pz");

var $d9uah = parcelRequire("d9uah");

var $bBybf = parcelRequire("bBybf");

var $5FNIB = parcelRequire("5FNIB");

var $dZbJL = parcelRequire("dZbJL");

var $57WVw = parcelRequire("57WVw");

var $16wAD = parcelRequire("16wAD");

var $6eVRc = parcelRequire("6eVRc");

var $b4BPn = parcelRequire("b4BPn");

var $1dQK4 = parcelRequire("1dQK4");

var $1qTRD = parcelRequire("1qTRD");

var $8DxyY = parcelRequire("8DxyY");

var $2Zh6g = parcelRequire("2Zh6g");

var $lw4k8 = parcelRequire("lw4k8");

var $62fLg = parcelRequire("62fLg");

var $i95Ru = parcelRequire("i95Ru");

var $44kiA = parcelRequire("44kiA");

var $hTkF2 = parcelRequire("hTkF2");

var $LHQKF = parcelRequire("LHQKF");

var $8cFzx = parcelRequire("8cFzx");

var $qeOHg = parcelRequire("qeOHg");

var $gL8KP = parcelRequire("gL8KP");

var $3pKG6 = parcelRequire("3pKG6");

var $hnPLd = parcelRequire("hnPLd");

var $d3xv8 = parcelRequire("d3xv8");

var $ca8Ml = parcelRequire("ca8Ml");

var $a1aTJ = parcelRequire("a1aTJ");

var $ihnh5 = parcelRequire("ihnh5");

var $kzWW6 = parcelRequire("kzWW6");

var $eYzuu = parcelRequire("eYzuu");

var $g7hjm = parcelRequire("g7hjm");

var $dx76w = parcelRequire("dx76w");

var $5X1ew = parcelRequire("5X1ew");

var $keeiy = parcelRequire("keeiy");
module.exports = {
    "home1-23561-0.jpg": $1rR3P,
    "home1-23561-1.jpg": $6ABRQ,
    "home1-2563-0.jpg": $gCfaO,
    "home1-2563-1.jpg": $73N3n,
    "home1-26397-0.jpg": $9LPhg,
    "home1-26397-1.jpg": $hQBsA,
    "home1-39416-0.jpg": $ircuq,
    "home1-39416-1.jpg": $4eaBy,
    "home1-45511-0.jpg": $1NwPa,
    "home1-45511-1.jpg": $2sxIS,
    "home1-45543-0.jpg": $eR2Ju,
    "home1-45543-1.jpg": $lFc41,
    "home1-45546-0.jpg": $likMZ,
    "home1-45546-1.jpg": $89Tof,
    "home1-45547-0.jpg": $1k9ew,
    "home1-45547-1.jpg": $byfTx,
    "home1-51064-0.jpg": $aF0SG,
    "home1-51064-1.jpg": $cuzmR,
    "home1-54630-0.jpg": $2ZHsa,
    "home1-54630-1.jpg": $2chDU,
    "home1-54633-0.jpg": $gMNtC,
    "home1-54633-1.jpg": $c3D4e,
    "home1-54646-0.jpg": $gqE1h,
    "home1-54646-1.jpg": $fND9t,
    "home1-54647-0.jpg": $f8zBY,
    "home1-54647-1.jpg": $cKIkz,
    "home1-54655-0.jpg": $80H1K,
    "home1-54655-1.jpg": $dukS5,
    "home1-64517-0.jpg": $7aB5n,
    "home1-64517-1.jpg": $a87gl,
    "home1-64644-0.jpg": $2nR7f,
    "home1-64644-1.jpg": $2yjIs,
    "home1-64745-0.jpg": $2AUSr,
    "home1-64745-1.jpg": $kLqsR,
    "home1-64771-0.jpg": $j0RPi,
    "home1-64771-1.jpg": $7mnfo,
    "home1-64777-0.jpg": $aXvx1,
    "home1-64777-1.jpg": $8gqEP,
    "home1-8108-0.jpg": $gBIBW,
    "home1-8108-1.jpg": $5hCLD,
    "home2-19951-0.jpg": $7YEfJ,
    "home2-19951-1.jpg": $c7UdW,
    "home2-2447-0.jpg": $7LlPF,
    "home2-2447-1.jpg": $cBWXi,
    "home2-2574-0.jpg": $gdSXe,
    "home2-2574-1.jpg": $gcOXs,
    "home2-45532-0.jpg": $jS4UN,
    "home2-45532-1.jpg": $dFWKF,
    "home2-51383-0.jpg": $beODY,
    "home2-51383-1.jpg": $efr8z,
    "home2-59917-0.jpg": $2Vp5Q,
    "home2-59917-1.jpg": $b5Qs1,
    "home2-59917-2.jpg": $3BhDV,
    "home2-59917-3.jpg": $4SlWS,
    "home2-59917-4.jpg": $6gxSo,
    "home2-59926-0.jpg": $3jBSP,
    "home2-59926-1.jpg": $kT5mF,
    "home2-65505-0.jpg": $4SQmg,
    "home2-65505-1.jpg": $6QufH,
    "home2-8882-0.jpg": $kShnH,
    "home2-8882-1.jpg": $2QUnt,
    "home3-15234-0.jpg": $czmLI,
    "home3-15234-1.jpg": $1wdCh,
    "home3-15235-0.jpg": $5I8gY,
    "home3-15235-1.jpg": $cCHwt,
    "home3-21806-0.jpg": $aMbfU,
    "home3-21806-1.jpg": $kGGJH,
    "home3-24306-0.jpg": $8cDzg,
    "home3-24306-1.jpg": $37mGl,
    "home3-2809-0.jpg": $kxi1h,
    "home3-2809-1.jpg": $ic5Rf,
    "home3-3183-0.jpg": $aoW3W,
    "home3-3183-1.jpg": $8mTmB,
    "home3-34693-0.jpg": $cOsjb,
    "home3-34693-1.jpg": $9JQ7l,
    "home3-35361-0.jpg": $2xYXJ,
    "home3-35361-1.jpg": $AFoeg,
    "home3-35389-0.jpg": $2TLi5,
    "home3-35389-1.jpg": $dmUnZ,
    "home3-41536-0.jpg": $9OnCZ,
    "home3-41536-1.jpg": $6FmY5,
    "home3-44047-0.jpg": $cUwqu,
    "home3-44047-1.jpg": $eqwfS,
    "home3-44048-0.jpg": $444tx,
    "home3-44048-1.jpg": $6Kcd7,
    "home3-59934-0.jpg": $dAaUr,
    "home3-59934-1.jpg": $4jnSc,
    "home3-8105-0.jpg": $88DuS,
    "home3-8105-1.jpg": $v748g,
    "home3-8106-0.jpg": $gsbMZ,
    "home3-8106-1.jpg": $eggqP,
    "home3-8107-0.jpg": $8IuIZ,
    "home3-8107-1.jpg": $fbeXo,
    "home4-45511-0.jpg": $bYvmr,
    "home4-45511-1.jpg": $8adLw,
    "home4-45532-0.jpg": $aaCKw,
    "home4-45532-1.jpg": $dJJuY,
    "home4-45534-0.jpg": $iqWr1,
    "home4-45534-1.jpg": $1IxW9,
    "home4-45534-2.jpg": $7o9Ul,
    "home4-45534-3.jpg": $eiA8E,
    "home4-45534-4.jpg": $2l18z,
    "home4-45534-5.jpg": $h5rKg,
    "home4-45534-6.jpg": $kwGUa,
    "home4-45534-7.jpg": $dx0o6,
    "home4-45534-8.jpg": $bBAmS,
    "home4-45534-9.jpg": $6wwuW,
    "home4-51064-0.jpg": $hhK4S,
    "home4-51064-1.jpg": $bXdjk,
    "home4-51079-0.jpg": $gjmde,
    "home4-51079-1.jpg": $3rULa,
    "home4-59917-0.jpg": $5RexM,
    "home4-59917-1.jpg": $cCXR1,
    "home4-59917-2.jpg": $03duD,
    "home4-59917-3.jpg": $hQo7R,
    "home4-59917-4.jpg": $2MrDj,
    "home4-59926-0.jpg": $7yIdZ,
    "home4-59926-1.jpg": $eybJG,
    "home4-59926-2.jpg": $9Osm1,
    "home4-59926-3.jpg": $d8La6,
    "home4-59926-4.jpg": $5jQci,
    "home4-64745-0.jpg": $3qAzE,
    "home4-64745-1.jpg": $4XKp9,
    "home4-64771-0.jpg": $2nHYP,
    "home4-64771-1.jpg": $17LkS,
    "home4-64771-10.jpg": $aX5yG,
    "home4-64771-11.jpg": $7bROg,
    "home4-64771-12.jpg": $6RDaF,
    "home4-64771-13.jpg": $2yofo,
    "home4-64771-2.jpg": $jDU34,
    "home4-64771-3.jpg": $bIFRt,
    "home4-64771-4.jpg": $lK5Gw,
    "home4-64771-5.jpg": $aO3Yz,
    "home4-64771-6.jpg": $e1N59,
    "home4-64771-7.jpg": $ksmPC,
    "home4-64771-8.jpg": $kWhyr,
    "home4-64771-9.jpg": $bZFIC,
    "home4-64777-0.jpg": $iLX5O,
    "home4-64777-1.jpg": $8NOxn,
    "home4-64777-2.jpg": $j00rP,
    "life1-19800-0.jpg": $eqhmb,
    "life1-19800-1.jpg": $jCx7v,
    "life1-19800-2.jpg": $7wjtj,
    "life1-19800-3.jpg": $q5kfj,
    "life1-19944-0.jpg": $jWyGo,
    "life1-19944-1.jpg": $8GWKF,
    "life1-20015-0.jpg": $2sBW4,
    "life1-20015-1.jpg": $5zk60,
    "life1-31912-0.jpg": $ccZ1E,
    "life1-31912-1.jpg": $5xicv,
    "life1-3310-0.jpg": $auNNO,
    "life1-3310-1.jpg": $7ueUy,
    "life1-45513-0.jpg": $5h1D2,
    "life1-45513-1.jpg": $87Yj2,
    "life1-45517-0.jpg": $4jlDv,
    "life1-45517-1.jpg": $3XDEk,
    "life1-45526-0.jpg": $hImkx,
    "life1-45526-1.jpg": $88dVv,
    "life1-45526-2.jpg": $1Bl2Y,
    "life1-45526-3.jpg": $kJBNc,
    "life1-45526-4.jpg": $2b9GB,
    "life1-45526-5.jpg": $eRxyQ,
    "life1-45526-6.jpg": $7SmsT,
    "life1-45530-0.jpg": $5lChU,
    "life1-45530-1.jpg": $enA0R,
    "life1-45531-0.jpg": $ir7qT,
    "life1-45531-1.jpg": $lT9Nx,
    "life1-45531-10.jpg": $ckfad,
    "life1-45531-11.jpg": $7GNiz,
    "life1-45531-12.jpg": $9yv2b,
    "life1-45531-2.jpg": $33iAn,
    "life1-45531-3.jpg": $27CZ3,
    "life1-45531-4.jpg": $joykB,
    "life1-45531-5.jpg": $fhZyo,
    "life1-45531-6.jpg": $4Qxms,
    "life1-45531-7.jpg": $9O2Lb,
    "life1-45531-8.jpg": $aU2nt,
    "life1-45531-9.jpg": $3wcRx,
    "life1-45539-0.jpg": $gQKGT,
    "life1-45539-1.jpg": $VR1uH,
    "life1-50258-0.jpg": $SovBX,
    "life1-50258-1.jpg": $a9A9x,
    "life1-50258-10.jpg": $3cblz,
    "life1-50258-2.jpg": $eNSZ8,
    "life1-50258-3.jpg": $3ECoS,
    "life1-50258-4.jpg": $9NFpn,
    "life1-50258-5.jpg": $6jSNg,
    "life1-50258-6.jpg": $iA9g4,
    "life1-50258-7.jpg": $eXij7,
    "life1-50258-8.jpg": $ifcYi,
    "life1-50258-9.jpg": $9GH9a,
    "life1-6662-0.jpg": $hGuaV,
    "life1-6662-1.jpg": $b8oNu,
    "life1-8815-0.jpg": $8py4l,
    "life1-8815-1.jpg": $gETuy,
    "life2-31536-0.jpg": $g2r2B,
    "life2-31536-1.jpg": $d6POJ,
    "life2-31601-0.jpg": $bponE,
    "life2-31601-1.jpg": $9QAmz,
    "life2-39393-0.jpg": $dsOvN,
    "life2-39393-1.jpg": $em1lw,
    "life2-45516-0.jpg": $k5dAv,
    "life2-45516-1.jpg": $jCkFq,
    "life2-45520-0.jpg": $e0s6D,
    "life2-45520-1.jpg": $dihlM,
    "life2-45520-2.jpg": $erSjq,
    "life2-45527-0.jpg": $bnCrZ,
    "life2-45527-1.jpg": $ekdhu,
    "life2-47219-0.jpg": $lNpsh,
    "life2-47219-1.jpg": $dysyG,
    "life2-47219-2.jpg": $6DVXn,
    "life2-47219-3.jpg": $dhrQq,
    "life2-47219-4.jpg": $jC5zD,
    "life2-47219-5.jpg": $cpGa3,
    "life2-47219-6.jpg": $j7w1Z,
    "life2-47219-7.jpg": $8xdRz,
    "life2-47219-8.jpg": $13z5Y,
    "life2-47219-9.jpg": $kuBwa,
    "life2-51061-0.jpg": $h0r6M,
    "life2-51061-1.jpg": $cXWmz,
    "life2-59917-0.jpg": $6btdl,
    "life2-59917-1.jpg": $6o0Cl,
    "life2-59917-2.jpg": $bgcVU,
    "life2-59917-3.jpg": $7yeWR,
    "life3-19334-0.jpg": $gaXcR,
    "life3-19334-1.jpg": $5Jb4S,
    "life3-35731-0.jpg": $aUKDh,
    "life3-35731-1.jpg": $2kiEa,
    "life3-35731-10.jpg": $l2O0u,
    "life3-35731-11.jpg": $78lGe,
    "life3-35731-12.jpg": $gwak9,
    "life3-35731-13.jpg": $5lNbv,
    "life3-35731-14.jpg": $2hRfo,
    "life3-35731-2.jpg": $8j8i1,
    "life3-35731-3.jpg": $bPLkT,
    "life3-35731-4.jpg": $b4h5S,
    "life3-35731-5.jpg": $cxyf0,
    "life3-35731-6.jpg": $5fPJF,
    "life3-35731-7.jpg": $yl9Bf,
    "life3-35731-8.jpg": $dzcY9,
    "life3-35731-9.jpg": $5wVJR,
    "life3-45524-0.jpg": $ifsQ0,
    "life3-45524-1.jpg": $6ocXz,
    "life3-45535-0.jpg": $6Wozp,
    "life3-45535-1.jpg": $8JbJi,
    "life3-45535-2.jpg": $6047g,
    "life3-45535-3.jpg": $7BYLj,
    "life3-45535-4.jpg": $eYFd8,
    "life3-45535-5.jpg": $jar7r,
    "life3-64771-0.jpg": $iHESA,
    "life3-64771-1.jpg": $f4IEa,
    "life3-64771-10.jpg": $9DXCb,
    "life3-64771-11.jpg": $iqARd,
    "life3-64771-12.jpg": $c3yW3,
    "life3-64771-2.jpg": $3GBRP,
    "life3-64771-3.jpg": $2N1go,
    "life3-64771-4.jpg": $j1IhL,
    "life3-64771-5.jpg": $45su8,
    "life3-64771-6.jpg": $337rU,
    "life3-64771-7.jpg": $9Tj7A,
    "life3-64771-8.jpg": $jut4w,
    "life3-64771-9.jpg": $6AjDG,
    "life4-45537-0.jpg": $82LYH,
    "life4-45537-1.jpg": $lg52c,
    "life4-45540-0.jpg": $kiy7M,
    "life4-45540-1.jpg": $Jlq5R,
    "life4-47327-0.jpg": $2htVZ,
    "life4-47327-1.jpg": $3GcR5,
    "life4-50143-0.jpg": $eiAam,
    "life4-50143-1.jpg": $dZE8e,
    "life4-51072-0.jpg": $7yg54,
    "life4-51072-1.jpg": $jCMHf,
    "life4-51072-2.jpg": $bcgtY,
    "life4-51072-3.jpg": $5SSjN,
    "pen1-13834-0.jpg": $gln6L,
    "pen1-13834-1.jpg": $eW2ed,
    "pen1-19800-0.jpg": $cSGmy,
    "pen1-19800-1.jpg": $t086i,
    "pen1-19800-2.jpg": $axGks,
    "pen1-31758-0.jpg": $iClop,
    "pen1-31758-1.jpg": $flWUF,
    "pen1-31758-10.jpg": $dyPKw,
    "pen1-31758-11.jpg": $9D0N5,
    "pen1-31758-12.jpg": $lGzaH,
    "pen1-31758-13.jpg": $2ni6A,
    "pen1-31758-14.jpg": $xf4t3,
    "pen1-31758-2.jpg": $k1aO7,
    "pen1-31758-3.jpg": $3xuUi,
    "pen1-31758-4.jpg": $eaj5f,
    "pen1-31758-5.jpg": $4hx9m,
    "pen1-31758-6.jpg": $8nIzB,
    "pen1-31758-7.jpg": $5oXmG,
    "pen1-31758-8.jpg": $hNSCE,
    "pen1-31758-9.jpg": $b1nyJ,
    "pen1-45524-0.jpg": $eknCS,
    "pen1-45524-1.jpg": $edbnv,
    "pen1-45531-0.jpg": $7WvKB,
    "pen1-45531-1.jpg": $egZ7s,
    "pen1-45531-2.jpg": $NxMmD,
    "pen1-45534-0.jpg": $hepu1,
    "pen1-45534-1.jpg": $5oIry,
    "pen1-45534-2.jpg": $9Vw7y,
    "pen1-59917-0.jpg": $296tr,
    "pen1-59917-1.jpg": $3XfKF,
    "pen1-59917-2.jpg": $l4BYf,
    "pen1-64755-0.jpg": $4D3KT,
    "pen1-64755-1.jpg": $d7BYn,
    "pen2-45518-0.jpg": $e1arP,
    "pen2-45518-1.jpg": $eV3IU,
    "pen2-47811-0.jpg": $5HZnK,
    "pen2-47811-1.jpg": $9Rj0w,
    "pen2-47811-2.jpg": $6tO56,
    "pen2-61174-0.jpg": $8YLEs,
    "pen2-61174-1.jpg": $bdHb7,
    "pen2-67596-0.jpg": $6nApc,
    "pen2-67596-1.jpg": $eAhbH,
    "pen2-72444-0.jpg": $jJKXJ,
    "pen2-72444-1.jpg": $bxnOn,
    "pen2-72519-0.jpg": $01fzV,
    "pen2-72519-1.jpg": $1RFDO,
    "pen2-73413-0.jpg": $jYZK2,
    "pen2-73413-1.jpg": $6CJda,
    "pen2-75947-0.jpg": $cmNYu,
    "pen2-75947-1.jpg": $bNGde,
    "pen2-75947-2.jpg": $im0FW,
    "pen2-75947-3.jpg": $5gKHz,
    "pen2-75947-4.jpg": $eOYwi,
    "pen2-78124-0.jpg": $8DHIL,
    "pen2-78124-1.jpg": $9lIZD,
    "pen2-78124-2.jpg": $bRGTg,
    "sight-13756-0.jpg": $4WV4L,
    "sight-13756-1.jpg": $9HTrt,
    "sight-19336-0.jpg": $kZeNj,
    "sight-19336-1.jpg": $lc4oM,
    "sight-19800-0.jpg": $dGU5x,
    "sight-19800-1.jpg": $4EUv7,
    "sight-19800-2.jpg": $brTVG,
    "sight-19800-4.jpg": $cBhNh,
    "sight-20015-0.jpg": $hdwVD,
    "sight-20015-1.jpg": $96Zr9,
    "sight-20016-0.jpg": $iREtf,
    "sight-20016-1.jpg": $dPQfT,
    "sight-26743-0.jpg": $9jiQw,
    "sight-26743-1.jpg": $lB9r4,
    "sight-26743-10.jpg": $fr0U3,
    "sight-26743-11.jpg": $kFi32,
    "sight-26743-12.jpg": $cHPWf,
    "sight-26743-13.jpg": $5ulUW,
    "sight-26743-14.jpg": $3DkIO,
    "sight-26743-15.jpg": $4NAgg,
    "sight-26743-2.jpg": $e9YWh,
    "sight-26743-3.jpg": $kEt6c,
    "sight-26743-4.jpg": $cH8up,
    "sight-26743-5.jpg": $7iB1D,
    "sight-26743-6.jpg": $azYiL,
    "sight-26743-7.jpg": $7YBvz,
    "sight-26743-8.jpg": $FUAeI,
    "sight-26743-9.jpg": $9RPPs,
    "sight-31307-0.jpg": $3FvtI,
    "sight-31307-1.jpg": $8FZ2X,
    "sight-31403-0.jpg": $bl5P5,
    "sight-31403-1.jpg": $bIpnO,
    "sight-31612-0.jpg": $4Pvry,
    "sight-31612-1.jpg": $ltq5h,
    "sight-31612-2.jpg": $jNVKZ,
    "sight-31612-3.jpg": $lcmQO,
    "sight-31612-4.jpg": $8GNW2,
    "sight-31612-5.jpg": $cl9wG,
    "sight-31612-6.jpg": $2fLCP,
    "sight-31612-7.jpg": $6xxbs,
    "sight-31612-8.jpg": $3Mkse,
    "sight-31612-9.jpg": $ghIKJ,
    "sight-31924-0.jpg": $2EG7e,
    "sight-31924-1.jpg": $6vvWa,
    "sight-34474-0.jpg": $994kh,
    "sight-34474-1.jpg": $bCUjp,
    "sight-34476-0.jpg": $evC5K,
    "sight-34476-1.jpg": $jAaC7,
    "sight-35365-0.jpg": $FVXN2,
    "sight-35365-1.jpg": $jYEYb,
    "sight-35731-0.jpg": $1uBow,
    "sight-35731-1.jpg": $218js,
    "sight-35731-14.jpg": $iwCX5,
    "sight-35731-15.jpg": $k0Tqe,
    "sight-35731-2.jpg": $cDJaL,
    "sight-39393-0.jpg": $gLNIR,
    "sight-39393-1.jpg": $1vfKK,
    "sight-39480-0.jpg": $jrbh7,
    "sight-39480-1.jpg": $5I6WU,
    "sight-41705-0.jpg": $37OkM,
    "sight-41705-1.jpg": $6xhEu,
    "sight-41705-10.jpg": $3RXN4,
    "sight-41705-2.jpg": $RYb4Z,
    "sight-41705-3.jpg": $gajLv,
    "sight-41705-4.jpg": $hyE1H,
    "sight-41705-5.jpg": $lCbh2,
    "sight-41705-6.jpg": $kTJ8M,
    "sight-41705-7.jpg": $dXP0z,
    "sight-41705-8.jpg": $1BGYc,
    "sight-41705-9.jpg": $6gVmk,
    "sight-45513-0.jpg": $gI8Zc,
    "sight-45513-1.jpg": $kNjLj,
    "sight-45529-0.jpg": $aBi1v,
    "sight-45529-1.jpg": $e9Z9n,
    "sight-45531-0.jpg": $8qq6G,
    "sight-45531-1.jpg": $f7mp6,
    "sight-45531-2.jpg": $gRSlt,
    "sight-45532-0.jpg": $1UqO3,
    "sight-45532-1.jpg": $jgaoD,
    "sight-45532a-0.jpg": $dad5E,
    "sight-45532a-1.jpg": $hqZPd,
    "sight-45534-0.jpg": $hmNgh,
    "sight-45534-1.jpg": $gEmg6,
    "sight-45534-2.jpg": $lu1EP,
    "sight-45537-0.jpg": $iZrQ6,
    "sight-45537-1.jpg": $kgzuB,
    "sight-45539-0.jpg": $j9V9g,
    "sight-45539-1.jpg": $40oue,
    "sight-46358-0.jpg": $iu2BQ,
    "sight-46358-1.jpg": $eBuOv,
    "sight-50327-0.jpg": $k5HbI,
    "sight-50327-1.jpg": $4P8K3,
    "sight-51068-0.jpg": $99Paz,
    "sight-51068-1.jpg": $j0VCL,
    "sight-51117-0.jpg": $9Y6Pz,
    "sight-51117-1.jpg": $d9uah,
    "sight-51117-10.jpg": $bBybf,
    "sight-51117-11.jpg": $5FNIB,
    "sight-51117-2.jpg": $dZbJL,
    "sight-51117-3.jpg": $57WVw,
    "sight-51117-4.jpg": $16wAD,
    "sight-51117-5.jpg": $6eVRc,
    "sight-51117-6.jpg": $b4BPn,
    "sight-51117-7.jpg": $1dQK4,
    "sight-51117-8.jpg": $1qTRD,
    "sight-51117-9.jpg": $8DxyY,
    "sight-59917-0.jpg": $2Zh6g,
    "sight-59917-1.jpg": $lw4k8,
    "sight-59917-2.jpg": $62fLg,
    "sight-59917-3.jpg": $i95Ru,
    "sight-59917-4.jpg": $44kiA,
    "sight-59917-5.jpg": $hTkF2,
    "sight-64330-0.jpg": $LHQKF,
    "sight-64330-1.jpg": $8cFzx,
    "sight-64339-0.jpg": $qeOHg,
    "sight-64339-1.jpg": $gL8KP,
    "sight-64770-0.jpg": $3pKG6,
    "sight-64770-1.jpg": $hnPLd,
    "sight-64772-0.jpg": $d3xv8,
    "sight-64772-1.jpg": $ca8Ml,
    "sight-6651-0.jpg": $a1aTJ,
    "sight-6651-1.jpg": $ihnh5,
    "sight-8815-0.jpg": $kzWW6,
    "sight-8815-1.jpg": $eYzuu,
    "sight-8857-0.jpg": $g7hjm,
    "sight-8857-1.jpg": $dx76w,
    "sight-w00001-0.jpg": $5X1ew,
    "sight-w00001-1.jpg": $keeiy
};

});
parcelRegister("1rR3P", function(module, exports) {
module.exports = new URL("home1-23561-0.aef558c9.jpg", import.meta.url).toString();

});

parcelRegister("6ABRQ", function(module, exports) {
module.exports = new URL("home1-23561-1.d0c7a7dc.jpg", import.meta.url).toString();

});

parcelRegister("gCfaO", function(module, exports) {
module.exports = new URL("home1-2563-0.32ab95fb.jpg", import.meta.url).toString();

});

parcelRegister("73N3n", function(module, exports) {
module.exports = new URL("home1-2563-1.d4dd4574.jpg", import.meta.url).toString();

});

parcelRegister("9LPhg", function(module, exports) {
module.exports = new URL("home1-26397-0.6d0de995.jpg", import.meta.url).toString();

});

parcelRegister("hQBsA", function(module, exports) {
module.exports = new URL("home1-26397-1.301e245b.jpg", import.meta.url).toString();

});

parcelRegister("ircuq", function(module, exports) {
module.exports = new URL("home1-39416-0.bbaca7f6.jpg", import.meta.url).toString();

});

parcelRegister("4eaBy", function(module, exports) {
module.exports = new URL("home1-39416-1.98e3bfa7.jpg", import.meta.url).toString();

});

parcelRegister("1NwPa", function(module, exports) {
module.exports = new URL("home1-45511-0.1996e45e.jpg", import.meta.url).toString();

});

parcelRegister("2sxIS", function(module, exports) {
module.exports = new URL("home1-45511-1.f0a593b1.jpg", import.meta.url).toString();

});

parcelRegister("eR2Ju", function(module, exports) {
module.exports = new URL("home1-45543-0.cb0aadd2.jpg", import.meta.url).toString();

});

parcelRegister("lFc41", function(module, exports) {
module.exports = new URL("home1-45543-1.7cf74a94.jpg", import.meta.url).toString();

});

parcelRegister("likMZ", function(module, exports) {
module.exports = new URL("home1-45546-0.a2b24f64.jpg", import.meta.url).toString();

});

parcelRegister("89Tof", function(module, exports) {
module.exports = new URL("home1-45546-1.c4773e08.jpg", import.meta.url).toString();

});

parcelRegister("1k9ew", function(module, exports) {
module.exports = new URL("home1-45547-0.01eff8d9.jpg", import.meta.url).toString();

});

parcelRegister("byfTx", function(module, exports) {
module.exports = new URL("home1-45547-1.bf3f04ed.jpg", import.meta.url).toString();

});

parcelRegister("aF0SG", function(module, exports) {
module.exports = new URL("home1-51064-0.094cfbc6.jpg", import.meta.url).toString();

});

parcelRegister("cuzmR", function(module, exports) {
module.exports = new URL("home1-51064-1.3df0addb.jpg", import.meta.url).toString();

});

parcelRegister("2ZHsa", function(module, exports) {
module.exports = new URL("home1-54630-0.b7bb2710.jpg", import.meta.url).toString();

});

parcelRegister("2chDU", function(module, exports) {
module.exports = new URL("home1-54630-1.47c737c6.jpg", import.meta.url).toString();

});

parcelRegister("gMNtC", function(module, exports) {
module.exports = new URL("home1-54633-0.4c8d44e9.jpg", import.meta.url).toString();

});

parcelRegister("c3D4e", function(module, exports) {
module.exports = new URL("home1-54633-1.ffbc8f92.jpg", import.meta.url).toString();

});

parcelRegister("gqE1h", function(module, exports) {
module.exports = new URL("home1-54646-0.79a8bf48.jpg", import.meta.url).toString();

});

parcelRegister("fND9t", function(module, exports) {
module.exports = new URL("home1-54646-1.c4d46359.jpg", import.meta.url).toString();

});

parcelRegister("f8zBY", function(module, exports) {
module.exports = new URL("home1-54647-0.d3371159.jpg", import.meta.url).toString();

});

parcelRegister("cKIkz", function(module, exports) {
module.exports = new URL("home1-54647-1.a5161a71.jpg", import.meta.url).toString();

});

parcelRegister("80H1K", function(module, exports) {
module.exports = new URL("home1-54655-0.57a317ea.jpg", import.meta.url).toString();

});

parcelRegister("dukS5", function(module, exports) {
module.exports = new URL("home1-54655-1.db238215.jpg", import.meta.url).toString();

});

parcelRegister("7aB5n", function(module, exports) {
module.exports = new URL("home1-64517-0.ae64df91.jpg", import.meta.url).toString();

});

parcelRegister("a87gl", function(module, exports) {
module.exports = new URL("home1-64517-1.9ff67daf.jpg", import.meta.url).toString();

});

parcelRegister("2nR7f", function(module, exports) {
module.exports = new URL("home1-64644-0.c5400a70.jpg", import.meta.url).toString();

});

parcelRegister("2yjIs", function(module, exports) {
module.exports = new URL("home1-64644-1.6acc1c96.jpg", import.meta.url).toString();

});

parcelRegister("2AUSr", function(module, exports) {
module.exports = new URL("home1-64745-0.d8358e61.jpg", import.meta.url).toString();

});

parcelRegister("kLqsR", function(module, exports) {
module.exports = new URL("home1-64745-1.22eb11d2.jpg", import.meta.url).toString();

});

parcelRegister("j0RPi", function(module, exports) {
module.exports = new URL("home1-64771-0.13001b75.jpg", import.meta.url).toString();

});

parcelRegister("7mnfo", function(module, exports) {
module.exports = new URL("home1-64771-1.3b2f31cf.jpg", import.meta.url).toString();

});

parcelRegister("aXvx1", function(module, exports) {
module.exports = new URL("home1-64777-0.05934717.jpg", import.meta.url).toString();

});

parcelRegister("8gqEP", function(module, exports) {
module.exports = new URL("home1-64777-1.32a26ba4.jpg", import.meta.url).toString();

});

parcelRegister("gBIBW", function(module, exports) {
module.exports = new URL("home1-8108-0.ffac98df.jpg", import.meta.url).toString();

});

parcelRegister("5hCLD", function(module, exports) {
module.exports = new URL("home1-8108-1.0d1336cf.jpg", import.meta.url).toString();

});

parcelRegister("7YEfJ", function(module, exports) {
module.exports = new URL("home2-19951-0.2e35a890.jpg", import.meta.url).toString();

});

parcelRegister("c7UdW", function(module, exports) {
module.exports = new URL("home2-19951-1.bf71f9e6.jpg", import.meta.url).toString();

});

parcelRegister("7LlPF", function(module, exports) {
module.exports = new URL("home2-2447-0.0c7fafcb.jpg", import.meta.url).toString();

});

parcelRegister("cBWXi", function(module, exports) {
module.exports = new URL("home2-2447-1.41c8db50.jpg", import.meta.url).toString();

});

parcelRegister("gdSXe", function(module, exports) {
module.exports = new URL("home2-2574-0.148ab4ec.jpg", import.meta.url).toString();

});

parcelRegister("gcOXs", function(module, exports) {
module.exports = new URL("home2-2574-1.7b619102.jpg", import.meta.url).toString();

});

parcelRegister("jS4UN", function(module, exports) {
module.exports = new URL("home2-45532-0.4b70e900.jpg", import.meta.url).toString();

});

parcelRegister("dFWKF", function(module, exports) {
module.exports = new URL("home2-45532-1.56deb235.jpg", import.meta.url).toString();

});

parcelRegister("beODY", function(module, exports) {
module.exports = new URL("home2-51383-0.3bb1e238.jpg", import.meta.url).toString();

});

parcelRegister("efr8z", function(module, exports) {
module.exports = new URL("home2-51383-1.2e947d8f.jpg", import.meta.url).toString();

});

parcelRegister("2Vp5Q", function(module, exports) {
module.exports = new URL("home2-59917-0.7c032971.jpg", import.meta.url).toString();

});

parcelRegister("b5Qs1", function(module, exports) {
module.exports = new URL("home2-59917-1.e6601219.jpg", import.meta.url).toString();

});

parcelRegister("3BhDV", function(module, exports) {
module.exports = new URL("home2-59917-2.f6861df8.jpg", import.meta.url).toString();

});

parcelRegister("4SlWS", function(module, exports) {
module.exports = new URL("home2-59917-3.dc9cc598.jpg", import.meta.url).toString();

});

parcelRegister("6gxSo", function(module, exports) {
module.exports = new URL("home2-59917-4.708f6192.jpg", import.meta.url).toString();

});

parcelRegister("3jBSP", function(module, exports) {
module.exports = new URL("home2-59926-0.9ca6dbe3.jpg", import.meta.url).toString();

});

parcelRegister("kT5mF", function(module, exports) {
module.exports = new URL("home2-59926-1.660c849e.jpg", import.meta.url).toString();

});

parcelRegister("4SQmg", function(module, exports) {
module.exports = new URL("home2-65505-0.2c4fbc03.jpg", import.meta.url).toString();

});

parcelRegister("6QufH", function(module, exports) {
module.exports = new URL("home2-65505-1.38b1354c.jpg", import.meta.url).toString();

});

parcelRegister("kShnH", function(module, exports) {
module.exports = new URL("home2-8882-0.a1f40bc9.jpg", import.meta.url).toString();

});

parcelRegister("2QUnt", function(module, exports) {
module.exports = new URL("home2-8882-1.fa6cf452.jpg", import.meta.url).toString();

});

parcelRegister("czmLI", function(module, exports) {
module.exports = new URL("home3-15234-0.2216dfa1.jpg", import.meta.url).toString();

});

parcelRegister("1wdCh", function(module, exports) {
module.exports = new URL("home3-15234-1.dcaed8af.jpg", import.meta.url).toString();

});

parcelRegister("5I8gY", function(module, exports) {
module.exports = new URL("home3-15235-0.07b1bde5.jpg", import.meta.url).toString();

});

parcelRegister("cCHwt", function(module, exports) {
module.exports = new URL("home3-15235-1.34175eeb.jpg", import.meta.url).toString();

});

parcelRegister("aMbfU", function(module, exports) {
module.exports = new URL("home3-21806-0.d6b37754.jpg", import.meta.url).toString();

});

parcelRegister("kGGJH", function(module, exports) {
module.exports = new URL("home3-21806-1.eac82f9d.jpg", import.meta.url).toString();

});

parcelRegister("8cDzg", function(module, exports) {
module.exports = new URL("home3-24306-0.e36f08bf.jpg", import.meta.url).toString();

});

parcelRegister("37mGl", function(module, exports) {
module.exports = new URL("home3-24306-1.83ac162f.jpg", import.meta.url).toString();

});

parcelRegister("kxi1h", function(module, exports) {
module.exports = new URL("home3-2809-0.e1b95b3f.jpg", import.meta.url).toString();

});

parcelRegister("ic5Rf", function(module, exports) {
module.exports = new URL("home3-2809-1.fce7ab8b.jpg", import.meta.url).toString();

});

parcelRegister("aoW3W", function(module, exports) {
module.exports = new URL("home3-3183-0.80d2d0cb.jpg", import.meta.url).toString();

});

parcelRegister("8mTmB", function(module, exports) {
module.exports = new URL("home3-3183-1.2f86ec65.jpg", import.meta.url).toString();

});

parcelRegister("cOsjb", function(module, exports) {
module.exports = new URL("home3-34693-0.1846d276.jpg", import.meta.url).toString();

});

parcelRegister("9JQ7l", function(module, exports) {
module.exports = new URL("home3-34693-1.65aaba73.jpg", import.meta.url).toString();

});

parcelRegister("2xYXJ", function(module, exports) {
module.exports = new URL("home3-35361-0.58aecb79.jpg", import.meta.url).toString();

});

parcelRegister("AFoeg", function(module, exports) {
module.exports = new URL("home3-35361-1.517cede4.jpg", import.meta.url).toString();

});

parcelRegister("2TLi5", function(module, exports) {
module.exports = new URL("home3-35389-0.92d5356e.jpg", import.meta.url).toString();

});

parcelRegister("dmUnZ", function(module, exports) {
module.exports = new URL("home3-35389-1.d7d7e729.jpg", import.meta.url).toString();

});

parcelRegister("9OnCZ", function(module, exports) {
module.exports = new URL("home3-41536-0.4a4bf0da.jpg", import.meta.url).toString();

});

parcelRegister("6FmY5", function(module, exports) {
module.exports = new URL("home3-41536-1.08d2f08b.jpg", import.meta.url).toString();

});

parcelRegister("cUwqu", function(module, exports) {
module.exports = new URL("home3-44047-0.9e1dfbd0.jpg", import.meta.url).toString();

});

parcelRegister("eqwfS", function(module, exports) {
module.exports = new URL("home3-44047-1.b7f230e1.jpg", import.meta.url).toString();

});

parcelRegister("444tx", function(module, exports) {
module.exports = new URL("home3-44048-0.6f65bb01.jpg", import.meta.url).toString();

});

parcelRegister("6Kcd7", function(module, exports) {
module.exports = new URL("home3-44048-1.dc52d0ff.jpg", import.meta.url).toString();

});

parcelRegister("dAaUr", function(module, exports) {
module.exports = new URL("home3-59934-0.12fe6a81.jpg", import.meta.url).toString();

});

parcelRegister("4jnSc", function(module, exports) {
module.exports = new URL("home3-59934-1.7de138f5.jpg", import.meta.url).toString();

});

parcelRegister("88DuS", function(module, exports) {
module.exports = new URL("home3-8105-0.f43f5a19.jpg", import.meta.url).toString();

});

parcelRegister("v748g", function(module, exports) {
module.exports = new URL("home3-8105-1.212083b4.jpg", import.meta.url).toString();

});

parcelRegister("gsbMZ", function(module, exports) {
module.exports = new URL("home3-8106-0.c78b8e40.jpg", import.meta.url).toString();

});

parcelRegister("eggqP", function(module, exports) {
module.exports = new URL("home3-8106-1.2867b161.jpg", import.meta.url).toString();

});

parcelRegister("8IuIZ", function(module, exports) {
module.exports = new URL("home3-8107-0.f1f56458.jpg", import.meta.url).toString();

});

parcelRegister("fbeXo", function(module, exports) {
module.exports = new URL("home3-8107-1.3ea90baa.jpg", import.meta.url).toString();

});

parcelRegister("bYvmr", function(module, exports) {
module.exports = new URL("home4-45511-0.a146a688.jpg", import.meta.url).toString();

});

parcelRegister("8adLw", function(module, exports) {
module.exports = new URL("home4-45511-1.f0a593b1.jpg", import.meta.url).toString();

});

parcelRegister("aaCKw", function(module, exports) {
module.exports = new URL("home4-45532-0.73da268b.jpg", import.meta.url).toString();

});

parcelRegister("dJJuY", function(module, exports) {
module.exports = new URL("home4-45532-1.56deb235.jpg", import.meta.url).toString();

});

parcelRegister("iqWr1", function(module, exports) {
module.exports = new URL("home4-45534-0.0e8f874e.jpg", import.meta.url).toString();

});

parcelRegister("1IxW9", function(module, exports) {
module.exports = new URL("home4-45534-1.cd42f380.jpg", import.meta.url).toString();

});

parcelRegister("7o9Ul", function(module, exports) {
module.exports = new URL("home4-45534-2.96bca7a7.jpg", import.meta.url).toString();

});

parcelRegister("eiA8E", function(module, exports) {
module.exports = new URL("home4-45534-3.c32b4e92.jpg", import.meta.url).toString();

});

parcelRegister("2l18z", function(module, exports) {
module.exports = new URL("home4-45534-4.3039e963.jpg", import.meta.url).toString();

});

parcelRegister("h5rKg", function(module, exports) {
module.exports = new URL("home4-45534-5.df0cab35.jpg", import.meta.url).toString();

});

parcelRegister("kwGUa", function(module, exports) {
module.exports = new URL("home4-45534-6.e0a41d6c.jpg", import.meta.url).toString();

});

parcelRegister("dx0o6", function(module, exports) {
module.exports = new URL("home4-45534-7.f51702f3.jpg", import.meta.url).toString();

});

parcelRegister("bBAmS", function(module, exports) {
module.exports = new URL("home4-45534-8.2efe69cd.jpg", import.meta.url).toString();

});

parcelRegister("6wwuW", function(module, exports) {
module.exports = new URL("home4-45534-9.7304030d.jpg", import.meta.url).toString();

});

parcelRegister("hhK4S", function(module, exports) {
module.exports = new URL("home4-51064-0.73e379c0.jpg", import.meta.url).toString();

});

parcelRegister("bXdjk", function(module, exports) {
module.exports = new URL("home4-51064-1.6e141205.jpg", import.meta.url).toString();

});

parcelRegister("gjmde", function(module, exports) {
module.exports = new URL("home4-51079-0.061b50c3.jpg", import.meta.url).toString();

});

parcelRegister("3rULa", function(module, exports) {
module.exports = new URL("home4-51079-1.c998e4c4.jpg", import.meta.url).toString();

});

parcelRegister("5RexM", function(module, exports) {
module.exports = new URL("home4-59917-0.f4a74056.jpg", import.meta.url).toString();

});

parcelRegister("cCXR1", function(module, exports) {
module.exports = new URL("home4-59917-1.e6601219.jpg", import.meta.url).toString();

});

parcelRegister("03duD", function(module, exports) {
module.exports = new URL("home4-59917-2.f6861df8.jpg", import.meta.url).toString();

});

parcelRegister("hQo7R", function(module, exports) {
module.exports = new URL("home4-59917-3.dc9cc598.jpg", import.meta.url).toString();

});

parcelRegister("2MrDj", function(module, exports) {
module.exports = new URL("home4-59917-4.708f6192.jpg", import.meta.url).toString();

});

parcelRegister("7yIdZ", function(module, exports) {
module.exports = new URL("home4-59926-0.d7d48a5e.jpg", import.meta.url).toString();

});

parcelRegister("eybJG", function(module, exports) {
module.exports = new URL("home4-59926-1.42adeb14.jpg", import.meta.url).toString();

});

parcelRegister("9Osm1", function(module, exports) {
module.exports = new URL("home4-59926-2.5f866084.jpg", import.meta.url).toString();

});

parcelRegister("d8La6", function(module, exports) {
module.exports = new URL("home4-59926-3.c78e5729.jpg", import.meta.url).toString();

});

parcelRegister("5jQci", function(module, exports) {
module.exports = new URL("home4-59926-4.70a295c4.jpg", import.meta.url).toString();

});

parcelRegister("3qAzE", function(module, exports) {
module.exports = new URL("home4-64745-0.d8358e61.jpg", import.meta.url).toString();

});

parcelRegister("4XKp9", function(module, exports) {
module.exports = new URL("home4-64745-1.22eb11d2.jpg", import.meta.url).toString();

});

parcelRegister("2nHYP", function(module, exports) {
module.exports = new URL("home4-64771-0.480846f1.jpg", import.meta.url).toString();

});

parcelRegister("17LkS", function(module, exports) {
module.exports = new URL("home4-64771-1.cbbae98b.jpg", import.meta.url).toString();

});

parcelRegister("aX5yG", function(module, exports) {
module.exports = new URL("home4-64771-10.3b7de61c.jpg", import.meta.url).toString();

});

parcelRegister("7bROg", function(module, exports) {
module.exports = new URL("home4-64771-11.423e8142.jpg", import.meta.url).toString();

});

parcelRegister("6RDaF", function(module, exports) {
module.exports = new URL("home4-64771-12.cec11d71.jpg", import.meta.url).toString();

});

parcelRegister("2yofo", function(module, exports) {
module.exports = new URL("home4-64771-13.76c37b4e.jpg", import.meta.url).toString();

});

parcelRegister("jDU34", function(module, exports) {
module.exports = new URL("home4-64771-2.009a2c5f.jpg", import.meta.url).toString();

});

parcelRegister("bIFRt", function(module, exports) {
module.exports = new URL("home4-64771-3.027de310.jpg", import.meta.url).toString();

});

parcelRegister("lK5Gw", function(module, exports) {
module.exports = new URL("home4-64771-4.58d401c3.jpg", import.meta.url).toString();

});

parcelRegister("aO3Yz", function(module, exports) {
module.exports = new URL("home4-64771-5.fb703e12.jpg", import.meta.url).toString();

});

parcelRegister("e1N59", function(module, exports) {
module.exports = new URL("home4-64771-6.19fcecbe.jpg", import.meta.url).toString();

});

parcelRegister("ksmPC", function(module, exports) {
module.exports = new URL("home4-64771-7.0130ae06.jpg", import.meta.url).toString();

});

parcelRegister("kWhyr", function(module, exports) {
module.exports = new URL("home4-64771-8.681982aa.jpg", import.meta.url).toString();

});

parcelRegister("bZFIC", function(module, exports) {
module.exports = new URL("home4-64771-9.7362ec41.jpg", import.meta.url).toString();

});

parcelRegister("iLX5O", function(module, exports) {
module.exports = new URL("home4-64777-0.8e0f9ef3.jpg", import.meta.url).toString();

});

parcelRegister("8NOxn", function(module, exports) {
module.exports = new URL("home4-64777-1.32a26ba4.jpg", import.meta.url).toString();

});

parcelRegister("j00rP", function(module, exports) {
module.exports = new URL("home4-64777-2.517fc008.jpg", import.meta.url).toString();

});

parcelRegister("eqhmb", function(module, exports) {
module.exports = new URL("life1-19800-0.43f2e2fe.jpg", import.meta.url).toString();

});

parcelRegister("jCx7v", function(module, exports) {
module.exports = new URL("life1-19800-1.82299572.jpg", import.meta.url).toString();

});

parcelRegister("7wjtj", function(module, exports) {
module.exports = new URL("life1-19800-2.1b27f5b3.jpg", import.meta.url).toString();

});

parcelRegister("q5kfj", function(module, exports) {
module.exports = new URL("life1-19800-3.ac9bc59d.jpg", import.meta.url).toString();

});

parcelRegister("jWyGo", function(module, exports) {
module.exports = new URL("life1-19944-0.b3d124ea.jpg", import.meta.url).toString();

});

parcelRegister("8GWKF", function(module, exports) {
module.exports = new URL("life1-19944-1.176664ba.jpg", import.meta.url).toString();

});

parcelRegister("2sBW4", function(module, exports) {
module.exports = new URL("life1-20015-0.0c653c4f.jpg", import.meta.url).toString();

});

parcelRegister("5zk60", function(module, exports) {
module.exports = new URL("life1-20015-1.84daef94.jpg", import.meta.url).toString();

});

parcelRegister("ccZ1E", function(module, exports) {
module.exports = new URL("life1-31912-0.f77e6aed.jpg", import.meta.url).toString();

});

parcelRegister("5xicv", function(module, exports) {
module.exports = new URL("life1-31912-1.9157f273.jpg", import.meta.url).toString();

});

parcelRegister("auNNO", function(module, exports) {
module.exports = new URL("life1-3310-0.32cf6cef.jpg", import.meta.url).toString();

});

parcelRegister("7ueUy", function(module, exports) {
module.exports = new URL("life1-3310-1.f32b75dc.jpg", import.meta.url).toString();

});

parcelRegister("5h1D2", function(module, exports) {
module.exports = new URL("life1-45513-0.ee5a95ae.jpg", import.meta.url).toString();

});

parcelRegister("87Yj2", function(module, exports) {
module.exports = new URL("life1-45513-1.c9cddef1.jpg", import.meta.url).toString();

});

parcelRegister("4jlDv", function(module, exports) {
module.exports = new URL("life1-45517-0.628bc986.jpg", import.meta.url).toString();

});

parcelRegister("3XDEk", function(module, exports) {
module.exports = new URL("life1-45517-1.a557e7fa.jpg", import.meta.url).toString();

});

parcelRegister("hImkx", function(module, exports) {
module.exports = new URL("life1-45526-0.bb3b044c.jpg", import.meta.url).toString();

});

parcelRegister("88dVv", function(module, exports) {
module.exports = new URL("life1-45526-1.af57f134.jpg", import.meta.url).toString();

});

parcelRegister("1Bl2Y", function(module, exports) {
module.exports = new URL("life1-45526-2.907d7c5f.jpg", import.meta.url).toString();

});

parcelRegister("kJBNc", function(module, exports) {
module.exports = new URL("life1-45526-3.822a866a.jpg", import.meta.url).toString();

});

parcelRegister("2b9GB", function(module, exports) {
module.exports = new URL("life1-45526-4.5c5d7155.jpg", import.meta.url).toString();

});

parcelRegister("eRxyQ", function(module, exports) {
module.exports = new URL("life1-45526-5.9fb162cb.jpg", import.meta.url).toString();

});

parcelRegister("7SmsT", function(module, exports) {
module.exports = new URL("life1-45526-6.e05f8c20.jpg", import.meta.url).toString();

});

parcelRegister("5lChU", function(module, exports) {
module.exports = new URL("life1-45530-0.401cc38e.jpg", import.meta.url).toString();

});

parcelRegister("enA0R", function(module, exports) {
module.exports = new URL("life1-45530-1.ba7dd26f.jpg", import.meta.url).toString();

});

parcelRegister("ir7qT", function(module, exports) {
module.exports = new URL("life1-45531-0.cf24c1a4.jpg", import.meta.url).toString();

});

parcelRegister("lT9Nx", function(module, exports) {
module.exports = new URL("life1-45531-1.28cd663c.jpg", import.meta.url).toString();

});

parcelRegister("ckfad", function(module, exports) {
module.exports = new URL("life1-45531-10.a48841ec.jpg", import.meta.url).toString();

});

parcelRegister("7GNiz", function(module, exports) {
module.exports = new URL("life1-45531-11.929d9e24.jpg", import.meta.url).toString();

});

parcelRegister("9yv2b", function(module, exports) {
module.exports = new URL("life1-45531-12.615fddca.jpg", import.meta.url).toString();

});

parcelRegister("33iAn", function(module, exports) {
module.exports = new URL("life1-45531-2.4e25f0e7.jpg", import.meta.url).toString();

});

parcelRegister("27CZ3", function(module, exports) {
module.exports = new URL("life1-45531-3.79414b14.jpg", import.meta.url).toString();

});

parcelRegister("joykB", function(module, exports) {
module.exports = new URL("life1-45531-4.6f35ea44.jpg", import.meta.url).toString();

});

parcelRegister("fhZyo", function(module, exports) {
module.exports = new URL("life1-45531-5.907ca300.jpg", import.meta.url).toString();

});

parcelRegister("4Qxms", function(module, exports) {
module.exports = new URL("life1-45531-6.2d759659.jpg", import.meta.url).toString();

});

parcelRegister("9O2Lb", function(module, exports) {
module.exports = new URL("life1-45531-7.f499ad23.jpg", import.meta.url).toString();

});

parcelRegister("aU2nt", function(module, exports) {
module.exports = new URL("life1-45531-8.7d4b9f9c.jpg", import.meta.url).toString();

});

parcelRegister("3wcRx", function(module, exports) {
module.exports = new URL("life1-45531-9.fb365ce8.jpg", import.meta.url).toString();

});

parcelRegister("gQKGT", function(module, exports) {
module.exports = new URL("life1-45539-0.5ad7884f.jpg", import.meta.url).toString();

});

parcelRegister("VR1uH", function(module, exports) {
module.exports = new URL("life1-45539-1.55d48863.jpg", import.meta.url).toString();

});

parcelRegister("SovBX", function(module, exports) {
module.exports = new URL("life1-50258-0.65bc481f.jpg", import.meta.url).toString();

});

parcelRegister("a9A9x", function(module, exports) {
module.exports = new URL("life1-50258-1.5506fab6.jpg", import.meta.url).toString();

});

parcelRegister("3cblz", function(module, exports) {
module.exports = new URL("life1-50258-10.663a68a7.jpg", import.meta.url).toString();

});

parcelRegister("eNSZ8", function(module, exports) {
module.exports = new URL("life1-50258-2.85119729.jpg", import.meta.url).toString();

});

parcelRegister("3ECoS", function(module, exports) {
module.exports = new URL("life1-50258-3.f86934b8.jpg", import.meta.url).toString();

});

parcelRegister("9NFpn", function(module, exports) {
module.exports = new URL("life1-50258-4.535f37fc.jpg", import.meta.url).toString();

});

parcelRegister("6jSNg", function(module, exports) {
module.exports = new URL("life1-50258-5.50dd46cf.jpg", import.meta.url).toString();

});

parcelRegister("iA9g4", function(module, exports) {
module.exports = new URL("life1-50258-6.0b46b1c0.jpg", import.meta.url).toString();

});

parcelRegister("eXij7", function(module, exports) {
module.exports = new URL("life1-50258-7.16c46d9c.jpg", import.meta.url).toString();

});

parcelRegister("ifcYi", function(module, exports) {
module.exports = new URL("life1-50258-8.c18a9ecb.jpg", import.meta.url).toString();

});

parcelRegister("9GH9a", function(module, exports) {
module.exports = new URL("life1-50258-9.2cf408b9.jpg", import.meta.url).toString();

});

parcelRegister("hGuaV", function(module, exports) {
module.exports = new URL("life1-6662-0.96263418.jpg", import.meta.url).toString();

});

parcelRegister("b8oNu", function(module, exports) {
module.exports = new URL("life1-6662-1.4ca31626.jpg", import.meta.url).toString();

});

parcelRegister("8py4l", function(module, exports) {
module.exports = new URL("life1-8815-0.11afd280.jpg", import.meta.url).toString();

});

parcelRegister("gETuy", function(module, exports) {
module.exports = new URL("life1-8815-1.184ec502.jpg", import.meta.url).toString();

});

parcelRegister("g2r2B", function(module, exports) {
module.exports = new URL("life2-31536-0.52bc8092.jpg", import.meta.url).toString();

});

parcelRegister("d6POJ", function(module, exports) {
module.exports = new URL("life2-31536-1.ad388b9f.jpg", import.meta.url).toString();

});

parcelRegister("bponE", function(module, exports) {
module.exports = new URL("life2-31601-0.3906452a.jpg", import.meta.url).toString();

});

parcelRegister("9QAmz", function(module, exports) {
module.exports = new URL("life2-31601-1.9d7df73b.jpg", import.meta.url).toString();

});

parcelRegister("dsOvN", function(module, exports) {
module.exports = new URL("life2-39393-0.0750f8c8.jpg", import.meta.url).toString();

});

parcelRegister("em1lw", function(module, exports) {
module.exports = new URL("life2-39393-1.3dc428a7.jpg", import.meta.url).toString();

});

parcelRegister("k5dAv", function(module, exports) {
module.exports = new URL("life2-45516-0.6dba1952.jpg", import.meta.url).toString();

});

parcelRegister("jCkFq", function(module, exports) {
module.exports = new URL("life2-45516-1.d7f8f7d5.jpg", import.meta.url).toString();

});

parcelRegister("e0s6D", function(module, exports) {
module.exports = new URL("life2-45520-0.8f531c38.jpg", import.meta.url).toString();

});

parcelRegister("dihlM", function(module, exports) {
module.exports = new URL("life2-45520-1.71b16461.jpg", import.meta.url).toString();

});

parcelRegister("erSjq", function(module, exports) {
module.exports = new URL("life2-45520-2.4434b713.jpg", import.meta.url).toString();

});

parcelRegister("bnCrZ", function(module, exports) {
module.exports = new URL("life2-45527-0.ff2cd903.jpg", import.meta.url).toString();

});

parcelRegister("ekdhu", function(module, exports) {
module.exports = new URL("life2-45527-1.9c29689b.jpg", import.meta.url).toString();

});

parcelRegister("lNpsh", function(module, exports) {
module.exports = new URL("life2-47219-0.aa46aedf.jpg", import.meta.url).toString();

});

parcelRegister("dysyG", function(module, exports) {
module.exports = new URL("life2-47219-1.120fc0f1.jpg", import.meta.url).toString();

});

parcelRegister("6DVXn", function(module, exports) {
module.exports = new URL("life2-47219-2.be770f46.jpg", import.meta.url).toString();

});

parcelRegister("dhrQq", function(module, exports) {
module.exports = new URL("life2-47219-3.ee5bcb5d.jpg", import.meta.url).toString();

});

parcelRegister("jC5zD", function(module, exports) {
module.exports = new URL("life2-47219-4.6736b338.jpg", import.meta.url).toString();

});

parcelRegister("cpGa3", function(module, exports) {
module.exports = new URL("life2-47219-5.df38df45.jpg", import.meta.url).toString();

});

parcelRegister("j7w1Z", function(module, exports) {
module.exports = new URL("life2-47219-6.dae10c06.jpg", import.meta.url).toString();

});

parcelRegister("8xdRz", function(module, exports) {
module.exports = new URL("life2-47219-7.87a2bde1.jpg", import.meta.url).toString();

});

parcelRegister("13z5Y", function(module, exports) {
module.exports = new URL("life2-47219-8.1f6bb864.jpg", import.meta.url).toString();

});

parcelRegister("kuBwa", function(module, exports) {
module.exports = new URL("life2-47219-9.235b8f7a.jpg", import.meta.url).toString();

});

parcelRegister("h0r6M", function(module, exports) {
module.exports = new URL("life2-51061-0.d4b1116e.jpg", import.meta.url).toString();

});

parcelRegister("cXWmz", function(module, exports) {
module.exports = new URL("life2-51061-1.fb639535.jpg", import.meta.url).toString();

});

parcelRegister("6btdl", function(module, exports) {
module.exports = new URL("life2-59917-0.add691af.jpg", import.meta.url).toString();

});

parcelRegister("6o0Cl", function(module, exports) {
module.exports = new URL("life2-59917-1.e6601219.jpg", import.meta.url).toString();

});

parcelRegister("bgcVU", function(module, exports) {
module.exports = new URL("life2-59917-2.2edc5469.jpg", import.meta.url).toString();

});

parcelRegister("7yeWR", function(module, exports) {
module.exports = new URL("life2-59917-3.dc9cc598.jpg", import.meta.url).toString();

});

parcelRegister("gaXcR", function(module, exports) {
module.exports = new URL("life3-19334-0.3404b09b.jpg", import.meta.url).toString();

});

parcelRegister("5Jb4S", function(module, exports) {
module.exports = new URL("life3-19334-1.44a8b9bf.jpg", import.meta.url).toString();

});

parcelRegister("aUKDh", function(module, exports) {
module.exports = new URL("life3-35731-0.0da9a670.jpg", import.meta.url).toString();

});

parcelRegister("2kiEa", function(module, exports) {
module.exports = new URL("life3-35731-1.47e9450a.jpg", import.meta.url).toString();

});

parcelRegister("l2O0u", function(module, exports) {
module.exports = new URL("life3-35731-10.868c7b5e.jpg", import.meta.url).toString();

});

parcelRegister("78lGe", function(module, exports) {
module.exports = new URL("life3-35731-11.9f246540.jpg", import.meta.url).toString();

});

parcelRegister("gwak9", function(module, exports) {
module.exports = new URL("life3-35731-12.27cdfdf2.jpg", import.meta.url).toString();

});

parcelRegister("5lNbv", function(module, exports) {
module.exports = new URL("life3-35731-13.bbb484a6.jpg", import.meta.url).toString();

});

parcelRegister("2hRfo", function(module, exports) {
module.exports = new URL("life3-35731-14.de5eabf3.jpg", import.meta.url).toString();

});

parcelRegister("8j8i1", function(module, exports) {
module.exports = new URL("life3-35731-2.81aea5e1.jpg", import.meta.url).toString();

});

parcelRegister("bPLkT", function(module, exports) {
module.exports = new URL("life3-35731-3.a60c8052.jpg", import.meta.url).toString();

});

parcelRegister("b4h5S", function(module, exports) {
module.exports = new URL("life3-35731-4.05a13ac8.jpg", import.meta.url).toString();

});

parcelRegister("cxyf0", function(module, exports) {
module.exports = new URL("life3-35731-5.96988f1b.jpg", import.meta.url).toString();

});

parcelRegister("5fPJF", function(module, exports) {
module.exports = new URL("life3-35731-6.dbb8a09e.jpg", import.meta.url).toString();

});

parcelRegister("yl9Bf", function(module, exports) {
module.exports = new URL("life3-35731-7.5fa41469.jpg", import.meta.url).toString();

});

parcelRegister("dzcY9", function(module, exports) {
module.exports = new URL("life3-35731-8.b208e9b7.jpg", import.meta.url).toString();

});

parcelRegister("5wVJR", function(module, exports) {
module.exports = new URL("life3-35731-9.4ef314d0.jpg", import.meta.url).toString();

});

parcelRegister("ifsQ0", function(module, exports) {
module.exports = new URL("life3-45524-0.564c424d.jpg", import.meta.url).toString();

});

parcelRegister("6ocXz", function(module, exports) {
module.exports = new URL("life3-45524-1.e39dfeac.jpg", import.meta.url).toString();

});

parcelRegister("6Wozp", function(module, exports) {
module.exports = new URL("life3-45535-0.a5795c34.jpg", import.meta.url).toString();

});

parcelRegister("8JbJi", function(module, exports) {
module.exports = new URL("life3-45535-1.b3cbb29e.jpg", import.meta.url).toString();

});

parcelRegister("6047g", function(module, exports) {
module.exports = new URL("life3-45535-2.34fb10de.jpg", import.meta.url).toString();

});

parcelRegister("7BYLj", function(module, exports) {
module.exports = new URL("life3-45535-3.a316faf6.jpg", import.meta.url).toString();

});

parcelRegister("eYFd8", function(module, exports) {
module.exports = new URL("life3-45535-4.9bf5bce8.jpg", import.meta.url).toString();

});

parcelRegister("jar7r", function(module, exports) {
module.exports = new URL("life3-45535-5.87edeb7f.jpg", import.meta.url).toString();

});

parcelRegister("iHESA", function(module, exports) {
module.exports = new URL("life3-64771-0.c8699d21.jpg", import.meta.url).toString();

});

parcelRegister("f4IEa", function(module, exports) {
module.exports = new URL("life3-64771-1.009a2c5f.jpg", import.meta.url).toString();

});

parcelRegister("9DXCb", function(module, exports) {
module.exports = new URL("life3-64771-10.423e8142.jpg", import.meta.url).toString();

});

parcelRegister("iqARd", function(module, exports) {
module.exports = new URL("life3-64771-11.48b43151.jpg", import.meta.url).toString();

});

parcelRegister("c3yW3", function(module, exports) {
module.exports = new URL("life3-64771-12.4ee5c7a0.jpg", import.meta.url).toString();

});

parcelRegister("3GBRP", function(module, exports) {
module.exports = new URL("life3-64771-2.027de310.jpg", import.meta.url).toString();

});

parcelRegister("2N1go", function(module, exports) {
module.exports = new URL("life3-64771-3.58d401c3.jpg", import.meta.url).toString();

});

parcelRegister("j1IhL", function(module, exports) {
module.exports = new URL("life3-64771-4.fb703e12.jpg", import.meta.url).toString();

});

parcelRegister("45su8", function(module, exports) {
module.exports = new URL("life3-64771-5.19fcecbe.jpg", import.meta.url).toString();

});

parcelRegister("337rU", function(module, exports) {
module.exports = new URL("life3-64771-6.0130ae06.jpg", import.meta.url).toString();

});

parcelRegister("9Tj7A", function(module, exports) {
module.exports = new URL("life3-64771-7.681982aa.jpg", import.meta.url).toString();

});

parcelRegister("jut4w", function(module, exports) {
module.exports = new URL("life3-64771-8.7362ec41.jpg", import.meta.url).toString();

});

parcelRegister("6AjDG", function(module, exports) {
module.exports = new URL("life3-64771-9.3b7de61c.jpg", import.meta.url).toString();

});

parcelRegister("82LYH", function(module, exports) {
module.exports = new URL("life4-45537-0.9910af20.jpg", import.meta.url).toString();

});

parcelRegister("lg52c", function(module, exports) {
module.exports = new URL("life4-45537-1.2a400825.jpg", import.meta.url).toString();

});

parcelRegister("kiy7M", function(module, exports) {
module.exports = new URL("life4-45540-0.ca6d6840.jpg", import.meta.url).toString();

});

parcelRegister("Jlq5R", function(module, exports) {
module.exports = new URL("life4-45540-1.b18a36e0.jpg", import.meta.url).toString();

});

parcelRegister("2htVZ", function(module, exports) {
module.exports = new URL("life4-47327-0.23e7bfcf.jpg", import.meta.url).toString();

});

parcelRegister("3GcR5", function(module, exports) {
module.exports = new URL("life4-47327-1.3b3b0fe5.jpg", import.meta.url).toString();

});

parcelRegister("eiAam", function(module, exports) {
module.exports = new URL("life4-50143-0.df238af3.jpg", import.meta.url).toString();

});

parcelRegister("dZE8e", function(module, exports) {
module.exports = new URL("life4-50143-1.c97c5c83.jpg", import.meta.url).toString();

});

parcelRegister("7yg54", function(module, exports) {
module.exports = new URL("life4-51072-0.0e5f5fa2.jpg", import.meta.url).toString();

});

parcelRegister("jCMHf", function(module, exports) {
module.exports = new URL("life4-51072-1.2d154264.jpg", import.meta.url).toString();

});

parcelRegister("bcgtY", function(module, exports) {
module.exports = new URL("life4-51072-2.0a2d1f20.jpg", import.meta.url).toString();

});

parcelRegister("5SSjN", function(module, exports) {
module.exports = new URL("life4-51072-3.19d0b881.jpg", import.meta.url).toString();

});

parcelRegister("gln6L", function(module, exports) {
module.exports = new URL("pen1-13834-0.2091d170.jpg", import.meta.url).toString();

});

parcelRegister("eW2ed", function(module, exports) {
module.exports = new URL("pen1-13834-1.b6c68c81.jpg", import.meta.url).toString();

});

parcelRegister("cSGmy", function(module, exports) {
module.exports = new URL("pen1-19800-0.ade88213.jpg", import.meta.url).toString();

});

parcelRegister("t086i", function(module, exports) {
module.exports = new URL("pen1-19800-1.bef4d3bd.jpg", import.meta.url).toString();

});

parcelRegister("axGks", function(module, exports) {
module.exports = new URL("pen1-19800-2.ba85118f.jpg", import.meta.url).toString();

});

parcelRegister("iClop", function(module, exports) {
module.exports = new URL("pen1-31758-0.91bb320c.jpg", import.meta.url).toString();

});

parcelRegister("flWUF", function(module, exports) {
module.exports = new URL("pen1-31758-1.34862c70.jpg", import.meta.url).toString();

});

parcelRegister("dyPKw", function(module, exports) {
module.exports = new URL("pen1-31758-10.99882fe2.jpg", import.meta.url).toString();

});

parcelRegister("9D0N5", function(module, exports) {
module.exports = new URL("pen1-31758-11.52e22c2c.jpg", import.meta.url).toString();

});

parcelRegister("lGzaH", function(module, exports) {
module.exports = new URL("pen1-31758-12.7f86fd9e.jpg", import.meta.url).toString();

});

parcelRegister("2ni6A", function(module, exports) {
module.exports = new URL("pen1-31758-13.abfb0e16.jpg", import.meta.url).toString();

});

parcelRegister("xf4t3", function(module, exports) {
module.exports = new URL("pen1-31758-14.bc5a445b.jpg", import.meta.url).toString();

});

parcelRegister("k1aO7", function(module, exports) {
module.exports = new URL("pen1-31758-2.a839a13a.jpg", import.meta.url).toString();

});

parcelRegister("3xuUi", function(module, exports) {
module.exports = new URL("pen1-31758-3.abf7e7af.jpg", import.meta.url).toString();

});

parcelRegister("eaj5f", function(module, exports) {
module.exports = new URL("pen1-31758-4.8a726842.jpg", import.meta.url).toString();

});

parcelRegister("4hx9m", function(module, exports) {
module.exports = new URL("pen1-31758-5.cf9602a4.jpg", import.meta.url).toString();

});

parcelRegister("8nIzB", function(module, exports) {
module.exports = new URL("pen1-31758-6.47d02b5a.jpg", import.meta.url).toString();

});

parcelRegister("5oXmG", function(module, exports) {
module.exports = new URL("pen1-31758-7.eb9e1e45.jpg", import.meta.url).toString();

});

parcelRegister("hNSCE", function(module, exports) {
module.exports = new URL("pen1-31758-8.24e6f91a.jpg", import.meta.url).toString();

});

parcelRegister("b1nyJ", function(module, exports) {
module.exports = new URL("pen1-31758-9.fc126287.jpg", import.meta.url).toString();

});

parcelRegister("eknCS", function(module, exports) {
module.exports = new URL("pen1-45524-0.564c424d.jpg", import.meta.url).toString();

});

parcelRegister("edbnv", function(module, exports) {
module.exports = new URL("pen1-45524-1.1e78ec09.jpg", import.meta.url).toString();

});

parcelRegister("7WvKB", function(module, exports) {
module.exports = new URL("pen1-45531-0.73ba0b65.jpg", import.meta.url).toString();

});

parcelRegister("egZ7s", function(module, exports) {
module.exports = new URL("pen1-45531-1.3f085196.jpg", import.meta.url).toString();

});

parcelRegister("NxMmD", function(module, exports) {
module.exports = new URL("pen1-45531-2.9c7341b6.jpg", import.meta.url).toString();

});

parcelRegister("hepu1", function(module, exports) {
module.exports = new URL("pen1-45534-0.0e995a0a.jpg", import.meta.url).toString();

});

parcelRegister("5oIry", function(module, exports) {
module.exports = new URL("pen1-45534-1.cd42f380.jpg", import.meta.url).toString();

});

parcelRegister("9Vw7y", function(module, exports) {
module.exports = new URL("pen1-45534-2.c48c6da4.jpg", import.meta.url).toString();

});

parcelRegister("296tr", function(module, exports) {
module.exports = new URL("pen1-59917-0.add691af.jpg", import.meta.url).toString();

});

parcelRegister("3XfKF", function(module, exports) {
module.exports = new URL("pen1-59917-1.e6601219.jpg", import.meta.url).toString();

});

parcelRegister("l4BYf", function(module, exports) {
module.exports = new URL("pen1-59917-2.dc9cc598.jpg", import.meta.url).toString();

});

parcelRegister("4D3KT", function(module, exports) {
module.exports = new URL("pen1-64755-0.18f0bf3e.jpg", import.meta.url).toString();

});

parcelRegister("d7BYn", function(module, exports) {
module.exports = new URL("pen1-64755-1.c7b1a9d5.jpg", import.meta.url).toString();

});

parcelRegister("e1arP", function(module, exports) {
module.exports = new URL("pen2-45518-0.dfc5fb49.jpg", import.meta.url).toString();

});

parcelRegister("eV3IU", function(module, exports) {
module.exports = new URL("pen2-45518-1.08fe7e9a.jpg", import.meta.url).toString();

});

parcelRegister("5HZnK", function(module, exports) {
module.exports = new URL("pen2-47811-0.5631cb97.jpg", import.meta.url).toString();

});

parcelRegister("9Rj0w", function(module, exports) {
module.exports = new URL("pen2-47811-1.976e495c.jpg", import.meta.url).toString();

});

parcelRegister("6tO56", function(module, exports) {
module.exports = new URL("pen2-47811-2.0aad4232.jpg", import.meta.url).toString();

});

parcelRegister("8YLEs", function(module, exports) {
module.exports = new URL("pen2-61174-0.18ba0030.jpg", import.meta.url).toString();

});

parcelRegister("bdHb7", function(module, exports) {
module.exports = new URL("pen2-61174-1.dba0f267.jpg", import.meta.url).toString();

});

parcelRegister("6nApc", function(module, exports) {
module.exports = new URL("pen2-67596-0.8bee32ff.jpg", import.meta.url).toString();

});

parcelRegister("eAhbH", function(module, exports) {
module.exports = new URL("pen2-67596-1.f2530ec5.jpg", import.meta.url).toString();

});

parcelRegister("jJKXJ", function(module, exports) {
module.exports = new URL("pen2-72444-0.5501039f.jpg", import.meta.url).toString();

});

parcelRegister("bxnOn", function(module, exports) {
module.exports = new URL("pen2-72444-1.1ce3fe07.jpg", import.meta.url).toString();

});

parcelRegister("01fzV", function(module, exports) {
module.exports = new URL("pen2-72519-0.e79aacde.jpg", import.meta.url).toString();

});

parcelRegister("1RFDO", function(module, exports) {
module.exports = new URL("pen2-72519-1.11b1bcd6.jpg", import.meta.url).toString();

});

parcelRegister("jYZK2", function(module, exports) {
module.exports = new URL("pen2-73413-0.0f9b65d0.jpg", import.meta.url).toString();

});

parcelRegister("6CJda", function(module, exports) {
module.exports = new URL("pen2-73413-1.fc228e3e.jpg", import.meta.url).toString();

});

parcelRegister("cmNYu", function(module, exports) {
module.exports = new URL("pen2-75947-0.cdfa0cac.jpg", import.meta.url).toString();

});

parcelRegister("bNGde", function(module, exports) {
module.exports = new URL("pen2-75947-1.1791846f.jpg", import.meta.url).toString();

});

parcelRegister("im0FW", function(module, exports) {
module.exports = new URL("pen2-75947-2.c384a5fb.jpg", import.meta.url).toString();

});

parcelRegister("5gKHz", function(module, exports) {
module.exports = new URL("pen2-75947-3.9a9581b4.jpg", import.meta.url).toString();

});

parcelRegister("eOYwi", function(module, exports) {
module.exports = new URL("pen2-75947-4.2f2787e5.jpg", import.meta.url).toString();

});

parcelRegister("8DHIL", function(module, exports) {
module.exports = new URL("pen2-78124-0.4cdfb44b.jpg", import.meta.url).toString();

});

parcelRegister("9lIZD", function(module, exports) {
module.exports = new URL("pen2-78124-1.af390c7d.jpg", import.meta.url).toString();

});

parcelRegister("bRGTg", function(module, exports) {
module.exports = new URL("pen2-78124-2.9f87f0b3.jpg", import.meta.url).toString();

});

parcelRegister("4WV4L", function(module, exports) {
module.exports = new URL("sight-13756-0.86c73375.jpg", import.meta.url).toString();

});

parcelRegister("9HTrt", function(module, exports) {
module.exports = new URL("sight-13756-1.3a3653cd.jpg", import.meta.url).toString();

});

parcelRegister("kZeNj", function(module, exports) {
module.exports = new URL("sight-19336-0.83fa8503.jpg", import.meta.url).toString();

});

parcelRegister("lc4oM", function(module, exports) {
module.exports = new URL("sight-19336-1.7a9ac6fd.jpg", import.meta.url).toString();

});

parcelRegister("dGU5x", function(module, exports) {
module.exports = new URL("sight-19800-0.ed371237.jpg", import.meta.url).toString();

});

parcelRegister("4EUv7", function(module, exports) {
module.exports = new URL("sight-19800-1.3bce16d0.jpg", import.meta.url).toString();

});

parcelRegister("brTVG", function(module, exports) {
module.exports = new URL("sight-19800-2.9c8739fe.jpg", import.meta.url).toString();

});

parcelRegister("cBhNh", function(module, exports) {
module.exports = new URL("sight-19800-4.4a6b6a32.jpg", import.meta.url).toString();

});

parcelRegister("hdwVD", function(module, exports) {
module.exports = new URL("sight-20015-0.10bb5e41.jpg", import.meta.url).toString();

});

parcelRegister("96Zr9", function(module, exports) {
module.exports = new URL("sight-20015-1.6eff7430.jpg", import.meta.url).toString();

});

parcelRegister("iREtf", function(module, exports) {
module.exports = new URL("sight-20016-0.2b8705b0.jpg", import.meta.url).toString();

});

parcelRegister("dPQfT", function(module, exports) {
module.exports = new URL("sight-20016-1.299e56d9.jpg", import.meta.url).toString();

});

parcelRegister("9jiQw", function(module, exports) {
module.exports = new URL("sight-26743-0.3d723288.jpg", import.meta.url).toString();

});

parcelRegister("lB9r4", function(module, exports) {
module.exports = new URL("sight-26743-1.4fdd07c7.jpg", import.meta.url).toString();

});

parcelRegister("fr0U3", function(module, exports) {
module.exports = new URL("sight-26743-10.16ac47ce.jpg", import.meta.url).toString();

});

parcelRegister("kFi32", function(module, exports) {
module.exports = new URL("sight-26743-11.d1dca9bc.jpg", import.meta.url).toString();

});

parcelRegister("cHPWf", function(module, exports) {
module.exports = new URL("sight-26743-12.d4546025.jpg", import.meta.url).toString();

});

parcelRegister("5ulUW", function(module, exports) {
module.exports = new URL("sight-26743-13.d0599d67.jpg", import.meta.url).toString();

});

parcelRegister("3DkIO", function(module, exports) {
module.exports = new URL("sight-26743-14.a19b4e89.jpg", import.meta.url).toString();

});

parcelRegister("4NAgg", function(module, exports) {
module.exports = new URL("sight-26743-15.ff66761d.jpg", import.meta.url).toString();

});

parcelRegister("e9YWh", function(module, exports) {
module.exports = new URL("sight-26743-2.91c7a437.jpg", import.meta.url).toString();

});

parcelRegister("kEt6c", function(module, exports) {
module.exports = new URL("sight-26743-3.0c431426.jpg", import.meta.url).toString();

});

parcelRegister("cH8up", function(module, exports) {
module.exports = new URL("sight-26743-4.018e60a5.jpg", import.meta.url).toString();

});

parcelRegister("7iB1D", function(module, exports) {
module.exports = new URL("sight-26743-5.ddbd3264.jpg", import.meta.url).toString();

});

parcelRegister("azYiL", function(module, exports) {
module.exports = new URL("sight-26743-6.5b20abfe.jpg", import.meta.url).toString();

});

parcelRegister("7YBvz", function(module, exports) {
module.exports = new URL("sight-26743-7.8a760e86.jpg", import.meta.url).toString();

});

parcelRegister("FUAeI", function(module, exports) {
module.exports = new URL("sight-26743-8.657af999.jpg", import.meta.url).toString();

});

parcelRegister("9RPPs", function(module, exports) {
module.exports = new URL("sight-26743-9.7ae62e8c.jpg", import.meta.url).toString();

});

parcelRegister("3FvtI", function(module, exports) {
module.exports = new URL("sight-31307-0.7a30a1e1.jpg", import.meta.url).toString();

});

parcelRegister("8FZ2X", function(module, exports) {
module.exports = new URL("sight-31307-1.30207f7c.jpg", import.meta.url).toString();

});

parcelRegister("bl5P5", function(module, exports) {
module.exports = new URL("sight-31403-0.ddf231a7.jpg", import.meta.url).toString();

});

parcelRegister("bIpnO", function(module, exports) {
module.exports = new URL("sight-31403-1.86d5ba9c.jpg", import.meta.url).toString();

});

parcelRegister("4Pvry", function(module, exports) {
module.exports = new URL("sight-31612-0.d27bd47e.jpg", import.meta.url).toString();

});

parcelRegister("ltq5h", function(module, exports) {
module.exports = new URL("sight-31612-1.42a58223.jpg", import.meta.url).toString();

});

parcelRegister("jNVKZ", function(module, exports) {
module.exports = new URL("sight-31612-2.275a1efd.jpg", import.meta.url).toString();

});

parcelRegister("lcmQO", function(module, exports) {
module.exports = new URL("sight-31612-3.ce85b130.jpg", import.meta.url).toString();

});

parcelRegister("8GNW2", function(module, exports) {
module.exports = new URL("sight-31612-4.98234d6e.jpg", import.meta.url).toString();

});

parcelRegister("cl9wG", function(module, exports) {
module.exports = new URL("sight-31612-5.c2fb7c35.jpg", import.meta.url).toString();

});

parcelRegister("2fLCP", function(module, exports) {
module.exports = new URL("sight-31612-6.eb8a9b16.jpg", import.meta.url).toString();

});

parcelRegister("6xxbs", function(module, exports) {
module.exports = new URL("sight-31612-7.f936870c.jpg", import.meta.url).toString();

});

parcelRegister("3Mkse", function(module, exports) {
module.exports = new URL("sight-31612-8.623cf21f.jpg", import.meta.url).toString();

});

parcelRegister("ghIKJ", function(module, exports) {
module.exports = new URL("sight-31612-9.32e9faa3.jpg", import.meta.url).toString();

});

parcelRegister("2EG7e", function(module, exports) {
module.exports = new URL("sight-31924-0.b2421c3c.jpg", import.meta.url).toString();

});

parcelRegister("6vvWa", function(module, exports) {
module.exports = new URL("sight-31924-1.ef167c90.jpg", import.meta.url).toString();

});

parcelRegister("994kh", function(module, exports) {
module.exports = new URL("sight-34474-0.58ead828.jpg", import.meta.url).toString();

});

parcelRegister("bCUjp", function(module, exports) {
module.exports = new URL("sight-34474-1.247a4f21.jpg", import.meta.url).toString();

});

parcelRegister("evC5K", function(module, exports) {
module.exports = new URL("sight-34476-0.e2d074a5.jpg", import.meta.url).toString();

});

parcelRegister("jAaC7", function(module, exports) {
module.exports = new URL("sight-34476-1.e9486b23.jpg", import.meta.url).toString();

});

parcelRegister("FVXN2", function(module, exports) {
module.exports = new URL("sight-35365-0.a800d5ef.jpg", import.meta.url).toString();

});

parcelRegister("jYEYb", function(module, exports) {
module.exports = new URL("sight-35365-1.18b5648c.jpg", import.meta.url).toString();

});

parcelRegister("1uBow", function(module, exports) {
module.exports = new URL("sight-35731-0.cdba99bf.jpg", import.meta.url).toString();

});

parcelRegister("218js", function(module, exports) {
module.exports = new URL("sight-35731-1.d6c8596b.jpg", import.meta.url).toString();

});

parcelRegister("iwCX5", function(module, exports) {
module.exports = new URL("sight-35731-14.27675544.jpg", import.meta.url).toString();

});

parcelRegister("k0Tqe", function(module, exports) {
module.exports = new URL("sight-35731-15.c748ca40.jpg", import.meta.url).toString();

});

parcelRegister("cDJaL", function(module, exports) {
module.exports = new URL("sight-35731-2.23268edf.jpg", import.meta.url).toString();

});

parcelRegister("gLNIR", function(module, exports) {
module.exports = new URL("sight-39393-0.91a4f8cd.jpg", import.meta.url).toString();

});

parcelRegister("1vfKK", function(module, exports) {
module.exports = new URL("sight-39393-1.3dc428a7.jpg", import.meta.url).toString();

});

parcelRegister("jrbh7", function(module, exports) {
module.exports = new URL("sight-39480-0.2707182b.jpg", import.meta.url).toString();

});

parcelRegister("5I6WU", function(module, exports) {
module.exports = new URL("sight-39480-1.48b51efd.jpg", import.meta.url).toString();

});

parcelRegister("37OkM", function(module, exports) {
module.exports = new URL("sight-41705-0.208dd323.jpg", import.meta.url).toString();

});

parcelRegister("6xhEu", function(module, exports) {
module.exports = new URL("sight-41705-1.e068fd1a.jpg", import.meta.url).toString();

});

parcelRegister("3RXN4", function(module, exports) {
module.exports = new URL("sight-41705-10.ee828e8f.jpg", import.meta.url).toString();

});

parcelRegister("RYb4Z", function(module, exports) {
module.exports = new URL("sight-41705-2.f98e9aa3.jpg", import.meta.url).toString();

});

parcelRegister("gajLv", function(module, exports) {
module.exports = new URL("sight-41705-3.52db0d30.jpg", import.meta.url).toString();

});

parcelRegister("hyE1H", function(module, exports) {
module.exports = new URL("sight-41705-4.fa323ad4.jpg", import.meta.url).toString();

});

parcelRegister("lCbh2", function(module, exports) {
module.exports = new URL("sight-41705-5.813b4ee5.jpg", import.meta.url).toString();

});

parcelRegister("kTJ8M", function(module, exports) {
module.exports = new URL("sight-41705-6.16ddf018.jpg", import.meta.url).toString();

});

parcelRegister("dXP0z", function(module, exports) {
module.exports = new URL("sight-41705-7.258b7aab.jpg", import.meta.url).toString();

});

parcelRegister("1BGYc", function(module, exports) {
module.exports = new URL("sight-41705-8.8bebbe6f.jpg", import.meta.url).toString();

});

parcelRegister("6gVmk", function(module, exports) {
module.exports = new URL("sight-41705-9.6a913a4c.jpg", import.meta.url).toString();

});

parcelRegister("gI8Zc", function(module, exports) {
module.exports = new URL("sight-45513-0.9a4304d1.jpg", import.meta.url).toString();

});

parcelRegister("kNjLj", function(module, exports) {
module.exports = new URL("sight-45513-1.64ea8124.jpg", import.meta.url).toString();

});

parcelRegister("aBi1v", function(module, exports) {
module.exports = new URL("sight-45529-0.2f1024d8.jpg", import.meta.url).toString();

});

parcelRegister("e9Z9n", function(module, exports) {
module.exports = new URL("sight-45529-1.064ee2b3.jpg", import.meta.url).toString();

});

parcelRegister("8qq6G", function(module, exports) {
module.exports = new URL("sight-45531-0.bf725dca.jpg", import.meta.url).toString();

});

parcelRegister("f7mp6", function(module, exports) {
module.exports = new URL("sight-45531-1.497a45aa.jpg", import.meta.url).toString();

});

parcelRegister("gRSlt", function(module, exports) {
module.exports = new URL("sight-45531-2.a7a39fbe.jpg", import.meta.url).toString();

});

parcelRegister("1UqO3", function(module, exports) {
module.exports = new URL("sight-45532-0.5dc8bb78.jpg", import.meta.url).toString();

});

parcelRegister("jgaoD", function(module, exports) {
module.exports = new URL("sight-45532-1.7f0913c1.jpg", import.meta.url).toString();

});

parcelRegister("dad5E", function(module, exports) {
module.exports = new URL("sight-45532a-0.4ef907dd.jpg", import.meta.url).toString();

});

parcelRegister("hqZPd", function(module, exports) {
module.exports = new URL("sight-45532a-1.212c24ea.jpg", import.meta.url).toString();

});

parcelRegister("hmNgh", function(module, exports) {
module.exports = new URL("sight-45534-0.a57e9d44.jpg", import.meta.url).toString();

});

parcelRegister("gEmg6", function(module, exports) {
module.exports = new URL("sight-45534-1.cd42f380.jpg", import.meta.url).toString();

});

parcelRegister("lu1EP", function(module, exports) {
module.exports = new URL("sight-45534-2.1088d36a.jpg", import.meta.url).toString();

});

parcelRegister("iZrQ6", function(module, exports) {
module.exports = new URL("sight-45537-0.cd928cec.jpg", import.meta.url).toString();

});

parcelRegister("kgzuB", function(module, exports) {
module.exports = new URL("sight-45537-1.fd0b8b6d.jpg", import.meta.url).toString();

});

parcelRegister("j9V9g", function(module, exports) {
module.exports = new URL("sight-45539-0.349fe5f6.jpg", import.meta.url).toString();

});

parcelRegister("40oue", function(module, exports) {
module.exports = new URL("sight-45539-1.55d48863.jpg", import.meta.url).toString();

});

parcelRegister("iu2BQ", function(module, exports) {
module.exports = new URL("sight-46358-0.c5641f24.jpg", import.meta.url).toString();

});

parcelRegister("eBuOv", function(module, exports) {
module.exports = new URL("sight-46358-1.e1417f3d.jpg", import.meta.url).toString();

});

parcelRegister("k5HbI", function(module, exports) {
module.exports = new URL("sight-50327-0.aaa1701d.jpg", import.meta.url).toString();

});

parcelRegister("4P8K3", function(module, exports) {
module.exports = new URL("sight-50327-1.b8abb2d9.jpg", import.meta.url).toString();

});

parcelRegister("99Paz", function(module, exports) {
module.exports = new URL("sight-51068-0.83fe3f8a.jpg", import.meta.url).toString();

});

parcelRegister("j0VCL", function(module, exports) {
module.exports = new URL("sight-51068-1.ca31bd17.jpg", import.meta.url).toString();

});

parcelRegister("9Y6Pz", function(module, exports) {
module.exports = new URL("sight-51117-0.966120b0.jpg", import.meta.url).toString();

});

parcelRegister("d9uah", function(module, exports) {
module.exports = new URL("sight-51117-1.8ee80fcd.jpg", import.meta.url).toString();

});

parcelRegister("bBybf", function(module, exports) {
module.exports = new URL("sight-51117-10.443e738b.jpg", import.meta.url).toString();

});

parcelRegister("5FNIB", function(module, exports) {
module.exports = new URL("sight-51117-11.a8f783b2.jpg", import.meta.url).toString();

});

parcelRegister("dZbJL", function(module, exports) {
module.exports = new URL("sight-51117-2.353a4a84.jpg", import.meta.url).toString();

});

parcelRegister("57WVw", function(module, exports) {
module.exports = new URL("sight-51117-3.5002b13d.jpg", import.meta.url).toString();

});

parcelRegister("16wAD", function(module, exports) {
module.exports = new URL("sight-51117-4.2ed7239e.jpg", import.meta.url).toString();

});

parcelRegister("6eVRc", function(module, exports) {
module.exports = new URL("sight-51117-5.fc9bba3e.jpg", import.meta.url).toString();

});

parcelRegister("b4BPn", function(module, exports) {
module.exports = new URL("sight-51117-6.a42706cc.jpg", import.meta.url).toString();

});

parcelRegister("1dQK4", function(module, exports) {
module.exports = new URL("sight-51117-7.3ef3d133.jpg", import.meta.url).toString();

});

parcelRegister("1qTRD", function(module, exports) {
module.exports = new URL("sight-51117-8.8a22515e.jpg", import.meta.url).toString();

});

parcelRegister("8DxyY", function(module, exports) {
module.exports = new URL("sight-51117-9.6a1b29d5.jpg", import.meta.url).toString();

});

parcelRegister("2Zh6g", function(module, exports) {
module.exports = new URL("sight-59917-0.4e851abc.jpg", import.meta.url).toString();

});

parcelRegister("lw4k8", function(module, exports) {
module.exports = new URL("sight-59917-1.e6601219.jpg", import.meta.url).toString();

});

parcelRegister("62fLg", function(module, exports) {
module.exports = new URL("sight-59917-2.dc9cc598.jpg", import.meta.url).toString();

});

parcelRegister("i95Ru", function(module, exports) {
module.exports = new URL("sight-59917-3.21bdf54d.jpg", import.meta.url).toString();

});

parcelRegister("44kiA", function(module, exports) {
module.exports = new URL("sight-59917-4.592e95ee.jpg", import.meta.url).toString();

});

parcelRegister("hTkF2", function(module, exports) {
module.exports = new URL("sight-59917-5.8f6a3c87.jpg", import.meta.url).toString();

});

parcelRegister("LHQKF", function(module, exports) {
module.exports = new URL("sight-64330-0.0b91da05.jpg", import.meta.url).toString();

});

parcelRegister("8cFzx", function(module, exports) {
module.exports = new URL("sight-64330-1.9f86f970.jpg", import.meta.url).toString();

});

parcelRegister("qeOHg", function(module, exports) {
module.exports = new URL("sight-64339-0.066dd177.jpg", import.meta.url).toString();

});

parcelRegister("gL8KP", function(module, exports) {
module.exports = new URL("sight-64339-1.a6f4d137.jpg", import.meta.url).toString();

});

parcelRegister("3pKG6", function(module, exports) {
module.exports = new URL("sight-64770-0.7e9430b4.jpg", import.meta.url).toString();

});

parcelRegister("hnPLd", function(module, exports) {
module.exports = new URL("sight-64770-1.0afce794.jpg", import.meta.url).toString();

});

parcelRegister("d3xv8", function(module, exports) {
module.exports = new URL("sight-64772-0.697bdc52.jpg", import.meta.url).toString();

});

parcelRegister("ca8Ml", function(module, exports) {
module.exports = new URL("sight-64772-1.1834a44c.jpg", import.meta.url).toString();

});

parcelRegister("a1aTJ", function(module, exports) {
module.exports = new URL("sight-6651-0.f0b12037.jpg", import.meta.url).toString();

});

parcelRegister("ihnh5", function(module, exports) {
module.exports = new URL("sight-6651-1.30f5472d.jpg", import.meta.url).toString();

});

parcelRegister("kzWW6", function(module, exports) {
module.exports = new URL("sight-8815-0.33b08dcb.jpg", import.meta.url).toString();

});

parcelRegister("eYzuu", function(module, exports) {
module.exports = new URL("sight-8815-1.f230c0a3.jpg", import.meta.url).toString();

});

parcelRegister("g7hjm", function(module, exports) {
module.exports = new URL("sight-8857-0.5ce46604.jpg", import.meta.url).toString();

});

parcelRegister("dx76w", function(module, exports) {
module.exports = new URL("sight-8857-1.2857e364.jpg", import.meta.url).toString();

});

parcelRegister("5X1ew", function(module, exports) {
module.exports = new URL("sight-w00001-0.3d3c9477.jpg", import.meta.url).toString();

});

parcelRegister("keeiy", function(module, exports) {
module.exports = new URL("sight-w00001-1.11b6dddf.jpg", import.meta.url).toString();

});


parcelRegister("9UqMq", function(module, exports) {
module.exports = new URL("to-home.c3c98d22.png", import.meta.url).toString();

});



//# sourceMappingURL=index.7cac1bf1.js.map
